
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("gJCIb", function(module, exports) {

$parcel$export(module.exports, "CapacitorException", () => $c2eee0a2243e654f$export$12e569be5e83b9f4);
$parcel$export(module.exports, "Capacitor", () => $c2eee0a2243e654f$export$ab659bfd88afdf29);
$parcel$export(module.exports, "registerPlugin", () => $c2eee0a2243e654f$export$7612db19fb8beb1e);
$parcel$export(module.exports, "WebPlugin", () => $c2eee0a2243e654f$export$7c58ec35c4c5ea54);
/*! Capacitor: https://capacitorjs.com/ - MIT License */ var $c2eee0a2243e654f$export$f8972ddbe8205c4b;
(function(ExceptionCode) {
    /**
     * API is not implemented.
     *
     * This usually means the API can't be used because it is not implemented for
     * the current platform.
     */ ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
    /**
     * API is not available.
     *
     * This means the API can't be used right now because:
     *   - it is currently missing a prerequisite, such as network connectivity
     *   - it requires a particular platform or browser version
     */ ExceptionCode["Unavailable"] = "UNAVAILABLE";
})($c2eee0a2243e654f$export$f8972ddbe8205c4b || ($c2eee0a2243e654f$export$f8972ddbe8205c4b = {}));
class $c2eee0a2243e654f$export$12e569be5e83b9f4 extends Error {
    constructor(message, code, data){
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
}
const $c2eee0a2243e654f$var$getPlatformId = (win)=>{
    var _a, _b;
    if (win === null || win === void 0 ? void 0 : win.androidBridge) return 'android';
    else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) return 'ios';
    else return 'web';
};
const $c2eee0a2243e654f$var$createCapacitor = (win)=>{
    const capCustomPlatform = win.CapacitorCustomPlatform || null;
    const cap = win.Capacitor || {};
    const Plugins = cap.Plugins = cap.Plugins || {};
    const getPlatform = ()=>{
        return capCustomPlatform !== null ? capCustomPlatform.name : $c2eee0a2243e654f$var$getPlatformId(win);
    };
    const isNativePlatform = ()=>getPlatform() !== 'web';
    const isPluginAvailable = (pluginName)=>{
        const plugin = registeredPlugins.get(pluginName);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) // JS implementation available for the current platform.
        return true;
        if (getPluginHeader(pluginName)) // Native implementation available.
        return true;
        return false;
    };
    const getPluginHeader = (pluginName)=>{
        var _a;
        return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find((h)=>h.name === pluginName);
    };
    const handleError = (err)=>win.console.error(err);
    const registeredPlugins = new Map();
    const registerPlugin = (pluginName, jsImplementations = {})=>{
        const registeredPlugin = registeredPlugins.get(pluginName);
        if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
        }
        const platform = getPlatform();
        const pluginHeader = getPluginHeader(pluginName);
        let jsImplementation;
        const loadPluginImplementation = async ()=>{
            if (!jsImplementation && platform in jsImplementations) jsImplementation = typeof jsImplementations[platform] === 'function' ? jsImplementation = await jsImplementations[platform]() : jsImplementation = jsImplementations[platform];
            else if (capCustomPlatform !== null && !jsImplementation && 'web' in jsImplementations) jsImplementation = typeof jsImplementations['web'] === 'function' ? jsImplementation = await jsImplementations['web']() : jsImplementation = jsImplementations['web'];
            return jsImplementation;
        };
        const createPluginMethod = (impl, prop)=>{
            var _a, _b;
            if (pluginHeader) {
                const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find((m)=>prop === m.name);
                if (methodHeader) {
                    if (methodHeader.rtype === 'promise') return (options)=>cap.nativePromise(pluginName, prop.toString(), options);
                    else return (options, callback)=>cap.nativeCallback(pluginName, prop.toString(), options, callback);
                } else if (impl) return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
            } else if (impl) return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
            else throw new $c2eee0a2243e654f$export$12e569be5e83b9f4(`"${pluginName}" plugin is not implemented on ${platform}`, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unimplemented);
        };
        const createPluginMethodWrapper = (prop)=>{
            let remove;
            const wrapper = (...args)=>{
                const p = loadPluginImplementation().then((impl)=>{
                    const fn = createPluginMethod(impl, prop);
                    if (fn) {
                        const p = fn(...args);
                        remove = p === null || p === void 0 ? void 0 : p.remove;
                        return p;
                    } else throw new $c2eee0a2243e654f$export$12e569be5e83b9f4(`"${pluginName}.${prop}()" is not implemented on ${platform}`, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unimplemented);
                });
                if (prop === 'addListener') p.remove = async ()=>remove();
                return p;
            };
            // Some flair ✨
            wrapper.toString = ()=>`${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, 'name', {
                value: prop,
                writable: false,
                configurable: false
            });
            return wrapper;
        };
        const addListener = createPluginMethodWrapper('addListener');
        const removeListener = createPluginMethodWrapper('removeListener');
        const addListenerNative = (eventName, callback)=>{
            const call = addListener({
                eventName: eventName
            }, callback);
            const remove = async ()=>{
                const callbackId = await call;
                removeListener({
                    eventName: eventName,
                    callbackId: callbackId
                }, callback);
            };
            const p = new Promise((resolve)=>call.then(()=>resolve({
                        remove: remove
                    })));
            p.remove = async ()=>{
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            };
            return p;
        };
        const proxy = new Proxy({}, {
            get (_, prop) {
                switch(prop){
                    // https://github.com/facebook/react/issues/20030
                    case '$$typeof':
                        return undefined;
                    case 'toJSON':
                        return ()=>({});
                    case 'addListener':
                        return pluginHeader ? addListenerNative : addListener;
                    case 'removeListener':
                        return removeListener;
                    default:
                        return createPluginMethodWrapper(prop);
                }
            }
        });
        Plugins[pluginName] = proxy;
        registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy: proxy,
            platforms: new Set([
                ...Object.keys(jsImplementations),
                ...pluginHeader ? [
                    platform
                ] : []
            ])
        });
        return proxy;
    };
    // Add in convertFileSrc for web, it will already be available in native context
    if (!cap.convertFileSrc) cap.convertFileSrc = (filePath)=>filePath;
    cap.getPlatform = getPlatform;
    cap.handleError = handleError;
    cap.isNativePlatform = isNativePlatform;
    cap.isPluginAvailable = isPluginAvailable;
    cap.registerPlugin = registerPlugin;
    cap.Exception = $c2eee0a2243e654f$export$12e569be5e83b9f4;
    cap.DEBUG = !!cap.DEBUG;
    cap.isLoggingEnabled = !!cap.isLoggingEnabled;
    return cap;
};
const $c2eee0a2243e654f$var$initCapacitorGlobal = (win)=>win.Capacitor = $c2eee0a2243e654f$var$createCapacitor(win);
const $c2eee0a2243e654f$export$ab659bfd88afdf29 = /*#__PURE__*/ $c2eee0a2243e654f$var$initCapacitorGlobal(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {});
const $c2eee0a2243e654f$export$7612db19fb8beb1e = $c2eee0a2243e654f$export$ab659bfd88afdf29.registerPlugin;
/**
 * Base class web plugins should extend.
 */ class $c2eee0a2243e654f$export$7c58ec35c4c5ea54 {
    constructor(){
        this.listeners = {};
        this.retainedEventArguments = {};
        this.windowListeners = {};
    }
    addListener(eventName, listenerFunc) {
        let firstListener = false;
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
            firstListener = true;
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) this.addWindowListener(windowListener);
        if (firstListener) this.sendRetainedArgumentsForEvent(eventName);
        const remove = async ()=>this.removeListener(eventName, listenerFunc);
        const p = Promise.resolve({
            remove: remove
        });
        return p;
    }
    async removeAllListeners() {
        this.listeners = {};
        for(const listener in this.windowListeners)this.removeWindowListener(this.windowListeners[listener]);
        this.windowListeners = {};
    }
    notifyListeners(eventName, data, retainUntilConsumed) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            if (retainUntilConsumed) {
                let args = this.retainedEventArguments[eventName];
                if (!args) args = [];
                args.push(data);
                this.retainedEventArguments[eventName] = args;
            }
            return;
        }
        listeners.forEach((listener)=>listener(data));
    }
    hasListeners(eventName) {
        var _a;
        return !!((_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.length);
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName: windowEventName,
            pluginEventName: pluginEventName,
            handler: (event)=>{
                this.notifyListeners(pluginEventName, event);
            }
        };
    }
    unimplemented(msg = 'not implemented') {
        return new $c2eee0a2243e654f$export$ab659bfd88afdf29.Exception(msg, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unimplemented);
    }
    unavailable(msg = 'not available') {
        return new $c2eee0a2243e654f$export$ab659bfd88afdf29.Exception(msg, $c2eee0a2243e654f$export$f8972ddbe8205c4b.Unavailable);
    }
    async removeListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) return;
        const index = listeners.indexOf(listenerFunc);
        this.listeners[eventName].splice(index, 1);
        // If there are no more listeners for this type of event,
        // remove the window listener
        if (!this.listeners[eventName].length) this.removeWindowListener(this.windowListeners[eventName]);
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) return;
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
    sendRetainedArgumentsForEvent(eventName) {
        const args = this.retainedEventArguments[eventName];
        if (!args) return;
        delete this.retainedEventArguments[eventName];
        args.forEach((arg)=>{
            this.notifyListeners(eventName, arg);
        });
    }
}
const $c2eee0a2243e654f$export$9ac0cb180b81cd43 = /*#__PURE__*/ $c2eee0a2243e654f$export$7612db19fb8beb1e('WebView');
/******** END WEB VIEW PLUGIN ********/ /******** COOKIES PLUGIN ********/ /**
 * Safely web encode a string value (inspired by js-cookie)
 * @param str The string value to encode
 */ const $c2eee0a2243e654f$var$encode = (str)=>encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
/**
 * Safely web decode a string value (inspired by js-cookie)
 * @param str The string value to decode
 */ const $c2eee0a2243e654f$var$decode = (str)=>str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class $c2eee0a2243e654f$var$CapacitorCookiesPluginWeb extends $c2eee0a2243e654f$export$7c58ec35c4c5ea54 {
    async getCookies() {
        const cookies = document.cookie;
        const cookieMap = {};
        cookies.split(';').forEach((cookie)=>{
            if (cookie.length <= 0) return;
            // Replace first "=" with CAP_COOKIE to prevent splitting on additional "="
            let [key, value] = cookie.replace(/=/, 'CAP_COOKIE').split('CAP_COOKIE');
            key = $c2eee0a2243e654f$var$decode(key).trim();
            value = $c2eee0a2243e654f$var$decode(value).trim();
            cookieMap[key] = value;
        });
        return cookieMap;
    }
    async setCookie(options) {
        try {
            // Safely Encoded Key/Value
            const encodedKey = $c2eee0a2243e654f$var$encode(options.key);
            const encodedValue = $c2eee0a2243e654f$var$encode(options.value);
            // Clean & sanitize options
            const expires = options.expires ? `; expires=${options.expires.replace('expires=', '')}` : '';
            const path = (options.path || '/').replace('path=', ''); // Default is "path=/"
            const domain = options.url != null && options.url.length > 0 ? `domain=${options.url}` : '';
            document.cookie = `${encodedKey}=${encodedValue || ''}${expires}; path=${path}; ${domain};`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async deleteCookie(options) {
        try {
            document.cookie = `${options.key}=; Max-Age=0`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearCookies() {
        try {
            const cookies = document.cookie.split(';') || [];
            for (const cookie of cookies)document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearAllCookies() {
        try {
            await this.clearCookies();
        } catch (error) {
            return Promise.reject(error);
        }
    }
}
const $c2eee0a2243e654f$export$702e5c97f7e4f579 = $c2eee0a2243e654f$export$7612db19fb8beb1e('CapacitorCookies', {
    web: ()=>new $c2eee0a2243e654f$var$CapacitorCookiesPluginWeb()
});
// UTILITY FUNCTIONS
/**
 * Read in a Blob value and return it as a base64 string
 * @param blob The blob value to convert to a base64 string
 */ const $c2eee0a2243e654f$var$readBlobAsBase64 = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const base64String = reader.result;
            // remove prefix "data:application/pdf;base64,"
            resolve(base64String.indexOf(',') >= 0 ? base64String.split(',')[1] : base64String);
        };
        reader.onerror = (error)=>reject(error);
        reader.readAsDataURL(blob);
    });
/**
 * Normalize an HttpHeaders map by lowercasing all of the values
 * @param headers The HttpHeaders object to normalize
 */ const $c2eee0a2243e654f$var$normalizeHttpHeaders = (headers = {})=>{
    const originalKeys = Object.keys(headers);
    const loweredKeys = Object.keys(headers).map((k)=>k.toLocaleLowerCase());
    const normalized = loweredKeys.reduce((acc, key, index)=>{
        acc[key] = headers[originalKeys[index]];
        return acc;
    }, {});
    return normalized;
};
/**
 * Builds a string of url parameters that
 * @param params A map of url parameters
 * @param shouldEncode true if you should encodeURIComponent() the values (true by default)
 */ const $c2eee0a2243e654f$var$buildUrlParams = (params, shouldEncode = true)=>{
    if (!params) return null;
    const output = Object.entries(params).reduce((accumulator, entry)=>{
        const [key, value] = entry;
        let encodedValue;
        let item;
        if (Array.isArray(value)) {
            item = '';
            value.forEach((str)=>{
                encodedValue = shouldEncode ? encodeURIComponent(str) : str;
                item += `${key}=${encodedValue}&`;
            });
            // last character will always be "&" so slice it off
            item.slice(0, -1);
        } else {
            encodedValue = shouldEncode ? encodeURIComponent(value) : value;
            item = `${key}=${encodedValue}`;
        }
        return `${accumulator}&${item}`;
    }, '');
    // Remove initial "&" from the reduce
    return output.substr(1);
};
/**
 * Build the RequestInit object based on the options passed into the initial request
 * @param options The Http plugin options
 * @param extra Any extra RequestInit values
 */ const $c2eee0a2243e654f$export$bd53726ce92e1297 = (options, extra = {})=>{
    const output = Object.assign({
        method: options.method || 'GET',
        headers: options.headers
    }, extra);
    // Get the content-type
    const headers = $c2eee0a2243e654f$var$normalizeHttpHeaders(options.headers);
    const type = headers['content-type'] || '';
    // If body is already a string, then pass it through as-is.
    if (typeof options.data === 'string') output.body = options.data;
    else if (type.includes('application/x-www-form-urlencoded')) {
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(options.data || {}))params.set(key, value);
        output.body = params.toString();
    } else if (type.includes('multipart/form-data') || options.data instanceof FormData) {
        const form = new FormData();
        if (options.data instanceof FormData) options.data.forEach((value, key)=>{
            form.append(key, value);
        });
        else for (const key of Object.keys(options.data))form.append(key, options.data[key]);
        output.body = form;
        const headers = new Headers(output.headers);
        headers.delete('content-type'); // content-type will be set by `window.fetch` to includy boundary
        output.headers = headers;
    } else if (type.includes('application/json') || typeof options.data === 'object') output.body = JSON.stringify(options.data);
    return output;
};
// WEB IMPLEMENTATION
class $c2eee0a2243e654f$var$CapacitorHttpPluginWeb extends $c2eee0a2243e654f$export$7c58ec35c4c5ea54 {
    /**
     * Perform an Http request given a set of options
     * @param options Options to build the HTTP request
     */ async request(options) {
        const requestInit = $c2eee0a2243e654f$export$bd53726ce92e1297(options, options.webFetchExtra);
        const urlParams = $c2eee0a2243e654f$var$buildUrlParams(options.params, options.shouldEncodeUrlParams);
        const url = urlParams ? `${options.url}?${urlParams}` : options.url;
        const response = await fetch(url, requestInit);
        const contentType = response.headers.get('content-type') || '';
        // Default to 'text' responseType so no parsing happens
        let { responseType: responseType = 'text' } = response.ok ? options : {};
        // If the response content-type is json, force the response to be json
        if (contentType.includes('application/json')) responseType = 'json';
        let data;
        let blob;
        switch(responseType){
            case 'arraybuffer':
            case 'blob':
                blob = await response.blob();
                data = await $c2eee0a2243e654f$var$readBlobAsBase64(blob);
                break;
            case 'json':
                data = await response.json();
                break;
            case 'document':
            case 'text':
            default:
                data = await response.text();
        }
        // Convert fetch headers to Capacitor HttpHeaders
        const headers = {};
        response.headers.forEach((value, key)=>{
            headers[key] = value;
        });
        return {
            data: data,
            headers: headers,
            status: response.status,
            url: response.url
        };
    }
    /**
     * Perform an Http GET request given a set of options
     * @param options Options to build the HTTP request
     */ async get(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'GET'
        }));
    }
    /**
     * Perform an Http POST request given a set of options
     * @param options Options to build the HTTP request
     */ async post(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'POST'
        }));
    }
    /**
     * Perform an Http PUT request given a set of options
     * @param options Options to build the HTTP request
     */ async put(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PUT'
        }));
    }
    /**
     * Perform an Http PATCH request given a set of options
     * @param options Options to build the HTTP request
     */ async patch(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PATCH'
        }));
    }
    /**
     * Perform an Http DELETE request given a set of options
     * @param options Options to build the HTTP request
     */ async delete(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'DELETE'
        }));
    }
}
const $c2eee0a2243e654f$export$380134cb65b51303 = $c2eee0a2243e654f$export$7612db19fb8beb1e('CapacitorHttp', {
    web: ()=>new $c2eee0a2243e654f$var$CapacitorHttpPluginWeb()
});
/******** END HTTP PLUGIN ********/ /******** SYSTEM BARS PLUGIN ********/ /**
 * Available status bar styles.
 */ var $c2eee0a2243e654f$export$933111517aee657e;
(function(SystemBarsStyle) {
    /**
     * Light system bar content on a dark background.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Dark"] = "DARK";
    /**
     * For dark system bar content on a light background.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Light"] = "LIGHT";
    /**
     * The style is based on the device appearance or the underlying content.
     * If the device is using Dark mode, the system bars content will be light.
     * If the device is using Light mode, the system bars content will be dark.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Default"] = "DEFAULT";
})($c2eee0a2243e654f$export$933111517aee657e || ($c2eee0a2243e654f$export$933111517aee657e = {}));
/**
 * Available system bar types.
 */ var $c2eee0a2243e654f$export$ecbb45a9cc39206e;
(function(SystemBarType) {
    /**
     * The top status bar on both Android and iOS.
     *
     * @since 8.0.0
     */ SystemBarType["StatusBar"] = "StatusBar";
    /**
     * The navigation bar (or gesture bar on iOS) on both Android and iOS.
     *
     * @since 8.0.0
     */ SystemBarType["NavigationBar"] = "NavigationBar";
})($c2eee0a2243e654f$export$ecbb45a9cc39206e || ($c2eee0a2243e654f$export$ecbb45a9cc39206e = {}));
class $c2eee0a2243e654f$var$SystemBarsPluginWeb extends $c2eee0a2243e654f$export$7c58ec35c4c5ea54 {
    async setStyle() {
        this.unavailable('not available for web');
    }
    async setAnimation() {
        this.unavailable('not available for web');
    }
    async show() {
        this.unavailable('not available for web');
    }
    async hide() {
        this.unavailable('not available for web');
    }
}
const $c2eee0a2243e654f$export$351f1c1bf140a74f = $c2eee0a2243e654f$export$7612db19fb8beb1e('SystemBars', {
    web: ()=>new $c2eee0a2243e654f$var$SystemBarsPluginWeb()
});

});

parcelRegister("4yDdM", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c4X6F").then(()=>parcelRequire('b2DIV'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("8o4NC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ixm1c").then(()=>parcelRequire('4J8NU'));

});

parcelRegister("79Dk4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jzBHo").then(()=>parcelRequire('92ASX'));

});

var $56ae3ab0c137f025$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"gBkvG\",\"index.b14a7c27.js\",\"gySbI\",\"home.6ad74136.png\",\"3FI65\",\"notification.171a9586.png\",\"gVjcq\",\"acti.247efd7d.png\",\"c0QUa\",\"menu.afd2bac0.png\",\"9p0kH\",\"home.db3cc163.png\",\"e3XP2\",\"notification.1af28844.png\",\"lbHVM\",\"acti.c2c00cf8.png\",\"7S4CF\",\"menu.92f84406.png\",\"l5BV8\",\"back.acb25378.png\",\"26euq\",\"exit-2px.f465ccbe.png\",\"1e9AY\",\"mai-logo-blured.92e6dd8f.avif\",\"c9uSH\",\"location-radius.87cac46a.png\",\"4Dd9q\",\"location-radius.ffdd9459.png\",\"bdyEU\",\"search.350149f8.png\",\"7dPGk\",\"listings.6ed6101e.png\",\"g9jvF\",\"business.f99ea506.png\",\"cza7H\",\"seller.9721b569.png\",\"fzevN\",\"add.b16e5ec5.png\",\"aXE0H\",\"30 sec icon.20a2b55d.png\",\"lYbBJ\",\"done.0b4a0ff7.png\",\"34FAo\",\"camara.3e71a423.png\",\"f1lrK\",\"back.c67811e5.png\",\"19wD8\",\"listed.b2f6fc86.png\",\"4E7Gy\",\"go.04a1cde7.png\",\"i0VBQ\",\"account.7544bf72.png\",\"8mVCZ\",\"map.8b977074.png\",\"7kN3z\",\"map.38395ae3.png\",\"TBNJG\",\"pin point.a0e3075a.png\",\"5WK7E\",\"camera.14bfdf74.png\",\"72WbL\",\"upload-image.8ad1872c.png\",\"90DYz\",\"video.959fa9be.png\",\"iZD7X\",\"done.28c1c687.png\",\"GyEXN\",\"link.7fd56236.png\",\"75NR0\",\"location-outline.6dbfadac.png\",\"3WPl4\",\"justanimagehere.2fa22ed1.png\",\"c4X6F\",\"web.bdd877ed.js\",\"hg9Ov\",\"star.6ddb4a1d.png\",\"jAA9C\",\"views.31143c8e.png\",\"1goAW\",\"views.0d9ab9ea.png\",\"kCYFv\",\"views.9e339a11.png\",\"13rqI\",\"whatsapp.f78d1668.png\",\"dhx8n\",\"share.c0d42a71.png\",\"gm1QF\",\"ahead.2b3d2689.png\",\"bVb6u\",\"ahead.2e686b35.png\",\"9o8ML\",\"1-more-images-black.b11fc2c2.png\",\"2FgIn\",\"2-more-images-black.7565cc91.png\",\"g9VRp\",\"3-more-images-black.714e3a79.png\",\"b3Hts\",\"4-more-images-black.017833f7.png\",\"aoXar\",\"5-more-images-black.223df771.png\",\"8RjEG\",\"6-more-images-black.b60e07ae.png\",\"fRtsR\",\"verified.769ce719.png\",\"8Gmf3\",\"MAI-VERIFIED.2d7e2d87.png\",\"heWhK\",\"dots-menu.2b814bb3.png\",\"lwcMk\",\"videos.155bac79.png\",\"eye9r\",\"empresa.ae36b219.png\",\"dfvf1\",\"delete.95f01386.png\",\"gyYz0\",\"edit.2c561dfb.png\",\"UUull\",\"saved.6090072f.png\",\"yWaga\",\"liked.a4a46fbd.png\",\"1zUfB\",\"save.9bceaacc.png\",\"fLQO4\",\"menu-up.0ab625d1.png\",\"8A0SQ\",\"menu-down.75ceb4ba.png\",\"ietj1\",\"exit.e166631f.png\",\"3GORV\",\"back-arrow.c9796fe3.png\",\"e8jhE\",\"like.cd818b16.png\",\"8f4YA\",\"back.7314e22c.png\",\"dQbdL\",\"ahead.ea3381bf.png\",\"cV8Cn\",\"like.7826fa21.png\",\"1WvhD\",\"share.b19a65a9.png\",\"8YgfF\",\"call.08ff8926.png\",\"c7pTU\",\"whatsapp.baf17bef.png\",\"1L1SN\",\"location.9725f23b.png\",\"buPDC\",\"whatsapp.5e5c7f7c.png\",\"44VKU\",\"call.c413939f.png\",\"6Nad7\",\"share.b16f1889.png\",\"3zpTC\",\"save.ade9a3f6.png\",\"3Bf0a\",\"saved.8e45c39d.png\",\"kZbHf\",\"more-menu.fbdc8beb.png\",\"3Z1aO\",\"info.bdca5780.png\",\"hqNrG\",\"dots menu.6d664b85.png\",\"2bQTM\",\"save.0c9daa86.png\",\"1JGVE\",\"saved.d13d7368.png\",\"aEU34\",\"share.d9b645b5.png\",\"1rZHr\",\"dots menu.8709da27.png\",\"afO8S\",\"save.c0ea6997.png\",\"835ED\",\"saved.df78b418.png\",\"LDxG0\",\"share.d89865a6.png\",\"8Fdpx\",\"like.9a14a95a.png\",\"jacDS\",\"view.f8357666.png\",\"atOnZ\",\"back.096bcf77.png\",\"j9wbg\",\"call.5d4ff92d.png\",\"6rOBb\",\"whatsApp.7f42d2c3.png\",\"1iByQ\",\"search.2fd68654.png\",\"kTxkq\",\"dots-menu.14619b3c.png\",\"5W93P\",\"settings.70964329.png\",\"lbywM\",\"back-step.46ee5749.png\",\"grDXc\",\"App-logo.a2cef48f.png\",\"aDWSM\",\"notify.512a36a1.png\",\"6A0hk\",\"not-notify.b67cd31e.png\",\"5TLn1\",\"verification-needed.d0c72850.png\",\"7QSqW\",\"back.498f5ca8.png\",\"2NRP3\",\"B3B3B3.6bd1b99d.png\",\"hOixy\",\"call.f4679058.png\",\"2MOP0\",\"add.a157b34f.png\",\"5Lvxp\",\"forward.51d564c6.png\",\"88LBQ\",\"web.f1a73908.png\",\"dXxAo\",\"whatsApp.bf8839c3.png\",\"84DZw\",\"location.721705d7.png\",\"5WXmd\",\"call.8b029bd3.png\",\"bHb9m\",\"mail.9a3b47e1.png\",\"7av3I\",\"web.1b757557.png\",\"gOoYR\",\"whatsApp.5fedf63c.png\",\"4zst1\",\"location.af50194d.png\",\"boBsr\",\"call.bb1be407.png\",\"V7b2w\",\"mail.92ab1d9b.png\",\"8AXbE\",\"website.c94bcfe2.png\",\"4IL8H\",\"exit.cbb6d077.png\",\"7gV0L\",\"notify.6ef54b4b.png\",\"eS3pa\",\"exit.6b844ab1.png\",\"12IGj\",\"filter.e30f00e2.png\",\"4hFue\",\"info.3eec2926.png\",\"zoz5X\",\"add.3e902104.png\",\"ixm1c\",\"web.e8294c7a.js\",\"ls2Re\",\"edit-list.26af9d21.png\",\"cqFEY\",\"listed.c155a809.png\",\"7DCbq\",\"whatsApp.a7a56ac6.png\",\"lbrAY\",\"call.24411d71.png\",\"8qoJT\",\"email.5f989814.png\",\"iAlRd\",\"website.6f980709.png\",\"1QFkl\",\"color.e4c38c84.png\",\"isBlV\",\"current-location.51cf0d52.png\",\"6jfTK\",\"target-location.1a58f6dc.png\",\"bnk03\",\"exit.63b3f4c5.png\",\"inCUT\",\"link.2f85be60.png\",\"bcyAu\",\"select image on image black.ed513fe9.png\",\"e0GyC\",\"select image on image.d0dd8996.png\",\"af5ST\",\"link 700.c6466bb3.png\",\"gvCB0\",\"location.e6484ec5.png\",\"4zfZR\",\"error.b189abf5.png\",\"ikgLk\",\"map.61fce082.png\",\"gM6QS\",\"white frame.a95e6e50.png\",\"2sISk\",\"ahead.7475b1ad.png\",\"1Nicn\",\"back-arrow.9f763ba4.png\",\"4h40S\",\"boost.23abfe3c.png\",\"aXRrC\",\"stats.39e0cabd.png\",\"il9KN\",\"edit.b315a14b.png\",\"b2nRG\",\"edit.2298aed4.png\",\"511fn\",\"add.a9935b72.png\",\"cUBcU\",\"add-business-page.5ccd7548.png\",\"59FV7\",\"dots-menu.b352965d.png\",\"dZieO\",\"forward.c17a7afc.png\",\"6LN7R\",\"logo-72.0ff5c5bd.png\",\"khFtV\",\"camara.371afd6c.png\",\"azRr8\",\"up-down.2c070ea6.png\",\"k974M\",\"delete.6d530767.png\",\"hl2RL\",\"profile-img-placeholder.a0f1e921.png\",\"jzBHo\",\"web.419eb71a.js\",\"g4z3i\",\"back-img.9eb9b86f.png\",\"bSNge\",\"forward-img.f09c2485.png\",\"cZXfJ\",\"video-mercado-mai.6f6246d3.png\",\"dNV2o\",\"MAI hand shake.452d57f2.png\",\"1oCA7\",\"logo-128.dcba3ec1.png\",\"dglcy\",\"error.a820cd8f.png\",\"dgiRA\",\"help.836683b0.png\",\"bAnBg\",\"icon-install.a82f879d.png\",\"9flEG\",\"drag-white.46699ad8.png\",\"9Dd5q\",\"filter.deadecb4.png\",\"uO9tX\",\"filter-open.b4cabde2.png\",\"11sBx\",\"filter-reset.84367387.png\",\"4RmwE\",\"play-vid-black.f880948d.png\",\"k95nX\",\"play.114464ac.png\",\"4lrEk\",\"pause.c54c57cb.png\"]"));

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c38e0f42709c826a$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $c38e0f42709c826a$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$getDefaultsFromGlobal = ()=>$c38e0f42709c826a$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $c38e0f42709c826a$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $cfae44f0dfdf62c0$exports === 'undefined' || typeof $cfae44f0dfdf62c0$exports.env === 'undefined') return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $c38e0f42709c826a$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $c38e0f42709c826a$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $c38e0f42709c826a$export$212bb2fc580a90a8 = ()=>{
    try {
        return $c38e0f42709c826a$var$getDefaultsFromGlobal() || $c38e0f42709c826a$var$getDefaultsFromEnvVariable() || $c38e0f42709c826a$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $c38e0f42709c826a$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $c38e0f42709c826a$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $c38e0f42709c826a$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $c38e0f42709c826a$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $c38e0f42709c826a$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $c38e0f42709c826a$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $c38e0f42709c826a$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $c38e0f42709c826a$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || '');
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c38e0f42709c826a$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $c38e0f42709c826a$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $c38e0f42709c826a$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    'debug': $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    'verbose': $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    'info': $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    'warn': $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    'error': $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    'silent': $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: 'info',
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: 'warn',
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $57d436074e210fb5$var$name$q = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.10.16";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/app');
const $57d436074e210fb5$var$name$p = "@firebase/app-compat";
const $57d436074e210fb5$var$name$o = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$n = "@firebase/analytics";
const $57d436074e210fb5$var$name$m = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$l = "@firebase/app-check";
const $57d436074e210fb5$var$name$k = "@firebase/auth";
const $57d436074e210fb5$var$name$j = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$i = "@firebase/database";
const $57d436074e210fb5$var$name$h = "@firebase/data-connect";
const $57d436074e210fb5$var$name$g = "@firebase/database-compat";
const $57d436074e210fb5$var$name$f = "@firebase/functions";
const $57d436074e210fb5$var$name$e = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$d = "@firebase/installations";
const $57d436074e210fb5$var$name$c = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$b = "@firebase/messaging";
const $57d436074e210fb5$var$name$a = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$9 = "@firebase/performance";
const $57d436074e210fb5$var$name$8 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$7 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$5 = "@firebase/storage";
const $57d436074e210fb5$var$name$4 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$3 = "@firebase/firestore";
const $57d436074e210fb5$var$name$2 = "@firebase/vertexai";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "11.0.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = '[DEFAULT]';
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$q]: 'fire-core',
    [$57d436074e210fb5$var$name$p]: 'fire-core-compat',
    [$57d436074e210fb5$var$name$n]: 'fire-analytics',
    [$57d436074e210fb5$var$name$o]: 'fire-analytics-compat',
    [$57d436074e210fb5$var$name$l]: 'fire-app-check',
    [$57d436074e210fb5$var$name$m]: 'fire-app-check-compat',
    [$57d436074e210fb5$var$name$k]: 'fire-auth',
    [$57d436074e210fb5$var$name$j]: 'fire-auth-compat',
    [$57d436074e210fb5$var$name$i]: 'fire-rtdb',
    [$57d436074e210fb5$var$name$h]: 'fire-data-connect',
    [$57d436074e210fb5$var$name$g]: 'fire-rtdb-compat',
    [$57d436074e210fb5$var$name$f]: 'fire-fn',
    [$57d436074e210fb5$var$name$e]: 'fire-fn-compat',
    [$57d436074e210fb5$var$name$d]: 'fire-iid',
    [$57d436074e210fb5$var$name$c]: 'fire-iid-compat',
    [$57d436074e210fb5$var$name$b]: 'fire-fcm',
    [$57d436074e210fb5$var$name$a]: 'fire-fcm-compat',
    [$57d436074e210fb5$var$name$9]: 'fire-perf',
    [$57d436074e210fb5$var$name$8]: 'fire-perf-compat',
    [$57d436074e210fb5$var$name$7]: 'fire-rc',
    [$57d436074e210fb5$var$name$6]: 'fire-rc-compat',
    [$57d436074e210fb5$var$name$5]: 'fire-gcs',
    [$57d436074e210fb5$var$name$4]: 'fire-gcs-compat',
    [$57d436074e210fb5$var$name$3]: 'fire-fst',
    [$57d436074e210fb5$var$name$1]: 'fire-fst-compat',
    [$57d436074e210fb5$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$57d436074e210fb5$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $57d436074e210fb5$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $57d436074e210fb5$export$fb03ad8d3d5c5f76.values())$57d436074e210fb5$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $57d436074e210fb5$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $57d436074e210fb5$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('app', 'Firebase', $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseServerAppImpl extends $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$q, $57d436074e210fb5$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $57d436074e210fb5$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $c38e0f42709c826a$export$3dfb6827a9f89756)());
    if (!options) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $57d436074e210fb5$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $c38e0f42709c826a$export$4e09c449d6c407f7)() && !(0, $c38e0f42709c826a$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($57d436074e210fb5$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $57d436074e210fb5$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $57d436074e210fb5$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(nameString);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $57d436074e210fb5$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $57d436074e210fb5$export$9f30fa0c10967f7f && (0, $c38e0f42709c826a$export$3dfb6827a9f89756)()) return $57d436074e210fb5$export$c55cfd413944906d();
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
    } else if ($57d436074e210fb5$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $57d436074e210fb5$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(' '));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $45b460d9de9b230f$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $45b460d9de9b230f$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$DB_NAME = 'firebase-heartbeat-database';
const $57d436074e210fb5$var$DB_VERSION = 1;
const $57d436074e210fb5$var$STORE_NAME = 'firebase-heartbeat-store';
let $57d436074e210fb5$var$dbPromise = null;
function $57d436074e210fb5$var$getDbPromise() {
    if (!$57d436074e210fb5$var$dbPromise) $57d436074e210fb5$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($57d436074e210fb5$var$DB_NAME, $57d436074e210fb5$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($57d436074e210fb5$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $57d436074e210fb5$var$dbPromise;
}
async function $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME);
        const result = await tx.objectStore($57d436074e210fb5$var$STORE_NAME).get($57d436074e210fb5$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
async function $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($57d436074e210fb5$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $57d436074e210fb5$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
function $57d436074e210fb5$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $57d436074e210fb5$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $57d436074e210fb5$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $57d436074e210fb5$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $57d436074e210fb5$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $57d436074e210fb5$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $57d436074e210fb5$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $c38e0f42709c826a$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $57d436074e210fb5$var$logger.warn(e);
            return '';
        }
    }
}
function $57d436074e210fb5$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $57d436074e210fb5$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $57d436074e210fb5$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $57d436074e210fb5$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
        else return (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $57d436074e210fb5$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $c38e0f42709c826a$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('platform-logger', (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('heartbeat', (container)=>new $57d436074e210fb5$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$q, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$q, $57d436074e210fb5$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents('');





const $1ee9b91e988771f9$var$name = "@firebase/installations";
const $1ee9b91e988771f9$var$version = "0.6.11";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS = 10000;
const $1ee9b91e988771f9$var$PACKAGE_VERSION = `w:${$1ee9b91e988771f9$var$version}`;
const $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $1ee9b91e988771f9$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $1ee9b91e988771f9$var$SERVICE = 'installations';
const $1ee9b91e988771f9$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $1ee9b91e988771f9$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)($1ee9b91e988771f9$var$SERVICE, $1ee9b91e988771f9$var$SERVICE_NAME, $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $1ee9b91e988771f9$var$isServerError(error) {
    return error instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$1ee9b91e988771f9$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $1ee9b91e988771f9$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $1ee9b91e988771f9$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    headers.append('Authorization', $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $1ee9b91e988771f9$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken) {
    return `${$1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig);
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $1ee9b91e988771f9$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $1ee9b91e988771f9$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $1ee9b91e988771f9$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $1ee9b91e988771f9$var$encode(fidByteArray);
        return $1ee9b91e988771f9$var$VALID_FID_PATTERN.test(fid) ? fid : $1ee9b91e988771f9$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $1ee9b91e988771f9$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $1ee9b91e988771f9$var$encode(fidByteArray) {
    const b64String = $1ee9b91e988771f9$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $1ee9b91e988771f9$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $1ee9b91e988771f9$var$fidChanged(appConfig, fid) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid);
    $1ee9b91e988771f9$var$broadcastFidChange(key, fid);
}
function $1ee9b91e988771f9$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $1ee9b91e988771f9$var$getBroadcastChannel();
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    let callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $1ee9b91e988771f9$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $1ee9b91e988771f9$var$removeCallback(appConfig, callback) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $1ee9b91e988771f9$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
function $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $1ee9b91e988771f9$var$broadcastFidChange(key, fid) {
    const channel = $1ee9b91e988771f9$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
let $1ee9b91e988771f9$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $1ee9b91e988771f9$var$getBroadcastChannel() {
    if (!$1ee9b91e988771f9$var$broadcastChannel && 'BroadcastChannel' in self) {
        $1ee9b91e988771f9$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $1ee9b91e988771f9$var$broadcastChannel.onmessage = (e)=>{
            $1ee9b91e988771f9$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $1ee9b91e988771f9$var$broadcastChannel;
}
function $1ee9b91e988771f9$var$closeBroadcastChannel() {
    if ($1ee9b91e988771f9$var$fidChangeCallbacks.size === 0 && $1ee9b91e988771f9$var$broadcastChannel) {
        $1ee9b91e988771f9$var$broadcastChannel.close();
        $1ee9b91e988771f9$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$DATABASE_NAME = 'firebase-installations-database';
const $1ee9b91e988771f9$var$DATABASE_VERSION = 1;
const $1ee9b91e988771f9$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $1ee9b91e988771f9$var$dbPromise = null;
function $1ee9b91e988771f9$var$getDbPromise() {
    if (!$1ee9b91e988771f9$var$dbPromise) $1ee9b91e988771f9$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($1ee9b91e988771f9$var$DATABASE_NAME, $1ee9b91e988771f9$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $1ee9b91e988771f9$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $1ee9b91e988771f9$var$set(appConfig, value) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $1ee9b91e988771f9$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $1ee9b91e988771f9$var$remove(appConfig) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $1ee9b91e988771f9$var$update(appConfig, updateFn) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $1ee9b91e988771f9$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $1ee9b91e988771f9$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $1ee9b91e988771f9$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $1ee9b91e988771f9$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $1ee9b91e988771f9$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $1ee9b91e988771f9$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $1ee9b91e988771f9$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $1ee9b91e988771f9$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $1ee9b91e988771f9$var$createInstallationRequest(installations, installationEntry);
        return $1ee9b91e988771f9$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $1ee9b91e988771f9$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $1ee9b91e988771f9$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateInstallationRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $1ee9b91e988771f9$var$clearTimedOutRequest(oldEntry);
    });
}
function $1ee9b91e988771f9$var$clearTimedOutRequest(entry) {
    if ($1ee9b91e988771f9$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $1ee9b91e988771f9$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse('Generate Auth Token', response);
}
function $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $1ee9b91e988771f9$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateAuthTokenRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $1ee9b91e988771f9$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $1ee9b91e988771f9$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $1ee9b91e988771f9$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$1ee9b91e988771f9$var$isAuthTokenExpired(authToken);
}
function $1ee9b91e988771f9$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $1ee9b91e988771f9$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $1ee9b91e988771f9$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $1ee9b91e988771f9$var$getErrorFromResponse('Delete Installation', response);
}
function $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, entry);
                await $1ee9b91e988771f9$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $1ee9b91e988771f9$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $1ee9b91e988771f9$var$addCallback(appConfig, callback);
    return ()=>{
        $1ee9b91e988771f9$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $1ee9b91e988771f9$export$9bfc115e43431ff5(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$extractAppConfig(app) {
    if (!app || !app.options) throw $1ee9b91e988771f9$var$getMissingValueError('App Configuration');
    if (!app.name) throw $1ee9b91e988771f9$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $1ee9b91e988771f9$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $1ee9b91e988771f9$var$getMissingValueError(valueName) {
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$INSTALLATIONS_NAME = 'installations';
const $1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $1ee9b91e988771f9$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $1ee9b91e988771f9$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $1ee9b91e988771f9$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $1ee9b91e988771f9$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$1ee9b91e988771f9$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $1ee9b91e988771f9$var$registerInstallations() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($1ee9b91e988771f9$var$INSTALLATIONS_NAME, $1ee9b91e988771f9$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL, $1ee9b91e988771f9$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $1ee9b91e988771f9$var$registerInstallations();
(0, $57d436074e210fb5$export$d29d5299a7137abc)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
(0, $57d436074e210fb5$export$d29d5299a7137abc)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version, 'esm2017');






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
const $97b6afad2c5c80cd$var$DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
const $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const $97b6afad2c5c80cd$var$ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */ const $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
var $97b6afad2c5c80cd$var$MessageType$1;
(function(MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})($97b6afad2c5c80cd$var$MessageType$1 || ($97b6afad2c5c80cd$var$MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var $97b6afad2c5c80cd$var$MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})($97b6afad2c5c80cd$var$MessageType || ($97b6afad2c5c80cd$var$MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $97b6afad2c5c80cd$var$base64ToArray(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ const $97b6afad2c5c80cd$var$OLD_DB_VERSION = 5;
const $97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function $97b6afad2c5c80cd$var$migrateOldDatabase(senderId) {
    if ('databases' in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db)=>db.name);
        if (!dbNames.includes($97b6afad2c5c80cd$var$OLD_DB_NAME)) // old DB didn't exist, no need to open.
        return null;
    }
    let tokenDetails = null;
    const db = await (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($97b6afad2c5c80cd$var$OLD_DB_NAME, $97b6afad2c5c80cd$var$OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction)=>{
            var _a;
            if (oldVersion < 2) // Database too old, skip migration.
            return;
            if (!db.objectStoreNames.contains($97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
            return;
            const objectStore = upgradeTransaction.objectStore($97b6afad2c5c80cd$var$OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index('fcmSenderId').get(senderId);
            await objectStore.clear();
            if (!value) // No entry in the database, nothing to migrate.
            return;
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === 'string' ? oldDetails.vapidKey : $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.auth),
                        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.auth),
                        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $97b6afad2c5c80cd$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await (0, $da032767b57a4aa4$export$9d6df0ac66a98bb2)($97b6afad2c5c80cd$var$OLD_DB_NAME);
    await (0, $da032767b57a4aa4$export$9d6df0ac66a98bb2)('fcm_vapid_details_db');
    await (0, $da032767b57a4aa4$export$9d6df0ac66a98bb2)('undefined');
    return $97b6afad2c5c80cd$var$checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function $97b6afad2c5c80cd$var$checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions: subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === 'number' && tokenDetails.createTime > 0 && typeof tokenDetails.token === 'string' && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === 'string' && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === 'string' && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === 'string' && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === 'string' && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === 'string' && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Exported for tests.
const $97b6afad2c5c80cd$var$DATABASE_NAME = 'firebase-messaging-database';
const $97b6afad2c5c80cd$var$DATABASE_VERSION = 1;
const $97b6afad2c5c80cd$var$OBJECT_STORE_NAME = 'firebase-messaging-store';
let $97b6afad2c5c80cd$var$dbPromise = null;
function $97b6afad2c5c80cd$var$getDbPromise() {
    if (!$97b6afad2c5c80cd$var$dbPromise) $97b6afad2c5c80cd$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($97b6afad2c5c80cd$var$DATABASE_NAME, $97b6afad2c5c80cd$var$DATABASE_VERSION, {
        upgrade: (upgradeDb, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
            // because if there are multiple versions between the old version and the current version, we
            // want ALL the migrations that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    upgradeDb.createObjectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $97b6afad2c5c80cd$var$dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */ async function $97b6afad2c5c80cd$var$dbGet(firebaseDependencies) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tokenDetails = await db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        // Check if there is a tokenDetails object in the old DB.
        const oldTokenDetails = await $97b6afad2c5c80cd$var$migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, tokenDetails) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tx = db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $97b6afad2c5c80cd$var$dbRemove(firebaseDependencies) {
    const key = $97b6afad2c5c80cd$var$getKey(firebaseDependencies);
    const db = await $97b6afad2c5c80cd$var$getDbPromise();
    const tx = db.transaction($97b6afad2c5c80cd$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($97b6afad2c5c80cd$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function $97b6afad2c5c80cd$var$getKey({ appConfig: appConfig }) {
    return appConfig.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ ]: 'This method is available in a Window context.',
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */ ]: 'This method is available in a service worker context.',
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */ ]: 'The notification permission was not granted and dismissed instead.',
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ ]: 'The notification permission was not granted and blocked instead.',
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ ]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ ]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ ]: 'We are unable to register the default service worker. {$browserErrorMessage}',
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ ]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ ]: 'FCM returned no token when subscribing the user to push.',
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ ]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ ]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ ]: 'FCM returned no token when updating the user to push.',
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */ ]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ ]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */ ]: 'The input to setBackgroundMessageHandler() must be a function.',
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */ ]: 'The public VAPID key must be a string.',
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */ ]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
};
const $97b6afad2c5c80cd$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('messaging', 'Messaging', $97b6afad2c5c80cd$var$ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const body = $97b6afad2c5c80cd$var$getBody(subscriptionOptions);
    const subscribeOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch($97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ );
    return responseData.token;
}
async function $97b6afad2c5c80cd$var$requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const body = $97b6afad2c5c80cd$var$getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${$97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ );
    return responseData.token;
}
async function $97b6afad2c5c80cd$var$requestDeleteToken(firebaseDependencies, token) {
    const headers = await $97b6afad2c5c80cd$var$getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: 'DELETE',
        headers: headers
    };
    try {
        const response = await fetch(`${$97b6afad2c5c80cd$var$getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
                errorInfo: message
            });
        }
    } catch (err) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function $97b6afad2c5c80cd$var$getEndpoint({ projectId: projectId }) {
    return `${$97b6afad2c5c80cd$var$ENDPOINT}/projects/${projectId}/registrations`;
}
async function $97b6afad2c5c80cd$var$getHeaders({ appConfig: appConfig, installations: installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': appConfig.apiKey,
        'x-goog-firebase-installations-auth': `FIS ${authToken}`
    });
}
function $97b6afad2c5c80cd$var$getBody({ p256dh: p256dh, auth: auth, endpoint: endpoint, vapidKey: vapidKey }) {
    const body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // UpdateRegistration will be called once every week.
const $97b6afad2c5c80cd$var$TOKEN_EXPIRATION_MS = 604800000; // 7 days
async function $97b6afad2c5c80cd$var$getTokenInternal(messaging) {
    const pushSubscription = await $97b6afad2c5c80cd$var$getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: $97b6afad2c5c80cd$var$arrayToBase64(pushSubscription.getKey('auth')),
        p256dh: $97b6afad2c5c80cd$var$arrayToBase64(pushSubscription.getKey('p256dh'))
    };
    const tokenDetails = await $97b6afad2c5c80cd$var$dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) // No token, get a new one.
    return $97b6afad2c5c80cd$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!$97b6afad2c5c80cd$var$isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await $97b6afad2c5c80cd$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return $97b6afad2c5c80cd$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + $97b6afad2c5c80cd$var$TOKEN_EXPIRATION_MS) // Weekly token refresh
    return $97b6afad2c5c80cd$var$updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    });
    else // Valid token, nothing to do.
    return tokenDetails.token;
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */ async function $97b6afad2c5c80cd$var$deleteTokenInternal(messaging) {
    const tokenDetails = await $97b6afad2c5c80cd$var$dbGet(messaging.firebaseDependencies);
    if (tokenDetails) {
        await $97b6afad2c5c80cd$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        await $97b6afad2c5c80cd$var$dbRemove(messaging.firebaseDependencies);
    }
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    // If there's no SW, consider it a success.
    return true;
}
async function $97b6afad2c5c80cd$var$updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await $97b6afad2c5c80cd$var$requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
            token: updatedToken,
            createTime: Date.now()
        });
        await $97b6afad2c5c80cd$var$dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e) {
        throw e;
    }
}
async function $97b6afad2c5c80cd$var$getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await $97b6afad2c5c80cd$var$requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token: token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    };
    await $97b6afad2c5c80cd$var$dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */ async function $97b6afad2c5c80cd$var$getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: $97b6afad2c5c80cd$var$base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function $97b6afad2c5c80cd$var$isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    $97b6afad2c5c80cd$var$propagateNotificationPayload(payload, internalPayload);
    $97b6afad2c5c80cd$var$propagateDataPayload(payload, internalPayload);
    $97b6afad2c5c80cd$var$propagateFcmOptions(payload, internalPayload);
    return payload;
}
function $97b6afad2c5c80cd$var$propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    const body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    const image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) payload.notification.icon = icon;
}
function $97b6afad2c5c80cd$var$propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function $97b6afad2c5c80cd$var$propagateFcmOptions(payload, messagePayloadInternal) {
    var _a, _b, _c, _d, _e;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions && !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) return;
    payload.fcmOptions = {};
    const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && $97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $97b6afad2c5c80cd$var$_mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
function $97b6afad2c5c80cd$var$_mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join('');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$extractAppConfig(app) {
    if (!app || !app.options) throw $97b6afad2c5c80cd$var$getMissingValueError('App Configuration Object');
    if (!app.name) throw $97b6afad2c5c80cd$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    const { options: options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw $97b6afad2c5c80cd$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function $97b6afad2c5c80cd$var$getMissingValueError(valueName) {
    return $97b6afad2c5c80cd$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $97b6afad2c5c80cd$var$MessagingService {
    constructor(app, installations, analyticsProvider){
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = $97b6afad2c5c80cd$var$extractAppConfig(app);
        this.firebaseDependencies = {
            app: app,
            appConfig: appConfig,
            installations: installations,
            analyticsProvider: analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register($97b6afad2c5c80cd$var$DEFAULT_SW_PATH, {
            scope: $97b6afad2c5c80cd$var$DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(()=>{
        /* it is non blocking and we don't care if it failed */ });
    } catch (e) {
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ , {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await $97b6afad2c5c80cd$var$registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ );
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = $97b6afad2c5c80cd$var$DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$getToken$1(messaging, options) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === 'default') await Notification.requestPermission();
    if (Notification.permission !== 'granted') throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    await $97b6afad2c5c80cd$var$updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await $97b6afad2c5c80cd$var$updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return $97b6afad2c5c80cd$var$getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$logToScion(messaging, messageType, data) {
    const eventType = $97b6afad2c5c80cd$var$getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ID],
        message_name: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_NAME],
        message_time: data[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
    });
}
function $97b6afad2c5c80cd$var$getEventType(messageType) {
    switch(messageType){
        case $97b6afad2c5c80cd$var$MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case $97b6afad2c5c80cd$var$MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === $97b6afad2c5c80cd$var$MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === 'function') messaging.onMessageHandler($97b6afad2c5c80cd$var$externalizePayload(internalPayload));
        else messaging.onMessageHandler.next($97b6afad2c5c80cd$var$externalizePayload(internalPayload));
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if ($97b6afad2c5c80cd$var$isConsoleMessage(dataPayload) && dataPayload[$97b6afad2c5c80cd$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1') await $97b6afad2c5c80cd$var$logToScion(messaging, internalPayload.messageType, dataPayload);
}
const $97b6afad2c5c80cd$var$name = "@firebase/messaging";
const $97b6afad2c5c80cd$var$version = "0.12.14";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $97b6afad2c5c80cd$var$WindowMessagingFactory = (container)=>{
    const messaging = new $97b6afad2c5c80cd$var$MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
    navigator.serviceWorker.addEventListener('message', (e)=>$97b6afad2c5c80cd$var$messageEventListener(messaging, e));
    return messaging;
};
const $97b6afad2c5c80cd$var$WindowMessagingInternalFactory = (container)=>{
    const messaging = container.getProvider('messaging').getImmediate();
    const messagingInternal = {
        getToken: (options)=>$97b6afad2c5c80cd$var$getToken$1(messaging, options)
    };
    return messagingInternal;
};
function $97b6afad2c5c80cd$var$registerMessagingInWindow() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('messaging', $97b6afad2c5c80cd$var$WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('messaging-internal', $97b6afad2c5c80cd$var$WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($97b6afad2c5c80cd$var$name, $97b6afad2c5c80cd$var$version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($97b6afad2c5c80cd$var$name, $97b6afad2c5c80cd$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */ async function $97b6afad2c5c80cd$export$48c17662a6902497() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)();
    } catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return typeof window !== 'undefined' && (0, $c38e0f42709c826a$export$3865db50535c2055)() && (0, $c38e0f42709c826a$export$f172b7eb6cf60599)() && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $97b6afad2c5c80cd$var$deleteToken$1(messaging) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (!messaging.swRegistration) await $97b6afad2c5c80cd$var$registerDefaultSw(messaging);
    return $97b6afad2c5c80cd$var$deleteTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $97b6afad2c5c80cd$var$onMessage$1(messaging, nextOrObserver) {
    if (!navigator) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    messaging.onMessageHandler = nextOrObserver;
    return ()=>{
        messaging.onMessageHandler = null;
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$f74c3c76482a8451(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    $97b6afad2c5c80cd$export$48c17662a6902497().then((isSupported)=>{
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ );
    }, (_)=>{
        // If `isWindowSupported()` rejected.
        throw $97b6afad2c5c80cd$var$ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ );
    });
    return (0, $57d436074e210fb5$export$fa0d6da0f5838f50)((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app), 'messaging').getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */ async function $97b6afad2c5c80cd$export$257b2d10b709d8ef(messaging, options) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$95d23a5f596fdc8e(messaging) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */ function $97b6afad2c5c80cd$export$7275a8dcb77dc20d(messaging, nextOrObserver) {
    messaging = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(messaging);
    return $97b6afad2c5c80cd$var$onMessage$1(messaging, nextOrObserver);
}
/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $97b6afad2c5c80cd$var$registerMessagingInWindow();





// import iconNavActWallet from "../../../Icons/nav-icons/active/wallet.png";
// import iconNavWallet from "../../../Icons/nav-icons/none-active/wallet.png";
// import iconNavActHome from "../../../Icons/NV/nav-version 2.0/act/home.png";
// import iconNavActSaved from "../../../Icons/NV/nav-version 2.0/act/noti.png";
// import iconNavActBusiness from "../../../Icons/NV/nav-version 2.0/act/acti.png";
// import iconNavActMenu from "../../../Icons/NV/nav-version 2.0/act/menu.png";
// import iconNavHome from "../../../Icons/NV/nav-version 2.0/none-act/home.png";
// import iconNavSaved from "../../../Icons/NV/nav-version 2.0/none-act/noti.png";
// import iconNavBusiness from "../../../Icons/NV/nav-version 2.0/none-act/acti.png";
// import iconNavMenu from "../../../Icons/NV/nav-version 2.0/none-act/menu.png";
var $88f9782579f7686d$exports = {};
$88f9782579f7686d$exports = new URL("home.6ad74136.png", import.meta.url).toString();


var $4cb497ff9fea61cf$exports = {};
$4cb497ff9fea61cf$exports = new URL("notification.171a9586.png", import.meta.url).toString();


var $552f21117d8c010d$exports = {};
$552f21117d8c010d$exports = new URL("acti.247efd7d.png", import.meta.url).toString();


var $3b1f096ec516b8ec$exports = {};
$3b1f096ec516b8ec$exports = new URL("menu.afd2bac0.png", import.meta.url).toString();


var $58e6274e123f7274$exports = {};
$58e6274e123f7274$exports = new URL("home.db3cc163.png", import.meta.url).toString();


var $3d1e6e71eb7e5348$exports = {};
$3d1e6e71eb7e5348$exports = new URL("notification.1af28844.png", import.meta.url).toString();


var $532b86f0cc5dafb6$exports = {};
$532b86f0cc5dafb6$exports = new URL("acti.c2c00cf8.png", import.meta.url).toString();


var $14fe910e53b1d182$exports = {};
$14fe910e53b1d182$exports = new URL("menu.92f84406.png", import.meta.url).toString();


var $8fd602925f160669$exports = {};
$8fd602925f160669$exports = new URL("back.acb25378.png", import.meta.url).toString();


var $1846610f282efb94$exports = {};
$1846610f282efb94$exports = new URL("exit-2px.f465ccbe.png", import.meta.url).toString();


var $808a0634a82ded0c$exports = {};
$808a0634a82ded0c$exports = new URL("mai-logo-blured.92e6dd8f.avif", import.meta.url).toString();


var $4fa095f945859e7c$exports = {};
$4fa095f945859e7c$exports = new URL("location-radius.87cac46a.png", import.meta.url).toString();


var $be137f656f8c64d6$exports = {};
$be137f656f8c64d6$exports = new URL("location-radius.ffdd9459.png", import.meta.url).toString();


var $00ab7ca9967cc321$exports = {};
$00ab7ca9967cc321$exports = new URL("search.350149f8.png", import.meta.url).toString();


var $fcd68649b92b39ce$exports = {};
$fcd68649b92b39ce$exports = new URL("listings.6ed6101e.png", import.meta.url).toString();


var $3bc97c66feee2b68$exports = {};
$3bc97c66feee2b68$exports = new URL("business.f99ea506.png", import.meta.url).toString();


var $b4288772f84d3451$exports = {};
$b4288772f84d3451$exports = new URL("seller.9721b569.png", import.meta.url).toString();


var $d9126ea873ff0a97$exports = {};
$d9126ea873ff0a97$exports = new URL("add.b16e5ec5.png", import.meta.url).toString();


var $5d1b842b8f157265$exports = {};
$5d1b842b8f157265$exports = new URL("30 sec icon.20a2b55d.png", import.meta.url).toString();


// <div id="homeScreenDisplayInitialScreenScrollButtonScrollTop" class="initScreenButtonScrollTopCon1 initScreenButtonScrollTopCon1Translate100">
//   <img height="20px" src="${iconToTop}" alt="" />
// </div>
class $632c6627a2700d24$var$GenarateHtml {
    _topToolsSetter() {
        return `




      <img class="maiHomeScreenTipsCon1BackPhoto" src="${0, (/*@__PURE__*/$parcel$interopDefault($808a0634a82ded0c$exports))}"/>
      <div id="homeScreenDisplayAll" class="homeScreenDisplayMainScreens" style="display: none">
        <div id="MainHomeContainerForAllItemsDisplay" class="MainAppConWithNavigationContentConForListings" style="display: none"></div>
        <div id="NVHomeMainContainerListings" class="MainAppConWithNavigationContentConForListings" style="display: flex"></div>
        <div id="NVHomeMainContainerBusinesses" class="MainAppConWithNavigationContentConForListings" style="display: none"></div>
        <div id="NVHomeMainContainerSellers" class="MainAppConWithNavigationContentConForListings" style="display: none"></div>

        <div id="homeScreenDisplayAllButtonBack" class="homeHeaderSearchCon10A1 topRightExitButtonOnFullScreenWindow" style="display: flex">
            <img height="30px" src="${0, (/*@__PURE__*/$parcel$interopDefault($8fd602925f160669$exports))}"/>
        </div>


        <div id="homeHeaderSearchCon1" class="homeHeaderSearchCon1">
          <div class="homeHeaderSearchCon3">

            <div id="nvHeaderCon2BigAddContainerA" class="nvHeaderCon2BigAddA">
              <div id="nvHeaderCon2BigAddContainer" class="nvHeaderCon2BigAdd"></div>
            </div>

            <div id="homeHeaderSearchCon9" class="homeHeaderSearchCon9">

              <div id="homeHeaderSearchCon10A" class="homeHeaderSearchCon10A homeHeaderSearchCon10APaddingLeft">

                <div class="homeHeaderSearchCon10A2">
                  <label id="homeHeaderSearchCon10" class="homeHeaderSearchCon10">
                    <img id="SearchStartUpComponentSearchInputIcon" height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($00ab7ca9967cc321$exports))}" alt="" />
                    <input
                      id="SearchStartUpComponentSearchInput"
                      class="SearchStartUpComponentCon5Input"
                      type="text"
                      placeholder="Buscar en Mercado MAI"
                      enterkeyhint="search" 
                    />
                  </label>
                </div>
                <div data-close="search" id="homeScreenDisplayAllButtonCloseSearch" class="homeHeaderSearchCon10A1 topRightExitButtonOnFullScreenWindow" style="display: none">
                    <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1846610f282efb94$exports))}"/>
                </div>
              </div>


              <div id="homeHeaderSearchCatCon" class="homeHeaderSearchCon11">
                <div class="homeHeaderSearchCon12">

                  <div data-category="listings" class="headerCatSelectorOnClick homeHeaderCategorySelectCon1 homeHeaderCategorySelectCon1ACT">
                    <div class="homeHeaderCategorySelectCon2 homeHeaderCategorySelectCon2Act">
                      <div class="homeHeaderSearchText1 homeHeaderSearchText1ACT">Listados</div>
                      <div id="homeHeaderSearchText1BListings" class="homeHeaderSearchText1B homeHeaderSearchText1BACT"></div>
                    </div>
                  </div> 

                  <div data-category="businesses" class="headerCatSelectorOnClick homeHeaderCategorySelectCon1">
                    <div class="homeHeaderCategorySelectCon2">
                      <div class="homeHeaderSearchText1">Empresas</div>
                      <div id="homeHeaderSearchText1BBusinesses" class="homeHeaderSearchText1B"></div>
                    </div>
                  </div> 

                  <div data-category="indsellers" class="headerCatSelectorOnClick homeHeaderCategorySelectCon1">
                    <div class="homeHeaderCategorySelectCon2">
                      <div class="homeHeaderSearchText1">Vendedores</div>
                      <div id="homeHeaderSearchText1BSellers" class="homeHeaderSearchText1B"></div>
                    </div>
                  </div> 

                </div>
              </div>

              <div id="locationFilterParentCon" class="locationFilterCon1">
                <div id="locationFilterAdjCon" class="locationFilterCon6" style="display: none">
                  <div class="locationFilterCon7">
                    <div class="locationFilterCon8">
                      <div class="locationFilterText3">Encontrar cerca de:</div>
                    </div>
                    <div class="locationFilterCon9">
                      <div id="locationFilterTagButtonOpenLocation" class="locationFilterCon10">
                        <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($be137f656f8c64d6$exports))}"/>
                        <div id="locationFilterSelectedLocationTag" class="locationFilterText4">Favor selecciona una ubicaci\xf3n primero</div>
                      </div>
                      <div id="locationFilterButtonOpenLocation" class="locationFilterCon11">
                        <div class="locationFilterText5">Cambiar</div>
                      </div>
                    </div>
                  </div>
                  <div class="locationFilterCon12">
                    <div class="locationFilterCon13">
                      <div class="locationFilterCon14">
                        <div class="locationFilterCon15">
                          <div class="locationFilterText6">Todo dentro de</div>
                        </div>

                        <div class="locationFilterKmCon1">
                          <div class="locationFilterKmCon3">
                            <div class="locationFilterKmCon4"></div>
                            <div id="locationFilterKmCon5" class="locationFilterKmCon5">
                              <div class="locationFilterKmCon7" data-km="10">
                                <div class="locationFilterKmText1">10 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="20">
                                <div class="locationFilterKmText1">20 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="50">
                                <div class="locationFilterKmText1">50 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="100">
                                <div class="locationFilterKmText1">100 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="200">
                                <div class="locationFilterKmText1">200 Km</div>
                              </div>
                              <div class="locationFilterKmCon7" data-km="500">
                                <div class="locationFilterKmText1">500 Km</div>
                              </div>
                            </div>
                            <div class="locationFilterKmCon6"></div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="locationFilterCon16">
                    <div id="locationFilterButtonCloseFilter" class="locationFilterCon17 topRightExitButtonOnFullScreenWindow">
                      <div class="locationFilterText7">Cerrar filtro</div>
                    </div>
                    <div id="locationFilterButtonAplyFilter" class="locationFilterCon18">
                      <div class="locationFilterText8">Filtrar listados</div>
                    </div>
                  </div>
                </div>


                <div id="locationFilterOpenerCon" class="locationFilterCon2" style="display: flex">
                  <div class="locationFilterCon3">
                    <div class="locationFilterCon4">
                      <div class="locationFilterText1">Encuentra lo que est\xe1 cerca de t\xed</div>
                    </div>
                    <div class="locationFilterCon5">
                      <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($4fa095f945859e7c$exports))}"/>
                      <div class="locationFilterText2">Descubrir</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div id="NVHeaderConSearchConPullDownCon1" class="NVHeaderConSearchConPullDownCon1">
            <div id="NVHeaderConSearchCon2B2" class="NVHeaderConSearchCon2B"></div>
          </div>

        </div>
      </div>





      <div id="homeScreenDisplayInitialScreen" class="homeScreenDisplayMainScreens" style="display: flex">
        <div id="homeScreenDisplayInitialScreenScroll" class="initScreenCon1">
        
          <div class="initScreenCon2">
           
            <div id="initScreenCon3" class="initScreenCon3">
              <div id="initScreenOpenSearch" class="initScreenCon4">
                <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($00ab7ca9967cc321$exports))}" alt="" />
                <div class="initScreenText1">Buscar en Mercado MAI</div>
              </div>
            </div>





            <div id="" class="maiHomeScreenTipsCon1" style="display: flex">
              <div class="maiHomeScreenTipsCon2 maiHomeScreenTipsCon2NEW">
                <div class="maiHomeScreenTipsCon3">
                  <div class="maiHomeScreenTipsCon4 maiHomeScreenTipsCon4NEW">
                    <div class="mercadoMaiTips mercadoMaiTipsNEW">Descubre lo nuevo</div>
                  </div>
                </div>

                <div class="homeScreenLocationFilterCtaCon1">

                  <div id="homeScreenLocationFilterCtaCon2" class="homeScreenLocationFilterCtaCon2">
                    <div class="homeScreenLocationFilterCtaCon3">
                      <div class="homeScreenLocationFilterCtaCon7">
                        <div class="homeScreenLocationFilterCtaText2">Ya puedes filtrar por ubicaci\xf3n</div>
                        <div class="homeScreenLocationFilterCtaCon8">
                          <div class="homeScreenLocationFilterCtaText3">'Cerca de mi'</div>
                          <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($be137f656f8c64d6$exports))}"/>
                        </div>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon6">
                        <img class="homeScreenLocationFilterCtaCon6Img" src="https://storage.googleapis.com/mqmexico-7c834.firebasestorage.app/mercado_mai_tips/thumbnails/variants/res_500/87ae8cdc-82ec-46f1-a6e9-09432785719c.avif"/>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon5">
                        <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($4fa095f945859e7c$exports))}"/>
                        <div class="homeScreenLocationFilterCtaText4">Encontrar listados cercanos ahora</div>
                      </div>
                      <div class="homeScreenLocationFilterCtaCon4">
                        <div class="homeScreenLocationFilterCtaText1">NUEVO</div>
                      </div>
                    </div>
                  </div>

                  <div id="homeScreenUploadCtaCon2" class="homeScreenLocationFilterCtaCon2">
                    <div class="homeScreenLocationFilterCtaCon3">
                      <div class="homeScreenLocationFilterCtaCon7">
                        <div class="homeScreenLocationFilterCtaText2 homeScreenLocationFilterCtaText2SubUpload">Publicar mas r\xe1pido</div>
                        <div class="homeScreenLocationFilterCtaCon8">
                          <div class="homeScreenLocationFilterCtaText3">30 seg.</div>
                          <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($5d1b842b8f157265$exports))}"/>
                        </div>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon6">
                        <img class="homeScreenLocationFilterCtaCon6Img" src="https://storage.googleapis.com/mqmexico-7c834.firebasestorage.app/mercado_mai_tips/thumbnails/variants/res_500/4a178e37-0184-4ec6-a774-ae57ac51cdc3.avif"/>
                      </div>

                      <div class="homeScreenLocationFilterCtaCon5 homeScreenLocationFilterCtaCon5SubUpload">
                        <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($d9126ea873ff0a97$exports))}"/>
                        <div class="homeScreenLocationFilterCtaText4 homeScreenLocationFilterCtaText4SubUpload">Publicar listado</div>
                      </div>
                      <div class="homeScreenLocationFilterCtaCon4">
                        <div class="homeScreenLocationFilterCtaText1">Mejorado</div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>







            <div id="initScreenInsertTopAdds" class="initScreenCon6 initScreenCon6NoAdds">
              <div class=" "></div>
            </div>


            <div id="maiHomeScreenTipsCon5TipsParentCon" class="maiHomeScreenTipsCon1" style="display: none">

              <div class="maiHomeScreenTipsCon2 maiHomeScreenTipsCon2TIPS">
                <div class="maiHomeScreenTipsCon3">
                  <div class="maiHomeScreenTipsCon4 maiHomeScreenTipsCon4TIPS">
                    <div class="mercadoMaiTips mercadoMaiTipsTIPS">Tips</div>
                  </div>
                </div>
                <div id="maiHomeScreenTipsCon5TipsCon" class="maiHomeScreenTipsCon5"></div>
              </div>
            </div>




            
  
          </div>
          <div class="initScreenCon14B">
            <div id="" class="maiHomeScreenTipsCon1B" style="display: flex">
              <div class="maiHomeScreenTipsCon2 maiHomeScreenTipsCon2CAT">
                <div class="maiHomeScreenTipsCon3">
                  <div class="maiHomeScreenTipsCon4 maiHomeScreenTipsCon4CAT">
                    <div class="mercadoMaiTips mercadoMaiTipsCAT">Descubre mas</div>
                  </div>
                </div>

                <div class="initScreenCon11">
                  <div id="initScreenOpenListings" class="initScreenCon12">
                    <div class="initScreenCon13">
                      <img height="29px" src="${0, (/*@__PURE__*/$parcel$interopDefault($fcd68649b92b39ce$exports))}" alt="" />
                    </div>
                    <div class="initScreenText3">Listados</div>
                  </div>
                  <div id="initScreenOpenBusinesses" class="initScreenCon12">
                    <div class="initScreenCon13">
                      <img height="29px" src="${0, (/*@__PURE__*/$parcel$interopDefault($3bc97c66feee2b68$exports))}" alt="" />
                    </div>
                    <div class="initScreenText3">Empresas</div>
                  </div>
                  <div id="initScreenOpenSellers" class="initScreenCon12">
                    <div class="initScreenCon13">
                      <img height="29px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b4288772f84d3451$exports))}" alt="" />
                    </div>
                    <div class="initScreenText3">Vendedores</div>
                  </div>
                </div>
              </div>
            </div>

            <div id="initScreenInsertListings" class="initScreenCon14"></div>
          </div>
        </div>
      </div>
    `;
    }
    _initScreenAdd(data) {
        // --- Build gradient string ---
        const gradient = data.gradient;
        let backgroundStyle = '';
        if (gradient?.type === "linear") {
            const stops = gradient.stops.map((stop)=>`${stop.color} ${stop.pos}%`).join(', ');
            backgroundStyle = `linear-gradient(${gradient.angle}deg, ${stops})`;
        }
        // --- Build items HTML dynamically ---
        const itemsHtml = data.items.map((item)=>`
    <div data-openlink="${item.openLink || data.openLink}" class="initScreenTopAddCon4">
      <img class="initScreenTopAddCon5" src="${item.imageUrl || 'https://placehold.co/90x66'}">
      <div class="initScreenTopAddText2">${item.text}</div>
    </div>
  `).join('');
        return `
    <div data-openlink="${data.openLink}" class="initScreenTopAddCon1" style="background:${backgroundStyle}">
      
      <div class="initScreenTopAddText1" style="color:${data.title.color}">
        ${data.title.text}
      </div>

      <div class="initScreenTopAddCon2">
        <div class="initScreenTopAddCon3">
          ${itemsHtml}
        </div>
      </div>

      <div class="initScreenTopAddCon6">
        <div class="initScreenTopAddText3" style="color:${data.description.color}">
          ${data.description.text}
        </div>
        <div class="initScreenTopAddText4" style="color:${data.ctaText.color}">
          ${data.ctaText.text}
        </div>
      </div>

      <div class="initScreenTopAddCon7">
        <div
          class="initScreenTopAddCon8" 
          style="background:${data.button.buttonColor}"
        >
          <div 
            class="initScreenTopAddText5" 
            style="color:${data.button.textColor}"
          >
            ${data.button.text}
          </div>
        </div>
      </div>

    </div>
  `;
    }
    _addContainerM1(adds) {
        return `
    
      <div class="model1AddCon1">
        <div class="model1AddCon2">
          <div class="model1AddCon3">
            <div class="model1AddText1">Hecha un vistazo</div>
          </div>
          <img class="model1AddButtonClose" height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1846610f282efb94$exports))}">
        </div>
        <div class="model1AddCon4">${adds}</div>
      </div>

    
    `;
    }
}
var $632c6627a2700d24$export$2e2bcd8739ae039 = new $632c6627a2700d24$var$GenarateHtml();



var $e03292d484fbbd10$exports = {};
$e03292d484fbbd10$exports = new URL("done.0b4a0ff7.png", import.meta.url).toString();


var $a5bec78d03ff2315$exports = {};
$a5bec78d03ff2315$exports = new URL("camara.3e71a423.png", import.meta.url).toString();


var $e065fa7fb3212492$exports = {};
$e065fa7fb3212492$exports = new URL("back.c67811e5.png", import.meta.url).toString();


var $2fa5f8396b01a065$exports = {};
$2fa5f8396b01a065$exports = new URL("listed.b2f6fc86.png", import.meta.url).toString();


var $eeee17e91b69eea4$exports = {};
$eeee17e91b69eea4$exports = new URL("go.04a1cde7.png", import.meta.url).toString();


var $7a2c58f3c1632c4a$exports = {};
$7a2c58f3c1632c4a$exports = new URL("account.7544bf72.png", import.meta.url).toString();


var $660d57b441f0f617$exports = {};
$660d57b441f0f617$exports = new URL("map.8b977074.png", import.meta.url).toString();


var $fabea5129ce188eb$exports = {};
$fabea5129ce188eb$exports = new URL("map.38395ae3.png", import.meta.url).toString();


var $b91aec60425dcaea$exports = {};
$b91aec60425dcaea$exports = new URL("pin point.a0e3075a.png", import.meta.url).toString();


var $80ae367ceea82be8$exports = {};
$80ae367ceea82be8$exports = new URL("camera.14bfdf74.png", import.meta.url).toString();


var $aaf0647636501650$exports = {};
$aaf0647636501650$exports = new URL("upload-image.8ad1872c.png", import.meta.url).toString();


var $fe788ea5ab1eb2cd$exports = {};
$fe788ea5ab1eb2cd$exports = new URL("video.959fa9be.png", import.meta.url).toString();


var $02cb795988e665a0$exports = {};
$02cb795988e665a0$exports = new URL("done.28c1c687.png", import.meta.url).toString();


var $15f727532d6614d9$exports = {};
$15f727532d6614d9$exports = new URL("link.7fd56236.png", import.meta.url).toString();


var $deff84bb0e42cce7$exports = {};
$deff84bb0e42cce7$exports = new URL("location-outline.6dbfadac.png", import.meta.url).toString();


var $e1ff1ca0949066aa$exports = {};
$e1ff1ca0949066aa$exports = new URL("justanimagehere.2fa22ed1.png", import.meta.url).toString();


var $d09f3ea8bad95388$exports = {};
/**
 * Copyright (c) 2011, Sun Ning.
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use, copy,
 * modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
 * BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
 * ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */ var $d09f3ea8bad95388$var$BASE32_CODES = "0123456789bcdefghjkmnpqrstuvwxyz";
var $d09f3ea8bad95388$var$BASE32_CODES_DICT = {};
for(var $d09f3ea8bad95388$var$i = 0; $d09f3ea8bad95388$var$i < $d09f3ea8bad95388$var$BASE32_CODES.length; $d09f3ea8bad95388$var$i++)$d09f3ea8bad95388$var$BASE32_CODES_DICT[$d09f3ea8bad95388$var$BASE32_CODES.charAt($d09f3ea8bad95388$var$i)] = $d09f3ea8bad95388$var$i;
var $d09f3ea8bad95388$var$ENCODE_AUTO = 'auto';
var $d09f3ea8bad95388$var$MIN_LAT = -90;
var $d09f3ea8bad95388$var$MAX_LAT = 90;
var $d09f3ea8bad95388$var$MIN_LON = -180;
var $d09f3ea8bad95388$var$MAX_LON = 180;
/**
 * Significant Figure Hash Length
 *
 * This is a quick and dirty lookup to figure out how long our hash
 * should be in order to guarantee a certain amount of trailing
 * significant figures. This was calculated by determining the error:
 * 45/2^(n-1) where n is the number of bits for a latitude or
 * longitude. Key is # of desired sig figs, value is minimum length of
 * the geohash.
 * @type Array
 */ //     Desired sig figs:  0  1  2  3  4   5   6   7   8   9  10
var $d09f3ea8bad95388$var$SIGFIG_HASH_LENGTH = [
    0,
    5,
    7,
    8,
    11,
    12,
    13,
    15,
    16,
    17,
    18
];
/**
 * Encode
 *
 * Create a Geohash out of a latitude and longitude that is
 * `numberOfChars` long.
 *
 * @param {Number|String} latitude
 * @param {Number|String} longitude
 * @param {Number} numberOfChars
 * @returns {String}
 */ var $d09f3ea8bad95388$var$encode = function(latitude, longitude, numberOfChars) {
    if (numberOfChars === $d09f3ea8bad95388$var$ENCODE_AUTO) {
        if (typeof latitude === 'number' || typeof longitude === 'number') throw new Error('string notation required for auto precision.');
        var decSigFigsLat = latitude.split('.')[1].length;
        var decSigFigsLong = longitude.split('.')[1].length;
        var numberOfSigFigs = Math.max(decSigFigsLat, decSigFigsLong);
        numberOfChars = $d09f3ea8bad95388$var$SIGFIG_HASH_LENGTH[numberOfSigFigs];
    } else if (numberOfChars === undefined) numberOfChars = 9;
    var chars = [], bits = 0, bitsTotal = 0, hash_value = 0, maxLat = $d09f3ea8bad95388$var$MAX_LAT, minLat = $d09f3ea8bad95388$var$MIN_LAT, maxLon = $d09f3ea8bad95388$var$MAX_LON, minLon = $d09f3ea8bad95388$var$MIN_LON, mid;
    while(chars.length < numberOfChars){
        if (bitsTotal % 2 === 0) {
            mid = (maxLon + minLon) / 2;
            if (longitude > mid) {
                hash_value = (hash_value << 1) + 1;
                minLon = mid;
            } else {
                hash_value = (hash_value << 1) + 0;
                maxLon = mid;
            }
        } else {
            mid = (maxLat + minLat) / 2;
            if (latitude > mid) {
                hash_value = (hash_value << 1) + 1;
                minLat = mid;
            } else {
                hash_value = (hash_value << 1) + 0;
                maxLat = mid;
            }
        }
        bits++;
        bitsTotal++;
        if (bits === 5) {
            var code = $d09f3ea8bad95388$var$BASE32_CODES[hash_value];
            chars.push(code);
            bits = 0;
            hash_value = 0;
        }
    }
    return chars.join('');
};
/**
 * Encode Integer
 *
 * Create a Geohash out of a latitude and longitude that is of 'bitDepth'.
 *
 * @param {Number} latitude
 * @param {Number} longitude
 * @param {Number} bitDepth
 * @returns {Number}
 */ var $d09f3ea8bad95388$var$encode_int = function(latitude, longitude, bitDepth) {
    bitDepth = bitDepth || 52;
    var bitsTotal = 0, maxLat = $d09f3ea8bad95388$var$MAX_LAT, minLat = $d09f3ea8bad95388$var$MIN_LAT, maxLon = $d09f3ea8bad95388$var$MAX_LON, minLon = $d09f3ea8bad95388$var$MIN_LON, mid, combinedBits = 0;
    while(bitsTotal < bitDepth){
        combinedBits *= 2;
        if (bitsTotal % 2 === 0) {
            mid = (maxLon + minLon) / 2;
            if (longitude > mid) {
                combinedBits += 1;
                minLon = mid;
            } else maxLon = mid;
        } else {
            mid = (maxLat + minLat) / 2;
            if (latitude > mid) {
                combinedBits += 1;
                minLat = mid;
            } else maxLat = mid;
        }
        bitsTotal++;
    }
    return combinedBits;
};
/**
 * Decode Bounding Box
 *
 * Decode hashString into a bound box matches it. Data returned in a four-element array: [minlat, minlon, maxlat, maxlon]
 * @param {String} hash_string
 * @returns {Array}
 */ var $d09f3ea8bad95388$var$decode_bbox = function(hash_string) {
    var isLon = true, maxLat = $d09f3ea8bad95388$var$MAX_LAT, minLat = $d09f3ea8bad95388$var$MIN_LAT, maxLon = $d09f3ea8bad95388$var$MAX_LON, minLon = $d09f3ea8bad95388$var$MIN_LON, mid;
    var hashValue = 0;
    for(var i = 0, l = hash_string.length; i < l; i++){
        var code = hash_string[i].toLowerCase();
        hashValue = $d09f3ea8bad95388$var$BASE32_CODES_DICT[code];
        for(var bits = 4; bits >= 0; bits--){
            var bit = hashValue >> bits & 1;
            if (isLon) {
                mid = (maxLon + minLon) / 2;
                if (bit === 1) minLon = mid;
                else maxLon = mid;
            } else {
                mid = (maxLat + minLat) / 2;
                if (bit === 1) minLat = mid;
                else maxLat = mid;
            }
            isLon = !isLon;
        }
    }
    return [
        minLat,
        minLon,
        maxLat,
        maxLon
    ];
};
/**
 * Decode Bounding Box Integer
 *
 * Decode hash number into a bound box matches it. Data returned in a four-element array: [minlat, minlon, maxlat, maxlon]
 * @param {Number} hashInt
 * @param {Number} bitDepth
 * @returns {Array}
 */ var $d09f3ea8bad95388$var$decode_bbox_int = function(hashInt, bitDepth) {
    bitDepth = bitDepth || 52;
    var maxLat = $d09f3ea8bad95388$var$MAX_LAT, minLat = $d09f3ea8bad95388$var$MIN_LAT, maxLon = $d09f3ea8bad95388$var$MAX_LON, minLon = $d09f3ea8bad95388$var$MIN_LON;
    var latBit = 0, lonBit = 0;
    var step = bitDepth / 2;
    for(var i = 0; i < step; i++){
        lonBit = $d09f3ea8bad95388$var$get_bit(hashInt, (step - i) * 2 - 1);
        latBit = $d09f3ea8bad95388$var$get_bit(hashInt, (step - i) * 2 - 2);
        if (latBit === 0) maxLat = (maxLat + minLat) / 2;
        else minLat = (maxLat + minLat) / 2;
        if (lonBit === 0) maxLon = (maxLon + minLon) / 2;
        else minLon = (maxLon + minLon) / 2;
    }
    return [
        minLat,
        minLon,
        maxLat,
        maxLon
    ];
};
function $d09f3ea8bad95388$var$get_bit(bits, position) {
    return bits / Math.pow(2, position) & 0x01;
}
/**
 * Decode
 *
 * Decode a hash string into pair of latitude and longitude. A javascript object is returned with keys `latitude`,
 * `longitude` and `error`.
 * @param {String} hashString
 * @returns {Object}
 */ var $d09f3ea8bad95388$var$decode = function(hashString) {
    var bbox = $d09f3ea8bad95388$var$decode_bbox(hashString);
    var lat = (bbox[0] + bbox[2]) / 2;
    var lon = (bbox[1] + bbox[3]) / 2;
    var latErr = bbox[2] - lat;
    var lonErr = bbox[3] - lon;
    return {
        latitude: lat,
        longitude: lon,
        error: {
            latitude: latErr,
            longitude: lonErr
        }
    };
};
/**
 * Decode Integer
 *
 * Decode a hash number into pair of latitude and longitude. A javascript object is returned with keys `latitude`,
 * `longitude` and `error`.
 * @param {Number} hash_int
 * @param {Number} bitDepth
 * @returns {Object}
 */ var $d09f3ea8bad95388$var$decode_int = function(hash_int, bitDepth) {
    var bbox = $d09f3ea8bad95388$var$decode_bbox_int(hash_int, bitDepth);
    var lat = (bbox[0] + bbox[2]) / 2;
    var lon = (bbox[1] + bbox[3]) / 2;
    var latErr = bbox[2] - lat;
    var lonErr = bbox[3] - lon;
    return {
        latitude: lat,
        longitude: lon,
        error: {
            latitude: latErr,
            longitude: lonErr
        }
    };
};
/**
 * Neighbor
 *
 * Find neighbor of a geohash string in certain direction. Direction is a two-element array, i.e. [1,0] means north, [-1,-1] means southwest.
 * direction [lat, lon], i.e.
 * [1,0] - north
 * [1,1] - northeast
 * ...
 * @param {String} hashString
 * @param {Array} Direction as a 2D normalized vector.
 * @returns {String}
 */ var $d09f3ea8bad95388$var$neighbor = function(hashString, direction) {
    var lonLat = $d09f3ea8bad95388$var$decode(hashString);
    var neighborLat = lonLat.latitude + direction[0] * lonLat.error.latitude * 2;
    var neighborLon = lonLat.longitude + direction[1] * lonLat.error.longitude * 2;
    neighborLon = $d09f3ea8bad95388$var$ensure_valid_lon(neighborLon);
    neighborLat = $d09f3ea8bad95388$var$ensure_valid_lat(neighborLat);
    return $d09f3ea8bad95388$var$encode(neighborLat, neighborLon, hashString.length);
};
/**
 * Neighbor Integer
 *
 * Find neighbor of a geohash integer in certain direction. Direction is a two-element array, i.e. [1,0] means north, [-1,-1] means southwest.
 * direction [lat, lon], i.e.
 * [1,0] - north
 * [1,1] - northeast
 * ...
 * @param {String} hash_string
 * @returns {Array}
*/ var $d09f3ea8bad95388$var$neighbor_int = function(hash_int, direction, bitDepth) {
    bitDepth = bitDepth || 52;
    var lonlat = $d09f3ea8bad95388$var$decode_int(hash_int, bitDepth);
    var neighbor_lat = lonlat.latitude + direction[0] * lonlat.error.latitude * 2;
    var neighbor_lon = lonlat.longitude + direction[1] * lonlat.error.longitude * 2;
    neighbor_lon = $d09f3ea8bad95388$var$ensure_valid_lon(neighbor_lon);
    neighbor_lat = $d09f3ea8bad95388$var$ensure_valid_lat(neighbor_lat);
    return $d09f3ea8bad95388$var$encode_int(neighbor_lat, neighbor_lon, bitDepth);
};
/**
 * Neighbors
 *
 * Returns all neighbors' hashstrings clockwise from north around to northwest
 * 7 0 1
 * 6 x 2
 * 5 4 3
 * @param {String} hash_string
 * @returns {encoded neighborHashList|Array}
 */ var $d09f3ea8bad95388$var$neighbors = function(hash_string) {
    var hashstringLength = hash_string.length;
    var lonlat = $d09f3ea8bad95388$var$decode(hash_string);
    var lat = lonlat.latitude;
    var lon = lonlat.longitude;
    var latErr = lonlat.error.latitude * 2;
    var lonErr = lonlat.error.longitude * 2;
    var neighbor_lat, neighbor_lon;
    var neighborHashList = [
        encodeNeighbor(1, 0),
        encodeNeighbor(1, 1),
        encodeNeighbor(0, 1),
        encodeNeighbor(-1, 1),
        encodeNeighbor(-1, 0),
        encodeNeighbor(-1, -1),
        encodeNeighbor(0, -1),
        encodeNeighbor(1, -1)
    ];
    function encodeNeighbor(neighborLatDir, neighborLonDir) {
        neighbor_lat = lat + neighborLatDir * latErr;
        neighbor_lon = lon + neighborLonDir * lonErr;
        neighbor_lon = $d09f3ea8bad95388$var$ensure_valid_lon(neighbor_lon);
        neighbor_lat = $d09f3ea8bad95388$var$ensure_valid_lat(neighbor_lat);
        return $d09f3ea8bad95388$var$encode(neighbor_lat, neighbor_lon, hashstringLength);
    }
    return neighborHashList;
};
/**
 * Neighbors Integer
 *
 * Returns all neighbors' hash integers clockwise from north around to northwest
 * 7 0 1
 * 6 x 2
 * 5 4 3
 * @param {Number} hash_int
 * @param {Number} bitDepth
 * @returns {encode_int'd neighborHashIntList|Array}
 */ var $d09f3ea8bad95388$var$neighbors_int = function(hash_int, bitDepth) {
    bitDepth = bitDepth || 52;
    var lonlat = $d09f3ea8bad95388$var$decode_int(hash_int, bitDepth);
    var lat = lonlat.latitude;
    var lon = lonlat.longitude;
    var latErr = lonlat.error.latitude * 2;
    var lonErr = lonlat.error.longitude * 2;
    var neighbor_lat, neighbor_lon;
    var neighborHashIntList = [
        encodeNeighbor_int(1, 0),
        encodeNeighbor_int(1, 1),
        encodeNeighbor_int(0, 1),
        encodeNeighbor_int(-1, 1),
        encodeNeighbor_int(-1, 0),
        encodeNeighbor_int(-1, -1),
        encodeNeighbor_int(0, -1),
        encodeNeighbor_int(1, -1)
    ];
    function encodeNeighbor_int(neighborLatDir, neighborLonDir) {
        neighbor_lat = lat + neighborLatDir * latErr;
        neighbor_lon = lon + neighborLonDir * lonErr;
        neighbor_lon = $d09f3ea8bad95388$var$ensure_valid_lon(neighbor_lon);
        neighbor_lat = $d09f3ea8bad95388$var$ensure_valid_lat(neighbor_lat);
        return $d09f3ea8bad95388$var$encode_int(neighbor_lat, neighbor_lon, bitDepth);
    }
    return neighborHashIntList;
};
/**
 * Bounding Boxes
 *
 * Return all the hashString between minLat, minLon, maxLat, maxLon in numberOfChars
 * @param {Number} minLat
 * @param {Number} minLon
 * @param {Number} maxLat
 * @param {Number} maxLon
 * @param {Number} numberOfChars
 * @returns {bboxes.hashList|Array}
 */ var $d09f3ea8bad95388$var$bboxes = function(minLat, minLon, maxLat, maxLon, numberOfChars) {
    numberOfChars = numberOfChars || 9;
    var hashSouthWest = $d09f3ea8bad95388$var$encode(minLat, minLon, numberOfChars);
    var hashNorthEast = $d09f3ea8bad95388$var$encode(maxLat, maxLon, numberOfChars);
    var latLon = $d09f3ea8bad95388$var$decode(hashSouthWest);
    var perLat = latLon.error.latitude * 2;
    var perLon = latLon.error.longitude * 2;
    var boxSouthWest = $d09f3ea8bad95388$var$decode_bbox(hashSouthWest);
    var boxNorthEast = $d09f3ea8bad95388$var$decode_bbox(hashNorthEast);
    var latStep = Math.round((boxNorthEast[0] - boxSouthWest[0]) / perLat);
    var lonStep = Math.round((boxNorthEast[1] - boxSouthWest[1]) / perLon);
    var hashList = [];
    for(var lat = 0; lat <= latStep; lat++)for(var lon = 0; lon <= lonStep; lon++)hashList.push($d09f3ea8bad95388$var$neighbor(hashSouthWest, [
        lat,
        lon
    ]));
    return hashList;
};
/**
 * Bounding Boxes Integer
 *
 * Return all the hash integers between minLat, minLon, maxLat, maxLon in bitDepth
 * @param {Number} minLat
 * @param {Number} minLon
 * @param {Number} maxLat
 * @param {Number} maxLon
 * @param {Number} bitDepth
 * @returns {bboxes_int.hashList|Array}
 */ var $d09f3ea8bad95388$var$bboxes_int = function(minLat, minLon, maxLat, maxLon, bitDepth) {
    bitDepth = bitDepth || 52;
    var hashSouthWest = $d09f3ea8bad95388$var$encode_int(minLat, minLon, bitDepth);
    var hashNorthEast = $d09f3ea8bad95388$var$encode_int(maxLat, maxLon, bitDepth);
    var latlon = $d09f3ea8bad95388$var$decode_int(hashSouthWest, bitDepth);
    var perLat = latlon.error.latitude * 2;
    var perLon = latlon.error.longitude * 2;
    var boxSouthWest = $d09f3ea8bad95388$var$decode_bbox_int(hashSouthWest, bitDepth);
    var boxNorthEast = $d09f3ea8bad95388$var$decode_bbox_int(hashNorthEast, bitDepth);
    var latStep = Math.round((boxNorthEast[0] - boxSouthWest[0]) / perLat);
    var lonStep = Math.round((boxNorthEast[1] - boxSouthWest[1]) / perLon);
    var hashList = [];
    for(var lat = 0; lat <= latStep; lat++)for(var lon = 0; lon <= lonStep; lon++)hashList.push($d09f3ea8bad95388$var$neighbor_int(hashSouthWest, [
        lat,
        lon
    ], bitDepth));
    return hashList;
};
function $d09f3ea8bad95388$var$ensure_valid_lon(lon) {
    if (lon > $d09f3ea8bad95388$var$MAX_LON) return $d09f3ea8bad95388$var$MIN_LON + lon % $d09f3ea8bad95388$var$MAX_LON;
    if (lon < $d09f3ea8bad95388$var$MIN_LON) return $d09f3ea8bad95388$var$MAX_LON + lon % $d09f3ea8bad95388$var$MAX_LON;
    return lon;
}
function $d09f3ea8bad95388$var$ensure_valid_lat(lat) {
    if (lat > $d09f3ea8bad95388$var$MAX_LAT) return $d09f3ea8bad95388$var$MAX_LAT;
    if (lat < $d09f3ea8bad95388$var$MIN_LAT) return $d09f3ea8bad95388$var$MIN_LAT;
    return lat;
}
var $d09f3ea8bad95388$var$geohash = {
    'ENCODE_AUTO': $d09f3ea8bad95388$var$ENCODE_AUTO,
    'encode': $d09f3ea8bad95388$var$encode,
    'encode_uint64': $d09f3ea8bad95388$var$encode_int,
    'encode_int': $d09f3ea8bad95388$var$encode_int,
    'decode': $d09f3ea8bad95388$var$decode,
    'decode_int': $d09f3ea8bad95388$var$decode_int,
    'decode_uint64': $d09f3ea8bad95388$var$decode_int,
    'decode_bbox': $d09f3ea8bad95388$var$decode_bbox,
    'decode_bbox_uint64': $d09f3ea8bad95388$var$decode_bbox_int,
    'decode_bbox_int': $d09f3ea8bad95388$var$decode_bbox_int,
    'neighbor': $d09f3ea8bad95388$var$neighbor,
    'neighbor_int': $d09f3ea8bad95388$var$neighbor_int,
    'neighbors': $d09f3ea8bad95388$var$neighbors,
    'neighbors_int': $d09f3ea8bad95388$var$neighbors_int,
    'bboxes': $d09f3ea8bad95388$var$bboxes,
    'bboxes_int': $d09f3ea8bad95388$var$bboxes_int
};
$d09f3ea8bad95388$exports = $d09f3ea8bad95388$var$geohash;



var $gJCIb = parcelRequire("gJCIb");
function $adc7742c85f64ed2$var$s(t) {
    t.CapacitorUtils.Synapse = new Proxy({}, {
        get (e, n) {
            return new Proxy({}, {
                get (w, o) {
                    return (c, p, r)=>{
                        const i = t.Capacitor.Plugins[n];
                        if (i === void 0) {
                            r(new Error(`Capacitor plugin ${n} not found`));
                            return;
                        }
                        if (typeof i[o] != "function") {
                            r(new Error(`Method ${o} not found in Capacitor plugin ${n}`));
                            return;
                        }
                        (async ()=>{
                            try {
                                const a = await i[o](c);
                                p(a);
                            } catch (a) {
                                r(a);
                            }
                        })();
                    };
                }
            });
        }
    });
}
function $adc7742c85f64ed2$var$u(t) {
    t.CapacitorUtils.Synapse = new Proxy({}, {
        get (e, n) {
            return t.cordova.plugins[n];
        }
    });
}
function $adc7742c85f64ed2$export$8fe1108d741bcfe3(t = !1) {
    typeof window > "u" || (window.CapacitorUtils = window.CapacitorUtils || {}, window.Capacitor !== void 0 && !t ? $adc7742c85f64ed2$var$s(window) : window.cordova !== void 0 && $adc7742c85f64ed2$var$u(window));
}





const $d916e40878854b98$export$6f7a28a04aa73a7e = (0, $gJCIb.registerPlugin)('Geolocation', {
    web: ()=>(parcelRequire("4yDdM")).then((m)=>new m.GeolocationWeb())
});
(0, $adc7742c85f64ed2$export$8fe1108d741bcfe3)();


const $a082c89adac62edb$var$url = "https://maquinariasonline.com/negocio/MyBusiness/listado/12345";
const $a082c89adac62edb$var$img = "https://marketplace.mx/assets/images/listing-image.jpg";
const $a082c89adac62edb$var$title = "Amazing Product Listing!";
const $a082c89adac62edb$var$description = "Check out this amazing listing on our marketplace!";
function $a082c89adac62edb$var$openHistoryDB() {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open('userHistoryDB', 1);
        request.onupgradeneeded = (e)=>{
            const db = e.target.result;
            if (!db.objectStoreNames.contains('history')) db.createObjectStore('history', {
                keyPath: 'timestamp'
            });
        };
        request.onsuccess = ()=>resolve(request.result);
        request.onerror = ()=>reject(request.error);
    });
}
class $a082c89adac62edb$var$generalHelpers {
    #timers = {};
    constructor(){
    // setTimeout(async () => {
    //   const locationData = await this._locationPicker()
    //   console.log('location data', locationData);
    // }, 7000);
    }
    _makeLoading(id) {
        const target = document.getElementById(id);
        const el = typeof target === 'string' ? document.getElementById(target) : target;
        if (!el || el.querySelector('.loadingShimmerOverlay')) return;
        if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
        const overlay = document.createElement('div');
        overlay.className = 'loadingShimmerOverlay';
        el.appendChild(overlay);
    }
    _removeLoading(id) {
        const target = document.getElementById();
        const el = typeof target === 'string' ? document.getElementById(target) : target;
        if (!el) return;
        el.querySelector('.loadingShimmerOverlay')?.remove();
    }
    _startTimer(timerName) {
        this.#timers[timerName] = performance.now();
    }
    _stopTimer(timerName) {
        const startTime = this.#timers[timerName];
        if (!startTime) {
            alert(`Timer "${timerName}" was never started.`);
            return;
        }
        const elapsedSeconds = ((performance.now() - startTime) / 1000).toFixed(2);
        alert(`Timer "${timerName}": ${elapsedSeconds} seconds`);
        delete this.#timers[timerName];
    }
    _getDisplayLocationName(location) {
        if (!location) return '';
        const { name: name, address: address, locationUrl: locationUrl } = location;
        // Detect Plus Codes like "Q4C9+4J"
        const isPlusCode = (str)=>{
            if (!str) return false;
            return /^[A-Z0-9]{4,}\+[A-Z0-9]+$/i.test(str.trim());
        };
        // Detect useless short names
        const isBadName = (str)=>{
            if (!str) return true;
            if (str.length < 4) return true;
            if (isPlusCode(str)) return true;
            return false;
        };
        if (!isBadName(name)) return name;
        if (address && address.trim().length > 0) return address;
        return locationUrl || '';
    }
    _geoHash(lat, lng, precision = 7) {
        const hash = (0, (/*@__PURE__*/$parcel$interopDefault($d09f3ea8bad95388$exports))).encode(lat, lng, precision);
        return hash;
    }
    // START location
    async _locationPicker(initialLocation = null) {
        return new Promise((resolve, reject)=>{
            const overlay = document.getElementById('locationPickerOverlay');
            const mapEl = document.getElementById('locationMap');
            const input = document.getElementById('locationSearch');
            const saveBtn = document.getElementById('locationSaveBtn');
            const cancelBtn = document.getElementById('locationCancelBtn');
            const myLocationBtn = document.getElementById('myLocationBtn');
            input.value = '';
            input.focus();
            input.addEventListener('focus', function() {
                requestAnimationFrame(()=>this.select());
            });
            if (!overlay || !mapEl || !input || !saveBtn || !cancelBtn) {
                reject('Missing required DOM elements');
                return;
            }
            overlay.classList.remove('hidden');
            let selectedLocation = null;
            let map, marker, autocomplete, geocoder;
            let debounceTimer = null;
            const defaultLocation = initialLocation?.lat && initialLocation?.lng ? {
                lat: initialLocation.lat,
                lng: initialLocation.lng
            } : {
                lat: 23.6345,
                lng: -102.5528
            };
            map = new google.maps.Map(mapEl, {
                center: defaultLocation,
                zoom: initialLocation ? 15 : 5
            });
            marker = new google.maps.Marker({
                map: map,
                draggable: true,
                position: initialLocation?.lat && initialLocation?.lng ? initialLocation : null
            });
            geocoder = new google.maps.Geocoder();
            // =========================
            // 🧠 PREFILL (SAFE)
            // =========================
            if (initialLocation && initialLocation.lat && initialLocation.lng) {
                selectedLocation = {
                    lat: initialLocation.lat,
                    lng: initialLocation.lng,
                    name: initialLocation.name || '',
                    address: initialLocation.address || '',
                    city: initialLocation.city || '',
                    state: initialLocation.state || '',
                    country: initialLocation.country || '',
                    locationUrl: initialLocation.locationUrl || `https://www.google.com/maps?q=${initialLocation.lat},${initialLocation.lng}`
                };
                if (initialLocation.address || initialLocation.name) input.value = initialLocation.address || initialLocation.name;
            }
            // =========================
            // 🧠 HELPER
            // =========================
            const extractLocationData = (components = [])=>{
                const get = (type)=>{
                    const comp = components.find((c)=>c.types.includes(type));
                    return comp ? comp.long_name : '';
                };
                return {
                    city: get('locality') || get('administrative_area_level_2'),
                    state: get('administrative_area_level_1'),
                    country: get('country')
                };
            };
            const buildLocationUrl = (lat, lng)=>{
                return `https://www.google.com/maps?q=${lat},${lng}`;
            };
            // =========================
            // 🔁 REVERSE GEOCODING
            // =========================
            const updateFromLatLng = (lat, lng)=>{
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(()=>{
                    geocoder.geocode({
                        location: {
                            lat: lat,
                            lng: lng
                        }
                    }, (results, status)=>{
                        if (status !== 'OK' || !results || !results.length) {
                            selectedLocation = {
                                lat: lat,
                                lng: lng,
                                name: '',
                                address: '',
                                city: '',
                                state: '',
                                country: '',
                                locationUrl: buildLocationUrl(lat, lng)
                            };
                            return;
                        }
                        const result = results[0];
                        const locationParts = extractLocationData(result.address_components);
                        const name = result.address_components?.[0]?.long_name || '';
                        selectedLocation = {
                            lat: lat,
                            lng: lng,
                            name: name,
                            address: result.formatted_address || '',
                            ...locationParts,
                            locationUrl: buildLocationUrl(lat, lng)
                        };
                        input.value = result.formatted_address || name;
                    });
                }, 300);
            };
            // =========================
            // 🔍 AUTOCOMPLETE
            // =========================
            autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.addListener('place_changed', ()=>{
                const place = autocomplete.getPlace();
                if (!place.geometry) return;
                const loc = place.geometry.location;
                const lat = loc.lat();
                const lng = loc.lng();
                map.setCenter(loc);
                map.setZoom(15);
                marker.setPosition(loc);
                const locationParts = extractLocationData(place.address_components);
                selectedLocation = {
                    lat: lat,
                    lng: lng,
                    name: place.name || '',
                    address: place.formatted_address || '',
                    ...locationParts,
                    locationUrl: buildLocationUrl(lat, lng)
                };
            });
            // =========================
            // 📍 CLICK MAP / POI
            // =========================
            map.addListener('click', (e)=>{
                if (e.placeId) {
                    e.stop();
                    const service = new google.maps.places.PlacesService(map);
                    service.getDetails({
                        placeId: e.placeId,
                        fields: [
                            'name',
                            'formatted_address',
                            'geometry',
                            'address_components'
                        ]
                    }, (place, status)=>{
                        if (status !== 'OK' || !place) return;
                        const loc = place.geometry.location;
                        const lat = loc.lat();
                        const lng = loc.lng();
                        const locationParts = extractLocationData(place.address_components);
                        marker.setPosition(loc);
                        map.setCenter(loc);
                        map.setZoom(15);
                        selectedLocation = {
                            lat: lat,
                            lng: lng,
                            name: place.name || '',
                            address: place.formatted_address || '',
                            ...locationParts,
                            locationUrl: buildLocationUrl(lat, lng)
                        };
                        input.value = place.name || place.formatted_address;
                    });
                    return;
                }
                const lat = e.latLng.lat();
                const lng = e.latLng.lng();
                marker.setPosition(e.latLng);
                updateFromLatLng(lat, lng);
            });
            // =========================
            // 📦 DRAG MARKER
            // =========================
            marker.addListener('dragend', ()=>{
                const pos = marker.getPosition();
                updateFromLatLng(pos.lat(), pos.lng());
            });
            // =========================
            // 📍 MY LOCATION
            // =========================
            // const handleMyLocation = () => {
            //   if (!navigator.geolocation) {
            //     alert('Tu navegador no soporta geolocalización.');
            //     return;
            //   }
            //   navigator.geolocation.getCurrentPosition(
            //     (position) => {
            //       const lat = position.coords.latitude;
            //       const lng = position.coords.longitude;
            //       const latLng = new google.maps.LatLng(lat, lng);
            //       map.setCenter(latLng);
            //       map.setZoom(15);
            //       marker.setPosition(latLng);
            //       updateFromLatLng(lat, lng);
            //     },
            //     () => {
            //       alert('No se pudo obtener tu ubicación.');
            //     },
            //     {
            //       enableHighAccuracy: true,
            //       timeout: 10000,
            //     }
            //   );
            // };
            const handleMyLocation = async ()=>{
                input.value = 'Cargando...';
                // ✅ Native (Android / iOS)
                if (window.Capacitor?.isNativePlatform?.()) try {
                    const permission = await (0, $d916e40878854b98$export$6f7a28a04aa73a7e).requestPermissions();
                    if (permission.location === 'denied') {
                        alert("Permiso de ubicaci\xf3n denegado.");
                        return;
                    }
                    const position = await (0, $d916e40878854b98$export$6f7a28a04aa73a7e).getCurrentPosition({
                        enableHighAccuracy: true,
                        timeout: 10000
                    });
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    const latLng = new google.maps.LatLng(lat, lng);
                    map.setCenter(latLng);
                    map.setZoom(15);
                    marker.setPosition(latLng);
                    updateFromLatLng(lat, lng);
                } catch (err) {
                    console.error("Geolocation error (native):", err);
                    alert("No se pudo obtener tu ubicaci\xf3n.");
                }
                else {
                    // ✅ Web (your ORIGINAL logic, unchanged)
                    if (!navigator.geolocation) {
                        alert("Tu navegador no soporta geolocalizaci\xf3n.");
                        return;
                    }
                    navigator.geolocation.getCurrentPosition((position)=>{
                        const lat = position.coords.latitude;
                        const lng = position.coords.longitude;
                        const latLng = new google.maps.LatLng(lat, lng);
                        map.setCenter(latLng);
                        map.setZoom(15);
                        marker.setPosition(latLng);
                        updateFromLatLng(lat, lng);
                    }, ()=>{
                        alert("No se pudo obtener tu ubicaci\xf3n.");
                    }, {
                        enableHighAccuracy: true,
                        timeout: 10000
                    });
                }
            };
            // =========================
            // ✅ SAVE
            // =========================
            const handleSave = ()=>{
                if (!selectedLocation) {
                    alert("Selecciona una ubicaci\xf3n primero");
                    return;
                }
                cleanup();
                overlay.classList.add('hidden');
                resolve(selectedLocation);
            };
            // =========================
            // ❌ CANCEL
            // =========================
            const handleCancel = ()=>{
                cleanup();
                overlay.classList.add('hidden');
                reject('cancelled');
            };
            function cleanup() {
                saveBtn.removeEventListener('click', handleSave);
                cancelBtn.removeEventListener('click', handleCancel);
                if (myLocationBtn) myLocationBtn.removeEventListener('click', handleMyLocation);
            }
            saveBtn.addEventListener('click', handleSave);
            cancelBtn.addEventListener('click', handleCancel);
            if (myLocationBtn) myLocationBtn.addEventListener('click', handleMyLocation);
        });
    }
    async _getCurrentLocation() {
        return new Promise(async (resolve, reject)=>{
            const buildLocationUrl = (lat, lng)=>{
                return `https://www.google.com/maps?q=${lat},${lng}`;
            };
            const extractLocationData = (components = [])=>{
                const get = (type)=>{
                    const comp = components.find((c)=>c.types.includes(type));
                    return comp ? comp.long_name : '';
                };
                return {
                    city: get('locality') || get('administrative_area_level_2'),
                    state: get('administrative_area_level_1'),
                    country: get('country')
                };
            };
            try {
                let lat;
                let lng;
                // Native
                if (window.Capacitor?.isNativePlatform?.()) {
                    const permission = await (0, $d916e40878854b98$export$6f7a28a04aa73a7e).requestPermissions();
                    if (permission.location === 'denied') {
                        reject('Location permission denied');
                        return;
                    }
                    const position = await (0, $d916e40878854b98$export$6f7a28a04aa73a7e).getCurrentPosition({
                        enableHighAccuracy: true,
                        timeout: 10000
                    });
                    lat = position.coords.latitude;
                    lng = position.coords.longitude;
                } else {
                    // Web
                    const position = await new Promise((res, rej)=>{
                        navigator.geolocation.getCurrentPosition(res, rej, {
                            enableHighAccuracy: true,
                            timeout: 10000
                        });
                    });
                    lat = position.coords.latitude;
                    lng = position.coords.longitude;
                }
                // Reverse geocode
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    location: {
                        lat: lat,
                        lng: lng
                    }
                }, (results, status)=>{
                    if (status !== 'OK' || !results?.length) {
                        resolve({
                            lat: lat,
                            lng: lng,
                            name: '',
                            address: '',
                            city: '',
                            state: '',
                            country: '',
                            locationUrl: buildLocationUrl(lat, lng)
                        });
                        return;
                    }
                    const result = results[0];
                    const locationParts = extractLocationData(result.address_components);
                    resolve({
                        lat: lat,
                        lng: lng,
                        name: result.address_components?.[0]?.long_name || '',
                        address: result.formatted_address || '',
                        ...locationParts,
                        locationUrl: buildLocationUrl(lat, lng)
                    });
                });
            } catch (err) {
                console.error(err);
                reject(err);
            }
        });
    }
    async _displayListingLocation(listingData, conId) {
        const con = document.getElementById(conId);
        if (!con) {
            console.warn("Container not found");
            return;
        }
        const { lat: lat, lng: lng, title: title, imageUrl: imageUrl, price: price, city: city, state: state, locationUrl: locationUrl } = listingData;
        const map = new google.maps.Map(con, {
            center: {
                lat: lat,
                lng: lng
            },
            zoom: 10,
            disableDefaultUI: true,
            gestureHandling: "none",
            draggable: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            keyboardShortcuts: false
        });
        // =========================
        // 📍 MARKER
        // =========================
        const marker = new google.maps.Marker({
            position: {
                lat: lat,
                lng: lng
            },
            map: map,
            animation: google.maps.Animation.DROP
        });
        // =========================
        // 🧩 CUSTOM INFO CARD
        // =========================
        const infoWindow = new google.maps.InfoWindow({
            content: `
        <div class="listingMapCard">

          <img
            src="${imageUrl || ''}"
            class="listingMapCardImg"
          >

          <div class="listingMapCardContent">

            <div class="listingMapCardTitle">
              ${title || ''}
            </div>

            <div class="listingMapCardDescription">
              ${listingData.description || ''}
            </div>

          </div>

        </div>
      `
        });
        // Open immediately
        infoWindow.open({
            anchor: marker,
            map: map
        });
        // =========================
        // 👉 OPEN MAPS
        // =========================
        marker.addListener('click', ()=>{
            if (locationUrl) this._openOutboundLink(locationUrl);
        });
        con.style.cursor = 'pointer';
        con.addEventListener('click', ()=>{
            this._openOutboundLink(locationUrl);
        });
    // // Optional:
    // // click card anywhere on map
    // map.addListener('click', () => {
    //   infoWindow.open({
    //     anchor: marker,
    //     map,
    //   });
    // });
    }
    // END location
    _callSharing() {
        this._shareImageWithText($a082c89adac62edb$var$title, $a082c89adac62edb$var$description, (0, (/*@__PURE__*/$parcel$interopDefault($e1ff1ca0949066aa$exports))));
    }
    _getClientPlatformInfo() {
        const ua = navigator.userAgent.toLowerCase();
        const platformUA = navigator.platform?.toLowerCase() || '';
        // -------- PLATFORM (web | ios | android)
        let platform = 'web';
        if (/iphone|ipad|ipod/.test(ua)) platform = 'ios';
        else if (/android/.test(ua)) platform = 'android';
        // -------- OS (macos | windows | ios | android)
        let os = 'unknown';
        if (/mac/.test(platformUA)) os = 'macos';
        else if (/win/.test(platformUA)) os = 'windows';
        else if (/iphone|ipad|ipod/.test(ua)) os = 'ios';
        else if (/android/.test(ua)) os = 'android';
        // -------- BROWSER (chrome | safari | edge | firefox)
        let browser = 'unknown';
        if (/firefox/.test(ua)) browser = 'firefox';
        else if (/edg/.test(ua)) browser = 'edge';
        else if (/chrome|crios/.test(ua) && !/edg/.test(ua)) browser = 'chrome';
        else if (/safari/.test(ua) && !/chrome|crios/.test(ua)) browser = 'safari';
        // -------- PWA INSTALL STATE
        const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches || window.navigator.standalone === true; // iOS Safari
        return {
            platform: platform,
            os: os,
            browser: browser,
            isPWA: isPWA // true | false
        };
    }
    _getPushNotificationStatus() {
        /* ----------------------------
       1️⃣ PWA installation check
       ---------------------------- */ const isInstalled = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true; // iOS
        if (!isInstalled) return false;
        // i dont want notifications on PWAs for now, so i will return false
        if (isInstalled) return false;
        /* ----------------------------
       2️⃣ Notification support
       ---------------------------- */ if (!("Notification" in window)) return false;
        /* ----------------------------
       3️⃣ Permission state
       ---------------------------- */ if (Notification.permission !== "granted") return "permission needed";
        /* ----------------------------
       4️⃣ All good
       ---------------------------- */ return true;
    }
    async _pushUserHistory(entry) {
        const db = await $a082c89adac62edb$var$openHistoryDB();
        const tx = db.transaction('history', 'readwrite');
        const store = tx.objectStore('history');
        store.add({
            href: entry.href,
            title: entry.title,
            image: entry.image,
            type: entry.type,
            timestamp: Date.now()
        });
        return tx.complete;
    }
    async _getUserHistory(limit = 50) {
        const db = await $a082c89adac62edb$var$openHistoryDB();
        const tx = db.transaction('history', 'readonly');
        const store = tx.objectStore('history');
        const items = [];
        return new Promise((resolve)=>{
            store.openCursor(null, 'prev').onsuccess = (e)=>{
                const cursor = e.target.result;
                if (cursor && items.length < limit) {
                    items.push(cursor.value);
                    cursor.continue();
                } else resolve(items);
            };
        });
    }
    async _deleteHistoryItem(timestamp) {
        const db = await $a082c89adac62edb$var$openHistoryDB();
        const tx = db.transaction('history', 'readwrite');
        tx.objectStore('history').delete(timestamp);
        return tx.complete;
    }
    async _clearUserHistory() {
        const db = await $a082c89adac62edb$var$openHistoryDB();
        const tx = db.transaction('history', 'readwrite');
        tx.objectStore('history').clear();
        return new Promise((resolve, reject)=>{
            tx.oncomplete = ()=>resolve(true);
            tx.onerror = ()=>reject(tx.error);
        });
    }
    _convertToPrice(price, coin) {
        // Convert to a number if it's a string
        const numericPrice = typeof price === "string" ? parseFloat(price) : price;
        // Check if the conversion resulted in a valid number
        if (isNaN(numericPrice)) throw new Error("Invalid price value. Please provide a valid number or string.");
        // Format the price with commas
        const formattedPrice = numericPrice.toLocaleString();
        // Return the formatted price with the coin appended
        return `${formattedPrice} ${coin}`;
    }
    _calculateFutureDate(serverTimestamp, days) {
        // Convert Firebase serverTimestamp to a Date object
        const timestamp = serverTimestamp.toDate();
        // Add days to the timestamp
        const calculatedDate = new Date(timestamp);
        calculatedDate.setDate(calculatedDate.getDate() + days); // Add days to the current date
        // Get the current date in Mexico timezone (or your desired timezone)
        const mexicoTimeZone = "America/Mexico_City"; // Set timezone to Mexico
        const currentDate = new Date();
        // Use Intl.DateTimeFormat to format the date in Mexico timezone
        const options = {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true
        };
        const currentDateString = new Intl.DateTimeFormat("es-MX", options).format(currentDate);
        // Check if we're past the calculated date
        const areWePast = currentDate > calculatedDate;
        // Calculate the time difference in days
        const timeDifferenceInMs = calculatedDate - currentDate;
        const timeNeeded = Math.ceil(timeDifferenceInMs / 86400000); // Convert milliseconds to days
        // If past, show how many days ago
        if (areWePast) timeNeeded *= -1; // If past, show negative number of days (e.g., 2 days ago)
        // Return the results
        return {
            calculatedDate: calculatedDate.toLocaleString("es-MX", options),
            areWePast: areWePast,
            timeNeeded: timeNeeded
        };
    }
    _convertServerTimestampToReadableTime(serverTimestamp, time = true) {
        const date = serverTimestamp.toDate();
        const getTimeFormat = (date)=>{
            if (!time) return ""; // 🔥 no time
            return date.toLocaleString("es-ES", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });
        };
        const getTodayOrYesterday = (date)=>{
            const now = new Date();
            const timeDiff = now - date;
            const msInDay = 86400000;
            if (timeDiff < msInDay && now.getDate() === date.getDate()) return time ? `Hoy, ${getTimeFormat(date)}` : "Hoy";
            if (timeDiff < msInDay && now.getDate() === date.getDate() + 1) return time ? `Ayer, ${getTimeFormat(date)}` : "Ayer";
            return null;
        };
        const getCurrentWeekFormat = (date)=>{
            const now = new Date();
            const timeDiff = now - date;
            const msInWeek = 604800000;
            if (timeDiff < msInWeek) return date.toLocaleString("es-ES", {
                weekday: "long",
                ...time && {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true
                }
            });
            return null;
        };
        const getCurrentYearFormat = (date)=>{
            return date.toLocaleString("es-ES", {
                month: "short",
                day: "numeric",
                ...time && {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true
                }
            });
        };
        const getPreviousYearFormat = (date)=>{
            return date.toLocaleString("es-ES", {
                month: "short",
                day: "numeric",
                year: "numeric",
                ...time && {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true
                }
            });
        };
        let result = getTodayOrYesterday(date);
        if (result) return result;
        result = getCurrentWeekFormat(date);
        if (result) return result;
        if (date.getFullYear() === new Date().getFullYear()) return getCurrentYearFormat(date);
        return getPreviousYearFormat(date);
    }
    async _createUrlForSharing2WORKSWITHSLASH(businessId, businessName, listingId, listingName) {
        console.log(businessName);
        let url = "";
        // if (businessName) {
        //   // if (businessName && businessName !== "null" && businessName !== null) {
        //   const bsName = businessName.split(" ").join("_");
        //   url += `negocio/${bsName}`;
        // }
        if (businessId) {
            if (url) url += "/"; // Add a separator if there's already a business name
            url += `negocio/${businessId}`;
            if (businessName) {
                const lsName = businessName.split(" ").join("");
                url += `?name=${encodeURIComponent(lsName)}`; // Encode listing name
            }
        }
        if (listingId) {
            if (url) url += "/"; // Add a separator if there's already a business name
            url += `listado/${listingId}`;
            if (listingName) {
                const lsName = listingName.split(" ").join("");
                url += `?name=${encodeURIComponent(lsName)}`; // Encode listing name
            }
        }
        const wholeUrl = "https://maquinariasonline.com/" + url;
        console.log(wholeUrl);
        return wholeUrl;
    }
    async _createUrlForSharing(businessId, sellerId, listingId) {
        console.warn("YEP CALLED THIS FUNCTION HERE", 'businessId', businessId, 'sellerId', sellerId, 'listingId', listingId);
        // Base URL
        // const baseUrl = "https://mercadomaidev.netlify.app"; // ✅ Change if you go live
        const baseUrl = "https://mercadomai.com"; // ✅ Change if you go live
        // Build query parameters
        const queryParams = [];
        if (sellerId && sellerId !== "null") {
            if (!businessId || businessId === "null") queryParams.push(`vendedor=${encodeURIComponent(sellerId)}`);
        }
        if (businessId && businessId !== "null") queryParams.push(`negocio=${encodeURIComponent(businessId)}`);
        if (listingId && listingId !== "null") queryParams.push(`listado=${encodeURIComponent(listingId)}`);
        const url = queryParams.length > 0 ? `${baseUrl}?${queryParams.join("&")}` : baseUrl;
        console.log("Generated sharing URL:", url);
        return url;
    }
    async _share(url, img, title, description) {
        console.warn("YEP CALLED THIS FUNCTION HERE");
        const text = `${title}\n${description}\n${url}`;
        if (navigator.share) try {
            await navigator.share({
                title: title,
                text: text,
                url: url
            });
            console.log("Shared successfully!");
        } catch (error) {
            console.error("Error sharing:", error);
        }
        else console.log("Web Share API not supported in this browser.");
    }
    async _shareImagesWithText(title, description, imgUrlsIn) {
        try {
            // Array to hold File objects
            const files = [];
            // Loop through each image URL and fetch the image
            for (const imgUrl of imgUrlsIn){
                const response = await fetch(imgUrl);
                const blob = await response.blob();
                const file = new File([
                    blob
                ], "shared-image.jpg", {
                    type: blob.type
                });
                files.push(file);
            }
            // Reorder the files array to move the last image to the start
            const reorderedFiles = files;
            //   const reorderedFiles = [files.pop(), ...files];
            // Check if the browser supports sharing multiple files
            if (navigator.canShare && navigator.canShare({
                files: reorderedFiles
            })) {
                await navigator.share({
                    files: reorderedFiles,
                    title: title,
                    text: description
                });
                console.log("Images and text shared successfully!");
                return {
                    success: true,
                    message: "Shared successfully"
                }; // Return success
            } else {
                console.error("Sharing multiple files is not supported on this browser.");
                return {
                    success: false,
                    message: "Sharing not supported"
                }; // Return error
            }
        } catch (error) {
            console.error("Error sharing images and text:", error);
            return {
                success: false,
                message: `Error: ${error.message}`
            }; // Return error
        }
    }
    async _shareImageWithText(title, description, listingUrl, imgUrl) {
        console.warn("YEP CALLED THIS FUNCTION HERE");
        try {
            // Fetch the image and convert it to a File object
            const response = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($e1ff1ca0949066aa$exports))));
            const blob = await response.blob();
            const file = new File([
                blob
            ], "shared-image.jpg", {
                type: blob.type
            });
            // Check if the browser supports sharing files
            if (navigator.canShare && navigator.canShare({
                files: [
                    file
                ]
            })) {
                await navigator.share({
                    files: [
                        file
                    ],
                    title: title,
                    text: title + " " + description + ":" + " " + listingUrl
                });
                console.log("Image and text shared successfully!");
            } else console.error("Sharing files is not supported on this browser.");
        } catch (error) {
            console.error("Error sharing image and text:", error);
        }
    }
    _getTimeStampJS() {
        const now = new Date();
        // Format components
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        // Combine into timestamp
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    _getUniqueIdfunction() {
        return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }
    _getSpanishGreetingForDay() {
        const now = new Date();
        const hour = now.getHours();
        if (hour >= 6 && hour < 12) return "Buenos d\xedas"; // Morning: 6 AM to 11:59 AM
        else if (hour >= 12 && hour < 20) return "Buenas tardes"; // Afternoon: 12 PM to 7:59 PM
        else return "Buenas noches"; // Evening/Night: 8 PM to 5:59 AM
    }
    _formatNumberShort(number) {
        if (!number) return 0;
        if (number < 1000) return number.toString(); // No formatting needed for numbers less than 1,000
        const suffixes = [
            "",
            "K",
            "M",
            "B",
            "T"
        ]; // Suffixes for thousand, million, billion, etc.
        let index = 0;
        while(number >= 1000 && index < suffixes.length - 1){
            number /= 1000;
            index++;
        }
        return `${number.toFixed(1).replace(/\.0$/, "")}${suffixes[index]}`;
    }
    _formatReadableString(input) {
        return input.split(/[-_]/) // Split by hyphen (-) or underscore (_)
        .map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
        .join(" "); // Join words with a space
    }
    _formatToPrice(value) {
        if (isNaN(value)) return "NaN";
        // Convert to a float to keep the decimal part
        const floatValue = parseFloat(value);
        // Use toLocaleString to format the number, and ensure to keep the decimal part
        return floatValue.toLocaleString();
    }
    _sortAndExtractNumbers(input) {
        // Extract numbers from the string using a regular expression
        const numbers = input.match(/\d+/g);
        // If no numbers are found, return an empty string
        if (!numbers) return "";
        // Sort the numbers, parse them as integers, and join them into a single string
        return numbers.map(Number).sort((a, b)=>a - b).join("");
    }
    _generateYearsArray(yearStart) {
        const currentYear = new Date().getFullYear(); // Get the current year
        const years = [];
        for(let year = currentYear + 1; year >= yearStart; year--)years.push(year);
        return years;
    }
    _createTokens(inputString, omittedWords) {
        console.log(inputString, omittedWords);
        if (!inputString || typeof inputString !== "string") return [];
        // Convert string to lowercase for uniformity
        const lowerCased = inputString.toLowerCase();
        console.log(lowerCased);
        // Split into words
        const words = lowerCased.split(/\s+/);
        // Filter out omitted words
        const filteredWords = words.filter((word)=>!omittedWords.includes(word));
        // Generate tokens (single words and bigrams for partial matches)
        const tokens = new Set(filteredWords);
        // Add bigrams (pairs of adjacent words)
        for(let i = 0; i < filteredWords.length - 1; i++)tokens.add(`${filteredWords[i]} ${filteredWords[i + 1]}`);
        // Convert Set back to Array
        return Array.from(tokens);
    }
    _generateTokens(inputArray = [], omittedWords = []) {
        if (!Array.isArray(inputArray) || inputArray.length === 0) return [];
        // --- Helper: normalize & remove accents ---
        const normalize = (str)=>str.toString().toLowerCase().normalize("NFD") // split accented chars into base + accent
            .replace(/[\u0300-\u036f]/g, "") // remove accents
            .replace(/[^\w\s]/g, "") // remove punctuation/symbols
            .replace(/\s+/g, " ") // collapse spaces
            .trim();
        const tokens = new Set();
        // ✅ Process each input string
        for (const rawValue of inputArray){
            const cleanValue = normalize(rawValue);
            if (!cleanValue) continue;
            // ✅ Always include the fully cleaned original string
            tokens.add(cleanValue);
            const parts = cleanValue.split(" ").filter(Boolean);
            // ✅ Single words & partial prefixes
            for (const part of parts)if (!omittedWords.includes(part)) {
                tokens.add(part);
                for(let i = 2; i <= part.length; i++)tokens.add(part.slice(0, i));
            }
            // ✅ Bigrams (word pairs in both directions)
            for(let i = 0; i < parts.length - 1; i++){
                tokens.add(`${parts[i]} ${parts[i + 1]}`);
                tokens.add(`${parts[i + 1]} ${parts[i]}`);
            }
            // ✅ Joined versions
            tokens.add(parts.join(""));
            tokens.add(parts.join("_"));
            tokens.add(parts.join("-"));
            // ✅ Numeric fragments if the value is all digits
            if (/^\d+$/.test(cleanValue)) {
                const num = cleanValue;
                tokens.add(num);
                // prefixes (996, 9967, ...)
                for(let i = 3; i <= num.length; i++)tokens.add(num.slice(0, i));
                // mid-segments (9967, 9673, ...)
                for(let i = 0; i < num.length - 3; i++)tokens.add(num.slice(i, i + 4));
            }
        }
        // ✅ Cross-field combos (mix words with number prefixes)
        const normalizedAll = inputArray.map((x)=>normalize(x));
        const words = normalizedAll.flatMap((v)=>v.split(" ")).filter((v)=>v && !/^\d+$/.test(v));
        const numbers = normalizedAll.filter((v)=>/^\d+$/.test(v));
        for (const word of words)for (const num of numbers)tokens.add(`${word}${num.slice(0, 4)}`);
        // ✅ Final clean output
        const cleanedTokens = Array.from(tokens).filter((t)=>t.length > 1 && !omittedWords.includes(t));
        return cleanedTokens;
    }
    _rankListings(foundListings, searchQuery, omittedWords) {
        // Tokenize the user's search query
        const searchTokens = this._createTokens(searchQuery, omittedWords);
        if (searchTokens.length === 0) {
            console.warn("No valid tokens generated from the search query.");
            return foundListings; // Return as is if no tokens are generated
        }
        // Compute relevance score for each listing
        const rankedListings = foundListings.map((listing)=>{
            let score = 0;
            if (listing.businessId) score += 150;
            // Count matches for single tokens, considering frequency of each token
            searchTokens.forEach((token)=>{
                const tokenCount = listing.listingTokens.filter((t)=>t === token).length;
                if (tokenCount > 0) score += tokenCount * 10; // Base score for each token match, multiplied by frequency
                if (listing.listingMachineType === token) score += tokenCount * 90; // Score for token match in machine type, multiplied by frequency
                if (listing.listingBrand === token) score += tokenCount * 100; // Score for token match in brand, multiplied by frequency
                if (listing.listingModel === token) score += tokenCount * 50; // Score for token match in model, multiplied by frequency
                if (listing.listingYear === token) score += tokenCount * 70; // Score for token match in year, multiplied by frequency
            });
            // Optional: Boost score for matching bigrams
            searchTokens.forEach((token)=>{
                if (token.includes(" ") && listing.listingTokens.includes(token)) {
                    const tokenCount = listing.listingTokens.filter((t)=>t === token).length;
                    score += tokenCount * 20; // Higher score for bigram matches, multiplied by frequency
                }
            });
            return {
                ...listing,
                score: score
            };
        });
        // Sort listings by score in descending order
        rankedListings.sort((a, b)=>b.score - a.score);
        return rankedListings;
    }
    _rankBusinesses(foundListings, searchQuery, omittedWords) {
        // Tokenize the user's search query
        const searchTokens = this._createTokens(searchQuery, omittedWords);
        if (searchTokens.length === 0) {
            console.warn("No valid tokens generated from the search query.");
            return foundListings; // Return as is if no tokens are generated
        }
        // Compute relevance score for each listing
        const rankedListings = foundListings.map((listing)=>{
            let score = 0;
            if (listing.businessId) score += 150;
            // Count matches for single tokens, considering frequency of each token
            searchTokens.forEach((token)=>{
                const tokenCount = listing.businessTokens.filter((t)=>t === token).length;
                if (tokenCount > 0) score += tokenCount * 10; // Base score for each token match, multiplied by frequency
            });
            // Optional: Boost score for matching bigrams
            searchTokens.forEach((token)=>{
                if (token.includes(" ") && listing.businessTokens.includes(token)) {
                    const tokenCount = listing.listingTokens.filter((t)=>t === token).length;
                    score += tokenCount * 20; // Higher score for bigram matches, multiplied by frequency
                }
            });
            return {
                ...listing,
                score: score
            };
        });
        // Sort listings by score in descending order
        rankedListings.sort((a, b)=>b.score - a.score);
        return rankedListings;
    }
    _shortenText(inputText, limitWords) {
        // Split the text into an array of words
        const words = inputText.split(/\s+/);
        // Check if the word count exceeds the limit
        if (words.length <= limitWords) return inputText; // Return the full text if within the limit
        // Join only the allowed number of words and add '...'
        const shortenedText = words.slice(0, limitWords).join(" ") + "...";
        return shortenedText;
    }
    _scrollToTopOfElement(id) {
        const el = document.getElementById(id);
        if (el) el.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        else console.warn(`Element with ID "${id}" not found.`);
    }
    // BUTTON ANIMATIONS
    _animateCTA(buttonId) {
        const button = document.getElementById(buttonId);
        if (!button) return;
        button.classList.add("cta-animate");
        // Optional: Remove animation and restart it after a delay
        setTimeout(()=>{
            button.classList.remove("cta-animate");
        }, 2000);
    }
    _startLoopAnimation(buttonId, isClass) {
        if (isClass) ;
        else {
            const button = document.getElementById(buttonId);
            if (!button) return;
            button.classList.add("cta-loop");
        }
    }
    _saveArrayLocalStorage(key, array) {
        localStorage.setItem(key, JSON.stringify(array));
    }
    _getArrayLocalStorage(key) {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : [];
    }
    _hexToRgba(hex, alpha = 1) {
        hex = hex.replace("#", "");
        if (hex.length === 3) hex = hex.split("").map((c)=>c + c).join("");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    _guardNumericInput(inputId) {
        const input = document.getElementById(inputId);
        if (!input) return;
        input.addEventListener("input", (e)=>{
            // Replace anything that's not a digit
            e.target.value = e.target.value.replace(/\D/g, "");
        });
    }
    _openOutboundLink(url) {
        if (!url) return;
        try {
            const parsedUrl = new URL(url);
            const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
            if (isPWA) window.location.href = parsedUrl.href;
            else window.open(parsedUrl.href, '_blank', 'noopener,noreferrer');
        } catch (err) {
            console.error('Invalid outbound URL:', url);
        }
    }
    _animateDragHint(barId, repeat = 2) {
        const el = document.getElementById(barId);
        if (!el) return;
        let iteration = 0;
        const animateOnce = ()=>{
            el.animate([
                {
                    transform: 'translateY(0px)'
                },
                {
                    transform: 'translateY(-8px)'
                },
                {
                    transform: 'translateY(4px)'
                },
                {
                    transform: 'translateY(0px)'
                }
            ], {
                duration: 900,
                easing: 'cubic-bezier(.22,.61,.36,1)',
                fill: 'forwards'
            });
            iteration++;
            if (iteration < repeat) setTimeout(animateOnce, 1100);
        };
        animateOnce();
    }
}
var $a082c89adac62edb$export$2e2bcd8739ae039 = new $a082c89adac62edb$var$generalHelpers();


class $ac56fd6b84e2bb3e$var$GenerateHTML {
    _display(data) {
        let edit = true;
        console.log(data);
        let locationName = "Ubicaci\xf3n no seleccionado";
        if (data?.place?.lat) locationName = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getDisplayLocationName(data.place);
        //   <div class="CreateListingNameUlrText">
        //   https://mqmexico.com/listings/john-deere-9600-2018
        // </div>
        // <div class="LogInCon6">
        //   <div data-helpwith="createListing" class="WalletCon8 openHelp">
        //     <div class="WalletText4">¿Como puedo crear un listado?</div>
        //   </div>
        // </div>
        // <div class="CreateListingImagesCon5">
        //   <img class="CreateListingImageUploadIcon" src="${iconBlackCamara}" alt="" height="24px" />
        //   <div class="CreateListingImagesCon5C">
        //     <div class="CreateListingImagesAddImagesText1">Fotos</div>
        //   </div>
        // </div>
        return `
<div id="SearchStartUpComponentAllCon" class="CreateListingCon1">
  <div class="CreateListingCon2A">


    <div class="CreateListingImagesCon1">
      <div id="CreateListingImagesCon2" class="CreateListingImagesCon2" style="display: none">
        <div class="CreateListingImagesCon2A">
          <div class="CreateListingImagesCon3" id="uploaded-images-container">
            <!-- Images will be dynamically added here -->
          </div>
        </div>
        <div class="CreateListingImagesCon4">
          <div id="CreateListingImageOrganizeMessage" class="CreateListingImagesOrganizeText CreateListingImagesAddImagesTextHidden">
            Arrastra las im\xe1genes para cambiar su orden. La primera imagen aparecer\xe1 como portada en las b\xfasquedas.
          </div>
        </div>
      </div>

      <div class="createListingImageUploadCon1">
        <div class="createListingImageUploadCon2">
          <div id="createListingImageUploadText1" class="createListingImageUploadText1">\xa1Tu listado merece excelentes im\xe1genes!</div>
          <div class="createListingImageUploadCon3">
            <img id="upload-trigger" src="${0, (/*@__PURE__*/$parcel$interopDefault($aaf0647636501650$exports))}" alt="" height="90px" />
          </div>
        </div>
      </div>
  

      <div class="CreateListingImagesCon5A">
        <div class="CreateListingImagesCon5BAA">
          <div class="CreateListingImagesCon5Text">Agrega tambi\xe9n (opcional)</div>
        </div>
        <div class="CreateListingImagesCon5BA">
          <div class="CreateListingImagesCon5B">

            <div class="CreateListingImagesCon5" id="upload-trigger-video">
              <img class="CreateListingImageUploadIcon" src="${0, (/*@__PURE__*/$parcel$interopDefault($fe788ea5ab1eb2cd$exports))}" alt="" height="24px" />
              <div class="CreateListingImagesCon5C">
                <div class="CreateListingImagesAddImagesText1">Video</div>
              </div>
              <div id="CreateListingImagesCon5C1" class="CreateListingImagesCon5C1" style="display: none">
                <img class="CreateListingImageUploadIconB" src="${0, (/*@__PURE__*/$parcel$interopDefault($02cb795988e665a0$exports))}" alt="" />
              </div>
            </div>

            
            <div class="CreateListingImagesCon5" id="upload-trigger-location" style="display: none">
                <img class="CreateListingImageUploadIcon" src="${0, (/*@__PURE__*/$parcel$interopDefault($deff84bb0e42cce7$exports))}" alt="" height="24px" />
              <div class="CreateListingImagesCon5C">
                <div class="CreateListingImagesAddImagesText1">Ubicaci\xf3n</div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <input type="file" id="image-upload-input" multiple accept="image/*" style="display: none" />
      <div class="NVCreateListingCon1">
        <div id="CreateListingErrorMessageImages" class="CreateListingErrorMessage"></div>
      </div>
    </div>

    <div class="CreateListingCon1B">


      <div id="CreateListingCon2InputForVidUrl" class="CreateListingCon2 CreateListingCon2Hidden">
        <div class="CreateListingNameCon1">
          <div id="nvV1CreateListignPreviewVidCon1" class="nvV1CreateListignPreviewVidCon1"></div>

          <div class="NVCreateListingText2">Enlace del video (solo YouTube)</div>
            <div class="CreateListingNameCon1B">
              <input class="CreateListingNameInput" type="text" placeholder="URL de un video" id="CreateListingVideoURL" />
              <div id="CreateListingVideoURLPasteFromClipBoardButton" class="CreateListingNameCon1B2">
                <img class="" src="${0, (/*@__PURE__*/$parcel$interopDefault($15f727532d6614d9$exports))}" alt="" height="7px" />
                Pegar
              </div>
            </div>
          <div class="CreateListingNameCon2">Primero sube tu video a YouTube, luego copia el enlace y p\xe9galo aqui. Aseg\xfarate que sea un enlace v\xe1lido, y que no hay restricci\xf3nes en el video.</div>


            <div class="CreateListingNameCon1C">
              <div class="CreateListingNameCon2B">Despu\xe9s que se genera la vista previa del video  puedes cerrar esta ventana con seguridad; esto no impedir\xe1 que el video se agregue a tu listado.</div>
              <div class="CreateListingNameCon1CA">
                <div id="CreateListingVideoURLPreviewVideoButton" class="CreateListingNameCon1C2">Generar vista previa</div>
                <div id="CreateListingVideoURLCloseVideoButton" class="CreateListingNameCon1C2A">Cerrar</div>
              </div>
            </div>


          <div id="CreateListingErrorMessageVideoURL" class="CreateListingErrorMessage"></div>
        </div>
      </div>



      <div class="CreateListingCon2 CreateListingCon2TopBorderRadius">
        <div class="CreateListingNameCon1">
          <div class="NVCreateListingText2">Titulo de tu listados</div>
          <textarea
            id="CreateListingName"
            class="CreateListingNameInputB"
            rows="1"
            placeholder="\xbfQue es lo que vendes?"
          ></textarea>
          <div class="NVCreateListingCon1">
            <div class="NVCreateListingText3">Dale a tu listado un titulo corto y descriptivo; esto ayuda a que nuestro
              buscador lo encuentre m\xe1s f\xe1cilmente.</div>
          </div>
          <div id="CreateListingErrorMessageName" class="CreateListingErrorMessage"></div>
        </div>
      </div>


      <div class="CreateListingCon2">
        <div class="CreateListingOptionsInputCon1B">
          <div class="CreateListingOptionsInputCon1C">
            <div class="CreateListingOptionsInputCon2">
              <div class="NVCreateListingText2">Precio</div>
              <div class="CreateListingOptionsInputCon3">
                <input class="CreateListingOptionsInputInput" type="text" placeholder="$0" id="CreateListingPrice" inputmode="numeric" />
              </div>
              <div id="CreateListingErrorMessagePrice" class="CreateListingErrorMessage"></div>
            </div>

            <!-- Currency -->
            <div id="CreateListingCoin" class="CreateListingOptionsPicCon1">
              <div class="NVCreateListingText4">Moneda</div>
              <div data-coin="none" id="CreateListingCoinPic" class="CreateListingOptionsPicCon2">
                <div data-picked="MXN" class="CreateListingOptionsPicCon3">MXN</div>
                <div data-picked="USD" class="CreateListingOptionsPicCon3">USD</div>
              </div>
              <div id="CreateListingErrorMessageCoin" class="CreateListingErrorMessage"></div>
            </div>
          </div>


          <!-- Mark Price As -->
          <div id="CreateListingOptionsPicPriceMArkedAs" class="CreateListingOptionsPicCon1" style="display: none">
            <div class="NVCreateListingText2">Marcar precio como</div>
            <div data-pricemarked="none" id="CreateListingPicMarkPrice" class="CreateListingOptionsPicCon2">
              <div data-picked="negociable" class="CreateListingOptionsPicCon3">Negociable</div>
              <div data-picked="preguntar" class="CreateListingOptionsPicCon3">Preguntar por precio</div>
            </div>
          </div>

        </div> <!-- END CreateListingOptionsInputCon1B -->



        <div id="CreateListingPriceMoreOptionsCon" class="CreateListingPriceMoreOptionsCon1">
          <div id="CreateListingPriceMoreOptionsButton" class="CreateListingPriceMoreOptionsCon2">
            <div class="CreateListingPriceMoreOptionsText1">Mas opciones de precio</div>
          </div>
        </div>



        <!-- Discount -->
        <div id="CreateListingDiscount" class="CreateListingOptionsInputCon1B" style="display: none">
            <div class="NVCreateListingText2">Ajustar descuento</div>
            <div class="CreateInputAdjustDiscountOnPriceCon2">

              <div class="CreateListingOptionsPicCon1">
                <div class="NVCreateListingText4">porcentaje %</div>
                <input class="CreateListingOptionsInputInput CreateListingOptionsInputInputMini" type="text" placeholder="0%" id="CreateListingDiscountPercent" inputmode="numeric" />
              </div>

              <div class="CreateListingOptionsPicCon1">
                <div class="NVCreateListingText4">descuento $</div>
                <input class="CreateListingOptionsInputInput CreateListingOptionsInputInputMini" type="text" placeholder="$0" id="CreateListingDiscountAmount" inputmode="numeric" />
              </div>

              <div class="CreateListingOptionsPicCon1">
                <div class="NVCreateListingText4">precio ahora $</div>
                <input class="CreateListingOptionsInputInput CreateListingOptionsInputInputMini" type="text" placeholder="$0" id="CreateListingDiscountFinalPrice" inputmode="numeric" />
              </div>

            </div> <!-- END CreateInputAdjustDiscountOnPriceCon2 -->

        </div> <!-- END CreateListingOptionsInputCon1B -->
      </div>



      <div class="CreateListingCon2">
        <div class="CreateListingCon2B">
          <div class="NVCreateListingText2">Ubicaci\xf3n de tu listados</div>
          <div class="NVCreateListingText2B">\xbfPor qu\xe9 agregar ubicaci\xf3n? <br> Permite que tu listado aparezca en \u{201C}Cerca de m\xed\u{201D} y llegue a m\xe1s clientes cercanos.</div>
        </div>
        
        <div id="nvCreateNewListingButtonOpenLocationSelector" class="nvBusinessEditorIn4Con5B margin10px0">
          <div class="nvBusinessEditorIn4Con6A">
            <div class="nvBusinessEditorIn4Con6">
              <img height="20" src="${0, (/*@__PURE__*/$parcel$interopDefault($660d57b441f0f617$exports))}"/>
              <div class="nvBusinessEditorIn4Text3">Google Maps</div>
            </div>
            <div class="nvBusinessEditorIn4Con7">
              <div class="nvBusinessEditorIn4Text4">Ubicaci\xf3n</div>
              <div class="nvBusinessEditorIn4Text5">Toca aqu\xed para abrir el mapa y poner la ubicaci\xf3n de tu negocio</div>
            </div>
          </div>
          <div class="nvBusinessEditorIn4Con7B">
            <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b91aec60425dcaea$exports))}"/>
            <div id="nvCreateNewListingButtonOpenLocationSelectorLocationTag" class="nvBusinessEditorIn4Text4B">${locationName}</div>
          </div>
        </div>

        <div class="NVCreateListingCon1">
          <div id="CreateListingErrorMessageLocation" class="CreateListingErrorMessage"></div>
        </div>

        <div class="CreateListingPriceMoreOptionsCon1">
          <div id="CreateListingLocationUseMyLocationButton" class="CreateListingPriceMoreOptionsCon4">
            <div class="CreateListingPriceMoreOptionsText2">Usar mi ubicaci\xf3n</div>
            <img height="14" src="${0, (/*@__PURE__*/$parcel$interopDefault($fabea5129ce188eb$exports))}"/>
          </div>
        </div>

      </div>


      <div id="CreateListingOptionalCategorySection" class="CreateListingCon2" style="display: none">
        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Categor\xeda</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectCategory" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectMachine" class="CreateListingErrorMessage"></div>
        </div>

        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Marca</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectBrand" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectBrand" class="CreateListingErrorMessage"></div>
        </div>

        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Modelo</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectModel" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectModel" class="CreateListingErrorMessage"></div>
        </div>


        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">A\xf1o</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectYear" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectYear" class="CreateListingErrorMessage"></div>
        </div>

        <div class="nvCreateNewListingCustomSelectCon1">
          <div class="nvCreateNewListingCustomSelectText1">Condici\xf3n</div>
          <div class="nvCreateNewListingCustomSelectCon2">
            <div id="CreateListingSelectCondition" class="custom-select"></div>
          </div>
          <div id="CreateListingErrorMessageSelectCondition" class="CreateListingErrorMessage"></div>
        </div>
      </div>


      <div id="CreateListingOptionalItemsAvailableSection" class="CreateListingCon2" style="display: none">
        <!-- Units Available -->
        <div class="CreateListingOptionsInputCon2">
          <div class="NVCreateListingText2">Unidades disponibles</div>
          <div class="CreateListingOptionsInputCon3">
            <input class="CreateListingOptionsInputInput" type="text" placeholder="no especificado" id="CreateListingItemsAvailable" inputmode="numeric" value="0" />
          </div>
          <div id="CreateListingErrorMessageItemsAvailable" class="CreateListingErrorMessage"></div>
        </div>
        <div class="CreateListingOptionsPicCon1">
          <div class="NVCreateListingText4">Marcar articulo como</div>
          <div
            data-itemmarked="none"
            id="CreateListingMarkItemAsCon"
            class="CreateListingOptionsPicCon2"
          >
            <div data-picked="sobre pedido" id="" class="CreateListingOptionsPicCon3">
              Sobre pedido
            </div>

            <div data-picked="disponible en stock" id="" class="CreateListingOptionsPicCon3">
              Disponible en stock
            </div>

            <div data-picked="agotado" id="" class="CreateListingOptionsPicCon3">
              Agotado
            </div>
          </div>
          </div>
      </div>


      <div id="CreateListingOptionalMoreDescriptionSection" class="CreateListingCon2" style="display: none">
        <div class="CreateListingDescriptionCon1">
          <div class="NVCreateListingText2">Descripci\xf3n de tu listado</div>
          <textarea class="CreateListingDescriptionTextarea" name="" id="CreateListingDescription"
            placeholder="Escribe todo los dem\xe1s detalles aqu\xed..."></textarea>
          <div class="NVCreateListingCon1">
            <div class="NVCreateListingText3">Dale una buena descripci\xf3n a tu listado.</div>
          </div>
          <div id="CreateListingErrorMessageDescription" class="CreateListingErrorMessage"></div>
        </div>

        <div class="CreateListingDescriptionCon1">
          <div class="NVCreateListingText2">Notas Admin</div>
          <textarea class="CreateListingDescriptionTextarea" name="" id="CreateListingAdminNotes"
            placeholder="Informaci\xf3n interna"></textarea>
          <div class="NVCreateListingCon1">
            <div class="NVCreateListingText3">Esta nota no ser\xe1 mostrado al publico. Es visible a los admins, y sirve para informaci\xf3n interno del negocio sobre este listado.</div>
          </div>
          <div id="CreateListingErrorMessageAdminNotes" class="CreateListingErrorMessage"></div>
        </div>
      </div>
      
      
      <div class="CreateListingPriceMoreOptionsCon1">
        <div id="CreateListingMoreOptionsButton" class="CreateListingPriceMoreOptionsCon3">
          <div class="CreateListingPriceMoreOptionsText1">Mostrar opciones avanzados</div>
        </div>
      </div>

    </div> <!-- END CreateListingCon1B -->
  </div> <!-- END CreateListingCon2A -->



  
  <div id="SelectPublishProfileCon1R" class="SelectPublishProfileCon1" style="display: none">
    <div class="SelectPublishProfileCon2">
      <div class="SelectPublishProfileCon3">
        <div class="SelectPublishProfileText1">Selecciona en donde quieres publicar este listado</div>
        <div class="SelectPublishProfileCon4">
          <div id="SelectPublishProfileCon1SelectAccount" data-select="profile" class="SelectPublishProfileSelectCon1">
            <div id="SelectPublishProfileCon2SelectAccount" class="SelectPublishProfileSelectCon2">
              <div id="SelectPublishProfileCon3SelectAccount" class="SelectPublishProfileSelectCon3">
                <img height="30px" src="${0, (/*@__PURE__*/$parcel$interopDefault($7a2c58f3c1632c4a$exports))}"/>
              </div>
              <div id="SelectPublishProfileCon1SelectAccountName" class="SelectPublishProfileText3"></div>
            </div>
            <div class="SelectPublishProfileText4">Seleccionar perfil de vendedor</div>
          </div>
          <div id="SelectPublishProfileCon1SelectBusiness" data-select="page" class="SelectPublishProfileSelectCon1">
            <div id="SelectPublishProfileCon2SelectBusiness" class="SelectPublishProfileSelectCon2">
              <div id="SelectPublishProfileCon3SelectBusiness" class="SelectPublishProfileSelectCon3">
                <img height="30px" src="${0, (/*@__PURE__*/$parcel$interopDefault($7a2c58f3c1632c4a$exports))}"/>
              </div>
              <div id="SelectPublishProfileCon1SelectBusinessName" class="SelectPublishProfileText3"></div>
            </div>
            <div class="SelectPublishProfileText4">Seleccionar p\xe1gina de negocio</div>
          </div>
        </div>
      </div>
      <div class="SelectPublishProfileCon5">
        <div class="SelectPublishProfileCon6B">
          <div id="SelectPublishProfileCon1ButtonBack" class="SelectPublishProfileCon6">
            <div class="SelectPublishProfileText2">Regresar</div>
          </div>
        </div>
        <div class="SelectPublishProfileCon6B">
          <div id="SelectPublishProfileCon1ButtonPublish" class="SelectPublishProfileCon7">
            <div class="SelectPublishProfileText2">Publicar</div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div id="SelectPublishProfileCon1" class="nvSelectPublishProfileCon1" style="display: none">
    <div class="nvSelectPublishProfileCon2">
      <div class="nvSelectPublishProfileCon3">
        <div class="nvSelectPublishProfileText1">Selecciona un perfil para publicar este listado</div>
      </div>
      <div class="nvSelectPublishProfileCon4">
        <div class="nvSelectPublishProfileCon5">
          <div class="nvSelectPublishProfileCon6">
            <div class="nvSelectPublishProfileText2">Tu perfil de vendedor</div>
          </div>
          <div id="SelectPublishProfileConProfile" class="nvSelectPublishProfileCon6B">
          </div>
          <div class="nvSelectPublishProfileCon6">
            <div class="selectpublishprofiletext4">Tus negocios</div>
          </div>
          <div id="SelectPublishProfileConBusinesses" class="nvSelectPublishProfileCon6B">
          </div>
        </div>
      </div>
    </div>
    <div class="CreateListingCon5B CreateListingCon5B2">
      <div id="CreateListingBtnBack" class="CreateListingCon5ButtonCancel topRightExitButtonOnFullScreenWindow">
        Regresar
      </div> 
      <div id="CreateListingBtnPublishNow" class="CreateListingCon5ButtonCreateListing">
        <p>Publicar Gratis</p>
        <img height="18px" src="${0, (/*@__PURE__*/$parcel$interopDefault($2fa5f8396b01a065$exports))}" />
      </div>
    </div>
  </div>
  





  <div class="CreateListingCon5B">
    <div id="CreateListingBtnCancel" class="CreateListingCon5ButtonCancel topRightExitButtonOnFullScreenWindow">
      Cancelar
    </div> 
    <div id="CreateListingBtnPublish" class="CreateListingCon5ButtonCreateListing">
      <p>Siguiente</p>
      <img height="18px" src="${0, (/*@__PURE__*/$parcel$interopDefault($eeee17e91b69eea4$exports))}" />
    </div>
  </div>



</div> <!-- END CreateListingCon1 -->

      `;
    }
    _returProfileHTML(data, account) {
        let actClass = "";
        if (data.act) actClass = "nvSelectPublishProfileProfileCon1Act";
        let imgClass = "nvSelectPublishProfileProfileCon4";
        if (data.type === "profile") imgClass = "nvSelectPublishProfileProfileCon4Profile";
        return `
      <div data-businessid="${data?.businessId || ''}" data-sellerid="${data?.userId || account.userId || ''}" data-type="${data.type}" class="nvSelectPublishProfileProfileCon1 ${actClass}">
        <div class="nvSelectPublishProfileProfileCon3">
          <img class="${imgClass}" src="${data.photoURL}" alt=""/>
          <div class="nvSelectPublishProfileProfileCon5">
            <div class="nvSelectPublishProfileProfileText2">${data.name}</div>
            <div class="nvSelectPublishProfileProfileText3">${data.description}</div>
          </div>
          <div class="nvSelectPublishProfileProfileCon2">
            <div class="nvSelectPublishProfileProfileText1">${data.role}</div>
          </div>
        </div>
      </div>
    `;
    }
    _returNoProfileHTML() {
        return `
      <div class="nvSelectPublishProfileProfileCon6">
        <div class="nvSelectPublishProfileProfileCon7">
          <div class="nvSelectPublishProfileProfileText4">No tienes negocios creados a\xfan.</div>
          <div class="nvSelectPublishProfileProfileText5">Crea un negocio primero luego podr\xe1s publicar tus listado bajo el perfil de este negocio</div>
        </div>
        <div id="CreateListingBtnCreateBusiness" class="nvSelectPublishProfileProfileCon8">
          Crear un Negocio
        </div>
      </div>
    `;
    }
    _returnVideoPreviewHTML(url) {
        if (!url) return "";
        function isYouTubeUrl(url) {
            return /^(https?:\/\/)?(www\.)?(youtube\.com\/|youtu\.be\/|youtube\.com\/shorts\/)/.test(url);
        }
        function extractYouTubeId(url) {
            let match;
            if (/youtube\.com\/shorts\/(.+)$/.test(url)) match = url.match(/youtube\.com\/shorts\/([^?&]+)/);
            else {
                const ytRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?#]+)/;
                match = url.match(ytRegex);
            }
            return match ? match[1] : null;
        }
        let videoElement = "";
        if (isYouTubeUrl(url)) {
            const videoId = extractYouTubeId(url);
            if (!videoId) return "";
            videoElement = `
      <iframe
        class="nvV1CreateListignPreviewVidCon4"
        src="https://www.youtube.com/embed/${videoId}"
        frameborder="0"
        allowfullscreen>
      </iframe>
    `;
        } else videoElement = `
      <video class="nvV1CreateListignPreviewVidCon4" controls preload="metadata">
        <source src="${url}" type="video/mp4">
      </video>
    `;
        return `

    <div class="nvV1CreateListignPreviewVidCon2">
      <div class="nvV1CreateListignPreviewVidCon3">
        
        ${videoElement}

        <div class="nvV1CreateListignPreviewVidCon5">
          <div class="nvV1CreateListignPreviewVidText1">Enlace: ${url}</div>
          <div class="nvV1CreateListignPreviewVidCon6">
            <div class="nvV1CreateListignPreviewVidCon7">
              <div id="CreateListingVideoURLDeleteVideoButton" class="nvV1CreateListignPreviewVidText2">Eliminar</div>
            </div>
          </div>
        </div>

      </div>
    </div>

  `;
    }
    _returnVideoPreviewHTMLV2(url) {
        if (!url) return "";
        function isYouTubeUrl(url) {
            return /^(https?:\/\/)?(www\.)?(youtube\.com\/|youtu\.be\/|youtube\.com\/shorts\/)/.test(url);
        }
        function extractYouTubeId(url) {
            let match;
            if (/youtube\.com\/shorts\/(.+)$/.test(url)) match = url.match(/youtube\.com\/shorts\/([^?&]+)/);
            else {
                const ytRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?#]+)/;
                match = url.match(ytRegex);
            }
            return match ? match[1] : null;
        }
        let videoElement = "";
        if (isYouTubeUrl(url)) {
            const videoId = extractYouTubeId(url);
            if (!videoId) {
                this._setVideoStatus(false);
                return "";
            }
            videoElement = `
      <iframe
        class="nvV1CreateListignPreviewVidCon4"
        src="https://www.youtube.com/embed/${videoId}"
        frameborder="0"
        allowfullscreen
        onload="window._videoPreviewLoaded && window._videoPreviewLoaded(true)">
      </iframe>
    `;
        } else videoElement = `
      <video
        class="nvV1CreateListignPreviewVidCon4"
        controls
        preload="metadata"
        onloadeddata="window._videoPreviewLoaded && window._videoPreviewLoaded(true)"
        onerror="window._videoPreviewLoaded && window._videoPreviewLoaded(false)">
        <source src="${url}" type="video/mp4">
      </video>
    `;
        return `
    <div class="nvV1CreateListignPreviewVidCon2">
      <div class="nvV1CreateListignPreviewVidCon3">

        ${videoElement}

        <div class="nvV1CreateListignPreviewVidCon5">
          <div class="nvV1CreateListignPreviewVidText1">Enlace: ${url}</div>
          <div class="nvV1CreateListignPreviewVidCon6">
            <div class="nvV1CreateListignPreviewVidCon7">
              <div id="CreateListingVideoURLDeleteVideoButton" class="nvV1CreateListignPreviewVidText2">Eliminar</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  `;
    }
}
var $ac56fd6b84e2bb3e$export$2e2bcd8739ae039 = new $ac56fd6b84e2bb3e$var$GenerateHTML();




const $15f2cce3daf449fd$var$spinnerMain = document.getElementById("SpinnerMain");
const $15f2cce3daf449fd$var$spinnerMessage = document.getElementById("SpinnerMessage");
class $15f2cce3daf449fd$var$Spinner {
    #spinnerTimeOut = 10000;
    #spinnerStartTimeStamp = "";
    #timeBeforeClosing = 300;
    #spinnerProblemTimer = null;
    #spinnerHideTimer = null;
    _displaySpinner(message = "", timeOut = 10000) {
        this.#spinnerTimeOut = timeOut;
        // A new spinner request cancels any old scheduled close/report.
        clearTimeout(this.#spinnerHideTimer);
        clearTimeout(this.#spinnerProblemTimer);
        this.#spinnerStartTimeStamp = Date.now();
        $15f2cce3daf449fd$var$spinnerMain.classList.remove("SpinnerHide");
        $15f2cce3daf449fd$var$spinnerMain.classList.add("SpinnerShow");
        $15f2cce3daf449fd$var$spinnerMessage.textContent = message;
        // Report only if this specific spinner stays visible for 10 seconds.
        this.#spinnerProblemTimer = setTimeout(()=>{
            const spinnerIsVisible = $15f2cce3daf449fd$var$spinnerMain.classList.contains("SpinnerShow");
            if (spinnerIsVisible) this._reportAProblem();
            this.#spinnerProblemTimer = null;
        }, this.#spinnerTimeOut);
    }
    _hideSpinner(force = false) {
        // if (!force) return
        clearTimeout(this.#spinnerHideTimer);
        const hideSpinner = ()=>{
            $15f2cce3daf449fd$var$spinnerMain.classList.add("SpinnerHide");
            $15f2cce3daf449fd$var$spinnerMain.classList.remove("SpinnerShow");
            $15f2cce3daf449fd$var$spinnerMessage.textContent = "";
            // Spinner is no longer active, so it must not report a timeout.
            clearTimeout(this.#spinnerProblemTimer);
            this.#spinnerProblemTimer = null;
            this.#spinnerHideTimer = null;
        };
        const timeBetween = Date.now() - this.#spinnerStartTimeStamp;
        const timeNeeded = Math.max(0, this.#timeBeforeClosing - timeBetween);
        if (timeNeeded === 0) hideSpinner();
        else this.#spinnerHideTimer = setTimeout(hideSpinner, timeNeeded);
    }
    async _reportAProblem(titleIn = null, descriptionIn = null) {
        let title = 'Reportar un Error';
        let description = "Esta aplicaci\xf3n tard\xf3 mucho en abrir esta p\xe1gina. Puedes reportarlo aqui. Favor describe lo que est\xe1s experimentando, para que podamos trabajar en mejorarlo.";
        if (titleIn) title = titleIn;
        if (descriptionIn) description = descriptionIn;
        const reportAProblemWindow1Title = document.getElementById('reportAProblemWindow1Title');
        const reportAProblemWindow1Description = document.getElementById('reportAProblemWindow1Description');
        reportAProblemWindow1Title.textContent = title;
        reportAProblemWindow1Description.textContent = description;
        const result = await this._confirmReportAProblem();
        this._hideSpinner(true);
        if (result === 'send') {
            // Handle the "send" case
            const input = document.getElementById('reportAProblemWindow1Input');
            const message = input.value.trim();
            if (message.length === 0) {
                alert("El reporte no puede estar vac\xedo. Por favor, describe el problema antes de enviarlo.");
                return;
            }
            const reportData = {
                message: message,
                timestamp: Date.now(),
                clientPlatformInfo: (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getClientPlatformInfo()
            };
            console.log("Sending report:", reportData);
            input.value = ''; // Clear the input field after sending
            const resultSend = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._reportAProblem(reportData);
            if (resultSend?.data?.status === 'success') console.log("Report sent successfully");
            else alert("Error al env\xedar el reporte. Puedes env\xedarnos un correo al: mercadomaionline@gmail.com para reportarlo.");
        }
        result;
        return 'done';
    }
    _confirmReportAProblem() {
        return new Promise((resolve)=>{
            const modal = document.getElementById('reportAProblemWindow1');
            const input = document.getElementById('reportAProblemWindow1Input');
            const sendBtn = document.getElementById('reportAProblemWindow1ButtonSend');
            const cancelBtn = document.getElementById('reportAProblemWindow1ButtonCancel');
            if (!modal || !input || !sendBtn || !cancelBtn) {
                resolve('cancel');
                return;
            }
            modal.style.display = 'flex';
            const cleanup = ()=>{
                sendBtn.removeEventListener('click', handleSend);
                cancelBtn.removeEventListener('click', handleCancel);
                modal.style.display = 'none';
            };
            const handleSend = ()=>{
                const message = input.value.trim();
                if (message.length === 0) {
                    alert("El reporte no puede estar vac\xedo. Por favor, describe el problema antes de enviarlo.");
                    return;
                }
                cleanup();
                resolve('send');
                this._thankYouForReportAProblem();
            };
            const handleCancel = ()=>{
                cleanup();
                resolve('cancel');
            };
            sendBtn.addEventListener('click', handleSend);
            cancelBtn.addEventListener('click', handleCancel);
        });
    }
    _thankYouForReportAProblem() {
        return new Promise((resolve)=>{
            const modal = document.getElementById('reportAProblemWindow2');
            const cancelBtn = document.getElementById('reportAProblemWindow2ButtonClose');
            if (!modal || !cancelBtn) {
                resolve('cancel');
                return;
            }
            modal.style.display = 'flex';
            const cleanup = ()=>{
                cancelBtn.removeEventListener('click', handleCancel);
                modal.style.display = 'none';
            };
            const handleCancel = ()=>{
                cleanup();
                resolve('cancel');
            };
            cancelBtn.addEventListener('click', handleCancel);
        });
    }
}
var $15f2cce3daf449fd$export$2e2bcd8739ae039 = new $15f2cce3daf449fd$var$Spinner();


// Keeping register as a relay functions for all those calls that come from diferent places
// instead of oing and chaning all those places to signUpProfile



// import AppLogo from "../../../Icons/logos/App-logo.png";
// import iconShow from "../../../Icons/icons-charcoal-dark/eye-show.png";
// import iconDone from "../../../Icons/icons-charcoal-dark/done.png";
var $64337d4b31a692ba$exports = {};
$64337d4b31a692ba$exports = new URL("star.6ddb4a1d.png", import.meta.url).toString();


var $1ec93aa3f5b0a0a3$exports = {};
$1ec93aa3f5b0a0a3$exports = new URL("views.31143c8e.png", import.meta.url).toString();


var $eadb67d7a10dd93a$exports = {};
$eadb67d7a10dd93a$exports = new URL("views.0d9ab9ea.png", import.meta.url).toString();


var $22464c49e0ce4777$exports = {};
$22464c49e0ce4777$exports = new URL("views.9e339a11.png", import.meta.url).toString();


var $e23f166ed2384893$exports = {};
$e23f166ed2384893$exports = new URL("whatsapp.f78d1668.png", import.meta.url).toString();


var $d1797cbceb848da8$exports = {};
$d1797cbceb848da8$exports = new URL("share.c0d42a71.png", import.meta.url).toString();


var $769f628d53a18151$exports = {};
$769f628d53a18151$exports = new URL("ahead.2b3d2689.png", import.meta.url).toString();


var $4ee8675ad6b65755$exports = {};
$4ee8675ad6b65755$exports = new URL("ahead.2e686b35.png", import.meta.url).toString();


var $e06ece8f507a608d$exports = {};
$e06ece8f507a608d$exports = new URL("1-more-images-black.b11fc2c2.png", import.meta.url).toString();


var $615cf3efb920d211$exports = {};
$615cf3efb920d211$exports = new URL("2-more-images-black.7565cc91.png", import.meta.url).toString();


var $fd23595bb2a20623$exports = {};
$fd23595bb2a20623$exports = new URL("3-more-images-black.714e3a79.png", import.meta.url).toString();


var $87dd1230f017b342$exports = {};
$87dd1230f017b342$exports = new URL("4-more-images-black.017833f7.png", import.meta.url).toString();


var $b6f8cd3cf95c6046$exports = {};
$b6f8cd3cf95c6046$exports = new URL("5-more-images-black.223df771.png", import.meta.url).toString();


var $d26c750e98654974$exports = {};
$d26c750e98654974$exports = new URL("6-more-images-black.b60e07ae.png", import.meta.url).toString();



class $324356ea97674db7$var$DisplayListing {
    constructor(){}
}
var $324356ea97674db7$export$2e2bcd8739ae039 = new $324356ea97674db7$var$DisplayListing();


var $6975554d1308a036$exports = {};
$6975554d1308a036$exports = new URL("verified.769ce719.png", import.meta.url).toString();


var $1a8906870c2da8ac$exports = {};
$1a8906870c2da8ac$exports = new URL("MAI-VERIFIED.2d7e2d87.png", import.meta.url).toString();


var $de3fcb18e82e2fa8$exports = {};
$de3fcb18e82e2fa8$exports = new URL("dots-menu.2b814bb3.png", import.meta.url).toString();


var $f2561d1a604d88e7$exports = {};
$f2561d1a604d88e7$exports = new URL("videos.155bac79.png", import.meta.url).toString();


var $b39d991b01f872b3$exports = {};
$b39d991b01f872b3$exports = new URL("empresa.ae36b219.png", import.meta.url).toString();



var $0d9d8e55938a3867$exports = {};
$0d9d8e55938a3867$exports = new URL("delete.95f01386.png", import.meta.url).toString();


var $c6666896698d7a3e$exports = {};
$c6666896698d7a3e$exports = new URL("edit.2c561dfb.png", import.meta.url).toString();


// import { title } from "process";
//
// style="background: #${colors.}; color: #${colors.};"
//
class $64185892d2bdb50b$var$GenarateHtml {
    _generateBusinessRewiewStars(number, reviews, data) {
        // TODO for now in use. Need to develop a rating system
        if (data.verifiedBusiness) return ` 
      <div class="RatingStarCon2">
        <img class="" height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($6975554d1308a036$exports))}" alt=""/>
        <div class="BusinessEditorBusinessHeaderVerifiedBadgeText">verificado de Mercado MAI</div>
      </div>
       `;
        return ``;
    }
    _businessPackOfPacks(html) {
        return `
    <div class="BusinessesPackOfPacksDisplayCon1">${html}</div>
    `;
    }
    _businessPack(title, id, colors) {
        return `
  <div class="BusinessesPackDisplayCon1">
    <div class="BusinessesPackDisplayCon2">
      <div  style="color: #${colors.packTitles};" class="BusinessesPackDisplayTitle">
        ${title}
      </div>
      <div data-generall="expandforviewallbusiness" class="BusinessesPackDisplayVerTodo">
        Ver mas
      </div>
    </div>
    <div id="${id}" class="BusinessesPackDisplayCon3"></div>
  </div>`;
    }
    _listingPack(title, colors, id, actionData = "expandforviewall") {
        return `
  <div class="ListingPackDisplayCon1">
    <div class="ListingPackDisplayCon2">
      <div  style="color: #${colors.packTitles};" class="BusinessesPackDisplayTitle">
        ${title}
      </div>
      <div data-generall="${actionData}"  style="color: #${colors.packTitlesHighlight};" class="BusinessesPackDisplayVerTodo">
        Ver mas
      </div>
    </div>
    <div id="${id}" class="ListingPackDisplayCon3"></div>
  </div>`;
    }
    async _generateBusiness2v(listings, data, listingsConDips = 'flex', isInSellers, own = false, edit = false) {
        let ownOptionDeletedisplayStatus = own ? 'flex' : 'none';
        let ownOptionEditdisplayStatus = edit ? 'flex' : 'none';
        let generalOptionsdisplayStatus = own ? 'none' : 'flex';
        let verifiedHTML = ``;
        let v20BusinessCon10Class = 'v20BusinessCon10';
        if (listingsConDips === 'none') v20BusinessCon10Class = '';
        const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        let menuDotsHtml = ``;
        if (userData?.businesses?.includes(data.businessId)) menuDotsHtml = `
        <div class="v20BusinessCon7BDots onBusinessOpenEditOptions returnForActionOpenForDisplay openBusinessEditOptionsGlobal">
          <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($de3fcb18e82e2fa8$exports))}"/>
        </div>
    `;
        let profUrl = data?.profileImg;
        let profUrlOrig = data?.profileImg;
        let backUrl = data?.backgroundImg;
        if (data?.images) {
            profUrl = data?.images?.profile[0]?.res_200;
            profUrlOrig = data?.images?.profile[0]?.res_1000;
            backUrl = data?.images?.background[0]?.res_500;
        }
        const businessHTML = `

        <div
          data-lives="business"
          data-origimg="${profUrlOrig}"
          data-businessId="${data.businessId}"
          class="v20BusinessCon1A ActionOpenForDisplay hasOriginalImages">




              <div class="nvBusinessEachCon6BA">
                <div class="nvBusinessEachCon6B">
                  <div class="nvBusinessEachCon6">
                    <div class="nvBusinessEachCon6Text1">${data.name}</div>
                    <div class="nvBusinessEachCon6Text2">${data.shortDescription}</div>
                  </div>

                  <div class="nvBusinessEachConProfileIMGCon">
                    <img src="${profUrl}" class="nvBusinessEachConProfileIMG ImgForBigDisplay">
                  </div>
                </div>
              </div>




            <div class="v20BusinessCon9">
              <div class="${v20BusinessCon10Class}" style:="display: ${listingsConDips};">
              ${listings}
              </div>
              <div class="v20BusinessCon11">
                <div class="v20BusinessCon12">
                  <div class="v20BusinessCon13">
                    <img height="8px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($eadb67d7a10dd93a$exports)))}" />
                    <div class="v20BusinessText6">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.views)}</div>
                  </div>
                  <div class="v20BusinessCon13">
                    <img height="8px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($d1797cbceb848da8$exports)))}" />
                    <div class="v20BusinessText6">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.shares)}</div>
                  </div>
                </div>


                <div class="v20BusinessCon14" style="display: ${generalOptionsdisplayStatus};">
                  <div class="v20BusinessText7">Ver Empresa</div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M0.75 5.75H10.75M10.75 5.75L5.75 0.75M10.75 5.75L5.75 10.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>      

                <div class="v20BusinessCon14Edit returnForActionOpenForDisplay" style="display: ${ownOptionEditdisplayStatus};">
                  <div class="v20BusinessText7Edit">Editar</div>
                  <img height="12px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($c6666896698d7a3e$exports)))}" />
                </div>   

                <div class="v20BusinessCon14Delete returnForActionOpenForDisplay" style="display: ${ownOptionDeletedisplayStatus};">
                  <div class="v20BusinessText7Delete">Eliminar</div>
                  <img height="12px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($0d9d8e55938a3867$exports)))}" />
                </div>



              </div>
            </div>
        </div>

    `;
        let finalBusinessHTML = businessHTML;
        if (!isInSellers) finalBusinessHTML = `<div class="nvBusinessVerCon1A">${businessHTML}</div>`;
        return finalBusinessHTML;
    }
    async _businessInPack(listings, data) {
        const backImgUrl = data.backgroundImg;
        const ProfileImgUrl = data.profileImg;
        return `
<div
  data-lives="business"
  data-businessId="${data.businessId}"
  class="BusinessInSearchCon1 ActionOpenForDisplay"
>
  <div class="BusinessInSearchCon2">
    <img
      id=""
      class="BusinessInSearchCon1BackgroundImg"
      loading="lazy"
      src="${backImgUrl}"
      alt=""
    >
    <div class="BusinessInSearchCon3">
      <div class="BusinessInSearchCon4">
        <div class="BusinessInSearchCon5">
          <div class="BusinessInSearchCon6">
            <div
              style="color: #${data.colors.headerPrimary};"
              class="BusinessInSearchBusinessName"
            >
              ${data.name}
            </div>
            <div
              style="color: #${data.colors.headerSecondary};"
              class="BusinessInSearchBusinessShortDescription"
            >
              ${data.shortDescription}
            </div>
          </div>
          <div class="BusinessInSearchCon7">
            ${this._generateBusinessRewiewStars(data.ratedAt, data.numberOfReviews, data)}
          </div>
        </div>
        <img
          id="BusinessInSearchCon8ProfileImg"
          class="BusinessInSearchCon8 ImgForBigDisplay"
          src="${ProfileImgUrl}"
          loading="lazy"
          alt=""
        >
      </div>
    </div>
  </div>
  <div class="BusinessInSearchCon9 BusinessInSearchCon9B">
    <div class="BusinessInSearchCon10">${listings}</div>
  </div>
</div>
`;
    }
    async _listingHorizontal(data, colors, openToIn, from) {
        if (!data) return ``;
        console.log(data);
        let priceToDisplay = data.listingPrice;
        // const openTo = data.openTo;
        let openTo = "listing";
        if (data.businessId) openTo = "listingInBusiness";
        let priceDescriptionHtml = ``;
        if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) priceDescriptionHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingHorizontalTextB1"
    >
      precio ${data.listingPriceMarkedAs}
    </div>
    `;
        let itmesAvailableHtml = ``;
        if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
            let textToShow = `${data.listingItemsAvailable} unidades disponibles`;
            if (data.listingItemsAvailable === 1) textToShow = `\xfaltimo disponible`;
            if (data.listingItemsAvailable === 2) textToShow = `solo ${data.listingItemsAvailable} unidades disponibles`;
            itmesAvailableHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingHorizontalTextB2"
    >
       ${textToShow}
    </div>
    `;
        }
        const itemImg = data.listingMainImg;
        // const itemImg = await firebase._getImageUrl(data.listingMainImg);
        let moreImgsHtml = `<img height="16px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e06ece8f507a608d$exports)))}" />`;
        if (data.listingImgsIds.length === 2) moreImgsHtml = `<img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($615cf3efb920d211$exports))}" />`;
        if (data.listingImgsIds.length === 3) moreImgsHtml = `<img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($fd23595bb2a20623$exports))}" />`;
        if (data.listingImgsIds.length === 4) moreImgsHtml = `<img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($87dd1230f017b342$exports))}" />`;
        if (data.listingImgsIds.length === 5) moreImgsHtml = `<img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b6f8cd3cf95c6046$exports))}" />`;
        if (data.listingImgsIds.length === 6) moreImgsHtml = `<img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($d26c750e98654974$exports))}" />`;
        let showPrice = "$ preguntar";
        let onDiscountTagHtml = "";
        let onDiscountTextHtml = "";
        let itemMarkedAsHtml = "";
        if (data?.listingMarkedAs) itemMarkedAsHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10B"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalTextB3"
          >
            ${data.listingMarkedAs}
          </div>
        </div>
      `;
        if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
            if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) ;
            else {
                priceToDisplay = data.onDiscount.finalPrice;
                onDiscountTagHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalOnDiscount"
          >
            En oferta ${data.onDiscount.percent}% \u{2193}
          </div>
        </div>
      `;
                onDiscountTextHtml = `
          <div
            style="color: #${colors.itemHighlight};"
            class="ListingVeriticalPriceBeforeText"
            >
            <div class="Antes">Antes</div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalPriceBeforePrice"
            >
              ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(data.listingPrice, data.listingCoin)}
            </div>
          </div>
      `;
            }
        }
        if (data.listingPriceMarkedAs !== "preguntar") showPrice = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(priceToDisplay, data.listingCoin);
        return `
<div
  data-openTo="${openTo}"
  data-openfrom="${from}"
  data-listingId="${data.listingId}"
  data-businessId="${data.businessId}"
    class="ListingHorizontalCon1 ActionOpenForDisplay">
  <div class="ListingVirticalCon2ImageB3">
    <img class="ListingHorizontalCon2Image ImgForBigDisplay" src="${itemImg}" loading="lazy">
    <div class="ListingVirticalCon2ImageC">
      ${moreImgsHtml}
    </div>
  </div>
  <div style="background: #${colors.itemBackgroundSecondary};"
       class="ListingHorizontalCon3">
    <div class="ListingHorizontalCon4">
      <div style="background: #${colors.itemBackgroundPrimary};" class="ListingHorizontalCon5">
        <div style="color: #${colors.itemTextPrimary};" class="ListingVeriticalTitle">
          ${data.listingName}
        </div>
      </div>
      <div style="background: #${colors.itemBackgroundSecondary};" class="ListingHorizontalCon6">
        <div class="ListingHorizontalCon7">
          <div class="ListingHorizontalCon8">
            <div class="ListingHorizontalCon9">
              ${onDiscountTagHtml}
              <div class="ListingHorizontalCon9B">
                ${priceDescriptionHtml}
                <div style="color: #${colors.itemTextFour};" class="ListingVeriticalPrice">
                  ${showPrice}
                </div>
              </div>
            </div>
            <div style="color: #${colors.itemTextFour};" class="ListingVeriticalCondition">
              ${data.listingCondition}
            </div>
            ${itmesAvailableHtml}
            ${itemMarkedAsHtml}
          </div>
          ${onDiscountTextHtml}
        </div>
        <div style="color: #${colors.itemTextSecondary};" class="ListingVeriticalDescription">
          ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._shortenText(data.listingDescription, 20)}
        </div>
      </div>
    </div>
    <div class="ListingVerticalCon13B">
      <div class="ListingVerticalCon11">
        <div class="ListingVerticalCon12">
          <div class="ListingDisplayViewsText">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.listingViews)}</div>
          <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($22464c49e0ce4777$exports))}" />
          </div>
          </div>
          <div class="ListingVerticalCon14">
          <div class="ListingVerticalText1">Ver art\xedculo</div>
          <img height="8px" src="${0, (/*@__PURE__*/$parcel$interopDefault($769f628d53a18151$exports))}" />
      </div>
    </div>
  </div>
</div>
    `;
    }
    async _listingVertical(data, colors, openToIn, businessId, from, fromEdit = "false", isForEdit) {
        console.warn(from);
        // return
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        let priceToDisplay = data.listingPrice;
        const itemImg = data.listingMainImg;
        // const itemImg = await firebase._getImageUrl(data.listingMainImg);
        // const openTo = data.openTo;
        let openTo = "listing";
        if (data.businessId) openTo = "listingInBusiness";
        let moreImgsHtml = `<img height="20px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e06ece8f507a608d$exports)))}" />`;
        let priceDescriptionHtml = ``;
        if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) priceDescriptionHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalTextB1"
    >
      precio ${data.listingPriceMarkedAs}
    </div>
    `;
        let itmesAvailableHtml = ``;
        if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
            let textToShow = `${data.listingItemsAvailable} unidades disponibles`;
            if (data.listingItemsAvailable === 1) textToShow = `\xfaltimo disponible`;
            if (data.listingItemsAvailable === 2) textToShow = `solo ${data.listingItemsAvailable} unidades disponibles`;
            itmesAvailableHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalTextB2"
    >
       ${textToShow}
    </div>
    `;
        }
        if (data.listingImgsIds.length === 2) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($615cf3efb920d211$exports))}" />`;
        if (data.listingImgsIds.length === 3) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($fd23595bb2a20623$exports))}" />`;
        if (data.listingImgsIds.length === 4) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($87dd1230f017b342$exports))}" />`;
        if (data.listingImgsIds.length === 5) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b6f8cd3cf95c6046$exports))}" />`;
        if (data.listingImgsIds.length === 6) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($d26c750e98654974$exports))}" />`;
        let onDiscountTagHtml = "";
        let onDiscountTextHtml = "";
        let itemMarkedAsHtml = "";
        if (data?.listingMarkedAs) itemMarkedAsHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10B"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalTextB3"
          >
            ${data.listingMarkedAs}
          </div>
        </div>
      `;
        let showPrice = "$ preguntar";
        if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
            if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) ;
            else {
                priceToDisplay = data.onDiscount.finalPrice;
                onDiscountTagHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalOnDiscount"
          >
            En oferta ${data.onDiscount.percent}% \u{2193}
          </div>
        </div>
      `;
                onDiscountTextHtml = `
          <div
            style="color: #${colors.itemHighlight};"
            class="ListingVeriticalPriceBeforeText"
            >
            <div class="Antes">Antes</div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalPriceBeforePrice"
            >
              ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(data.listingPrice, data.listingCoin)}
            </div>
          </div>
      `;
            }
        }
        if (data.listingPriceMarkedAs !== "preguntar") showPrice = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(priceToDisplay, data.listingCoin);
        let menuDotsHtml = ``;
        if (data.businessId) {
            if (account?.business === data.businessId) menuDotsHtml = `
        <div class="OwnBusinessListingButtonMenu returnForActionOpenForDisplay openListingEditOptionsGlobal">
          <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($de3fcb18e82e2fa8$exports))}"/>
        </div>
    `;
        }
        return `
<div
  data-openTo="${openTo}"
  data-openfrom="${from}"
  data-openfromedit="${fromEdit}"
  data-listingId="${data.listingId}"
  data-businessId="${data.businessId}"
  class="ListingVeriticalCon1 ActionOpenForDisplay"
>
  <div class="ListingVirticalCon2ImageB">
    <img class="ListingVirticalCon2Image ImgForBigDisplay" src="${itemImg}" loading="lazy">
    ${menuDotsHtml}
    <div class="ListingVirticalCon2ImageC">
    ${moreImgsHtml}
    </div>
  </div>
  <div
    style="background: ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._hexToRgba(colors.itemBackgroundSecondary, 0.8)}"
    class="ListingVeriticalCon3"
  >
    <div class="ListingVeriticalCon4">
      <div
        style="background: #${colors.itemBackgroundPrimary};"
        class="ListingVeriticalCon5"
      >
        <div style="color: #${colors.itemTextPrimary};" class="ListingVeriticalTitle">
          ${data.listingName}
        </div>
      </div>
      <div class="ListingVeriticalCon6">
        <div class="ListingVeriticalCon7">
          <div class="ListingVeriticalCon8">
            <div class="ListingVeriticalCon9">
              ${onDiscountTagHtml}
              <div class="ListingVeriticalCon9B">
                ${priceDescriptionHtml}
                <div
                  style="color: #${colors.itemTextFour};"
                  class="ListingVeriticalPrice"
                >
                  ${showPrice}
                </div>
              </div>
            </div>
            <div
              style="color: #${colors.itemTextFour};"
              class="ListingVeriticalCondition"
            >
              ${data.listingCondition}
            </div>
            ${itmesAvailableHtml}
            ${itemMarkedAsHtml}
          </div>
         ${onDiscountTextHtml}
        </div>
        <div
          style="color: #${colors.itemTextSecondary};"
          class="ListingVeriticalDescription"
        >
          ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._shortenText(data.listingDescription, 30)}
        </div>
      </div>
    </div>


<div class="ListingVerticalCon13">
  <div class="ListingVerticalCon11">
    <div class="ListingVerticalCon12">
      <div class="ListingDisplayViewsText">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.listingViews)}</div>
      <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($22464c49e0ce4777$exports))}" />
      </div>
      </div>
      <div class="ListingVerticalCon14">
      <div class="ListingVerticalText1">Ver art\xedculo</div>
      <img height="8px" src="${0, (/*@__PURE__*/$parcel$interopDefault($769f628d53a18151$exports))}" />
  </div>
</div>`;
    }
    _listingVerticalNV(data, isInRecent, from = '', isInBusiness, deleteOnly = false) {
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        let priceToDisplay = data.listingPrice;
        let lives = 'seller';
        let isInRecentClass = '';
        let isMiniTitleClass = '';
        let isPriceMiniClass = '';
        let displayHiddenForMini = 'flex';
        if (isInRecent) isInRecentClass = 'nvListingVerCon1InRecent';
        if (isInBusiness) {
            isInRecentClass = 'nvListingVerCon1InBusiness';
            isMiniTitleClass = 'nvListingVerText2Mini';
            displayHiddenForMini = 'none';
            isPriceMiniClass = 'nvListingVerText6Mini';
        }
        if (data.businessId) lives = 'business';
        let priceDescriptionHtml = ``;
        if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) priceDescriptionHtml = `
        <div class="nvListingVerText5">\u{2022} precio ${data.listingPriceMarkedAs}</div>
    `;
        let itmesAvailableHtml = ``;
        if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
            let textToShow = `\u{2022} ${data.listingItemsAvailable} unidades disponibles`;
            if (data.listingItemsAvailable === 1) textToShow = `\u{2022} \xfaltimo disponible`;
            if (data.listingItemsAvailable === 2) textToShow = `\u{2022} solo ${data.listingItemsAvailable} unidades disponibles`;
            itmesAvailableHtml = `
          <div class="nvListingVerText7">${textToShow}</div>
        `;
        }
        let itemConditionHtml = ``;
        if (data?.listingCondition) itemConditionHtml = `
      <div class="nvListingVerText12">\u{2022} ${data.listingCondition}</div>
    `;
        let onDiscountTagHtml = "";
        let onDiscountTextHtml = "";
        let itemMarkedAsHtml = "";
        if (data?.listingMarkedAs) itemMarkedAsHtml = `
          <div class="nvListingVerText8">\u{2022} ${data.listingMarkedAs}</div>
      `;
        let showPrice = "$ preguntar";
        if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
            if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) ;
            else {
                priceToDisplay = data.onDiscount.finalPrice;
                onDiscountTagHtml = `
          <div class="nvListingVerCon20" style="display: ${displayHiddenForMini}">
            <div class="nvListingVerText4">En oferta ${data.onDiscount.percent}% \u{2193}</div>
          </div>
      `;
                onDiscountTextHtml = `
          <div class="nvListingVerCon25" style="display: ${displayHiddenForMini}">
            <div class="nvListingVerText9">Antes</div>
            <div class="nvListingVerText10">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(data.listingPrice, data.listingCoin)}
            </div>
          </div>
        `;
            }
        }
        if (data.listingPriceMarkedAs !== "preguntar") showPrice = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(priceToDisplay, data.listingCoin);
        let menuDotsHtml = ``;
        const generateAdminPrivilegedHtml = ()=>{
            if (!account) return;
            if (data?.businessId) {
                function accountHasBusiness(account, businessId) {
                    if (!account || !account.businesses) return false;
                    return account.businesses.some((business)=>business.id === businessId);
                }
                if (!accountHasBusiness(account, data.businessId)) {
                    console.log('here');
                    return;
                }
            } else if (data.sellerId !== account.userId) {
                console.log('here');
                return;
            }
            if (!isInBusiness) menuDotsHtml = `
                <div class="nvListingVerCon3Dots returnForActionOpenForDisplay openListingEditOptionsGlobal">
                  <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($de3fcb18e82e2fa8$exports))}"/>
                </div>
            `;
        };
        generateAdminPrivilegedHtml();
        let allImgs = ``;
        // data.listingImgsIds.forEach(img => {
        //   allImgs += `
        //   <div class="nvListingVerCon8">
        //     <img class="nvListingVerCon8Img" src="${img}">
        //   </div>
        //   `
        // });
        let img1Display = 'flex';
        let img2Class = 'nvListingVerCon2Bg';
        if (isInBusiness) // img1Display = 'none'
        img2Class = 'nvListingVerCon2ImgNoBlur';
        // let from = ''
        // if (data.businessId) {
        //   from = 'business'
        // }
        let imageBig = data.listingMainImg;
        let imageBlurred = data.listingMainImg;
        if (!data.listingMainImg) {
            if (isInRecent) imageBig = data.listingImgsIds[0].res_500;
            else imageBig = data.listingImgsIds[0].res_200;
            imageBlurred = data.listingImgsIds[0].res_blurred;
            data.listingImgsIds.forEach((img)=>{
                allImgs += `
      <div class="nvListingVerCon8">
        <img class="nvListingVerCon8Img" src="${img.res_20}">
      </div>
      `;
            });
        }
        let businessLogo = ``;
        if (lives === 'business' && from !== 'business' && !isInBusiness) businessLogo = `<img class="nvListingVerCon4" height="32px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b39d991b01f872b3$exports))}"></img>`;
        let videoHtml = ``;
        if (data.videoUrl) videoHtml = `
        <div class="nvListingVerCon7">
          <img class="nvListingVerCon7Icon" height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f2561d1a604d88e7$exports))}" />
        </div>
       `;
        let originalImages = data.listingImgsIds;
        if (data?.listingImgsIds?.[0]?.res_200) {
            let orgImgs = [];
            data.listingImgsIds.forEach((img)=>{
                orgImgs.push(img.res_1000 || img.res_500);
            });
            originalImages = orgImgs;
        }
        const listingHtml = `
        <div
         data-origimg="${originalImages.join("\xb0-\xb0|\xb0-\xb0?\xb0-\xb0|\xb0-\xb0")}"
          data-lives="${lives}"
          data-deleteonly="${deleteOnly}"
          data-from="${from}"
          data-listingId="${data.listingId}"
          data-businessId="${data.businessId}"
          data-sellerId="${data.sellerId}"
          data-mainimgurl="${data.listingMainImg}"

          class="nvListingVerCon1 ${isInRecentClass} ActionOpenForDisplayListing hasOriginalImages">

          <div class="nvListingVerCon2">
            <img class="nvListingVerCon2Img ImgForBigDisplay" style="display: ${img1Display}" src="${imageBig}">
            <img class="${img2Class} ImgForBigDisplay" src="${imageBlurred}">
            <div class="nvListingVerCon3">
              ${businessLogo}
            </div>
            ${menuDotsHtml}
            <div class="nvListingVerCon5">
              <div class="nvListingVerCon6">
                ${videoHtml}
                ${allImgs}
              </div>
              <div class="nvListingVerCon9">
                <div class="nvListingVerCon10">
                  <div class="nvListingVerCon11">
                    <div class="nvListingVerText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.listingViews)}</div>
                    <img height="6px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($eadb67d7a10dd93a$exports)))}" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nvListingVerCon12">
            <div class="nvListingVerCon13">
              <div class="nvListingVerCon14">
                <div class="nvListingVerText2 ${isMiniTitleClass}">${data.listingName}</div>
              </div>
              <div class="nvListingVerCon15" style="display: ${displayHiddenForMini}">
                <div class="nvListingVerText3">${data.listingDescription}</div>
              </div>
            </div>
            <div class="nvListingVerCon16">
              <div class="nvListingVerCon17">
                <div class="nvListingVerCon18">
                  <div class="nvListingVerCon19">
                    ${onDiscountTagHtml}

                    <div class="nvListingVerCon21">
                      <div class="nvListingVerText6 ${isPriceMiniClass}">${showPrice}</div>
                    </div>
                  </div>
                  <div class="nvListingVerCon22" style="display: ${displayHiddenForMini}">
                    ${itemConditionHtml}
                    ${itemMarkedAsHtml}
                    ${itmesAvailableHtml}
                    ${priceDescriptionHtml}
                  </div>
                </div>
                <div class="nvListingVerCon24">
                  ${onDiscountTextHtml}
                </div>
              </div>
            </div>
          </div>
        </div>
  `;
        let finalHtml = '';
        if (isInBusiness) finalHtml = listingHtml;
        else finalHtml = `<div class="nvListingVerCon1A">${listingHtml}</div>`;
        return finalHtml;
    }
    async _listingVerticalMini(data, colors, openToIn, businessId, from) {
        return this._listingVerticalNV(data, null, null, true);
    }
    _viewAllListingsMini(colors) {
        return `
<div class="ListingMiniVeriticalCon3B" style="background: ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._hexToRgba(colors.itemBackgroundSecondary, 0.8)};">
  <div class="ListingMiniVeriticalCon5" style="background: #${colors.itemBackgroundPrimary};">
    <div style="color: #${colors.itemTextPrimary};" class="ListingVeriticalTitleMini">Visita este negocio</div>
  </div>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 49" fill="none">
  <path d="M24 0.5C24.8302 0.5 25.6265 0.829812 26.2135 1.41688C26.8006 2.00395 27.1304 2.80019 27.1304 3.63043V21.3696H44.8696C45.6998 21.3696 46.496 21.6994 47.0831 22.2864C47.6702 22.8735 48 23.6698 48 24.5C48 25.3302 47.6702 26.1265 47.0831 26.7135C46.496 27.3006 45.6998 27.6304 44.8696 27.6304H27.1304V45.3696C27.1304 46.1998 26.8006 46.996 26.2135 47.5831C25.6265 48.1702 24.8302 48.5 24 48.5C23.1698 48.5 22.3735 48.1702 21.7864 47.5831C21.1994 46.996 20.8696 46.1998 20.8696 45.3696V27.6304H3.13043C2.30019 27.6304 1.50395 27.3006 0.916883 26.7135C0.329812 26.1265 0 25.3302 0 24.5C0 23.6698 0.329812 22.8735 0.916883 22.2864C1.50395 21.6994 2.30019 21.3696 3.13043 21.3696H20.8696V3.63043C20.8696 2.80019 21.1994 2.00395 21.7864 1.41688C22.3735 0.829812 23.1698 0.5 24 0.5Z" fill="#${colors.itemBackgroundPrimary}"/>
</svg>
  <div class="ListingMiniVeriticalCon5" style="background: #${colors.itemBackgroundPrimary};">
    <div style="color: #${colors.itemTextPrimary};"  class="ListingVeriticalTitleMini">Para ver todos los listados</div>
  </div>
</div>`;
    }
    _listingVerticalMiniNoListings(individual, messageIn) {
        let message = "Este negocio no tiene listados en este momento. Regrese pronto.";
        if (individual) message = "No hay listados aqui.";
        if (messageIn) message = messageIn;
        return `
  <div class="NoListingsMiniCon1">
    <div class="NoListingsMiniTitle">
      Sin listados...
    </div>
  </div>
    `;
    }
    async _listingVerticalBig(data, colors, openToIn, businessId, from) {
        let priceToDisplay = data.listingPrice;
        const itemImg = data.listingMainImg;
        // let businessIdToUse = "nothing";
        // const itemImg = await firebase._getImageUrl(data.listingMainImg);
        // const openTo = data.openTo;
        let openTo = "listing";
        if (data.businessId) openTo = "listingInBusiness";
        let priceDescriptionHtml = ``;
        if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) priceDescriptionHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalBigTextB1"
    >
      \u{2022} precio ${data.listingPriceMarkedAs}
    </div>
    `;
        let itmesAvailableHtml = ``;
        if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
            let textToShow = `\u{2022} ${data.listingItemsAvailable} unidades disponibles`;
            if (data.listingItemsAvailable === 1) textToShow = `\u{2022} \xfaltimo disponible`;
            if (data.listingItemsAvailable === 2) textToShow = `\u{2022} solo ${data.listingItemsAvailable} unidades disponibles`;
            itmesAvailableHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalBigTextB2"
    >
      ${textToShow}
    </div>
    `;
        }
        let moreImgsHtml = `<img height="20px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e06ece8f507a608d$exports)))}" />`;
        if (data.listingImgsIds.length === 2) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($615cf3efb920d211$exports))}" />`;
        if (data.listingImgsIds.length === 3) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($fd23595bb2a20623$exports))}" />`;
        if (data.listingImgsIds.length === 4) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($87dd1230f017b342$exports))}" />`;
        if (data.listingImgsIds.length === 5) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b6f8cd3cf95c6046$exports))}" />`;
        if (data.listingImgsIds.length === 6) moreImgsHtml = `<img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($d26c750e98654974$exports))}" />`;
        let showPrice = "$ preguntar";
        let onDiscountTagHtml = "";
        let onDiscountTextHtml = "";
        let itemMarkedAsHtml = "";
        if (data?.listingMarkedAs) itemMarkedAsHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalBigCon10B"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalBigTextB3"
          >
            \u{2022} ${data.listingMarkedAs}
          </div>
        </div>
      `;
        if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
            if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) ;
            else {
                priceToDisplay = data.onDiscount.finalPrice;
                onDiscountTagHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalBigCon10"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalBigOnDiscount"
          >
            En oferta ${data.onDiscount.percent}% \u{2193}
          </div>
        </div>
      `;
                onDiscountTextHtml = `
          <div
            style="color: #${colors.itemHighlight};"
            class="ListingVeriticalBigPriceBeforeText"
            >
            <div class="Antes">Antes</div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalBigPriceBeforePrice"
            >
              ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(data.listingPrice, data.listingCoin)}
            </div>
          </div>
      `;
            }
        }
        if (data.listingPriceMarkedAs !== "preguntar") showPrice = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(priceToDisplay, data.listingCoin);
        return `
<div
  data-openTo="${openTo}"
  data-openfrom="${from}"
  data-listingId="${data.listingId}"
  data-businessId="${data.businessId}"
  class="ListingVeriticalBigCon1 ActionOpenForDisplay"
>
  <div class="ListingVirticalCon2ImageB2">
    <img class="ListingVirticalBigCon2Image ImgForBigDisplay" src="${itemImg}" loading="lazy">
    <div class="ListingVirticalCon2ImageC">
      ${moreImgsHtml}
    </div>
  </div>
  <div
    style="background: #${colors.itemBackgroundSecondary}; "
    class="ListingVeriticalBigCon3"
  >
    <div class="ListingVeriticalBigCon4">
      <div
        style="background: #${colors.itemBackgroundPrimary};"
        class="ListingVeriticalBigCon5"
      >
        <div style="color: #${colors.itemTextPrimary};" class="ListingVeriticalBigTitle">
          ${data.listingName}
        </div>
      </div>
      <div class="ListingVeriticalBigCon6">
        <div class="ListingVeriticalBigCon7">
          <div class="ListingVeriticalBigCon8">
            <div class="ListingVeriticalBigCon9">
              ${onDiscountTagHtml}
              <div class="ListingVeriticalBigCon9B">
                ${priceDescriptionHtml}
                <div
                  style="color: #${colors.itemTextFour};"
                  class="ListingVeriticalBigPrice"
                >
                  ${showPrice}
                </div>
              </div>
            </div>
            <div
              style="color: #${colors.itemTextFour};"
              class="ListingVeriticalBigCondition"
            >
              ${data.listingCondition}
            </div>
            ${itmesAvailableHtml}
            ${itemMarkedAsHtml}
          </div>
         ${onDiscountTextHtml}
        </div>
        <div
          style="color: #${colors.itemTextSecondary};"
          class="ListingVeriticalBigDescription"
        >
          ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._shortenText(data.listingDescription, 20)}
        </div>
      </div>
    </div>
    <div class="ListingVeriticalBigCon12">
      <div class="ListingDisplayBigDateCon">
        <p
          class="ListingDisplayBigDateText"
        >
          ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.updatedAt)}
        </p>
      </div>
      <div class="ListingMiniVeriticalBigCon12">
        <div
          class="ListingDisplayBigViewsText"
        >
          ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.listingViews)}
        </div>
          <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($22464c49e0ce4777$exports))}" />
      </div>
      <div class="listingveriticalcon1b">
        <div class="listingveriticaltext1b">Ver art\xedculo</div>
        <div class="listingveriticalcon1b">
          <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($769f628d53a18151$exports))}" />
        </div>
      </div>
    </div>
  </div>
</div>

    `;
    }
}
var $64185892d2bdb50b$export$2e2bcd8739ae039 = new $64185892d2bdb50b$var$GenarateHtml();






class $f512c4c2fe359fda$var$generateHtml {
    // <div class="promotedItemViewMiniText4">Ver Producto</div>
    _generateItem(data, rawData) {
        console.log(data, rawData);
        let platformClass1 = '';
        let platformClass2 = '';
        let platformClass3 = '';
        let platformClass4 = '';
        let platformClass5 = '';
        let platformClass6 = '';
        let platformClass7 = '';
        let platformClass8 = '';
        let platformLabelText = '';
        if (data.platform === 'mercado-libre') {
            platformClass1 = 'platformClass1MercadoLibre';
            platformClass2 = 'platformClass2MercadoLibre';
            platformClass3 = 'platformClass3MercadoLibre';
            platformClass4 = 'platformClass4MercadoLibre';
            platformClass5 = 'platformClass5MercadoLibre';
            platformClass6 = 'platformClass6MercadoLibre';
            platformClass7 = 'platformClass7MercadoLibre';
            platformClass8 = 'platformClass8MercadoLibre';
            platformLabelText = 'Mercado Libre';
        }
        if (data.platform === 'amazon') {
            platformClass1 = 'platformClass1Amazon';
            platformClass2 = 'platformClass2Amazon';
            platformClass3 = 'platformClass3Amazon';
            platformClass4 = 'platformClass4Amazon';
            platformClass5 = 'platformClass5Amazon';
            platformClass6 = 'platformClass6Amazon';
            platformClass7 = 'platformClass7Amazon';
            platformClass8 = 'platformClass8Amazon';
            platformLabelText = 'Amazon';
        }
        let buttonLabel = 'Ver producto';
        if (rawData.buttonLabel) buttonLabel = rawData.buttonLabel;
        return `
        

<div class="promotedItemViewMiniCon1 ${platformClass1}" data-openurl="${data.url}">
  <div class="promotedItemViewMiniCon2">
    <div class="promotedItemViewMiniCon3">
        <div class="promotedItemViewMiniCon4">
            <img src="${data.image}" alt="Producto Mercado Libre">
        </div>
        <div class="promotedItemViewMiniCon5 ${platformClass2}">
            <div class="promotedItemViewMiniText1 ${platformClass3}">${platformLabelText}</div>
        </div>
    </div>
  </div>
  <div class="promotedItemViewMiniCon6">
    <div class="promotedItemViewMiniCon7 ${platformClass4}">
      <div class="promotedItemViewMiniText2 ${platformClass5}">${data.title}</div>
      <div class="promotedItemViewMiniCon8">
        <div class="promotedItemViewMiniText3 ${platformClass6}">${data.description}</div>
      </div>
    </div>
    <div class="promotedItemViewMiniCon9">
        <div
            class="promotedItemViewMiniCon10 ${platformClass7} promotedItemViewMiniText4 ${platformClass8}"
            >
            ${buttonLabel}
        </div>
    </div>
  </div>
</div>



  


  
        
        
        
        `;
    }
    _generateSkeleton(id) {
        return `
<div id="${id}" class="promotedItemSkeleton">

    <div class="skeletonImage shimmer"></div>

    <div class="skeletonText shimmer"></div>
    <div class="skeletonTextSmall shimmer"></div>

    <div class="skeletonButton shimmer"></div>

</div>
`;
    }
}
var $f512c4c2fe359fda$export$2e2bcd8739ae039 = new $f512c4c2fe359fda$var$generateHtml();


var $8cdc32ca8f61c6ec$exports = {};
$8cdc32ca8f61c6ec$exports = new URL("saved.6090072f.png", import.meta.url).toString();


var $d3e6cf0f8d8bf945$exports = {};
$d3e6cf0f8d8bf945$exports = new URL("liked.a4a46fbd.png", import.meta.url).toString();


var $282489a792f3e6e6$exports = {};
$282489a792f3e6e6$exports = new URL("save.9bceaacc.png", import.meta.url).toString();


var $86cbc6500278ca92$exports = {};
$86cbc6500278ca92$exports = new URL("menu-up.0ab625d1.png", import.meta.url).toString();


var $d3332e1704519a30$exports = {};
$d3332e1704519a30$exports = new URL("menu-down.75ceb4ba.png", import.meta.url).toString();


var $22804ceefbfec0a6$exports = {};
$22804ceefbfec0a6$exports = new URL("exit.e166631f.png", import.meta.url).toString();


var $d96af719fcf1f083$exports = {};
$d96af719fcf1f083$exports = new URL("back-arrow.c9796fe3.png", import.meta.url).toString();



var $ee74abca297c63cc$exports = {};
$ee74abca297c63cc$exports = new URL("like.cd818b16.png", import.meta.url).toString();




var $51f5827f0e2cef3f$exports = {};
$51f5827f0e2cef3f$exports = new URL("back.7314e22c.png", import.meta.url).toString();



var $56917d2328dcfbde$exports = {};
$56917d2328dcfbde$exports = new URL("ahead.ea3381bf.png", import.meta.url).toString();


var $c56f3ea79eeaee78$exports = {};
$c56f3ea79eeaee78$exports = new URL("like.7826fa21.png", import.meta.url).toString();





var $54520949b970bb70$exports = {};
$54520949b970bb70$exports = new URL("share.b19a65a9.png", import.meta.url).toString();


var $f686cfdff2f307c7$exports = {};
$f686cfdff2f307c7$exports = new URL("call.08ff8926.png", import.meta.url).toString();


var $4ecd2677925c6ea6$exports = {};
$4ecd2677925c6ea6$exports = new URL("whatsapp.baf17bef.png", import.meta.url).toString();




var $48b57b26aaf6c3c1$exports = {};
$48b57b26aaf6c3c1$exports = new URL("location.9725f23b.png", import.meta.url).toString();


var $64af874227dfbcd8$exports = {};
$64af874227dfbcd8$exports = new URL("whatsapp.5e5c7f7c.png", import.meta.url).toString();



var $d4f97493ec4bc5db$exports = {};
$d4f97493ec4bc5db$exports = new URL("call.c413939f.png", import.meta.url).toString();



var $b83bf9f7282ed2ae$exports = {};
$b83bf9f7282ed2ae$exports = new URL("share.b16f1889.png", import.meta.url).toString();


var $bea62215618c37fd$exports = {};
$bea62215618c37fd$exports = new URL("save.ade9a3f6.png", import.meta.url).toString();


var $7020d75361e719ac$exports = {};
$7020d75361e719ac$exports = new URL("saved.8e45c39d.png", import.meta.url).toString();


var $4f135521ed49efb5$exports = {};
$4f135521ed49efb5$exports = new URL("more-menu.fbdc8beb.png", import.meta.url).toString();


var $54f80ec6c63d9279$exports = {};
$54f80ec6c63d9279$exports = new URL("info.bdca5780.png", import.meta.url).toString();


var $84526e9d741e9aac$exports = {};
$84526e9d741e9aac$exports = new URL("dots menu.6d664b85.png", import.meta.url).toString();


var $0a4c20255f61e245$exports = {};
$0a4c20255f61e245$exports = new URL("save.0c9daa86.png", import.meta.url).toString();


var $5cf7715425f15f40$exports = {};
$5cf7715425f15f40$exports = new URL("saved.d13d7368.png", import.meta.url).toString();


var $861825bbf8ef5bfc$exports = {};
$861825bbf8ef5bfc$exports = new URL("share.d9b645b5.png", import.meta.url).toString();


var $c5448bc06c6d8f10$exports = {};
$c5448bc06c6d8f10$exports = new URL("dots menu.8709da27.png", import.meta.url).toString();


var $8f28592c94f0050d$exports = {};
$8f28592c94f0050d$exports = new URL("save.c0ea6997.png", import.meta.url).toString();


var $11e00ae57e007b61$exports = {};
$11e00ae57e007b61$exports = new URL("saved.df78b418.png", import.meta.url).toString();


var $2cb6983923666ed7$exports = {};
$2cb6983923666ed7$exports = new URL("share.d89865a6.png", import.meta.url).toString();


var $eb2532c928e31866$exports = {};
$eb2532c928e31866$exports = new URL("like.9a14a95a.png", import.meta.url).toString();


var $7c1061807835b7b3$exports = {};
$7c1061807835b7b3$exports = new URL("view.f8357666.png", import.meta.url).toString();


var $4944faf5c3a87c23$exports = {};
$4944faf5c3a87c23$exports = new URL("back.096bcf77.png", import.meta.url).toString();


var $ac3abc5c3e0decae$exports = {};
$ac3abc5c3e0decae$exports = new URL("call.5d4ff92d.png", import.meta.url).toString();


var $070672480c5f4a25$exports = {};
$070672480c5f4a25$exports = new URL("whatsApp.7f42d2c3.png", import.meta.url).toString();




function $85ab628818b272fa$export$fa06d3374ad502c3(string) {
    const shiftAmount = 5; // Define how much to shift each character by
    let encodedString = "";
    for(let i = 0; i < string.length; i++){
        let charCode = string.charCodeAt(i); // Get character code of each character
        let shiftedCharCode = charCode + shiftAmount; // Shift the character by the shiftAmount
        encodedString += String.fromCharCode(shiftedCharCode); // Convert back to a character and append it to the result
    }
    return encodedString;
}
function $85ab628818b272fa$export$b83d27db6578b2d4(encodedString) {
    const shiftAmount = 5; // Same shift as used in encoding
    let decodedString = "";
    for(let i = 0; i < encodedString.length; i++){
        let charCode = encodedString.charCodeAt(i); // Get character code of each character
        let shiftedCharCode = charCode - shiftAmount; // Reverse the shift by subtracting the shiftAmount
        decodedString += String.fromCharCode(shiftedCharCode); // Convert back to character and append to result
    }
    return decodedString;
}



class $747dcf33e8614cd4$var$HandlenAccount {
    #accountState;
    constructor(){}
    async _accountInit() {
        const localKey = (0, $85ab628818b272fa$export$fa06d3374ad502c3)("accountId");
        const data = localStorage.getItem(localKey);
        if (!data) return null;
        const accountId = (0, $85ab628818b272fa$export$b83d27db6578b2d4)(data);
        const accountData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAccountDataById(accountId);
        this.#accountState = accountData;
    }
    async _getAccountState() {
        await this._accountInit();
        return this.#accountState;
    }
    _getLocalAccountState() {
        return this.#accountState;
    }
}
var $747dcf33e8614cd4$export$2e2bcd8739ae039 = new $747dcf33e8614cd4$var$HandlenAccount();



class $17669737d3cc7ae6$var$GenerateHtml {
    _generateBusinessRewiewStars(number, numberOfRewviews) {
        let starHtml = ``;
        const stars = Math.round(number);
        if (stars === 0) starHtml += `<img style="height: 10px;" src="${0, (/*@__PURE__*/$parcel$interopDefault($64337d4b31a692ba$exports))}" alt="">`;
        else for(let i = 0; i < stars; i++)starHtml += `<img style="height: 10px;" src="${0, (/*@__PURE__*/$parcel$interopDefault($64337d4b31a692ba$exports))}" alt="">`;
        return `<div class="RatingStarCon1">
        <div class="RatingStarCon2">
          <div class="RatingStarRatedAtNumber">
            ${number}
          </div>
          <div class="RatingStarCon3">
            ${starHtml}
          </div>
        </div>
      </div>`;
    }
    _returnVideoPlayerForCreateListing(video, id) {
        let idToUse = id || "";
        function isYouTubeUrl(url) {
            // Match 'youtube.com', 'youtu.be', or 'youtube.com/shorts/'
            return /^(https?:\/\/)?(www\.)?(youtube\.com\/|youtu\.be\/|youtube\.com\/shorts\/)/.test(url);
        }
        function extractYouTubeId(url) {
            let match;
            // Handle Shorts URLs
            if (/youtube\.com\/shorts\/(.+)$/.test(url)) match = url.match(/youtube\.com\/shorts\/([^?&]+)/);
            else {
                // Handle regular YouTube URLs
                const ytRegex = /(?:youtube\.com\/.*v=|youtu\.be\/)([^&?#]+)/;
                match = url.match(ytRegex);
            }
            return match ? match[1] : null;
        }
        if (!video) return;
        if (isYouTubeUrl(video)) {
            const videoId = extractYouTubeId(video);
            if (videoId) return `
          <div id="${idToUse}" class="floating-video">
            <iframe 
              src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0" 
              frameborder="0" 
              allow="autoplay; encrypted-media" 
              allowfullscreen 
              style="width: 100%; height: 180px; border-radius: 10px 10px 0 0;"
            ></iframe>
            <div class="drag-handle" title="Drag me">
              <span class="drag-icon">&#x2630;</span>
              <button class="close-btn" title="Close video">&times;</button>
            </div>
          </div>
        `;
            else {
                if (id) alert("URL de YouTube inv\xe1lida");
                return;
            }
        } else {
            // For non-YouTube URLs, check if it is a valid video URL
            const tempVideo = document.createElement("video");
            tempVideo.src = video;
            tempVideo.preload = "metadata";
            return new Promise((resolve)=>{
                tempVideo.onerror = ()=>{
                    if (id) alert("El video no se pudo cargar. Verifica la URL.");
                    resolve("ERROR");
                };
                tempVideo.onloadedmetadata = ()=>{
                    const videoHTML = `
            <div class="floating-video">
              <video controls preload="metadata" autoplay muted>
                <source src="${video}" type="video/mp4">
              </video>
              <div class="drag-handle" title="Drag me">
                <span class="drag-icon">&#x2630;</span>
                <button class="close-btn" title="Close video">&times;</button>
              </div>
            </div>
          `;
                    resolve(videoHTML);
                };
            });
        }
    }
    _returnVideoPlayer(video, id) {
        console.log(video);
        if (!video || video.length < 1) return "";
        function isYouTubeUrl(url) {
            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(url);
        }
        function extractYouTubeId(url) {
            // Handles normal, youtu.be, and shorts links
            const ytRegex = /(?:youtube\.com\/.*v=|youtu\.be\/|youtube\.com\/shorts\/)([^&?#]+)/;
            const match = url.match(ytRegex);
            return match ? match[1] : null;
        }
        let videoHTML = ``;
        if (video) {
            if (isYouTubeUrl(video)) {
                const videoId = extractYouTubeId(video);
                if (videoId) videoHTML = `
      <div id="${id}" class="floating-video">
        <iframe 
          src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0" 
          frameborder="0" 
          allow="autoplay; encrypted-media" 
          allowfullscreen 
          style="width: 100%; height: 180px; border-radius: 10px 10px 0 0;"
        ></iframe>
        <div class="drag-handle" title="Drag me">
          <span class="drag-icon">&#x2630;</span>
          <button class="close-btn" title="Close video">&times;</button>
        </div>
      </div>
          `;
                else videoHTML = `<p>URL de YouTube inv\xe1lida</p>`;
            } else videoHTML = `
      <div class="floating-video">
        <video controls preload="metadata" autoplay muted>
          <source src="${video}" type="video/mp4">
        </video>
        <div class="drag-handle" title="Drag me">
          <span class="drag-icon">&#x2630;</span>
          <button class="close-btn" title="Close video">&times;</button>
        </div>
      </div>
        `;
        }
        return videoHTML;
    }
    _pickClosestClass(width, height) {
        if (!width || !height) return "aspectRatio_16-9"; // fallback
        const actual = width / height;
        let closest = null;
        let bestDiff = Infinity;
        for (const [cls, ratio] of Object.entries(RATIO_MAP)){
            const diff = Math.abs(actual - ratio);
            if (diff < bestDiff) {
                bestDiff = diff;
                closest = cls;
            }
        }
        return closest;
    }
    async _getClosestAspectRatioClass(url, { crossOrigin: crossOrigin = null } = {}) {
        try {
            const img = new Image();
            if (crossOrigin) img.crossOrigin = crossOrigin; // optional: "anonymous"
            img.src = url;
            // If decode() is supported, use it (returns a Promise)
            if (img.decode) // If the image hasn't started loading yet, ensure src is set before decode (we did).
            await img.decode();
            else // fallback to onload
            await new Promise((resolve, reject)=>{
                img.onload = ()=>resolve();
                img.onerror = ()=>reject(new Error("Image load error"));
            });
            return this._pickClosestClass(img.naturalWidth, img.naturalHeight);
        } catch (err) {
            // failed to load or decode — return fallback
            console.warn("getClosestAspectRatioClassFromUrl failed:", err);
            return "aspectRatio_16-9";
        }
    }
    _imageDisplayer(imgArr, video, metaData, rationClass, origImg, editRight) {
        console.log(origImg);
        let html = ``;
        let allImgsHtml = ``;
        let videoHtml = ``;
        console.log(imgArr);
        imgArr.forEach((img, i)=>{
            console.log(img);
            let backgroundImg = ``;
            html += `
        <div class="nvImgDisplayerListingEachCon2 ${rationClass} ImgForBigDisplayParentCon">
        ${backgroundImg}
        <img class="nvImgDisplayerListingEachCon2Img ImgForBigDisplay" src="${img.res_500 ?? img}">
        </div>
      `;
            let actClass = "";
            if (i < 1) actClass = "nvImgDisplayerListingEachCon3ACT";
            allImgsHtml += `
        <div class="nvImgDisplayerListingEachCon3 ${actClass}">
          <img class="nvImgDisplayerListingEachCon3Img" src="${img.res_200 ?? img}">
        </div>
      `;
        });
        // <img class="nvImgDisplayerListingEachCon2BgB" src="${imgArr[0].res_blurred}">
        let finalHtml = `
    ${this._returnVideoPlayer(video)}
      <div data-origimg="${origImg.join("\xb0-\xb0|\xb0-\xb0?\xb0-\xb0|\xb0-\xb0")}" class="nvImgDisplayerListingEachCon1B hasOriginalImages">

        
        <div class="nvImgDisplayerListingEachCon1">
          ${html}
        </div>
        <div class="nvImgDisplayerListingEachCon5">
          ${allImgsHtml}
        </div>  

        <div class="nvImgDisplayerListingEachCon6">
          <div id="btnActionListingOptions" class="nvImgDisplayerListingEachCon7 returnForActionOpenForDisplay openListingEditOptionsGlobal" style="display: ${editRight ? 'flex' : 'none'};">
            <img height="4" src="${(0, (/*@__PURE__*/$parcel$interopDefault($84526e9d741e9aac$exports)))}"/>
          </div>
          ${metaData.saveButton}
          <div id="btnActionListingShare" class="nvImgDisplayerListingEachCon7">
            <img height="16" src="${(0, (/*@__PURE__*/$parcel$interopDefault($861825bbf8ef5bfc$exports)))}"/>
          </div>
        </div>

        <div class="nvImgDisplayerListingEachCon8">
          <div class="nvImgDisplayerListingEachCon9">
            <div class="nvImgDisplayerListingEachCon10">
              <div class="nvImgDisplayerListingEachCon11">
                <div class="nvImgDisplayerListingEachText1">${metaData.views}</div>
                <img height="6px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($7c1061807835b7b3$exports)))}"/>
              </div>
              ${metaData.sharesHtml}
            </div>
            <div class="nvImgDisplayerListingEachText2">${metaData.time}</div>
          </div>
        </div>
  
      </div>
      `;
        return finalHtml;
    }
    _generateListing(dataIn, business, imgUrlsIn, colors, contactInfo, openFrom, fromEdit, rationClass) {
        const data = dataIn.data;
        console.log(data);
        const ads = dataIn.ads;
        let time = "Ayer, 4:23pm";
        if (fromEdit !== "true") time = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.createdAt);
        let listingSharesHTML = ``;
        let SavedHtml = `
            <div id="btnActionListingSave" class="nvImgDisplayerListingEachCon7" style="display: none;">
              <img height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($0a4c20255f61e245$exports)))}"/>
            </div>
          `;
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        const checkIfSaved = (path)=>{
            let saved = false;
            if (account && account.activeSaves) {
                if (account.activeSaves.includes(path)) saved = true;
            }
            if (saved) SavedHtml = `
            <div id="btnActionListingSave" class="nvImgDisplayerListingEachCon7" style="display: none;">
              <img height="20" src="${0, (/*@__PURE__*/$parcel$interopDefault($5cf7715425f15f40$exports))}"/>
            </div>
          `;
        };
        if (account) {
            if (data.businessId) checkIfSaved(`businesses/${data.businessId}/listings/${data.listingId}`);
            else checkIfSaved(`listings/${data.listingId}`);
        }
        if (data.businessId) listingSharesHTML = `
          <div class="nvImgDisplayerListingEachCon11">
            <div class="nvImgDisplayerListingEachText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.listingShares)}</div>
            <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($861825bbf8ef5bfc$exports))}"/>
          </div>
        `;
        // Price
        let priceToUse = "$ preguntar";
        let priceBeforeHtml = ``;
        let onDiscountTagHtml = ``;
        let listingPriceBefore;
        if (data.listingPriceMarkedAs !== "preguntar") priceToUse = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(data.listingPrice, data.listingCoin);
        if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
            if (data.onDiscount.amount > 0) {
                listingPriceBefore = data.onDiscount.finalPrice;
                console.warn(data.onDiscount);
                priceToUse = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(data.onDiscount.finalPrice, data.listingCoin);
                priceBeforeHtml = `
            <div class="nvListingEachText8">Antes</div>
            <div class="nvListingEachText9">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(data.listingPrice, data.listingCoin)}</div>
          `;
                onDiscountTagHtml = `
            <div class="nvListingEachCon8">
              <div class="nvListingEachText3">En oferta ahora ${data.onDiscount.percent}%</div>
            </div>
          `;
            }
        }
        // other
        let locationHtml = "";
        let shareWhat = "";
        if (business) {
            shareWhat = "linstingInBusiness";
            locationHtml = `
          <div class="DisplayListingEachCon13C">
            <img style="height: 20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($48b57b26aaf6c3c1$exports))}" alt="" />
            <a class="DisplayListingEachCon13CText" href="${business.place.locationUrl}">${business.place.name}</a>
          </div>
      `;
        } else if (data.place) locationHtml = `
        <div class="DisplayListingEachCon13C">
          <img style="height: 20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($48b57b26aaf6c3c1$exports))}" alt="" />
          <a class="DisplayListingEachCon13CText" href="${data.place.locationUrl}">${data.place.name}</a>
        </div>
        `;
        //  new
        console.warn(data);
        let itmesAvailableHtml = ``;
        let itemMarkedAsHtml = "";
        // let showPrice = "$ preguntar";
        let priceDescriptionHtml = ``;
        if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
            let textToShow = `${data.listingItemsAvailable} unidades disponibles`;
            if (data.listingItemsAvailable === 1) textToShow = `\xfaltimo disponible`;
            if (data.listingItemsAvailable === 2) textToShow = `solo ${data.listingItemsAvailable} unidades disponibles`;
            itmesAvailableHtml = `
          <div class="nvListingEachText6">\u{2022} ${textToShow}</div>
        `;
        }
        if (data?.listingMarkedAs) itemMarkedAsHtml = `
            <div class="nvListingEachText7">\u{2022} ${data.listingMarkedAs}</div>
        `;
        // if (data.listingPriceMarkedAs !== "preguntar") {
        //   showPrice = GENRALHELPERS._convertToPrice(priceToUse, data.listingCoin);
        // }
        if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) priceDescriptionHtml = `
          <div class="nvListingEachText3B">\u{2022} Precio ${data.listingPriceMarkedAs}</div>
        `;
        let itemConditionHtml = "";
        if (data?.listingCondition) itemConditionHtml = `
          <div class="nvListingEachText5">\u{2022} ${data.listingCondition}</div>
        `;
        let lives = 'seller';
        if (data.businessId) lives = 'business';
        let from = '';
        if (openFrom) from = 'business';
        let imgsUrls = data.listingImgsIds;
        let originalImages = data.listingImgsIds;
        if (data?.listingImgsIds?.[0]?.res_200) {
            let imgs = [];
            let orgImgs = [];
            data.listingImgsIds.forEach((img)=>{
                imgs.push(img.res_500);
                orgImgs.push(img.res_1000 || img.res_500);
            });
            imgsUrls = imgs;
            originalImages = orgImgs;
        }
        let adminNotesHtml = "";
        let editRight = false;
        const generateAdminPrivilegedHtml = ()=>{
            console.log(account);
            if (!account) return;
            if (data?.businessId) {
                function accountHasBusiness(account, businessId) {
                    if (!account || !account.businesses) return false;
                    return account.businesses.some((business)=>business.id === businessId);
                }
                if (!accountHasBusiness(account, data.businessId)) {
                    console.log('here');
                    return;
                }
            } else if (data.sellerId !== account.userId) {
                console.log('here');
                return;
            }
            editRight = true;
            if (data.adminNotes) adminNotesHtml = `
      <div class="nvListingEachAdminNotesCon1">
          <div class="nvListingEachAdminNotesCon3">
            <div class="nvListingEachAdminNotesText1">Notas admin</div>
          </div>
          <div class="nvListingEachAdminNotesCon4">
            <div class="nvListingEachAdminNotesText2">${data.adminNotes}</div>
          </div>
      </div>
    `;
        };
        generateAdminPrivilegedHtml();
        let imagesVideoHTML = this._imageDisplayer(imgsUrls, data.videoUrl, {
            time: time,
            views: (0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.listingViews),
            sharesHtml: listingSharesHTML,
            saveButton: SavedHtml
        }, rationClass, originalImages, editRight);
        const { callNumber: callNumber, whatsAppNumber: whatsAppNumber } = contactInfo;
        console.log(contactInfo);
        let informationTableDisplay = "flex";
        if (!data?.listingMachineType || data?.listingMachineType?.length < 1) {
            console.log('hiding');
            informationTableDisplay = "none";
        }
        console.log(informationTableDisplay);
        console.log(data.listingMachineType);
        return `
          <div data-lives="${lives}"
            data-from="${from}"
            data-listingId="${data.listingId}"
            data-businessId="${data.businessId}"
            data-sellerId="${data.sellerId}"
            data-share="listing" class="nvListingEachCon1A">

            <div class="nvListingEachCon1C">
              <div class="nvListingEachCon1D">

                ${imagesVideoHTML}

                <div class="nvImgDisplayerListingEachCon12 CloseCurrentStackPageButton">
                  <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($8fd602925f160669$exports))}"/>
                </div>



                ${adminNotesHtml}
                <div class="nvListingEachCon1B">
                  <div class="nvListingEachCon1">
                    <div class="nvListingEachText1">${data.listingName}</div>
                  </div>
                  <div class="nvListingEachCon2">
                    <div class="nvListingEachText2">${data.listingDescription}</div>
                  </div>

                  <div class="nvListingEachCon1BC">
                    <div class="nvListingEachCon4">
                      <div class="nvListingEachCon5">
                        <div class="nvListingEachCon6">
                            ${onDiscountTagHtml}
                            <div class="nvListingEachCon7">
                              <div class="nvListingEachText4">${priceToUse}</div>
                            </div>
                        </div>
                      </div>
                      <div class="nvListingEachCon11">
                        ${priceBeforeHtml}
                      </div>
                    </div>



                    <div class="nvListingEachCon9">
                      ${itemConditionHtml}
                      ${itemMarkedAsHtml}
                      ${itmesAvailableHtml}
                      ${priceDescriptionHtml}
                    </div>
                  </div>
                </div>

                
                <div class="nvListingEachCon3" style="display: ${informationTableDisplay}";>

                  <div class="nvListingEachCon18">
                    <div class="nvListingEachCon19">
                      <div class="nvListingEachText15">Informaci\xf3n t\xe9cnica</div>
                    </div>
                    <div class="nvListingEachCon20">
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Categor\xeda</div>
                        <div class="nvListingEachText17">${data.listingMachineType}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Marca</div>
                        <div class="nvListingEachText17">${data.listingBrand}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Modelo</div>
                        <div class="nvListingEachText17">${data.listingModel}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">A\xf1o</div>
                        <div class="nvListingEachText17">${data.listingYear}</div>
                      </div>
                      <div class="nvListingEachCon21">
                        <div class="nvListingEachText16">Condici\xf3n</div>
                        <div class="nvListingEachText17">${data.listingCondition}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="nvListingEachConLocationContainerParent" style="display: none" class="nvListingEachCon3">
                  <div id="nvListingEachConLocationContainer" class="nvListingEachConLocationContainer">
                  </div>


                  <div class="nvListingEachConLocationButtonCon">
                    <div id="nvListingEachConLocationContainerButtonOpenMaps" class="nvListingEachConLocationContainerButtonOpenMaps">Abrir Mapa</div>
                  </div>

                </div>

                ${ads}
              </div>
            </div>



            <div id="nvListingsContactEachCon13C" class="nvListingsContactEachCon13C">
              <div class="nvBusinessContactEachCon13CListingEach">
                <div class="nvBusinessContactEachCon13" style="display: none">
                  <div class="nvBusinessContactEachText10Listing">Ponte en contacto</div>
                  <div class="nvBusinessContactEachCon13B" style="display: none;">
                    <div class="nvBusinessContactEachText10B">@bernardoklassen</div>
                  </div>
                </div>
                <div class="nvBusinessContactEachCon14ListingEach expanded">

                  <a id="btnActionBusinessContactCall" 
                    class="nvBusinessContactEachCon16ListingEach" 
                    href="tel:+${callNumber}">
                    <div class="nvBusinessContactEachText12ListingEach">Llamar</div>
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ac3abc5c3e0decae$exports))}" height="24px" />
                  </a>

                  <div data-whatsappnumber="${whatsAppNumber}" id="btnActionListingContactWhatsApp" class="nvBusinessContactEachCon15ListingEach">
                    <div class="nvBusinessContactEachText11ListingEach">WhatsApp</div>
                    <img height="24px" src="${0, (/*@__PURE__*/$parcel$interopDefault($070672480c5f4a25$exports))}"/>
                  </div>
        
                  <!-- Email button can be added. 'nvBusinessContactEachCon16B' is the button class -->
        
                </div>
                <div class="nvListingEachCon17ListingEach">
                  <div class="nvListingEachText13ListingEach">Resuelve tus dudas,</div>
                  <div class="nvListingEachText14ListingEach">\xa1y hazlo tuyo ya!</div>
                </div>
              </div>
            </div>
          

            <!-- <div class="nvListingEachCon12">
              <div class="nvListingEachCon12B">
                <div class="nvListingEachCon12C">
                </div>
              </div>
              <div class="nvListingEachCon13">
                <div class="nvListingEachText10">Ponte en contacto con el vendedor</div>
              </div>
              <div class="nvListingEachCon14">
                <div id="btnActionListingContactWhatsApp" class="nvListingEachCon15">
                  <div class="nvListingEachText11">WhatsApp</div>
                  <img height=18px" src="${0, (/*@__PURE__*/$parcel$interopDefault($070672480c5f4a25$exports))}"/>
                </div>
                <a id="btnActionListingContactCall" 
                  class="nvListingEachCon16" 
                  href="tel:+52${callNumber}">
                  <div class="nvListingEachText12">Llamar</div>
                  <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ac3abc5c3e0decae$exports))}" height="18px" />
                </a>
              </div>
              <div class="nvListingEachCon17">
                <div class="nvListingEachText13">Resuelve tus dudas,</div>
                <div class="nvListingEachText14">\xa1y hazlo tuyo ya!</div>
              </div>
            </div> --!>
          </div>
    `;
    }
}
var $17669737d3cc7ae6$export$2e2bcd8739ae039 = new $17669737d3cc7ae6$var$GenerateHtml();














var $f44f4aeba8ceba5b$exports = {};
$f44f4aeba8ceba5b$exports = new URL("search.2fd68654.png", import.meta.url).toString();


var $a0224fded362449c$exports = {};
$a0224fded362449c$exports = new URL("dots-menu.14619b3c.png", import.meta.url).toString();


var $da25b6cac10355df$exports = {};
$da25b6cac10355df$exports = new URL("settings.70964329.png", import.meta.url).toString();


var $b537cb8bc2a33dbb$exports = {};
$b537cb8bc2a33dbb$exports = new URL("back-step.46ee5749.png", import.meta.url).toString();




class $3003dd10a1870dc8$var$generateHtml {
    _main() {
        return `
<div id="SavedConMainSavedCon" class="SavedAndFollowingCon1">
    <div class="SavedAndFollowingCon2">
        <div class="SavedAndFollowingCon3">
            <div class="SavedAndFollowingCon4" style="display: none">
                <div class="SavedAndFollowingCon5">
                <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f44f4aeba8ceba5b$exports))}"/>
                <div class="SavedAndFollowingText1">Buscar en guardados</div>
                </div>
                <div class="SavedAndFollowingCon6">
                    <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($a0224fded362449c$exports))}"/>
                </div>
            </div>
            <div class="SavedAndFollowingCon7">
                <div id="SavedConMainSavedButtonSortAll" class="SavedAndFollowingCon8">
                    <div class="SavedAndFollowingText2">Todos</div>
                </div>      
                 <div id="SavedConMainSavedButtonSortBusiness" class="SavedAndFollowingCon8">
                    <div class="SavedAndFollowingText2">Negocios</div>
                </div>
                <div id="SavedConMainSavedButtonSortListings" class="SavedAndFollowingCon8">
                    <div class="SavedAndFollowingText2">Listados</div>
                </div>
            </div>
        </div>
        <div class="SavedAndFollowingCon9B">
        <div id="SavedAndFollowingCon9InsertSaved" class="SavedAndFollowingCon9">
            <div class="SavedAndFollowingConB10">
                <div class="SavedAndFollowingConB11">
                    <div id="SavedAndFollowingTextB10UpateMessage" class="SavedAndFollowingTextB10">Cargando...</div>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>
`;
    }
    async _genDevicesHtml() {
        const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        console.log('userData for devices:', userData);
        if (!userData) return '';
        const registeredDevices = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllDocsFromPathByMostRecent(`accounts/${userData.userId}/fcmTokens`);
        console.log(' devices:', registeredDevices);
        let devicesHtml = ``;
        registeredDevices.forEach((device)=>{
            let name = device.name || '';
            let os = device.os || 'Desconocido';
            let browser = device.browser || 'Desconocido';
            let platform = device.platform || 'Desconocido';
            let registeredAt = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(device.createdAt) || 'Desconocido';
            let lastSeen = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(device.lastSeenAt) || 'Desconocido';
            devicesHtml += `
                <div data-device="${device.token}" class="nvNotiSetingsDeviceCon1">
                    <div class="nvNotiSetingsDeviceCon2">
                        <div class="nvNotiSetingsDeviceCon4">
                        <div class="nvNotiSetingsDeviceText1">Nombre del dispositivo:</div>
                        <input class="nvNotiSetingsDeviceCon5 nvNotiSetingsDeviceText2" type="text" value="${name}"
                            placeholder="Ponle un nombre a tu dispositivo">
                        </div>
                        <div class="nvNotiSetingsDeviceCon4">
                        <div class="nvNotiSetingsDeviceText1">Sistema de operaci\xf3n:</div>
                        <div class="nvNotiSetingsDeviceText3">${os}</div>
                        </div>
                        <div class="nvNotiSetingsDeviceCon4">
                        <div class="nvNotiSetingsDeviceText1">Navegador:</div>
                        <div class="nvNotiSetingsDeviceText3">${browser}</div>
                        </div>
                        <div class="nvNotiSetingsDeviceCon4">
                        <div class="nvNotiSetingsDeviceText1">Plataforma:</div>
                        <div class="nvNotiSetingsDeviceText3">${platform}</div>
                        </div>
                        <div class="nvNotiSetingsDeviceCon4">
                        <div class="nvNotiSetingsDeviceText1">Registrado:</div>
                        <div class="nvNotiSetingsDeviceText3">${registeredAt}</div>
                        </div>
                        <div class="nvNotiSetingsDeviceCon4">
                        <div class="nvNotiSetingsDeviceText1">\xdaltimo visto:</div>
                        <div class="nvNotiSetingsDeviceText3">${lastSeen}</div>
                        </div>
                    </div>
                    <div class="nvNotiSetingsDeviceCon6">
                        <div class="nvNotiSetingsDeviceCon7">
                        <div class="nvNotiSetingsDeviceText4">Eliminar dispositivo</div>
                        </div>
                        <div class="nvNotiSetingsDeviceCon8">
                        <div class="nvNotiSetingsDeviceText4">Guardar cambios</div>
                        </div>
                    </div>
                </div>
            `;
        });
        return devicesHtml;
    }
    async _noti() {
        let blokedCategories = [];
        function arrayIncludes(value) {
            if (!Array.isArray(blokedCategories)) return false;
            return blokedCategories.includes(value);
        }
        const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (userData) {
            const settingsDoc = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${userData.userId}/settings/notificationSettings`);
            if (settingsDoc) blokedCategories = settingsDoc.blockedCategories || [];
        }
        console.log('blokedCategories:', blokedCategories);
        return `
            <div class="NvNotiCon1">

                <div class="nvNotiSelectorMainCon1">
                    <div class="nvNotiSelectorMainCon2">
                        <div class="nvNotiSelectorMainCon3">

                            <!-- 
                            <div class="nvNotiSelectorMainCon4 nvNotiSelectorMainCon4Act">
                                <img class="nvNotiSelectorMainCon5" src="https://placehold.co/30x30">
                                <div class="nvNotiSelectorMainText1">Personales</div>
                            </div>
                           
                            <div class="nvNotiSelectorMainCon4">
                            <img class="nvNotiSelectorMainCon5" src="https://placehold.co/30x30">
                            <div class="nvNotiSelectorMainText1">Canales</div>
                            </div> -->
                        </div>
                        <img id="nvNotiSelectorMainConButtonSettings" height="22px" src="${0, (/*@__PURE__*/$parcel$interopDefault($da25b6cac10355df$exports))}"/>
                    </div>
                </div>
  

                <div class="nvNotiConainerCon1">
                    <div class="nvNotiConainerCatSelectorCon1A">
                        <div id="nvNotiConainerCatSelectorCon1" class="nvNotiConainerCatSelectorCon1">
                            <div data-cat="all" class="nvNotiConainerCatSelectorCon2 nvNotiConainerCatSelectorCon2Act">
                                <div class="nvNotiConainerCatSelectorText1">Todos</div>
                            </div>
                            <div data-cat="important" class="nvNotiConainerCatSelectorCon2">
                                <div class="nvNotiConainerCatSelectorText1">Importantes</div>
                            </div>
                            <div data-cat="promotional" class="nvNotiConainerCatSelectorCon2">
                                <div class="nvNotiConainerCatSelectorText1">Promocionales</div>
                            </div>
                        </div>
                    </div>
                    <div id="NvNotiConForNotificationsScroll" class="nvNotiConainerCon2A">
                        <div id="NvNotiConForNotifications" class="nvNotiConainerCon2"></div>
                    </div>
                </div>




                <div id="nvNotiSetingsConainerMainCon" class="nvNotiSetingsConainerCon1" style="display: none">
                    <div class="nvNotiSetingsConainerCon2">
                        <div class="nvNotiSetingsConainerCon3">
                        <div id="nvNotiSetingsConainerButtonBack" class="nvNotiSetingsConainerCon4 topRightExitButtonOnFullScreenWindow">
                            <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b537cb8bc2a33dbb$exports))}"/>
                        </div>
                        <div class="nvNotiSetingsConainerCon5">
                            <div class="nvNotiSetingsConainerText1A">Ajustes de notificaciones</div>
                        </div>
                        </div>
                    </div>
                    <div class="nvNotiSetingsConainerCon6">
                        <div class="nvNotiSetingsConainerCon7">
                        <div class="nvNotiSetingsConainerCon8">
                            <div class="nvNotiSetingsConainerCon9">
                            <div class="nvNotiSetingsConainerCon10">
                                <div class="nvNotiSetingsConainerText1">Notificar por Categor\xeda</div>
                                <div class="nvNotiSetingsConainerText2">Puedes desactivar las notificaciones por categor\xeda. Los mensajes seguir\xe1n entrando a tu centro de notificaciones, pero no recibir\xe1s alertas por estas las categor\xedas desactivadas.</div>
                            </div>
                            </div>
                            <div class="nvNotiSetingsConainerCon11">

                                <div class="nvNotiSetingsSwitchCon1">
                                    <div class="nvNotiSetingsSwitchCon2">
                                        <div class="nvNotiSetingsSwitchText1">Todas las notificaciones</div>
                                        <div class="nvNotiSetingsSwitchText2">Esto desactiva todas las notificaciones</div>
                                    </div>
                                    <div id="nvNotiSetingsSwitchAll" data-state="${arrayIncludes('all') ? "off" : "on"}" class="nvNotiSetingsSwitchCon3">
                                        <div class="nvNotiSetingsSwitchCon4 ${arrayIncludes('promotional') ? "" : "nvNotiSetingsSwitchCon4Act"}"></div>
                                    </div>
                                </div>
                                <div class="nvNotiSetingsSwitchCon1">
                                    <div class="nvNotiSetingsSwitchCon2">
                                        <div class="nvNotiSetingsSwitchText1">Importantes</div>
                                        <div class="nvNotiSetingsSwitchText2">Te notificamos cuando entra un mensaje con la categor\xeda "importante"</div>
                                    </div>
                                    <div id="nvNotiSetingsSwitchImportant" data-state="${arrayIncludes('important') ? "off" : "on"}" class="nvNotiSetingsSwitchCon3">
                                        <div class="nvNotiSetingsSwitchCon4 ${arrayIncludes('important') ? "" : "nvNotiSetingsSwitchCon4Act"}"></div>
                                    </div>
                                </div>
                                <div class="nvNotiSetingsSwitchCon1">
                                    <div class="nvNotiSetingsSwitchCon2">
                                        <div class="nvNotiSetingsSwitchText1">Promocionales</div>
                                        <div class="nvNotiSetingsSwitchText2">Te notificamos cuando entra un mensaje con la categor\xeda "promocional"</div>
                                    </div>
                                    <div id="nvNotiSetingsSwitchPromotion" data-state="${arrayIncludes('promotional') ? "off" : "on"}" class="nvNotiSetingsSwitchCon3">
                                        <div class="nvNotiSetingsSwitchCon4 ${arrayIncludes('promotional') ? "" : "nvNotiSetingsSwitchCon4Act"}"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="nvNotiSetingsConainerCon12">
                            <div class="nvNotiSetingsConainerCon13">
                            <div class="nvNotiSetingsConainerCon14">
                                <div class="nvNotiSetingsConainerText1">Tus dispositivos</div>
                                <div class="nvNotiSetingsConainerText12">Aqu\xed puedes ver y editar los dispositivos registrados para recibir notificaciones de tu cuenta. Puedes eliminarlo si ya no deseas que un dispositivo sigue recibiendo notificaciones de tu cuenta. Si los eliminas, al abrir la el menu de mensajes en la aplicaci\xf3n de nuevo ser\xe1n registrados otra ves.</div>
                            </div>
                            <div id="nvNotiSetingsContainerCon15" class="nvNotiSetingsContainerCon15">
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                



            </div>
        `;
    }
    _notification(title, subTitle, content, read, buttonLabel, inAppLink, inAppLinkType = '') {
        let activeClass = 'nvNotificationCon2Act';
        let buttonHtml = '';
        if (buttonLabel) buttonHtml = `
                <div class="nvNotificationCon5">
                    <div class="nvNotificationCon6">
                        <div class="nvNotificationText4">${buttonLabel}</div>
                    </div>
                </div>
            `;
        if (read) activeClass = '';
        return `
            <div data-inapplink="${inAppLink}" data-inapplinktype="${inAppLinkType}" class="nvNotificationCon1">
                <div class="nvNotificationCon2 ${activeClass}">
                    <div class="nvNotificationCon3">
                    <div class="nvNotificationText1">${title}</div>
                    <div class="nvNotificationCon4">
                        <div class="nvNotificationText2">${subTitle}</div>
                    </div>
                    </div>
                    <div class="nvNotificationText3">${content}</div>
                    ${buttonHtml}
                </div>
            </div>
        `;
    }
}
var $3003dd10a1870dc8$export$2e2bcd8739ae039 = new $3003dd10a1870dc8$var$generateHtml();





// import firebase from "./firebase"
// import GENRALHELPERS from "./GENRAL-HELPERS"
// import { PushNotifications } from '@capacitor/push-notifications';
// class CTANotifications {
//     #CTANotificationEventsInitialized = false
//     _CTANotificationsOn(hide) {
//         const CTAActivateNotifications = document.getElementById('CTAActivateNotifications')
//         const CTAActivateNotificationsButtonActivate = document.getElementById('CTAActivateNotificationsButtonActivate')
//         const CTAActivateNotificationsButtonClose = document.getElementById('CTAActivateNotificationsButtonClose')
//         if (!hide) {
//             CTAActivateNotifications.style.display = 'flex'
//         } else {
//             CTAActivateNotifications.style.display = 'none'
//         }
//         if (this.#CTANotificationEventsInitialized) return
//         this.#CTANotificationEventsInitialized = true
//         CTAActivateNotificationsButtonActivate.addEventListener('click', () => {
//             this._pushNotificationsActivate()
//             CTAActivateNotifications.style.display = 'none'
//         })
//         CTAActivateNotificationsButtonClose.addEventListener('click', () => {
//             CTAActivateNotifications.style.display = 'none'
//         })
//     }
//     async _pushNotificationsActivate() {
//         async function getSWRegistration() {
//             if (!("serviceWorker" in navigator)) {
//                 throw new Error("Service workers not supported");
//             }
//             // If already controlling → resolves immediately
//             if (navigator.serviceWorker.controller) {
//                 return navigator.serviceWorker.ready;
//             }
//             // Otherwise wait for control change
//             await new Promise((resolve) => {
//                 navigator.serviceWorker.addEventListener(
//                     "controllerchange",
//                     () => resolve(),
//                     { once: true }
//                 );
//             });
//             return navigator.serviceWorker.ready;
//         }
//         console.warn("before SW");
//         const swRegistration = await getSWRegistration();
//         console.warn("SW ready:", swRegistration);
//         const userData = firebase._getLatestCurrentUserData()
//         await firebase._getAndStoreFCMToken('userData.uid', swRegistration);
//     }
//     async _initializePushNotifications() {
//         const status = GENRALHELPERS._getPushNotificationStatus()
//         console.log(status)
//         if (status === 'permission needed') {
//             this._CTANotificationsOn()
//             return
//         }
//         if (status) {
//             this._pushNotificationsActivate()
//         }
//     }
//     // START Native notification
//     async _initNativePush() {
//         // Only run on native
//         if (!window.Capacitor?.isNativePlatform?.()) return;
//         // 🔐 Request permission
//         const permStatus = await PushNotifications.requestPermissions();
//         if (permStatus.receive !== 'granted') {
//             console.warn('Push permission not granted');
//             return;
//         }
//         // 📡 Register device
//         await PushNotifications.register();
//         // 🎟️ Token
//         PushNotifications.addListener('registration', (token) => {
//             console.log('📱 Native FCM Token:', token.value);
//             // 👉 Save SAME as web
//             firebase._savePushToken(token.value);
//         });
//         // ❌ Error
//         PushNotifications.addListener('registrationError', (err) => {
//             console.error('Push registration error:', err);
//         });
//         // 📩 Foreground notification
//         PushNotifications.addListener('pushNotificationReceived', (notification) => {
//             console.log('📩 Foreground push:', notification);
//         });
//         // 👆 User taps notification
//         PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
//             console.log('👆 Notification tapped:', notification);
//             const data = notification.notification.data;
//             if (data?.url) {
//                 openUrls._parseLocateAndDisplay(data.url);
//             }
//         });
//     }
//     // END Native notification
// }
// export default new CTANotifications()



var $gJCIb = parcelRequire("gJCIb");
/// <reference types="@capacitor/cli" />


const $73af3aa28454c31d$export$8f83d3f28eb09744 = (0, $gJCIb.registerPlugin)('PushNotifications', {});






var $d31ff1ddcbead596$exports = {};
$d31ff1ddcbead596$exports = new URL("App-logo.a2cef48f.png", import.meta.url).toString();





var $64c0d04053c4a08a$exports = {};
$64c0d04053c4a08a$exports = new URL("notify.512a36a1.png", import.meta.url).toString();


var $14b20fe7cdfe208b$exports = {};
$14b20fe7cdfe208b$exports = new URL("not-notify.b67cd31e.png", import.meta.url).toString();



var $4d3de6826b8380bb$exports = {};
$4d3de6826b8380bb$exports = new URL("verification-needed.d0c72850.png", import.meta.url).toString();


var $2a38f154661fa80d$exports = {};
$2a38f154661fa80d$exports = new URL("back.498f5ca8.png", import.meta.url).toString();



var $d87a3439daeaf8be$exports = {};
$d87a3439daeaf8be$exports = new URL("B3B3B3.6bd1b99d.png", import.meta.url).toString();




var $9b83b27e2c8bcae5$exports = {};
$9b83b27e2c8bcae5$exports = new URL("call.f4679058.png", import.meta.url).toString();




var $99954c935005cf66$exports = {};
$99954c935005cf66$exports = new URL("add.a157b34f.png", import.meta.url).toString();


var $4ef0f4e56773f3c2$exports = {};
$4ef0f4e56773f3c2$exports = new URL("forward.51d564c6.png", import.meta.url).toString();


var $a6cf5ec4a9366a88$exports = {};
$a6cf5ec4a9366a88$exports = new URL("web.f1a73908.png", import.meta.url).toString();



var $2d20bb190c44a07c$exports = {};
$2d20bb190c44a07c$exports = new URL("whatsApp.bf8839c3.png", import.meta.url).toString();


var $32ce398cf5168d0a$exports = {};
$32ce398cf5168d0a$exports = new URL("location.721705d7.png", import.meta.url).toString();


var $503a9d1d06043e75$exports = {};
$503a9d1d06043e75$exports = new URL("call.8b029bd3.png", import.meta.url).toString();


var $33a57ed0356928fa$exports = {};
$33a57ed0356928fa$exports = new URL("mail.9a3b47e1.png", import.meta.url).toString();


var $8a15873450c017ef$exports = {};
$8a15873450c017ef$exports = new URL("web.1b757557.png", import.meta.url).toString();


var $c5e7b98077df15dd$exports = {};
$c5e7b98077df15dd$exports = new URL("whatsApp.5fedf63c.png", import.meta.url).toString();


var $d63e84a7b45ce4b1$exports = {};
$d63e84a7b45ce4b1$exports = new URL("location.af50194d.png", import.meta.url).toString();


var $7c2528253e3c0c9a$exports = {};
$7c2528253e3c0c9a$exports = new URL("call.bb1be407.png", import.meta.url).toString();


var $1a7ab562016878a9$exports = {};
$1a7ab562016878a9$exports = new URL("mail.92ab1d9b.png", import.meta.url).toString();


var $2cd6380fd5f615cb$exports = {};
$2cd6380fd5f615cb$exports = new URL("website.c94bcfe2.png", import.meta.url).toString();





var $9ac61311daad3145$exports = {};
$9ac61311daad3145$exports = new URL("exit.cbb6d077.png", import.meta.url).toString();







var $c28d7344dc2062af$exports = {};
$c28d7344dc2062af$exports = new URL("notify.6ef54b4b.png", import.meta.url).toString();




var $132c50ca9603833f$exports = {};
$132c50ca9603833f$exports = new URL("exit.6b844ab1.png", import.meta.url).toString();











var $2aa09a61659efca6$exports = {};
$2aa09a61659efca6$exports = new URL("filter.e30f00e2.png", import.meta.url).toString();








var $99a9fd790d04f04b$exports = {};
$99a9fd790d04f04b$exports = new URL("info.3eec2926.png", import.meta.url).toString();




var $c761b37634f7dc73$exports = {};
$c761b37634f7dc73$exports = new URL("add.3e902104.png", import.meta.url).toString();







class $b21bc75fcca6f702$var$GenerateHtml {
    _generateBusinessRewiewStars(number, numberOfRewviews) {
        // TODO need to develop a rating system
        return ``;
    }
    _generateBusiness(data, id) {
        let businessCategoriesHTML = ``;
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        console.log(data);
        if (!data) return;
        let editButtonDisplay = 'none';
        if (account?.businesses?.some((b)=>b.id === data?.businessId)) editButtonDisplay = 'flex';
        function pluralizeEs(word) {
            if (!word) return word;
            const STOP_WORDS = new Set([
                'de',
                'del',
                'con',
                'a',
                'al',
                'en',
                'por',
                'para',
                'sin',
                'y',
                'o',
                'rtk'
            ]);
            const capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
            // handle hyphenated words (pluralize each meaningful part)
            if (word.includes('-')) return word.split('-').map((part)=>{
                const lower = part.toLowerCase();
                // stop words stay lowercase
                if (STOP_WORDS.has(lower)) return lower;
                const plural = pluralizeEs(part);
                return capitalize(plural);
            }).join(' ');
            let result;
            // already plural-ish
            if (word.endsWith('s') || word.endsWith('es')) result = word;
            else if (word.endsWith('z')) result = word.slice(0, -1) + 'ces';
            else if (/[aeiouáéíóú]$/i.test(word)) result = word + 's';
            else result = word + 'es';
            // capitalize single words (unless stop word)
            return STOP_WORDS.has(result.toLowerCase()) ? result.toLowerCase() : capitalize(result);
        }
        const generatBusinessCategories = ()=>{
            console.warn(data.categories);
            function sortByMachineAlphabetically(data) {
                return [
                    ...data
                ].sort((a, b)=>a.machine.localeCompare(b.machine, "es", {
                        sensitivity: "base"
                    }));
            }
            if (data.categories) sortByMachineAlphabetically(data.categories).forEach((cat)=>{
                let tagName = pluralizeEs(cat.machine);
                if (cat.name) tagName = cat.name;
                if (cat) businessCategoriesHTML += `
          <div data-machine="${cat.machine}" class="nvBusinessEachCon21">
            <div class="nvBusinessEachCon21BC">
              ${cat?.image?.res_200?.length ? `<img class="nvBusinessEachCon21Img" src="${cat.image.res_200}" />` : ''}
            </div>
            <div class="nvBusinessEachCon21B">
              <div class="nvBusinessEachText8">${tagName}</div>
              <div class="nvBusinessEachText9">${cat?.number ?? 0}</div>
            </div>
          </div>
      `;
            });
        };
        generatBusinessCategories();
        let SavedHtml = `
            <div id="btnActionBusinessSave" class="nvBusinessOptionsEachCon14" style="display: none;">
              <img height="12" src="${(0, (/*@__PURE__*/$parcel$interopDefault($bea62215618c37fd$exports)))}"/>
              <div class="nvBusinessOptionsEachText14">Guardar</div>
            </div>
          `;
        const checkIfSaved = (path)=>{
            let saved = false;
            if (account && account.activeSaves) {
                if (account.activeSaves.includes(path)) saved = true;
            }
            if (saved) SavedHtml = `
            <div id="btnActionBusinessSave" class="nvBusinessOptionsEachCon14" style="display: none;">
              <img height="12" src="${0, (/*@__PURE__*/$parcel$interopDefault($7020d75361e719ac$exports))}"/>
              <div class="nvBusinessOptionsEachText14">Quitar Guardado</div>
            </div>
          `;
        };
        console.log(account);
        console.log(data.businessId);
        if (account) checkIfSaved(`businesses/${data.businessId}`);
        let profUrl = data.profileImg;
        let backUrl = data.backgroundImg;
        let profUrlOrig = data?.profileImg;
        if (data.images) {
            profUrl = data?.images?.profile[0]?.res_200;
            backUrl = data?.images?.background[0]?.res_500;
            profUrlOrig = data?.images?.profile[0]?.res_1000;
        }
        return `
<div
  data-is="business"
  data-businessid="${data.businessId}"
  class="bussinessDisplayCon1 ActionForShare">

  <div id="nvBusinessEachCon1A" class="nvBusinessEachCon1A">
    <div id="nvBusinessEachCon1B" class="BnvBusinessEachCon1B">



          <div class="BnvBusinessEachCon2 CloseCurrentStackPageButton">
            <div id="BnvBusinessEachCon3" class="BnvBusinessEachCon3">
              <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($8fd602925f160669$exports))}"/>
            </div>
          </div>


      <div class="BnvBusinessEachCon7B">
        <div class="nvBusinessEachConBackCon"></div>
        <img src="${backUrl}" class="nvBusinessEachConBackIMG">
        <div class="BnvBusinessEachCon6C">






          <div class="BnvBusinessEachCon22">
            <div class="BnvImgDisplayerListingEachCon9">
              <div class="nvImgDisplayerListingEachCon10">
                <div class="nvImgDisplayerListingEachCon11">
                  <div class="nvImgDisplayerListingEachText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.views)}</div>
                  <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($7c1061807835b7b3$exports))}"/>
                </div>
                <div class="nvImgDisplayerListingEachCon11">
                  <div class="nvImgDisplayerListingEachText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.shares)}</div>
                  <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($861825bbf8ef5bfc$exports))}"/>
                </div>
              </div>
              <div class="BnvImgDisplayerListingEachText2">desde, ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.createdAt, false)}</div>
            </div>
          </div>
        </div>

        <div class="BnvBusinessEachCon6B">
          <div class="BnvBusinessEachCon6">
            <div class="BnvBusinessEachText2">${data.name}</div>
            <div class="BnvBusinessEachText3">${data.shortDescription}</div>
          </div>

          <div
            data-origimg="${profUrlOrig}"
            class="BnvBusinessEachConProfileIMGCon ActionOpenForDisplay hasOriginalImages">
            <img src="${profUrl}" class="nvBusinessEachConProfileIMG ImgForBigDisplay">
          </div>

          <div class="BnvBusinessEachCon6D1">
            <div id="btnActionBusinessContactShowOptions" class="BnvBusinessEachCon6D2">
              <div class="BnvBusinessEachCon6DText1">Contacto</div>
              <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($4ef0f4e56773f3c2$exports))}"/>
            </div>
            <div id="btnActionBusinessOptionsShowOptions" class="BnvBusinessEachCon6D3">
              <div class="BnvBusinessEachCon6DText2">Mas</div>
              <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($c761b37634f7dc73$exports))}"/>
            </div>
          </div>
        </div>
      </div>

    </div> 


    <div id="bussinessDisplayHeaderCon1A" class="nvBusinessEachCon20A"></div>
    <div id="nvBusinessEachCon20AB" class="nvBusinessEachCon20AB">
      <div class="nvBusinessEachCon20AC">
        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($2aa09a61659efca6$exports))}" height="10px" />
      </div>
      <div id="bussinessDisplayHeaderCon1" class="nvBusinessEachCon20">
        <div id="categorySelectMainConInBusiness" class="nvBusinessEachCon20B">
          <div data-machine="all" class="nvBusinessEachCon21 nvBusinessEachCon21Act">
            <div class="nvBusinessEachCon21BC">

              <img class="nvBusinessEachCon21Img" src="${profUrl}" />

            </div>
            <div class="nvBusinessEachCon21B">
              <div class="nvBusinessEachText8">Todos</div>
              <div class="nvBusinessEachText9">${data?.numberOfListings ?? 0}</div>
            </div>
            <div class="categorySelectMiniCon3"></div>
          </div>      
          ${businessCategoriesHTML}
        </div>
      </div>
    </div>

    <div id="bussinessDisplayInsertListingsCon" class="nvBusinessEachCon19"></div>
  </div>



  <div id="nvBusinessContactEachCon12A" class="nvBusinessContactEachCon12A topRightExitButtonOnFullScreenOverlay" style="display: flex;">
    <div id="nvBusinessContactEachCon12" class="nvBusinessContactEachCon12 nvBusinessContactEachCon12View" style="display: flex;">

      <div class="nvBusinessContactEachCon12B">
        <div class="nvBusinessContactEachCon12C">
        </div>
      </div>

      <div class="nvBusinessContactEachCon13C">
        <div class="nvBusinessContactEachCon13">
          <div class="nvBusinessContactEachText10">Ponte en contacto con nosotros</div>
          <div class="nvBusinessContactEachCon13B" style="display: none;">
            <div class="nvBusinessContactEachText10B">@bernardoklassen</div>
          </div>
        </div>
        <div class="nvBusinessContactEachCon14">
          <div id="btnActionBusinessContactWhatsApp" class="nvBusinessContactEachCon15">
            <div class="nvBusinessContactEachText11">WhatsApp</div>
            <img height=24px" src="${0, (/*@__PURE__*/$parcel$interopDefault($070672480c5f4a25$exports))}"/>
          </div>
          <a id="btnActionBusinessContactCall" 
            class="nvBusinessContactEachCon16" 
            href="tel:+52${data.contacts.call.contact}">
            <div class="nvBusinessContactEachText12">Llamar</div>
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($ac3abc5c3e0decae$exports))}" height="24px" />
          </a>

          <!-- Email button can be added. 'nvBusinessContactEachCon16B' is the button class -->

        </div>
      </div>
      <div class="nvBusinessContactEachCon17">
        <div class="nvBusinessContactEachText13">Siempre listos</div>
        <div class="nvBusinessContactEachText14">para resolver tus dudas</div>
      </div>
    </div>
  </div>



  <div id="nvBusinessOptionsEachCon12A" class="nvBusinessOptionsEachCon12A topRightExitButtonOnFullScreenOverlay" style="display: flex;">
    <div class="nvBusinessOptionsEachCon12">
      <div class="nvBusinessOptionsEachCon13">
        <div class="nvBusinessOptionsEachCon13B">
          <div id="btnActionBusinessInfo"  class="nvBusinessOptionsEachCon14">
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($54f80ec6c63d9279$exports))}" height="12px" />
            <div class="nvBusinessOptionsEachText14">Info</div>
          </div>

          ${SavedHtml}
          
          <div id="btnActionBusinessShare" class="nvBusinessOptionsEachCon14">
            <img height="16" src="${0, (/*@__PURE__*/$parcel$interopDefault($b83bf9f7282ed2ae$exports))}"/>
            <div class="nvBusinessOptionsEachText14">Compartir</div>
          </div>
        </div>

        <div class="nvBusinessOptionsEachCon13B" style="display: ${editButtonDisplay}">
          <div id="btnActionBusinessEdit" class="nvBusinessOptionsEachCon14" style="display: ${editButtonDisplay}">
            <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($c6666896698d7a3e$exports))}"/>
            <div class="nvBusinessOptionsEachText15">Editar negocio</div>
          </div>

          <div id="btnActionBusinessDelete" class="nvBusinessOptionsEachCon14" style="display: ${editButtonDisplay}">
            <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($0d9d8e55938a3867$exports))}"/>
            <div class="nvBusinessOptionsEachText15B">Eliminar negocio</div>
          </div>
        </div>
      </div>
    </div>
  </div>




  <div id="nvBusinessEachListsOptionsCon12A" class="nvBusinessOptionsEachCon12A topRightExitButtonOnFullScreenOverlay" style="display: flex;">
    <div class="nvBusinessOptionsEachCon12">
      <div class="nvBusinessOptionsEachCon13">
        <div class="nvBusinessOptionsEachCon13B">
          <div id="btnActionBusinessListShare" class="nvBusinessOptionsEachCon14">
            <img height="16" src="${0, (/*@__PURE__*/$parcel$interopDefault($b83bf9f7282ed2ae$exports))}"/>
            <div class="nvBusinessOptionsEachText14">Compartir Lista</div>
          </div>
        </div>

        <div class="nvBusinessOptionsEachCon13B" style="display: ${editButtonDisplay}">
          <div id="btnActionBusinessListEdit" class="nvBusinessOptionsEachCon14" style="display: ${editButtonDisplay}">
            <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($c6666896698d7a3e$exports))}"/>
            <div class="nvBusinessOptionsEachText15">Editar Lista</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="nvBusinessInfoEachCon12A" class="nvBusinessInfoEachCon12A preventSwipeBack" style="display: none;">
    <div class="nvBusinessInfoEachCon12B">
      <div class="ShareWindowCon2B">
        <div id="businessInfoConForDisplayBtnExit" class="nvBusinessInfoEachCon12C topRightExitButtonOnFullScreenWindow">
          <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($2a38f154661fa80d$exports))}" alt="" />
        </div>
      </div>
    </div>

    ${this._generateInfo(data)}
  </div>
</div>
`;
    }
    // Start GEnerating Business Info
    _generateInfo(businessData) {
        const placeHtml = this._visualizerPopulateBusinessInfoPortion("Lugar", this._visualizerPopulateBusinessInfoPlace(businessData.place));
        const contactHtml = this._visualizerPopulateBusinessInfoPortion("Contacto", this._visualizerPopulateBusinessInfoContact(businessData.contacts));
        const aboutHtml = this._visualizerPopulateBusinessInfoPortion("Acerca de nosotros", this._visualizerPopulateBusinessInfoAbout(businessData.about));
        const finalPortionsHtml = placeHtml + contactHtml + aboutHtml;
        return this._visualizerPopulateBusinessInfoMain(finalPortionsHtml);
    }
    _visualizerPopulateBusinessInfoMain(html) {
        return `
    <div class="BusinessInfoCon3">${html}</div>
    `;
    }
    _visualizerPopulateBusinessInfoPortion(title, html) {
        return ` 
  <div id="BusinessInfoPortionCon1" class="BusinessInfoPortionCon1">
    <div class="BusinessInfoPortionHeaderText">
      ${title}
      </div>
    ${html}
  </div>
    `;
    }
    _visualizerPopulateBusinessInfoPlace(data) {
        return `
  <div class="BusinessInfoPortionLinkCon1">
    <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($d63e84a7b45ce4b1$exports))}" alt="" />
    <a class="BusinessInfoPortionLinkText" 
      href="${data.locationUrl}" 
      target="_blank" 
      rel="noopener noreferrer">
      ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._getDisplayLocationName(data)}
    </a>
  </div>

  <div class="BusinessInfoLocationCon2">
    <div class="BusinessInfoLocationHeaderText">Descripci\xf3n</div>
    <div class="BusinessInfoLocationCon3">
      <div class="BusinessInfoLocationDescriptionText">${data.description}</div>
    </div>
  </div>
    `;
    }
    _visualizerPopulateBusinessInfoContact(data) {
        let contactWays = ""; // Initialize as an empty string to avoid 'undefined'
        if (data.call) contactWays += `
      <a href="tel:+52${data.call.contact}">
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($7c2528253e3c0c9a$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.call.contact}</div>
      </div>
      </a>`;
        if (data.whatsApp) contactWays += `
      <div id="DisplayBusinessEachInfoPortionWahtsApp" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($c5e7b98077df15dd$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.whatsApp.contact}</div>
      </div>`;
        if (data.email) contactWays += `
      <div data-email="${data.email.contact}" id="DsiplayBusinessEachInfoPortionEmail" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1a7ab562016878a9$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.email.contact}</div>
      </div>`;
        if (data.website) contactWays += `
      <a href="${data.website.contact}" target="_blank" rel="noopener noreferrer">
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="10px" src="${0, (/*@__PURE__*/$parcel$interopDefault($2cd6380fd5f615cb$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkText">${data.website.contact}</div>
      </div>
      </a>`;
        return `<div class="BusinessInfoContactCon1">${contactWays}</div>`;
    }
    _visualizerPopulateBusinessInfoAbout(about) {
        return `
  <div id="BusinessInfoAboutCon1" class="BusinessInfoAboutCon1">
    <div class="BusinessInfoAboutText">
      ${about}
    </div>
  </div>
    `;
    }
}
var $b21bc75fcca6f702$export$2e2bcd8739ae039 = new $b21bc75fcca6f702$var$GenerateHtml();













class $5c95fe7382e82beb$var$generateHtml {
    // https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%2F0b4e2dc8-3d4e-497e-a288-dd6721482fe5.jpg?alt=media&token=216fbd18-b042-4fac-87a0-8828c32f107d
    _prepareImageForListing(imgUrl) {
        return `

  <div id="isImageInSharingCon" class="ShareNowListingCon2">
  <img width="100%" src="${imgUrl}" />
  </div>

`;
    }
    _prepareImageForBusiness(imgUrl) {
        return `
  <div id="isImageInSharingCon" class="ShareNowListingCon2">
  <img width="100%" src="${imgUrl}" />
  </div>
    `;
    }
}
var $5c95fe7382e82beb$export$2e2bcd8739ae039 = new $5c95fe7382e82beb$var$generateHtml();


class $dabc90a4270361e7$var$makeCanvas {
    constructor(sourceId, targetId, options = {}){
        this.sourceElement = document.getElementById(sourceId);
        this.targetElement = document.getElementById(targetId);
        this.canvas = document.createElement("canvas");
        this.ctx = this.canvas.getContext("2d");
        // Default options
        this.options = {
            scale: 1,
            wordWrap: false,
            ...options
        };
        this.initCanvas();
        this.renderText();
        this.insertCanvas();
        // Watch for resize events on the source element
        window.addEventListener("resize", ()=>this.updateCanvasSize());
    }
    initCanvas() {
        if (!this.sourceElement || !this.targetElement) return;
        const rect = this.sourceElement.getBoundingClientRect();
        this.canvas.width = rect.width * this.options.scale;
        this.canvas.height = rect.height * this.options.scale;
        this.applyStyles();
    }
    updateCanvasSize() {
        const rect = this.sourceElement.getBoundingClientRect();
        this.canvas.width = rect.width * this.options.scale;
        this.canvas.height = rect.height * this.options.scale;
        this.applyStyles();
        this.renderText(); // Re-render text after resizing
    }
    applyStyles() {
        const styles = window.getComputedStyle(this.sourceElement);
        this.ctx.fillStyle = styles.backgroundColor;
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.strokeStyle = styles.borderColor;
        this.ctx.lineWidth = parseFloat(styles.borderWidth) || 0;
        if (this.ctx.lineWidth > 0) this.ctx.strokeRect(0, 0, this.canvas.width, this.canvas.height);
    }
    renderText() {
        const styles = window.getComputedStyle(this.sourceElement);
        this.ctx.font = `${styles.fontSize} ${styles.fontFamily}`;
        this.ctx.fillStyle = styles.color;
        this.ctx.textBaseline = "top";
        let text = this.sourceElement.innerText.trim();
        const padding = 10;
        const maxWidth = this.canvas.width - padding * 2;
        if (this.options.wordWrap) this.wrapText(text, padding, padding, maxWidth);
        else this.ctx.fillText(text, padding, padding);
    }
    wrapText(text, x, y, maxWidth) {
        const words = text.split(" ");
        let line = "";
        let lineHeight = parseFloat(window.getComputedStyle(this.sourceElement).lineHeight) || 20;
        for(let i = 0; i < words.length; i++){
            let testLine = line + words[i] + " ";
            let testWidth = this.ctx.measureText(testLine).width;
            if (testWidth > maxWidth) {
                this.ctx.fillText(line, x, y);
                line = words[i] + " ";
                y += lineHeight;
            } else line = testLine;
        }
        this.ctx.fillText(line, x, y); // Render the last line
    }
    insertCanvas() {
        if (this.targetElement) this.targetElement.appendChild(this.canvas);
    }
    clearCanvas() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
}
class $dabc90a4270361e7$var$callMakeCanvas {
    _call(sourceId, targetId) {
        // Example usage:
        const canvasCopy = new $dabc90a4270361e7$var$makeCanvas(sourceId, targetId);
        canvasCopy.renderText();
        canvasCopy.insertCanvas();
    }
}
var $dabc90a4270361e7$export$2e2bcd8739ae039 = new $dabc90a4270361e7$var$callMakeCanvas();



const $2fd1c9c04394e5f7$var$BigErrorMainCon = document.getElementById("BigErrorMainCon");
const $2fd1c9c04394e5f7$var$BigErrorTitle = document.getElementById("BigErrorTitle");
const $2fd1c9c04394e5f7$var$BigErrorBody = document.getElementById("BigErrorBody");
const $2fd1c9c04394e5f7$var$BigErrorBtnAcept = document.getElementById("BigErrorBtnAcept");
const $2fd1c9c04394e5f7$var$BigErrorBtnCancel = document.getElementById("BigErrorBtnCancel");
class $2fd1c9c04394e5f7$var$bigError {
    constructor(){
    // this._events();
    }
    _open(title, body, buttonAceptText, buttonAceptAction, buttonCancelText, buttonCancelAction) {
        return new Promise((resolve)=>{
            if (!buttonCancelText) $2fd1c9c04394e5f7$var$BigErrorBtnCancel.style.display = "none";
            else {
                $2fd1c9c04394e5f7$var$BigErrorBtnCancel.style.display = "inline-block";
                $2fd1c9c04394e5f7$var$BigErrorBtnCancel.textContent = buttonCancelText;
            }
            if (!buttonAceptText) $2fd1c9c04394e5f7$var$BigErrorBtnAcept.style.display = "none";
            else {
                $2fd1c9c04394e5f7$var$BigErrorBtnAcept.style.display = "inline-block";
                $2fd1c9c04394e5f7$var$BigErrorBtnAcept.textContent = buttonAceptText;
            }
            $2fd1c9c04394e5f7$var$BigErrorMainCon.style.display = "flex";
            $2fd1c9c04394e5f7$var$BigErrorTitle.textContent = title;
            $2fd1c9c04394e5f7$var$BigErrorBody.textContent = body;
            const onAccept = ()=>{
                this._close();
                resolve(true);
            };
            const onCancel = ()=>{
                this._close();
                resolve(false);
            };
            $2fd1c9c04394e5f7$var$BigErrorBtnAcept.onclick = onAccept;
            $2fd1c9c04394e5f7$var$BigErrorBtnCancel.onclick = onCancel;
        });
    }
    _close() {
        $2fd1c9c04394e5f7$var$BigErrorMainCon.style.display = "none";
    }
}
var $2fd1c9c04394e5f7$export$2e2bcd8739ae039 = new $2fd1c9c04394e5f7$var$bigError();



function $9eb70742a7095e98$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement('base');
    const a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $9eb70742a7095e98$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $9eb70742a7095e98$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $9eb70742a7095e98$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
let $9eb70742a7095e98$var$styleProps = null;
function $9eb70742a7095e98$export$be6bf80faea8d5af(options = {}) {
    if ($9eb70742a7095e98$var$styleProps) return $9eb70742a7095e98$var$styleProps;
    if (options.includeStyleProperties) {
        $9eb70742a7095e98$var$styleProps = options.includeStyleProperties;
        return $9eb70742a7095e98$var$styleProps;
    }
    $9eb70742a7095e98$var$styleProps = $9eb70742a7095e98$export$45b10814cc054894(window.getComputedStyle(document.documentElement));
    return $9eb70742a7095e98$var$styleProps;
}
function $9eb70742a7095e98$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function $9eb70742a7095e98$var$getNodeWidth(node) {
    const leftBorder = $9eb70742a7095e98$var$px(node, 'border-left-width');
    const rightBorder = $9eb70742a7095e98$var$px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function $9eb70742a7095e98$var$getNodeHeight(node) {
    const topBorder = $9eb70742a7095e98$var$px(node, 'border-top-width');
    const bottomBorder = $9eb70742a7095e98$var$px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function $9eb70742a7095e98$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $9eb70742a7095e98$var$getNodeWidth(targetNode);
    const height = options.height || $9eb70742a7095e98$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $9eb70742a7095e98$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $cfae44f0dfdf62c0$exports;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $9eb70742a7095e98$var$canvasDimensionLimit = 16384;
function $9eb70742a7095e98$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $9eb70742a7095e98$var$canvasDimensionLimit || canvas.height > $9eb70742a7095e98$var$canvasDimensionLimit) {
        if (canvas.width > $9eb70742a7095e98$var$canvasDimensionLimit && canvas.height > $9eb70742a7095e98$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.width;
                canvas.width = $9eb70742a7095e98$var$canvasDimensionLimit;
            } else {
                canvas.width *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.height;
                canvas.height = $9eb70742a7095e98$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $9eb70742a7095e98$var$canvasDimensionLimit) {
            canvas.height *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.width;
            canvas.width = $9eb70742a7095e98$var$canvasDimensionLimit;
        } else {
            canvas.width *= $9eb70742a7095e98$var$canvasDimensionLimit / canvas.height;
            canvas.height = $9eb70742a7095e98$var$canvasDimensionLimit;
        }
    }
}
function $9eb70742a7095e98$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(',')[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : 'image/png'
        }));
    });
}
function $9eb70742a7095e98$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            img.decode().then(()=>{
                requestAnimationFrame(()=>resolve(img));
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
async function $9eb70742a7095e98$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $9eb70742a7095e98$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(xmlns, 'svg');
    const foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    foreignObject.setAttribute('width', '100%');
    foreignObject.setAttribute('height', '100%');
    foreignObject.setAttribute('x', '0');
    foreignObject.setAttribute('y', '0');
    foreignObject.setAttribute('externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $9eb70742a7095e98$export$fe77aa9c02de4599(svg);
}
const $9eb70742a7095e98$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $9eb70742a7095e98$export$3a92fc9ec83ef360(nodePrototype, instance);
};


function $f1d3d4da19ace37e$var$formatCSSText(style) {
    const content = style.getPropertyValue('content');
    return `${style.cssText} content: '${content.replace(/'|"/g, '')}';`;
}
function $f1d3d4da19ace37e$var$formatCSSProperties(style, options) {
    return (0, $9eb70742a7095e98$export$be6bf80faea8d5af)(options).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? ' !important' : ''};`;
    }).join(' ');
}
function $f1d3d4da19ace37e$var$getPseudoElementStyle(className, pseudo, style, options) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $f1d3d4da19ace37e$var$formatCSSText(style) : $f1d3d4da19ace37e$var$formatCSSProperties(style, options);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $f1d3d4da19ace37e$var$clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue('content');
    if (content === '' || content === 'none') return;
    const className = (0, $9eb70742a7095e98$export$31b40729666a4ae0)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement('style');
    styleElement.appendChild($f1d3d4da19ace37e$var$getPseudoElementStyle(className, pseudo, style, options));
    clonedNode.appendChild(styleElement);
}
function $f1d3d4da19ace37e$export$8df63687a708ed2e(nativeNode, clonedNode, options) {
    $f1d3d4da19ace37e$var$clonePseudoElement(nativeNode, clonedNode, ':before', options);
    $f1d3d4da19ace37e$var$clonePseudoElement(nativeNode, clonedNode, ':after', options);
}



const $67e830aaea99e7b5$var$WOFF = 'application/font-woff';
const $67e830aaea99e7b5$var$JPEG = 'image/jpeg';
const $67e830aaea99e7b5$var$mimes = {
    woff: $67e830aaea99e7b5$var$WOFF,
    woff2: $67e830aaea99e7b5$var$WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: $67e830aaea99e7b5$var$JPEG,
    jpeg: $67e830aaea99e7b5$var$JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp'
};
function $67e830aaea99e7b5$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function $67e830aaea99e7b5$export$200548c990602f61(url) {
    const extension = $67e830aaea99e7b5$var$getExtension(url).toLowerCase();
    return $67e830aaea99e7b5$var$mimes[extension] || '';
}


function $fd9aaa441bfc2baf$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $fd9aaa441bfc2baf$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $fd9aaa441bfc2baf$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $fd9aaa441bfc2baf$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $fd9aaa441bfc2baf$var$cache = {};
function $fd9aaa441bfc2baf$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, '');
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, '');
    return contentType ? `[${contentType}]${key}` : key;
}
async function $fd9aaa441bfc2baf$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $fd9aaa441bfc2baf$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($fd9aaa441bfc2baf$var$cache[cacheKey] != null) return $fd9aaa441bfc2baf$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
    let dataURL;
    try {
        const content = await $fd9aaa441bfc2baf$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get('Content-Type') || '';
            return $fd9aaa441bfc2baf$var$getContentFromDataUrl(result);
        });
        dataURL = $fd9aaa441bfc2baf$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || '';
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === 'string' ? error : error.message;
        if (msg) console.warn(msg);
    }
    $fd9aaa441bfc2baf$var$cache[cacheKey] = dataURL;
    return dataURL;
}


async function $dc746d806551912c$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === 'data:,') return canvas.cloneNode(false);
    return (0, $9eb70742a7095e98$export$ec664d7487540b)(dataURL);
}
async function $dc746d806551912c$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $9eb70742a7095e98$export$ec664d7487540b)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $67e830aaea99e7b5$export$200548c990602f61)(poster);
    const dataURL = await (0, $fd9aaa441bfc2baf$export$bdf0422c029b202a)(poster, contentType, options);
    return (0, $9eb70742a7095e98$export$ec664d7487540b)(dataURL);
}
async function $dc746d806551912c$var$cloneIFrameElement(iframe, options) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $dc746d806551912c$export$ae8e35ea29ddac22(iframe.contentDocument.body, options, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $dc746d806551912c$var$cloneSingleNode(node, options) {
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(node, HTMLCanvasElement)) return $dc746d806551912c$var$cloneCanvasElement(node);
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(node, HTMLVideoElement)) return $dc746d806551912c$var$cloneVideoElement(node, options);
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(node, HTMLIFrameElement)) return $dc746d806551912c$var$cloneIFrameElement(node, options);
    return node.cloneNode($dc746d806551912c$var$isSVGElement(node));
}
const $dc746d806551912c$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
const $dc746d806551912c$var$isSVGElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === 'SVG';
async function $dc746d806551912c$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    if ($dc746d806551912c$var$isSVGElement(clonedNode)) return clonedNode;
    let children = [];
    if ($dc746d806551912c$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $9eb70742a7095e98$export$45b10814cc054894)(nativeNode.assignedNodes());
    else if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $9eb70742a7095e98$export$45b10814cc054894)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $9eb70742a7095e98$export$45b10814cc054894)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$dc746d806551912c$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $dc746d806551912c$var$cloneCSSStyle(nativeNode, clonedNode, options) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $9eb70742a7095e98$export$be6bf80faea8d5af)(options).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === 'font-size' && value.endsWith('px')) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && name === 'display' && value === 'inline') value = 'block';
        if (name === 'd' && clonedNode.getAttribute('d')) value = `path(${clonedNode.getAttribute('d')})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $dc746d806551912c$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(nativeNode, HTMLInputElement)) clonedNode.setAttribute('value', nativeNode.value);
}
function $dc746d806551912c$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute('value'));
        if (selectedOption) selectedOption.setAttribute('selected', '');
    }
}
function $dc746d806551912c$var$decorate(nativeNode, clonedNode, options) {
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        $dc746d806551912c$var$cloneCSSStyle(nativeNode, clonedNode, options);
        (0, $f1d3d4da19ace37e$export$8df63687a708ed2e)(nativeNode, clonedNode, options);
        $dc746d806551912c$var$cloneInputValue(nativeNode, clonedNode);
        $dc746d806551912c$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $dc746d806551912c$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute('xlink:href');
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $dc746d806551912c$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = 'http://www.w3.org/1999/xhtml';
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('xmlns', ns);
        svg.style.position = 'absolute';
        svg.style.width = '0';
        svg.style.height = '0';
        svg.style.overflow = 'hidden';
        svg.style.display = 'none';
        const defs = document.createElementNS(ns, 'defs');
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $dc746d806551912c$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$dc746d806551912c$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$dc746d806551912c$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$dc746d806551912c$var$decorate(node, clonedNode, options)).then((clonedNode)=>$dc746d806551912c$var$ensureSVGSymbols(clonedNode, options));
}





const $8cc1ee3e9af11276$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $8cc1ee3e9af11276$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $8cc1ee3e9af11276$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $8cc1ee3e9af11276$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, 'g');
}
function $8cc1ee3e9af11276$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($8cc1ee3e9af11276$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $fd9aaa441bfc2baf$export$f8a05efa20ffd5a)(url));
}
async function $8cc1ee3e9af11276$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $9eb70742a7095e98$export$f85c16a6d62f7d63)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $67e830aaea99e7b5$export$200548c990602f61)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $fd9aaa441bfc2baf$export$68336ea1617fa80a)(content, contentType);
        } else dataURL = await (0, $fd9aaa441bfc2baf$export$bdf0422c029b202a)(resolvedURL, contentType, options);
        return cssText.replace($8cc1ee3e9af11276$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $8cc1ee3e9af11276$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($8cc1ee3e9af11276$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $8cc1ee3e9af11276$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return '';
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $8cc1ee3e9af11276$export$7b668369e5eab853(url) {
    return url.search($8cc1ee3e9af11276$var$URL_REGEX) !== -1;
}
async function $8cc1ee3e9af11276$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$8cc1ee3e9af11276$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $8cc1ee3e9af11276$var$filterPreferredFontFormat(cssText, options);
    const urls = $8cc1ee3e9af11276$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$8cc1ee3e9af11276$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}





async function $5938d0f1526f12ac$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $8cc1ee3e9af11276$export$3d88803585cbbc21)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $5938d0f1526f12ac$var$embedBackground(clonedNode, options) {
    await $5938d0f1526f12ac$var$embedProp('background', clonedNode, options) || await $5938d0f1526f12ac$var$embedProp('background-image', clonedNode, options);
    await $5938d0f1526f12ac$var$embedProp('mask', clonedNode, options) || await $5938d0f1526f12ac$var$embedProp('-webkit-mask', clonedNode, options) || await $5938d0f1526f12ac$var$embedProp('mask-image', clonedNode, options) || await $5938d0f1526f12ac$var$embedProp('-webkit-mask-image', clonedNode, options);
}
async function $5938d0f1526f12ac$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $fd9aaa441bfc2baf$export$f8a05efa20ffd5a)(clonedNode.src)) && !((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(clonedNode, SVGImageElement) && !(0, $fd9aaa441bfc2baf$export$f8a05efa20ffd5a)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $fd9aaa441bfc2baf$export$bdf0422c029b202a)(url, (0, $67e830aaea99e7b5$export$200548c990602f61)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = options.onImageErrorHandler ? (...attributes)=>{
            try {
                resolve(options.onImageErrorHandler(...attributes));
            } catch (error) {
                reject(error);
            }
        } : reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === 'lazy') image.loading = 'eager';
        if (isImageElement) {
            clonedNode.srcset = '';
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $5938d0f1526f12ac$var$embedChildren(clonedNode, options) {
    const children = (0, $9eb70742a7095e98$export$45b10814cc054894)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$5938d0f1526f12ac$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $5938d0f1526f12ac$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $9eb70742a7095e98$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        await $5938d0f1526f12ac$var$embedBackground(clonedNode, options);
        await $5938d0f1526f12ac$var$embedImageNode(clonedNode, options);
        await $5938d0f1526f12ac$var$embedChildren(clonedNode, options);
    }
}


function $07c931b022560f33$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}





const $673cafb05cbd0034$var$cssFetchCache = {};
async function $673cafb05cbd0034$var$fetchCSS(url) {
    let cache = $673cafb05cbd0034$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $673cafb05cbd0034$var$cssFetchCache[url] = cache;
    return cache;
}
async function $673cafb05cbd0034$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, '$1');
        if (!url.startsWith('https://')) url = new URL(url, data.url).href;
        return (0, $fd9aaa441bfc2baf$export$c20a8b76c95b0d41)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $673cafb05cbd0034$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $673cafb05cbd0034$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ('cssRules' in sheet) try {
            (0, $9eb70742a7095e98$export$45b10814cc054894)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $673cafb05cbd0034$var$fetchCSS(url).then((metadata)=>$673cafb05cbd0034$var$embedFonts(metadata, options)).then((cssText)=>$673cafb05cbd0034$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith('@import') ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error('Error inserting rule from remote css', {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error('Error loading remote css', e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($673cafb05cbd0034$var$fetchCSS(sheet.href).then((metadata)=>$673cafb05cbd0034$var$embedFonts(metadata, options)).then((cssText)=>$673cafb05cbd0034$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, inline.cssRules.length);
                })).catch((err)=>{
                console.error('Error loading remote stylesheet', err);
            }));
            console.error('Error inlining remote css file', e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ('cssRules' in sheet) try {
                (0, $9eb70742a7095e98$export$45b10814cc054894)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $673cafb05cbd0034$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $8cc1ee3e9af11276$export$7b668369e5eab853)(rule.style.getPropertyValue('src')));
}
async function $673cafb05cbd0034$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error('Provided element is not within a Document');
    const styleSheets = (0, $9eb70742a7095e98$export$45b10814cc054894)(node.ownerDocument.styleSheets);
    const cssRules = await $673cafb05cbd0034$var$getCSSRules(styleSheets, options);
    return $673cafb05cbd0034$var$getWebFontRules(cssRules);
}
function $673cafb05cbd0034$var$normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function $673cafb05cbd0034$var$getUsedFonts(node) {
    const fonts = new Set();
    function traverse(node) {
        const fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach((font)=>{
            fonts.add($673cafb05cbd0034$var$normalizeFontFamily(font));
        });
        Array.from(node.children).forEach((child)=>{
            if (child instanceof HTMLElement) traverse(child);
        });
    }
    traverse(node);
    return fonts;
}
async function $673cafb05cbd0034$export$253c9aa3d83a57b6(node, options) {
    const rules = await $673cafb05cbd0034$var$parseWebFontRules(node, options);
    const usedFonts = $673cafb05cbd0034$var$getUsedFonts(node);
    const cssTexts = await Promise.all(rules.filter((rule)=>usedFonts.has($673cafb05cbd0034$var$normalizeFontFamily(rule.style.fontFamily))).map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $8cc1ee3e9af11276$export$3d88803585cbbc21)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join('\n');
}
async function $673cafb05cbd0034$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $673cafb05cbd0034$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement('style');
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}



async function $8fb130f5e2a07b68$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $9eb70742a7095e98$export$ada5537b2c061996)(node, options);
    const clonedNode = await (0, $dc746d806551912c$export$ae8e35ea29ddac22)(node, options, true);
    await (0, $673cafb05cbd0034$export$2c2c83b77c8cb421)(clonedNode, options);
    await (0, $5938d0f1526f12ac$export$6660fa8dd20e53aa)(clonedNode, options);
    (0, $07c931b022560f33$export$d63a6b7859608045)(clonedNode, options);
    const datauri = await (0, $9eb70742a7095e98$export$b62810fb8ca515fa)(clonedNode, width, height);
    return datauri;
}
async function $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $9eb70742a7095e98$export$ada5537b2c061996)(node, options);
    const svg = await $8fb130f5e2a07b68$export$20d300cb2d558b7(node, options);
    const img = await (0, $9eb70742a7095e98$export$ec664d7487540b)(svg);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const ratio = options.pixelRatio || (0, $9eb70742a7095e98$export$d39ce20a37bba061)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $9eb70742a7095e98$export$c2c809a2fe6b0f1a)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $8fb130f5e2a07b68$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $9eb70742a7095e98$export$ada5537b2c061996)(node, options);
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, width, height).data;
}
async function $8fb130f5e2a07b68$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $8fb130f5e2a07b68$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL('image/jpeg', options.quality || 1);
}
async function $8fb130f5e2a07b68$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $8fb130f5e2a07b68$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $9eb70742a7095e98$export$403d539f215df596)(canvas);
    return blob;
}
async function $8fb130f5e2a07b68$export$92678bad7eef403b(node, options = {}) {
    return (0, $673cafb05cbd0034$export$253c9aa3d83a57b6)(node, options);
}


class $1d5594e9ee7f91eb$var$makeIMG {
    async _init(id, targetId) {
        // const container = document.getElementById(id);
        // const targetContainer = document.getElementById("targetForGeneratedImg");
        // toJpeg(container, { quality: 0.95, useCORS: true }).then((dataUrl) => {
        //   targetContainer.src = dataUrl;
        // });
        const container = document.getElementById(id);
        const images = container.getElementsByTagName("img");
        await Promise.all(Array.from(images).map((img)=>{
            return new Promise((resolve)=>{
                if (img.complete) resolve();
                else img.onload = resolve;
            });
        }));
        (0, $8fb130f5e2a07b68$export$ed218bd2440d33a5)(container, {
            quality: 0.95,
            useCORS: true,
            imageRendering: "pixelated"
        }).then((dataUrl)=>{
            document.getElementById("targetForGeneratedImg").src = dataUrl;
        });
    }
}
var $1d5594e9ee7f91eb$export$2e2bcd8739ae039 = new $1d5594e9ee7f91eb$var$makeIMG();



var $gJCIb = parcelRequire("gJCIb");



const $0793367efc17a8e8$export$c9915453de10000b = (0, $gJCIb.registerPlugin)('Share', {
    web: ()=>(parcelRequire("8o4NC")).then((m)=>new m.ShareWeb())
});



class $dc7988840845b777$var$ShareNow {
    #imgLocalUrlForSharing = null;
    #callGenerateImgNum = 0;
    #customImgEventActivated = false;
    #eventInitialized;
    #abortedNum = 0;
    #isFromBusiness = null;
    #data;
    #what;
    #imageFileForSharing = null;
    constructor(){
        // this._open();
        this.#eventInitialized = false;
    }
    _events() {
        if (this.#eventInitialized) return;
        const ShareWindowBackButton = document.getElementById("ShareWindowBackButton");
        const textarea = document.getElementById("editableTextInShareNowInput");
        textarea.addEventListener("input", function() {
            this.style.height = "auto"; // Reset height to shrink if needed
            this.style.height = this.scrollHeight + "px"; // Expand based on content
        });
        const ShareWindowButtonShareAgain = document.getElementById("ShareWindowButtonShareAgain");
        const ShareWindowButtonCopyLink = document.getElementById("ShareWindowButtonCopyLink");
        ShareWindowButtonCopyLink.addEventListener("click", ()=>{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Copiando texto");
            this._copyToClipboard(this._getCombinedText());
        });
        ShareWindowButtonShareAgain.addEventListener("click", ()=>{
            console.log("clicked here");
            this._shareImageFromContainer();
        });
        ShareWindowBackButton.addEventListener("click", ()=>{
            console.log("clicked here");
            this._close();
        });
        this.#eventInitialized = true;
    }
    _close() {
        const ShareWindowMainCon = document.getElementById("ShareWindowMainCon");
        ShareWindowMainCon.style.display = "none";
    }
    _open(data, what, listName = null) {
        console.log(data, what);
        this.#abortedNum = 0;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Preparando para compartir");
        this.#data = data;
        this.#what = what;
        const ShareWindowMainCon = document.getElementById("ShareWindowMainCon");
        ShareWindowMainCon.style.display = "flex";
        this._prepareImgForShare(0, listName);
        if (this.#eventInitialized) return;
        this._events();
    }
    _handleSelectCustomImgForSharing(imgsArr) {
        const insertAllImagesToSelectFrom = document.getElementById("insertAllImagesToSelectFrom");
        insertAllImagesToSelectFrom.innerHTML = "";
        imgsArr.forEach((img, i)=>{
            let actClass = "";
            if (i < 1) actClass = "shareWindowConB3Act";
            let imgHtml = `<img class="shareWindowImgForCustomSelecting shareWindowConB3 ${actClass}" src="${img.res_200 ?? img}" />`;
            insertAllImagesToSelectFrom.insertAdjacentHTML("beforeend", imgHtml);
        });
        const setImageAndUrl = (i)=>{
            const ShareWindowItemLinkText = document.getElementById("ShareWindowItemLinkText");
            const isImageInSharingCon = document.getElementById("isImageInSharingCon");
            const [link, img] = ShareWindowItemLinkText.textContent.split("&img=");
            isImageInSharingCon.querySelector("img").src = imgsArr[i].res_500 ?? imgsArr[i];
            ShareWindowItemLinkText.textContent = link + `&img=${i}`;
        };
        const events = ()=>{
            this.#customImgEventActivated = true;
            const allImgs = insertAllImagesToSelectFrom.querySelectorAll(".shareWindowImgForCustomSelecting");
            console.log(allImgs);
            allImgs.forEach((img)=>{
                img.addEventListener("click", ()=>{
                    allImgs.forEach((imgSorting, i)=>{
                        imgSorting.classList.remove("shareWindowConB3Act");
                        if (imgSorting === img) {
                            imgSorting.classList.add("shareWindowConB3Act");
                            setImageAndUrl(i);
                        }
                    });
                });
            });
        };
        // if (this.#customImgEventActivated) return;
        events();
    }
    async _prepareImgForShare(useImg = 0, listName) {
        try {
            this.#isFromBusiness = true;
            const isImageInSharingCon = document.getElementById("isImageInSharingCon");
            const textarea = document.getElementById("editableTextInShareNowInput");
            const ShareWindowItemLinkText = document.getElementById("ShareWindowItemLinkText");
            const ShareWindowInLinkTitle = document.getElementById("ShareWindowInLinkTitle");
            const ShareWindowInLinkDescription = document.getElementById("ShareWindowInLinkDescription");
            const ShareWindowItemInstructionsText = document.getElementById("ShareWindowItemInstructionsText");
            const ShareWindowInsertShareImgCon = document.getElementById("ShareWindowInsertShareImgCon");
            const insertAllImagesToSelectFromMainContainer = document.getElementById("insertAllImagesToSelectFromMainContainer");
            if (isImageInSharingCon) isImageInSharingCon.remove();
            if (this.#what === "listing") {
                insertAllImagesToSelectFromMainContainer.style.display = "flex";
                ShareWindowItemLinkText.textContent = this.#data.listingUrl;
                ShareWindowItemInstructionsText.textContent = "Para contactar al vendedor, abre el enlace y toca el bot\xf3n de WhatsApp";
                textarea.value = "Descubre m\xe1s aqu\xed:";
                textarea.style.height = "auto"; // Reset height to shrink if needed
                textarea.style.height = textarea.scrollHeight + "px"; // Expand based on content
                console.log(this.#data);
                let price = "$preguntar";
                let onDiscountText = "";
                if (this.#data.listing?.listingPriceMarkedAs !== "preguntar") {
                    price = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(this.#data.listing.listingPrice, this.#data.listing.listingCoin);
                    console.log(this.#data.listing?.onDiscount?.finalPrice, this.#data.listing.listingPrice);
                    if (this.#data.listing?.onDiscount?.finalPrice !== Number(this.#data.listing.listingPrice)) {
                        price = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertToPrice(this.#data.listing.onDiscount?.finalPrice, this.#data.listing.listingCoin);
                        onDiscountText = "En descuento ahora";
                    }
                }
                const setInLinkText = ()=>{
                    let title = "";
                    let description = "";
                    title = price + " \u2022 " + this.#data.listing.listingName;
                    description = this.#data.listing.listingCondition + " | " + onDiscountText + " | " + this.#data.listing.listingDescription;
                    ShareWindowInLinkTitle.textContent = title;
                    ShareWindowInLinkDescription.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._shortenText(description, 25);
                };
                setInLinkText();
                console.log('218', useImg);
                const imgUrl = this.#data.listing.listingImgsIds[useImg];
                console.log('219', this.#data.listing.listingImgsIds);
                console.log('219', imgUrl);
                // generateHtml._prepareListing();
                const html = (0, $5c95fe7382e82beb$export$2e2bcd8739ae039)._prepareImageForListing(imgUrl.res_500 ?? imgUrl);
                this._handleSelectCustomImgForSharing(this.#data.listing.listingImgsIds);
                ShareWindowInsertShareImgCon.insertAdjacentHTML("beforeend", html);
            } else if (this.#what === "business") {
                insertAllImagesToSelectFromMainContainer.style.display = "none";
                ShareWindowItemLinkText.textContent = this.#data.businessUrl;
                ShareWindowItemInstructionsText.textContent = "Para contactar este negocio, abre el enlace.";
                textarea.value = "Abre este negocio aqu\xed:";
                textarea.style.height = "auto"; // Reset height to shrink if needed
                textarea.style.height = textarea.scrollHeight + "px"; // Expand based on content
                console.log("Should be sharing business now");
                console.log(this.#data);
                this.#imgLocalUrlForSharing = this.#data?.business?.images?.profile?.[0]?.res_500 || this.#data?.business?.images?.profile?.[0]?.res_original || this.#data?.business?.profileImg || '';
                console.log(this.#imgLocalUrlForSharing);
                const html = (0, $5c95fe7382e82beb$export$2e2bcd8739ae039)._prepareImageForBusiness(this.#imgLocalUrlForSharing);
                ShareWindowInsertShareImgCon.insertAdjacentHTML("beforeend", html);
                console.log(this.#data);
                const setInLinkText = ()=>{
                    let title = "";
                    let description = "";
                    title = this.#data.business.name;
                    description = this.#data.business.shortDescription + " | " + this.#data.business.about;
                    ShareWindowInLinkTitle.textContent = title;
                    ShareWindowInLinkDescription.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._shortenText(description, 25);
                };
                setInLinkText();
            } else if (this.#what === "business list") {
                insertAllImagesToSelectFromMainContainer.style.display = "none";
                ShareWindowItemLinkText.textContent = this.#data.businessUrl;
                ShareWindowItemInstructionsText.textContent = "Para ver esta lista, abre el enlace.";
                textarea.value = "Ver lista:";
                textarea.style.height = "auto"; // Reset height to shrink if needed
                textarea.style.height = textarea.scrollHeight + "px"; // Expand based on content
                console.log("Should be sharing business list now", this.#data);
                this.#imgLocalUrlForSharing = this.#data.business.profileImg;
                const html = (0, $5c95fe7382e82beb$export$2e2bcd8739ae039)._prepareImageForBusiness(this.#data.business.categories?.find((cat)=>cat.machine === listName)?.image?.res_500 ?? this.#data.business.profileImg);
                ShareWindowInsertShareImgCon.insertAdjacentHTML("beforeend", html);
                function pluralizeEs(word) {
                    if (!word) return word;
                    const STOP_WORDS = new Set([
                        'de',
                        'del',
                        'con',
                        'a',
                        'al',
                        'en',
                        'por',
                        'para',
                        'sin',
                        'y',
                        'o',
                        'rtk'
                    ]);
                    const capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
                    // handle hyphenated words (pluralize each meaningful part)
                    if (word.includes('-')) return word.split('-').map((part)=>{
                        const lower = part.toLowerCase();
                        // stop words stay lowercase
                        if (STOP_WORDS.has(lower)) return lower;
                        const plural = pluralizeEs(part);
                        return capitalize(plural);
                    }).join(' ');
                    let result;
                    // already plural-ish
                    if (word.endsWith('s') || word.endsWith('es')) result = word;
                    else if (word.endsWith('z')) result = word.slice(0, -1) + 'ces';
                    else if (/[aeiouáéíóú]$/i.test(word)) result = word + 's';
                    else result = word + 'es';
                    // capitalize single words (unless stop word)
                    return STOP_WORDS.has(result.toLowerCase()) ? result.toLowerCase() : capitalize(result);
                }
                console.log(this.#data);
                const setInLinkText = ()=>{
                    let title = "";
                    let description = "";
                    let tag = this.#data.business.categories?.find((cat)=>cat.machine === listName)?.name ?? pluralizeEs(listName);
                    title = this.#data.business.name + " | " + tag;
                    description = `Descubre nuestra lista de '${tag}'`;
                    ShareWindowInLinkTitle.textContent = title;
                    ShareWindowInLinkDescription.textContent = description;
                };
                setInLinkText();
            } else {
                console.error("This image is not for listing sharing");
                insertAllImagesToSelectFromMainContainer.style.display = "none";
            }
        } catch (error) {
            alert(`Here: ${error}`);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            this._shareImageFromContainer();
        }
    }
    _copyToClipboard(text) {
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Copiando texto");
        if (navigator.clipboard) navigator.clipboard.writeText(text).then(()=>{
            console.log("Text copied to clipboard:", text);
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }).catch((err)=>{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            console.error("Failed to copy text:", err);
        });
        else {
            // Fallback for older browsers
            const textarea = document.createElement("textarea");
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                document.execCommand("copy");
                console.log("Text copied to clipboard (fallback):", text);
            } catch (err) {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                console.error("Fallback: Failed to copy text:", err);
            }
            document.body.removeChild(textarea);
        }
    }
    _getCombinedText() {
        // Get the text from the textarea
        const textArea = document.getElementById("editableTextInShareNowInput");
        const textAreaValue = textArea.value.trim(); // Trim removes extra spaces
        // Get the text from the span with class 'link'
        const linkSpan = document.querySelector(".link");
        const linkText = linkSpan ? linkSpan.textContent.trim() : "";
        const instructionsSpan = document.querySelector(".instructions");
        const instructionsText = instructionsSpan ? instructionsSpan.textContent.trim() : "";
        // Combine both texts
        const combinedText = `${textAreaValue} ${linkText} \n \n *${instructionsText}*`;
        console.log(combinedText);
        return combinedText;
    }
    // async _shareImageFromContainer() {
    //   const ShareWindowCon3 = document.getElementById("ShareWindowCon3");
    //   // Start showing the spinner immediately
    //   spinner._displaySpinner("Preparando para compartir");
    //   try {
    //     // Check if sharing is supported
    //     if (navigator.canShare) {
    //       await navigator.share({
    //         title: this._getCombinedText(),
    //       });
    //       console.log("Image shared successfully!");
    //       let dataSendToShare = {
    //         listingId: this.#data.listing.listingId,
    //       };
    //       if (this.#isFromBusiness) {
    //         dataSendToShare = {
    //           listingId: this.#data.listing.listingId,
    //           businessId: this.#data.listing.businessId,
    //         };
    //       }
    //       firebase._updateSharesOnListings(dataSendToShare);
    //     } else {
    //       alert(
    //         "Error. La opción de compartir no está disponible en este dispositivo. Favor de copiar el enlace y pegarlo donde lo quiere compartir."
    //       );
    //     }
    //   } catch (err) {
    //     console.error("Error while sharing the image:", err);
    //     if (err.message && err.message.includes("gesture")) {
    //       alert(
    //         "Porfavor use el botón verde 'Compartir de nuevo' para compartir este articulo."
    //       );
    //       if (ShareWindowCon3) {
    //         GENRALHELPERS._animateCTA("ShareWindowButtonShareAgain");
    //       }
    //     } else if (
    //       err.message &&
    //       err.message.includes("possibly because the user denied permission")
    //     ) {
    //       alert(
    //         "Porfavor use el botón verde 'Compartir de nuevo' para compartir este articulo."
    //       );
    //     } else {
    //       // alert("Este articulo no fué compartido");
    //     }
    //   }finally {
    //     spinner._hideSpinner();
    //   }
    // }
    async _shareImageFromContainer() {
        const ShareWindowCon3 = document.getElementById("ShareWindowCon3");
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Preparando para compartir");
        try {
            const shareData = {
                title: this._getCombinedText(),
                text: this._getCombinedText(),
                url: window.location.href // or your listing URL
            };
            // ✅ 1. Native (Android / iOS via Capacitor)
            if (window.Capacitor?.isNativePlatform?.()) {
                await (0, $0793367efc17a8e8$export$c9915453de10000b).share({
                    title: shareData.title,
                    text: shareData.text,
                    url: shareData.url,
                    dialogTitle: 'Compartir'
                });
                console.log("Shared via native share");
            // ✅ 2. Web Share API (mobile browser)
            } else if (navigator.share) {
                await navigator.share(shareData);
                console.log("Shared via web share");
            // ❌ 3. Fallback
            } else {
                alert("No se puede compartir autom\xe1ticamente. Copia el enlace manualmente.");
                return;
            }
            // ✅ Track share (same as your logic)
            let dataSendToShare = {
                listingId: this.#data.listing.listingId
            };
            if (this.#isFromBusiness) dataSendToShare.businessId = this.#data.listing.businessId;
            (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateSharesOnListings(dataSendToShare);
        } catch (err) {
            console.error("Error while sharing:", err);
            // Same UX handling you already had
            if (err.message?.includes("gesture")) {
                alert("Por favor usa el bot\xf3n 'Compartir de nuevo'.");
                if (ShareWindowCon3) (0, $a082c89adac62edb$export$2e2bcd8739ae039)._animateCTA("ShareWindowButtonShareAgain");
            } else if (err.message?.includes("denied")) alert("Permiso denegado. Intenta nuevamente.");
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
}
var $dc7988840845b777$export$2e2bcd8739ae039 = new $dc7988840845b777$var$ShareNow();










var $1e0a876464f124f6$exports = {};
$1e0a876464f124f6$exports = new URL("edit-list.26af9d21.png", import.meta.url).toString();


var $fb771c59cd73da81$exports = {};
$fb771c59cd73da81$exports = new URL("listed.c155a809.png", import.meta.url).toString();


var $a09862394dab6394$exports = {};
$a09862394dab6394$exports = new URL("whatsApp.a7a56ac6.png", import.meta.url).toString();


var $5ce8e3a6965a117b$exports = {};
$5ce8e3a6965a117b$exports = new URL("call.24411d71.png", import.meta.url).toString();



var $49eddbfc8a0f42b9$exports = {};
$49eddbfc8a0f42b9$exports = new URL("email.5f989814.png", import.meta.url).toString();


var $5954c48d6ce68e0a$exports = {};
$5954c48d6ce68e0a$exports = new URL("website.6f980709.png", import.meta.url).toString();


var $f712e9428771bc05$exports = {};
$f712e9428771bc05$exports = new URL("color.e4c38c84.png", import.meta.url).toString();


var $e21640a4543ad06d$exports = {};
$e21640a4543ad06d$exports = new URL("current-location.51cf0d52.png", import.meta.url).toString();


var $a1958079b1b1bc47$exports = {};
$a1958079b1b1bc47$exports = new URL("target-location.1a58f6dc.png", import.meta.url).toString();










var $92d6f0f713f0d9c5$exports = {};
$92d6f0f713f0d9c5$exports = new URL("exit.63b3f4c5.png", import.meta.url).toString();



var $c77acca88c6c77d2$exports = {};
$c77acca88c6c77d2$exports = new URL("link.2f85be60.png", import.meta.url).toString();






var $e919019ec60aef25$exports = {};
$e919019ec60aef25$exports = new URL("select image on image black.ed513fe9.png", import.meta.url).toString();


var $b0737735bbf9e622$exports = {};
$b0737735bbf9e622$exports = new URL("select image on image.d0dd8996.png", import.meta.url).toString();



var $358890c23dbc74f2$exports = {};
$358890c23dbc74f2$exports = new URL("link 700.c6466bb3.png", import.meta.url).toString();







var $6d252ce60bc0082e$exports = {};
$6d252ce60bc0082e$exports = new URL("location.e6484ec5.png", import.meta.url).toString();


var $9f9fe422c170dfff$exports = {};
$9f9fe422c170dfff$exports = new URL("error.b189abf5.png", import.meta.url).toString();


var $4524bfb9676e1d53$exports = {};
$4524bfb9676e1d53$exports = new URL("map.61fce082.png", import.meta.url).toString();


var $f573e87710da15e3$exports = {};
$f573e87710da15e3$exports = new URL("white frame.a95e6e50.png", import.meta.url).toString();


var $197b964e30a399b9$exports = {};
$197b964e30a399b9$exports = new URL("ahead.7475b1ad.png", import.meta.url).toString();




class $45d8d8fc6a6044af$var$GenerateHtml {
    _NVBusinessEditor(data, edit) {
        console.log(data);
        let dateCreatedAt = "hoy, 6:00 am";
        if (data.createdAt) dateCreatedAt = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.createdAt);
        let name = "Nombre de tu empresa.";
        let shortDescription = "Descripci\xf3n corta de tu empresa";
        let nameForInput = "";
        let shortDescriptionForInput = "";
        let whatsAppNumber = "";
        let callNumber = "";
        let email = "";
        let locationLink = "";
        let locationDescription = "";
        let locationName = "Ubicaci\xf3n no seleccionada";
        let description = "";
        let website = "";
        let profileImgSrc = (0, (/*@__PURE__*/$parcel$interopDefault($f573e87710da15e3$exports)));
        let backgroundImgSrc = (0, (/*@__PURE__*/$parcel$interopDefault($f573e87710da15e3$exports)));
        if (edit) {
            name = data.name;
            nameForInput = data.name;
            shortDescription = data.shortDescription;
            shortDescriptionForInput = data.shortDescription;
            whatsAppNumber = data.contacts.whatsApp.contact;
            callNumber = data.contacts.call.contact;
            email = data.contacts.email.contact;
            locationLink = data.place.locationUrl;
            locationDescription = data.place.description;
            locationName = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getDisplayLocationName(data.place);
            description = data.about;
            profileImgSrc = data.profileImg;
            backgroundImgSrc = data.backgroundImg;
            if (data.contacts.website.contact === "Sitio web") website = "";
            else website = data.contacts.website.contact;
        }
        if (data.images && edit) {
            profileImgSrc = data.images.profile[0].res_200;
            backgroundImgSrc = data.images.background[0].res_500;
        }
        return `
<div id="MainContainerBusinessPageBuild" class="MainContainerBusinessPageBuild">
<input id="nvBusinessEditorImgBackgroundInput" type="file" accept="image/*" style="display: none" />
<input id="nvBusinessEditorImgProfileInput" type="file" accept="image/*" style="display: none" />
  <div class="nvBusinessEditorCon1">
    <div class="nvBusinessEditorCon2">
      <div class="nvBusinessEditorCon3">
        <div class="nvBusinessEditorCon4">
          <div class="nvBusinessEditorText1">Vista previa en el editor</div>
        </div> 
        <div id="nvBusinessEditorButtonClose" class="nvBusinessEditorCon4B">
          <div class="nvBusinessEditorText1B">Cerrar</div>
        </div>
      </div>

      <div id="nvBusinessEachCon1B" class="nvBusinessJustEditorEachCon1B">

        <div class="nvBusinessEachCon7">
          <label for="nvBusinessEditorImgBackgroundInput" class="nvBusinessJustEditorEachConProfileSelect" >
            <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($80ae367ceea82be8$exports))}">
          </label>
          <img id="nvBusinessEditorImgBackground" src="${backgroundImgSrc}" class="nvBusinessJustEditorEachConBackIMG uploadSpecific">
          <div class="nvBusinessJustEditorEachConBackCon"></div>




          <div class="nvBusinessJustEditorEachCon6B">
            <div class="nvBusinessJustEditorEachCon6">
              <div id="nvBusinessEditorShowName" class="nvBusinessJustEditorEachText2">${name}</div>
              <div id="nvBusinessEditorShowShortDescription" class="nvBusinessJustEditorEachText3">${shortDescription}</div>
            </div>

            <div class="nvBusinessJustEditorEachConProfileIMGCon">
              <label for="nvBusinessEditorImgProfileInput" class="nvBusinessJustEditorEachConProfileSelect2">
                <img height="15px" src="${0, (/*@__PURE__*/$parcel$interopDefault($80ae367ceea82be8$exports))}">
              </label>
              <img id="nvBusinessEditorImgProfile" src="${profileImgSrc}" class="nvBusinessJustEditorEachConProfileIMG uploadSpecific">
            </div>

            <div class="nvBusinessJustEditorEachCon6D1">
              <div class="nvBusinessJustEditorEachCon6D2">
                <div class="nvBusinessJustEditorEachCon6DText1">Contacto</div>
                <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($4ef0f4e56773f3c2$exports))}"/>
              </div>
              <div class="nvBusinessJustEditorEachCon6D3">
                <div class="nvBusinessJustEditorEachCon6DText2">Mas</div>
                <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($d9126ea873ff0a97$exports))}"/>
              </div>
            </div>
          </div>
  
          <!-- 
          <div class="nvBusinessEachCon22">
            <div class="nvImgDisplayerListingEachCon9">
              <div class="nvImgDisplayerListingEachCon10">
                <div class="nvImgDisplayerListingEachCon11">
                  <div class="nvImgDisplayerListingEachText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.views)}</div>
                  <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($7c1061807835b7b3$exports))}"/>
                </div>
                <div class="nvImgDisplayerListingEachCon11">
                  <div class="nvImgDisplayerListingEachText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.shares)}</div>
                  <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($861825bbf8ef5bfc$exports))}"/>
                </div>
              </div>
              <div class="nvImgDisplayerListingEachText2">desde, ${dateCreatedAt}</div>
            </div>
          </div>
          -->



        </div>
      </div> 

    </div>

    <div class="nvBusinessEditorCon5">
      <div class="nvBusinessEditorCon6">
        <div class="nvBusinessEditorCon7">
          <div class="nvBusinessEditorText2">Pasos para completar</div>
          <div id="nvBusinessEditorCon8" class="nvBusinessEditorCon8">
            <div data-step="Nombre" class="nvBusinessEditorCon9 nvBusinessEditorCon9Act">
              <div data-status="completed" class="nvBusinessEditorCon9B" style="display: none">
                <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($02cb795988e665a0$exports))}"/>
              </div>
              <div data-status="error" class="nvBusinessEditorCon9B" style="display: none">
                <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($9f9fe422c170dfff$exports))}"/>
              </div>
              <div class="nvBusinessEditorText3 nvBusinessEditorText3Act">Nombre</div>
            </div>
            <div data-step="Fotos" class="nvBusinessEditorCon9">
              <div data-status="completed" class="nvBusinessEditorCon9B" style="display: none">
                <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($02cb795988e665a0$exports))}"/>
              </div>
              <div data-status="error" class="nvBusinessEditorCon9B" style="display: none">
                <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($9f9fe422c170dfff$exports))}"/>
              </div>
              <div class="nvBusinessEditorText3">Fotos</div>
            </div>
            <div data-step="Contacto" class="nvBusinessEditorCon9">
              <div data-status="completed" class="nvBusinessEditorCon9B" style="display: none">
                <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($02cb795988e665a0$exports))}"/>
              </div>
              <div data-status="error" class="nvBusinessEditorCon9B" style="display: none">
                <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($9f9fe422c170dfff$exports))}"/>
              </div>
              <div class="nvBusinessEditorText3">Contacto</div>
            </div>
            <div data-step="Lugar" class="nvBusinessEditorCon9">
              <div data-status="completed" class="nvBusinessEditorCon9B" style="display: none">
                <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($02cb795988e665a0$exports))}"/>
              </div>
              <div data-status="error" class="nvBusinessEditorCon9B" style="display: none">
                <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($9f9fe422c170dfff$exports))}"/>
              </div>
              <div class="nvBusinessEditorText3">Lugar</div>
            </div>
            <div data-step="Informaci\xf3n" class="nvBusinessEditorCon9">
              <div data-status="completed" class="nvBusinessEditorCon9B" style="display: none">
                <img height="6px" src="${0, (/*@__PURE__*/$parcel$interopDefault($02cb795988e665a0$exports))}"/>
              </div>
              <div data-status="error" class="nvBusinessEditorCon9B" style="display: none">
                <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($9f9fe422c170dfff$exports))}"/>
              </div>
              <div class="nvBusinessEditorText3">Informaci\xf3n</div>
            </div>
          </div>
          <p id="nvBusinessEditorErrorMessage" class="nvBusinessEditorText3BGood"></p>
        </div>
        <div id="nvBusinessEditorCon10" class="nvBusinessEditorCon10">

          <div data-step="Nombre" class="nvBusinessEditorCon10B">
            <div class="nvBusinessEditorIn1Con1">
              <div class="nvBusinessEditorIn1Text1">Nombre de tu negocio</div>
              <div class="nvBusinessEditorIn1Con2">
                <input id="nvBusinessEditorInputBusinessName" type="text" placeholder="Nombre" value="${nameForInput}" class="nvBusinessEditorIn1Con3 nvBusinessEditorIn1Text2">
                <div class="nvBusinessEditorIn1Con4">
                  <div class="nvBusinessEditorIn1Text3">Escribe el nombre de tu negocio aqu\xed</div>
                </div>
              </div>
            </div>
            <div class="nvBusinessEditorIn1Con5">
              <div class="nvBusinessEditorIn1Text1">Descripci\xf3n corta</div>
              <div class="nvBusinessEditorIn1Con6">
                <textarea id="nvBusinessEditorInputBusinessShortDescription" class="nvBusinessEditorIn1Con7 nvBusinessEditorIn1Text4" placeholder="Descripci\xf3n">${shortDescriptionForInput}</textarea>
                <div class="nvBusinessEditorIn1Con8">
                  <div class="nvBusinessEditorIn1Text3">Escribe una descripci\xf3n breve de tu negocio aqu\xed. Sugerencia 4 a 10 palabras.</div>
                </div>
              </div>
            </div>
          </div>

          <div data-step="Fotos" class="nvBusinessEditorCon10B">
            <label for="nvBusinessEditorImgBackgroundInput" class="nvBusinessEditorIn2Con1">
              <div class="nvBusinessEditorIn2Con2">
                <img height="24px" src="${0, (/*@__PURE__*/$parcel$interopDefault($80ae367ceea82be8$exports))}"/>
              </div>
              <div class="nvBusinessEditorIn2Con3">
                <div class="nvBusinessEditorIn2Text1">Sube la Foto de Fondo</div>
                <div class="nvBusinessEditorIn2Text2">Toca aqu\xed para abrir tu galer\xeda</div>
              </div>
            </label>
            <label for="nvBusinessEditorImgProfileInput" class="nvBusinessEditorIn2Con1">
              <div class="nvBusinessEditorIn2Con2">
                <img height="24px" src="${0, (/*@__PURE__*/$parcel$interopDefault($80ae367ceea82be8$exports))}"/>
              </div>
              <div class="nvBusinessEditorIn2Con3">
                <div class="nvBusinessEditorIn2Text1">Sube la Foto de Perfil</div>
                <div class="nvBusinessEditorIn2Text2">Toca aqu\xed para abrir tu galer\xeda</div>
              </div>
            </label>
          </div> 

          <div data-step="Contacto" class="nvBusinessEditorCon10B">
            <div class="nvBusinessEditorIn3Con1">
              <div class="nvBusinessEditorIn3Text1">N\xfamero de WhatsApp</div>
              <div class="nvBusinessEditorIn3Con2">
                <div class="nvBusinessEditorIn3Con3">

                  <select class="nvBusinessEditorIn3Con4 nvBusinessEditorIn3Text2"
                    id="nvBusinessEditorInputWhatsAppNumberContryCode">
                    <option value="+52">+52</option>
                    <option value="+1">+1</option>
                  </select>

                  <input id="nvBusinessEditorInputWhatsAppNumber" type="text" id="ProfileInputMobileNumber"
                    class="nvBusinessEditorIn3Con5 nvBusinessEditorIn3Text3" placeholder="1231234567" value="${whatsAppNumber}" />
                </div>
                <div class="nvBusinessEditorIn3Con6">
                  <div class="nvBusinessEditorIn3Text4">A este n\xfamero te pueden llamar por llamada m\xf3vil los
                    interesados en tus productos. Puede ser el mismo que tu n\xfamero de WhatsApp.</div>
                </div>
              </div>
            </div>
            <div class="nvBusinessEditorIn3Con1">
              <div class="nvBusinessEditorIn3Text1">N\xfamero de llamadas</div>
              <div class="nvBusinessEditorIn3Con2">
                <div class="nvBusinessEditorIn3Con3">

                  <select class="nvBusinessEditorIn3Con4 nvBusinessEditorIn3Text2"
                    id="nvBusinessEditorInputCallNumberContryCode">
                    <option value="+52">+52</option>
                    <option value="+1">+1</option>
                  </select>

                  <input id="nvBusinessEditorInputCallNumber" type="text" id="ProfileInputMobileNumber"
                    class="nvBusinessEditorIn3Con5 nvBusinessEditorIn3Text3" placeholder="1231234567" value="${callNumber}" />
                </div>
                <div class="nvBusinessEditorIn3Con6">
                  <div class="nvBusinessEditorIn3Text4">A este n\xfamero te pueden llamar por llamada m\xf3vil los
                    interesados en tus productos. Puede ser el mismo que tu n\xfamero de WhatsApp.</div>
                </div>
              </div>
            </div>
            <div class="nvBusinessEditorIn1Con1">
              <div class="nvBusinessEditorIn1Text1">Correo electr\xf3nico</div>
              <div class="nvBusinessEditorIn1Con2">
                <input id="nvBusinessEditorInputEmail" type="email" placeholder="ejemplo@icloud.com" value="${email}" class="nvBusinessEditorIn1Con3 nvBusinessEditorIn1Text2">
                <div class="nvBusinessEditorIn1Con4">
                  <div class="nvBusinessEditorIn1Text3">Escribe un correo electr\xf3nico al cual te pueden contactar</div>
                </div>
              </div>
            </div>
          </div> 

          <div data-step="Lugar" class="nvBusinessEditorCon10B">
            <div class="nvBusinessEditorIn4Con1">
              <div class="nvBusinessEditorIn4Con2" style="display: none">
                <div class="nvBusinessEditorIn4Con3">
                  <div class="nvBusinessEditorIn4Con4Act">
                    <img height="16" src="${0, (/*@__PURE__*/$parcel$interopDefault($6d252ce60bc0082e$exports))}"/>
                    <div class="nvBusinessEditorIn4Text1Act">Escoger ubicaci\xf3n</div>
                  </div>
                  <div class="nvBusinessEditorIn4Con5">
                    <div class="nvBusinessEditorIn4Text2">Pegar enlace</div>
                    <img height="16" src="${0, (/*@__PURE__*/$parcel$interopDefault($c77acca88c6c77d2$exports))}"/>
                  </div>
                </div>
              </div>
              <div id="nvBusinessEditorButtonOpenLocationSelector" class="nvBusinessEditorIn4Con5B">
                <div class="nvBusinessEditorIn4Con6A">
                  <div class="nvBusinessEditorIn4Con6">
                    <img height="20" src="${0, (/*@__PURE__*/$parcel$interopDefault($660d57b441f0f617$exports))}"/>
                    <div class="nvBusinessEditorIn4Text3">Google Maps</div>
                  </div>
                  <div class="nvBusinessEditorIn4Con7">
                    <div class="nvBusinessEditorIn4Text4">Ubicaci\xf3n</div>
                    <div class="nvBusinessEditorIn4Text5">Toca aqu\xed para abrir el mapa y poner la ubicaci\xf3n de tu negocio</div>
                  </div>
                </div>
                <div class="nvBusinessEditorIn4Con7B">
                  <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b91aec60425dcaea$exports))}"/>
                  <div id="nvBusinessEditorButtonOpenLocationSelectorLocationTag" class="nvBusinessEditorIn4Text4B">${locationName}</div>
                </div>
              </div>


              <div class="nvBusinessEditorIn1Con5">
                <div class="nvBusinessEditorIn1Text1">Descripci\xf3n del lugar</div>
                <div class="nvBusinessEditorIn1Con6">
                  <textarea id="nvBusinessEditorInputLocationDescription" class="nvBusinessEditorIn1Con7 nvBusinessEditorIn1Text4" placeholder="Descripci\xf3n">${locationDescription}</textarea>
                  <div class="nvBusinessEditorIn1Con8">
                    <div class="nvBusinessEditorIn1Text3">Da una breve referencia del lugar donde se ubica tu negocio</div>
                  </div>
                </div>
              </div>
            </div>
          </div> 

          <div data-step="Informaci\xf3n" class="nvBusinessEditorCon10B">
            <div class="nvBusinessEditorIn1Con5">
              <div class="nvBusinessEditorIn1Text1">Descripci\xf3n de tu negocio</div>
              <div class="nvBusinessEditorIn1Con6">
                <textarea id="nvBusinessEditorInputBusinessDescription" class="nvBusinessEditorIn1Con7B nvBusinessEditorIn1Text4" placeholder="Descripci\xf3n">${description}</textarea>
                <div class="nvBusinessEditorIn1Con8">
                  <div class="nvBusinessEditorIn1Text3">Escribe una buena descripci\xf3n sobre tu negocio</div>
                </div>
              </div>
            </div>
            <div class="nvBusinessEditorIn1Con1">
              <div class="nvBusinessEditorIn1Text1">P\xe1gina web</div>
              <div class="nvBusinessEditorIn1Con2">
                <input id="nvBusinessEditorInputWebsite" type="text" placeholder="https://tunegocio.com" value="${website}" class="nvBusinessEditorIn1Con3 nvBusinessEditorIn1Text2">
                <div class="nvBusinessEditorIn1Con4">
                  <div class="nvBusinessEditorIn1Text3">\xbfTienes una p\xe1gina web para tu negocio? Puedes ponerlo aqu\xed, y ser\xe1 visible en informaci\xf3n de tu negocio (opcional)</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>



      <div class="nvBusinessEditorCon11">
        <div id="nvBusinessEditorButtonStepBack" class="nvBusinessEditorCon12 nvBusinessEditorCon12Exit topRightExitButtonOnFullScreenWindow">
          <img height="12" src="${0, (/*@__PURE__*/$parcel$interopDefault($92d6f0f713f0d9c5$exports))}"/>
          <div class="nvBusinessEditorText4">Cancelar</div>
        </div>
        <div id="nvBusinessEditorButtonStepAhead" class="nvBusinessEditorCon13">
          <div class="nvBusinessEditorText4B">Siguiente</div>
          <img height="12" src="${0, (/*@__PURE__*/$parcel$interopDefault($197b964e30a399b9$exports))}"/>
        </div>
      </div>
    </div>
  </div>
</div>
  
    
    
    
    
    `;
    }
    _initialPopulation(html, data, colors) {
        return `
<div id="MainContainerBusinessPageBuild" class="MainContainerBusinessPageBuild">
  <div class="BusinessPageVisualizerCon1">
    <div class="BusinessEditorBCon1A">
      <div class="BusinessEditorBCon1">
        <div id="BusinessPageEditorButtonCancel" class="BusinessEditorBCon2">
          <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($132c50ca9603833f$exports))}"/>
        </div>
        <div id="BusinessPageEditorButtonCreatePage" class="BusinessEditorBCon3">
          <div class="BusinessEditorBText2">Publicar esta p\xe1gina</div>
          <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($fb771c59cd73da81$exports))}"/>
        </div>
      </div>
      <div class="BusinessEditorBCon3B">
        <div class="BusinessEditorBCon4">
          <div id="BusinessEditorBCon9EditorToolsShowHideButton" class="BusinessEditorBCon5">
            <div class="BusinessEditorBText3">Editor de p\xe1ginas</div>
          </div>
          <div class="BusinessEditorBCon6">
            <!-- <div class="BusinessEditorBCon7">
              <div class="BusinessEditorBText4">Mercado MAI</div>
            </div> -->
            <div data-helpwith="createBusinessPage" class="WalletCon8 openHelp">
              <div class="WalletText4">Ayuda para crear mi p\xe1gina de negocio</div>
            </div>
          </div>
        </div>
        <div class="BusinessEditorBCon8">
          <div id="BusinessEditorBCon9EditorTools" class="BusinessEditorBCon9 BusinessEditorBCon9Expanded">
          <div class="BusinessEditorBCon9B">
            <div class="BusinessEditorBCon10">
              <div class="BusinessInfoPortionLinkCon1B">
                <label id="BusinessEditorBCon9EditorToolsButtonBackgroungImg" for="BusinessPageEditorSelectImgBackground" class="BusinessEditorBCon11">
                  <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($80ae367ceea82be8$exports))}"/>
                  <div class="BusinessEditorBText5">Escoge una imagen de fondo de negocio</div>
                </label>
                <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
              </div>
              <div class="BusinessInfoPortionLinkCon1B">
                <label id="BusinessEditorBCon9EditorToolsButtonProfileImg" for="BusinessPageEditorSelectImgProfile" class="BusinessEditorBCon11">
                  <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($80ae367ceea82be8$exports))}"/>
                  <div class="BusinessEditorBText5">Escoge una imagen de perfil de negocio</div>
                </label>
                <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
              </div>
            </div>
            <div class="BusinessEditorBCon12">
              <div id="BusinessEditorBCon13ButtonEditColors" class="BusinessEditorBCon13">
                <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}"/>
                <div class="BusinessEditorBText5">Editar colores de p\xe1gina</div>
              </div>
              <div id="BusinessEditorBCon13ButtonEditLists" class="BusinessEditorBCon13" style="display: none">
                <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1e0a876464f124f6$exports))}"/>
                <div class="BusinessEditorBText5">Editar listas</div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div id="BusinessPageVisualizerConForInsert" class="BusinessPageVisualizerCon3"></div>
  </div>
  <div class="BusinessPageEditorCon1 BusinessPageEditorCon1Hidden">
    <div class="BusinessPageEditorCon2">
      <div class="BusinessPageEditorListingsApearButtonHideMoreTools BusinessPageEditorListingsApearButtonCon1">
        Cerrar
      </div>
      <div class="BusinessPageEditorConSilderUopDownCon1">
        <div class="BusinessPageEditorConSilderUopDownCon2"></div>
      </div>
         <div class="BusinessPageEditorListingsApearButtonHideMoreTools BusinessPageEditorListingsApearButtonCon2">
        Listo
      </div>
    </div>
    <div class="BusinessPageEditorCon3">
      <div id="BusinessPageEditorCon4" class="BusinessPageEditorCon4"></div>
    </div>
  </div>
</div>

        `;
    }
    async _visualizerPopulateHeader(data, colors, edit, backgroudImgChange, profileImgChange) {
        let backgroundImg = data.backgroundImg;
        let profileImg = data.profileImg;
        if (edit) {
            if (!backgroudImgChange) backgroundImg = data.backgroundImg;
            if (!profileImgChange) profileImg = data.profileImg;
        }
        return `
<div id="SectionIndicatedBusinessEditorBusinessHeaderCon1"></div>
<div
  id="BusinessEditorBusinessHeaderCon1"
  class="BusinessEditorBusinessHeaderCon1"
>
  <img
    id="BusinessEditorBusinessHeaderCon6BackgroundImgCon"
    class="BusinessEditorBusinessHeaderCon6ImgBackground"
    src="${backgroundImg}"
    alt=""
  />
  <div class="BusinessEditorBusinessHeaderCon2">
    <div class="BusinessEditorBusinessHeaderCon3">
      <div class="BusinessEditorBusinessHeaderCon4">
        <div class="BusinessEditorBusinessHeaderCon5">
          <div class="BusinessEditorBusinessHeaderCon10">
            <div class="BusinessInfoPortionLinkCon1B">
              <div
                id="BusinessEditorInputBusinessName"
                contenteditable="true"
                style="color: #${colors.headerPrimary}"
                class="BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners BusinessEditorBusinessHeaderBusinessName BusinessEditorInputBusinesTextEditableView"
              >
                ${data.name}
              </div>
              <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
            </div>
            <div class="BusinessInfoPortionLinkCon1B">
              <div
                id="BusinessEditorInputBusinessShortDescription"
                contenteditable="true"
                style="color: #${colors.headerSecondary}"
                class="BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners BusinessEditorBusinessHeaderBusinessShortDescription"
              >
                ${data.shortDescription}
              </div>
              <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
            </div>
          </div>
        </div>
        <div class="BusinessEditorBusinessHeaderCon6">
          <img
            id="BusinessEditorBusinessHeaderCon6ProfileImgCon"
            class="BusinessEditorBusinessHeaderCon6Img"
            src="${profileImg}"
            alt=""
          />
        </div>
      </div>
      <div class="BusinessEditorBusinessHeaderCon7">
        <div class="BusinessEditorBusinessHeaderCon8">
          <div class="BusinessEditorBusinessHeaderButtonCon1">
            <div class="BusinessEditorBusinessHeaderButtonCon2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.905 14.52 11.0007 14.2827 11 14V10C11 9.71667 10.904 9.47933 10.712 9.288C10.52 9.09667 10.2827 9.00067 10 9C9.71733 8.99933 9.48 9.09533 9.288 9.288C9.096 9.48067 9 9.718 9 10V14C9 14.2833 9.096 14.521 9.288 14.713C9.48 14.905 9.71733 15.0007 10 15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C10.9993 5.71733 10.9033 5.48 10.712 5.288C10.5207 5.096 10.2833 5 10 5C9.71667 5 9.47933 5.096 9.288 5.288C9.09667 5.48 9.00067 5.71733 9 6C8.99933 6.28267 9.09533 6.52033 9.288 6.713C9.48067 6.90567 9.718 7.00133 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88334 18.6867 3.825 17.9743 2.925 17.075C2.025 16.1757 1.31267 15.1173 0.788001 13.9C0.263335 12.6827 0.000667932 11.3827 1.26582e-06 10C-0.000665401 8.61733 0.262001 7.31733 0.788001 6.1C1.314 4.88267 2.02633 3.82433 2.925 2.925C3.82367 2.02567 4.882 1.31333 6.1 0.788C7.318 0.262667 8.618 0 10 0C11.382 0 12.682 0.262667 13.9 0.788C15.118 1.31333 16.1763 2.02567 17.075 2.925C17.9737 3.82433 18.6863 4.88267 19.213 6.1C19.7397 7.31733 20.002 8.61733 20 10C19.998 11.3827 19.7353 12.6827 19.212 13.9C18.6887 15.1173 17.9763 16.1757 17.075 17.075C16.1737 17.9743 15.1153 18.687 13.9 19.213C12.6847 19.739 11.3847 20.0013 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                  fill="#${colors.headerPrimary}"
                />
              </svg>
            </div>
            <div
              style="color: #${colors.headerPrimary}"
              class="BusinessEditorBusinessHeaderButtonLabel"
            >
              Info
            </div>
          </div>
          <div class="BusinessEditorBusinessHeaderButtonCon1">
            <div class="BusinessEditorBusinessHeaderButtonCon2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="22"
                viewBox="0 0 23 22"
                fill="none"
              >
                <path
                  d="M20.7093 16.6718C19.9458 15.9026 18.0967 14.7801 17.1996 14.3277C16.0313 13.7393 15.9351 13.6912 15.0168 14.3734C14.4043 14.8287 13.9971 15.2354 13.2802 15.0825C12.5634 14.9296 11.0056 14.0676 9.64167 12.7081C8.27769 11.3485 7.36565 9.7457 7.21228 9.03131C7.05891 8.31691 7.47239 7.91453 7.92336 7.30061C8.55895 6.43526 8.51087 6.29104 7.96759 5.12282C7.54402 4.2142 6.38871 2.38255 5.61657 1.62297C4.79059 0.807138 4.79059 0.951363 4.25836 1.17251C3.82505 1.35477 3.40936 1.57636 3.01651 1.8345C2.24726 2.34553 1.82032 2.77003 1.52176 3.40799C1.22319 4.04594 1.08905 5.54155 2.63092 8.34239C4.17278 11.1432 5.25454 12.5754 7.49354 14.808C9.73254 17.0406 11.4542 18.241 13.9711 19.6525C17.0846 21.3962 18.2789 21.0563 18.9188 20.7582C19.5587 20.4601 19.9852 20.0371 20.4972 19.2679C20.756 18.8757 20.9781 18.4605 21.1607 18.0276C21.3824 17.4973 21.5266 17.4973 20.7093 16.6718Z"
                  stroke="#${colors.headerPrimary}"
                  stroke-width="2"
                  stroke-miterlimit="10"
                />
              </svg>
            </div>
            <div
              style="color: #${colors.headerPrimary}"
              class="BusinessEditorBusinessHeaderButtonLabel"
            >
              Llamar
            </div>
          </div>
          <div class="BusinessEditorBusinessHeaderButtonCon1">
            <div class="BusinessEditorBusinessHeaderButtonCon2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
              >
                <path
                  d="M17.2519 2.91005C16.3304 1.98416 15.2329 1.25002 14.0233 0.750414C12.8137 0.250812 11.5163 -0.00426316 10.2067 5.3895e-05C4.71927 5.3895e-05 0.246906 4.45004 0.246906 9.91003C0.246906 11.66 0.709218 13.36 1.57354 14.86L0.166504 20L5.44289 18.62C6.90018 19.41 8.53837 19.83 10.2067 19.83C15.6942 19.83 20.1665 15.38 20.1665 9.92003C20.1665 7.27004 19.1313 4.78004 17.2519 2.91005ZM10.2067 18.15C8.71927 18.15 7.26199 17.75 5.9856 17L5.6841 16.82L2.54842 17.64L3.38259 14.6L3.18158 14.29C2.355 12.9771 1.91618 11.4593 1.91525 9.91003C1.91525 5.37004 5.63384 1.67005 10.1967 1.67005C12.4077 1.67005 14.4881 2.53005 16.0459 4.09004C16.8174 4.85391 17.4287 5.76258 17.8445 6.76337C18.2603 7.76415 18.4722 8.83712 18.468 9.92003C18.4881 14.46 14.7695 18.15 10.2067 18.15ZM14.7494 11.99C14.4982 11.87 13.272 11.27 13.0509 11.18C12.8198 11.1 12.659 11.06 12.4881 11.3C12.3173 11.55 11.8449 12.11 11.7042 12.27C11.5635 12.44 11.4127 12.46 11.1615 12.33C10.9102 12.21 10.1062 11.94 9.16148 11.1C8.41777 10.44 7.9253 9.63003 7.77455 9.38003C7.63384 9.13003 7.75445 9.00003 7.8851 8.87003C7.99565 8.76003 8.13636 8.58003 8.25696 8.44003C8.37756 8.30003 8.42782 8.19003 8.50822 8.03003C8.58862 7.86004 8.54842 7.72004 8.48812 7.60004C8.42782 7.48004 7.9253 6.26004 7.7243 5.76004C7.52329 5.28004 7.31224 5.34004 7.16148 5.33004H6.67907C6.50822 5.33004 6.24691 5.39004 6.01575 5.64004C5.79465 5.89004 5.15143 6.49004 5.15143 7.71004C5.15143 8.93003 6.0459 10.11 6.16651 10.27C6.28711 10.44 7.9253 12.94 10.4178 14.01C11.0107 14.27 11.473 14.42 11.8349 14.53C12.4278 14.72 12.9705 14.69 13.4027 14.63C13.8851 14.56 14.8801 14.03 15.0811 13.45C15.2921 12.87 15.2921 12.38 15.2218 12.27C15.1514 12.16 15.0007 12.11 14.7494 11.99Z"
                  fill="#${colors.headerPrimary}"
                />
              </svg>
            </div>
            <div
              style="color: #${colors.headerPrimary}"
              class="BusinessEditorBusinessHeaderButtonLabel"
            >
              WhatsApp
            </div>
          </div>
          <div class="BusinessEditorBusinessHeaderButtonCon1">
            <div class="BusinessEditorBusinessHeaderButtonCon2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M7.39687 14.7937C5.32954 14.7937 3.58009 14.0776 2.14851 12.6452C0.716928 11.2129 0.000759255 9.46344 6.02106e-07 7.39687C-0.000758051 5.3303 0.715411 3.58084 2.14851 2.14851C3.5816 0.716169 5.33106 0 7.39687 0C9.46268 0 11.2125 0.716169 12.6464 2.14851C14.0802 3.58084 14.796 5.3303 14.7937 7.39687C14.7937 8.23139 14.661 9.01849 14.3954 9.75818C14.1299 10.4979 13.7696 11.1522 13.3144 11.7212L19.6871 18.0939C19.8957 18.3025 20 18.568 20 18.8905C20 19.2129 19.8957 19.4784 19.6871 19.6871C19.4784 19.8957 19.2129 20 18.8905 20C18.568 20 18.3025 19.8957 18.0939 19.6871L11.7212 13.3144C11.1522 13.7696 10.4979 14.1299 9.75818 14.3954C9.01849 14.661 8.23139 14.7937 7.39687 14.7937ZM7.39687 12.5178C8.81935 12.5178 10.0286 12.0201 11.0248 11.0247C12.0209 10.0294 12.5185 8.8201 12.5178 7.39687C12.517 5.97364 12.0193 4.76472 11.0248 3.77013C10.0302 2.77553 8.82086 2.27748 7.39687 2.27596C5.97288 2.27444 4.76396 2.7725 3.77013 3.77013C2.77629 4.76776 2.27824 5.97667 2.27596 7.39687C2.27368 8.81707 2.77174 10.0264 3.77013 11.0247C4.76852 12.0231 5.97743 12.5208 7.39687 12.5178Z"
                  fill="#${colors.headerPrimary}"
                />
              </svg>
            </div>
            <div
              style="color: #${colors.headerPrimary}"
              class="BusinessEditorBusinessHeaderButtonLabel"
            >
              Buscar
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    `;
    }
    _generateBusinessForEditing(data, listingsHtml) {
        let businessCategoriesHTML = ``;
        console.log(data);
        const generatBusinessCategories = ()=>{
            if (data.categories) data.categories.forEach((cat)=>{
                if (cat) businessCategoriesHTML += `
              <div data-machine="${cat.machine}" class="categorySelectMiniCon1">
                <div class="categorySelectMiniCon2">
                  <div class="categorySelectMiniText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatReadableString(cat.machine)}</div>
                  <div class="categorySelectMiniText2">${cat.number}</div>
                </div>
                <div class="categorySelectMiniCon3" style="display: none"></div>
              </div>
          `;
            });
        };
        generatBusinessCategories();
        let SavedHtml = `
          <div id="btnActionBusinessSave" data-property-1="action on thing button save" class="property1actionOnThingButtonShare">
            <div class="actionOnThingButtonShareText">Guardar negocio</div>
              <img height="16px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($bea62215618c37fd$exports)))}"/>
          </div>`;
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        return `
    <div
      data-is="business"
      data-businessid="${data.businessId}"
      class="bussinessDisplayCon1ForEditor ActionForShare">
      <div class="bussinessDisplayCon3B">
        <div class="bussinessDisplayHeaderBackgroundImgCon2">
          <img id="BusinessEditorBusinessHeaderCon6BackgroundImgCon" src="${data.profileImg}" class="bussinessDisplayHeaderBackgroundImg2">
        </div>
        <div class="bussinessDisplayCon3">
          <div id="bussinessDisplayHeaderCon1" class="bussinessDisplayHeaderCon1ForEditor">
            <div id="bussinessDisplayHeaderCon2BForColapse" class="bussinessDisplayHeaderCon2B">
              <div class="bussinessDisplayHeaderBackgroundImgCon">
                <img src="${data.backgroundImg}" class="bussinessDisplayHeaderBackgroundImg">
              </div>
              <div class="bussinessDisplayHeaderCon2">
                <div class="bussinessDisplayHeaderCon3">
                  <div class="bussinessDisplayHeaderCon4">
                    <div class="BusinessInfoPortionLinkCon1B">

                    <div
                      id="BusinessEditorInputBusinessName"
                      contenteditable="true"
                 style="color: #${data.colors.headerPrimary};" class="BusinessEditorInputBusinessForKeyUpListeners bussinessDisplayHeaderNameText BusinessEditorInputBusinesTextEditableView">${data.name}</div>
                      <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
                    </div>
                    <div class="BusinessInfoPortionLinkCon1B">
                    <div
                      id="BusinessEditorInputBusinessShortDescription"
                      contenteditable="true"
                      style="color: #${data.colors.headerSecondary};" class="BusinessEditorInputBusinessForKeyUpListeners bussinessDisplayHeaderDescriptionText BusinessEditorInputBusinesTextEditableView">${data.shortDescription}</div>
                      <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
                    </div>
                    <div class="bussinessDisplayHeaderCon5" style="display: none">
                      <div class="mercadoMaiVerifiedCon1">
                        <div class="mercadoMaiVerifiedText">Negocio verificado de Mercado MAI</div>
                        <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1a8906870c2da8ac$exports))}"/>
                      </div>
                    </div>
                  </div>
                  
                  <img id="BusinessEditorBusinessHeaderCon6ProfileImgCon" src="${data.profileImg}" class="bussinessDisplayHeaderProfileImgCon ImgForBigDisplay">
                </div>
                <div class="actionOnThingCon1">
                  <div class="actionOnThingCon2">
                    <div class="actionOnThingCon3">
                      <div id="" class="property1actionOnThingWhatsappContactButton">
                        <div class="actionOnThingWhatsappContactButtonText">Contactar negocio por WhatsApp</div>
                        <img class="SMBoxShadow" height=24px" src="${0, (/*@__PURE__*/$parcel$interopDefault($64af874227dfbcd8$exports))}"/>
                      </div>
                      <div id="" 
                        class="property1actionOnThingWhatsappCallButton" 
                        href="tel:+52${data.contacts.call.contact}">
                        <div class="actionOnThingCallContactButtonText">Llamar negocio</div>
                        <img class="SMBoxShadow" src="${0, (/*@__PURE__*/$parcel$interopDefault($d4f97493ec4bc5db$exports))}" height="24px" />
                      </div>
                    </div>
                    <div class="actionOnThingCon3B">
                      <div class="actionOnThingSumaryCon1">
                        <div class="actionOnThingSumaryCon2">
                          <div class="actionOnThingSumaryText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.views)}</div>
                            <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($22464c49e0ce4777$exports))}"/>
                          </div>
                          <div class="actionOnThingSumaryCon2">
                          <div class="actionOnThingSumaryText1">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatNumberShort(data.shares)}</div>
                            <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b83bf9f7282ed2ae$exports))}"/>
                        </div>
                      </div>
                      <div id="btnActionBusinessInfo" class="property1actionOnThingButtonShare">
                        <div class="actionOnThingButtonShareText">info</div>
                        <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($54f80ec6c63d9279$exports))}"/>
                      </div>
                    </div>
                  </div>
                  <div class="actionOnThingCon4">
                    <div id="btnActionBusinessShare" data-property-1="action on thing button share" class="property1actionOnThingButtonShare">
                      <div class="actionOnThingButtonShareText">Compartir negocio</div>
                        <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($b83bf9f7282ed2ae$exports))}"/>
                    </div>
                    ${SavedHtml}
                    <div id="btnActionBusinessMore" data-property-1="action on thing button more" class="property1actionOnThingButtonShare">
                      <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($4f135521ed49efb5$exports))}"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="categorySelectMainConInBusiness" class="categorySelectMainCon">
              <div data-machine="all" class="categorySelectMiniCon1">
                <div class="categorySelectMiniCon2 categorySelectMiniCon2Act">
                  <div class="categorySelectMiniText1">Todos</div>
                  <div class="categorySelectMiniText2">${data.numberOfListings}</div>
                </div>
                <div class="categorySelectMiniCon3"></div>
              </div>      
              ${businessCategoriesHTML}
            </div>
          </div>
          <div id="bussinessDisplayHeaderCon10ForEditor" class="bussinessDisplayHeaderCon10ForEditor"></div>
    
        </div>
      </div>
    <div id="businessInfoConForDisplay" class="blackBackgroundCon1" style="display: none">
      <div class="blackBackgroundCon2 blackBackgroundCon2HiddenOffScreenBottom">
        <div class="blackBackgroundCon3">
        <img id="businessInfoConForDisplayBtnExit" height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($92d6f0f713f0d9c5$exports))}"/>
        </div>
        
      </div>
    </div>
    </div>
    
    
    
    `;
    // <div class="blackBackgroundCon4">${this._generateInfo(data)}</div>
    }
    _visualizerPopulateListingsSection(html, data, colors) {
        return `
      <div id="ListingsExampleDisplayCon1" class="ListingsExampleDisplayCon1">
    <div class="ListingsExampleDisplayCon2">
      <div style="color: #${colors.packTitles}" class="ListingsExampleDisplayHeaderTitle">
        ${data.name}
      </div>
      <div style="color: #${colors.packTitlesHighlight}" class="ListingsExampleDisplayHeaderSeeAll">
        Ver todo
      </div>
    </div>
    <div class="ListingsExampleDisplayCon3">${html}</div>
  </div>
    `;
    }
    _visualizerPopulateListing(colors) {
        return `
  <div
    class="ListingVeriticalCon1"
  >
    <div class="ListingExampleVeriticalCon2">
      <img class="BusinessEditorBusinessHeaderImportantIconExit" src="${0, (/*@__PURE__*/$parcel$interopDefault($80ae367ceea82be8$exports))}" alt="" />
    </div>
    <div
      style="background: #${colors.itemBackgroundSecondary}; "
      class="ListingVeriticalCon3"
    >
      <div class="ListingVeriticalCon4">
        <div
          style="background: #${colors.itemBackgroundPrimary};"
          class="ListingVeriticalCon5"
        >
          <div style="color: #${colors.itemTextPrimary};" class="ListingVeriticalTitle">
            Nombre de listado
          </div>
        </div>
        <div class="ListingVeriticalCon6">
          <div class="ListingVeriticalCon7">
            <div class="ListingVeriticalCon8">
              <div class="ListingVeriticalCon9">
                <div
                  style="background: #${colors.itemHighlight};"
                  class="ListingVeriticalCon10"
                  >
                  <div
                    style="color: #${colors.itemHighlightText};"
                    class="ListingVeriticalOnDiscount"
                  >
                    En oferta 4% \u{2193}
                  </div>
                </div>
                <div
                  style="color: #${colors.itemTextFour};"
                  class="ListingVeriticalPrice"
                > 25,000 USD </div>
              </div>
              <div
                style="color: #${colors.itemTextFour};"
                class="ListingVeriticalCondition"
              >
                Usado
              </div>
            </div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalPriceBeforeText"
              >
              <div class="Antes">Antes</div>
              <div
                style="color: #${colors.itemHighlight};"
                class="ListingVeriticalPriceBeforePrice"
              >26,000 USD </div>
            </div>
          </div>
          <div
            style="color: #${colors.itemTextSecondary};"
            class="ListingVeriticalDescription"
          >
            Descripci\xf3n de listado. Mas informaci\xf3n de la maquina.
          </div>
        </div>
      </div>
      <div class="ListingVeriticalCon12">
        <div class="ListingDisplayDateCon">
          <p
            class="ListingDisplayDateText"
            style="color: #${colors.itemTextTerteriary};"
          > Hoy, 8:45 a. m.</p>
        </div>
        <div class="ListingMiniVeriticalCon12">
          <div
            class="ListingDisplayViewsText"
            style="color: #${colors.itemTextTerteriary};"
          >
            1.3k
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 8 8"
            fill="none"
          >
            <path
              d="M7.46885 5.36328L7.46807 5.3625L7.46729 5.36172C7.12275 4.63281 6.58916 4.25781 5.879 4.25781C5.16885 4.25781 4.63525 4.63359 4.28994 5.36172V5.3625C4.24775 5.45234 4.24775 5.55703 4.28994 5.64687C4.63525 6.375 5.16885 6.75 5.879 6.75C6.58916 6.75 7.12275 6.37422 7.46807 5.64609C7.51025 5.55625 7.51025 5.45234 7.46885 5.36328ZM5.879 6.25C5.39385 6.25 5.03994 6.01562 4.77666 5.50391C5.03916 4.99219 5.39385 4.75781 5.879 4.75781C6.36416 4.75781 6.71807 4.99219 6.98135 5.50391C6.71885 6.01562 6.36416 6.25 5.879 6.25Z"
            fill="#${colors.itemTextTerteriary}"
            />
            <path
              d="M5.44531 5.50781C5.44531 5.62384 5.49141 5.73512 5.57345 5.81717C5.6555 5.89922 5.76678 5.94531 5.88281 5.94531C5.99884 5.94531 6.11012 5.89922 6.19217 5.81717C6.27422 5.73512 6.32031 5.62384 6.32031 5.50781C6.32031 5.39178 6.27422 5.2805 6.19217 5.19845C6.11012 5.11641 5.99884 5.07031 5.88281 5.07031C5.76678 5.07031 5.6555 5.11641 5.57345 5.19845C5.49141 5.2805 5.44531 5.39178 5.44531 5.50781ZM1.0625 1.8125H6.5625V3.78906H7.125V1.5C7.125 1.36172 7.01328 1.25 6.875 1.25H0.75C0.611719 1.25 0.5 1.36172 0.5 1.5V5.5625C0.5 5.70078 0.611719 5.8125 0.75 5.8125H3.5V5.25H1.0625V1.8125Z"
            fill="#${colors.itemTextTerteriary}"
            />
            <path
              d="M5.66348 2.64136L5.37598 2.35386C5.35176 2.32964 5.31191 2.32964 5.2877 2.35386L3.85176 3.79136L3.1791 3.11792C3.15488 3.0937 3.11504 3.0937 3.09082 3.11792L1.96348 4.24526C1.93926 4.26948 1.93926 4.30933 1.96348 4.33354L2.25098 4.62104C2.2752 4.64526 2.31504 4.64526 2.33926 4.62104L3.13457 3.82573L3.80723 4.49917C3.83145 4.52339 3.87129 4.52339 3.89551 4.49917L5.66348 2.72964C5.68848 2.70542 5.68848 2.66558 5.66348 2.64136Z"
            fill="#${colors.itemTextTerteriary}"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
  
      `;
    }
    _visualizerPopulateBusinessInfoMain(html) {
        return `
  <div id="SectionIndicatedBusinessInfoCon1" class="BusinessInfoCon1">
    <div class="BusinessInfoCon2">
      <div class="BusinessInfoHeaderText">
        Informaci\xf3n de este negocio
      </div>
    </div>
    <div class="BusinessInfoCon3">${html}</div>
  </div>
    `;
    }
    _visualizerPopulateBusinessInfoPortion(title, html) {
        return ` 
  <div id="BusinessInfoPortionCon1" class="BusinessInfoPortionCon1">
    <div class="BusinessInfoPortionCon2">
      <div class="BusinessInfoPortionHeaderText">
        ${title}
      </div>
    </div>
    ${html}
  </div>
    `;
    }
    _visualizerPopulateBusinessInfoPlace(data) {
        return `
<div id="BusinessInfoLocationCon1" class="BusinessInfoLocationCon1">
  <div class="BusinessPageEditorPortionCon3">
    <div class="BusinessPageEditorInfoCon2">
      <label for="BusinessPageEditorLocationInput">
        <img
          id="BusinessPageEditorOpenMapButton"
          height="20px"
          src="${0, (/*@__PURE__*/$parcel$interopDefault($48b57b26aaf6c3c1$exports))}"
          alt=""
        />
      </label>
      <div class="BusinessInfoPortionLinkCon1B">
        <div class="BusinessEditorInputBusinessInfoLabel Wallet2Text3 Wallet2Text3Dark">Ubicaci\xf3n de tu negocio</div>
        <input
          type="text"
          placeholder="Busca una ubicacion"
          class="BusinessEditorInputBusinessForKeyUpListeners"
          id="BusinessPageEditorLocationInput"
          value="${data.name}"
        />
        <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
      </div>
      <div
        id="BusinessEditorLocationMyLocationCon1"
        style="display: none"
        class="BusinessEditorLocationMyLocationCon1"
      >
        <img
          id="BusinessPageEditorOpenMapButtonLocator"
          height="20px"
          src="${0, (/*@__PURE__*/$parcel$interopDefault($e21640a4543ad06d$exports))}"
          alt=""
        />
        <div class="BusinessEditorLocationMyLocationText">Ubicar</div>
      </div>
    </div>
    <div style="display: none" id="BusinessPageEditorMapContainer1">
      <div
        id="BusinessPageEditorMapContainer"
        class="BusinessPageEditorMapContainer"
      ></div>
      <div id="BusinessPageEditorMapCenterMarker">
        <img
          id="BusinessPageEditorOpenMapButtonLocator"
          height="24px"
          src="${0, (/*@__PURE__*/$parcel$interopDefault($a1958079b1b1bc47$exports))}"
          alt=""
        />
      </div>
    </div>
    <div class="InputMiniCon2">
      <div class="InputMiniCon2">
        <div class="InputMiniLabel">Referencias</div>
        <div
          id="BusinessEditorInputBusinessLocationDescription"
          contenteditable="true"
          class="InputMiniInput BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners"
        >${data.description}</div>
        <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
      </div>
    </div>
  </div>
</div>
    `;
    }
    _visualizerPopulateBusinessInfoContact(data) {
        let call = "N\xfamero de llamadas";
        let whatsApp = "N\xfamero de WhatsApp";
        let email = "Correo electr\xf3nico";
        let website = "Sitio web";
        let contactWays = ``;
        if (data.call?.contact) call = data.call?.contact;
        contactWays += `
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="18px" src="${0, (/*@__PURE__*/$parcel$interopDefault($5ce8e3a6965a117b$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkCon1B">
          <div class="BusinessEditorInputBusinessInfoLabel Wallet2Text3 Wallet2Text3Dark"></div>
          <div id="BusinessEditorInputBusinessInfoPhoneNumber" contenteditable="true" class="BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners BusinessInfoPortionLinkText">${call}</div>
          <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
        </div>
      </div>`;
        if (data.whatsApp?.contact) whatsApp = data.whatsApp?.contact;
        contactWays += `
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="18px" src="${0, (/*@__PURE__*/$parcel$interopDefault($a09862394dab6394$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkCon1B">
          <div class="BusinessEditorInputBusinessInfoLabel Wallet2Text3 Wallet2Text3Dark"></div>
          <div id="BusinessEditorInputBusinessInfoWhatsAppNumber" contenteditable="true" class="BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners BusinessInfoPortionLinkText">${whatsApp}</div>
          <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
        </div>
      </div>`;
        if (data.email?.contact) email = data.email?.contact;
        contactWays += `
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="18px" src="${0, (/*@__PURE__*/$parcel$interopDefault($49eddbfc8a0f42b9$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkCon1B">
          <div class="BusinessEditorInputBusinessInfoLabel Wallet2Text3 Wallet2Text3Dark"></div>
          <div id="BusinessEditorInputBusinessInfoEmail" contenteditable="true" class="BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners BusinessInfoPortionLinkText">${email}</div>
          <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
        </div>
      </div>`;
        if (data.website?.contact) website = data.website?.contact;
        contactWays += `
      <div id="BusinessInfoPortionLinkCon1" class="BusinessInfoPortionLinkCon1">
        <img height="18px" src="${0, (/*@__PURE__*/$parcel$interopDefault($5954c48d6ce68e0a$exports))}" alt="" />
        <div class="BusinessInfoPortionLinkCon1B">
          <div class="BusinessEditorInputBusinessInfoLabel Wallet2Text3 Wallet2Text3Dark"></div>
          <div id="BusinessEditorInputBusinessInfoWebsite" contenteditable="true" class="BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners BusinessInfoPortionLinkText">${website}</div>
          <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
        </div>
      </div>`;
        return `<div class="BusinessInfoContactCon1">${contactWays}</div>`;
    }
    _visualizerPopulateBusinessInfoAbout(about) {
        return `
  <div id="BusinessInfoAboutCon1" class="BusinessInfoAboutCon1">
    <div class="BusinessInfoPortionLinkCon1B">
      <div id="BusinessEditorInputBusinessInfoAbout" contenteditable="true" class="BusinessEditorInputBusinesTextEditableView BusinessEditorInputBusinessForKeyUpListeners BusinessInfoAboutText">
        ${about}
      </div>
      <div class="Wallet2Text3 Wallet2Text3Error editorErrorInputMessage"></div>
    </div>
  </div>
    `;
    }
}
var $45d8d8fc6a6044af$export$2e2bcd8739ae039 = new $45d8d8fc6a6044af$var$GenerateHtml();




var $b70fbd1110057bc1$exports = {};
$b70fbd1110057bc1$exports = new URL("back-arrow.9f763ba4.png", import.meta.url).toString();






const $5e2d2197cd245583$var$appUploadStatus = 'active';
class $5e2d2197cd245583$var$settings {
    _getAppUploadStatus() {
        return $5e2d2197cd245583$var$appUploadStatus;
    }
}
var $5e2d2197cd245583$export$2e2bcd8739ae039 = new $5e2d2197cd245583$var$settings();




var $2a69d3e1a57b5fa2$exports = {};
$2a69d3e1a57b5fa2$exports = new URL("boost.23abfe3c.png", import.meta.url).toString();


var $e09b7dde741fb75a$exports = {};
$e09b7dde741fb75a$exports = new URL("stats.39e0cabd.png", import.meta.url).toString();


var $7ecc8b91be0caa50$exports = {};
$7ecc8b91be0caa50$exports = new URL("edit.b315a14b.png", import.meta.url).toString();


var $9dc55003fd723de3$exports = {};
$9dc55003fd723de3$exports = new URL("edit.2298aed4.png", import.meta.url).toString();




var $f8aec8cbd86ee40a$exports = {};
$f8aec8cbd86ee40a$exports = new URL("add.a9935b72.png", import.meta.url).toString();


var $643956bf3970c6d4$exports = {};
$643956bf3970c6d4$exports = new URL("add-business-page.5ccd7548.png", import.meta.url).toString();



var $776231c65e7d45e6$exports = {};
$776231c65e7d45e6$exports = new URL("dots-menu.b352965d.png", import.meta.url).toString();




var $a95cb208699addab$exports = {};
$a95cb208699addab$exports = new URL("forward.c17a7afc.png", import.meta.url).toString();



var $1034e4a6d12d04d7$exports = {};
$1034e4a6d12d04d7$exports = new URL("logo-72.0ff5c5bd.png", import.meta.url).toString();



class $95daa10db0d540ef$var$GenerateHtml {
    _actiListingDraft(data) {
        let imgs = [];
        data?.images?.forEach((img)=>{
            const url = URL.createObjectURL(img.blob);
            imgs.push(url);
        });
        let uploadingDisp = 'none';
        let successDisp = 'none';
        let errorDisp = 'none';
        let draftDisp = 'none';
        if (data?.uploadStatus) {
            if (data?.uploadStatus === 'uploading') uploadingDisp = 'flex';
            if (data?.uploadStatus === 'success') successDisp = 'flex';
            if (data?.uploadStatus === 'error') errorDisp = 'flex';
            if (data?.uploadStatus === 'none') draftDisp = 'flex';
        } else draftDisp = 'flex';
        return `
      <div data-id="${data.prefixId}" id="${data.prefixId}actiListingDraftCon1A" class="actiListingDraftCon1A">
        <div class="actiListingDraftCon1">
          <div id="${data.prefixId}actiListingDraftCon2" class="actiListingDraftCon2" style="display: ${uploadingDisp}">
            <div class="actiListingDraftText1">Subiendo tu listado...</div>
          </div>
          <div id="${data.prefixId}actiListingDraftCon3" class="actiListingDraftCon3" style="display: ${uploadingDisp}">
            <div class="actiListingDraftText2">No debes cerrar la aplicaci\xf3n antes que termina de subir este listado.</div>
          </div>
          <div id="${data.prefixId}imageProgressDisplay" class="actiListingDraftText2"></div>
          <div id="${data.prefixId}actiListingDraftCon4" class="actiListingDraftCon4" style="display: ${successDisp}">
            <div class="actiListingDraftText3">\xa1Publicado con \xe9xito!</div>
          </div>
          <div id="${data.prefixId}actiListingDraftCon5" class="actiListingDraftCon5" style="display: ${errorDisp}">
            <div class="actiListingDraftText4">${data?.uploadErrorMessaje || ''}</div>
          </div>
          <div id="${data.prefixId}actiListingDraftCon6" class="actiListingDraftCon6" style="display: ${errorDisp}">
            <div class="actiListingDraftText5">El listado no ten\xeda suficiente informaci\xf3n para publicarlo.</div>
          </div>
          <div class="actiListingDraftCon7">
            <img class="actiListingDraftCon8" src="${imgs?.[0]}" alt="" />
            <div class="actiListingDraftCon9">
              <div class="actiListingDraftText6">${data?.listingName || 'Sin titulo'}</div>
              <div id="${data.prefixId}actiListingDraftText7" class="actiListingDraftText7"></div>
              <div id="${data.prefixId}actiListingDraftText8" class="actiListingDraftText8"></div>
            </div>
          </div>
          <div class="actiListingDraftCon10" style="display: ${errorDisp}">
            <div id="${data.prefixId}actiListingDraftCon12" class="actiListingDraftCon12">
              <div class="actiListingDraftText10">Volver a intentar subir</div>
            </div>
            <div id="${data.prefixId}actiListingDraftCon13" class="actiListingDraftCon13" style="display: none">
              <div class="actiListingDraftText11">Cerrar</div>
            </div>
          </div>
          <div class="actiListingDraftCon10" style="display: ${successDisp}">
            <div id="${data.prefixId}actiListingDraftCon11" class="actiListingDraftCon11">
              <div class="actiListingDraftText9">\xbfCompartir listado?</div>
            </div>
            <div id="${data.prefixId}actiListingDraftCon13" class="actiListingDraftCon13" style="display: none">
              <div class="actiListingDraftText11">Cerrar</div>
            </div>
          </div>
          <div class="actiListingDraftCon14" style="display: ${draftDisp}">
            <div id="${data.prefixId}actiListingDraftCon15" class="actiListingDraftCon15">
              <div class="actiListingDraftText12">Eliminar</div>
            </div>
            <div id="${data.prefixId}actiListingDraftCon16" class="actiListingDraftCon16">
              <div class="actiListingDraftText13">Terminar</div>
            </div>
          </div>

        <div class="loadingBar" style="display: ${data.uploadStatus === 'uploading' ? 'block' : 'none'}">
            <div class="loadingBarSweep"></div>
        </div>

        </div>
      </div>
        
      `;
    }
    async _listing(data, atention) {
        const itemImg = data.listingMainImg;
        // const itemImg = await firebase._getImageUrl(data.listingMainImg);
        let dotsMenuHtml = `
    <div class="OwnBusinessListingButtonMenu returnForActionOpenForDisplay openListingEditOptionsGlobal">
    <img height="20px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($de3fcb18e82e2fa8$exports)))}"/>
    </div>`;
        let actionButtonsHtml = `
          <div class="OwnBusinessListingButtonAction openListingShareGlobal">
            <img height="14px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($54520949b970bb70$exports)))}"/>
          </div>
          <div class="OwnBusinessListingButtonAction openListingBoostGlobal">
            <img height="14px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($2a69d3e1a57b5fa2$exports)))}"/>
          </div>`;
        if (atention) {
            dotsMenuHtml = ``;
            // dotsMenuHtml = `<img height="20px" src="${iconDotsMenuRed}"/>`;
            if (atention === "waitingPayment") actionButtonsHtml = `
          <div id="OwnBusinessListingButtonActionPayNow" class="OwnBusinessListingButtonActionPayNow">Pagar</div>
        `;
            if (atention === "selectForPayment") actionButtonsHtml = `
          <div id="OwnBusinessListingButtonActionSelectForPayment" class="OwnBusinessListingButtonActionSelect">Seleccionar</div>
        `;
        }
        return `
  <div id="${data.listingId}" data-listingid="${data.listingId}" data-businessid="${data.businessId}" data-imgid="${itemImg}" data-name="${data.listingName}" class="OwnBusinessListingCon1 ActionOpenForDisplay">
    <div class="OwnBusinessListingCon2">
     <img class="OwnBusinessListingCon2Image ImgForBigDisplay" src="${itemImg}" />
        ${dotsMenuHtml}
    </div>
    <div class="OwnBusinessListingCon3">
      <div class="OwnBusinessListingCon4">
        <div class="OwnBusinessListingTitle">
          ${data.listingName}
        </div>
      </div>
        <div class="OwnBusinessListingCon6 returnForActionOpenForDisplay">
          ${actionButtonsHtml}
        </div>
        <div class="OwnBusinessListingCon7">
          <div class="OwnBusinessListingCon8">
            <div class="OwnBusinessListingTime">
              ${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.updatedAt)}
            </div>
          </div>
          <div class="OwnBusinessListingCon9">
            <div class="OwnBusinessListingTime">
              ${data.listingViews}
            </div>
            <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1ec93aa3f5b0a0a3$exports))}"/>
          </div>
        </div>
    </div>
  </div>
    `;
    }
    _listingsCon(title, id) {
        return `
  <div class="OwnBusinessListingsCon2">
    <div class="OwnBusinessListingsCon3">
      <div class="OwnBusinessListingsTitle">
        ${title}
      </div>
      <div data-generall="expandforviewallEditMode" class="OwnBusinessListingsSeeAll">
        Ver todo
      </div>
    </div>
    <div id="${id}" class="OwnBusinessListingsCon4">
    </div>
  </div>`;
    }
    async _business(data) {
        console.log(data);
        const backImgUrl = data.backgroundImg;
        // const backImgUrl = await firebase._getImageUrl(data.backgroundImg);
        const ProfileImgUrl = data.profileImg;
        // const ProfileImgUrl = await firebase._getImageUrl(data.profileImg);
        // <div class="OwnBusinessConBusinessMessageConSubscriptionButtonCon">
        //   <div id="OwnBusinessConBusinessMessageConSubscriptionButton" class="OwnBusinessConBusinessMessageConSubscriptionButton">
        //     <div class="OwnBusinessConBusinessMessageConSubscriptionButtonText">Ver subscripción</div>
        //     <img height="20px" src="${iconDarkForward}" alt="" />
        //   </div>
        // </div>
        // Subscriiption Button goes where space is
        return `
  <div data-businessid="${data.businessId}" class="OwnBusinessCon3">



  <div class="OwnBusinessCon5A">
  <div class="OwnBusinessCon5">
    <img class="BusinessInSearchCon1BackgroundImg" src="${backImgUrl}" />
    <div class="OwnBusinessCon6">
      <div class="OwnBusinessCon7">
        <div class="OwnBusinessCon9">
          <img class="OwnBusinessCon9Img ImgForBigDisplay" src="${ProfileImgUrl}" />
        </div>
        <div class="OwnBusinessCon10">
          <div class="OwnBusinessCon11">
            <div style="color: #${data.colors.headerPrimary}" class="TratoresKiotyHopelchN">${data.name}</div>
            <div style="color: #${data.colors.headerSecondary}" class="TratoresKiotyHopelchNDescription">${data.shortDescription}</div>
          </div>
          <div
            id="OwnBusinessButtonsActionOnBusinessActionMenu"
            class="OwnBusinessButtonsActionOnBusinessOpen OwnBusinessButtonsActionOnBusinessForEventListining"
          >
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($de3fcb18e82e2fa8$exports))}" alt="" />
          </div>
        </div>
      </div>
      <div class="OwnBusinessCon12">
        <div class="OwnBusinessCon13">
          <div class="OwnBusinessCon13">
            <div class="OwnBusinessCon14">
              <div
                id="OwnBusinessButtonsActionOnBusinessShare"
                class="OwnBusinessButtonsActionOnBusiness OwnBusinessButtonsActionOnBusinessForEventListining" style="display: none"
              >
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($54520949b970bb70$exports))}" alt="" />
              </div>
              <div
                id="OwnBusinessButtonsActionOnBusinessBoost"
                class="OwnBusinessButtonsActionOnBusiness OwnBusinessButtonsActionOnBusinessForEventListining"
              >
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($2a69d3e1a57b5fa2$exports))}" alt="" />
              </div>
              <div
                id="OwnBusinessButtonsActionOnBusinessStats"
                class="OwnBusinessButtonsActionOnBusiness OwnBusinessButtonsActionOnBusinessForEventListining"
              >
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($e09b7dde741fb75a$exports))}" alt="" />
              </div>
              <div
                id="OwnBusinessButtonsActionOnBusinessEdit"
                class="OwnBusinessButtonsActionOnBusiness OwnBusinessButtonsActionOnBusinessForEventListining"
              >
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($7ecc8b91be0caa50$exports))}" alt="" />
              </div>
            </div>
          </div>
          <div
            id="OwnBusinessButtonsActionOnBusinessOpen"
            class="OwnBusinessButtonsActionOnBusinessOpen OwnBusinessButtonsActionOnBusinessForEventListining"
          >
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($4ef0f4e56773f3c2$exports))}" alt="" />
          </div>
        </div>
        <div class="OwnBusinessCon15">
          <div class="KVisitasLtimos7Dias">${data.views} Visitas total</div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <div class="LogInCon6">
    <div data-helpwith="editBusinessPage" class="WalletCon8 openHelp">
      <div class="WalletText4">\xbfComo puede administrar mi negocio?</div>
    </div>
  </div>
  <div class="LogInCon6">
    <div data-helpwith="editListing" class="WalletCon8 openHelp">
      <div class="WalletText4">
        \xbfComo puedo editar o eliminar un listado?
      </div>
    </div>
  </div>
</div>

    `;
    }
    _NVActiPageHtml() {
        // Goes where the big space is, Maybe use later
        // <div data-selector="more" class="nvActiCon5">
        //   <div class="nvActiText2">Mas</div>
        // </div>
        // <div data-selector="history" class="nvActiCon5">
        //   <div class="nvActiText2">Recientes</div>
        // </div>
        return `
<div class="nvActiCon1">
  <div class="nvActiCon2">
    <div class="nvActiCon3">
      <div id="nvActiCon4" class="nvActiCon4">
        <div data-selector="listing-drafts" class="nvActiCon5">
          <div class="nvActiText2">Borradores</div>
        </div>
        <div data-selector="sellerprofile" class="nvActiCon5">
          <div class="nvActiText2">Perfil de Vendedor</div>
        </div> 
        <div data-selector="businesses" class="nvActiCon5 nvActiCon5Act">
          <div class="nvActiText2 nvActiText2Act">Negocios</div>
        </div>
        <div data-selector="listings" class="nvActiCon5">
          <div class="nvActiText2">Listados</div>
        </div>





      </div>
    </div>
  </div>
  <div id="nvActiCon8Items" class="nvActiCon8"></div>

</div>
    `;
    }
    _noActi(title = 'Sin publicaciones', description = "Debes publicar algo primero", buttonLabel = 'Publicar', opento = 'uploadGeneral') {
        let dispButton = 'none';
        if (buttonLabel) dispButton = 'flex';
        return `
<div class="nvActiCon9">
  <div class="nvActiCon10">
    <div class="nvActiText4">${title}</div>
    <div class="nvActiText5">${description}</div>
  </div>
  <div data-opento="${opento}" class="actiUploadButton nvActiCon7" style="display: ${dispButton}">
    <img height="14px" src="${0, (/*@__PURE__*/$parcel$interopDefault($c761b37634f7dc73$exports))}"/>
    <div class="nvActiText3">${buttonLabel}</div>
  </div>
</div>
  
    
    
    
    `;
    }
    _businesMain() {
        return `
<div class="OwnBusinessCon1">
  <div class="OwnBusinessCon2">
    <div id="OwnBusinessButtonCreateListing" class="OwnBusinessButtonCreateListing">
        <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f8aec8cbd86ee40a$exports))}"/>
      Crear Listado
    </div>
  </div>
  <div class="OwnBusinessCon1B">
    <div
      id="OwnBusinessConBusinessListingsCon"
      class="OwnBusinessConBusinessListingsCon">
    </div>

    <div
      id="bussinessDisplayHeaderCon10ForBusinessOwn"
      class="bussinessDisplayHeaderCon10ForBusinessOwn"
    >
    </div>


  </div>
</div>
    `;
    }
    // _businesListings(html) {
    //   return `
    //    <div id="bussinessDisplayHeaderCon10ForBusinessOwn" class="bussinessDisplayHeaderCon10ForBusinessOwn"></div>
    //   `;
    // }
    _createBusinessPageMessage(account) {
        let message = "A\xfan no tienes una pagina de negocio con nosotros. Crea una p\xe1gina ahorita completamente gratuito";
        if (!account) message += " \n O si ya tienes una p\xe1gina de negocio, debes acceder a tu cuenta para poder administrarlo.";
        return `
  <div class="OwnBusinessCon19">
    <div class="OwnBusinessCon20">
      <div class="OwnBusinessConMessage">
        ${message}
      </div>
    </div>
  </div>
    `;
    }
    _createBusinessPageButtons(account) {
        let accessAccountBtn = ``;
        if (!account) accessAccountBtn = ` <div class="OwnBusinessCon21" style="display: none">
      <div id="OwnBusinessConButtonLogin" class="OwnBusinessConButtonWhatIsBusinessPage">
        Acceder a mi cuenta
      </div>
    </div>`;
        return `
  <div class="OwnBusinessCon21">
    <div class="LogInCon6">
      <div data-helpwith="whatIsBusinessPage" class="WalletCon8 openHelp">
        <div class="WalletText4">\xbfQue es una p\xe1gina de negocio?</div>
      </div>
      <div data-helpwith="createBusinessPage" class="WalletCon8 openHelp">
        <div class="WalletText4">\xbfComo puedo crea mi p\xe1gina de negocio?</div>
      </div>
    </div>
  </div>
  <div class="OwnBusinessCon22">
    <div id="OwnBusinessConButtonCreateBusinessPage" class="OwnBusinessConButtonCreateBusinessPage">
      Crear pagina
        <img height="20px" class="" src="${0, (/*@__PURE__*/$parcel$interopDefault($643956bf3970c6d4$exports))}" />
    </div>
  </div>
  ${accessAccountBtn}


    `;
    }
    _subscriptionPlanHtml(data) {
        let currentSubscriptionHtml = ``;
        if (data) {
            let backgroundColorClass = "mercadoMAIBackground";
            let text1Class = "textColorGreenAction";
            let text2Class = "textColorOrangeAction";
            let endDate = "";
            let startDate = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.startDate);
            let listings = data.numberOfListingsIncluded;
            let availableListings = data.numberOfListingsAvailable;
            let plan = "Un mes";
            const calculatedTime = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._calculateFutureDate(data.startDate, data.time);
            endDate = calculatedTime.calculatedDate;
            if (data.plan === "year") {
                plan = "Un a\xf1o";
                text1Class = "textColorOrangeAction";
                text2Class = "textColorGreenAction";
                backgroundColorClass = "mercadoMAIProBackground";
            }
            if (data.unlimited) {
                listings = "ilimitado";
                availableListings = "ilimitado";
            }
            currentSubscriptionHtml = `
        <div class="SubBusPlanCurrPlanCon1 ${backgroundColorClass}">
          <div class="SubBusPlanCurrPlanText1">Tu plan Actual</div>
          <div class="SubBusPlanCurrPlanCon2">
            <div class="SubBusPlanCurrPlanCon3">
              <div class="SubBusPlanCurrPlanText2 ${text1Class}">Plan</div>
              <div class="SubBusPlanCurrPlanText3 ${text2Class}">${plan}</div>
            </div>
            <div class="SubBusPlanCurrPlanCon3">
              <div class="SubBusPlanCurrPlanText2 ${text1Class}">Listados incluidos</div>
              <div class="SubBusPlanCurrPlanText3 ${text2Class}">${listings}</div>
            </div>            
            <div class="SubBusPlanCurrPlanCon3">
              <div class="SubBusPlanCurrPlanText2 ${text1Class}">Listados disponibles</div>
              <div class="SubBusPlanCurrPlanText3 ${text2Class}">${availableListings}</div>
            </div>
            <div class="SubBusPlanCurrPlanCon3">
              <div class="SubBusPlanCurrPlanText2 ${text1Class}">Fecha de inicio</div>
              <div class="SubBusPlanCurrPlanText3 ${text2Class}">${startDate}</div>
            </div>
            <div class="SubBusPlanCurrPlanCon3">
              <div class="SubBusPlanCurrPlanText2 ${text1Class}">Tiempo</div>
              <div class="SubBusPlanCurrPlanText3 ${text2Class}">${data.time} d\xedas</div>
            </div>
            <div class="SubBusPlanCurrPlanCon3">
              <div class="SubBusPlanCurrPlanText2 ${text1Class}">Vence el</div>
              <div class="SubBusPlanCurrPlanText3 ${text2Class}">${endDate}</div>
            </div>
            <div class="SubBusPlanCurrPlanCon3">
              <div class="SubBusPlanCurrPlanText2 ${text1Class}">Precio</div>
              <div class="SubBusPlanCurrPlanText3 ${text2Class}">$${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatToPrice(data.price)}</div>
            </div>
          </div>
        </div>
        `;
        }
        return `
      <div class="SubBusPlanCon1A">
        <div class="LogInCon6">
          <div data-helpwith="subscription" class="WalletCon8 openHelp">
            <div class="WalletText4">Conocer las subscripciones</div>
          </div>
        </div>
        ${currentSubscriptionHtml}
        <div class="SubBusPlanCurrPlanCon4">
          <div id="subscriptionPlanTextHeader" class="SubBusPlanCurrPlanText4">Renueva tu plan</div>
        </div>
        <div id="subscriptionPlanConMonth" class="SubBusPlanCon1 mercadoMAIBackground">
          <div class="SubBusPlanCon2">
            <img height="32px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1034e4a6d12d04d7$exports))}" alt="" />
            <div class="SubBusPlanCon4">
              <div class="SubBusPlanCon5">
                <div class="SubBusPlanCon6 mercadoMAIBackground">
                  <div class="SubBusPlanConText1">Un mes</div>
                  <div class="SubBusPlanConText2">$290</div>
                </div>
                <div id="subscriptionPlanSelectYearButton" class="SubBusPlanCon7">
                  <div class="SubBusPlanConText3">Un a\xf1o</div>
                  <div class="SubBusPlanConText2">$2,958</div>
                </div>
              </div>
              <div class="SubBusPlanConText5">ahora 15% en el plan de un a\xf1o</div>
            </div>
          </div>
          <div class="SubBusPlanCon8">
            <div class="SubBusPlanCon9">
              <div class="SubBusPlanConText6">Listados</div>
            </div>
            <div class="SubBusPlanCon10">
              <div class="SubBusPlanConText7">Escoge el n\xfamero de listados que quieres con tu plan</div>
              <div id="subscriptionPlanSelectListingsMonth" class="SubBusPlanCon11">
                <div data-selected="true" data-numberoflistings="included" class="SubBusPlanCon12 SubBusPlanCon12Active">
                  <div class="SubBusPlanCon12Text SubBusPlanConText8">10</div>
                  <div class="SubBusPlanConText9">Incluido</div>
                </div>
                <div data-selected="false" data-numberoflistings="20" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10">20</div>
                  <div class="SubBusPlanConText9">+ $290</div>
                </div>
                <div data-selected="false" data-numberoflistings="30" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10">30</div>
                  <div class="SubBusPlanConText9">+ $480</div>
                </div>
                <div data-selected="false" data-numberoflistings="45" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10">45</div>
                  <div class="SubBusPlanConText9">+ $600</div>
                </div>
                <div data-selected="false" data-numberoflistings="unlimited" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10">ilimitado</div>
                  <div class="SubBusPlanConText9">+ $1,280</div>
                </div>
              </div>
            </div>
          </div>
          <div class="SubBusPlanCon8">
            <div class="SubBusPlanCon9">
              <div class="SubBusPlanConText6">Aumentar vistas de tus listados</div>
            </div>
            <div class="SubBusPlanCon10">
              <div class="SubBusPlanCon13">
                <div class="SubBusPlanCon14">
                  <div class="SubBusPlanConText11">Puedes incluir un nivel de prioridad a este plan, y este nivel ser\xe1 agregado a tus listados al publicarlos</div>
                </div>
                <div class="SubBusPlanCon15">
                  <div class="SubBusPlanCon16">
                    <div class="SubBusPlanConText12">puntos</div>
                    <div class="SubBusPlanConText9">+ $.50 cada punto</div>
                  </div>
                  <div class="SubBusPlanCon17">
                  <input class="SubBusPlanCon18 SubBusPlanConText13" id="subscriptionPlanInputPriorityPointsMonth" inputmode="numeric" placeholder="0"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="SubBusPlanCon19">
            <div class="SubBusPlanCon20">
              <div class="SubBusPlanCon21">
                <div id="subscriptionPlanFinalPriceMonth" class="SubBusPlanConText14">$290</div>
                <div class="SubBusPlanConText15">MXN</div>
              </div>
              <div class="SubBusPlanConText16">/mes</div>
            </div>
            <div class="subscriptionPlanNextButtons SubBusPlanCon22">
              <div class="SubBusPlanConText17">Siguiente</div>
              <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($4ef0f4e56773f3c2$exports))}" alt="" />
            </div>
          </div>
        </div>
        <div id="subscriptionPlanConYear" class="SubBusPlanCon1 mercadoMAIProBackground" style="display: none">
          <div class="SubBusPlanCon2">
            <img height="32px" src="${0, (/*@__PURE__*/$parcel$interopDefault($1034e4a6d12d04d7$exports))}" alt="" />
            <div class="SubBusPlanCon4">
              <div class="SubBusPlanCon5">
                <div id="subscriptionPlanSelectMonthButton" class="SubBusPlanCon6B">
                  <div class="SubBusPlanConText1B">Un mes</div>
                  <div class="SubBusPlanConText2">$290</div>
                </div>
                <div class="SubBusPlanCon7B mercadoMAIProBackground">
                  <div class="SubBusPlanConText1">Un a\xf1o</div>
                  <div class="SubBusPlanConText2">$2,958</div>
                </div>
              </div>
              <div class="SubBusPlanConText5">ahora 15% en el plan de un a\xf1o</div>
            </div>
          </div>
          <div class="SubBusPlanCon8">
            <div class="SubBusPlanCon9">
              <div class="SubBusPlanConText6B">Listados</div>
            </div>
            <div class="SubBusPlanCon10">
              <div class="SubBusPlanConText7">Escoge el n\xfamero de listados que quieres con tu plan</div>
              <div id="subscriptionPlanSelectListingsYear" class="SubBusPlanCon11">
                <div data-selected="true" data-numberoflistings="included" class="SubBusPlanCon12 SubBusPlanCon12ActivePro">
                  <div class="SubBusPlanCon12Text SubBusPlanConText8">120</div>
                  <div class="SubBusPlanConText9">Incluido</div>
                </div>
                <div data-selected="false" data-numberoflistings="240" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10B">240</div>
                  <div class="SubBusPlanConText9">+ $2,958</div>
                </div>
                <div data-selected="false" data-numberoflistings="360" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10B">360</div>
                  <div class="SubBusPlanConText9">+ $4,896</div>
                </div>
                <div data-selected="false" data-numberoflistings="540" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10B">540</div>
                  <div class="SubBusPlanConText9">+ $5,508</div>
                </div>
                <div data-selected="false" data-numberoflistings="unlimited" class="SubBusPlanCon12 SubBusPlanCon12NoneActive">
                  <div class="SubBusPlanCon12Text SubBusPlanConText10B">ilimitado</div>
                  <div class="SubBusPlanConText9">+ $13,056</div>
                </div>
              </div>
            </div>
          </div>
          <div class="SubBusPlanCon8">
            <div class="SubBusPlanCon9">
              <div class="SubBusPlanConText6B">Aumentar vistas de tus listados</div>
            </div>
            <div class="SubBusPlanCon10">
              <div class="SubBusPlanCon13">
                <div class="SubBusPlanCon14">
                  <div class="SubBusPlanConText11 textColorOrangeAction">Puedes incluir un nivel de prioridad a este plan, y este nivel ser\xe1 agregado a tus listados al publicarlos</div>
                </div>
                <div class="SubBusPlanCon15">
                  <div class="SubBusPlanCon16">
                    <div class="SubBusPlanConText12">puntos</div>
                    <div class="SubBusPlanConText9">+ $.50 cada punto</div>
                  </div>
                  <div class="SubBusPlanCon17">
                    <input class="SubBusPlanCon18 SubBusPlanConText13" id="subscriptionPlanInputPriorityPointsYear" inputmode="numeric" placeholder="0"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="SubBusPlanCon19">
            <div class="SubBusPlanCon20">
              <div class="SubBusPlanCon21">
                <div id="subscriptionPlanFinalPriceYear"  class="SubBusPlanConText14B">$2,958</div>
                <div class="SubBusPlanConText15B">MXN</div>
              </div>
              <div class="SubBusPlanConText16B">/a\xf1o</div>
            </div>
            <div class="subscriptionPlanNextButtons SubBusPlanCon22B">
              <div class="SubBusPlanConText17">Siguiente</div>
              <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($4ef0f4e56773f3c2$exports))}" alt="" />
            </div>
          </div>
        </div>
        <div class="subscriptionPlanExitButtons SubBusPlanCon3">Cerrar</div>
      </div>
    
    `;
    }
}
var $95daa10db0d540ef$export$2e2bcd8739ae039 = new $95daa10db0d540ef$var$GenerateHtml();




var $e123d817210ae976$exports = {};
$e123d817210ae976$exports = new URL("camara.371afd6c.png", import.meta.url).toString();


var $cbdb3f8f381da9a8$exports = {};
$cbdb3f8f381da9a8$exports = new URL("up-down.2c070ea6.png", import.meta.url).toString();


var $20e2c971d2fb8a9a$exports = {};
$20e2c971d2fb8a9a$exports = new URL("delete.6d530767.png", import.meta.url).toString();








class $7c3ae6448f73cddf$var$GenerateHtmlEditorTools {
    // FUNCTION Part header
    _headerInputs(data) {
        return `   
<div class="InputMiniCon1">
  <div class="InputMiniCon2">
    <div class="InputMiniLabel">Nombre de negocio</div>
    <input id="BusinessEditorNameInput"
      placeholder="Nombre del negocio"
      class="InputMiniInput InputForFocusCheck"
      type="text"
      value="${data.name}"
    />
  </div>
</div>
<div class="InputMiniCon1">
  <div class="InputMiniCon2">
    <div class="InputMiniLabel">Descripci\xf3n corta de negocio</div>
    <input id="BusinessEditorShortDescriptionInput"
      placeholder="Descripci\xf3n corta del negocio"
      class="InputMiniInput InputForFocusCheck"
      type="text"
      value="${data.shortDescription}"
    />
  </div>
</div>
    `;
    }
    _headerImages() {
        return `
<label
  for="BusinessPageEditorSelectImgBackground"
  class="BusinessPageEditorSelectImgCon1"
>
  <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($e123d817210ae976$exports))}" alt="" />
  <div class="BusinessPageEditorSelectImgLabel">Escoge una imagen de fondo</div>
</label>
<label
  for="BusinessPageEditorSelectImgProfile"
  class="BusinessPageEditorSelectImgCon1"
>
  <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($e123d817210ae976$exports))}" alt="" />
  <div class="BusinessPageEditorSelectImgLabel">
    Escoge una imagen de negocio
  </div>
</label>
    `;
    }
    // FUNCTION Part listings
    _listingsApear() {
        return `
<div class="BusinessPageEditorListingsApearCon1A">
  <label class="BusinessPageEditorListingsApearCon1">
    <div class="BusinessPageEditorListingsApearCon2">
      <div class="BusinessPageEditorListingsApearCon3">
        <div class="BusinessPageEditorListingsApearConB1"></div>
        <div class="BusinessPageEditorListingsApearConB2">
          <div class="BusinessPageEditorListingsApearConB3"></div>
          <div class="BusinessPageEditorListingsApearConB4"></div>
          <div class="BusinessPageEditorListingsApearConB5"></div>
          <div class="BusinessPageEditorListingsApearConB6">
            <div class="BusinessPageEditorListingsApearConB7"></div>
            <div class="BusinessPageEditorListingsApearConB8"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="BusinessPageEditorListingsApearText">Vertical</div>
    <input id="BusinessEditorListsAppearVirtical"
      type="radio"
      name="layout"
      value="vertical"
      class="BusinessPageEditorRadio"
    />
  </label>
  <label class="BusinessPageEditorListingsApearCon4">
    <div class="BusinessPageEditorListingsApearCon5">
      <div class="BusinessPageEditorListingsApearCon6">
        <div class="BusinessPageEditorListingsApearConB9"></div>
        <div class="BusinessPageEditorListingsApearConB10">
          <div class="BusinessPageEditorListingsApearConB11"></div>
          <div class="BusinessPageEditorListingsApearConB12"></div>
          <div class="BusinessPageEditorListingsApearConB13"></div>
          <div class="BusinessPageEditorListingsApearConB14">
            <div class="BusinessPageEditorListingsApearConB15"></div>
            <div class="BusinessPageEditorListingsApearConB16"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="BusinessPageEditorListingsApearText">Horizontal</div>
    <input id="BusinessEditorListsAppearHorizontal"
      type="radio"
      name="layout"
      value="horizontal"
      class="BusinessPageEditorRadio"
    />
  </label>
</div>

    `;
    }
    _creatLists(lists, tags) {
        console.log(lists);
        let html = ``;
        lists.forEach((list)=>{
            let tagOptions = `<option value="${list.tag}">${list.tag}</option>`;
            let autoManualOptions = ``;
            tags.forEach((tag)=>{
                tagOptions += `<option value="${tag}">${tag}</option>`;
            });
            if (list.type !== "auto") {
                if (list.type === "todos") {
                    autoManualOptions = `
          <option value="todos">todos</option>
          `;
                    html += this._listingsList(list, "", tagOptions, autoManualOptions, list.type);
                } else {
                    autoManualOptions = `
          <option value="auto">Por etiqueta</option>
          `;
                    // { <option value="manual">Agregar listados individualmente</option>}
                    html += this._listingsList(list, "", tagOptions, autoManualOptions);
                }
            } else {
                autoManualOptions = `
        <option value="auto">Por etiqueta</option>
        `;
                // <option value="manual">Agregar listados individualmente</option>
                html += this._listingsList(list, "", tagOptions, autoManualOptions);
            }
        });
        return this._listingsLists(html);
    }
    _listingsList(list, tagDisplay, tagOptions, autoManualOptions, type) {
        return `
    <div data-idsarray="${list.ids}" class="BusinessPageEditorListingsListsCon2" draggable="true">
  <div class="BusinessPageEditorListingsListsCon2B">
 ${type !== "todos" ? `<div class="BusinessPageEditorListingsListsCon3 BusinessPageEditorListingsListDelete"> <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($20e2c971d2fb8a9a$exports))}" alt="" /></div>` : ""}
    <div class="BusinessPageEditorListingsListsCon3 BusinessPageEditorListingsListOrder" draggable="false">
    <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($cbdb3f8f381da9a8$exports))}" alt="" />
    </div>
  </div>
  <div class="BusinessPageEditorListingsListsCon4">
    <div class="BusinessPageEditorListingsListsCon5">
      <div class="BusinessPageEditorListingsListsLabel">Nombre de lista</div>
      <input
        class="BusinessPageEditorListingsListsInputName InputForFocusCheck"
        id="BusinessPageEditorListingsListsListName"
        placeholder="en oferta"
        type="text"
        value="${list.name}"
      />
    </div>
    <div class="BusinessPageEditorListingsListsCon5">
      <div class="BusinessPageEditorListingsListsLabel">Tipo de lista</div>
      <select ${type === "todos" ? `disabled` : ""}
        class="BusinessPageEditorListingsListsChoose"
        name=""
        id="BusinessPageEditorListingsListsListTypeSelect"
      >
      ${autoManualOptions}
      </select>
    </div>
    <div style="display: ${tagDisplay}" class="BusinessPageEditorListingsListsCon5">
      <div class="BusinessPageEditorListingsListsLabel">Etiquetas</div>
      <select
        class="BusinessPageEditorListingsListsChoose"
        name=""
        id="BusinessPageEditorListingsListsListTagSelect"
      >
      ${tagOptions}
      </select>
    </div>
  </div>
</div>

  `;
    }
    _listingsLists(listHtml) {
        return `
<div class="BusinessPageEditorListingsListsCon1">
  ${listHtml}
</div>
<div class="BusinessPageEditorListingsListsCon7">
  <button id="BusinessPageEditorListingsListsButtonNewList" class="BusinessPageEditorListingsListsButtonNewList">
      <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f8aec8cbd86ee40a$exports))}" alt="" />
    Nueva lista
  </button>
</div>

  `;
    }
    // FUNCTION Part info
    _infoLocation(data) {
        return `
<div class="BusinessPageEditorInfoCon2">
  <label for="BusinessPageEditorLocationInput">
    <img
      id="BusinessPageEditorOpenMapButton"
      height="20px"
      src="${0, (/*@__PURE__*/$parcel$interopDefault($48b57b26aaf6c3c1$exports))}"
      alt=""
    />
  </label>
  <input
    type="text"
    placeholder="Search for a location..."
    id="BusinessPageEditorLocationInput"
    value="${data.name}"
  />
  <div id="BusinessEditorLocationMyLocationCon1" style="display: none" class="BusinessEditorLocationMyLocationCon1">
      <img
        id="BusinessPageEditorOpenMapButtonLocator"
        height="20px"
        src="${0, (/*@__PURE__*/$parcel$interopDefault($e21640a4543ad06d$exports))}"
        alt=""
      />
    <div class="BusinessEditorLocationMyLocationText">
      Ubicar
    </div>
  </div>
</div>
<div style="display: none" id="BusinessPageEditorMapContainer1">
  <div
    id="BusinessPageEditorMapContainer"
    class="BusinessPageEditorMapContainer"
  ></div>
  <div id="BusinessPageEditorMapCenterMarker"><img
    id="BusinessPageEditorOpenMapButtonLocator"
    height="24px"
    src="${0, (/*@__PURE__*/$parcel$interopDefault($a1958079b1b1bc47$exports))}"
    alt=""
  /></div>
</div>
<div class="InputMiniCon2">
  <div class="InputMiniCon2">
    <div class="InputMiniLabel">Referencias</div>
    <input
      id="BusinessPageEditorLocationDescriptionInput"
      class="InputMiniInput InputForFocusCheck"
      type="text"
      placeholder="Describe el lugar"
      value="${data.description}"
    />
  </div>
</div>

    `;
    }
    _infoContacts(data) {
        let callNumber = "";
        let whatsAppNumber = "";
        let email = "";
        let website = "";
        if (data.contacts.call && data.contacts.call.contact !== "") callNumber = data.contacts.call.contact;
        if (data.contacts.whatsApp && data.contacts.whatsApp.contact !== "") whatsAppNumber = data.contacts.whatsApp.contact;
        if (data.contacts.email && data.contacts.email.contact !== "") email = data.contacts.email.contact;
        if (data.contacts.website && data.contacts.website.contact !== "") website = data.contacts.website.contact;
        return `
    <div class="InputCon1">
      <div class="InputMiniCon2">
        <div class="InputMiniLabel">
          Numero de tel\xe9fono para llamadas
        </div>
        <div class="CreateListingImportantMessage">
          El n\xfamero de llamadas debe ser del pa\xeds de M\xe9xico, ya que ocupamos '+52' en
          todos los n\xfameros.
        </div>
        <input class="InputMiniInput InputForFocusCheck" type="text" placeholder="0000000000" value="${callNumber}" />
      </div>
    </div>
    <div class="InputCon1">
      <div class="InputMiniCon2">
        <div class="InputMiniLabel">
          Numero de tel\xe9fono para WhatsApp
        </div>
        <div class="CreateListingImportantMessage">
          El n\xfamero de WhatsApp debe ser del pa\xeds de M\xe9xico, ya que ocupamos '+52' en
          todos los n\xfameros.
        </div>
        <input class="InputMiniInput InputForFocusCheck" type="text" placeholder="0000000000" value="${whatsAppNumber}" />
      </div>
    </div>
    <div class="InputCon1">
      <div class="InputMiniCon2">
        <div class="InputMiniLabel">
          Correo electr\xf3nico
        </div>
        <input class="InputMiniInput InputForFocusCheck" type="text" placeholder="@gmail.com" value="${email}" />
      </div>
    </div>
    <div class="InputCon1">
      <div class="InputMiniCon2">
        <div class="InputMiniLabel">
          P\xe1gina web
        </div>
        <input class="InputMiniInput InputForFocusCheck" type="text" placeholder="https://ejemplo.com" value="${website}" />
      </div>
    </div>`;
    }
    _infoAbout(data) {
        return `

    <textarea
    id="BusinessEditorInfoTextAreaCon1"
      class="BusinessEditorInfoTextAreaCon1 InputForFocusCheck"
      name=""
      id=""
      placeholder="Describe tu negocio aqu\xed. Dile a la gente lo que quieres que sepan sobre tu negocio."
    >${data.about}</textarea>

  `;
    }
    // TODO Maybe use color sets later
    // {<div class="BusinessPageEditorColorsCon4">
    //   <div class="BusinessPageEditorColorsHeaderText">
    //     Elige un conjunto colores
    //   </div>
    // </div>
    // <div class="BusinessEditorColorGroupSelectionCon1A">
    //   <div
    //     class="BusinessEditorColorGroupSelectionCon1 BusinessEditorColorGroupSelectionCon1Active"
    //   >
    //     <div class="BusinessEditorColorGroupSelectionCon2">
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #ffffff"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #e0e0e0"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #aeaeae"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #6d6d6d"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #2b2b2b"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #3a7d44"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #ff7043"
    //       ></div>
    //     </div>
    //   </div>
    //   <div
    //     class="BusinessEditorColorGroupSelectionCon1"
    //   >
    //     <div class="BusinessEditorColorGroupSelectionCon2">
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #ffffff"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #e0e0e0"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #aeaeae"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #6d6d6d"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #2b2b2b"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #3a7d44"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #ff7043"
    //       ></div>
    //     </div>
    //   </div>
    //   <div
    //     class="BusinessEditorColorGroupSelectionCon1"
    //   >
    //     <div class="BusinessEditorColorGroupSelectionCon2">
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #ffffff"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #e0e0e0"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #aeaeae"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #6d6d6d"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #2b2b2b"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #3a7d44"
    //       ></div>
    //       <div
    //         class="BusinessEditorColorGroupSelectionColor"
    //         style="background: #ff7043"
    //       ></div>
    //     </div>
    //   </div>
    // </div>}
    _colors(colors) {
        return `
<div class="BusinessPageEditorColorsCon4">
  <div class="BusinessPageEditorColorsHeaderText">
    Personaliza tus colores
  </div>
</div>
<div class="BusinessPageEditorColorsCon1">
  <div class="BusinessPageEditorColorsTitle">Negocio</div>
  <div class="BusinessPageEditorColorsCon2">
    <label
      for="colorPickerForOpining"
      data-color="${colors.headerPrimary}"
      data-for="headerPrimary"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">Nombre de negocio</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.headerPrimary};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-color="${colors.headerSecondary}"
      data-for="headerSecondary"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">
      Descripci\xf3n corta de negocio
    </div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.headerSecondary};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
  </div>
</div>
<div class="BusinessPageEditorColorsCon1">
  <div class="BusinessPageEditorColorsTitle">Listados</div>
  <div class="BusinessPageEditorColorsCon2">
    <label
      for="colorPickerForOpining"
      data-for="packTitles"
      data-color="${colors.packTitles}"
      class="BusinessPageEditorColorsCon3"
      style="display: none"
    >
    <div class="BusinessPageEditorColorsLabel">Titulos de listas</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.packTitles};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="packTitlesHighlight"
      data-color="${colors.packTitlesHighlight}"
      class="BusinessPageEditorColorsCon3"
      style="display: none"
    >
    <div class="BusinessPageEditorColorsLabel">'Ver todo' de listas</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.packTitlesHighlight};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemBackgroundPrimary"
      data-color="${colors.itemBackgroundPrimary}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">
      Fondo de nombre de listado
    </div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemBackgroundPrimary};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemBackgroundSecondary"
      data-color="${colors.itemBackgroundSecondary}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">
      Fondo de descripci\xf3n de listado
    </div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemBackgroundSecondary};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemTextPrimary"
      data-color="${colors.itemTextPrimary}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">Nombre de listado</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemTextPrimary};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemTextFour"
      data-color="${colors.itemTextFour}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">Precio de listado</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemTextFour};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemTextSecondary"
      data-color="${colors.itemTextSecondary}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">Descripci\xf3n de listado</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemTextSecondary};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemTextTerteriary"
      data-color="${colors.itemTextTerteriary}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">Otro texto de listado</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemTextTerteriary};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemHighlight"
      data-color="${colors.itemHighlight}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">Resaltos en listados</div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemHighlight};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
    <label
      for="colorPickerForOpining"
      data-for="itemHighlightText"
      data-color="${colors.itemHighlightText}"
      class="BusinessPageEditorColorsCon3"
    >
    <div class="BusinessPageEditorColorsLabel">
      Texto de resalto en listados
    </div>
    <div class="BusinessPageEditorColorsCon3B">
      <div
        style="background-color: #${colors.itemHighlightText};"
        class="BusinessPageEditorColorsColorInEditor"
      ></div>
      <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($f712e9428771bc05$exports))}" alt="" />
      </div>
    </label>
  </div>
</div>


    `;
    }
    // FUNCTION Portion creator
    _helperPortionCreator(title, html) {
        return ` 
  <div class="BusinessPageEditorPortionCon1">
    <div class="BusinessPageEditorColorsCon4">
      <div class="BusinessPageEditorColorsHeaderText">
        ${title}
      </div>
    </div>
    <div class="BusinessPageEditorPortionCon3">${html}</div>
  </div>
    `;
    }
    _colorThemeTheme() {
        // TODO Need to only feature 6 colors and divide them.
        return `
<div class="ColorThemeCon1">
  <div class="ColorThemeText1">Professional</div>
  <div class="ColorThemeCon2">
    <div class="ColorThemeCon3">
      <div class="ColorThemeCon4"></div>
      <div class="ColorThemeCon4"></div>
      <div class="ColorThemeCon4"></div>
      <div class="ColorThemeCon4"></div>
      <div class="ColorThemeCon4"></div>
      <div class="ColorThemeCon4"></div>
    </div>
    <div class="White">
      <div class="Group">
        <div class="Vector"></div>
        <div class="Vector"></div>
      </div>
    </div>
  </div>
</div>
    `;
    }
}
var $7c3ae6448f73cddf$export$2e2bcd8739ae039 = new $7c3ae6448f73cddf$var$GenerateHtmlEditorTools();



class $6b11b388aeb506e5$var$EditorTools {
    elementThatOpenedColorPicker;
    whatForColor;
    constructor(){}
    _colorGetBacker = (color)=>{
        console.log("now here");
        const allColorsPickers = document.querySelectorAll(".BusinessPageEditorColorsCon3");
        allColorsPickers.forEach((colorPicker)=>{
            if (colorPicker.dataset.for === this.whatForColor) {
                const colorSquare = colorPicker.querySelector(".BusinessPageEditorColorsColorInEditor");
                colorSquare.style.backgroundColor = `#${color}`;
            }
        });
    };
    _openColorPickerAndLogColor(colorIn) {
        const colorInput = document.getElementById("colorPickerForOpining");
        colorInput.value = `#${colorIn}`; // Set the initial color
        // Helper function to ensure the color is in '#000000' format
        function formatToHex(color) {
            if (!color.startsWith("#")) {
                const ctx = document.createElement("canvas").getContext("2d");
                ctx.fillStyle = color;
                return ctx.fillStyle; // Converts color to hex
            }
            return color; // Already in hex format
        }
        // Debounce function to limit function calls to 100ms
        function debounce(func, delay) {
            let timeout;
            return (...args)=>{
                clearTimeout(timeout);
                timeout = setTimeout(()=>func(...args), delay);
            };
        }
        // Function to handle color changes
        const handleColorChange = debounce((selectedColor)=>{
            const colorWithoutHash = selectedColor.substring(1); // Remove the first character ('#')
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._colorSetter(colorWithoutHash, this.whatForColor);
            this._colorGetBacker(colorWithoutHash);
            console.log("Selected color:", selectedColor);
        }, 100);
        // Attach a change event listener to log the color
        colorInput.addEventListener("change", ()=>{
            let selectedColor = colorInput.value; // Get the selected color
            selectedColor = formatToHex(selectedColor); // Ensure it's in '#000000' format
            handleColorChange(selectedColor); // Call the debounced handler
        });
        // Simulate a click to open the color picker
        setTimeout(()=>{
            colorInput.click(); // Open the color picker
        }, 0); // Ensure it runs after the current event loop
    }
    _eventBusinessColors() {
        const allColorsPickers = document.querySelectorAll(".BusinessPageEditorColorsCon3");
        allColorsPickers.forEach(async (colorPicker)=>{
            colorPicker.addEventListener("click", async (e)=>{
                this.elementThatOpenedColorPicker = e.target;
                const closestColorPicker = e.target.closest(".BusinessPageEditorColorsCon3");
                this.whatForColor = closestColorPicker.dataset.for;
                console.log(closestColorPicker.dataset.for); // Logs the closest element with the class
                const colorForIn = closestColorPicker.dataset.color;
                console.log(colorForIn);
                console.log("clicked");
                this._openColorPickerAndLogColor(colorForIn);
            });
        });
    }
    _init(part, data, tags) {
        const editorCon = document.getElementById("BusinessPageEditorCon4");
        const editorContainer = document.querySelector(".BusinessPageEditorCon1");
        const BusinessPageEditorListingsApearButtonsHideMoreTools = document.querySelectorAll(".BusinessPageEditorListingsApearButtonHideMoreTools");
        editorContainer.classList.remove("BusinessPageEditorCon1Hidden");
        editorContainer.style.height = "";
        BusinessPageEditorListingsApearButtonsHideMoreTools.forEach((button)=>{
            button.addEventListener("click", ()=>{
                editorContainer.style.height = "";
                editorContainer.classList.add("BusinessPageEditorCon1Hidden");
                (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._hideShowTopEditorTools("show");
            });
        });
        if (part === "header") {
            let html;
            html = (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Texto", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._headerInputs(data));
            html += (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Imagenes", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._headerImages());
            editorCon.innerHTML = html;
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._eventBusinessHeader();
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._changeColorsReturn(false);
            // Scroll to the top of the container
            editorCon.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        if (part === "listings") {
            const apearHtml = (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Como aparecen tus listados en busquedas en tu negocio", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._listingsApear());
            const listsHtml = (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Listas de listados", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._creatLists(data.lists, tags));
            editorCon.innerHTML = apearHtml + listsHtml;
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._eventBusinessLists();
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._changeColorsReturn(false);
            // Scroll to the top of the container
            editorCon.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        if (part === "info") {
            const locationHtml = (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Lugar", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._infoLocation(data.place));
            const contactsHtml = (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Conatactos", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._infoContacts(data));
            const aboutHtml = (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Acerca de este negocio", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._infoAbout(data));
            editorCon.innerHTML = locationHtml + contactsHtml + aboutHtml;
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._eventBusinessInfo();
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._changeColorsReturn(false);
            // Scroll to the top of the container
            editorCon.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        if (part === "colors") {
            const colorsHtml = (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._helperPortionCreator("Colores", (0, $7c3ae6448f73cddf$export$2e2bcd8739ae039)._colors(data.colors));
            editorCon.innerHTML = colorsHtml;
            this._eventBusinessColors();
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._changeColorsReturn(true);
            // Scroll to the top of the container
            editorCon.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
}
var $6b11b388aeb506e5$export$2e2bcd8739ae039 = new $6b11b388aeb506e5$var$EditorTools();





/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $df9a6d7fd06616c9$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $df9a6d7fd06616c9$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $df9a6d7fd06616c9$export$697502632950e9d3 extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($df9a6d7fd06616c9$var$prependCode(code), `Firebase Storage: ${message} (${$df9a6d7fd06616c9$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $df9a6d7fd06616c9$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $df9a6d7fd06616c9$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $df9a6d7fd06616c9$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($df9a6d7fd06616c9$export$54592d666d6ce114 || ($df9a6d7fd06616c9$export$54592d666d6ce114 = {}));
function $df9a6d7fd06616c9$var$prependCode(code) {
    return 'storage/' + code;
}
function $df9a6d7fd06616c9$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNKNOWN, message);
}
function $df9a6d7fd06616c9$var$objectNotFound(path) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $df9a6d7fd06616c9$var$quotaExceeded(bucket) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $df9a6d7fd06616c9$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $df9a6d7fd06616c9$var$unauthorizedApp() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $df9a6d7fd06616c9$var$unauthorized(path) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $df9a6d7fd06616c9$var$retryLimitExceeded() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $df9a6d7fd06616c9$var$canceled() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $df9a6d7fd06616c9$var$invalidUrl(url) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $df9a6d7fd06616c9$var$invalidDefaultBucket(bucket) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $df9a6d7fd06616c9$var$noDefaultBucket() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $df9a6d7fd06616c9$var$cannotSliceBlob() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $df9a6d7fd06616c9$var$serverFileWrongSize() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $df9a6d7fd06616c9$var$noDownloadURL() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $df9a6d7fd06616c9$var$missingPolyFill(polyFill) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$8f74d9881d1936fd(message) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $df9a6d7fd06616c9$var$appDeleted() {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $df9a6d7fd06616c9$export$61f54cdc36500ad(name) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $df9a6d7fd06616c9$var$invalidFormat(format, message) {
    return new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $df9a6d7fd06616c9$var$internalError(message) {
    throw new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $df9a6d7fd06616c9$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $df9a6d7fd06616c9$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $df9a6d7fd06616c9$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $df9a6d7fd06616c9$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $df9a6d7fd06616c9$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $df9a6d7fd06616c9$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $df9a6d7fd06616c9$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $df9a6d7fd06616c9$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$isFunction(p) {
    return typeof p === 'function';
}
function $df9a6d7fd06616c9$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $df9a6d7fd06616c9$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $df9a6d7fd06616c9$var$isNativeBlob(p) {
    return $df9a6d7fd06616c9$var$isNativeBlobDefined() && p instanceof Blob;
}
function $df9a6d7fd06616c9$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $df9a6d7fd06616c9$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $df9a6d7fd06616c9$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $df9a6d7fd06616c9$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $df9a6d7fd06616c9$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($df9a6d7fd06616c9$var$ErrorCode || ($df9a6d7fd06616c9$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $df9a6d7fd06616c9$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $df9a6d7fd06616c9$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $df9a6d7fd06616c9$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                    backoffCallback(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $df9a6d7fd06616c9$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($df9a6d7fd06616c9$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $df9a6d7fd06616c9$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $df9a6d7fd06616c9$var$appDeleted() : $df9a6d7fd06616c9$var$canceled();
                    reject(err);
                } else {
                    const err = $df9a6d7fd06616c9$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $df9a6d7fd06616c9$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $df9a6d7fd06616c9$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $df9a6d7fd06616c9$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $df9a6d7fd06616c9$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : 'AppManager');
}
function $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $df9a6d7fd06616c9$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true) {
    const queryPart = $df9a6d7fd06616c9$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $df9a6d7fd06616c9$var$addGmpidHeader_(headers, appId);
    $df9a6d7fd06616c9$var$addAuthHeader_(headers, authToken);
    $df9a6d7fd06616c9$var$addVersionHeader_(headers, firebaseVersion);
    $df9a6d7fd06616c9$var$addAppCheckHeader_(headers, appCheckToken);
    return new $df9a6d7fd06616c9$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $df9a6d7fd06616c9$var$getBlob$1(...args) {
    const BlobBuilder1 = $df9a6d7fd06616c9$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $df9a6d7fd06616c9$export$697502632950e9d3($df9a6d7fd06616c9$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $df9a6d7fd06616c9$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $df9a6d7fd06616c9$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $df9a6d7fd06616c9$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $df9a6d7fd06616c9$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $df9a6d7fd06616c9$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$utf8Bytes_(stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$base64Bytes_(format, stringData));
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL:
            return new $df9a6d7fd06616c9$var$StringData($df9a6d7fd06616c9$var$dataURLBytes_(stringData), $df9a6d7fd06616c9$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $df9a6d7fd06616c9$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $df9a6d7fd06616c9$var$utf8Bytes_(decoded);
}
function $df9a6d7fd06616c9$var$base64Bytes_(format, value) {
    switch(format){
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $df9a6d7fd06616c9$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $df9a6d7fd06616c9$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $df9a6d7fd06616c9$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $df9a6d7fd06616c9$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $df9a6d7fd06616c9$var$invalidFormat($df9a6d7fd06616c9$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $df9a6d7fd06616c9$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $df9a6d7fd06616c9$var$dataURLBytes_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    if (parts.base64) return $df9a6d7fd06616c9$var$base64Bytes_($df9a6d7fd06616c9$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $df9a6d7fd06616c9$var$percentEncodedBytes_(parts.rest);
}
function $df9a6d7fd06616c9$var$dataURLContentType_(dataUrl) {
    const parts = new $df9a6d7fd06616c9$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $df9a6d7fd06616c9$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $df9a6d7fd06616c9$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($df9a6d7fd06616c9$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($df9a6d7fd06616c9$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $df9a6d7fd06616c9$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($df9a6d7fd06616c9$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $df9a6d7fd06616c9$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7($df9a6d7fd06616c9$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($df9a6d7fd06616c9$var$isString(val)) return $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0($df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $df9a6d7fd06616c9$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($df9a6d7fd06616c9$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $df9a6d7fd06616c9$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $df9a6d7fd06616c9$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $df9a6d7fd06616c9$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$noXform_(metadata, value) {
    return value;
}
class $df9a6d7fd06616c9$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $df9a6d7fd06616c9$var$noXform_;
    }
}
let $df9a6d7fd06616c9$var$mappings_ = null;
function $df9a6d7fd06616c9$var$xformPath(fullPath) {
    if (!$df9a6d7fd06616c9$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $df9a6d7fd06616c9$var$lastComponent(fullPath);
}
function $df9a6d7fd06616c9$var$getMappings() {
    if ($df9a6d7fd06616c9$var$mappings_) return $df9a6d7fd06616c9$var$mappings_;
    const mappings = [];
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('bucket'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('generation'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('metageneration'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $df9a6d7fd06616c9$var$xformPath(fullPath);
    }
    const nameMapping = new $df9a6d7fd06616c9$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $df9a6d7fd06616c9$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('timeCreated'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('updated'));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('md5Hash', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('cacheControl', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentDisposition', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentEncoding', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentLanguage', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('contentType', null, true));
    mappings.push(new $df9a6d7fd06616c9$var$Mapping('metadata', 'customMetadata', true));
    $df9a6d7fd06616c9$var$mappings_ = mappings;
    return $df9a6d7fd06616c9$var$mappings_;
}
function $df9a6d7fd06616c9$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $df9a6d7fd06616c9$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $df9a6d7fd06616c9$var$addRef(metadata, service);
    return metadata;
}
function $df9a6d7fd06616c9$var$fromResourceString(service, resourceString, mappings) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromResource(service, resource, mappings);
}
function $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$df9a6d7fd06616c9$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $df9a6d7fd06616c9$var$makeUrl(urlPart, host, protocol);
        const queryString = $df9a6d7fd06616c9$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $df9a6d7fd06616c9$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $df9a6d7fd06616c9$var$PREFIXES_KEY = 'prefixes';
const $df9a6d7fd06616c9$var$ITEMS_KEY = 'items';
function $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]) for (const path of resource[$df9a6d7fd06616c9$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$df9a6d7fd06616c9$var$ITEMS_KEY]) for (const item of resource[$df9a6d7fd06616c9$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $df9a6d7fd06616c9$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $df9a6d7fd06616c9$var$fromResponseString(service, bucket, resourceString) {
    const obj = $df9a6d7fd06616c9$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $df9a6d7fd06616c9$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $df9a6d7fd06616c9$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $df9a6d7fd06616c9$var$handlerCheck(cndn) {
    if (!cndn) throw $df9a6d7fd06616c9$var$unknown();
}
function $df9a6d7fd06616c9$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $df9a6d7fd06616c9$var$fromResponseString(service, bucket, text);
        $df9a6d7fd06616c9$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $df9a6d7fd06616c9$var$fromResourceString(service, text, mappings);
        $df9a6d7fd06616c9$var$handlerCheck(metadata !== null);
        return $df9a6d7fd06616c9$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $df9a6d7fd06616c9$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $df9a6d7fd06616c9$var$unauthorizedApp();
            else newErr = $df9a6d7fd06616c9$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $df9a6d7fd06616c9$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $df9a6d7fd06616c9$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$objectErrorHandler(location) {
    const shared = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $df9a6d7fd06616c9$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $df9a6d7fd06616c9$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $df9a6d7fd06616c9$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $df9a6d7fd06616c9$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$objectErrorHandler(location);
    return requestInfo;
}
function $df9a6d7fd06616c9$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $df9a6d7fd06616c9$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $df9a6d7fd06616c9$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $df9a6d7fd06616c9$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $df9a6d7fd06616c9$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, $df9a6d7fd06616c9$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $df9a6d7fd06616c9$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $df9a6d7fd06616c9$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $df9a6d7fd06616c9$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $df9a6d7fd06616c9$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $df9a6d7fd06616c9$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $df9a6d7fd06616c9$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $df9a6d7fd06616c9$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $df9a6d7fd06616c9$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        $df9a6d7fd06616c9$var$handlerCheck($df9a6d7fd06616c9$var$isString(url));
        return url;
    }
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $df9a6d7fd06616c9$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $df9a6d7fd06616c9$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $df9a6d7fd06616c9$var$handlerCheck(false);
        const size = Number(sizeString);
        $df9a6d7fd06616c9$var$handlerCheck(!isNaN(size));
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $df9a6d7fd06616c9$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $df9a6d7fd06616c9$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $df9a6d7fd06616c9$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $df9a6d7fd06616c9$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $df9a6d7fd06616c9$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $df9a6d7fd06616c9$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $df9a6d7fd06616c9$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $df9a6d7fd06616c9$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $df9a6d7fd06616c9$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $df9a6d7fd06616c9$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $df9a6d7fd06616c9$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $df9a6d7fd06616c9$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $df9a6d7fd06616c9$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $df9a6d7fd06616c9$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $df9a6d7fd06616c9$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $df9a6d7fd06616c9$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $df9a6d7fd06616c9$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .send() more than once');
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $df9a6d7fd06616c9$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $df9a6d7fd06616c9$var$XhrTextConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $df9a6d7fd06616c9$var$newTextConnection() {
    return $df9a6d7fd06616c9$var$textFactoryOverride ? $df9a6d7fd06616c9$var$textFactoryOverride() : new $df9a6d7fd06616c9$var$XhrTextConnection();
}
class $df9a6d7fd06616c9$var$XhrBytesConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $df9a6d7fd06616c9$var$newBytesConnection() {
    return new $df9a6d7fd06616c9$var$XhrBytesConnection();
}
class $df9a6d7fd06616c9$var$XhrBlobConnection extends $df9a6d7fd06616c9$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $df9a6d7fd06616c9$var$newBlobConnection() {
    return new $df9a6d7fd06616c9$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $df9a6d7fd06616c9$export$86a2a9b92406a048 {
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $df9a6d7fd06616c9$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($df9a6d7fd06616c9$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $df9a6d7fd06616c9$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $df9a6d7fd06616c9$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($df9a6d7fd06616c9$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $df9a6d7fd06616c9$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $df9a6d7fd06616c9$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $df9a6d7fd06616c9$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $df9a6d7fd06616c9$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $df9a6d7fd06616c9$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $df9a6d7fd06616c9$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state)){
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                    $df9a6d7fd06616c9$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
                case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $df9a6d7fd06616c9$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $df9a6d7fd06616c9$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.RUNNING:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $df9a6d7fd06616c9$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $df9a6d7fd06616c9$var$async(observer.complete.bind(observer))();
                break;
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.CANCELED:
            case $df9a6d7fd06616c9$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $df9a6d7fd06616c9$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $df9a6d7fd06616c9$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $df9a6d7fd06616c9$export$adb98fff6714334) this._location = location;
        else this._location = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $df9a6d7fd06616c9$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $df9a6d7fd06616c9$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $df9a6d7fd06616c9$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $df9a6d7fd06616c9$export$adb98fff6714334(this._location.bucket, newPath);
        return new $df9a6d7fd06616c9$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $df9a6d7fd06616c9$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $df9a6d7fd06616c9$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $df9a6d7fd06616c9$var$multipartUpload(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings(), new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $df9a6d7fd06616c9$export$86a2a9b92406a048(ref, new $df9a6d7fd06616c9$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$var$uploadString$1(ref, value, format = $df9a6d7fd06616c9$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $df9a6d7fd06616c9$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $df9a6d7fd06616c9$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $df9a6d7fd06616c9$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $df9a6d7fd06616c9$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $df9a6d7fd06616c9$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $df9a6d7fd06616c9$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $df9a6d7fd06616c9$var$getMetadata$2(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $df9a6d7fd06616c9$var$updateMetadata$2(ref.storage, ref._location, metadata, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $df9a6d7fd06616c9$var$getDownloadUrl(ref.storage, ref._location, $df9a6d7fd06616c9$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection).then((url)=>{
        if (url === null) throw $df9a6d7fd06616c9$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $df9a6d7fd06616c9$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $df9a6d7fd06616c9$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $df9a6d7fd06616c9$var$_getChild$1(ref, childPath) {
    const newPath = $df9a6d7fd06616c9$var$child(ref._location.path, childPath);
    const location = new $df9a6d7fd06616c9$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $df9a6d7fd06616c9$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $df9a6d7fd06616c9$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $df9a6d7fd06616c9$var$refFromURL(service, url) {
    return new $df9a6d7fd06616c9$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $df9a6d7fd06616c9$var$refFromPath(ref, path) {
    if (ref instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $df9a6d7fd06616c9$var$noDefaultBucket();
        const reference = new $df9a6d7fd06616c9$var$Reference(service, service._bucket);
        if (path != null) return $df9a6d7fd06616c9$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $df9a6d7fd06616c9$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $df9a6d7fd06616c9$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $df9a6d7fd06616c9$var$FirebaseStorageImpl) return $df9a6d7fd06616c9$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $df9a6d7fd06616c9$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $df9a6d7fd06616c9$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $df9a6d7fd06616c9$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$df9a6d7fd06616c9$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $c38e0f42709c826a$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $df9a6d7fd06616c9$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $df9a6d7fd06616c9$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $df9a6d7fd06616c9$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $df9a6d7fd06616c9$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $df9a6d7fd06616c9$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $df9a6d7fd06616c9$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $df9a6d7fd06616c9$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $df9a6d7fd06616c9$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $df9a6d7fd06616c9$var$FailRequest($df9a6d7fd06616c9$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $df9a6d7fd06616c9$var$name = "@firebase/storage";
const $df9a6d7fd06616c9$var$version = "0.13.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $df9a6d7fd06616c9$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $df9a6d7fd06616c9$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $df9a6d7fd06616c9$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $df9a6d7fd06616c9$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $df9a6d7fd06616c9$export$8548546c0aa631e6(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $df9a6d7fd06616c9$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $df9a6d7fd06616c9$export$8837f4fc672e936d(ref, options) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $df9a6d7fd06616c9$export$6a265a7d315dec03(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $df9a6d7fd06616c9$export$39c5ed4ec960eade(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$deleteObject$1(ref);
}
function $df9a6d7fd06616c9$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(serviceOrRef);
    return $df9a6d7fd06616c9$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $df9a6d7fd06616c9$export$9acd24c0fce96a85(ref, childPath) {
    return $df9a6d7fd06616c9$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $df9a6d7fd06616c9$export$fbd9b57a66480737(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, $df9a6d7fd06616c9$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $df9a6d7fd06616c9$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $df9a6d7fd06616c9$export$9850e656f954b889(storage, host, port, options = {}) {
    $df9a6d7fd06616c9$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $df9a6d7fd06616c9$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return $df9a6d7fd06616c9$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $df9a6d7fd06616c9$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $df9a6d7fd06616c9$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $df9a6d7fd06616c9$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $57d436074e210fb5$export$31499a9cd224b78c));
}
function $df9a6d7fd06616c9$var$registerStorage() {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($df9a6d7fd06616c9$var$STORAGE_TYPE, $df9a6d7fd06616c9$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, '');
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($df9a6d7fd06616c9$var$name, $df9a6d7fd06616c9$var$version, 'esm2017');
}
$df9a6d7fd06616c9$var$registerStorage();




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}








let $aacf0c292643cb7f$var$listingDataPlaceHolder = {
    listingName: "Tractor John Deere",
    listingMachineType: "tractor",
    listingBrand: "john-deere",
    listingModel: "8r-410",
    listingCondition: "usado",
    listingYear: "2023",
    listingPrice: "1800000",
    listingPriceMarkedAs: "negociable",
    listingItemsAvailable: 1,
    listingMarkedAs: "disponible en stock",
    priorityLevelPoints: 1,
    listingCoin: "MXN",
    listingDescription: "Tractor John Deere como nuevo. Tiene 500 horas.",
    listingTokens: [],
    listingViews: 203,
    onDiscount: {
        finalPrice: "1155000",
        percent: "23",
        amount: "345000"
    },
    listingMainImg: "https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/place%20holder%20images%20for%20Mercado%20MAI%2Fjohn-deere-ces.WEBP?alt=media&token=77c2b8ff-98d0-4fde-9562-32408b361db5",
    listingImgsIds: [
        "https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/place%20holder%20images%20for%20Mercado%20MAI%2Fjohn-deere-ces.WEBP?alt=media&token=77c2b8ff-98d0-4fde-9562-32408b361db5"
    ],
    listingWhatsAppNumber: "0000000000",
    listingCallNumber: "0000000000"
};
const $aacf0c292643cb7f$var$prefil = {
    name: "Nombre de negocio",
    shortDescription: "Descripci\xf3n corta de negocio",
    contacts: {
        call: {
            contact: "N\xfamero de llamadas"
        },
        whatsApp: {
            contact: "N\xfamero de WhatsApp"
        },
        email: {
            contact: "Correo electr\xf3nico"
        },
        website: {
            contact: "Sitio web"
        }
    },
    place: {
        name: "",
        locationUrl: "",
        description: "Describe el lugar, da referencias."
    },
    about: "Acerca de tu negocio"
};
let $aacf0c292643cb7f$var$businessData = {
    name: "Nombre de negocio",
    shortDescription: "Descripci\xf3n corta de negocio",
    contacts: {
        call: {
            contact: "N\xfamero de llamadas"
        },
        whatsApp: {
            contact: "N\xfamero de WhatsApp"
        },
        email: {
            contact: "Correo electr\xf3nico"
        },
        website: {
            contact: "Sitio web"
        }
    },
    place: {
        name: "",
        locationUrl: "",
        description: "Describe el lugar, da referencias."
    },
    about: "Acerca de tu negocio",
    backgroundImg: "",
    profileImg: "",
    about: $aacf0c292643cb7f$var$prefil.about,
    listingsApear: "",
    ratedAt: 5,
    numberOfReviews: 0,
    listingsApear: "horizontal",
    lists: [
        {
            name: "En oferta",
            type: "auto",
            tag: "en oferta",
            ids: []
        },
        {
            name: "Tractores",
            type: "auto",
            tag: "tractor",
            ids: []
        },
        {
            name: "Todos",
            type: "todos",
            ids: []
        }
    ],
    colors: {
        headerPrimary: "FFFFFF",
        headerSecondary: "E0E0E0",
        packTitles: "6D6D6D",
        packTitlesHighlight: "3A7D44",
        itemBackgroundPrimary: "3A7D44",
        itemBackgroundSecondary: "6D6D6D",
        itemTextPrimary: "FFFFFF",
        itemTextSecondary: "2B2B2B",
        itemTextTerteriary: "AEAEAE",
        itemTextFour: "FFFFFF",
        itemHighlight: "FF7043",
        itemHighlightText: "FFFFFF"
    }
};
const $aacf0c292643cb7f$var$tags = [
    "en oferta"
];
class $aacf0c292643cb7f$var$BusinessPageEditor {
    #colors = false;
    #hasScrolledToError = false;
    #currentInterval = null;
    #eventsInitialized = false;
    #businessBackGroundImgChange = false;
    #businessProfileImgChange = false;
    #editCurrent;
    constructor(){}
    _getPlaceHolderListingData() {
        return $aacf0c292643cb7f$var$listingDataPlaceHolder;
    }
    _getPlaceHolderBusinessColors() {
        return $aacf0c292643cb7f$var$businessData.colors;
    }
    _setimageChangeState(which) {
        console.log(which);
        if (!which) return;
        if (which === "background") this.#businessBackGroundImgChange = true;
        if (which === "profile") this.#businessProfileImgChange = true;
        if (which === "reset") {
            this.#businessProfileImgChange = false;
            this.#businessBackGroundImgChange = false;
        }
    }
    _changeColorsReturn(input) {
        this.#colors = input;
    }
    async _init(edit, open) {
        console.log(edit, open);
        this.#eventsInitialized = false;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Un momento");
        this.#editCurrent = edit;
        console.log(edit);
        const machineData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData("machineTypes");
        console.log(machineData);
        machineData.forEach((machineType)=>{
            $aacf0c292643cb7f$var$tags.push(machineType.id);
        });
        this._setimageChangeState("reset");
        edit;
        if (edit) {
            const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            console.log(account);
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando tu negocio");
            $aacf0c292643cb7f$var$businessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getBusinessById(account.business);
        }
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        this._setMainEditor(edit);
        if (open === "colors") {
            (0, $6b11b388aeb506e5$export$2e2bcd8739ae039)._init("colors", $aacf0c292643cb7f$var$businessData, $aacf0c292643cb7f$var$tags);
            this._hideShowTopEditorTools("hide");
        }
        if (open === "lists") {
            (0, $6b11b388aeb506e5$export$2e2bcd8739ae039)._init("listings", $aacf0c292643cb7f$var$businessData, $aacf0c292643cb7f$var$tags);
            this._hideShowTopEditorTools("hide");
        }
    // this._events(edit);
    }
    _displayErrorMessage(id, message) {
        const errorMessageCon = document.getElementById(id).parentElement.querySelector(".editorErrorInputMessage");
        errorMessageCon.textContent = message;
        if (!this.#hasScrolledToError) {
            const scrollToElementWithMargin = (id)=>{
                const element = document.getElementById(id);
                if (element) {
                    // if (!scrolled) {
                    // Scroll into view
                    const container = document.getElementById("BusinessPageVisualizerConForInsert"); // Scrollable container
                    container.scrollTo({
                        top: element.offsetTop - (container.offsetTop + 80),
                        behavior: "smooth"
                    });
                    // scrolled = true;
                    // }
                    // Scroll the element into view
                    // element.scrollIntoView({ behavior: "smooth", block: "start" });
                    // Adjust the scroll position to add a 50px margin
                    // window.scrollBy(0, -50); // Scroll 50px up from the element
                    this.#hasScrolledToError = true;
                }
            };
            scrollToElementWithMargin(id);
        }
    }
    _checkFields() {
        this.#hasScrolledToError = false;
        let alertMessage = "Por favor complete los datos necesarios antes de seguir.";
        let canGoOn = true;
        let alertFields = "";
        if ($aacf0c292643cb7f$var$businessData.name === "" || $aacf0c292643cb7f$var$businessData.name === $aacf0c292643cb7f$var$prefil.name) {
            alertFields += "\n- Nombre de negocio";
            this._displayErrorMessage("BusinessEditorInputBusinessName", "El nombre de negocio es obligatorio");
        }
        if ($aacf0c292643cb7f$var$businessData.shortDescription === "" || $aacf0c292643cb7f$var$businessData.shortDescription === $aacf0c292643cb7f$var$prefil.shortDescription) {
            alertFields += "\n- Descripci\xf3n corta de negocio";
            this._displayErrorMessage("BusinessEditorInputBusinessShortDescription", "El descripci\xf3n corta de negocio es obligatorio");
        }
        if ($aacf0c292643cb7f$var$businessData.backgroundImg === "") {
            alertFields += "\n- Imagen de fondo de negocio";
            this._displayErrorMessage("BusinessEditorBCon9EditorToolsButtonBackgroungImg", "La imagen de fondo de negocio es obligatorio");
        }
        if ($aacf0c292643cb7f$var$businessData.profileImg === "") {
            alertFields += "\n- Imagen de perfil de negocio";
            this._displayErrorMessage("BusinessEditorBCon9EditorToolsButtonProfileImg", "La imagen de perfil de negocio es obligatorio");
        }
        if ($aacf0c292643cb7f$var$businessData.listingsApear !== "horizontal" && $aacf0c292643cb7f$var$businessData.listingsApear !== "vertical") alertFields += "\n- Como aparecen tu listados en 'ver todo'";
        if ($aacf0c292643cb7f$var$businessData.place.name === "") {
            alertFields += "\n- Lugar, ubicaci\xf3n.";
            this._displayErrorMessage("BusinessPageEditorLocationInput", "La ubicaci\xf3n de tu negocio es obligatorio");
        }
        if ($aacf0c292643cb7f$var$businessData.place.description === "" || $aacf0c292643cb7f$var$businessData.place.description === $aacf0c292643cb7f$var$prefil.place.description) {
            alertFields += "\n- Lugar, descripci\xf3n del lugar.";
            this._displayErrorMessage("BusinessEditorInputBusinessLocationDescription", "La descripci\xf3n de la ubicaci\xf3n de tu negocio es obligatorio");
        }
        if ($aacf0c292643cb7f$var$businessData.contacts.call) {
            if ($aacf0c292643cb7f$var$businessData.contacts.call.contact === "" || $aacf0c292643cb7f$var$businessData.contacts.call.contact === $aacf0c292643cb7f$var$prefil.contacts.call.contact) {
                alertFields += "\n- N\xfamero de llamadas";
                this._displayErrorMessage("BusinessEditorInputBusinessInfoPhoneNumber", "El n\xfamero de llamadas es obligatorio");
            }
            if ($aacf0c292643cb7f$var$businessData.contacts.call.contact.length < 10 || $aacf0c292643cb7f$var$businessData.contacts.call.contact.length > 10) {
                alertFields += "\n- N\xfamero de llamadas no es un n\xfamero v\xe1lido.";
                this._displayErrorMessage("BusinessEditorInputBusinessInfoPhoneNumber", "El n\xfamero de llamadas no es v\xe1lido");
            }
        } else alertFields += "\n- N\xfamero de llamadas";
        if ($aacf0c292643cb7f$var$businessData.contacts.whatsApp) {
            if ($aacf0c292643cb7f$var$businessData.contacts.whatsApp.contact === "" || $aacf0c292643cb7f$var$businessData.contacts.whatsApp.contact === $aacf0c292643cb7f$var$prefil.contacts.whatsApp.contact) {
                alertFields += "\n- N\xfamero de WhatsApp";
                this._displayErrorMessage("BusinessEditorInputBusinessInfoWhatsAppNumber", "El n\xfamero de WhatsApp es obligatorio");
            }
            if ($aacf0c292643cb7f$var$businessData.contacts.whatsApp.contact.length < 10 || $aacf0c292643cb7f$var$businessData.contacts.whatsApp.contact.length > 10) {
                alertFields += "\n- N\xfamero de WhatsApp no es un n\xfamero v\xe1lido.";
                this._displayErrorMessage("BusinessEditorInputBusinessInfoWhatsAppNumber", "El n\xfamero de WhatsApp no es v\xe1lido");
            }
        } else alertFields += "\n- N\xfamero de WhatsApp";
        if ($aacf0c292643cb7f$var$businessData.contacts.email) {
            if ($aacf0c292643cb7f$var$businessData.contacts.email.contact === "" || $aacf0c292643cb7f$var$businessData.contacts.email.contact === $aacf0c292643cb7f$var$prefil.contacts.email.contact) {
                alertFields += "\n- Correo electr\xf3nico";
                this._displayErrorMessage("BusinessEditorInputBusinessInfoEmail", "El correo electr\xf3nico es obligatorio");
            }
            const email = $aacf0c292643cb7f$var$businessData.contacts.email.contact;
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                alertFields += "\n- El correo electr\xf3nico no es un correo v\xe1lido.";
                this._displayErrorMessage("BusinessEditorInputBusinessInfoEmail", "El correo electr\xf3nico no es v\xe1lido");
            }
        } else {
            alertFields += "\n- Correo electr\xf3nico";
            this._displayErrorMessage("BusinessEditorInputBusinessInfoEmail", "El correo electr\xf3nico es obligatorio");
        }
        if ($aacf0c292643cb7f$var$businessData.contacts.website) {
            const website = $aacf0c292643cb7f$var$businessData.contacts.website.contact;
            if (website.length > 0 && website !== "Sitio web") {
                if (!website.startsWith("http://") && !website.startsWith("https://")) {
                    alertFields += "\n- El sitio web debe comenzar con 'http://' o 'https://'.";
                    this._displayErrorMessage("BusinessEditorInputBusinessInfoWebsite", "El sitio web debe comenzar con 'http://' o 'https://'. Es opcional, y puede ser omitido.");
                } else if (!website.includes(".")) {
                    alertFields += "\n- El sitio web no es v\xe1lido.";
                    this._displayErrorMessage("BusinessEditorInputBusinessInfoWebsite", "El sitio web no es v\xe1lido. Es opcional, y puede ser omitido.");
                }
            }
        }
        if ($aacf0c292643cb7f$var$businessData.about === "" || $aacf0c292643cb7f$var$businessData.about === $aacf0c292643cb7f$var$prefil.about) {
            alertFields += "\n- Acerca del negocio";
            this._displayErrorMessage("BusinessEditorInputBusinessInfoAbout", "Acerca de tu negocio es obligatorio");
        }
        // Start handle alert
        if (alertFields.length > 0) canGoOn = false;
        if (canGoOn) return canGoOn;
        alert(alertMessage + alertFields);
        return canGoOn;
    }
    _navigateEditorSections() {
        const businessSectionsMainIds = [
            "SectionIndicatedBusinessEditorBusinessHeaderCon1",
            "SectionIndicatedListingsExampleDisplayCon1",
            "SectionIndicatedBusinessInfoCon1",
            "SectionIndicatedBusinessColors"
        ];
        const sections = businessSectionsMainIds.map((id)=>document.getElementById(id));
        const buttonBack = document.getElementById("BusinessPageEditorButtonBack");
        const buttonNext = document.getElementById("BusinessPageEditorButtonNext");
        const buttonCreatePage = document.getElementById("BusinessPageEditorButtonCreatePage");
        let currSectionNum = 0;
        let isButtonNavigating = false; // Prevents manual scroll interruptions during button clicks
        const scrollTo = (index)=>{
            this.#colors = false;
            if (index < 0 || index >= sections.length) return; // Ensure index is valid
            isButtonNavigating = true;
            currSectionNum = index;
            updateButtonStates();
            if (!sections[index]) return;
            sections[index].scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            setTimeout(()=>isButtonNavigating = false, 600); // Allow manual scrolling after animation
        };
        const updateButtonStates = ()=>{
            if (this.#colors) return;
            // Update editor tools based on section
            const editorActions = [
                "header",
                "listings",
                "info",
                "colors"
            ];
            editorActions[currSectionNum];
            // // Update button visibility and interactivity
            // buttonBack.classList.toggle(
            //   "BusinessPageEditorButtonInactive",
            //   currSectionNum === 0
            // );
            // buttonNext.classList.toggle(
            //   "BusinessPageEditorButtonInactive",
            //   currSectionNum === sections.length - 1
            // );
            // Show "Create Page" button only on the last section, but don't hide it again
            if (currSectionNum === sections.length - 1) buttonCreatePage.style.display = "";
        };
        // buttonBack.addEventListener("click", () => {
        //   scrollTo(currSectionNum - 1);
        // });
        // buttonNext.addEventListener("click", () => {
        //   scrollTo(currSectionNum + 1);
        // });
        const observer = new IntersectionObserver((entries)=>{
            if (isButtonNavigating) return; // Ignore updates during button navigation
            let closestSection = null;
            let closestDistance = Infinity;
            entries.forEach((entry)=>{
                const index = businessSectionsMainIds.indexOf(entry.target.id);
                if (index !== -1) {
                    // Calculate distance from the top of the viewport
                    const distanceFromTop = Math.abs(entry.boundingClientRect.top);
                    // Check if this section is closer to the top than the current closest
                    if (distanceFromTop < closestDistance) {
                        closestDistance = distanceFromTop;
                        closestSection = index;
                    }
                }
            });
            if (closestSection !== null && closestSection !== currSectionNum) {
                currSectionNum = closestSection;
                const InputForFocus = document.querySelectorAll(".InputForFocusCheck");
                function isAnyInputFocused() {
                    return Array.from(InputForFocus).some((input)=>input === document.activeElement);
                }
                // Example usage:
                if (isAnyInputFocused()) return;
                updateButtonStates();
            }
        }, {
            root: null,
            threshold: 0.1
        } // Trigger when at least 10% of the section is visible
        );
        sections.forEach((section)=>{
            if (!section) return;
            observer.observe(section);
        });
        const BusinessPageEditorCon4 = document.getElementById("BusinessPageEditorCon4");
        BusinessPageEditorCon4.innerHTML;
    }
    _setBusinessInfo() {
        const placeHtml = (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._visualizerPopulateBusinessInfoPortion("Lugar", (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._visualizerPopulateBusinessInfoPlace($aacf0c292643cb7f$var$businessData.place));
        const contactHtml = (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._visualizerPopulateBusinessInfoPortion("Contacto", (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._visualizerPopulateBusinessInfoContact($aacf0c292643cb7f$var$businessData.contacts));
        const aboutHtml = (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._visualizerPopulateBusinessInfoPortion("Acerca de nosotros", (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._visualizerPopulateBusinessInfoAbout($aacf0c292643cb7f$var$businessData.about));
        const finalPortionsHtml = placeHtml + contactHtml + aboutHtml;
        return (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._visualizerPopulateBusinessInfoMain(finalPortionsHtml);
    }
    _closeBusinessEditor() {
        const MainContainerBusinessPageBuild = document.getElementById("MainContainerBusinessPageBuild");
        MainContainerBusinessPageBuild.remove();
    }
    _sortAndSaveContent(eTarget, text) {
        const id = eTarget.id;
        const errorMessageCon = document.getElementById(id).parentElement.querySelector(".errorMessage");
        if (!errorMessageCon) console.log("No error container");
        console.log("here too");
        if (!id) return;
        if (id === "BusinessEditorInputBusinessName") {
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.name;
                $aacf0c292643cb7f$var$businessData.name = $aacf0c292643cb7f$var$prefil.name;
            } else $aacf0c292643cb7f$var$businessData.name = text;
        }
        if (id === "BusinessEditorInputBusinessShortDescription") {
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.shortDescription;
                $aacf0c292643cb7f$var$businessData.shortDescription = $aacf0c292643cb7f$var$prefil.shortDescription;
            } else $aacf0c292643cb7f$var$businessData.shortDescription = text;
        }
        if (id === "BusinessEditorInputBusinessLocationDescription") {
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.place.description;
                $aacf0c292643cb7f$var$businessData.place.description = $aacf0c292643cb7f$var$prefil.place.description;
            } else $aacf0c292643cb7f$var$businessData.place.description = text;
        }
        if (id === "BusinessEditorInputBusinessInfoPhoneNumber") {
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.contacts.call.contact;
                $aacf0c292643cb7f$var$businessData.contacts.call.contact = $aacf0c292643cb7f$var$prefil.contacts.call.contact;
            } else $aacf0c292643cb7f$var$businessData.contacts.call.contact = text;
        }
        if (id === "BusinessEditorInputBusinessInfoWhatsAppNumber") {
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.contacts.whatsApp.contact;
                $aacf0c292643cb7f$var$businessData.contacts.whatsApp.contact = $aacf0c292643cb7f$var$prefil.contacts.whatsApp.contact;
            } else $aacf0c292643cb7f$var$businessData.contacts.whatsApp.contact = text;
        }
        if (id === "BusinessEditorInputBusinessInfoEmail") {
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.contacts.email.contact;
                $aacf0c292643cb7f$var$businessData.contacts.email.contact = $aacf0c292643cb7f$var$prefil.contacts.email.contact;
            } else $aacf0c292643cb7f$var$businessData.contacts.email.contact = text;
        }
        if (id === "BusinessEditorInputBusinessInfoWebsite") {
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.contacts.website.contact;
                $aacf0c292643cb7f$var$businessData.contacts.website.contact = $aacf0c292643cb7f$var$prefil.contacts.website.contact;
            } else $aacf0c292643cb7f$var$businessData.contacts.website.contact = text;
        }
        if (id === "BusinessEditorInputBusinessInfoAbout") {
            console.log("About here");
            if (text.length < 1) {
                eTarget.textContent = $aacf0c292643cb7f$var$prefil.about;
                $aacf0c292643cb7f$var$businessData.about = $aacf0c292643cb7f$var$prefil.about;
            } else $aacf0c292643cb7f$var$businessData.about = text;
        }
    }
    _checkAndClear(eTarget) {
        const id = eTarget.id;
        const text = eTarget.textContent.trim();
        const BusinessEditorInputBusinessInfoLabel = document.getElementById(id).parentElement.querySelector(".BusinessEditorInputBusinessInfoLabel");
        const BusinessEditorInputBusinessErrorCon = document.getElementById(id).parentElement.querySelector(".editorErrorInputMessage");
        console.log(BusinessEditorInputBusinessInfoLabel);
        console.log(BusinessEditorInputBusinessErrorCon);
        BusinessEditorInputBusinessErrorCon.textContent = "";
        if (!id) return;
        if (!text) return;
        if (id === "BusinessEditorInputBusinessName" && text === $aacf0c292643cb7f$var$prefil.name) eTarget.textContent = "";
        if (id === "BusinessEditorInputBusinessShortDescription" && text === $aacf0c292643cb7f$var$prefil.shortDescription) eTarget.textContent = "";
        if (id === "BusinessEditorInputBusinessLocationDescription" && text === $aacf0c292643cb7f$var$prefil.place.description) eTarget.textContent = "";
        if (id === "BusinessEditorInputBusinessInfoPhoneNumber" && text === $aacf0c292643cb7f$var$prefil.contacts.call.contact) {
            BusinessEditorInputBusinessInfoLabel.textContent = text;
            eTarget.textContent = "";
        }
        if (id === "BusinessEditorInputBusinessInfoWhatsAppNumber" && text === $aacf0c292643cb7f$var$prefil.contacts.whatsApp.contact) {
            BusinessEditorInputBusinessInfoLabel.textContent = text;
            eTarget.textContent = "";
        }
        if (id === "BusinessEditorInputBusinessInfoEmail" && text === $aacf0c292643cb7f$var$prefil.contacts.email.contact) {
            BusinessEditorInputBusinessInfoLabel.textContent = text;
            eTarget.textContent = "";
        }
        if (id === "BusinessEditorInputBusinessInfoWebsite" && text === $aacf0c292643cb7f$var$prefil.contacts.website.contact) {
            BusinessEditorInputBusinessInfoLabel.textContent = text;
            eTarget.textContent = "";
        }
        if (id === "BusinessEditorInputBusinessInfoAbout" && text === $aacf0c292643cb7f$var$prefil.about) {
            console.log("About here");
            eTarget.textContent = "";
        }
    }
    _hideShowTopEditorTools(hideShow) {
        const BusinessEditorBCon9EditorTools = document.getElementById("BusinessEditorBCon9EditorTools");
        if (hideShow === "show") BusinessEditorBCon9EditorTools.classList.remove("BusinessEditorBCon9Shrinked");
        else BusinessEditorBCon9EditorTools.classList.add("BusinessEditorBCon9Shrinked");
        if (BusinessEditorBCon9EditorTools.classList.contains("BusinessEditorBCon9Shrinked")) BusinessEditorBCon9EditorTools.classList.remove("BusinessEditorBCon9Expanded");
        else BusinessEditorBCon9EditorTools.classList.add("BusinessEditorBCon9Expanded");
    }
    _startLoadingEffect(id = null, stop = false) {
        // If no id is provided, simply return (this handles the case where no element is targeted)
        if (!id) return;
        const element = document.getElementById(id);
        if (!element) return; // Ensure the element exists
        // If an effect is already running and stop is true, stop the effect and reset the background
        if (this.#currentInterval !== null && stop) {
            clearInterval(this.#currentInterval);
            this.#currentInterval = null;
            element.style.backgroundColor = "#fff"; // Reset background color to white
            element.style.opacity = 1; // Reset opacity to fully opaque
            return; // Exit the function once we stop the effect
        }
        // If stop is false or no previous effect is running, start the "loading" effect
        // Set a blueish background color to the element
        element.style.backgroundColor = "rgba(0, 123, 255, 0.3)";
        element.style.transition = "background-color 0.5s ease";
        let opacity = 1;
        let decreasing = true;
        // Start the "loading" effect with a set interval
        this.#currentInterval = setInterval(()=>{
            if (decreasing) {
                opacity -= 0.05; // Decrease opacity
                if (opacity <= 0.3) decreasing = false;
            } else {
                opacity += 0.05; // Increase opacity
                if (opacity >= 1) decreasing = true;
            }
            // Apply the new opacity to the element
            element.style.opacity = opacity;
        }, 50); // Adjust the speed by changing the interval time
    }
    _events(edit) {
        const BusinessPageEditorButtonCancel1 = document.getElementById("BusinessPageEditorButtonCancel");
        BusinessPageEditorButtonCancel1.addEventListener("click", ()=>{
            const confirmExit = confirm("\xbfCerrar? Perder\xe1s todos los cambios que hiciste a tu p\xe1gina.");
            if (confirmExit) this._closeBusinessEditor();
        // MainContainerBusinessPageBuild.remove();
        });
        var input, e, input1, e1;
        return;
    }
    async _saveBusiness() {
        const edit = this.#editCurrent;
        if (!this._checkFields()) return;
        console.log(edit);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Validando informaci\xf3n de negocio");
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        try {
            let backgroundImgRef;
            let profileImgRef;
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Subiendo im\xe1genes de negocio");
            if (edit) {
                if (this.#businessBackGroundImgChange) {
                    console.log(this.#businessBackGroundImgChange);
                    backgroundImgRef = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImageById("BusinessEditorBusinessHeaderCon6BackgroundImgCon");
                } else {
                    console.log("else");
                    console.log($aacf0c292643cb7f$var$businessData.backgroundImg);
                    backgroundImgRef = $aacf0c292643cb7f$var$businessData.backgroundImg;
                }
                if (this.#businessProfileImgChange) {
                    console.log(this.#businessProfileImgChange);
                    profileImgRef = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImageById("BusinessEditorBusinessHeaderCon6ProfileImgCon");
                } else {
                    console.log("else");
                    profileImgRef = $aacf0c292643cb7f$var$businessData.profileImg;
                }
            }
            if (!edit) {
                backgroundImgRef = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImageById("BusinessEditorBusinessHeaderCon6BackgroundImgCon");
                profileImgRef = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImageById("BusinessEditorBusinessHeaderCon6ProfileImgCon");
            }
            console.log(backgroundImgRef, profileImgRef);
            // Ensure businessData is defined or valid
            if (!$aacf0c292643cb7f$var$businessData) {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                throw new Error("Business data is missing or invalid.");
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Guardando informaci\xf3n de negocio");
            const createResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._createUpdateBusiness($aacf0c292643cb7f$var$businessData, backgroundImgRef, profileImgRef, edit);
            console.log(createResult);
            if (createResult.data.status === "error") throw new Error(createResult.data.message);
            if (createResult.data.status === "success") {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                this._closeBusinessEditor();
                alert(`Exito: ${createResult.data.message}`);
                (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init();
            }
        } catch (error) {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            console.error("Error saving business info:", error);
            alert(`Error: ${error.message}`);
        }
    }
    async _getBusinessDataFromLocalStorage() {
        const retrievedData = localStorage.getItem("createBusinessData");
        if (retrievedData) {
            const parsedData = JSON.parse(retrievedData);
            const finishWhereLeftOf = confirm("Puedes seguir creando tu p\xe1gina de negocio. Presiona cancelar para empezar de nuevo.");
            if (!finishWhereLeftOf) {
                localStorage.removeItem("createBusinessData");
                return;
            }
            $aacf0c292643cb7f$var$businessData = parsedData;
        }
    }
    async _setVisualizer(edit) {
        this._events();
        return;
    }
    _getTheListsData() {
        const lists = [];
        // Get all list containers
        const listContainers = document.querySelectorAll(".BusinessPageEditorListingsListsCon2");
        listContainers.forEach((container)=>{
            // Get the list name
            const name = container.querySelector(".BusinessPageEditorListingsListsInputName").value;
            // Get the list type
            const type = container.querySelector("#BusinessPageEditorListingsListsListTypeSelect").value;
            // Find the tag select if type is auto, otherwise it's undefined
            const tagSelect = container.querySelector("#BusinessPageEditorListingsListsListTagSelect");
            const idArray = container.dataset.idsarray;
            const tag = type === "auto" && tagSelect ? tagSelect.value : undefined;
            // Push list object to the array
            let idsArrayForSave = [];
            if (idArray) idArray.split(",").forEach((id)=>{
                idsArrayForSave.push(id);
            });
            console.log(idArray);
            lists.push({
                name: name.trim(),
                type: type,
                ids: idsArrayForSave,
                ...tag && {
                    tag: tag.trim()
                }
            });
        });
        $aacf0c292643cb7f$var$businessData.lists = lists;
        this._setVisualizer(this.#editCurrent);
    }
    _getTheListsDataActive() {
        // // Start get data
        // Event listener for keyup on input fields
        document.querySelectorAll(".BusinessPageEditorListingsListsInputName").forEach((input)=>{
            input.addEventListener("keyup", ()=>{
                this._getTheListsData();
            });
        });
        // Event listener for change on select elements
        document.querySelectorAll(".BusinessPageEditorListingsListsChoose").forEach((select)=>{
            select.addEventListener("change", ()=>{
                this._getTheListsData();
            });
        });
    }
    _eventBusinessLists() {
        // Function to handle radio button selection
        const handleRadioChange = ()=>{
            const selectedValue = document.querySelector('input[name="layout"]:checked').value;
            console.log("Selected layout:", selectedValue); // You can handle this as needed
            $aacf0c292643cb7f$var$businessData.listingsApear = selectedValue;
        };
        // Attach the event listener to both radio buttons
        const radioButtons = document.querySelectorAll(".BusinessPageEditorRadio");
        radioButtons.forEach((radio)=>{
            radio.addEventListener("change", handleRadioChange);
        });
        // Function to programmatically set the radio button
        function setLayout(layout) {
            if (layout === "vertical" || layout === "horizontal") {
                const value = layout.toLowerCase();
                const radioToSelect = document.querySelector(`input[value="${value}"]`);
                if (radioToSelect) {
                    radioToSelect.checked = true;
                    handleRadioChange(); // Optionally trigger the change handler
                }
            } else console.error("Invalid layout value. Use 'Vertical' or 'Horizontal'.");
        }
        if ($aacf0c292643cb7f$var$businessData.listingsApear) setLayout($aacf0c292643cb7f$var$businessData.listingsApear);
        // Start lists ordering
        const listsContainer = document.querySelector(".BusinessPageEditorListingsListsCon1");
        const orderButtons = document.querySelectorAll(".BusinessPageEditorListingsListOrder");
        let draggingItem = null;
        let touchStartY = 0;
        // Add event listeners for both mouse and touch events
        orderButtons.forEach((button)=>{
            button.addEventListener("mousedown", startDrag);
            button.addEventListener("touchstart", startDrag);
        });
        function startDrag(e) {
            e.preventDefault();
            const listItem = e.target.closest(".BusinessPageEditorListingsListsCon2");
            draggingItem = listItem;
            draggingItem.classList.add("dragging");
            touchStartY = e.touches ? e.touches[0].clientY : e.clientY;
            listsContainer.addEventListener("mousemove", handleDrag);
            listsContainer.addEventListener("touchmove", handleDrag);
            document.addEventListener("mouseup", endDrag);
            document.addEventListener("touchend", endDrag);
        }
        function handleDrag(e) {
            e.preventDefault();
            const currentY = e.touches ? e.touches[0].clientY : e.clientY;
            const afterElement = getDragAfterElement(listsContainer, currentY);
            if (afterElement == null) listsContainer.appendChild(draggingItem);
            else listsContainer.insertBefore(draggingItem, afterElement);
        }
        const endDrag = ()=>{
            if (draggingItem) {
                draggingItem.classList.remove("dragging");
                this._getTheListsData();
                draggingItem = null;
            }
            listsContainer.removeEventListener("mousemove", handleDrag);
            listsContainer.removeEventListener("touchmove", handleDrag);
            document.removeEventListener("mouseup", endDrag);
            document.removeEventListener("touchend", endDrag);
        };
        function getDragAfterElement(container, y) {
            const draggableElements = [
                ...container.querySelectorAll(".BusinessPageEditorListingsListsCon2:not(.dragging)")
            ];
            return draggableElements.reduce((closest, child)=>{
                const box = child.getBoundingClientRect();
                const offset = y - box.top - box.height / 2;
                if (offset < 0 && offset > closest.offset) return {
                    offset: offset,
                    element: child
                };
                else return closest;
            }, {
                offset: Number.NEGATIVE_INFINITY
            }).element;
        }
        //Start delete list
        const deleteButtons = document.querySelectorAll(".BusinessPageEditorListingsListDelete");
        deleteButtons.forEach((button)=>{
            button.addEventListener("click", ()=>{
                // Find the corresponding input element for the list name
                const listContainer = button.closest(".BusinessPageEditorListingsListsCon2");
                const listNameInput = listContainer.querySelector(".BusinessPageEditorListingsListsInputName");
                const listName = listNameInput.value.trim();
                // Confirm with the user
                const userConfirmed = confirm(`\xbfEst\xe1s seguro de que deseas eliminar la lista "${listName}"?`);
                if (userConfirmed) {
                    // Remove the corresponding list container
                    listContainer.remove();
                    this._getTheListsData();
                    alert(`La lista "${listName}" ha sido eliminada.`);
                } else alert(`La eliminaci\xf3n de la lista "${listName}" fue cancelada.`);
            });
        });
        //
        // Start Hide Tags options
        const typeSelects = document.querySelectorAll("#BusinessPageEditorListingsListsListTypeSelect");
        typeSelects.forEach((select)=>{
            select.addEventListener("change", function() {
                const listContainer = select.closest(".BusinessPageEditorListingsListsCon2");
                const tagContainer = listContainer.querySelector('[id="BusinessPageEditorListingsListsListTagSelect"]').closest(".BusinessPageEditorListingsListsCon5");
                // Toggle visibility based on selected value
                if (select.value === "auto") tagContainer.style.display = "";
                else tagContainer.style.display = "none";
            });
            // Trigger the change event on load to set initial visibility
            select.dispatchEvent(new Event("change"));
        });
        this._getTheListsDataActive();
        // Start New List
        const BusinessPageEditorListingsListsButtonNewList = document.getElementById("BusinessPageEditorListingsListsButtonNewList");
        BusinessPageEditorListingsListsButtonNewList.addEventListener("click", ()=>{
            const newList = {
                name: "Nombre de lista",
                type: "auto",
                tag: "escoge"
            };
            $aacf0c292643cb7f$var$businessData.lists.push(newList);
            console.log("clicked");
            console.log($aacf0c292643cb7f$var$businessData.lists);
            this._setVisualizer(this.#editCurrent);
            (0, $6b11b388aeb506e5$export$2e2bcd8739ae039)._init("listings", $aacf0c292643cb7f$var$businessData, $aacf0c292643cb7f$var$tags);
            this._hideShowTopEditorTools("hide");
        // this._getTheListsData();
        });
    }
    _eventBusinessInfo() {
        const BusinessPageEditorLocationDescriptionInput = document.getElementById("BusinessPageEditorLocationDescriptionInput");
        BusinessPageEditorLocationDescriptionInput.addEventListener("keyup", ()=>{
            $aacf0c292643cb7f$var$businessData.place.description = BusinessPageEditorLocationDescriptionInput.value.trim();
        });
        // Start contacts data
        const inputs = document.querySelectorAll(".BusinessPageEditorPortionCon3 .InputMiniCon2");
        const createContactsObject = ()=>{
            const inputs = document.querySelectorAll(".BusinessPageEditorPortionCon3 .InputMiniCon2");
            // Initialize the contacts object without predefined keys
            const contacts = {};
            // Map labels to contact types
            const labelToTypeMap = {
                "Numero de tel\xe9fono para llamadas": "call",
                "Numero de tel\xe9fono para WhatsApp": "whatsApp",
                "Correo electr\xf3nico": "email",
                "P\xe1gina web": "website"
            };
            inputs.forEach((inputContainer)=>{
                const label = inputContainer.querySelector(".InputMiniLabel").textContent.trim();
                const input = inputContainer.querySelector("input");
                if (input && input.value.trim() !== "") {
                    const type = labelToTypeMap[label];
                    if (type) contacts[type] = {
                        contact: input.value.trim()
                    };
                }
            });
            $aacf0c292643cb7f$var$businessData.contacts = contacts;
            console.log(contacts);
            console.log($aacf0c292643cb7f$var$businessData.contacts);
            this._setVisualizer(this.#editCurrent);
        };
        inputs.forEach((input)=>{
            input.addEventListener("keyup", ()=>{
                const result = createContactsObject();
            });
        });
        // Start about
        const BusinessEditorInfoTextAreaCon1 = document.getElementById("BusinessEditorInfoTextAreaCon1");
        BusinessEditorInfoTextAreaCon1.addEventListener("keyup", ()=>{
            $aacf0c292643cb7f$var$businessData.about = BusinessEditorInfoTextAreaCon1.value.trim();
            this._setVisualizer(this.#editCurrent);
        });
        // Start Map
        this._justIntergratingTheMap();
    }
    _colorSetter(color, whatForColor) {
        console.log(color, whatForColor);
        if (whatForColor === "headerPrimary") $aacf0c292643cb7f$var$businessData.colors.headerPrimary = color;
        if (whatForColor === "headerSecondary") $aacf0c292643cb7f$var$businessData.colors.headerSecondary = color;
        if (whatForColor === "packTitles") $aacf0c292643cb7f$var$businessData.colors.packTitles = color;
        if (whatForColor === "packTitlesHighlight") $aacf0c292643cb7f$var$businessData.colors.packTitlesHighlight = color;
        if (whatForColor === "itemBackgroundPrimary") $aacf0c292643cb7f$var$businessData.colors.itemBackgroundPrimary = color;
        if (whatForColor === "itemBackgroundSecondary") $aacf0c292643cb7f$var$businessData.colors.itemBackgroundSecondary = color;
        if (whatForColor === "itemTextPrimary") $aacf0c292643cb7f$var$businessData.colors.itemTextPrimary = color;
        if (whatForColor === "itemTextFour") $aacf0c292643cb7f$var$businessData.colors.itemTextFour = color;
        if (whatForColor === "itemTextSecondary") $aacf0c292643cb7f$var$businessData.colors.itemTextSecondary = color;
        if (whatForColor === "itemTextTerteriary") $aacf0c292643cb7f$var$businessData.colors.itemTextTerteriary = color;
        if (whatForColor === "itemHighlight") $aacf0c292643cb7f$var$businessData.colors.itemHighlight = color;
        if (whatForColor === "itemHighlightText") $aacf0c292643cb7f$var$businessData.colors.itemHighlightText = color;
        console.log($aacf0c292643cb7f$var$businessData.colors);
        this._setVisualizer(this.#editCurrent);
    }
    _justIntergratingTheMap() {
        console.log("Integrating the map");
        const TheLocationInputForLocationBusinessPageEditorLocationInput = document.getElementById("BusinessPageEditorLocationInput");
        function loadGoogleMaps(apiKey) {
            return new Promise((resolve, reject)=>{
                if (document.getElementById("googleMapsScript")) {
                    resolve(); // If already loaded, resolve immediately
                    return;
                }
                const script = document.createElement("script");
                script.id = "googleMapsScript";
                script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initMap`;
                script.async = true;
                script.defer = true;
                script.onerror = ()=>reject(new Error("Failed to load Google Maps API"));
                document.body.appendChild(script);
                window.initMap = resolve;
            });
        }
        const initMap = async ()=>{
            try {
                const apiKey = "AIzaSyAiZwvYIzOaWxCfghLdC0OZWhBKe5TruEk"; // Replace with your actual API key
                await loadGoogleMaps(apiKey);
                const mapContainer = document.getElementById("BusinessPageEditorMapContainer");
                let latForStart = 20.6595382;
                let lngForStart = -103.3494376;
                if ($aacf0c292643cb7f$var$businessData.place.lat || $aacf0c292643cb7f$var$businessData.place.lng) {
                    latForStart = $aacf0c292643cb7f$var$businessData.place.lat;
                    lngForStart = $aacf0c292643cb7f$var$businessData.place.lng;
                }
                const map = new google.maps.Map(mapContainer, {
                    center: {
                        lat: latForStart,
                        lng: lngForStart
                    },
                    zoom: 13
                });
                const geocoder = new google.maps.Geocoder();
                // Update input with address from map center
                map.addListener("idle", ()=>{
                    const center = map.getCenter();
                    geocoder.geocode({
                        location: center
                    }, (results, status)=>{
                        if (status === "OK" && results[0]) {
                            if (TheLocationInputForLocationBusinessPageEditorLocationInput.value.trim() === "") return;
                            const locatedLocation = results[0].formatted_address;
                            TheLocationInputForLocationBusinessPageEditorLocationInput.value = locatedLocation;
                            $aacf0c292643cb7f$var$businessData.place.name = locatedLocation;
                            $aacf0c292643cb7f$var$businessData.place.locationUrl = `https://www.google.com/maps?q=${center.lat()},${center.lng()}`;
                            $aacf0c292643cb7f$var$businessData.place.lat = center.lat();
                            $aacf0c292643cb7f$var$businessData.place.lng = center.lng();
                            console.log(center.lat(), center.lng());
                        } else console.error("Geocoder failed:", status);
                    });
                });
                // Autocomplete for input field
                const input = document.getElementById("BusinessPageEditorLocationInput");
                const autocomplete = new google.maps.places.Autocomplete(input);
                autocomplete.addListener("place_changed", function() {
                    const place = autocomplete.getPlace();
                    if (place.geometry) {
                        map.setCenter(place.geometry.location);
                        map.setZoom(15);
                        new google.maps.Marker({
                            position: place.geometry.location,
                            map: map
                        });
                        console.log("Selected place from search:", place.name, place.geometry.location);
                    } else console.error("No details available for the selected place.");
                });
                // Locate user's current position
                document.getElementById("BusinessEditorLocationMyLocationCon1").addEventListener("click", ()=>{
                    this._startLoadingEffect("BusinessEditorLocationMyLocationCon1");
                    // toggleSpinner("start");
                    if (navigator.geolocation) navigator.geolocation.getCurrentPosition((position)=>{
                        const userLocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        map.setCenter(userLocation);
                        map.setZoom(15);
                        new google.maps.Marker({
                            position: userLocation,
                            map: map
                        });
                        geocoder.geocode({
                            location: userLocation
                        }, (results, status)=>{
                            this._startLoadingEffect("BusinessEditorLocationMyLocationCon1", true);
                            console.log(results[5].formatted_address);
                            if (status === "OK" && results[0]) {
                                const locatedLocation = results[0].formatted_address;
                                TheLocationInputForLocationBusinessPageEditorLocationInput.value = locatedLocation;
                                $aacf0c292643cb7f$var$businessData.place.name = locatedLocation;
                                $aacf0c292643cb7f$var$businessData.place.locationUrl = `https://www.google.com/maps?q=${userLocation.lat},${userLocation.lng}`;
                            // toggleSpinner("stop");
                            } else console.error("Geocoder failed:", status);
                        });
                    }, (error)=>{
                        console.error("Error getting location:", error);
                        alert("Unable to retrieve your location. Please enable location services.");
                    });
                    else alert("Geolocation is not supported by this browser.");
                });
            } catch (error) {
                console.error("Error loading Google Maps:", error);
            }
        };
        // // Map initialization trigger
        // document
        //   .getElementById("BusinessPageEditorOpenMapButton")
        //   .addEventListener("click", initMap);
        document.getElementById("BusinessPageEditorLocationInput").addEventListener("click", ()=>{
            const mapContainer = document.getElementById("BusinessPageEditorMapContainer1");
            const btnLocator = document.getElementById("BusinessEditorLocationMyLocationCon1");
            initMap();
            // mapContainer.classList.add("BusinessPageEditorMapContainer1");
            mapContainer.style.display = "";
            btnLocator.style.display = "";
        });
    }
    _eventBusinessHeader() {
        const BusinessEditorNameInput = document.getElementById("BusinessEditorNameInput");
        const BusinessEditorShorDescriptionInput = document.getElementById("BusinessEditorShortDescriptionInput");
        BusinessEditorNameInput.addEventListener("keyup", ()=>{
            $aacf0c292643cb7f$var$businessData.name = BusinessEditorNameInput.value.trim();
            this._setVisualizer(this.#editCurrent);
        });
        BusinessEditorShorDescriptionInput.addEventListener("keyup", ()=>{
            $aacf0c292643cb7f$var$businessData.shortDescription = BusinessEditorShorDescriptionInput.value.trim();
            this._setVisualizer(this.#editCurrent);
        });
        const handleImageUpload = (imgInputId, imgPutInto)=>{
            const fileInput = document.getElementById(imgInputId);
            const outputElement = document.getElementById(imgPutInto);
            fileInput.addEventListener("change", ()=>{
                const file = fileInput.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e)=>{
                        if (imgInputId === "BusinessPageEditorSelectImgBackground") {
                            $aacf0c292643cb7f$var$businessData.backgroundImg = e.target.result;
                            this._setimageChangeState("background");
                        }
                        if (imgInputId === "BusinessPageEditorSelectImgProfile") {
                            $aacf0c292643cb7f$var$businessData.profileImg = e.target.result;
                            this._setimageChangeState("profile");
                        }
                        this._setVisualizer(this.#editCurrent);
                    // outputElement.src = e.target.result;
                    };
                    reader.readAsDataURL(file);
                }
            });
        };
        // Initialize the function with IDs
        handleImageUpload("BusinessPageEditorSelectImgBackground", "BusinessEditorBusinessHeaderCon6BackgroundImgCon");
        handleImageUpload("BusinessPageEditorSelectImgProfile", "BusinessEditorBusinessHeaderCon6ProfileImgCon");
    }
    _setMainEditor(edit = true) {
        (0, $81574927169af67f$export$2e2bcd8739ae039)._businessEditor();
        return;
        function bindImageInputToDisplay(inputId, displayImgId) {
            const input = document.getElementById(inputId);
            const display = document.getElementById(displayImgId);
            if (!input || !display) {
                console.error("bindImageInputToDisplay: invalid IDs provided.");
                return;
            }
            input.addEventListener("change", (event)=>{
                const file = event.target.files && event.target.files[0];
                if (!file) return;
                if (!file.type.startsWith("image/")) {
                    console.error("Selected file is not an image.");
                    display.src = ""; // clear
                    return;
                }
                const reader = new FileReader();
                reader.onload = (e)=>{
                    display.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        }
    }
}
var $aacf0c292643cb7f$export$2e2bcd8739ae039 = new $aacf0c292643cb7f$var$BusinessPageEditor();












var $f7e2830c161aaed5$exports = {};
$f7e2830c161aaed5$exports = new URL("profile-img-placeholder.a0f1e921.png", import.meta.url).toString();



// import { connectFirestoreEmulator } from "firebase/firestore";
const $33656b45f0922648$var$ProfileOpenButtonBack = document.getElementById("ProfileOpenButtonBack");
const $33656b45f0922648$var$ProfileOpenCon6B = document.getElementById("ProfileOpenCon6B");
const $33656b45f0922648$var$ProfileOpenConContactNumberMessage = document.getElementById("ProfileOpenConContactNumberMessage");
const $33656b45f0922648$var$ProfileOpenInputEmail = document.getElementById("ProfileOpenInputEmail");
const $33656b45f0922648$var$ProfileOpenInputSellerName = document.getElementById("ProfileOpenInputSellerName");
const $33656b45f0922648$var$ProfileOpenInputPhoneNumber = document.getElementById("ProfileOpenInputPhoneNumber");
const $33656b45f0922648$var$ProfileOpenInputWhatsAppNumber = document.getElementById("ProfileOpenInputWhatsAppNumber");
const $33656b45f0922648$var$ProfileOpenCon1 = document.getElementById("ProfileOpenCon1Main");
const $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton = document.getElementById("ProfileOpenSellerProfileSaveButton");
const $33656b45f0922648$var$ProfileOpenButtonLogOut = document.getElementById("ProfileOpenButtonLogOut");
const $33656b45f0922648$var$ProfileOpenButtonDeleteAccount = document.getElementById("ProfileOpenButtonDeleteAccount");
const $33656b45f0922648$var$ProfileOpenFileInput = document.getElementById("ProfileOpenFileInput");
const $33656b45f0922648$var$profileImage = document.getElementById("ProfileOpenProfileFoto");
const $33656b45f0922648$var$ProfileOpenFotoDeleteButton = document.getElementById("ProfileOpenFotoDeleteButton");
class $33656b45f0922648$var$ManageAccountAndProfileChanges {
    #changedProfileImg = false;
    #changesToBeSaved = false;
    #initializedEventOnOpen = false;
    #initializedEvent = false;
    #sellerProfile = {
        userName: "",
        callNumber: "",
        whatsAppNumber: "",
        profileImageUrl: "",
        sellerProfileStatus: "active",
        sellerProfileTokens: []
    };
    constructor(){
        this._events();
        this._imageSelectHandle();
    }
    async _saveSellerProfile(close) {
        let valid = true;
        if (!this._checkIfReady("name")) valid = this._checkIfReady("name");
        if (!this._checkIfReady("callNumber")) valid = this._checkIfReady("callNumber");
        if (!this._checkIfReady("whatsAppNumber")) valid = this._checkIfReady("whatsAppNumber");
        if (!valid) alert("Porfavor completa todos los campos, incluso la foto de perfil.");
        try {
            if (!this.#sellerProfile.userName || this.#sellerProfile.userName === "" || !this.#sellerProfile.callNumber || this.#sellerProfile.callNumber === "" || !this.#sellerProfile.whatsAppNumber || this.#sellerProfile.whatsAppNumber === "") {
                alert("Porfavor completa los campos antes de subir tu perfil de vendedor");
                return;
            }
            if (this.#changedProfileImg) {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Subiendo imagen de perfil");
                const profileImgUrl = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImageById("ProfileOpenProfileFoto");
                this.#sellerProfile.profileImageUrl = profileImgUrl;
                this.#changedProfileImg = false;
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Subiendo perfil de vendedor");
            const tokenInput = this.#sellerProfile.userName + this.#sellerProfile.callNumber + this.#sellerProfile.whatsAppNumber;
            this.#sellerProfile.sellerProfileTokens = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(tokenInput, [
                "&",
                "de",
                "y",
                "para"
            ]);
            const updateProfileResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateUserTemplate(this.#sellerProfile);
            console.log(updateProfileResult);
            if (updateProfileResult.data.status === "error") {
                alert(`Hubo un error en actualizar tu perfil de vendedor. ${updateProfileResult.message}`);
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                return;
            }
            if (updateProfileResult.data.status === "success") {
                $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "none";
                $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.remove("ProfileOpenSellerProfileSaveButtonNoneAct");
                this.#changesToBeSaved = false;
                if (close) this._close();
                alert("\xc9xito. \xa1Perfil de vendedor actualizado correctamente!");
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        } catch (error) {
            console.error(error);
        }
    }
    async _open() {
        const messages = document.querySelectorAll(".ProfileOpenInputMessage");
        messages.forEach((ms)=>{
            ms.textContent = "";
            ms.classList.remove("ProfileOpenInputMessageSuccess");
            ms.classList.remove("ProfileOpenInputMessageError");
        });
        const currentAccount = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (!currentAccount) {
            (0, $5b997bd2b2817dfd$export$2e2bcd8739ae039)._displayOptions("account_and_profile", "Escoge una opci\xf3n para seguir", "register");
            return;
        }
        $33656b45f0922648$var$ProfileOpenInputEmail.textContent = currentAccount.email;
        if (!currentAccount.userName || currentAccount.userName === "sin nombre") {
            console.warn("Not a seller profile");
            $33656b45f0922648$var$ProfileOpenCon6B.style.display = "flex";
            this._eventsOnOpen();
            $33656b45f0922648$var$ProfileOpenInputSellerName.value = "";
            $33656b45f0922648$var$ProfileOpenInputPhoneNumber.value = "";
            $33656b45f0922648$var$ProfileOpenInputWhatsAppNumber.value = "";
            $33656b45f0922648$var$ProfileOpenFileInput.value = "";
            $33656b45f0922648$var$profileImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($f7e2830c161aaed5$exports)));
            $33656b45f0922648$var$ProfileOpenFotoDeleteButton.style.display = "none";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "none";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.remove("ProfileOpenSellerProfileSaveButtonNoneAct");
        } else {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando");
            this._eventsOnOpen();
            $33656b45f0922648$var$ProfileOpenFotoDeleteButton.style.display = "flex";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "none";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.remove("ProfileOpenSellerProfileSaveButtonNoneAct");
            if (currentAccount.profileImageUrl) {
                const imgUrl = currentAccount.profileImageUrl;
                // const imgUrl = await firebase._getImageUrl(
                //   currentAccount.profileImageUrl
                // );
                $33656b45f0922648$var$profileImage.src = imgUrl;
            }
            this.#sellerProfile.userName = currentAccount.userName;
            this.#sellerProfile.callNumber = currentAccount.callNumber;
            this.#sellerProfile.whatsAppNumber = currentAccount.whatsAppNumber;
            this.#sellerProfile.profileImageUrl = currentAccount.profileImageUrl;
            $33656b45f0922648$var$ProfileOpenInputSellerName.value = currentAccount.userName;
            $33656b45f0922648$var$ProfileOpenInputPhoneNumber.value = currentAccount.callNumber;
            $33656b45f0922648$var$ProfileOpenInputWhatsAppNumber.value = currentAccount.whatsAppNumber;
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
        $33656b45f0922648$var$ProfileOpenCon1.style.display = "flex";
    }
    _checkIfReady = (what)=>{
        this.#changesToBeSaved = true;
        let allValid = true; // Tracks overall validity
        const checkImg = ()=>{
            const messageCon = $33656b45f0922648$var$profileImage.closest(".ProfileOpenFotoCon").querySelector(".ProfileOpenInputMessage");
            // Check if the profile image is the placeholder or empty
            if ($33656b45f0922648$var$profileImage.src.includes("profile-img-placeholder") || $33656b45f0922648$var$profileImage.src === "") {
                console.warn("this was true somehow");
                console.log($33656b45f0922648$var$profileImage.src.includes("profile-img-placeholder"));
                console.log($33656b45f0922648$var$profileImage.src);
                messageCon.classList.add("ProfileOpenInputMessageError");
                messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Una foto de perfil es requerida"; // Grammar correction
                return false;
            } else {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = ""; // Provide positive feedback
                return true;
            }
        };
        const checkName = ()=>{
            const messageCon = $33656b45f0922648$var$ProfileOpenInputSellerName.closest(".ProfileOpenInputCon2").querySelector(".ProfileOpenInputMessage");
            if (!this.#sellerProfile.userName || this.#sellerProfile.userName.length < 3) {
                if (what === "name") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.userName ? "El nombre de vendedor es requerido" : "El nombre de vendedor no puede ser menor a 3 car\xe1cteres";
                }
                return false;
            }
            if (what === "name") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Nombre v\xe1lido";
            }
            return true;
        };
        const checkCallNumber = ()=>{
            const messageCon = $33656b45f0922648$var$ProfileOpenInputPhoneNumber.closest(".ProfileOpenInputCon2").querySelector(".ProfileOpenInputMessage");
            if (!this.#sellerProfile.callNumber || this.#sellerProfile.callNumber.length !== 10) {
                if (what === "callNumber") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.callNumber ? "N\xfamero de llamadas es requerido" : "N\xfamero de llamadas no v\xe1lido";
                }
                return false;
            }
            if (what === "callNumber") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "N\xfamero v\xe1lido";
            }
            return true;
        };
        const checkWhatsAppNumber = ()=>{
            const messageCon = $33656b45f0922648$var$ProfileOpenInputWhatsAppNumber.closest(".ProfileOpenInputCon2").querySelector(".ProfileOpenInputMessage");
            if (!this.#sellerProfile.whatsAppNumber || this.#sellerProfile.whatsAppNumber.length !== 10) {
                if (what === "whatsAppNumber") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.whatsAppNumber ? "N\xfamero de WhatsApp es requerido" : "N\xfamero de WhatsApp no v\xe1lido";
                }
                return false;
            }
            if (what === "whatsAppNumber") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "N\xfamero v\xe1lido";
            }
            return true;
        };
        // Perform all checks and track validity
        allValid = checkImg() && allValid;
        allValid = checkName() && allValid;
        allValid = checkCallNumber() && allValid;
        allValid = checkWhatsAppNumber() && allValid;
        // Toggle save button based on overall validity
        if (allValid) {
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.remove("ProfileOpenSellerProfileSaveButtonNoneAct");
            return allValid;
        } else {
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.add("ProfileOpenSellerProfileSaveButtonNoneAct");
            return allValid;
        }
    };
    _eventsOnOpen() {
        if (this.#initializedEventOnOpen) return;
        this.#sellerProfile = {
            userName: "",
            callNumber: "",
            whatsAppNumber: ""
        };
        const forRemoveMessage = $33656b45f0922648$var$ProfileOpenCon6B.closest(".ProfileOpenCon5");
        forRemoveMessage.addEventListener("click", ()=>{
            $33656b45f0922648$var$ProfileOpenCon6B.style.display = "none";
        });
        $33656b45f0922648$var$ProfileOpenCon6B.addEventListener("click", ()=>{
            $33656b45f0922648$var$ProfileOpenInputSellerName.focus();
        });
        $33656b45f0922648$var$ProfileOpenInputSellerName.addEventListener("keyup", (e)=>{
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "flex";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.add("ProfileOpenSellerProfileSaveButtonNoneAct");
            const trimedValue = e.target.value.trim();
            this.#sellerProfile.userName = trimedValue;
            this._checkIfReady("name");
        });
        $33656b45f0922648$var$ProfileOpenInputPhoneNumber.addEventListener("keyup", (e)=>{
            $33656b45f0922648$var$ProfileOpenConContactNumberMessage.style.display = "flex";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "flex";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.add("ProfileOpenSellerProfileSaveButtonNoneAct");
            const trimedValue = e.target.value.trim();
            this.#sellerProfile.callNumber = trimedValue;
            this._checkIfReady("callNumber");
        });
        $33656b45f0922648$var$ProfileOpenInputWhatsAppNumber.addEventListener("keyup", (e)=>{
            $33656b45f0922648$var$ProfileOpenConContactNumberMessage.style.display = "flex";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "flex";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.add("ProfileOpenSellerProfileSaveButtonNoneAct");
            const trimedValue = e.target.value.trim();
            this.#sellerProfile.whatsAppNumber = trimedValue;
            this._checkIfReady("whatsAppNumber");
        });
        $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.addEventListener("click", ()=>{
            if ($33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.contains("ProfileOpenSellerProfileSaveButtonNoneAct")) return;
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.add("ProfileOpenSellerProfileSaveButtonNoneAct");
            this._saveSellerProfile();
        });
        this.#initializedEventOnOpen = true;
    }
    _close() {
        console.log("Close was called");
        console.log(this.#changesToBeSaved);
        if (this.#changesToBeSaved) {
            const saveChanges = confirm("Tienes cambios en tu perfil. \xbfQuieres guardarlos antes de salir?");
            if (saveChanges) this._saveSellerProfile(true);
            else {
                $33656b45f0922648$var$ProfileOpenCon1.style.display = "none";
                this.#changesToBeSaved = false;
            }
        } else $33656b45f0922648$var$ProfileOpenCon1.style.display = "none";
    }
    _imageSelectHandle() {
        // Start image select
        // Listen for file input change
        $33656b45f0922648$var$ProfileOpenFileInput.addEventListener("change", (event)=>{
            const file = event.target.files[0]; // Get the selected file
            if (file) {
                const reader = new FileReader();
                // When the file is loaded, set the src of the image
                reader.onload = (e)=>{
                    $33656b45f0922648$var$profileImage.src = e.target.result; // Set the image src to the file's data URL
                    this.#changedProfileImg = true;
                };
                reader.readAsDataURL(file); // Read the file as a Data URL
                $33656b45f0922648$var$ProfileOpenFotoDeleteButton.style.display = "flex";
                $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "flex";
                $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.add("ProfileOpenSellerProfileSaveButtonNoneAct");
            }
            setTimeout(()=>{
                this._checkIfReady();
            }, 10);
        });
        const clearInputAndImage = ()=>{
            // const profileImage = document.getElementById("ProfileOpenProfileFoto");
            // Clear the file input
            $33656b45f0922648$var$ProfileOpenFileInput.value = "";
            // Reset the profile image
            $33656b45f0922648$var$profileImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($f7e2830c161aaed5$exports)));
            $33656b45f0922648$var$ProfileOpenFotoDeleteButton.style.display = "none";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.style.display = "none";
            $33656b45f0922648$var$ProfileOpenSellerProfileSaveButton.classList.remove("ProfileOpenSellerProfileSaveButtonNoneAct");
            this._checkIfReady();
        };
        $33656b45f0922648$var$ProfileOpenFotoDeleteButton.addEventListener("click", clearInputAndImage);
    }
    _events() {
        if (this.#initializedEvent) return;
        $33656b45f0922648$var$ProfileOpenButtonBack.addEventListener("click", (e)=>{
            // e.target.closest(".ProfileOpenCon1").style.display = "none";
            this._close();
        });
        $33656b45f0922648$var$ProfileOpenButtonLogOut.addEventListener("click", async ()=>{
            const MainMenuCon1A = document.querySelector(".MainMenuCon1A");
            const confirmLogOut = confirm(`\xbfEst\xe1s seguro que quieres cerar sesi\xf3n con esta cuenta?
        Tus datos no se borar\xe1n.
        Los podras acceder al iniciar sesi\xf3n con esta cuenta otra vez.`);
            console.log(confirmLogOut);
            if (!confirmLogOut) return;
            await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._signOutUser();
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Un momento");
            this._close();
            if (MainMenuCon1A) MainMenuCon1A.remove();
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("last");
            setTimeout(()=>{
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }, 800);
        });
        $33656b45f0922648$var$ProfileOpenButtonDeleteAccount.addEventListener("click", async ()=>{
            alert("Proximamente. Esta funci\xf3n a\xfan no esta lista.");
        });
        this.#initializedEvent = true;
    }
}
var $33656b45f0922648$export$2e2bcd8739ae039 = new $33656b45f0922648$var$ManageAccountAndProfileChanges();







class $fec3fe9805a53782$var$BusinessOwn {
    #currentAccount;
    #currentBsiness;
    #windowEventActivated = false;
    #currentActi = 'businesses';
    #currentBusinessId = '';
    #draftsEventsActivated = false;
    constructor(){
        // this._handelEditOptinsShow(true)
        this._handelEditOptinsEvents();
        this._initEditOptionsDrag();
    }
    _displayRightNavWindow() {
        const windows = document.querySelectorAll(".MainAppConWithNavigationContentCon");
        windows.forEach((window1)=>{
            if (window1.id === "MainAppConWithNavigationContentConBusiness") window1.style.display = "";
            else window1.style.display = "none";
        });
    }
    _clearContainer() {
        const HomeScreenContenConForAll = document.getElementById("MainAppConWithNavigationContentConBusiness");
        HomeScreenContenConForAll.style.paddingTop = "0px";
        HomeScreenContenConForAll.innerHTML = "";
    }
    async _init(tab = 'businesses') {
        await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getUserDataFromBase();
        this._displayRightNavWindow();
        this._NVPreparePage(tab);
        this._selectActiDisplay(tab);
        this._handleUploadButtons();
    }
    // call this to show/hide the sheet
    _handelEditOptinsShow(open) {
        const NVEditOptions = document.getElementById('NVEditOptions');
        if (!NVEditOptions) return;
        const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
        if (!sheet) return;
        // Ensure transition style is set once
        sheet.style.transition = 'transform 0.35s ease, opacity 0.35s ease';
        if (open) {
            // Make container visible first
            NVEditOptions.style.display = 'flex';
            NVEditOptions.style.pointerEvents = 'auto';
            sheet.style.pointerEvents = 'auto';
            // Start from off-screen
            sheet.style.transform = 'translateY(100%)';
            sheet.style.opacity = '0';
            // Animate in on the next frame
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    sheet.style.transform = 'translateY(0)';
                    sheet.style.opacity = '1';
                });
            });
        } else {
            // Animate out
            sheet.style.transform = 'translateY(100%)';
            sheet.style.opacity = '0';
            sheet.style.pointerEvents = 'none';
            NVEditOptions.style.pointerEvents = 'none';
            // After transition, hide completely
            const cleanup = ()=>{
                NVEditOptions.style.display = 'none';
                sheet.removeEventListener('transitionend', cleanup);
            };
            sheet.addEventListener('transitionend', cleanup);
            // Fallback timeout in case transitionend doesn’t fire
            setTimeout(cleanup, 350);
        }
    }
    _initEditOptionsDrag() {
        const NVEditOptions = document.getElementById('NVEditOptions');
        if (!NVEditOptions) return;
        const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
        const handle = NVEditOptions.querySelector('#NVEditOptionsHideBar');
        if (!sheet || !handle) return;
        // Prevent duplicate listener setup
        if (this.__nvEditOptionsDragInit) return;
        this.__nvEditOptionsDragInit = true;
        let startY = 0;
        let currentY = 0;
        let lastY = 0;
        let lastTime = 0;
        let dragging = false;
        let velocity = 0;
        const originalTransition = getComputedStyle(sheet).transition || 'transform 0.35s ease, opacity 0.35s ease';
        const startDrag = (e)=>{
            if (NVEditOptions.style.display === 'none' || NVEditOptions.style.display === '') return;
            dragging = true;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            startY = clientY;
            currentY = clientY;
            lastY = clientY;
            lastTime = performance.now();
            sheet.style.transition = 'none';
            sheet.style.willChange = 'transform, opacity';
        };
        const onDrag = (e)=>{
            if (!dragging) return;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            const diff = Math.max(0, clientY - startY);
            currentY = clientY;
            // velocity calculation
            const now = performance.now();
            const deltaTime = now - lastTime;
            velocity = (clientY - lastY) / deltaTime;
            lastY = clientY;
            lastTime = now;
            sheet.style.transform = `translateY(${diff}px)`;
            sheet.style.opacity = `${Math.max(0.3, 1 - diff / 300)}`;
        };
        const endDrag = ()=>{
            if (!dragging) return;
            dragging = false;
            sheet.style.transition = originalTransition;
            sheet.style.willChange = '';
            const diff = currentY - startY;
            const dismissThreshold = 120;
            const velocityThreshold = 0.6;
            if (diff > dismissThreshold || velocity > velocityThreshold) {
                // dismiss
                sheet.style.transform = 'translateY(100%)';
                sheet.style.opacity = '0';
                this._handelEditOptinsShow(false);
            } else {
                // snap back
                sheet.style.transform = 'translateY(0)';
                sheet.style.opacity = '1';
            }
        };
        // === Event Listeners ===
        const dragTargets = [
            sheet,
            handle,
            NVEditOptions
        ];
        dragTargets.forEach((el)=>{
            el.addEventListener('touchstart', startDrag, {
                passive: true
            });
            el.addEventListener('mousedown', (ev)=>{
                ev.preventDefault();
                startDrag(ev);
            });
        });
        window.addEventListener('touchmove', onDrag, {
            passive: true
        });
        window.addEventListener('mousemove', onDrag);
        window.addEventListener('touchend', endDrag);
        window.addEventListener('mouseup', endDrag);
        // Close when tapping backdrop (outside sheet)
        NVEditOptions.addEventListener('click', (ev)=>{
            // Only close if clicked outside the sheet
            if (ev.target === NVEditOptions) this._handelEditOptinsShow(false);
        });
    }
    async _editCurrentBusiness() {
        console.log('open edit');
        if (!this.#currentBusinessId) alert('No podimos cargar tu negocio en este momento. Intenta de nuevo mas tarde.');
        const businessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${this.#currentBusinessId}`);
        if (!businessData) alert('No podimos cargar tu negocio en este momento. Intenta de nuevo mas tarde.');
        (0, $81574927169af67f$export$2e2bcd8739ae039)._init(businessData, true);
    }
    _deleteCurrentBusiness() {
        alert("Eliminar un negocio no es posible en este momento. Pedimos de tu paciencia mientras estamos mejorando esta aplicaci\xf3n.");
    }
    _handelEditOptinsEvents() {
        const NVEditOptions = document.getElementById('NVEditOptions');
        const NVEditOptionsHideBar = document.getElementById('NVEditOptionsHideBar');
        const NVEditOptionsEdit = document.getElementById('NVEditOptionsEdit');
        const NVEditOptionsDelete = document.getElementById('NVEditOptionsDelete');
        NVEditOptions.addEventListener('click', ()=>{
            this._handelEditOptinsShow(false);
        });
        NVEditOptionsHideBar.addEventListener('click', ()=>{
            this._handelEditOptinsShow(false);
        });
        NVEditOptionsEdit.addEventListener('click', ()=>{
            this._editCurrentBusiness();
        });
        NVEditOptionsDelete.addEventListener('click', ()=>{
            this._deleteCurrentBusiness();
        });
    }
    async _selectActiDisplay(tab) {
        console.log(tab);
        const nvActiCon4 = document.getElementById('nvActiCon4');
        const allSelectors = nvActiCon4.querySelectorAll('.nvActiCon5');
        allSelectors.forEach((selector)=>{
            const isTab = selector.dataset.selector === tab;
            if (!isTab) {
                selector.classList.remove('nvActiCon5Act');
                selector.querySelector('.nvActiText2').classList.remove('nvActiText2Act');
            } else {
                selector.classList.add('nvActiCon5Act');
                selector.querySelector('.nvActiText2').classList.add('nvActiText2Act');
            }
        });
        nvActiCon4.addEventListener('click', async (e)=>{
            const isSelector = e.target.closest('.nvActiCon5');
            if (isSelector) {
                const selected = isSelector.dataset.selector;
                if (selected !== 'sellerprofile') {
                    allSelectors.forEach((selector)=>{
                        selector.classList.remove('nvActiCon5Act');
                        selector.querySelector('.nvActiText2').classList.remove('nvActiText2Act');
                    });
                    isSelector.classList.add('nvActiCon5Act');
                    isSelector.querySelector('.nvActiText2').classList.add('nvActiText2Act');
                }
                if (selected === 'listing-drafts') this._NVDisplayListignDrafts();
                if (selected === 'businesses') this._NVDipslayBusinesses();
                if (selected === 'listings') this._NVDisplayListings();
                if (selected === 'more') this._NVDisplayMore();
                if (selected === 'history') {
                    const userSavedHistory = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUserHistory();
                    console.log(userSavedHistory);
                    this._NVDisplayHistory();
                }
                if (selected === 'sellerprofile') this._NVSellerProfile();
            }
        });
    }
    async _NVDisplayListignDrafts(reset = false) {
        reset;
        this.#currentActi = "listing-drafts";
        const nvActiCon8ItemsMainCon = document.getElementById('MainAppConWithNavigationContentConBusiness');
        const nvActiCon8Items = document.getElementById('nvActiCon8Items');
        nvActiCon8Items.innerHTML = "";
        const drafts = await (0, $4f930c604957bd07$export$2e2bcd8739ae039)._getDrafts();
        drafts.forEach((draft)=>{
            const currentTime = Date.now();
            if (draft.uploadStatus === 'uploading' && currentTime - draft.savedAt > 60000) {
                (0, $4f930c604957bd07$export$2e2bcd8739ae039)._deleteDraft(draft.prefixId);
                return;
            }
            const html = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._actiListingDraft(draft);
            nvActiCon8Items.insertAdjacentHTML("beforeend", html);
        });
        if (this.#draftsEventsActivated) return;
        this.#draftsEventsActivated = true;
        nvActiCon8ItemsMainCon.addEventListener('click', async (e)=>{
            const isDraft = e.target.closest('.actiListingDraftCon1A');
            const isDeleteBtn = e.target.closest('.actiListingDraftCon15');
            const isUseBtn = e.target.closest('.actiListingDraftCon16');
            console.log('Yep clicked', isDraft, isDeleteBtn, isUseBtn);
            if (!isDraft) return;
            const id = isDraft.dataset.id;
            if (!id) return;
            if (isUseBtn) {
                console.log('used');
                (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init(null, id);
            }
            if (isDeleteBtn) {
                const result = await (0, $4f930c604957bd07$export$2e2bcd8739ae039)._deleteDraft(id);
                console.log(result);
                if (result === 'deleted') isDraft.remove();
            }
        });
    }
    async _handleUploadButtons() {
        if (this.#windowEventActivated) return;
        this.#windowEventActivated = true;
        window.addEventListener('click', async (e)=>{
            const isUploadButton = e.target.closest('.actiUploadButton');
            if (isUploadButton) {
                const openTo = isUploadButton.dataset.opento;
                if (openTo === 'uploadGeneral') {
                    console.log('here');
                    (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
                }
                if (openTo === 'uploadListing') {
                    console.log('here');
                    (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
                }
                if (openTo === 'createBusiness') {
                    console.log('here');
                    (0, $81574927169af67f$export$2e2bcd8739ae039)._init();
                }
            }
            const isBusinessEditOptionsButton = e.target.closest('.onBusinessOpenEditOptions');
            if (isBusinessEditOptionsButton) {
                const businessId = isBusinessEditOptionsButton.closest('.v20BusinessCon1A').dataset.businessid;
                if (businessId) {
                    this.#currentBusinessId = businessId;
                    this._handelEditOptinsShow(true);
                }
            }
        });
    }
    _NVPreparePage(tab) {
        const mainCon = document.getElementById('MainAppConWithNavigationContentConBusiness');
        mainCon.style.display = 'flex';
        mainCon.innerHTML = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._NVActiPageHtml();
        if (tab === 'listing-drafts') this._NVDisplayListignDrafts(true);
        else this._NVDipslayBusinesses();
    }
    async _NVDisplayListings() {
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando tus listdos');
            this.#currentActi = "listings";
            const nvActiCon8Items = document.getElementById('nvActiCon8Items');
            nvActiCon8Items.innerHTML = "";
            const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            if (this.#currentActi !== 'listings') return;
            console.log(userData);
            if (!userData) {
                // throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.")
                (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open();
                return;
            }
            if (this.#currentActi !== 'listings') return;
            const loadedListings = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllDocsFromPathByMostRecent(`accounts/${userData.userId}/listings`, true);
            console.log(loadedListings, userData.userId);
            if (!loadedListings) throw new Error("No hemos podido cargar tus listados en este momento. Intenta de nuevo mas tarde.");
            if (this.#currentActi !== 'listings') return;
            if (loadedListings.length > 0) loadedListings.forEach((listing)=>{
                const listingHtml = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing, true, 'listing', false);
                nvActiCon8Items.insertAdjacentHTML("beforeend", listingHtml);
            });
            else {
                const noListings = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._noActi('No tienes listados publicados en Mercado MAI.', "Debes publicar un listado primero, luego lo encontrar\xe1s aqu\xed.", 'Publicar un listado', 'uploadListing');
                if (this.#currentActi !== 'listings') return;
                nvActiCon8Items.insertAdjacentHTML("beforeend", noListings);
            }
        } catch (error) {
            if (this.#currentActi !== 'listings') return;
            alert(error.message);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _NVDisplayMore() {
        this.#currentActi = "more";
        const nvActiCon8Items = document.getElementById('nvActiCon8Items');
        nvActiCon8Items.innerHTML = "";
        const noMore = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._noActi('Por el momento no hay mas publicaciones.', "Porfavor tenganos un poquito paciencia mientras estamos desarollando mas tipos de publicaci\xf3nes en Mercado MAI.", 'Publicar', 'uploadGeneral');
        nvActiCon8Items.insertAdjacentHTML("beforeend", noMore);
    }
    async _NVDisplayHistory() {
        this.#currentActi = "history";
        const nvActiCon8Items = document.getElementById('nvActiCon8Items');
        nvActiCon8Items.innerHTML = "";
        const noMore = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._noActi("Esta funci\xf3n est\xe1 en desarollo.", 'Por favor tenos un poco de paciencia mientras mejoramos tu experiancia.', null, null);
        nvActiCon8Items.insertAdjacentHTML("beforeend", noMore);
    }
    async _NVSellerProfile() {
        console.log('seller profile');
        const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (!userData) {
            (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open();
            return;
        // throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.")
        }
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._displaySellerEach(userData.userId);
    }
    async _NVDipslayBusinesses() {
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando tus negocios.');
            this.#currentActi = "businesses";
            const nvActiCon8Items = document.getElementById('nvActiCon8Items');
            nvActiCon8Items.innerHTML = "";
            await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getUserDataFromBase();
            const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            if (!userData) {
                (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open();
                return;
            // throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.")
            }
            console.log(userData);
            console.log(userData.businesses);
            // if (0 > 0) {
            if (userData?.businesses?.length > 0) for (const business of userData.businesses){
                if (this.#currentActi !== 'businesses') return;
                const loadedBusinessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${business.id}`);
                if (!loadedBusinessData) {
                    alert(`Este negocio ya no existe o fue eliminado.\n\nID: ${business.id}\n\nPorfavor ponte en contacto con nuestro equipo de soporte para resolver este error.`);
                    continue; // 👈 skip this business and move on
                }
                if (this.#currentActi !== 'businesses') return;
                const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(null, 6, `businesses/${business.id}/listings`);
                let listingsHtml = ``;
                if (this.#currentActi !== 'businesses') return;
                if (!listings || listings.length === 0) listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings();
                else {
                    if (this.#currentActi !== 'businesses') return;
                    for (const listing of listings){
                        if (this.#currentActi !== 'businesses') return;
                        listingsHtml += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMini(listing, null, "listingInBusiness", business.businessId);
                    }
                // listingsHtml += generateHtmlListings._viewAllListingsMini(
                //   business.colors
                // );
                }
                if (this.#currentActi !== 'businesses') return;
                const businessInPackHtml = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._generateBusiness2v(listingsHtml, loadedBusinessData, null, null, true, true);
                if (this.#currentActi !== 'businesses') return;
                nvActiCon8Items.insertAdjacentHTML("beforeend", businessInPackHtml);
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
            else {
                if (this.#currentActi !== 'businesses') return;
                const noBusinessesHtml = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._noActi('No tienes un negocio en Mercado MAI.', "Debes crear un negocio primero, luego lo podr\xe1s encontrar aqu\xed.", 'Crear un negocio', 'createBusiness');
                nvActiCon8Items.insertAdjacentHTML("beforeend", noBusinessesHtml);
            }
        } catch (error) {
            if (this.#currentActi !== 'businesses') return;
            alert(error.message);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _checkForBusiness() {
        const bussinessDisplayHeaderCon10ForBusinessOwn = document.getElementById("bussinessDisplayHeaderCon10ForBusinessOwn");
        this.#currentAccount = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        console.log(this.#currentAccount);
        if (this.#currentAccount && this.#currentAccount?.business) {
            const business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getBusinessById(this.#currentAccount.business);
            this.#currentBsiness = business;
            const listings = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllDocsFromPathByMostRecent(`businesses/${this.#currentAccount.business}/listings`, true);
            console.log(listings);
            bussinessDisplayHeaderCon10ForBusinessOwn.innerHTML = await (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._business(business);
            this._fillInBusinessListings(listings, business);
            this._eventsHasPage();
            this._generalEvents();
        } else {
            bussinessDisplayHeaderCon10ForBusinessOwn.innerHTML = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._createBusinessPageMessage(this.#currentAccount);
            bussinessDisplayHeaderCon10ForBusinessOwn.insertAdjacentHTML("beforeend", (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._createBusinessPageButtons(this.#currentAccount));
            (0, $a082c89adac62edb$export$2e2bcd8739ae039)._animateCTA("OwnBusinessConButtonCreateBusinessPage");
            this._eventsNoPage();
            this._generalEvents();
        }
    }
    async _handelActionsOnBusiness(id, button) {
        console.log(id);
        // OwnBusinessCon3
        if (id === "OwnBusinessButtonsActionOnBusinessEdit") {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner();
            const businessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${this.#currentBsiness.businessId}`);
            if (businessData) (0, $81574927169af67f$export$2e2bcd8739ae039)._init(businessData, true);
            else alert('No hemos podido cargar tu negocio en este momento. Intente de nuevo mas tarde.');
        // businessPageEditor._init("edit");
        }
        OwnBusinessButtonsActionOnBusinessStats || OwnBusinessButtonsActionOnBusinessBoost || OwnBusinessButtonsActionOnBusinessShare;
        if (id === "OwnBusinessButtonsActionOnBusinessStats" || id === "OwnBusinessButtonsActionOnBusinessBoost" || id === "OwnBusinessButtonsActionOnBusinessActionMenu") alert("Pr\xf3ximamente. Esta funci\xf3n a\xfan no esta lista.");
        if (id === "OwnBusinessConButtonEditBusinessPageLists1" || id === "OwnBusinessConButtonEditBusinessPageLists2") {
            (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._init("edit", "lists");
            console.log("yep here");
        }
        if (id === "OwnBusinessButtonsActionOnBusinessShare" || id === "OwnBusinessButtonsActionOnBusinessOpen") {
            const businessId = button.closest(".OwnBusinessCon3").dataset.businessid;
            if (businessId) {
                if (id === "OwnBusinessButtonsActionOnBusinessShare") (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._displayTheRightWay(businessId, null, "business", null, true);
                else (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._displayTheRightWay(businessId, null, "business");
            } else alert("Hubio un error al abrir tu negocio. \n Si este error persiste, sugerijmos que cierras y luego abres esta aplicaci\xf3n de nuevo.");
        }
    }
    async _displayLists(listName) {
        let htmlToReturn;
        const htmlContainerId = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUniqueIdfunction();
        try {
            htmlToReturn = (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._listingsCon(listName, htmlContainerId);
            return [
                htmlToReturn,
                htmlContainerId
            ];
        } catch (err) {
            if (err.name === "AbortError") console.log("Display For You aborted.");
            else console.error(err);
        }
    }
    async _fillInBusinessListings(listings, businessData) {
        console.warn(listings);
        const fillInListings = async ()=>{
            const OwnBusinessConBusinessListingsCon = document.getElementById("OwnBusinessConBusinessListingsCon");
            for (const listing of listings){
                // if (signal.aborted) throw new Error("Aborted");
                const html = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVertical(listing, businessData.colors, null, businessData.businessId, undefined, "false", true);
                OwnBusinessConBusinessListingsCon.insertAdjacentHTML("beforeend", html);
            }
        };
        fillInListings();
    }
    _eventsNoPage() {
        const createPageButton = document.getElementById("OwnBusinessConButtonCreateBusinessPage");
        // const buttonLogin = document.getElementById("OwnBusinessConButtonLogin");
        // buttonLogin.addEventListener("click", () => {
        //   register._displayOptions("create_business_page");
        // });
        createPageButton.addEventListener("click", ()=>{
            const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            if (account) {
                if (!account.whatsAppNumber) {
                    (0, $33656b45f0922648$export$2e2bcd8739ae039)._open();
                    alert("Debes tener un perfil de vendedor para poder publicar listados.");
                    return;
                }
                (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._init();
            } else (0, $5b997bd2b2817dfd$export$2e2bcd8739ae039)._displayOptions("create_business_page");
        });
    }
    _showTopBusinessCon() {
        const bussinessDisplayHeaderCon10ForBusinessOwn = document.getElementById("bussinessDisplayHeaderCon10ForBusinessOwn");
        bussinessDisplayHeaderCon10ForBusinessOwn.classList.remove("OwnBusinessConBusinessMessageConColapsed");
    }
    _hideTopBusinessCon() {
        const bussinessDisplayHeaderCon10ForBusinessOwn = document.getElementById("bussinessDisplayHeaderCon10ForBusinessOwn");
        bussinessDisplayHeaderCon10ForBusinessOwn.classList.add("OwnBusinessConBusinessMessageConColapsed");
    }
    _scrollDirectionDecide(direction) {
        if (direction === "up") this._showTopBusinessCon();
        else if (direction === "down") this._hideTopBusinessCon();
    }
    _detectScrollDirection(id, callback) {
        const container = document.getElementById(id);
        let lastScrollTop = container.scrollTop;
        container.addEventListener("scroll", ()=>{
            const currentScrollTop = container.scrollTop;
            const diff = currentScrollTop - lastScrollTop;
            if (currentScrollTop < 0) return;
            // Check if the container is scrolled to the bottom
            if (container.scrollHeight - container.scrollTop === container.clientHeight) this._showTopBusinessCon(); // Call when at the bottom
            if (Math.abs(diff) > 100) {
                const direction = diff > 0 ? "down" : "up";
                this._scrollDirectionDecide(direction);
                lastScrollTop = currentScrollTop; // reset after trigger
            }
        });
    }
    _addTheRightPaddingToItemsCon() {
        const con = document.getElementById("bussinessDisplayHeaderCon10ForBusinessOwn"); // Replace with your actual ID or class
        const target = document.getElementById("OwnBusinessConBusinessListingsCon");
        console.log(con, target);
        if (con && target) {
            const conHeight = con.offsetHeight;
            console.log(conHeight);
            target.style.paddingTop = `${conHeight + 5}px`;
        }
    }
    _eventsHasPage() {
        this._detectScrollDirection("OwnBusinessConBusinessListingsCon");
        this._addTheRightPaddingToItemsCon();
        const buttonsContainer = document.querySelectorAll(".OwnBusinessButtonsActionOnBusinessForEventListining");
        buttonsContainer.forEach((button)=>{
            button.addEventListener("click", (e)=>{
                // Check for the closest element with an ID
                const targetButton = e.target.closest(".OwnBusinessButtonsActionOnBusinessForEventListining");
                if (targetButton && targetButton.id) this._handelActionsOnBusiness(targetButton.id, button);
                else console.log("No valid ID found.");
            });
        });
    }
    async _openSubscription(dataIn) {
        let dataToSend = null;
        if (this.#currentBsiness?.currentSubscriptionId) dataToSend = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`subscriptions/${this.#currentBsiness.currentSubscriptionId}`);
        const subscriptionPlanTextHeader = document.querySelectorAll(".subscriptionPlanTextHeader");
        const subscriptionPlanExitButtons = document.querySelectorAll(".subscriptionPlanExitButtons");
        const subscriptionPlanNextButtons = document.querySelectorAll(".subscriptionPlanNextButtons");
        const subscriptionPlanSelectYearButton = document.getElementById("subscriptionPlanSelectYearButton");
        const subscriptionPlanSelectMonthButton = document.getElementById("subscriptionPlanSelectMonthButton");
        const subscriptionPlanConMonth = document.getElementById("subscriptionPlanConMonth");
        const subscriptionPlanConYear = document.getElementById("subscriptionPlanConYear");
        const subscriptionPlanInputPriorityPointsMonth = document.getElementById("subscriptionPlanInputPriorityPointsMonth");
        const subscriptionPlanInputPriorityPointsYear = document.getElementById("subscriptionPlanInputPriorityPointsYear");
        const subscriptionPlanFinalPriceMonth = document.getElementById("subscriptionPlanFinalPriceMonth");
        const subscriptionPlanFinalPriceYear = document.getElementById("subscriptionPlanFinalPriceYear");
        const subscriptionPlanSelectListingsMonth = document.getElementById("subscriptionPlanSelectListingsMonth");
        const allLisitngSelectorsInMonth = subscriptionPlanSelectListingsMonth.querySelectorAll(".SubBusPlanCon12");
        const subscriptionPlanSelectListingsYear = document.getElementById("subscriptionPlanSelectListingsYear");
        const allLisitngSelectorsInYear = subscriptionPlanSelectListingsYear.querySelectorAll(".SubBusPlanCon12");
        let subscriptionDataToSet = null;
        let planselected = "month";
        let listingSelected = "included";
        let priorityLevelSelected = "";
        subscriptionPlanTextHeader.textContent = "Escoge el plan perfecto para tu negocio";
        if (dataIn) dataIn.items.forEach((item)=>{
            if (item.type === "subscripci\xf3n") subscriptionDataToSet = item;
        });
        if (subscriptionDataToSet) {
            subscriptionPlanTextHeader.textContent = "Renueva tu plan";
            planselected = subscriptionDataToSet.plan;
            listingSelected = subscriptionDataToSet.listings;
            priorityLevelSelected = subscriptionDataToSet.priorityLevel;
        }
        const allowOnlyNumbers = (event)=>{
            const input = event.target;
            const value = input.value;
            // Replace all non-digit characters
            input.value = value.replace(/\D/g, ""); // \D matches any non-digit character
        };
        const calculatePlanPrice = (data)=>{
            let finalAmount = 0;
            if (data.plan === "month") finalAmount += 290;
            if (data.plan === "year") finalAmount += 2958;
            if (data.listings === "20") finalAmount += 290;
            if (data.listings === "30") finalAmount += 480;
            if (data.listings === "45") finalAmount += 600;
            if (data.listings === "240") finalAmount += 2958;
            if (data.listings === "360") finalAmount += 4896;
            if (data.listings === "540") finalAmount += 5508;
            if (data.plan === "month" && data.listings === "unlimited") finalAmount += 1280;
            if (data.plan === "year" && data.listings === "unlimited") finalAmount += 13056;
            finalAmount += Number(data.priorityLevel * 0.5);
            if (data.plan === "month") {
                console.log("month now");
                subscriptionPlanFinalPriceMonth.textContent = `$${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatToPrice(finalAmount)}`;
            }
            if (data.plan === "year") {
                console.log("yearNow");
                subscriptionPlanFinalPriceYear.textContent = `$${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatToPrice(finalAmount)}`;
            }
        };
        const getPlanData = ()=>{
            const planData = {
                plan: "",
                listings: "",
                priorityLevel: ""
            };
            console.log(planselected);
            if (planselected === "month") {
                allLisitngSelectorsInMonth.forEach((selector)=>{
                    if (selector.dataset.selected === "true") planData.listings = selector.dataset.numberoflistings;
                });
                planData.priorityLevel = subscriptionPlanInputPriorityPointsMonth.value.trim();
                if (planData.priorityLevel === "") planData.priorityLevel = "0";
                planData.plan = "month";
            }
            if (planselected === "year") {
                allLisitngSelectorsInYear.forEach((selector)=>{
                    if (selector.dataset.selected === "true") planData.listings = selector.dataset.numberoflistings;
                });
                planData.priorityLevel = subscriptionPlanInputPriorityPointsYear.value.trim();
                if (planData.priorityLevel === "") planData.priorityLevel = "0";
                planData.plan = "year";
            }
            calculatePlanPrice(planData);
            console.log(planData);
            return planData;
        };
        subscriptionPlanInputPriorityPointsMonth.addEventListener("blur", (e)=>{
            allowOnlyNumbers(e);
            getPlanData();
        });
        subscriptionPlanInputPriorityPointsMonth.addEventListener("keyup", (e)=>{
            allowOnlyNumbers(e);
            getPlanData();
        });
        subscriptionPlanInputPriorityPointsYear.addEventListener("blur", (e)=>{
            allowOnlyNumbers(e);
            getPlanData();
        });
        subscriptionPlanInputPriorityPointsYear.addEventListener("keyup", (e)=>{
            allowOnlyNumbers(e);
            getPlanData();
        });
        const setYearListingSelector = (closestSelector)=>{
            console.log(closestSelector);
            allLisitngSelectorsInYear.forEach((selector)=>{
                const text = selector.querySelector(".SubBusPlanCon12Text");
                selector.classList.remove("SubBusPlanCon12ActivePro");
                selector.classList.add("SubBusPlanCon12NoneActive");
                text.classList.remove("SubBusPlanConText8");
                text.classList.add("SubBusPlanConText10B");
                selector.dataset.selected = "false";
                if (selector.dataset.numberoflistings === closestSelector.dataset.numberoflistings) {
                    selector.dataset.selected = "true";
                    text.classList.add("SubBusPlanConText8");
                    text.classList.remove("SubBusPlanConText10B");
                    console.log(selector.dataset.numberoflistings);
                    selector.classList.add("SubBusPlanCon12ActivePro");
                    selector.classList.remove("SubBusPlanCon12NoneActive");
                }
            });
            getPlanData();
        };
        const setMonthListingSelector = (closestSelector)=>{
            console.log(closestSelector);
            allLisitngSelectorsInMonth.forEach((selector)=>{
                const text = selector.querySelector(".SubBusPlanCon12Text");
                selector.classList.remove("SubBusPlanCon12Active");
                selector.classList.add("SubBusPlanCon12NoneActive");
                text.classList.remove("SubBusPlanConText8");
                text.classList.add("SubBusPlanConText10");
                selector.dataset.selected = "false";
                if (selector.dataset.numberoflistings === closestSelector.dataset.numberoflistings) {
                    selector.dataset.selected = "true";
                    text.classList.add("SubBusPlanConText8");
                    text.classList.remove("SubBusPlanConText10");
                    console.log(selector.dataset.numberoflistings);
                    selector.classList.add("SubBusPlanCon12Active");
                    selector.classList.remove("SubBusPlanCon12NoneActive");
                }
            });
            getPlanData();
        };
        if (planselected === "month" && subscriptionDataToSet) {
            allLisitngSelectorsInMonth.forEach((selector)=>{
                if (selector.dataset.numberoflistings === listingSelected) setMonthListingSelector(selector);
            });
            subscriptionPlanConMonth.style.display = "";
            subscriptionPlanConYear.style.display = "none";
            planselected = "month";
            subscriptionPlanInputPriorityPointsMonth.value = priorityLevelSelected;
        }
        if (planselected === "year" && subscriptionDataToSet) {
            allLisitngSelectorsInYear.forEach((selector)=>{
                if (selector.dataset.numberoflistings === listingSelected) setYearListingSelector(selector);
            });
            subscriptionPlanConMonth.style.display = "none";
            subscriptionPlanConYear.style.display = "";
            planselected = "month";
            subscriptionPlanInputPriorityPointsYear.value = priorityLevelSelected;
        }
        subscriptionPlanSelectListingsMonth.addEventListener("click", (e)=>{
            const closestSelector = e.target.closest(".SubBusPlanCon12");
            if (closestSelector) setMonthListingSelector(closestSelector);
        });
        subscriptionPlanSelectListingsYear.addEventListener("click", (e)=>{
            const closestSelector = e.target.closest(".SubBusPlanCon12");
            if (closestSelector) setYearListingSelector(closestSelector);
        });
        subscriptionPlanSelectYearButton.addEventListener("click", ()=>{
            subscriptionPlanConMonth.style.display = "none";
            subscriptionPlanConYear.style.display = "";
            planselected = "year";
        });
        subscriptionPlanSelectMonthButton.addEventListener("click", ()=>{
            subscriptionPlanConMonth.style.display = "";
            subscriptionPlanConYear.style.display = "none";
            planselected = "month";
        });
        subscriptionPlanExitButtons.forEach((button)=>{
            button.addEventListener("click", ()=>{});
        });
        subscriptionPlanNextButtons.forEach((button)=>{
            button.addEventListener("click", ()=>{
                const plan = getPlanData();
                console.log(plan);
            });
        });
    }
    _generalEvents() {
        const OwnBusinessButtonCreateListing = document.getElementById("OwnBusinessButtonCreateListing");
        const OwnBusinessConBusinessMessageConSubscriptionButton = document.getElementById("OwnBusinessConBusinessMessageConSubscriptionButton");
        OwnBusinessButtonCreateListing.addEventListener("click", ()=>{
            (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
        });
        if (OwnBusinessConBusinessMessageConSubscriptionButton) OwnBusinessConBusinessMessageConSubscriptionButton.addEventListener("click", ()=>{
            this._openSubscription();
        });
    }
}
var $fec3fe9805a53782$export$2e2bcd8739ae039 = new $fec3fe9805a53782$var$BusinessOwn();


let $81574927169af67f$var$businessDataResetTo = {
    name: 'Nombre de negocio',
    shortDescription: "Descripci\xf3n corta de tu negocio",
    views: '',
    images: {
        profile: {
            fullUrl: ""
        },
        background: {
            fullUrl: ""
        }
    },
    shares: '',
    contacts: {
        call: {
            contact: "",
            contryCode: "52"
        },
        whatsApp: {
            contact: "",
            contryCode: "52"
        },
        email: {
            contact: ""
        },
        website: {
            contact: ""
        }
    },
    status: "active",
    about: "",
    place: {
        description: "",
        lat: "",
        lng: "",
        locationUrl: "",
        name: "",
        city: "",
        country: "",
        state: ""
    },
    businessTokens: [],
    moreData: {
        edit: false,
        imagesChaneged: false
    },
    filterLat: '',
    filterLng: '',
    filterState: '',
    filterCountry: '',
    filterCity: ''
};
let $81574927169af67f$var$businessData = {
    name: 'Nombre de negocio',
    shortDescription: "Descripci\xf3n corta de tu negocio",
    views: '',
    images: {
        profile: {
            fullUrl: ""
        },
        background: {
            fullUrl: ""
        }
    },
    shares: '',
    contacts: {
        call: {
            contact: "",
            contryCode: "52"
        },
        whatsApp: {
            contact: "",
            contryCode: "52"
        },
        email: {
            contact: ""
        },
        website: {
            contact: ""
        }
    },
    status: "active",
    about: "",
    place: {
        description: "",
        lat: "",
        lng: "",
        locationUrl: "",
        name: "",
        city: "",
        country: "",
        state: ""
    },
    businessTokens: [],
    moreData: {
        edit: false,
        imagesChaneged: false
    },
    filterLat: '',
    filterLng: '',
    filterState: '',
    filterCountry: '',
    filterCity: ''
};
// const arrStatus = {
//     Nombre: { status: "completed" },
//     Fotos: { status: "completed" },
//     Contacto: { status: "completed" },
//     Lugar: { status: "completed" },
//     Información: { status: "error" }
// };
let $81574927169af67f$var$arrStatus = {
    Nombre: {
        name: {
            status: "",
            errorMessage: ""
        },
        description: {
            status: "",
            errorMessage: ""
        }
    },
    Fotos: {
        profile: {
            status: "",
            errorMessage: ""
        },
        background: {
            status: "",
            errorMessage: ""
        }
    },
    Contacto: {
        call: {
            status: "",
            errorMessage: ""
        },
        whatsApp: {
            status: "",
            errorMessage: ""
        },
        email: {
            status: "",
            errorMessage: ""
        }
    },
    Lugar: {
        link: {
            status: "",
            errorMessage: ""
        },
        description: {
            status: "",
            errorMessage: ""
        }
    },
    "Informaci\xf3n": {
        description: {
            status: "",
            errorMessage: ""
        },
        website: {
            status: "completed",
            errorMessage: ""
        }
    }
};
class $81574927169af67f$var$NVBusinessEditor {
    _resetEditorStatus(arrStatus, resetTo = "") {
        const newStatus = {};
        for (const [step, subSteps] of Object.entries(arrStatus)){
            newStatus[step] = {};
            for (const [key, subData] of Object.entries(subSteps))newStatus[step][key] = {
                status: resetTo,
                errorMessage: ""
            };
        }
        return newStatus;
    }
    _updateEditorSteps(atNow, arrStatus) {
        const stepsContainer = document.getElementById("nvBusinessEditorCon8");
        const steps = Array.from(stepsContainer.querySelectorAll(".nvBusinessEditorCon9"));
        const errorMessageEl = document.getElementById("nvBusinessEditorErrorMessage");
        const stepNames = steps.map((step)=>step.querySelector(".nvBusinessEditorText3, .nvBusinessEditorText3Act").textContent.trim());
        const currentIndex = stepNames.indexOf(atNow);
        if (currentIndex === -1) return console.warn("\u26A0\uFE0F Step not found:", atNow);
        steps.forEach((step, i)=>{
            const stepName = stepNames[i];
            const subSteps = arrStatus[stepName] || {};
            // Extract substep statuses (ignore errorMessage field)
            const statuses = Object.values(subSteps).map((sub)=>sub.status);
            const hasError = statuses.includes("error");
            const allCompleted = statuses.length > 0 && statuses.every((s)=>s === "completed");
            const textEl = step.querySelector(".nvBusinessEditorText3, .nvBusinessEditorText3Act");
            // Reset visuals
            step.classList.remove("nvBusinessEditorCon9Act");
            textEl.classList.remove("nvBusinessEditorText3Act");
            step.querySelector("[data-status='completed']").style.display = "none";
            step.querySelector("[data-status='error']").style.display = "none";
            // Mark active steps up to the current one
            if (i <= currentIndex) {
                step.classList.add("nvBusinessEditorCon9Act");
                textEl.classList.add("nvBusinessEditorText3Act");
            }
            // Set step-level indicators
            if (hasError) step.querySelector("[data-status='error']").style.display = "flex";
            else if (allCompleted) step.querySelector("[data-status='completed']").style.display = "flex";
        });
        // ✅ Handle error messages for the currently active step
        if (errorMessageEl) {
            const currentStepData = arrStatus[atNow];
            if (currentStepData) {
                // Collect all non-empty error messages from substeps
                const allErrors = Object.entries(currentStepData).map(([subKey, subData])=>subData?.errorMessage?.trim()).filter((msg)=>msg && msg.length > 0);
                if (allErrors.length > 0) {
                    errorMessageEl.textContent = allErrors.join("\n");
                    errorMessageEl.classList.add("nvBusinessEditorText3BError");
                    errorMessageEl.classList.remove("nvBusinessEditorText3BGood");
                } else {
                    errorMessageEl.textContent = "Sin errores aqu\xed";
                    errorMessageEl.classList.remove("nvBusinessEditorText3BError");
                    errorMessageEl.classList.add("nvBusinessEditorText3BGood");
                }
            } else {
                // Step not found (safety fallback)
                errorMessageEl.textContent = "Sin errores aqu\xed";
                errorMessageEl.classList.remove("nvBusinessEditorText3BError");
                errorMessageEl.classList.add("nvBusinessEditorText3BGood");
            }
        }
    }
    _watchEditorScroll(containerId, arrStatus) {
        const container = document.getElementById(containerId);
        if (!container) return console.warn("\u26A0\uFE0F Container not found:", containerId);
        const sections = Array.from(container.querySelectorAll(".nvBusinessEditorCon10B"));
        if (sections.length === 0) return console.warn("\u26A0\uFE0F No editor sections found.");
        // IntersectionObserver to detect visible section
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                    const atNow = entry.target.dataset.step;
                    this._updateEditorSteps(atNow, arrStatus);
                    this._handleButtonUpdates({
                        to: atNow
                    });
                }
            });
        }, {
            root: container,
            threshold: [
                0.6
            ]
        });
        sections.forEach((sec)=>observer.observe(sec));
    }
    _scrollToEditorStep(directionOrStep) {
        const container = document.getElementById("nvBusinessEditorCon10");
        if (!container) {
            console.warn("\u26A0\uFE0F Editor container not found.");
            return null;
        }
        const steps = Array.from(container.querySelectorAll(".nvBusinessEditorCon10B"));
        const stepNames = steps.map((el)=>el.dataset.step);
        // 🧠 Detect which step is most visible in the scroll container
        let activeIndex = steps.findIndex((el)=>el.classList.contains("nvBusinessEditorCon10BAct"));
        let visibleIndex = activeIndex;
        const containerRect = container.getBoundingClientRect();
        let maxVisibleWidth = 0;
        steps.forEach((step, i)=>{
            const rect = step.getBoundingClientRect();
            const visibleWidth = Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left);
            if (visibleWidth > maxVisibleWidth) {
                maxVisibleWidth = visibleWidth;
                visibleIndex = i;
            }
        });
        // ✅ Use the most visible step as the current one
        activeIndex = visibleIndex !== -1 ? visibleIndex : 0;
        const prevStep = stepNames[activeIndex];
        let targetIndex = activeIndex;
        if (directionOrStep === "ahead") targetIndex = Math.min(activeIndex + 1, steps.length - 1);
        else if (directionOrStep === "back") targetIndex = Math.max(activeIndex - 1, 0);
        else {
            const stepNameIndex = stepNames.indexOf(directionOrStep);
            if (stepNameIndex !== -1) targetIndex = stepNameIndex;
            else {
                console.warn("\u26A0\uFE0F Step not found:", directionOrStep);
                return null;
            }
        }
        const targetStep = steps[targetIndex];
        if (!targetStep) return null;
        // Smooth scroll to it
        targetStep.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
        });
        // Update active class
        steps.forEach((s)=>{
            if (s) s.classList.remove("nvBusinessEditorCon10BAct");
        });
        targetStep.classList.add("nvBusinessEditorCon10BAct");
        const stepData = {
            from: prevStep,
            to: targetStep.dataset.step
        };
        // Hook for external updates
        this._handleButtonUpdates(stepData, directionOrStep);
        return stepData;
    }
    _initEditorStepClicks() {
        const stepsHeader = document.getElementById("nvBusinessEditorCon8");
        if (!stepsHeader) return console.warn("\u26A0\uFE0F Step header container not found.");
        const stepButtons = stepsHeader.querySelectorAll(".nvBusinessEditorCon9");
        stepButtons.forEach((btn)=>{
            btn.addEventListener("click", ()=>{
                const step = btn.dataset.step;
                if (!step) return;
                const returnStep = this._scrollToEditorStep(step);
            });
        });
    }
    _handleButtonUpdates(stepData, direction = null) {
        const nvBusinessEditorButtonStepBack = document.getElementById("nvBusinessEditorButtonStepBack");
        const nvBusinessEditorButtonStepAhead = document.getElementById("nvBusinessEditorButtonStepAhead");
        const buttonBackText = nvBusinessEditorButtonStepBack.querySelector('.nvBusinessEditorText4');
        const buttonBackIcon = nvBusinessEditorButtonStepBack.querySelector('img');
        const buttonAheadText = nvBusinessEditorButtonStepAhead.querySelector('.nvBusinessEditorText4B');
        const buttonAheadIcon = nvBusinessEditorButtonStepAhead.querySelector('img');
        if (stepData.from === "Nombre" && direction === "back") {
            const confirmExit = confirm("\xbfCerrar? Perder\xe1s todos los cambios que hiciste a tu p\xe1gina.");
            if (confirmExit) this._closeBusinessEditor();
        }
        if (stepData.from === "Informaci\xf3n" && direction === "ahead") {
            const confirmSave = confirm("\xbfListo? Esto guardar\xe1 todos tus cambios en tu p\xe1gina de negocio.");
            if (confirmSave) this._NVBusinessCreateUpdate();
        }
        if (stepData.to === "Nombre") {
            buttonBackText.textContent = "Cancelar";
            buttonBackIcon.src = (0, (/*@__PURE__*/$parcel$interopDefault($92d6f0f713f0d9c5$exports)));
            nvBusinessEditorButtonStepBack.classList.add("nvBusinessEditorCon12Exit");
        } else {
            buttonBackText.textContent = "Volver";
            buttonBackIcon.src = (0, (/*@__PURE__*/$parcel$interopDefault($b70fbd1110057bc1$exports)));
            nvBusinessEditorButtonStepBack.classList.remove("nvBusinessEditorCon12Exit");
        }
        if (stepData.to === "Informaci\xf3n") {
            buttonAheadText.textContent = "Guardar";
            buttonAheadIcon.src = (0, (/*@__PURE__*/$parcel$interopDefault($02cb795988e665a0$exports)));
            nvBusinessEditorButtonStepAhead.classList.add("nvBusinessEditorCon13Save");
        } else {
            buttonAheadText.textContent = "Siguiente";
            buttonAheadIcon.src = (0, (/*@__PURE__*/$parcel$interopDefault($197b964e30a399b9$exports)));
            nvBusinessEditorButtonStepAhead.classList.remove("nvBusinessEditorCon13Save");
        }
    }
    _activateDataGather() {
        const nvBusinessEditorShowName = document.getElementById('nvBusinessEditorShowName');
        const nvBusinessEditorShowShortDescription = document.getElementById('nvBusinessEditorShowShortDescription');
        const nvBusinessEditorInputBusinessName = document.getElementById('nvBusinessEditorInputBusinessName');
        const nvBusinessEditorInputBusinessShortDescription = document.getElementById('nvBusinessEditorInputBusinessShortDescription');
        const nvBusinessEditorInputWhatsAppNumberContryCode = document.getElementById('nvBusinessEditorInputWhatsAppNumberContryCode');
        const nvBusinessEditorInputWhatsAppNumber = document.getElementById('nvBusinessEditorInputWhatsAppNumber');
        const nvBusinessEditorInputCallNumberContryCode = document.getElementById('nvBusinessEditorInputCallNumberContryCode');
        const nvBusinessEditorInputCallNumber = document.getElementById('nvBusinessEditorInputCallNumber');
        const nvBusinessEditorInputEmail = document.getElementById('nvBusinessEditorInputEmail');
        const nvBusinessEditorButtonOpenLocationSelector = document.getElementById('nvBusinessEditorButtonOpenLocationSelector');
        const nvBusinessEditorInputLocationDescription = document.getElementById('nvBusinessEditorInputLocationDescription');
        const nvBusinessEditorInputBusinessDescription = document.getElementById('nvBusinessEditorInputBusinessDescription');
        const nvBusinessEditorInputWebsite = document.getElementById('nvBusinessEditorInputWebsite');
        // START Business name
        const setBusinessName = ()=>{
            let valueL = "Nombre de Negocio";
            let value = nvBusinessEditorInputBusinessName.value.trim();
            if (value.length > 0) valueL = value;
            nvBusinessEditorShowName.textContent = valueL;
            $81574927169af67f$var$businessData.name = valueL;
            if (value.length > 2) {
                $81574927169af67f$var$arrStatus.Nombre.name.status = "completed";
                $81574927169af67f$var$arrStatus.Nombre.name.errorMessage = "";
            } else {
                $81574927169af67f$var$arrStatus.Nombre.name.status = "error";
                $81574927169af67f$var$arrStatus.Nombre.name.errorMessage = "\u2022 El nombre debe ser por lo menos una palabra de 3 letras";
            }
            this._updateEditorSteps("Nombre", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputBusinessName.addEventListener('keyup', ()=>{
            setBusinessName();
        });
        nvBusinessEditorInputBusinessName.addEventListener('blur', ()=>{
            setBusinessName();
        });
        nvBusinessEditorButtonOpenLocationSelector.addEventListener('click', async ()=>{
            try {
                const locationData = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._locationPicker($81574927169af67f$var$businessData.place);
                const locationTag = document.getElementById('nvBusinessEditorButtonOpenLocationSelectorLocationTag');
                locationTag.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getDisplayLocationName(locationData);
                $81574927169af67f$var$businessData.place.lat = locationData.lat;
                $81574927169af67f$var$businessData.place.lng = locationData.lng;
                $81574927169af67f$var$businessData.place.state = locationData.state;
                $81574927169af67f$var$businessData.place.country = locationData.country;
                $81574927169af67f$var$businessData.place.city = locationData.city;
                $81574927169af67f$var$businessData.place.locationUrl = locationData.locationUrl;
                $81574927169af67f$var$businessData.place.name = locationData.name;
                $81574927169af67f$var$businessData.place.address = locationData.address;
                $81574927169af67f$var$businessData.filterLat = locationData.lat;
                $81574927169af67f$var$businessData.filterLng = locationData.lng;
                $81574927169af67f$var$businessData.filterState = locationData.state;
                $81574927169af67f$var$businessData.filterCountry = locationData.country;
                $81574927169af67f$var$businessData.filterCity = locationData.city;
                console.log('LocationData', locationData, 'businessData', $81574927169af67f$var$businessData);
                $81574927169af67f$var$arrStatus.Lugar.link.status = "completed";
                $81574927169af67f$var$arrStatus.Lugar.link.errorMessage = "";
                this._updateEditorSteps("Lugar", $81574927169af67f$var$arrStatus);
            } catch (error) {
                console.log(error);
                if (error === 'cancelled') {
                    $81574927169af67f$var$arrStatus.Lugar.link.status = "error";
                    $81574927169af67f$var$arrStatus.Lugar.link.errorMessage = "\u2022 Nesecitas seleccionar una ubicaci\xf3n.";
                    this._updateEditorSteps("Lugar", $81574927169af67f$var$arrStatus);
                }
            }
        });
        // START Business Short Description
        const setBusinessShortDescription = ()=>{
            let valueL = "Descripci\xf3n corta de tu negocio";
            let value = nvBusinessEditorInputBusinessShortDescription.value.trim();
            if (value.length > 0) valueL = value;
            nvBusinessEditorShowShortDescription.textContent = valueL;
            $81574927169af67f$var$businessData.shortDescription = valueL;
            if (value.split(" ").length > 3) {
                $81574927169af67f$var$arrStatus.Nombre.description.status = "completed";
                $81574927169af67f$var$arrStatus.Nombre.description.errorMessage = "";
            } else {
                $81574927169af67f$var$arrStatus.Nombre.description.status = "error";
                $81574927169af67f$var$arrStatus.Nombre.description.errorMessage = "\u2022 La descripci\xf3n corta debe tener por lo menos 4 palabras";
            }
            this._updateEditorSteps("Nombre", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputBusinessShortDescription.addEventListener('keyup', ()=>{
            setBusinessShortDescription();
        });
        nvBusinessEditorInputBusinessShortDescription.addEventListener('blur', ()=>{
            setBusinessShortDescription();
        });
        // START WhatsApp
        const setWhatsAppNumber = ()=>{
            let valueL = "";
            let value = nvBusinessEditorInputWhatsAppNumber.value.trim();
            if (value.length > 0) valueL = value;
            $81574927169af67f$var$businessData.contacts.whatsApp.contact = valueL;
            if (value.length === 10) {
                $81574927169af67f$var$arrStatus.Contacto.whatsApp.status = "completed";
                $81574927169af67f$var$arrStatus.Contacto.whatsApp.errorMessage = "";
            } else {
                $81574927169af67f$var$arrStatus.Contacto.whatsApp.status = "error";
                $81574927169af67f$var$arrStatus.Contacto.whatsApp.errorMessage = "\u2022 El n\xfamero de WhatsApp debe tener exactamente 10 digitos";
            }
            this._updateEditorSteps("Contacto", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputWhatsAppNumber.addEventListener('keyup', ()=>{
            setWhatsAppNumber();
        });
        nvBusinessEditorInputWhatsAppNumber.addEventListener('blur', ()=>{
            setWhatsAppNumber();
        });
        nvBusinessEditorInputWhatsAppNumberContryCode.addEventListener("change", (e)=>{
            const selectedValue = e.target.value;
            $81574927169af67f$var$businessData.contacts.whatsApp.contryCode = selectedValue;
        });
        // START Call
        const setCallNumber = ()=>{
            let valueL = "";
            let value = nvBusinessEditorInputCallNumber.value.trim();
            if (value.length > 0) valueL = value;
            $81574927169af67f$var$businessData.contacts.call.contact = valueL;
            if (value.length === 10) {
                $81574927169af67f$var$arrStatus.Contacto.call.status = "completed";
                $81574927169af67f$var$arrStatus.Contacto.call.errorMessage = "";
            } else {
                $81574927169af67f$var$arrStatus.Contacto.call.status = "error";
                $81574927169af67f$var$arrStatus.Contacto.call.errorMessage = "\u2022 El n\xfamero de llamadas debe tener exactamente 10 digitos";
            }
            this._updateEditorSteps("Contacto", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputCallNumber.addEventListener('keyup', ()=>{
            setCallNumber();
        });
        nvBusinessEditorInputCallNumber.addEventListener('blur', ()=>{
            setCallNumber();
        });
        nvBusinessEditorInputCallNumberContryCode.addEventListener("change", (e)=>{
            const selectedValue = e.target.value;
            $81574927169af67f$var$businessData.contacts.call.contryCode = selectedValue;
        });
        // START email
        const setEmail = ()=>{
            let valueL = "";
            let value = nvBusinessEditorInputEmail.value.trim();
            if (value.length > 0) valueL = value;
            $81574927169af67f$var$businessData.contacts.email.contact = valueL;
            const email = value;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(email)) {
                $81574927169af67f$var$arrStatus.Contacto.email.status = "completed";
                $81574927169af67f$var$arrStatus.Contacto.email.errorMessage = "";
            } else {
                $81574927169af67f$var$arrStatus.Contacto.email.status = "error";
                $81574927169af67f$var$arrStatus.Contacto.email.errorMessage = "\u2022 Este correo no es un correo v\xe1lido";
            }
            this._updateEditorSteps("Contacto", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputEmail.addEventListener('keyup', ()=>{
            setEmail();
        });
        nvBusinessEditorInputEmail.addEventListener('blur', ()=>{
            setEmail();
        });
        // START location
        // const setLocationUrl = () => {
        //     let valueL = ""
        //     let value = nvBusinessEditorInputLocationLink.value.trim()
        //     if (value.length > 0) {
        //         valueL = value
        //     }
        //     function isValidMapLink(value) {
        //         try {
        //             const url = new URL(value);
        //             const { hostname } = url;
        //             // Normalize hostname (remove www.)
        //             const cleanHost = hostname.replace(/^www\./, "").toLowerCase();
        //             // List of known map domains
        //             const mapDomains = [
        //                 "google.com",
        //                 "maps.google.com",
        //                 "goo.gl",                // short Google Maps links
        //                 "apple.com",
        //                 "maps.apple.com",
        //                 "bing.com",
        //                 "maps.bing.com",
        //                 "waze.com",
        //                 "openstreetmap.org",
        //                 "mapy.cz",
        //                 "here.com"
        //             ];
        //             // Check if hostname includes any known map domain
        //             return mapDomains.some(domain => cleanHost.includes(domain));
        //         } catch {
        //             return false;
        //         }
        //     }
        //     if (isValidMapLink(value)) {
        //         arrStatus.Lugar.link.status = "completed"
        //         arrStatus.Lugar.link.errorMessage = ""
        //         businessData.place.locationUrl = valueL
        //     } else {
        //         arrStatus.Lugar.link.status = "error"
        //         arrStatus.Lugar.link.errorMessage = "• Este enlace de ubicación no es un enlace válido"
        //         businessData.place.locationUrl = "valueL"
        //     }
        //     this._updateEditorSteps("Lugar", arrStatus)
        // }
        const setLocationDiscription = ()=>{
            let valueL = "";
            let value = nvBusinessEditorInputLocationDescription.value.trim();
            if (value.length > 0) valueL = value;
            $81574927169af67f$var$businessData.place.description = valueL;
            if (value.split(" ").length > 2) {
                $81574927169af67f$var$arrStatus.Lugar.description.status = "completed";
                $81574927169af67f$var$arrStatus.Lugar.description.errorMessage = "";
            } else {
                $81574927169af67f$var$arrStatus.Lugar.description.status = "error";
                $81574927169af67f$var$arrStatus.Lugar.description.errorMessage = "\u2022 Las descripci\xf3n del lugar deber tener por lo menos 3 palabras";
            }
            this._updateEditorSteps("Lugar", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputLocationDescription.addEventListener('keyup', ()=>{
            setLocationDiscription();
        });
        nvBusinessEditorInputLocationDescription.addEventListener('blur', ()=>{
            setLocationDiscription();
        });
        // START location
        const setBusinessDescription = ()=>{
            let valueL = "Nombre de Negocio";
            let value = nvBusinessEditorInputBusinessDescription.value.trim();
            if (value.length > 0) valueL = value;
            $81574927169af67f$var$businessData.about = valueL;
            if (value.split(" ").length > 9) {
                $81574927169af67f$var$arrStatus.Informaci\u00f3n.description.status = "completed";
                $81574927169af67f$var$arrStatus.Informaci\u00f3n.description.errorMessage = "";
            } else {
                $81574927169af67f$var$arrStatus.Informaci\u00f3n.description.status = "error";
                $81574927169af67f$var$arrStatus.Informaci\u00f3n.description.errorMessage = "\u2022 La descripci\xf3n de tu negocio debe tener por lo menos 10 palabras";
            }
            this._updateEditorSteps("Informaci\xf3n", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputBusinessDescription.addEventListener('keyup', ()=>{
            setBusinessDescription();
        });
        nvBusinessEditorInputBusinessDescription.addEventListener('blur', ()=>{
            setBusinessDescription();
        });
        // START website
        const setWebsite = ()=>{
            let valueL = "";
            let value = nvBusinessEditorInputWebsite.value.trim();
            if (value.length > 0) valueL = value;
            function isValidHttpUrl(value) {
                try {
                    const url = new URL(value);
                    return url.protocol === "http:" || url.protocol === "https:";
                } catch (_) {
                    return false;
                }
            }
            if (value.length > 0) {
                if (isValidHttpUrl(value)) {
                    $81574927169af67f$var$arrStatus.Informaci\u00f3n.website.status = "completed";
                    $81574927169af67f$var$arrStatus.Informaci\u00f3n.website.errorMessage = "";
                    $81574927169af67f$var$businessData.contacts.website.contact = valueL;
                } else {
                    $81574927169af67f$var$arrStatus.Informaci\u00f3n.website.status = "error";
                    $81574927169af67f$var$arrStatus.Informaci\u00f3n.website.errorMessage = "\u2022 La direcci\xf3n de tu p\xe1gina no es una direcci\xf3n v\xe1lida";
                    $81574927169af67f$var$businessData.contacts.website.contact = "";
                }
            } else {
                $81574927169af67f$var$arrStatus.Informaci\u00f3n.website.status = "completed";
                $81574927169af67f$var$arrStatus.Informaci\u00f3n.website.errorMessage = "";
                $81574927169af67f$var$businessData.contacts.website.contact = "";
            }
            this._updateEditorSteps("Informaci\xf3n", $81574927169af67f$var$arrStatus);
        };
        nvBusinessEditorInputWebsite.addEventListener('keyup', ()=>{
            setWebsite();
        });
        nvBusinessEditorInputWebsite.addEventListener('blur', ()=>{
            setWebsite();
        });
    }
    _events() {
        const nvBusinessEditorButtonStepBack = document.getElementById("nvBusinessEditorButtonStepBack");
        const nvBusinessEditorButtonStepAhead = document.getElementById("nvBusinessEditorButtonStepAhead");
        const nvBusinessEditorButtonClose = document.getElementById("nvBusinessEditorButtonClose");
        nvBusinessEditorButtonStepBack.addEventListener("click", ()=>{
            const returnStep = this._scrollToEditorStep('back');
        });
        nvBusinessEditorButtonStepAhead.addEventListener("click", ()=>{
            const returnStep = this._scrollToEditorStep('ahead');
        });
        nvBusinessEditorButtonClose.addEventListener("click", ()=>{
            const confirmExit = confirm("\xbfCerrar? Perder\xe1s todos los cambios que hiciste a tu p\xe1gina.");
            if (confirmExit) this._closeBusinessEditor();
        });
        this._watchEditorScroll("nvBusinessEditorCon10", $81574927169af67f$var$arrStatus);
        this._initEditorStepClicks();
    }
    _closeBusinessEditor() {
        const MainContainerBusinessPageBuild = document.getElementById("MainContainerBusinessPageBuild");
        MainContainerBusinessPageBuild.remove();
    }
    _bindImageInputToDisplay(inputId, displayImgId) {
        const input = document.getElementById(inputId);
        const display = document.getElementById(displayImgId);
        if (!input || !display) {
            console.error("bindImageInputToDisplay: invalid IDs provided.");
            return;
        }
        input.addEventListener("change", (event)=>{
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            if (!file.type.startsWith("image/")) {
                console.error("Selected file is not an image.");
                display.src = ""; // clear
                return;
            }
            const reader = new FileReader();
            reader.onload = (e)=>{
                display.src = e.target.result;
                console.log(displayImgId);
                if (displayImgId === 'nvBusinessEditorImgProfile') {
                    $81574927169af67f$var$arrStatus.Fotos.profile.status = "completed";
                    $81574927169af67f$var$businessData.moreData.imagesChaneged = true;
                }
                if (displayImgId === 'nvBusinessEditorImgBackground') {
                    $81574927169af67f$var$arrStatus.Fotos.background.status = "completed";
                    $81574927169af67f$var$businessData.moreData.imagesChaneged = true;
                }
                this._updateEditorSteps("Fotos", $81574927169af67f$var$arrStatus);
            };
            reader.readAsDataURL(file);
        });
    }
    _init(data, edit = false) {
        const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        console.log(userData);
        const hasOwnerBusiness = userData.businesses?.some((business)=>business?.role === 'owner') ?? false;
        // Need to be turned on in production
        if (!edit && hasOwnerBusiness) {
            (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init();
            return;
        }
        if (!userData.whatsAppNumber) {
            (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open(true);
            return;
        }
        if (!edit) $81574927169af67f$var$businessData = {
            ...$81574927169af67f$var$businessDataResetTo
        };
        ($81574927169af67f$var$businessData ??= {}).moreData ??= {};
        $81574927169af67f$var$businessData.moreData.imagesChaneged = false;
        $81574927169af67f$var$businessData.moreData.edit = false;
        console.log(edit);
        if (edit) {
            $81574927169af67f$var$businessData = data;
            ($81574927169af67f$var$businessData ??= {}).moreData ??= {};
            $81574927169af67f$var$businessData.moreData.edit = true;
            $81574927169af67f$var$businessData.moreData.businessId = $81574927169af67f$var$businessData.businessId;
            $81574927169af67f$var$arrStatus = this._resetEditorStatus($81574927169af67f$var$arrStatus, "completed");
        }
        const container = document.getElementById("MainAppContentContainer");
        const busineesPageEditorHtml = (0, $45d8d8fc6a6044af$export$2e2bcd8739ae039)._NVBusinessEditor($81574927169af67f$var$businessData, edit);
        container.insertAdjacentHTML("beforeend", busineesPageEditorHtml);
        this._events(edit);
        this._activateDataGather();
        this._bindImageInputToDisplay('nvBusinessEditorImgBackgroundInput', 'nvBusinessEditorImgBackground');
        this._bindImageInputToDisplay('nvBusinessEditorImgProfileInput', 'nvBusinessEditorImgProfile');
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        (0, $a082c89adac62edb$export$2e2bcd8739ae039)._guardNumericInput("nvBusinessEditorInputWhatsAppNumber");
        (0, $a082c89adac62edb$export$2e2bcd8739ae039)._guardNumericInput("nvBusinessEditorInputCallNumber");
    }
    _getImages(from) {
        if (from === 'back') return $81574927169af67f$var$businessData.images.background[0];
        if (from === 'prof') return $81574927169af67f$var$businessData.images.profile[0];
    }
    async _NVBusinessCreateUpdate() {
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Guardando informaci\xf3n de negocio", 30000);
            if ($81574927169af67f$var$businessData.moreData.imagesChaneged) {
                const backgroundImg = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImagesAndGetReferences("nvBusinessEditorImgBackground", 'imageProgressCon', true, 'public/tempUploads/', 'businessBackground');
                const profileImg = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImagesAndGetReferences("nvBusinessEditorImgProfile", 'imageProgressCon', true, 'public/tempUploads/', 'businessProfile');
                $81574927169af67f$var$businessData.images.background = backgroundImg;
                $81574927169af67f$var$businessData.images.profile = profileImg;
                $81574927169af67f$var$businessData.moreData.adminImgPath = 'public/businesses';
                console.log('backgroundImg', backgroundImg);
                console.log('profileImg', profileImg);
            }
            if (!$81574927169af67f$var$businessData.moreData.edit) $81574927169af67f$var$businessData.moreData.businessStatus = (0, $5e2d2197cd245583$export$2e2bcd8739ae039)._getAppUploadStatus();
            console.log($81574927169af67f$var$businessData);
            // return
            const createResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVcreateUpdateBusiness($81574927169af67f$var$businessData);
            console.log(createResult);
            if (createResult.data.status === "error") throw new Error(createResult.data.message);
            if (createResult.data.status === "success") {
                alert(`Exito: ${createResult.data.message}`);
                this._closeBusinessEditor();
                (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._NVDipslayBusinesses();
                // Logic to open business after create/edit goes here
                // Ensure correct data is passed
                (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._displayTheRightWay(createResult.data.id, '', 'business', '', null, '', true, null, true);
            }
        } catch (error) {
            console.error(error.message);
            alert(`Error: ${error.message}`);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
}
var $81574927169af67f$export$2e2bcd8739ae039 = new $81574927169af67f$var$NVBusinessEditor();


class $fa6b7443c0c8b64b$var$DisplayBusinessEach {
    #account;
    #interaction = false;
    #lastVisibleDocForBusinessListings = null;
    #wasFinalDocForLoad = false;
    #currenBusinessData = null;
    #currentCategory = null;
    #bottomScrollDetectOnBusinessDisplayConActivated = false;
    #isLoadingLisitngForBusiness = false;
    #currentBusinessId = null;
    #contactInfoDispFunction = null;
    #optionsDispFunction = null;
    #listsOptionsDispFunction = null;
    #listsEditDispFunction = null;
    #currentListForAction = '';
    #catagoryImageChanged = false;
    #editListsEventsInitialized = false;
    #oneTimeEventsInitialized = false;
    _getCurrentBusiness() {
        return this.#currenBusinessData;
    }
    _detectScrollDirection(id, callback) {
        const container = document.getElementById(id);
        console.log(container);
        let lastScrollTop = container.scrollTop;
        container.addEventListener("scroll", ()=>{
            const currentScrollTop = container.scrollTop;
            const diff = currentScrollTop - lastScrollTop;
            if (currentScrollTop < 0) return;
            if (Math.abs(diff) > 50) {
                const direction = diff > 0 ? "down" : "up";
                // this._scrollDirectionDecide(direction);
                lastScrollTop = currentScrollTop; // reset after trigger
            }
        });
    }
    _returnMiniSpinner() {
        return `<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="20"
      height="20"
      class="miniSpinneForButtons">
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke="#2B2B2B"
        stroke-width="4"
        fill="none"
        stroke-dasharray="125.6"
        stroke-dashoffset="94.2"
        stroke-linecap="round">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.8s"
          repeatCount="indefinite" />
      </circle>
    </svg>`;
    }
    _activateDetectScrollToBottom = (margin = 50)=>{
        console.log("dectect bottom scroll called");
        if (this.#bottomScrollDetectOnBusinessDisplayConActivated) return;
        console.log("dectect bottom scroll activated");
        const businessListingsCon = document.getElementById(`nvBusinessEachCon1A`);
        if (!businessListingsCon) {
            console.log("Error: Container not found.");
            return;
        }
        // Add a scroll event listener
        businessListingsCon.addEventListener("scroll", async ()=>{
            const isScrolledToBottom = businessListingsCon.scrollHeight - businessListingsCon.scrollTop - businessListingsCon.clientHeight <= margin;
            if (isScrolledToBottom) {
                if (this.#wasFinalDocForLoad) return;
                this._loadMoreBusinessListings();
            }
        });
        this.#bottomScrollDetectOnBusinessDisplayConActivated = true;
    };
    async _loadMoreBusinessListings(reset = false) {
        if (!this.#currenBusinessData) return;
        const bussinessDisplayInsertListingsCon = document.getElementById("bussinessDisplayInsertListingsCon");
        const loadDocsNum = 12;
        if (this.#isLoadingLisitngForBusiness) return;
        this.#isLoadingLisitngForBusiness = true;
        if (reset) this.#lastVisibleDocForBusinessListings = null;
        console.warn(this.#currenBusinessData);
        const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(this.#lastVisibleDocForBusinessListings, loadDocsNum, `businesses/${this.#currenBusinessData.businessId}/listings`, "listingMachineType", this.#currentCategory);
        this.#lastVisibleDocForBusinessListings = lastVisibleDoc;
        if (listings.length < loadDocsNum) {
            this.#wasFinalDocForLoad = true;
            console.warn("set to true");
        }
        if (listings.length > 0) {
            if (reset) {
                bussinessDisplayInsertListingsCon.innerHTML = "";
                console.log('FINDING SOME OTHER SOLUTION FOR THEI HERE');
                setTimeout(()=>{
                    if (!this.#interaction) return;
                    this._scrollToTopOfElement("nvBusinessEachCon1A", 'bussinessDisplayHeaderCon1A');
                }, 500);
            }
            for (const listing of listings){
                const html = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing, null, 'business');
                bussinessDisplayInsertListingsCon.insertAdjacentHTML("beforeend", html);
            }
        }
        this.#isLoadingLisitngForBusiness = false;
        this._activateDetectScrollToBottom();
    }
    _scrollToTopOfElement(scrollContainerId, scrollToId) {
        const container = document.getElementById(scrollContainerId);
        if (!container) {
            console.warn(`Element with ID "${scrollContainerId}" not found.`);
            return;
        }
        if (scrollToId) {
            const target = document.getElementById(scrollToId);
            if (target) {
                // Compute target position relative to the scroll container
                const containerRect = container.getBoundingClientRect();
                const targetRect = target.getBoundingClientRect();
                const scrollTop = container.scrollTop + (targetRect.top - containerRect.top);
                container.scrollTo({
                    top: scrollTop,
                    behavior: "smooth"
                });
            } else console.warn(`Element with ID "${scrollToId}" not found.`);
        } else // Scroll to top of the container
        container.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    _onContainerScroll(id) {
        const container = document.getElementById(id);
        if (!container) return;
        container.addEventListener('scroll', ()=>{
            this.#interaction = true;
        });
    }
    _initializeContactButtonsShow(show = true) {
        const overlay = document.getElementById("nvBusinessContactEachCon12A");
        const panel = document.getElementById("nvBusinessContactEachCon12");
        if (!overlay || !panel) return;
        let startY = 0;
        let currentY = 0;
        let dragging = false;
        const resetPanel = ()=>{
            panel.style.transition = "";
            panel.style.transform = "";
        };
        const open = ()=>{
            resetPanel();
            overlay.classList.add("nvBusinessContactEachCon12AView");
            panel.classList.add("nvBusinessContactEachCon12View");
        };
        const close = ()=>{
            panel.style.transition = "transform 0.4s ease";
            panel.style.transform = "translateY(100%)";
            setTimeout(()=>{
                panel.classList.remove("nvBusinessContactEachCon12View");
                overlay.classList.remove("nvBusinessContactEachCon12AView");
                resetPanel();
            }, 400);
        };
        // Initial state
        show ? open() : close();
        // Tap background to close
        overlay.addEventListener("click", (e)=>{
            if (e.target === overlay) close();
        });
        /* ---------- DRAG (panel + overlay) ---------- */ const onTouchStart = (e)=>{
            e.stopPropagation(); // 👈 IMPORTANT
            startY = e.touches[0].clientY;
            currentY = startY;
            dragging = true;
            panel.style.transition = "none";
        };
        const onTouchMove = (e)=>{
            if (!dragging) return;
            e.stopPropagation(); // 👈 IMPORTANT
            currentY = e.touches[0].clientY;
            const diff = currentY - startY;
            if (diff > 0) panel.style.transform = `translateY(${diff}px)`;
        };
        const onTouchEnd = (e)=>{
            e.stopPropagation(); // 👈 IMPORTANT
            dragging = false;
            const diff = currentY - startY;
            if (diff > 120) close();
            else {
                panel.style.transition = "transform 0.3s ease";
                panel.style.transform = "translateY(0)";
            }
            startY = 0;
            currentY = 0;
        };
        panel.addEventListener("touchstart", onTouchStart);
        panel.addEventListener("touchmove", onTouchMove);
        panel.addEventListener("touchend", onTouchEnd);
        overlay.addEventListener("touchstart", onTouchStart);
        overlay.addEventListener("touchmove", onTouchMove);
        overlay.addEventListener("touchend", onTouchEnd);
        return {
            open: open,
            close: close
        };
    }
    _initializeOptionsButtonsShow(show = false) {
        const overlay = document.getElementById("nvBusinessOptionsEachCon12A");
        const menu = overlay.querySelector(".nvBusinessOptionsEachCon12");
        if (!overlay || !menu) return;
        const open = ()=>{
            overlay.classList.add("nvBusinessOptionsEachCon12AView");
        };
        const close = ()=>{
            overlay.classList.remove("nvBusinessOptionsEachCon12AView");
        };
        // Initial state
        show ? open() : close();
        // Click outside closes
        overlay.addEventListener("click", (e)=>{
            if (!menu.contains(e.target)) close();
        });
        return {
            open: open,
            close: close
        };
    }
    _initializeListsOptionsButtonsShow(show = false) {
        const overlay = document.getElementById("nvBusinessEachListsOptionsCon12A");
        const menu = overlay.querySelector(".nvBusinessOptionsEachCon12");
        if (!overlay || !menu) return;
        const open = ()=>{
            overlay.classList.add("nvBusinessOptionsEachCon12AView");
        };
        const close = ()=>{
            overlay.classList.remove("nvBusinessOptionsEachCon12AView");
        };
        // Initial state
        show ? open() : close();
        // Click outside closes
        overlay.addEventListener("click", (e)=>{
            if (!menu.contains(e.target)) close();
        });
        return {
            open: open,
            close: close
        };
    }
    _initializeListEditShow(show = false) {
        const overlay = document.getElementById("BusinessEachEditList");
        const backButton = document.getElementById("BusinessEachEditListBackButton");
        const saveButton = document.getElementById("BusinessEachEditListSaveButton");
        const BusinessEachEditListInputName = document.getElementById("BusinessEachEditListInputName");
        const BusinessEachEditListDisplayTag = document.getElementById("BusinessEachEditListDisplayTag");
        const input = document.getElementById('businessCatListImageInput');
        const preview = document.getElementById('businessCatListImageDisp');
        const el = document.getElementById('btnActionBusinessContactShowOptions');
        let targetE = '';
        if (!overlay || !backButton) return;
        const open = (e)=>{
            targetE = e;
            if (this.#currentListForAction === 'all') {
                alert("No puedes editar la lista de todos los listados.");
                return;
            }
            this.#catagoryImageChanged = false;
            overlay.style.display = "flex";
            let tagName = this.#currenBusinessData.categories?.find((cat)=>cat.machine === this.#currentListForAction)?.name ?? this.#currentListForAction;
            let tagImage = this.#currenBusinessData.categories?.find((cat)=>cat.machine === this.#currentListForAction)?.image?.res_500 ?? (0, (/*@__PURE__*/$parcel$interopDefault($d87a3439daeaf8be$exports)));
            BusinessEachEditListInputName.value = tagName;
            BusinessEachEditListDisplayTag.textContent = this.#currentListForAction;
            preview.src = tagImage;
        };
        const close = ()=>{
            overlay.style.display = "none";
        };
        const save = async ()=>{
            try {
                const name = BusinessEachEditListInputName.value.trim();
                console.log('saving list changes');
                if (name.length > 50) {
                    alert("El nombre de la lista no puede tener m\xe1s de 50 caracteres.");
                    return;
                }
                let category = this.#currenBusinessData.categories?.find((cat)=>cat.machine === this.#currentListForAction) ?? null;
                if (!category) return;
                let img = category.image;
                console.log(category);
                console.log(this.#catagoryImageChanged);
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Subiendo im\xe1genes");
                img = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImagesAndGetReferences("businessCatListImageDispParentCon", 'imageProgressCon', false, 'public/tempUploads/');
                console.log(img);
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Actualizando lista");
                const dataSend = {
                    machine: this.#currentListForAction,
                    name: name,
                    isNewImage: this.#catagoryImageChanged,
                    image: img[0].res_original,
                    businessId: this.#currenBusinessData.businessId,
                    adminImgPath: `public/businesses/${this.#currenBusinessData.businessId}`
                };
                console.log(dataSend);
                if (!dataSend.image) {
                    alert("Debes seleccionar una imagen para la lista.");
                    return;
                }
                console.log(dataSend);
                const updateResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVEditBusinessCatLists(dataSend);
                if (updateResult.data.success) {
                    close();
                    console.log(el);
                    (0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._goBackOnStack(targetE, el);
                    (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._displayTheRightWay(this.#currenBusinessData.businessId, null, 'business', null, null, null, null, this.#currentListForAction);
                    // this._init(this.#currenBusinessData, false, this.#currentListForAction);
                    alert("Lista actualizado correctamente.");
                } else alert(`Hubo un error al actualizar esta lista. Error: ${resultUploadListing.data.message}`);
                console.log(name);
            } catch (error) {} finally{
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
        };
        // Initial state
        show ? open() : close();
        if (!this.#editListsEventsInitialized) {
            this.#editListsEventsInitialized = true;
            backButton.addEventListener("click", ()=>{
                close();
            });
            saveButton.addEventListener("click", ()=>{
                save();
            });
            input.addEventListener('change', ()=>{
                this.#catagoryImageChanged = true;
                const file = input.files[0];
                if (!file) return;
                // ensure it's an image
                if (!file.type.startsWith('image/')) return;
                const reader = new FileReader();
                reader.onload = (e)=>{
                    preview.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        }
        return {
            open: open,
            close: close
        };
    }
    async _init(businessData, share, list = 'all') {
        if (!businessData) return;
        console.log("Display Business Each Init called");
        this.#currenBusinessData = null;
        this.#currentCategory = null;
        this.#interaction = false;
        if (list !== 'all') this.#currentCategory = list;
        if (this.#currentBusinessId === businessData?.businessId) return;
        this.#currentBusinessId = businessData?.businessId;
        setTimeout(()=>{
            this.#currentBusinessId = null;
        }, 2000);
        this.#account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        this.#bottomScrollDetectOnBusinessDisplayConActivated = false;
        this.#wasFinalDocForLoad = false;
        console.log(businessData);
        this.#currenBusinessData = businessData;
        console.log(this.#currenBusinessData);
        const thisBusinessUniqueId = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUniqueIdfunction();
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando negocio");
        console.log("called");
        const allHtmlForBusiness = (0, $b21bc75fcca6f702$export$2e2bcd8739ae039)._generateBusiness(businessData, thisBusinessUniqueId, list);
        (0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._display(allHtmlForBusiness);
        this._loadMoreBusinessListings(true);
        (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateViewsOnBusiness({
            businessId: businessData.businessId
        });
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        this._businessEvents();
        this._onContainerScroll('nvBusinessEachCon1A');
        this.#contactInfoDispFunction = this._initializeContactButtonsShow(false);
        this.#optionsDispFunction = this._initializeOptionsButtonsShow(false);
        this.#listsOptionsDispFunction = this._initializeListsOptionsButtonsShow(false);
        this.#listsEditDispFunction = this._initializeListEditShow(false);
        // setTimeout(() => {
        //   contactInfo.open();
        // }, 5000)
        this._activateTheRightCategoryButtonInBusiness(list);
        const historySaveUrl = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessData.businessId, null, null, null);
        const historyData = {
            href: historySaveUrl,
            title: businessData.name || 'Negocio sin nombre',
            image: businessData?.images?.profile[0]?.res_200 || '',
            type: 'business'
        };
        (0, $a082c89adac62edb$export$2e2bcd8739ae039)._pushUserHistory(historyData);
        this._fadeTargetNearTop('nvBusinessEachCon20AB', 'BnvBusinessEachCon3');
    }
    // _fadeTargetNearTop(elementId, targetElId) {
    //   const element = document.getElementById(elementId);
    //   const targetEl = document.getElementById(targetElId);
    //   console.log(element, targetElId);
    //   const fadeDistance = 99;
    //   const minOpacity = 0.01;
    //   const updateOpacity = () => {
    //     const { top } = element.getBoundingClientRect();
    //     // 0 at/above the top, 1 when 99px or farther away
    //     const progress = Math.max(0, Math.min(top / fadeDistance, 1));
    //     console.log('progress', progress);
    //     // Never reaches zero
    //     const opacity = minOpacity + (1 - minOpacity) * progress;
    //     targetEl.style.opacity = opacity;
    //     targetEl.style.pointerEvents = progress <= 0 ? "none" : "auto";
    //   };
    //   updateOpacity();
    //   window.addEventListener("scroll", updateOpacity, { passive: true });
    //   window.addEventListener("resize", updateOpacity, { passive: true });
    //   // Return this so you can remove listeners if the UI is destroyed.
    //   return () => {
    //     window.removeEventListener("scroll", updateOpacity);
    //     window.removeEventListener("resize", updateOpacity);
    //   };
    // }
    _fadeTargetNearTop(elementId, targetElId) {
        const element = document.getElementById(elementId);
        const targetEl = document.getElementById(targetElId);
        if (!element || !targetEl) {
            console.warn("Element not found:", {
                elementId: elementId,
                targetElId: targetElId
            });
            return;
        }
        targetEl.style.transition = "opacity 80ms linear, transform 180ms ease";
        const fadeDistance = 99;
        const triggerOffset = 2;
        const minOpacity = 0.35;
        const updateOpacity = ()=>{
            const elementTop = element.getBoundingClientRect().top;
            // Fully faded at 2px from the top.
            const progress = Math.min(1, Math.max(0, (elementTop - triggerOffset) / fadeDistance));
            targetEl.style.opacity = minOpacity + (1 - minOpacity) * progress;
            targetEl.style.pointerEvents = progress <= 0 ? "none" : "auto";
            // Move left when it reaches the 2px trigger point.
            targetEl.style.transform = progress <= 0 ? "translateX(-40px)" : "translateX(0)";
        };
        updateOpacity();
        // Captures scroll events from window AND any scrollable parent.
        document.addEventListener("scroll", updateOpacity, {
            passive: true,
            capture: true
        });
        window.addEventListener("resize", updateOpacity, {
            passive: true
        });
        return ()=>{
            document.removeEventListener("scroll", updateOpacity, true);
            window.removeEventListener("resize", updateOpacity);
        };
    }
    async _fillInBusinessListings(businessData, listingDirectionIds) {
        const listings = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllDocsFromPathByMostRecent(`businesses/${businessData.businessId}/listings`, true);
        const fillInListings = async (listings, id)=>{
            const containerForListingsInput = document.getElementById(id);
            for (const listing of listings){
                const html = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVertical(listing, businessData.colors, "listingInBusiness", businessData.businessId, true, "business");
                containerForListingsInput.insertAdjacentHTML("beforeend", html);
            }
        };
        listingDirectionIds.forEach(async (list)=>{
            let currentLisitngs = [];
            // Check if list is a All list
            if (list.listType === "todos") {
                listings.forEach((listing)=>{
                    console.log("got taken for All listings");
                    currentLisitngs.push(listing);
                });
                fillInListings(currentLisitngs, list.listId);
            }
            // Check if list is a manual list
            if (list.listType === "manual") {
                if (list.listingsIds) {
                    listings.forEach((listing)=>{
                        if (list.listingsIds.includes(listing.id)) {
                            console.log("got taken for manual");
                            currentLisitngs.push(listing);
                        } else console.log("not taken for manual");
                    });
                    console.log(currentLisitngs);
                    fillInListings(currentLisitngs, list.listId);
                }
            }
            // Check if list is a auto list
            if (list.listType === "auto") {
                // Check if list is a discount list
                if (list.listTag === "en oferta") {
                    listings.forEach((listing)=>{
                        if (listing?.onDiscount?.amount > 0) currentLisitngs.push(listing);
                    });
                    fillInListings(currentLisitngs, list.listId);
                } else {
                    console.log("got here");
                    listings.forEach((listing)=>{
                        if (listing.listingMachineType === list.listTag) currentLisitngs.push(listing);
                    });
                    console.log(currentLisitngs);
                    fillInListings(currentLisitngs, list.listId);
                }
            }
        });
    }
    async _displayLists(listName, business) {
        let htmlToReturn;
        const htmlContainerId = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUniqueIdfunction();
        try {
            htmlToReturn = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._businessPackOfPacks((0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingPack(listName, business.colors, htmlContainerId));
            return [
                htmlToReturn,
                htmlContainerId
            ];
        } catch (err) {
            if (err.name === "AbortError") console.log("Display For You aborted.");
            else console.error(err);
        }
    }
    // Start Making an image
    async _captureElementScreenshot(elementCl) {
        const elementForImgGeting = document.querySelector(`.BusinessViewEachHeaderCon1`);
        const element = document.querySelector(`.${elementCl}`);
        if (!element) throw new Error("Element not found");
        const imgUrl = elementForImgGeting.querySelector("img").src;
        console.log(imgUrl);
        function setBackgroundImage(element, imageUrl) {
            if (!element || !imageUrl) {
                console.error("Element or image URL is missing");
                return;
            }
            // Set the background image and styles
            element.style.backgroundImage = `url('${imageUrl}')`;
            element.style.backgroundSize = "cover";
            element.style.backgroundRepeat = "no-repeat";
            element.style.backgroundPosition = "center";
        //   Add some more
        }
        setBackgroundImage(element, imgUrl);
        // Ensure the element is styled properly for rendering
        const originalStyle = element.style.cssText;
        // Set inline styles to ensure full rendering
        element.style.paddingBottom = "6px";
        element.style.width = "300px";
        element.querySelector(".addForShareText").style.display = "flex";
        try {
            // Use html2canvas to capture the element
            const canvas = await html2canvas(element, {
                useCORS: true,
                backgroundColor: null,
                scale: 5
            });
            // Convert the canvas to a Blob
            const blob = await new Promise((resolve)=>canvas.toBlob(resolve, "image/png"));
            if (!blob) throw new Error("Failed to create Blob from canvas");
            // Optionally, create a URL and trigger a download
            const url = URL.createObjectURL(blob);
            //   const link = document.createElement("a");
            //   link.href = url;
            //   link.download = "screenshot.png";
            //   document.body.appendChild(link);
            //   link.click();
            //   document.body.removeChild(link);
            //   URL.revokeObjectURL(url);
            //   Return the Blob for further use
            return url;
        //   return blob;
        } catch (error) {
            console.error("Error capturing element screenshot:", error);
            throw error;
        } finally{
            // Restore the original styles
            element.style.cssText = originalStyle;
            element.style.backgroundImage = ``;
            element.querySelector(".addForShareText").style.display = "none";
        }
    }
    // End Making an image
    _filterListingsByTokens(listings, tokens) {
        // Ensure tokens are unique for efficient lookup
        const tokenSet = new Set(tokens);
        // Filter listings based on whether any token matches
        return listings.filter((listing)=>{
            if (!Array.isArray(listing.listingTokens)) return false; // Skip listings without valid tokens
            return listing.listingTokens.some((token)=>tokenSet.has(token));
        });
    }
    _shareActionForBusiness = async (target)=>{
        const getUrlToCurrentBusiness = async ()=>{
            const parentForData = target.closest(".ActionForShare");
            const businessName = parentForData.dataset.businessname;
            const businessId = parentForData.dataset.businessid;
            console.log(businessId);
            const url = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessId, businessName);
            return url;
        };
        const ButtonActionShare = target.closest("#BusinessViewEachUserActionsCon6Share");
        const parentEL = ButtonActionShare.closest(".ActionForShare");
        const businessId = parentEL.dataset.businessid;
        const businessName = parentEL.dataset.businessname;
        const businessShortDescription = parentEL.dataset.businessshordescription;
        const imgBlob = await this._captureElementScreenshot("BusinessViewEachHeaderCon8");
        const businessUrl = await getUrlToCurrentBusiness();
        const textForBusinessName = "```" + businessName + "```";
        const textForDescription = "``" + businessShortDescription + "``";
        const descriptionForBusinessShare = `*${businessName}*\n${textForDescription}\n\n*Visita este negocio en:* _${businessUrl}_

 *Visita nuestro mercado de maquinaria agricola e industrial en:* _https://maquinariasonline.com_

\u{1F517} *COMPARTE*`;
        const sharingResult = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._shareImagesWithText(businessName, descriptionForBusinessShare, [
            imgBlob
        ]);
        if (sharingResult.success) (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateSharesOnBusiness({
            businessId: businessId
        });
    };
    // new start here
    async _contactWhatsApp(id) {
        const businessName = this.#currenBusinessData.name;
        const businessId = this.#currenBusinessData.businessId;
        const url = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessId, businessName);
        console.log(this.#currenBusinessData);
        const openWhatsApp = (phoneNumber, message)=>{
            try {
                // Encode the phone number and message for URL safety
                const encodedMessage = encodeURIComponent(message);
                const whatsappUrl = `https://wa.me/+52${phoneNumber}?text=${encodedMessage}`;
                (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink(whatsappUrl);
                return;
            } catch (error) {
                console.error("Error creating or opening WhatsApp link:", error);
            }
        };
        const message = `${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._getSpanishGreetingForDay()}, *${businessName}*.\nLes estoy contactando desde ${url}\n\n*Mesaje:*`;
        openWhatsApp(this.#currenBusinessData.contacts.whatsApp.contact, message);
    }
    _call(id) {}
    async _share(id) {
        const businessName = this.#currenBusinessData.name;
        const businessId = this.#currenBusinessData.businessId;
        const businessShortDescription = this.#currenBusinessData.businessShortDescription;
        console.log(businessId, id);
        if (businessId !== id) {
            alert("Hay un error en identificar este negocio. Por favor cierra este negocio y \xe1brelo de nuevo.");
            return;
        }
        const getUrlToCurrentBusiness = async ()=>{
            console.log(businessId);
            const url = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessId, businessName);
            return url;
        };
        const currentBusiness = await getUrlToCurrentBusiness();
        (0, $dc7988840845b777$export$2e2bcd8739ae039)._open({
            business: this.#currenBusinessData,
            businessUrl: currentBusiness
        }, "business");
    }
    async _shareList(id) {
        if (this.#currentListForAction === 'all') {
            this._share(id);
            return;
        }
        const businessName = this.#currenBusinessData.name;
        const businessId = this.#currenBusinessData.businessId;
        console.log(businessId, id);
        if (businessId !== id) {
            alert("Hay un error en identificar este negocio. Por favor cierra este negocio y \xe1brelo de nuevo.");
            return;
        }
        const getUrlToCurrentBusiness = async ()=>{
            console.log(businessId);
            const url = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessId, businessName);
            return url;
        };
        const currentBusiness = await getUrlToCurrentBusiness() + `&lista=${this.#currentListForAction}`;
        console.log(currentBusiness);
        (0, $dc7988840845b777$export$2e2bcd8739ae039)._open({
            business: this.#currenBusinessData,
            businessUrl: currentBusiness
        }, "business list", this.#currentListForAction);
    }
    async _editList(id, e) {
        this.#listsEditDispFunction.open(e);
        return;
    }
    async _save(id) {
        const btnActionBusinessSave = document.getElementById("btnActionBusinessSave");
        const businessId = this.#currenBusinessData.businessId;
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (account) {
            console.log("clicked");
            let path = `businesses/${businessId}`;
            const saveObj = {
                path: path,
                time: (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getTimeStampJS()
            };
            btnActionBusinessSave.insertAdjacentHTML("beforeend", this._returnMiniSpinner());
            console.log(businessId);
            const saveResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateSavesOnBusiness({
                businessId: businessId
            });
            if (saveResult.data.status === "success") {
                if (saveResult.data.action === "saved") {
                    (0, $747dcf33e8614cd4$export$2e2bcd8739ae039)._getAccountState();
                    btnActionBusinessSave.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($7020d75361e719ac$exports)));
                    btnActionBusinessSave.querySelector(".nvBusinessOptionsEachText14").textContent = "Quitar Guardado";
                    btnActionBusinessSave.querySelector(".miniSpinneForButtons").remove();
                }
                if (saveResult.data.action === "removed") {
                    (0, $747dcf33e8614cd4$export$2e2bcd8739ae039)._getAccountState();
                    btnActionBusinessSave.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($bea62215618c37fd$exports)));
                    btnActionBusinessSave.querySelector(".nvBusinessOptionsEachText14").textContent = "Guardar";
                    btnActionBusinessSave.querySelector(".miniSpinneForButtons").remove();
                }
            }
        } else (0, $5b997bd2b2817dfd$export$2e2bcd8739ae039)._displayOptions(null, "Para guardar un negocio tienes que tener una cuenta activa en este dispositivo.");
    }
    _info(what, id) {
        const nvBusinessInfoEachCon12A = document.getElementById("nvBusinessInfoEachCon12A");
        if (what === "show") nvBusinessInfoEachCon12A.style.display = "flex";
        if (what === "hide") nvBusinessInfoEachCon12A.style.display = "none";
    }
    _loadSpecificCategoryInBusiness(cat) {
        console.log(cat);
        this.#wasFinalDocForLoad = false;
        this.#lastVisibleDocForBusinessListings = null;
        this.#currentCategory = cat;
        if (cat === "all") this.#currentCategory = null;
        this._loadMoreBusinessListings(true);
    }
    async _EditBusinessCall(businessId, e) {
        const businessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${businessId}`);
        if (!businessData) {
            alert("No podimos cargar tu negocio en este momento. Intenta de nuevo un poco despues.");
            return;
        }
        if (e) {
            const mainParent = e.target.closest('.bussinessDisplayCon1');
            const closestBackButton = mainParent.querySelector('.CloseCurrentStackPageButton');
            closestBackButton.click();
        }
        (0, $81574927169af67f$export$2e2bcd8739ae039)._init(businessData, true);
        console.log('should open business edit');
    }
    // _activateTheRightCategoryButtonInBusiness(cat) {
    //   const categorySelectMainConInBusiness = document.getElementById(
    //     "categorySelectMainConInBusiness"
    //   );
    //   const allCategoryButtons = categorySelectMainConInBusiness.querySelectorAll(
    //     ".nvBusinessEachCon21"
    //   );
    //   allCategoryButtons.forEach((btn) => {
    //     btn.classList.remove("nvBusinessEachCon21Act");
    //     if (btn.dataset.machine === cat) {
    //       btn.classList.add("nvBusinessEachCon21Act");
    //     }
    //     if (cat === 'all' && btn.dataset.machine === 'all') {
    //       btn.classList.add("nvBusinessEachCon21Act");
    //     }
    //   });
    // }
    _activateTheRightCategoryButtonInBusiness(cat) {
        const categorySelectMainConInBusiness = document.getElementById("categorySelectMainConInBusiness");
        const allCategoryButtons = categorySelectMainConInBusiness.querySelectorAll(".nvBusinessEachCon21");
        let activeBtn = null;
        allCategoryButtons.forEach((btn)=>{
            const text1 = btn.querySelector('.nvBusinessEachText8');
            const text2 = btn.querySelector('.nvBusinessEachText9');
            btn.classList.remove("nvBusinessEachCon21Act");
            text1.classList.remove("nvBusinessEachText8ACT");
            text2.classList.remove("nvBusinessEachText9ACT");
            if (btn.dataset.machine === cat || cat === 'all' && btn.dataset.machine === 'all') {
                btn.classList.add("nvBusinessEachCon21Act");
                text1.classList.add("nvBusinessEachText8ACT");
                text2.classList.add("nvBusinessEachText9ACT");
                activeBtn = btn;
            }
        });
        // 👇 scroll active button into view
        if (activeBtn) activeBtn.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
        });
    }
    async _businessEvents() {
        console.log('Business events active');
        let businessOpenOptionsEvent = null;
        const btnActionBusinessEdit = document.getElementById("btnActionBusinessEdit");
        const btnActionBusinessDelete = document.getElementById("btnActionBusinessDelete");
        const btnActionBusinessOptionsShowOptions = document.getElementById("btnActionBusinessOptionsShowOptions");
        const btnActionBusinessContactShowOptions = document.getElementById("btnActionBusinessContactShowOptions");
        const btnActionBusinessContactWhatsApp = document.getElementById("btnActionBusinessContactWhatsApp");
        const btnActionBusinessContactCall = document.getElementById("btnActionBusinessContactCall");
        const btnActionBusinessShare = document.getElementById("btnActionBusinessShare");
        const btnActionBusinessListShare = document.getElementById("btnActionBusinessListShare");
        const btnActionBusinessListEdit = document.getElementById("btnActionBusinessListEdit");
        const btnActionBusinessSave = document.getElementById("btnActionBusinessSave");
        const btnActionBusinessInfo = document.getElementById("btnActionBusinessInfo");
        const businessInfoConForDisplayBtnExit = document.getElementById("businessInfoConForDisplayBtnExit");
        const DisplayBusinessEachInfoPortionWahtsApp = document.getElementById("DisplayBusinessEachInfoPortionWahtsApp");
        const categorySelectMainConInBusiness = document.getElementById("categorySelectMainConInBusiness");
        // const allCategoryButtons = categorySelectMainConInBusiness.querySelectorAll(
        //   ".nvBusinessEachCon21"
        // );
        btnActionBusinessEdit.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            console.log("btnActionBusinessEdit");
            this._EditBusinessCall(businessId, e);
        });
        btnActionBusinessDelete.addEventListener("click", async (e)=>{
            try {
                const businessId = e.target.closest(".ActionForShare").dataset.businessid;
                console.log("btnActionBusinessDelete");
                const confirmDelete = confirm("Est\xe1s seguro que quieres eliminar este negocio? Esto elimina tambi\xe9n todos los listados publicado en este negocio. Esta acci\xf3n no se puede deshacer.");
                if (!confirmDelete) return;
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Por favor espera mientras estamos eliminando tu empresa.');
                const { data: data } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVDeleteBusiness({
                    businessId: businessId
                });
                console.log(data);
                if (data.status === 'success') {
                    const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
                    (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getUserDataFromBase(userData.userId);
                    alert("Tu empresa ha side eliminado con \xe9xito.");
                    (0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._goBackOnStack(businessOpenOptionsEvent, btnActionBusinessDelete);
                }
            } catch (error) {
                alert(error);
            } finally{
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
        });
        btnActionBusinessContactWhatsApp.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            console.log("btnActionBusinessContactWhatsApp");
            this._contactWhatsApp(businessId);
        });
        btnActionBusinessContactShowOptions.addEventListener("click", (e)=>{
            this.#contactInfoDispFunction.open();
        });
        btnActionBusinessOptionsShowOptions.addEventListener("click", (e)=>{
            businessOpenOptionsEvent = e;
            this.#optionsDispFunction.open();
        });
        DisplayBusinessEachInfoPortionWahtsApp.addEventListener("click", (e)=>{
            console.log("btnActionBusinessContactWhatsAppFromInfo");
            this._contactWhatsApp();
        });
        btnActionBusinessContactCall.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            console.log("btnActionBusinessContactCall");
            this._call(businessId);
        });
        btnActionBusinessShare.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            console.log("btnActionBusinessShare");
            this._share(businessId);
            this.#optionsDispFunction.close();
        });
        btnActionBusinessListShare.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            console.log("btnActionBusinessShare");
            this._shareList(businessId);
            this.#listsOptionsDispFunction.close();
        });
        btnActionBusinessListEdit.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            this._editList(businessId, e);
            this.#listsOptionsDispFunction.close();
        });
        btnActionBusinessSave.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            console.log("btnActionBusinessSave");
            this._save(businessId);
        });
        btnActionBusinessInfo.addEventListener("click", (e)=>{
            const businessId = e.target.closest(".ActionForShare").dataset.businessid;
            console.log("btnActionBusinessInfo");
            this._info("show", businessId);
            this.#optionsDispFunction.close();
        });
        businessInfoConForDisplayBtnExit.addEventListener("click", (e)=>{
            console.log("businessInfoConForDisplayBtnExit");
            this._info("hide");
        });
        categorySelectMainConInBusiness.addEventListener("click", (e)=>{
            const isCatButton = e.target.closest('.nvBusinessEachCon21');
            if (!isCatButton) return;
            const machine = isCatButton.dataset.machine;
            this._loadSpecificCategoryInBusiness(machine);
            this._activateTheRightCategoryButtonInBusiness(machine);
        });
        if (this.#oneTimeEventsInitialized) return;
        this.#oneTimeEventsInitialized = true;
        let pressTimer;
        window.addEventListener('contextmenu', (e)=>{
            const isCatButton = e.target.closest('.nvBusinessEachCon21');
            if (!isCatButton) return;
            e.preventDefault(); // 🚫 stop native menu
        });
        window.addEventListener('pointerdown', (e)=>{
            const isCatButton = e.target.closest('.nvBusinessEachCon21');
            if (!isCatButton) return;
            e.preventDefault(); // 🔑 THIS is key
            const machine = isCatButton.dataset.machine;
            if (!machine) return;
            this.#currentListForAction = machine;
            pressTimer = setTimeout(()=>{
                this.#listsOptionsDispFunction.open();
            }, 500);
        });
        window.addEventListener('pointerup', ()=>{
            clearTimeout(pressTimer);
        });
        window.addEventListener('pointercancel', ()=>{
            clearTimeout(pressTimer);
        });
        window.addEventListener('pointermove', ()=>{
            clearTimeout(pressTimer); // cancel if user moves
        });
    }
}
var $fa6b7443c0c8b64b$export$2e2bcd8739ae039 = new $fa6b7443c0c8b64b$var$DisplayBusinessEach();





const $5df95a5c365eca14$var$openHistory = false;
class $5df95a5c365eca14$var$openUrls {
    #userData = {};
    _getGatheredUserData() {
        return this.#userData;
    }
    async _init() {
        console.error($5df95a5c365eca14$var$openHistory, 'Open last is set to false for dev. Needs to be further developed and then turned on.');
        // GENRALHELPERS._clearUserHistory()
        console.log("init");
        const userSavedHistory = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUserHistory();
        let useUrl = '';
        // console.warn(userSavedHistory.length);
        if ($5df95a5c365eca14$var$openHistory && userSavedHistory.length > 0) useUrl = userSavedHistory[0].href;
        this._parseLocateAndDisplay(useUrl);
    }
    // Start visitStats
    async _storeUserVisitWithData(creditTo) {
        // Helper functions to collect the data
        function getDeviceType() {
            const userAgent = navigator.userAgent.toLowerCase();
            if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) return "Phone";
            else if (/tablet|ipad/.test(userAgent)) return "Tablet";
            return "Desktop";
        }
        function getBrowser() {
            const userAgent = navigator.userAgent;
            if (/chrome|crios|crmo/i.test(userAgent)) return "Chrome";
            else if (/firefox|fxios/i.test(userAgent)) return "Firefox";
            else if (/safari/i.test(userAgent)) return "Safari";
            else if (/edge/i.test(userAgent)) return "Edge";
            else if (/opr|opera/i.test(userAgent)) return "Opera";
            else return "Unknown";
        }
        function getOperatingSystem() {
            const userAgent = navigator.userAgent;
            if (/windows/i.test(userAgent)) return "Windows";
            else if (/mac/i.test(userAgent)) return "MacOS";
            else if (/linux/i.test(userAgent)) return "Linux";
            else if (/android/i.test(userAgent)) return "Android";
            else if (/iphone|ipad|ipod/i.test(userAgent)) return "iOS";
            else return "Unknown";
        }
        function getScreenResolution() {
            return `${window.screen.width}x${window.screen.height}`;
        }
        function getLanguage() {
            return navigator.language || navigator.userLanguage || "null";
        }
        function getTimeZone() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone || "null";
        }
        function isTouchDevice() {
            return "ontouchstart" in window || navigator.maxTouchPoints > 0;
        }
        let creditToObj = {
            creditTo: null
        };
        if (creditTo) creditToObj.creditTo = creditTo;
        // Construct the user data object
        this.#userData = {
            device: getDeviceType() || "null",
            browser: getBrowser() || "null",
            os: getOperatingSystem() || "null",
            screenResolution: getScreenResolution() || "null",
            language: getLanguage(),
            timeZone: getTimeZone(),
            isTouchDevice: isTouchDevice() || "null",
            userAgent: navigator.userAgent || "null",
            ip: "not tracked",
            ...creditToObj
        };
        const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._writeVisitStats("siteVisits", this.#userData);
        console.log(result);
        return this.#userData;
    }
    // End visitStats
    _updateVisiteStats(creditTo) {
        this._storeUserVisitWithData(creditTo);
    }
    // https://mercadopromaq.netlify.app?creditTo=heramientashopelchen
    async _parseLocateAndDisplay(inUrl) {
        console.warn(inUrl);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Estamos cargando la informaci\xf3n solicitada");
        let businessId;
        let listName;
        let listingId;
        let sellerId;
        let payment;
        // Function to parse URL and get business and listing IDs
        const parseUrlAndDisplay = ()=>{
            let url = window.location.href;
            if (inUrl) url = inUrl;
            if (url.includes("negocio") || url.includes("listado") || url.includes("subirlistado")) url;
            // Check for payment
            if (url.includes("payment")) {
                const paymentToMatch = url.match(/payment=([^&?]+)/);
                if (paymentToMatch) {
                    console.log(`Opened from stripe: ${paymentToMatch[1]}`);
                    function waitForAccount() {
                        const startTime = Date.now();
                        const interval = setInterval(()=>{
                            const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
                            if (account) {
                                clearInterval(interval);
                                accountFound();
                            } else if (Date.now() - startTime >= 10000) {
                                clearInterval(interval);
                                accountNotFound();
                                console.warn("Timeout: No account found after 10 seconds.");
                            }
                        }, 500); // Check every 500ms
                    }
                    waitForAccount();
                    const accountFound = ()=>{
                        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                    };
                    const accountNotFound = ()=>{
                        alert("No podimos encontrar tu cuenta en este momento. Puede ser por mala conexi\xf3n a internet.");
                        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                    };
                    return;
                }
            }
            // Check for from email verified redirect
            if (url.includes("verified")) {
                (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._openEmailVerification(null, false);
                return;
            }
            // Check for creditTo
            if (url.includes("creditTo")) {
                const creditToMatch = url.match(/creditTo=([^&?]+)/);
                if (creditToMatch) {
                    console.log(`This visit is credited to: ${creditToMatch[1]}`);
                    this._updateVisiteStats(creditToMatch[1]);
                } else this._updateVisiteStats();
            } else this._updateVisiteStats();
            // Extract 'negocio' id
            if (url.includes("negocio")) {
                const negocioMatch = url.match(/negocio=([^&?]+)/);
                if (negocioMatch) businessId = negocioMatch[1]; // Set the businessId
            }
            // Extract 'negocio' id, and list
            if (url.includes("lista")) {
                const listMatch = url.match(/lista=([^&?]+)/);
                if (listMatch) listName = listMatch[1]; // Set the list 
            }
            // Extract 'listado' id
            if (url.includes("listado")) {
                const listadoMatch = url.match(/listado=([^&?]+)/);
                if (listadoMatch) listingId = listadoMatch[1]; // Set the listingId
            }
            // Extract 'Seller' id
            if (url.includes("vendedor")) {
                const listadoMatch = url.match(/vendedor=([^&?]+)/);
                if (listadoMatch) sellerId = listadoMatch[1]; // Set the listingId
            }
            // Extract 'subirListado' id
            if (url.includes("subirlistado")) (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
            // Handle case where neither 'negocio' nor 'listado' are present
            !businessId && listingId;
        };
        // Run the function to parse the current URL
        parseUrlAndDisplay();
        // Log the IDs after parsing the URL
        let businessData;
        // Ensure businessId and listingId are set before trying to fetch data
        if (businessId) {
            businessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getBusinessById(businessId);
            (0, $fa6b7443c0c8b64b$export$2e2bcd8739ae039)._init(businessData, null, listName);
        }
        if (listingId && businessId) {
            console.log("business and listing present");
            const listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${businessId}/listings/${listingId}`);
            console.log(listingData);
            (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._init(listingData, businessData, true);
        }
        if (listingId && sellerId) {
            console.log("business and listing present");
            const listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${sellerId}/listings/${listingId}`);
            console.log(listingData);
            (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._init(listingData);
        }
        if (listingId && !businessId && !sellerId) {
            console.log("no business but listing present");
            const listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`listings/${listingId}`);
            console.log(listingData);
            (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._init(listingData);
        }
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
    }
    _getUserOpenedUrl() {
        const currentUrl = window.location.href; // Get the full URL
        return currentUrl;
    }
}
var $5df95a5c365eca14$export$2e2bcd8739ae039 = new $5df95a5c365eca14$var$openUrls();





var $gJCIb = parcelRequire("gJCIb");
/// <reference types="@capacitor/cli" />



const $fc70cc85372c45fc$export$86fbec116b87613f = (0, $gJCIb.registerPlugin)('App', {
    web: ()=>(parcelRequire("79Dk4")).then((m)=>new m.AppWeb())
});


class $f260e10f63c0e00d$var$CTANotifications {
    #CTANotificationEventsInitialized = false;
    #nativeInitialized = false;
    /* ================================
       🚀 ENTRY POINT
       ================================ */ // async init() {
    //     // 👉 Always try native first
    //     await this._initNativePush();
    //     // 👉 Then handle web logic
    //     await this._initializePushNotifications();
    // }
    async init() {
        const isNative = window.Capacitor?.isNativePlatform?.();
        if (isNative) document.addEventListener("deviceready", async ()=>{
            await this._initNativePush();
        }, {
            once: true
        });
        else await this._initializePushNotifications();
    }
    _initNotificationClickListener() {
        const openNotification = localStorage.getItem('openNotification');
        if (openNotification) {
            console.log("\uD83D\uDD14 Opening notifications from persisted flag");
            (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav('Notification');
        }
    // setTimeout(() => {
    //     // 🚫 Prevent double handling
    //     if (window.__NOTIFICATION_HANDLED__) {
    //         console.warn("🚫 Notification already handled");
    //         return;
    //     }
    //     // 📩 Native notification tap
    //     if (window.__PENDING_NOTIFICATION__) {
    //         console.log("🟡 Handling delayed native notification");
    //         window.__NOTIFICATION_HANDLED__ = true;
    //         const notif = window.__PENDING_NOTIFICATION__;
    //         const data = notif.notification?.data || {};
    //         // 🔔 Only open notification panel if explicitly from push
    //         if (data.fromNotification === "true") {
    //             saved._openNotifications();
    //             nav._changeNav('Notification');
    //         }
    //         // 🔗 Handle route
    //         if (data.url) {
    //             openUrls._parseLocateAndDisplay(data.url);
    //         }
    //         // 🧹 Cleanup
    //         window.__PENDING_NOTIFICATION__ = null;
    //     }
    // }, 500);
    // if (!("serviceWorker" in navigator)) return;
    // navigator.serviceWorker.addEventListener("message", (event) => {
    //     const data = event.data;
    //     if (!data) return;
    //     // 🔔 Open notification panel
    //     if (data.type === "OPEN_NOTIFICATION_PANEL") {
    //         console.log("🔔 Notification click detected");
    //         saved._openNotifications();
    //         nav._changeNav('Notification');
    //         // optional: also navigate via URL if needed
    //         if (data.url) {
    //             openUrls._parseLocateAndDisplay(data.url);
    //         }
    //     }
    // });
    // App.addListener('appUrlOpen', (event) => {
    //     console.log('🚀 App opened from notification:', event);
    //     saved._openNotifications();
    //     nav._changeNav('Notification');
    //     if (event.url) {
    //         openUrls._parseLocateAndDisplay(event.url);
    //     }
    // });
    }
    /* ================================
       🌐 CTA UI (WEB)
       ================================ */ _CTANotificationsOn(hide) {
        const CTAActivateNotifications = document.getElementById('CTAActivateNotifications');
        const CTAActivateNotificationsButtonActivate = document.getElementById('CTAActivateNotificationsButtonActivate');
        const CTAActivateNotificationsButtonClose = document.getElementById('CTAActivateNotificationsButtonClose');
        if (!hide) CTAActivateNotifications.style.display = 'flex';
        else CTAActivateNotifications.style.display = 'none';
        if (this.#CTANotificationEventsInitialized) return;
        this.#CTANotificationEventsInitialized = true;
        CTAActivateNotificationsButtonActivate.addEventListener('click', ()=>{
            this._pushNotificationsActivate();
            CTAActivateNotifications.style.display = 'none';
        });
        CTAActivateNotificationsButtonClose.addEventListener('click', ()=>{
            CTAActivateNotifications.style.display = 'none';
        });
    }
    /* ================================
       🌐 WEB PUSH
       ================================ */ async _pushNotificationsActivate() {
        async function getSWRegistration() {
            if (!("serviceWorker" in navigator)) throw new Error("Service workers not supported");
            if (navigator.serviceWorker.controller) return navigator.serviceWorker.ready;
            await new Promise((resolve)=>{
                navigator.serviceWorker.addEventListener("controllerchange", ()=>resolve(), {
                    once: true
                });
            });
            return navigator.serviceWorker.ready;
        }
        console.warn("\uD83C\uDF10 Web push flow");
        const swRegistration = await getSWRegistration();
        const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        // ⚠️ FIXED BUG HERE
        await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAndStoreFCMToken(userData.userId, swRegistration);
    }
    async _initializePushNotifications() {
        const status = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getPushNotificationStatus();
        if (status === 'permission needed') {
            this._CTANotificationsOn();
            return;
        }
        if (status) this._pushNotificationsActivate();
    }
    /* ================================
       📱 NATIVE PUSH (Android / iOS)
       ================================ */ async _initNativePush() {
        if (!window.Capacitor?.isNativePlatform?.()) return;
        // Prevent double init
        if (this.#nativeInitialized) return;
        this.#nativeInitialized = true;
        console.warn("\uD83D\uDCF1 Native push init");
        try {
            const permStatus = await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).requestPermissions();
            if (permStatus.receive !== 'granted') {
                console.warn('Push permission not granted');
                return;
            }
            await (0, $73af3aa28454c31d$export$8f83d3f28eb09744).register();
            // 🎟️ TOKEN
            (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener('registration', async (token)=>{
                console.log("\uD83D\uDCF1 Native FCM Token:", token.value);
                await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._storeNativeFCMToken(token.value);
                console.log("\uD83D\uDCE4 Native FCM token sent:", token.value);
            });
            // ❌ ERROR
            (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener('registrationError', (err)=>{
                console.error('Push registration error:', err);
            });
            // 📩 FOREGROUND
            (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener('pushNotificationReceived', (notification)=>{
                console.log("\uD83D\uDCE9 Foreground push:", notification);
            });
            // 👆 TAP
            (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener('pushNotificationActionPerformed', (notification)=>{
                console.log("\uD83D\uDC46 Notification tapped:", notification);
                (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
                (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav('Notification');
                const data = notification.notification?.data || {};
                if (data.url) (0, $5df95a5c365eca14$export$2e2bcd8739ae039)._parseLocateAndDisplay(data.url);
            });
        } catch (err) {
            console.error("Native push init error:", err);
        }
    }
}
var $f260e10f63c0e00d$export$2e2bcd8739ae039 = new $f260e10f63c0e00d$var$CTANotifications();





const $c31a2d575b60811d$var$colors = {
    headerPrimary: "FFFFFF",
    headerSecondary: "E0E0E0",
    packTitles: "6D6D6D",
    packTitlesHighlight: "3A7D44",
    itemBackgroundPrimary: "3A7D44",
    itemBackgroundSecondary: "fff",
    itemTextPrimary: "FFFFFF",
    itemTextSecondary: "2B2B2B",
    itemTextTerteriary: "3A7D44",
    itemTextFour: "3A7D44",
    itemHighlight: "FF7043",
    itemHighlightText: "FFFFFF"
};
const $c31a2d575b60811d$var$notificationsTest = [
    {
        title: "Tenemos una vueva actualizaci\xf3n",
        subTitle: "Nuevas Funciones est\xe1n disponibles",
        content: "Ahora puedes disfrutar De funciones como notificaci\xf3nes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.",
        read: true
    },
    {
        title: "NEW Tenemos una vueva actualizaci\xf3n",
        subTitle: "Nuevas Funciones est\xe1n disponibles",
        content: "Ahora puedes disfrutar De funciones como notificaci\xf3nes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.",
        read: true
    },
    {
        title: "Tenemos una vueva actualizaci\xf3n",
        subTitle: "Nuevas Funciones est\xe1n disponibles",
        content: "Ahora puedes disfrutar De funciones como notificaci\xf3nes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.",
        read: true
    },
    {
        title: "Tenemos una vueva actualizaci\xf3n",
        subTitle: "Nuevas Funciones est\xe1n disponibles",
        content: "Ahora puedes disfrutar De funciones como notificaci\xf3nes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.",
        read: false
    },
    {
        title: "Tenemos una vueva actualizaci\xf3n",
        subTitle: "Nuevas Funciones est\xe1n disponibles",
        content: "Ahora puedes disfrutar De funciones como notificaci\xf3nes, en tu negocio ahora puedes agregar una foto a tus lista, y compartiur una lista completa.",
        read: false
    }
];
class $c31a2d575b60811d$var$saved {
    #sortButtonsActived = false;
    #loadedData;
    #notificationEvents = false;
    #currentCategory = 'all';
    #notificationLastDoc = null;
    #isLoadingNotifications = false;
    #hasMoreNotifications = true;
    constructor(){
        this._windowEvents();
    }
    _windowEvents() {
        window.addEventListener("click", ()=>{
            const isNotificationClick = event.target.closest(".nvNotificationCon1");
            if (isNotificationClick) {
                const inAppLink = isNotificationClick.dataset.inapplink;
                const inAppLinkType = isNotificationClick.dataset.inapplinktype;
                this._handleInAppLinks(inAppLinkType, inAppLink);
            }
        });
    }
    async _handleInAppLinks(inAppLinkType, link) {
        const [p1, p2, p3, p4, p5] = link.split("/");
        if (link === 'postItemForSale') (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
        if (inAppLinkType === 'openOwnCreatedListing') {
            console.log('Should open listing of current user, listing:', link);
            console.log("Listing uploaded successfully. Should open listing now, and trigger CTA share.");
            let lives = 'seller';
            if (p1 !== 'accounts') lives = 'business';
            await (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._displayTheRightWay(p2, p4, lives, 'publish', false, "aspectRatio_9-6", true);
        }
    }
    // _initializeSwitch(id, callback) {
    //   const switchEl = document.getElementById(id);
    //   if (!switchEl) return;
    //   const knob = switchEl.querySelector(".nvNotiSetingsSwitchCon4");
    //   if (!knob) return;
    //   // Normalize initial state
    //   let state = switchEl.dataset.state === "on";
    //   // Sync UI with state
    //   const syncUI = () => {
    //     knob.classList.toggle("nvNotiSetingsSwitchCon4Act", state);
    //     switchEl.dataset.state = state ? "on" : "off";
    //   };
    //   syncUI();
    //   // Click handler
    //   switchEl.addEventListener("click", () => {
    //     state = !state;
    //     syncUI();
    //     if (typeof callback === "function") {
    //       callback(state);
    //     }
    //   });
    // }
    _initializeSwitch(id, callback, cooldownMs = 2000) {
        const switchEl = document.getElementById(id);
        if (!switchEl) return;
        const knob = switchEl.querySelector(".nvNotiSetingsSwitchCon4");
        if (!knob) return;
        let state = switchEl.dataset.state === "on";
        let locked = false;
        const syncUI = ()=>{
            knob.classList.toggle("nvNotiSetingsSwitchCon4Act", state);
            switchEl.dataset.state = state ? "on" : "off";
        };
        syncUI();
        switchEl.addEventListener("click", ()=>{
            if (locked) return; // 🚫 ignore spam clicks
            locked = true;
            state = !state;
            syncUI();
            if (typeof callback === "function") callback(state);
            // 🔓 unlock after cooldown
            setTimeout(()=>{
                locked = false;
            }, cooldownMs);
        });
    }
    _reverseSwitch(id) {
        const switchEl = document.getElementById(id);
        if (!switchEl) return;
        const knob = switchEl.querySelector(".nvNotiSetingsSwitchCon4");
        if (!knob) return;
        const isOn = switchEl.dataset.state === "on";
        const newState = !isOn;
        switchEl.dataset.state = newState ? "on" : "off";
        knob.classList.toggle("nvNotiSetingsSwitchCon4Act", newState);
    }
    async _loadSaved() {
        const SavedAndFollowingTextB10UpateMessage = document.getElementById("SavedAndFollowingTextB10UpateMessage");
        this.#sortButtonsActived = false;
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (!account) {
            SavedAndFollowingTextB10UpateMessage.textContent = "Dedes ingresar a tu cuenta para ver tus guardados.";
            return;
        }
        const allPaths = [];
        let activeBusinessFollows = [];
        let savedBusinesses = [];
        let savedListings = [];
        if (account.activeFollows) activeBusinessFollows = account.activeFollows;
        if (account.activeBusinessSaves) savedBusinesses = account.activeBusinessSaves;
        if (account.activeSaves) savedListings = account.activeSaves;
        // Add paths to the allPaths array
        if (activeBusinessFollows.length > 0) activeBusinessFollows.forEach((save)=>{
            if (typeof save === "object") allPaths.push(save.path);
            if (typeof save === "string") allPaths.push(save);
        });
        if (savedBusinesses.length > 0) savedBusinesses.forEach((save)=>{
            if (typeof save === "object") allPaths.push(save.path);
            if (typeof save === "string") allPaths.push(save);
        });
        if (savedListings.length > 0) savedListings.forEach((save)=>{
            if (typeof save === "object") allPaths.push(save.path);
            if (typeof save === "string") allPaths.push(save);
        });
        if (!activeBusinessFollows.length > 0 && !savedBusinesses.length > 0 && !savedListings.length > 0) {
            SavedAndFollowingTextB10UpateMessage.textContent = "No tienes guardados a\xfan.";
            return;
        }
        const loadedSaves = {
            businesses: [],
            individualListings: []
        };
        // To track which businesses are loaded
        const loadedBusinessIds = new Set();
        // Sequential loading function for each path
        async function loadData(path) {
            const save = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(path);
            // Extract business ID if it's a Type 1 path (businesses/{businessId}/listings/{listingId})
            let businessId = null;
            if (path.startsWith("businesses/")) {
                const parts = path.split("/");
                businessId = parts[1]; // Extract business ID from the path
            }
            // Type 1: Business and listing path (businesses/{businessId}/listings/{listingId})
            if (path.includes("businesses/") && path.includes("/listings/")) {
                // Check if the business is already loaded (businessId)
                if (!loadedBusinessIds.has(businessId)) {
                    // Load the business if not already loaded
                    const business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${businessId}`);
                    loadedSaves.businesses.push({
                        ...business,
                        id: businessId,
                        listings: []
                    });
                    // Mark this business as loaded
                    loadedBusinessIds.add(businessId);
                }
                // Add the listing to the corresponding business
                const business = loadedSaves.businesses.find((b)=>b.id === businessId);
                business.listings.push(save);
            } else if (path.startsWith("listings/")) loadedSaves.individualListings.push(save);
            else if (path.startsWith("businesses/")) // Check if the business is already loaded (businessId)
            {
                if (!loadedBusinessIds.has(businessId)) {
                    // Load the business if not already loaded
                    loadedSaves.businesses.push({
                        ...save,
                        id: businessId,
                        listings: []
                    });
                    // Mark this business as loaded
                    loadedBusinessIds.add(businessId);
                }
            }
        }
        // Sequentially process each path one at a time (wait for each to finish before starting the next)
        try {
            // Loop through each path and load the data one by one
            for(let i = 0; i < allPaths.length; i++)await loadData(allPaths[i]); // This ensures each path loads in sequence
            // After all data is loaded, display and finalize
            this.#loadedData = loadedSaves;
            console.warn(this.#loadedData);
            this._displayAllSaved("all");
            this.#sortButtonsActived = true;
        } catch (error) {
            console.error("Error loading data:", error);
        }
    }
    async _loadNotifications(cat) {
        if (this.#isLoadingNotifications) return;
        if (!this.#hasMoreNotifications && cat === this.#currentCategory) return;
        this.#isLoadingNotifications = true;
        const NvNotiConForNotifications = document.getElementById("NvNotiConForNotifications");
        // 🔁 Category changed → reset pagination
        if (cat !== this.#currentCategory) {
            this.#notificationLastDoc = null;
            this.#hasMoreNotifications = true;
            NvNotiConForNotifications.innerHTML = "";
        }
        this.#currentCategory = cat;
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (!account) {
            (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open();
            this.#isLoadingNotifications = false;
            return;
        }
        try {
            const { notifications: notifications, lastDoc: lastDoc, hasMore: hasMore } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getNotifications(`accounts/${account.userId}/notifications`, this.#currentCategory, this.#notificationLastDoc);
            this.#notificationLastDoc = lastDoc;
            this.#hasMoreNotifications = hasMore;
            notifications.forEach((noti)=>{
                console.log(noti);
                const subTitle = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(noti.createdAt);
                const notiHtml = (0, $3003dd10a1870dc8$export$2e2bcd8739ae039)._notification(noti.title, subTitle, noti.body, noti.read, noti.buttonLabel, noti.inAppLink, noti?.inAppLinkType || '');
                NvNotiConForNotifications.insertAdjacentHTML("beforeend", notiHtml);
            });
        } catch (err) {
            console.error("Failed loading notifications:", err);
        } finally{
            this.#isLoadingNotifications = false;
        }
    }
    async _displayAllSaved(display) {
        const dataIn = this.#loadedData;
        const containerForSpecialDiscountListings = document.getElementById("SavedAndFollowingCon9InsertSaved");
        // const SavedAndFollowingTextB10UpateMessage = document.getElementById(
        //   "SavedAndFollowingTextB10UpateMessage"
        // );
        containerForSpecialDiscountListings.innerHTML = "";
        if (display === "all" || display === "businesses") for (const business of dataIn.businesses){
            console.warn(business);
            let listingsHtml = ``;
            if (business.listings.length < 1 || business.listings[0] === null) listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings(null, "No tines listados guardados en este negocio.");
            else for (const listing of business.listings)listingsHtml += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMini(listing, business.colors, "listingInBusiness", business.businessId);
            const businessInPackHtml = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._generateBusiness2v(listingsHtml, business);
            let isInSearch = false;
            if (isInSearch) return businessInPackHtml;
            else // console.warn("html", businessInPackHtml);
            containerForSpecialDiscountListings.insertAdjacentHTML("beforeend", businessInPackHtml);
        }
        if (display === "all" || display === "listings") for (const listing of dataIn.individualListings){
            console.log(dataIn);
            const html = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingHorizontal(listing, $c31a2d575b60811d$var$colors, "listing");
            containerForSpecialDiscountListings.insertAdjacentHTML("beforeend", html);
        }
    }
    async _open() {
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        this._displayRightNavWindow();
        this._setContent();
        this._loadSaved();
    }
    async _openNotifications() {
        this.#currentCategory = 'all';
        this.#notificationLastDoc = null;
        this.#isLoadingNotifications = false;
        this.#hasMoreNotifications = true;
        this.#notificationEvents = false;
        // 🧹 Cleanup
        setTimeout(()=>{
            localStorage.removeItem('openNotification');
        }, 1000);
        this._displayRightNavWindow();
        await this._setContent('noti');
        this._loadNotifications('all');
        this._notificationEvents();
        this._initializeSwitch('nvNotiSetingsSwitchAll', async (state)=>{
            console.log('Notifications all switch state:', state);
            let result;
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Actualizando configuraci\xf3n...");
            if (state) result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateNotiSetBlockedCat({
                category: 'all',
                state: 'remove'
            });
            else result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateNotiSetBlockedCat({
                category: 'all',
                state: 'add'
            });
            if (!result.data.success) {
                alert(result.data.message);
                this._reverseSwitch('nvNotiSetingsSwitchAll');
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        // Here you can add code to handle the switch state change
        });
        this._initializeSwitch('nvNotiSetingsSwitchImportant', async (state)=>{
            console.log('Notifications Important switch state:', state);
            let result;
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Actualizando configuraci\xf3n...");
            if (state) result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateNotiSetBlockedCat({
                category: 'important',
                state: 'remove'
            });
            else result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateNotiSetBlockedCat({
                category: 'important',
                state: 'add'
            });
            if (!result.data.success) {
                alert(result.data.message);
                this._reverseSwitch('nvNotiSetingsSwitchImportant');
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        // Here you can add code to handle the switch state change
        });
        this._initializeSwitch('nvNotiSetingsSwitchPromotion', async (state)=>{
            console.log('Notifications Promotion switch state:', state);
            let result;
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Actualizando configuraci\xf3n...");
            if (state) result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateNotiSetBlockedCat({
                category: 'promotional',
                state: 'remove'
            });
            else result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateNotiSetBlockedCat({
                category: 'promotional',
                state: 'add'
            });
            if (!result.data.success) {
                alert(result.data.message);
                this._reverseSwitch('nvNotiSetingsSwitchPromotion');
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        // Here you can add code to handle the switch state change
        });
        setTimeout(()=>{
            // CTANotifications._initializePushNotifications()
            (0, $f260e10f63c0e00d$export$2e2bcd8739ae039).init();
        }, 500);
    }
    _displayRightNavWindow() {
        const windows = document.querySelectorAll(".MainAppConWithNavigationContentCon");
        windows.forEach((window1)=>{
            if (window1.id === "MainAppConWithNavigationContentConSaved") window1.style.display = "flex";
            else window1.style.display = "none";
        });
    }
    async _setContent(what) {
        const HomeScreenContenConForAll = document.getElementById("MainAppConWithNavigationContentConSaved");
        HomeScreenContenConForAll.style.paddingTop = "0px";
        HomeScreenContenConForAll.innerHTML = "";
        if (what === 'noti') HomeScreenContenConForAll.innerHTML = await (0, $3003dd10a1870dc8$export$2e2bcd8739ae039)._noti();
        else {
            HomeScreenContenConForAll.innerHTML = (0, $3003dd10a1870dc8$export$2e2bcd8739ae039)._main();
            this._events();
        }
    }
    _notificationEvents() {
        console.log('here');
        if (this.#notificationEvents) return;
        this.#notificationEvents = true;
        const nvNotiSelectorMainConButtonSettings = document.getElementById('nvNotiSelectorMainConButtonSettings');
        const nvNotiSetingsConainerButtonBack = document.getElementById('nvNotiSetingsConainerButtonBack');
        const nvNotiSetingsConainerMainCon = document.getElementById('nvNotiSetingsConainerMainCon');
        const nvNotiSetingsContainerCon15 = document.getElementById('nvNotiSetingsContainerCon15');
        nvNotiSetingsConainerButtonBack.addEventListener('click', ()=>{
            nvNotiSetingsConainerMainCon.style.display = 'none';
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._show();
        });
        nvNotiSelectorMainConButtonSettings.addEventListener('click', async ()=>{
            nvNotiSetingsConainerMainCon.style.display = 'flex';
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando dispositivos...');
            nvNotiSetingsContainerCon15.innerHTML = await (0, $3003dd10a1870dc8$export$2e2bcd8739ae039)._genDevicesHtml();
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._hide();
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        });
        nvNotiSetingsConainerMainCon.addEventListener('click', async (e)=>{
            const deleteDeviceBtn = e.target.closest('.nvNotiSetingsDeviceCon7');
            const editDeviceBtn = e.target.closest('.nvNotiSetingsDeviceCon8');
            if (deleteDeviceBtn) {
                const deviceToken = e.target.closest('.nvNotiSetingsDeviceCon1').dataset.device;
                if (!deviceToken) return;
                console.log('delete device:', deviceToken);
                const confirmDelete = confirm("\xbfEst\xe1s seguro de que deseas eliminar este dispositivo? Ya no recibir\xe1s notificaciones en este dispositivo.");
                if (!confirmDelete) return;
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Eliminando dispositivo...');
                let result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateDeleteDevice({
                    token: deviceToken,
                    state: 'delete'
                });
                if (!result.data.success) {
                    alert(result.data.message);
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                    return;
                }
                // Remove device from UI
                const deviceEl = document.querySelector(`.nvNotiSetingsDeviceCon1[data-device="${deviceToken}"]`);
                if (deviceEl) deviceEl.remove();
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
            if (editDeviceBtn) {
                const device = e.target.closest('.nvNotiSetingsDeviceCon1');
                console.log('device:', device);
                if (!device) return;
                const deviceToken = device.dataset.device;
                console.log('token:', deviceToken);
                if (!deviceToken) return;
                const input = device.querySelector('.nvNotiSetingsDeviceCon2 .nvNotiSetingsDeviceCon5');
                if (!input) return;
                const name = input.value.trim();
                console.log('name:', name);
                if (!name || name.length < 3) {
                    alert('El nombre del dispositivo debe tener al menos 3 caracteres.');
                    return;
                }
                console.log('edit device:', deviceToken);
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Actualizando nombre del dispositivo...');
                let result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVWUpdateDeleteDevice({
                    token: deviceToken,
                    state: 'update',
                    data: {
                        name: name
                    }
                });
                if (!result.data.success) {
                    alert(result.data.message);
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                    return;
                }
                input.value = name;
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
        });
        // Exicutable functions
        const catSelectorActivate = ()=>{
            console.log('here');
            const nvNotiConainerCatSelectorCon1 = document.getElementById('nvNotiConainerCatSelectorCon1');
            const allCatSelectors = nvNotiConainerCatSelectorCon1.querySelectorAll('.nvNotiConainerCatSelectorCon2');
            console.log(nvNotiConainerCatSelectorCon1, allCatSelectors);
            allCatSelectors.forEach((catE)=>{
                console.log('here');
                catE.addEventListener('click', ()=>{
                    const category = catE.dataset.cat;
                    if (!category) return;
                    this._loadNotifications(category);
                    console.log('click');
                    allCatSelectors.forEach((cat)=>{
                        cat.classList.remove('nvNotiConainerCatSelectorCon2Act');
                    });
                    catE.classList.add('nvNotiConainerCatSelectorCon2Act');
                });
            });
        };
        catSelectorActivate();
        const container = document.getElementById("NvNotiConForNotificationsScroll");
        console.log('container:', container);
        if (!container) return;
        container.addEventListener("scroll", ()=>{
            if (this.#isLoadingNotifications) return;
            if (!this.#hasMoreNotifications) return;
            const threshold = 120; // px from bottom
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = container;
            if (scrollTop + clientHeight >= scrollHeight - threshold) this._loadNotifications(this.#currentCategory);
        });
    }
    _events() {
        const SavedConMainSavedButtonSortAll = document.getElementById("SavedConMainSavedButtonSortAll");
        const SavedConMainSavedButtonSortBusiness = document.getElementById("SavedConMainSavedButtonSortBusiness");
        const SavedConMainSavedButtonSortListings = document.getElementById("SavedConMainSavedButtonSortListings");
        const SavedConMainSavedButtonSortFollowing = document.getElementById("SavedConMainSavedButtonSortFollowing");
        SavedConMainSavedButtonSortAll.addEventListener("click", ()=>{
            if (!this.#sortButtonsActived) return;
            this._displayAllSaved("all");
        });
        SavedConMainSavedButtonSortBusiness.addEventListener("click", ()=>{
            if (!this.#sortButtonsActived) return;
            this._displayAllSaved("businesses");
        });
        SavedConMainSavedButtonSortListings.addEventListener("click", ()=>{
            if (!this.#sortButtonsActived) return;
            this._displayAllSaved("listings");
        });
    }
}
var $c31a2d575b60811d$export$2e2bcd8739ae039 = new $c31a2d575b60811d$var$saved();


class $ac8c1f225cf741ea$var$generateHtml {
    _miniAddGenerator(data) {
        let imageHtml = '';
        let buttonHtml = '';
        let buttonClass = 'miniHeaderAddCon6Nor';
        if (data.imgUrl) imageHtml = `<img class="miniHeaderAddCon2Image" src="${data.imgUrl}">`;
        if (data.buttonType === 'pro') buttonClass = 'miniHeaderAddCon6';
        if (data.buttonLabel) buttonHtml = `
        <div class="miniHeaderAddCon5">
          <div class="${buttonClass}">
            <div class="miniHeaderAddText3">${data.buttonLabel}</div>
          </div>
        </div>
      `;
        return `
    
<div class="miniHeaderAddCon1A">
  <div data-inapplink="${data.inAppLink}" data-outapplink="${data.outAppLink}" class="miniHeaderAddCon1">
    <div class="miniHeaderAddCon2">

      ${imageHtml}

      <div class="miniHeaderAddCon3">
        <div class="miniHeaderAddText1">${data.title}</div>
        <div class="miniHeaderAddCon4">
          <div class="miniHeaderAddText2">${data.context}</div>
        </div>
      </div>
    </div>

    ${buttonHtml}

  </div>
</div>
    `;
    }
    _bigVideoAddGeneratorV1(data) {
        let buttonHtml = ``;
        let buttonClass = '';
        if (data.buttonType === 'pro') buttonClass = 'headerVideoAddCon5Pro';
        if (data.buttonLabel) buttonHtml = `
        <div class="headerVideoAddCon4">
            <div class="headerVideoAddCon5 ${buttonClass}">
                <div class="headerVideoAddText3">${data.buttonLabel}</div>
            </div>
        </div>

    `;
        return `
    <div class="headerVideoAddCon1">
      <div 
        data-inapplink="${data.inAppLink || ''}" 
        data-outapplink="${data.outAppLink || ''}" 
        class="headerVideoAddCon2"
      >
        <div class="headerVideoAddCon2Video">
            <video 
            class="headerVideoVideo"
            src="${data.vidUrl || ''}"
            muted
            playsinline
            preload="auto"
            controls
            ></video>
            <button class="videoMuteToggle">Audio \u{1F507}</button>

        </div>

        <div class="headerVideoAddCon3">
          <div class="headerVideoAddText1">${data.title}</div>
          <div class="headerVideoAddText2">${data.context}</div>

          ${buttonHtml}
        </div>
      </div>
    </div>
  `;
    }
    _bigVideoAddGenerator(data) {
        let buttonHtml = ``;
        let buttonClass = '';
        if (data.buttonType === 'pro') buttonClass = 'headerVideoAddCon5Pro';
        if (data.buttonLabel) buttonHtml = `
        <div class="headerVideoAddCon4">
            <div class="headerVideoAddCon5 ${buttonClass}">
                <div class="headerVideoAddText3">${data.buttonLabel}</div>
            </div>
        </div>
        `;
        const vid720 = data?.vidRes?.vid720Url || '';
        const vid1080 = data?.vidRes?.vid1080Url || '';
        return `
    <div class="headerVideoAddCon1">
      <div 
        data-inapplink="${data.inAppLink || ''}" 
        data-outapplink="${data.outAppLink || ''}" 
        class="headerVideoAddCon2"
      >

        <div class="headerVideoAddCon2Video">
            <video 
                class="headerVideoVideo"
                muted
                playsinline
                preload="metadata"
                controls
            >

                ${vid1080 ? `<source src="${vid1080}" type="video/mp4" media="(min-width: 1000px)">` : ''}

                ${vid720 ? `<source src="${vid720}" type="video/mp4">` : ''}

            </video>

            <button class="videoMuteToggle">Audio \u{1F507}</button>
        </div>

        <div class="headerVideoAddCon3">
          <div class="headerVideoAddText1">${data.title || ''}</div>
          <div class="headerVideoAddText2">${data.context || ''}</div>

          ${buttonHtml}
        </div>

      </div>
    </div>
    `;
    }
}
var $ac8c1f225cf741ea$export$2e2bcd8739ae039 = new $ac8c1f225cf741ea$var$generateHtml();


const $84d4f35da787c4f0$var$bigAddsData = [];
const $84d4f35da787c4f0$var$miniAddsData = [
    {
        title: "Nueva versi\xf3n de Mercado MAI",
        context: "Descubre una experiencia m\xe1s intuitiva, r\xe1pida y optimizada para comprar y vender con mayor facilidad.",
        inAppLink: '',
        outAppLink: '',
        buttonLabel: '',
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fhome%20screen.png?alt=media&token=1adf350f-1508-4836-a195-e5dd8f45357e'
    },
    {
        title: 'Notificaciones inteligentes',
        context: "Recibe alertas importantes directamente en tu dispositivo. Personaliza cu\xe1ndo quieres ser notificado.",
        inAppLink: 'open-notifications',
        outAppLink: '',
        buttonLabel: "Ver Notificani\xf3nes",
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fnotifications.png?alt=media&token=eab4a32f-6d8c-4980-a3c8-67077c5305b4'
    },
    {
        title: "B\xfasqueda mejorada",
        context: "Nuestro nuevo motor de b\xfasqueda te permite encontrar listados, negocios y perfiles de vendedores con mayor precisi\xf3n y profundidad.",
        inAppLink: '',
        outAppLink: '',
        buttonLabel: '',
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fsearch%20listings.png?alt=media&token=3634864c-b62b-4f1a-96f5-422ad61c8fbb'
    },
    {
        title: 'Comparte listas de negocios',
        context: "Ahora puedes compartir listas de productos organizadas por categor\xeda. Mant\xe9n presionada una lista y selecciona \u201CCompartir\u201D.",
        inAppLink: '',
        outAppLink: '',
        buttonLabel: '',
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fshare%20list.png?alt=media&token=21cd8595-faaa-46db-b63a-458cff39e823'
    }
];
class $84d4f35da787c4f0$var$adds {
    #videoCarousel = {
        container: null,
        videos: [],
        currentIndex: 0,
        scrollTimeout: null,
        isPaused: false
    };
    #isVideoAddShowOnTimer = false;
    constructor(){
        console.log('Adds is live!');
    // setTimeout(() => {
    //     this._initializeMiniAdds()
    //     this._initializeBigAdds()
    // }, 3000);
    }
    _hideDispBigVideoAdd(state, isOnTimer) {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2BigAddContainer');
        if (state === 'hide') {
            nvHeaderCon2MiniAddContainer.style.display = 'none';
            this._pauseVideoCarousel();
            if (!this.#isVideoAddShowOnTimer && isOnTimer) this.#isVideoAddShowOnTimer = true;
        }
        if (!this.#isVideoAddShowOnTimer && state === 'show') {
            console.log('here');
            this._openVideoAgain();
        }
        console.log(this.#isVideoAddShowOnTimer);
    }
    _init() {}
    // START mini adds
    async _initializeMiniAdds() {
        let localAddsList = $84d4f35da787c4f0$var$miniAddsData;
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2MiniAddContainer');
        const miniAddsSettings = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById('adds/miniAdds');
        if (miniAddsSettings.miniAddsOn) {
            localAddsList = [];
            for (const id of miniAddsSettings.currentList){
                const add = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`adds/miniAdds/adds/${id}`);
                localAddsList.push(add);
            }
        } else localAddsList = $84d4f35da787c4f0$var$miniAddsData;
        nvHeaderCon2MiniAddContainer.innerHTML = '';
        localAddsList.forEach((add)=>{
            const addHtml = (0, $ac8c1f225cf741ea$export$2e2bcd8739ae039)._miniAddGenerator(add);
            nvHeaderCon2MiniAddContainer.insertAdjacentHTML('beforeend', addHtml);
        });
        this._startMiniAddsAutoScroll();
        this._miniAddClickEvent();
    }
    _startMiniAddsAutoScroll() {
        const container = document.getElementById('nvHeaderCon2MiniAddContainer');
        if (!container) return;
        const items = Array.from(container.children);
        if (!items.length) return;
        let currentIndex = 0;
        let autoScrollTimer = null;
        let pauseTimer = null;
        let isPaused = false;
        let autoScroll = false;
        /* -------------------- */ /* Detect Active Slide  */ /* -------------------- */ const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) currentIndex = items.indexOf(entry.target);
            });
        }, {
            root: container,
            threshold: 0.6
        });
        items.forEach((item)=>observer.observe(item));
        /* -------------------- */ /* Auto Scroll Engine   */ /* -------------------- */ const scheduleNextScroll = ()=>{
            clearTimeout(autoScrollTimer);
            if (isPaused) return;
            // autoScrollTimer = setTimeout(() => {
            //   currentIndex = (currentIndex + 1) % items.length;
            //   autoScroll = true
            //   container.scrollTo({
            //     left: items[currentIndex].offsetLeft,
            //     behavior: 'smooth'
            //   });
            //   setTimeout(() => {
            //     autoScroll = false
            //   }, 2000)
            //   scheduleNextScroll(); // schedule next 5s after scroll
            // }, 5000);
            autoScrollTimer = setTimeout(()=>{
                const nextIndex = (currentIndex + 1) % items.length;
                const isLooping = nextIndex === 0; // 👈 detect wrap
                currentIndex = nextIndex;
                autoScroll = true;
                container.scrollTo({
                    left: items[currentIndex].offsetLeft,
                    behavior: isLooping ? 'auto' : 'smooth' // 👈 key change
                });
                setTimeout(()=>{
                    autoScroll = false;
                }, isLooping ? 50 : 2000); // shorter lock for instant jump
                scheduleNextScroll();
            }, 5000);
        };
        const pauseAutoScroll = ()=>{
            if (autoScroll) return;
            isPaused = true;
            clearTimeout(autoScrollTimer);
            clearTimeout(pauseTimer);
            pauseTimer = setTimeout(()=>{
                isPaused = false;
                scheduleNextScroll(); // fresh 5s cycle
            }, 15000);
        };
        /* -------------------- */ /* User Interaction     */ /* -------------------- */ const handleInteraction = ()=>{
            pauseAutoScroll(); // always resets 15s
        };
        container.addEventListener('touchstart', handleInteraction, {
            passive: true
        });
        container.addEventListener('mousedown', handleInteraction);
        container.addEventListener('scroll', handleInteraction);
        /* -------------------- */ scheduleNextScroll(); // start system
    }
    _miniAddClickEvent() {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2MiniAddContainer');
        nvHeaderCon2MiniAddContainer.addEventListener('click', (e)=>{
            console.log('here');
            const isInAdd = e.target.closest('.miniHeaderAddCon1');
            if (!isInAdd) return;
            console.log('here');
            const inAppLink = isInAdd.dataset.inapplink;
            const outAppLink = isInAdd.dataset.outapplink;
            if (inAppLink) {
                console.log(inAppLink);
                if (inAppLink === 'open-notifications') {
                    (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav('Notification');
                    (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
                }
            }
            if (outAppLink) (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink(outAppLink);
        });
    }
    // END mini adds
    // START big adds
    async _initializeBigAdds() {
        let localAddsList = $84d4f35da787c4f0$var$miniAddsData;
        let addCount = 0;
        const videoAddsSettings = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById('adds/videoAdds');
        console.log(videoAddsSettings);
        if (videoAddsSettings.videoAddsOn) {
            localAddsList = [];
            for (const id of videoAddsSettings.lists[videoAddsSettings.currentListName]){
                const add = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`adds/videoAdds/adds/${id}`);
                localAddsList.push(add);
                addCount++;
            }
        } else {
            localAddsList = $84d4f35da787c4f0$var$miniAddsData;
            return;
        }
        console.log(addCount);
        if (addCount < 1) return;
        const nvHeaderCon2BigAddContainer = document.getElementById('nvHeaderCon2BigAddContainer');
        const buttonHtml = '<div id="headerAddVideoButtonCloseVideos" class="headerAddVideoButtonCloseVideos">Cerrar Videos</div>';
        nvHeaderCon2BigAddContainer.innerHTML = '';
        nvHeaderCon2BigAddContainer.insertAdjacentHTML('beforeend', buttonHtml);
        localAddsList.forEach((add)=>{
            const addHtml = (0, $ac8c1f225cf741ea$export$2e2bcd8739ae039)._bigVideoAddGenerator(add);
            nvHeaderCon2BigAddContainer.insertAdjacentHTML('beforeend', addHtml);
        // allHandeling._translateTheHeaderAcordingToScroll("NVHomeMainContainerBusinesses", true)
        // allHandeling._translateTheHeaderAcordingToScroll("NVHomeMainContainerListings", true)
        // allHandeling._translateTheHeaderAcordingToScroll("NVHomeMainContainerSellers", true)
        });
        // this._startMiniAddsAutoScroll()
        // this._miniAddClickEvent()
        this._initializeVideoControls();
        this._initVideoCarousel();
        this._bigAddClickEvent();
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._addHeader3Stage('NVHomeMainContainerListings');
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._addHeader3Stage('NVHomeMainContainerBusinesses');
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._addHeader3Stage('NVHomeMainContainerSellers');
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._listenAddContainerHeightChanges();
    }
    _initializeVideoControls() {
        const videos = document.querySelectorAll('.headerVideoAddCon2Video');
        videos.forEach((container)=>{
            const video = container.querySelector('video');
            const button = container.querySelector('.videoMuteToggle');
            if (!video || !button) return;
            button.addEventListener('click', (e)=>{
                e.stopPropagation(); // prevent triggering parent click
                video.muted = !video.muted;
                button.textContent = video.muted ? "Audio \uD83D\uDD07" : "Audio \uD83D\uDD0A";
            });
        });
    }
    // _initVideoCarousel() {
    //     const container = document.getElementById("nvHeaderCon2BigAddContainer");
    //     if (!container) return;
    //     const videos = Array.from(
    //         container.querySelectorAll(".headerVideoVideo")
    //     );
    //     if (!videos.length) return;
    //     let currentIndex = 0;
    //     let scrollTimeout = null;
    //     const playVideoAt = (index) => {
    //         videos.forEach((video, i) => {
    //             if (i === index) {
    //                 video.play().catch(() => { });
    //             } else {
    //                 video.pause();
    //                 video.currentTime = 0;
    //             }
    //         });
    //         currentIndex = index;
    //     };
    //     // ✅ Play first video initially
    //     playVideoAt(0);
    //     // ✅ When video ends → go to next
    //     videos.forEach((video, index) => {
    //         video.addEventListener("ended", () => {
    //             const nextIndex = (index + 1) % videos.length;
    //             const nextItem = videos[nextIndex].closest(".headerVideoAddCon1");
    //             nextItem.scrollIntoView({
    //                 behavior: "smooth",
    //                 inline: "center",
    //                 block: "nearest"
    //             });
    //             playVideoAt(nextIndex);
    //         });
    //     });
    //     // ✅ Detect visible video on scroll
    //     container.addEventListener("scroll", () => {
    //         // Pause immediately during scroll
    //         videos[currentIndex].pause();
    //         clearTimeout(scrollTimeout);
    //         scrollTimeout = setTimeout(() => {
    //             const containerRect = container.getBoundingClientRect();
    //             let closestIndex = 0;
    //             let closestDistance = Infinity;
    //             videos.forEach((video, index) => {
    //                 const rect = video.getBoundingClientRect();
    //                 const videoCenter = rect.left + rect.width / 2;
    //                 const containerCenter = containerRect.left + containerRect.width / 2;
    //                 const distance = Math.abs(containerCenter - videoCenter);
    //                 if (distance < closestDistance) {
    //                     closestDistance = distance;
    //                     closestIndex = index;
    //                 }
    //             });
    //             playVideoAt(closestIndex);
    //         }, 150); // wait for scroll to stop
    //     });
    // }
    _initVideoCarousel() {
        const container = document.getElementById("nvHeaderCon2BigAddContainer");
        if (!container) return;
        const videos = Array.from(container.querySelectorAll(".headerVideoVideo"));
        if (!videos.length) return;
        // Save references
        this.#videoCarousel.container = container;
        this.#videoCarousel.videos = videos;
        this.#videoCarousel.currentIndex = 0;
        this.#videoCarousel.isPaused = false;
        const playVideoAt = (index)=>{
            if (this.#videoCarousel.isPaused) return;
            videos.forEach((video, i)=>{
                if (i === index) video.play().catch(()=>{});
                else {
                    video.pause();
                    video.currentTime = 0;
                }
            });
            this.#videoCarousel.currentIndex = index;
        };
        // ▶️ Play first video
        playVideoAt(0);
        // 🔁 Auto advance when video ends
        videos.forEach((video, index)=>{
            video.addEventListener("ended", ()=>{
                if (this.#videoCarousel.isPaused) return;
                const nextIndex = (index + 1) % videos.length;
                const nextItem = videos[nextIndex].closest(".headerVideoAddCon1");
                nextItem.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "nearest"
                });
                playVideoAt(nextIndex);
            });
        });
        // 👆 Scroll detection
        container.addEventListener("scroll", ()=>{
            if (this.#videoCarousel.isPaused) return;
            videos[this.#videoCarousel.currentIndex].pause();
            clearTimeout(this.#videoCarousel.scrollTimeout);
            this.#videoCarousel.scrollTimeout = setTimeout(()=>{
                const containerRect = container.getBoundingClientRect();
                let closestIndex = 0;
                let closestDistance = Infinity;
                videos.forEach((video, index)=>{
                    const rect = video.getBoundingClientRect();
                    const videoCenter = rect.left + rect.width / 2;
                    const containerCenter = containerRect.left + containerRect.width / 2;
                    const distance = Math.abs(containerCenter - videoCenter);
                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestIndex = index;
                    }
                });
                playVideoAt(closestIndex);
            }, 150);
        });
        // 👁️ Pause when carousel goes off screen (vertical visibility)
        const visibilityObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) {
                    // 🔴 Off screen → pause everything
                    this.#videoCarousel.isPaused = true;
                    const currentVideo = videos[this.#videoCarousel.currentIndex];
                    currentVideo?.pause();
                } else {
                    // 🟢 Back on screen → resume
                    this.#videoCarousel.isPaused = false;
                    const currentVideo = videos[this.#videoCarousel.currentIndex];
                    currentVideo?.play().catch(()=>{});
                }
            });
        }, {
            root: null,
            threshold: 0.25 // trigger when at least 25% visible
        });
        visibilityObserver.observe(container);
    }
    _pauseVideoCarousel() {
        if (!this.#videoCarousel.videos.length) return;
        this.#videoCarousel.isPaused = true;
        const current = this.#videoCarousel.videos[this.#videoCarousel.currentIndex];
        current.pause();
    }
    _resumeVideoCarousel() {
        if (!this.#videoCarousel.videos.length) return;
        this.#videoCarousel.isPaused = false;
        const current = this.#videoCarousel.videos[this.#videoCarousel.currentIndex];
        current.play().catch(()=>{});
    }
    _openVideoAgain() {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2BigAddContainer');
        if ((0, $3932d5095c13a35b$export$2e2bcd8739ae039)._getIsInSearchState()) return;
        if ((0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._getOpenState()) return;
        nvHeaderCon2MiniAddContainer.style.display = 'flex';
        this._resumeVideoCarousel();
    }
    _bigAddClickEvent() {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2BigAddContainer');
        nvHeaderCon2MiniAddContainer.addEventListener('click', (e)=>{
            console.log('here');
            const isInAdd = e.target.closest('.headerVideoAddCon2');
            const isCloseButton = e.target.closest('.headerAddVideoButtonCloseVideos');
            const isActionButton = e.target.closest('.headerVideoAddCon4');
            if (isCloseButton) {
                this._hideDispBigVideoAdd('hide', true);
                const min = 6000; // 1 second
                const max = 8000; // 4 seconds
                // const min = 120000; // 2  minutes
                // const max = 300000; // 5 minutes
                const randomDelay = Math.floor(Math.random() * (max - min + 1)) + min;
                console.log(randomDelay);
                setTimeout(()=>{
                    this.#isVideoAddShowOnTimer = false;
                    this._hideDispBigVideoAdd('show');
                }, randomDelay);
            }
            if (isInAdd && isActionButton) {
                console.log('here');
                const inAppLink = isInAdd.dataset.inapplink;
                const outAppLink = isInAdd.dataset.outapplink;
                if (inAppLink) {
                    console.log(inAppLink);
                    if (inAppLink === 'open-notifications') {
                        (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav('Notification');
                        (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
                    }
                }
                if (outAppLink) (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink(outAppLink);
            }
        });
    }
}
var $84d4f35da787c4f0$export$2e2bcd8739ae039 = new $84d4f35da787c4f0$var$adds();



const $642fdc7e4da030b9$var$MainOneOnOverTheOther = document.getElementById("MainOneOnOverTheOther");
class $642fdc7e4da030b9$var$StackDisplay {
    #initiated = false;
    #lastHtmlInStack;
    #isStackDispOpen = false;
    _getOpenState() {
        return this.#isStackDispOpen;
    }
    _display(html) {
        this.#isStackDispOpen = true;
        (0, $84d4f35da787c4f0$export$2e2bcd8739ae039)._pauseVideoCarousel();
        if (this.#lastHtmlInStack === html) console.log("same");
        this.#lastHtmlInStack = html;
        $642fdc7e4da030b9$var$MainOneOnOverTheOther.style.display = "flex";
        $642fdc7e4da030b9$var$MainOneOnOverTheOther.insertAdjacentHTML("beforeend", this._generateWraper(html));
        if (!this.#initiated) {
            this._events();
            this.#initiated = true;
        }
    }
    _generateWraper(html) {
        return `
        <div class="MainOneOnOverTheOtherInner">${html}</div>
    `;
    }
    _initSwipe() {
        let gesture = null;
        const MIN_SWIPE_DISTANCE = 50;
        const MAX_SWIPE_TIME = 800;
        const LEFT_EDGE_MARGIN = 30;
        const getTopOverlay = ()=>{
            const overlays = $642fdc7e4da030b9$var$MainOneOnOverTheOther.querySelectorAll(".MainOneOnOverTheOtherInner");
            return overlays[overlays.length - 1] || null;
        };
        const resetSwipePosition = async (element, distance)=>{
            const animation = element.animate([
                {
                    translate: `${distance}px 0`
                },
                {
                    translate: "0 0"
                }
            ], {
                duration: 220,
                easing: "cubic-bezier(0.22, 1, 0.36, 1)",
                fill: "forwards"
            });
            try {
                await animation.finished;
            } catch  {}
            animation.cancel();
            element.style.translate = "";
            element.style.willChange = "";
        };
        const touchStartHandler = (event)=>{
            if (event.touches.length !== 1) return;
            const touch = event.touches[0];
            if (touch.pageX > LEFT_EDGE_MARGIN || event.target.closest(".preventSwipeBack")) {
                gesture = null;
                return;
            }
            const elementToRemove = getTopOverlay();
            if (!elementToRemove) return;
            const isLastChild = $642fdc7e4da030b9$var$MainOneOnOverTheOther.childElementCount === 1;
            gesture = {
                startX: touch.pageX,
                startY: touch.pageY,
                startTime: Date.now(),
                distance: 0,
                blocked: false,
                elementToRemove: elementToRemove,
                // Slide the parent for the last screen, avoiding a white flash.
                elementToMove: isLastChild ? $642fdc7e4da030b9$var$MainOneOnOverTheOther : elementToRemove,
                isLastChild: isLastChild
            };
            // Uses CSS translate, so any existing stack transform stays intact.
            gesture.elementToMove.style.willChange = "translate";
        };
        const touchMoveHandler = (event)=>{
            if (!gesture || event.touches.length !== 1) return;
            const touch = event.touches[0];
            const deltaX = touch.pageX - gesture.startX;
            const deltaY = touch.pageY - gesture.startY;
            // Treat a primarily vertical movement as scrolling, not swipe-back.
            if (!gesture.blocked && Math.abs(deltaY) > Math.abs(deltaX)) {
                gesture.blocked = true;
                return;
            }
            if (gesture.blocked || deltaX <= 0) return;
            event.preventDefault();
            gesture.distance = Math.min(deltaX, window.innerWidth);
            gesture.elementToMove.style.translate = `${gesture.distance}px 0`;
        };
        const finishGesture = async ()=>{
            if (!gesture) return;
            const currentGesture = gesture;
            gesture = null;
            const duration = Date.now() - currentGesture.startTime;
            const overlayWidth = currentGesture.elementToMove.getBoundingClientRect().width;
            const isPastHalfway = currentGesture.distance >= overlayWidth / 2;
            const isValidSwipe = !currentGesture.blocked && (isPastHalfway || currentGesture.distance >= MIN_SWIPE_DISTANCE && duration <= MAX_SWIPE_TIME);
            if (!isValidSwipe) {
                await resetSwipePosition(currentGesture.elementToMove, currentGesture.distance);
                return;
            }
            this._swipeAction(currentGesture);
        };
        document.addEventListener("touchstart", touchStartHandler, {
            passive: true
        });
        document.addEventListener("touchmove", touchMoveHandler, {
            passive: false
        });
        document.addEventListener("touchend", finishGesture, {
            passive: true
        });
        document.addEventListener("touchcancel", finishGesture, {
            passive: true
        });
    }
    async _swipeAction({ elementToRemove: elementToRemove, elementToMove: elementToMove, distance: distance, isLastChild: isLastChild }) {
        (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._resetCurrentImageIndex();
        const rect = elementToMove.getBoundingClientRect();
        // Continue from the user's current drag position until fully off-screen.
        const finalDistance = distance + (window.innerWidth - rect.left) + 32;
        const exitAnimation = elementToMove.animate([
            {
                translate: `${distance}px 0`
            },
            {
                translate: `${finalDistance}px 0`
            }
        ], {
            duration: 220,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)",
            fill: "forwards"
        });
        try {
            await exitAnimation.finished;
        } catch  {}
        elementToRemove.remove();
        if (isLastChild) {
            $642fdc7e4da030b9$var$MainOneOnOverTheOther.style.display = "none";
            this.#isStackDispOpen = false;
            (0, $84d4f35da787c4f0$export$2e2bcd8739ae039)._openVideoAgain();
        }
        exitAnimation.cancel();
        elementToMove.style.translate = "";
        elementToMove.style.willChange = "";
    }
    async _goBackOnStack(e, el) {
        console.log('here');
        (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._resetCurrentImageIndex();
        const sourceEl = e?.target || el;
        if (!sourceEl) return;
        const elementToRemove = sourceEl.closest(".MainOneOnOverTheOtherInner");
        if (!elementToRemove || elementToRemove.dataset.isClosing) return;
        elementToRemove.dataset.isClosing = "true";
        const isLastChild = $642fdc7e4da030b9$var$MainOneOnOverTheOther.childElementCount === 1;
        // When closing the last overlay, move its parent too.
        const elementToAnimate = isLastChild ? $642fdc7e4da030b9$var$MainOneOnOverTheOther : elementToRemove;
        const rect = elementToAnimate.getBoundingClientRect();
        const distanceToRight = window.innerWidth - rect.left + 32;
        let exitAnimation;
        try {
            exitAnimation = elementToAnimate.animate([
                {
                    transform: "translateX(0)"
                },
                {
                    transform: `translateX(${distanceToRight}px)`
                }
            ], {
                duration: 680,
                easing: "cubic-bezier(0.22, 1, 0.36, 1)",
                fill: "forwards"
            });
            await exitAnimation.finished;
        } catch  {
        // Still close if the animation is interrupted.
        }
        elementToRemove.remove();
        // Check the real state now, after removal.
        const stackIsEmpty = $642fdc7e4da030b9$var$MainOneOnOverTheOther.childElementCount === 0;
        if (stackIsEmpty) {
            console.log("last child removed");
            $642fdc7e4da030b9$var$MainOneOnOverTheOther.style.display = "none";
            this.#isStackDispOpen = false;
            exitAnimation?.cancel();
        }
    // if (isLastChild) {
    //   console.log("last child removed");
    //   MainOneOnOverTheOther.style.display = "none";
    //   this.#isStackDispOpen = false;
    //   // adds._openVideoAgain();
    //   // Remove the saved animation state so it opens normally next time.
    //   exitAnimation?.cancel();
    // }
    }
    _events() {
        this._initSwipe();
        $642fdc7e4da030b9$var$MainOneOnOverTheOther.addEventListener("click", (e)=>{
            const closestCloseButtonCheck = e.target.closest(".CloseCurrentStackPageButton");
            if (closestCloseButtonCheck) this._goBackOnStack(e);
        });
    }
}
var $642fdc7e4da030b9$export$2e2bcd8739ae039 = new $642fdc7e4da030b9$var$StackDisplay();











var $1364613338738de8$exports = {};
$1364613338738de8$exports = new URL("back-img.9eb9b86f.png", import.meta.url).toString();


var $8dc38640dbfd56a1$exports = {};
$8dc38640dbfd56a1$exports = new URL("forward-img.f09c2485.png", import.meta.url).toString();






var $906344b47e605252$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $906344b47e605252$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $906344b47e605252$export$70ffa26850098d01;
var $906344b47e605252$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $906344b47e605252$export$9f5a3dfc7a9f5dd = $906344b47e605252$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $906344b47e605252$export$70ffa26850098d01 = $906344b47e605252$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $906344b47e605252$var$commonjsGlobal !== 'undefined' ? $906344b47e605252$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


var $33cb313d667e3306$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $33cb313d667e3306$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $33cb313d667e3306$export$26404658cda3ee02;
var $33cb313d667e3306$export$ddb1030448106742;
var $33cb313d667e3306$export$aa726fb96ad3e039;
var $33cb313d667e3306$export$3d7865934588d77e;
var $33cb313d667e3306$export$d4e71bc0b80dc0fb;
var $33cb313d667e3306$export$cbbc350c1dfc80cb;
var $33cb313d667e3306$export$d61e24a684f9e51;
var $33cb313d667e3306$export$888d0d9ab79d08fc;
var $33cb313d667e3306$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $33cb313d667e3306$var$commonjsGlobal && $33cb313d667e3306$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a;
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        const b = a.length;
        if (0 < b) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(let c = 1; c < arguments.length; c++){
            const d = arguments[c];
            if (ha(d)) {
                const e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(let g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    class na {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class Aa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = Ba.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var Ba = new na(()=>new Ca, (a)=>a.reset());
    class Ca {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let x, y = !1, za = new Aa, Ea = ()=>{
        const a = k.Promise.resolve(void 0);
        x = ()=>{
            a.then(Da);
        };
    };
    var Da = ()=>{
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(()=>{
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class eb extends z {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : cb(this);
        }
        N() {
            super.N();
            this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = class {
        stringify(a) {
            return k.JSON.stringify(a, void 0);
        }
        parse(a) {
            return k.JSON.parse(a, void 0);
        }
    };
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        const b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        const b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        const b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const w = P(this.g);
                var b = this.g.Ba();
                const O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            let B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        const a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    let l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            const v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            const w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            const O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            const B = a.g;
                            if (B) {
                                const ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    const db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.D);
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(const d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(let d = 0; d < b.length; d++){
            const e = a[d];
            for(let f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        let b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            const f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        const c = new vb;
        if (k.Image) {
            const d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        const c = new vb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        const d = c || "";
        try {
            nc(a, function(e, f) {
                let g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        const b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function() {
            return "include" === this.m;
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        let b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    const g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            const c = a.g, d = a.v[0] ? ()=>{} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        const b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            const e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    const e = new M(this, this.j, a);
                    let f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        const d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            let f = -1;
            for(;;){
                const g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                let m = !0;
                for(let q = 0; q < c; q++){
                    let l = e[q].g;
                    const v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        let c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            const b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $33cb313d667e3306$export$66869136fc133c3a = $33cb313d667e3306$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new hd;
    };
    $33cb313d667e3306$export$888d0d9ab79d08fc = $33cb313d667e3306$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return qb();
    };
    $33cb313d667e3306$export$d61e24a684f9e51 = $33cb313d667e3306$export$2e2bcd8739ae039.Event = I;
    $33cb313d667e3306$export$cbbc350c1dfc80cb = $33cb313d667e3306$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $33cb313d667e3306$export$d4e71bc0b80dc0fb = $33cb313d667e3306$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $33cb313d667e3306$export$3d7865934588d77e = $33cb313d667e3306$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $33cb313d667e3306$export$aa726fb96ad3e039 = $33cb313d667e3306$export$2e2bcd8739ae039.WebChannel = mb;
    $33cb313d667e3306$export$ddb1030448106742 = $33cb313d667e3306$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $33cb313d667e3306$export$26404658cda3ee02 = $33cb313d667e3306$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $33cb313d667e3306$var$commonjsGlobal !== 'undefined' ? $33cb313d667e3306$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});




var $70fd6868680e912c$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $70fd6868680e912c$var$w = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $70fd6868680e912c$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $70fd6868680e912c$var$User.UNAUTHENTICATED = new $70fd6868680e912c$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$70fd6868680e912c$var$User.GOOGLE_CREDENTIALS = new $70fd6868680e912c$var$User("google-credentials-uid"), $70fd6868680e912c$var$User.FIRST_PARTY = new $70fd6868680e912c$var$User("first-party-uid"), $70fd6868680e912c$var$User.MOCK_USER = new $70fd6868680e912c$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $70fd6868680e912c$var$S = "11.0.2";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$b = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $70fd6868680e912c$var$__PRIVATE_getLogLevel() {
    return $70fd6868680e912c$var$b.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $70fd6868680e912c$export$c622e99c0ce7b1c9(e) {
    $70fd6868680e912c$var$b.setLogLevel(e);
}
function $70fd6868680e912c$var$__PRIVATE_logDebug(e, ...t) {
    if ($70fd6868680e912c$var$b.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$b.debug(`Firestore (${$70fd6868680e912c$var$S}): ${e}`, ...n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_logError(e, ...t) {
    if ($70fd6868680e912c$var$b.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$b.error(`Firestore (${$70fd6868680e912c$var$S}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $70fd6868680e912c$export$86cd73f49cc6e0bb(e, ...t) {
    if ($70fd6868680e912c$var$b.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) {
        const n = t.map($70fd6868680e912c$var$__PRIVATE_argToString);
        $70fd6868680e912c$var$b.warn(`Firestore (${$70fd6868680e912c$var$S}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $70fd6868680e912c$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $70fd6868680e912c$var$fail(e = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const t = `FIRESTORE (${$70fd6868680e912c$var$S}) INTERNAL ASSERTION FAILED: ` + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $70fd6868680e912c$var$__PRIVATE_logError(t), new Error(t);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $70fd6868680e912c$var$__PRIVATE_hardAssert(e, t) {
    e || $70fd6868680e912c$var$fail();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $70fd6868680e912c$export$1d2b90eea9bba017(e, t) {
    e || $70fd6868680e912c$var$fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $70fd6868680e912c$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$D = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $70fd6868680e912c$export$8fada0bf726bf278 extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($70fd6868680e912c$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $70fd6868680e912c$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $70fd6868680e912c$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === this.o);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $70fd6868680e912c$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $70fd6868680e912c$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($70fd6868680e912c$var$__PRIVATE_hardAssert("string" == typeof t.accessToken), new $70fd6868680e912c$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(null === e || "string" == typeof e), new $70fd6868680e912c$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $70fd6868680e912c$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = $70fd6868680e912c$var$User.FIRST_PARTY, this.T = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ I() {
        return this.P ? this.P() : null;
    }
    get headers() {
        this.T.set("X-Goog-AuthUser", this.l);
        // Use array notation to prevent minification
        const e = this.I();
        return e && this.T.set("Authorization", e), this.h && this.T.set("X-Goog-Iam-Authorization-Token", this.h), this.T;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $70fd6868680e912c$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n;
    }
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$__PRIVATE_FirstPartyToken(this.l, this.h, this.P));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($70fd6868680e912c$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $70fd6868680e912c$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $70fd6868680e912c$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(e){
        this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
    }
    start(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === this.o);
        const onTokenChanged = (e)=>{
            null != e.error && $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.R;
            return this.R = e.token, $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.A.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.A.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $70fd6868680e912c$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($70fd6868680e912c$var$__PRIVATE_hardAssert("string" == typeof e.token), this.R = e.token, new $70fd6868680e912c$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $70fd6868680e912c$export$253bcaa5572dcc83 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $70fd6868680e912c$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
        }
        return n;
    }
}
function $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $70fd6868680e912c$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $70fd6868680e912c$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor(1e6 * (e - 1e3 * t));
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $70fd6868680e912c$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $70fd6868680e912c$var$SnapshotVersion(e);
    }
    static min() {
        return new $70fd6868680e912c$var$SnapshotVersion(new $70fd6868680e912c$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $70fd6868680e912c$var$SnapshotVersion(new $70fd6868680e912c$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $70fd6868680e912c$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $70fd6868680e912c$var$fail(), void 0 === n ? n = e.length - t : n > e.length - t && $70fd6868680e912c$var$fail(), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $70fd6868680e912c$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $70fd6868680e912c$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = e.get(r), i = t.get(r);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $70fd6868680e912c$var$ResourcePath extends $70fd6868680e912c$var$BasePath {
    construct(e, t, n) {
        return new $70fd6868680e912c$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $70fd6868680e912c$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $70fd6868680e912c$var$ResourcePath([]);
    }
}
const $70fd6868680e912c$var$v = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $70fd6868680e912c$export$b7871852b967eaf1 extends $70fd6868680e912c$var$BasePath {
    construct(e, t, n) {
        return new $70fd6868680e912c$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $70fd6868680e912c$var$v.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $70fd6868680e912c$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $70fd6868680e912c$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $70fd6868680e912c$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $70fd6868680e912c$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $70fd6868680e912c$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $70fd6868680e912c$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $70fd6868680e912c$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $70fd6868680e912c$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $70fd6868680e912c$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $70fd6868680e912c$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $70fd6868680e912c$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $70fd6868680e912c$var$IndexState(0, $70fd6868680e912c$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $70fd6868680e912c$export$d9bcbd5e1ff81430(n + 1, 0) : new $70fd6868680e912c$export$d9bcbd5e1ff81430(n, r));
    return new $70fd6868680e912c$var$IndexOffset(i, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $70fd6868680e912c$var$IndexOffset(e.readTime, e.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $70fd6868680e912c$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$SnapshotVersion.max(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$C = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $70fd6868680e912c$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $70fd6868680e912c$var$D.FAILED_PRECONDITION || e.message !== $70fd6868680e912c$var$C) throw e;
    $70fd6868680e912c$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $70fd6868680e912c$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $70fd6868680e912c$var$fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $70fd6868680e912c$var$PersistencePromise ? t : $70fd6868680e912c$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $70fd6868680e912c$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $70fd6868680e912c$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $70fd6868680e912c$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $70fd6868680e912c$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $70fd6868680e912c$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.V = new $70fd6868680e912c$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.V.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.V.reject(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.V.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.V.reject(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get m() {
        return this.V.promise;
    }
    abort(e) {
        e && this.V.reject(e), this.aborted || ($70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    g() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $70fd6868680e912c$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        return $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "Removing database:", e), $70fd6868680e912c$var$__PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static p() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return !1;
        if ($70fd6868680e912c$var$__PRIVATE_SimpleDb.S()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $c38e0f42709c826a$export$c36915b22ce77c19)(), t = $70fd6868680e912c$var$__PRIVATE_SimpleDb.D(e), n = 0 < t && t < 10, r = $70fd6868680e912c$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static S() {
        var e;
        return "undefined" != typeof $cfae44f0dfdf62c0$exports && "YES" === (null === (e = $cfae44f0dfdf62c0$exports.__PRIVATE_env) || void 0 === e ? void 0 : e.v);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static C(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static D(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.F = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $70fd6868680e912c$var$__PRIVATE_SimpleDb.D((0, $c38e0f42709c826a$export$c36915b22ce77c19)()) && $70fd6868680e912c$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async M(e) {
        return this.db || ($70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.F.O(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.N && (this.db.onversionchange = (e)=>this.N(e)), this.db;
    }
    L(e) {
        this.N = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.M(e);
                const t = $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.g(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $70fd6868680e912c$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.m, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $70fd6868680e912c$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $70fd6868680e912c$var$__PRIVATE_IterationController {
    constructor(e){
        this.B = e, this.k = !1, this.q = null;
    }
    get isDone() {
        return this.k;
    }
    get K() {
        return this.q;
    }
    set cursor(e) {
        this.B = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.k = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ $(e) {
        this.q = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.B.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTransactionError extends $70fd6868680e912c$export$8fada0bf726bf278 {
    constructor(e, t){
        super($70fd6868680e912c$var$D.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $70fd6868680e912c$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $70fd6868680e912c$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
        return $70fd6868680e912c$var$__PRIVATE_wrapRequest(this.store.count());
    }
    U(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.W(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ G(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $70fd6868680e912c$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    j(e, t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.H = !1;
        const r = this.cursor(n);
        return this.W(r, (e, t, n)=>n.delete());
    }
    J(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.W(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Y(e) {
        const t = this.cursor({});
        return new $70fd6868680e912c$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    W(e, t) {
        const n = [];
        return new $70fd6868680e912c$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $70fd6868680e912c$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $70fd6868680e912c$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $70fd6868680e912c$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.K ? i.continue() : i.continue(s.K);
            };
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.H ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $70fd6868680e912c$var$__PRIVATE_wrapRequest(e) {
    return new $70fd6868680e912c$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $70fd6868680e912c$var$F = !1;
function $70fd6868680e912c$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_SimpleDb.D((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $70fd6868680e912c$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $70fd6868680e912c$var$F || ($70fd6868680e912c$var$F = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $70fd6868680e912c$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.Z = t, this.task = null;
    }
    start() {
        this.X(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    X(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("IndexBackfiller", `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                $70fd6868680e912c$var$__PRIVATE_logDebug("IndexBackfiller", `Documents written: ${await this.Z.ee()}`);
            } catch (e) {
                $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $70fd6868680e912c$var$__PRIVATE_logDebug("IndexBackfiller", "Ignoring IndexedDB error during index backfill: ", e) : await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.X(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $70fd6868680e912c$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ee(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.te(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ te(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $70fd6868680e912c$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $70fd6868680e912c$var$__PRIVATE_logDebug("IndexBackfiller", `Processing collection: ${t}`), this.ne(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ ne(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.re(r, n)).next((n)=>($70fd6868680e912c$var$__PRIVATE_logDebug("IndexBackfiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ re(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $70fd6868680e912c$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $70fd6868680e912c$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ie(e), this.se = (e)=>t.writeSequenceNumber(e));
    }
    ie(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.se && this.se(e), e;
    }
}
$70fd6868680e912c$var$__PRIVATE_ListenSequence.oe = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $70fd6868680e912c$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $70fd6868680e912c$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$70fd6868680e912c$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $70fd6868680e912c$var$__PRIVATE_encodeSeparator(t)), t = $70fd6868680e912c$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $70fd6868680e912c$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $70fd6868680e912c$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case "":
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $70fd6868680e912c$var$__PRIVATE_encodeSeparator(e) {
    return e + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(t >= 2), 2 === t) return $70fd6868680e912c$var$__PRIVATE_hardAssert("" === e.charAt(0) && "" === e.charAt(1)), $70fd6868680e912c$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf("", i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $70fd6868680e912c$var$fail();
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $70fd6868680e912c$var$fail();
        }
        i = t + 2;
    }
    return new $70fd6868680e912c$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$M = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $70fd6868680e912c$var$x = {}, $70fd6868680e912c$var$O = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $70fd6868680e912c$var$N = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $70fd6868680e912c$var$L = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $70fd6868680e912c$var$B = [
    "canonicalId",
    "targetId"
], $70fd6868680e912c$var$k = [
    "targetId",
    "path"
], $70fd6868680e912c$var$q = [
    "path",
    "targetId"
], $70fd6868680e912c$var$Q = [
    "collectionId",
    "parent"
], $70fd6868680e912c$var$K = [
    "indexId",
    "uid"
], $70fd6868680e912c$var$$ = [
    "uid",
    "sequenceNumber"
], $70fd6868680e912c$var$U = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $70fd6868680e912c$var$W = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $70fd6868680e912c$var$G = [
    "userId",
    "collectionPath",
    "documentId"
], $70fd6868680e912c$var$z = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $70fd6868680e912c$var$j = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $70fd6868680e912c$var$H = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $70fd6868680e912c$var$J = [
    ...$70fd6868680e912c$var$H,
    "documentOverlays"
], $70fd6868680e912c$var$Y = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $70fd6868680e912c$var$Z = $70fd6868680e912c$var$Y, $70fd6868680e912c$var$X = [
    ...$70fd6868680e912c$var$Z,
    "indexConfiguration",
    "indexState",
    "indexEntries"
], $70fd6868680e912c$var$ee = $70fd6868680e912c$var$X, $70fd6868680e912c$var$te = [
    ...$70fd6868680e912c$var$X,
    "globals"
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction extends $70fd6868680e912c$var$PersistenceTransaction {
    constructor(e, t){
        super(), this._e = e, this.currentSequenceNumber = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_getStore(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return $70fd6868680e912c$var$__PRIVATE_SimpleDb.C(n._e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $70fd6868680e912c$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $70fd6868680e912c$var$__PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $70fd6868680e912c$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $70fd6868680e912c$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $70fd6868680e912c$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $70fd6868680e912c$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $70fd6868680e912c$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $70fd6868680e912c$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $70fd6868680e912c$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $70fd6868680e912c$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $70fd6868680e912c$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $70fd6868680e912c$var$LLRBNode.RED, this.left = null != r ? r : $70fd6868680e912c$var$LLRBNode.EMPTY, this.right = null != i ? i : $70fd6868680e912c$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $70fd6868680e912c$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $70fd6868680e912c$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $70fd6868680e912c$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $70fd6868680e912c$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $70fd6868680e912c$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $70fd6868680e912c$var$fail();
        if (this.right.isRed()) throw $70fd6868680e912c$var$fail();
        const e = this.left.check();
        if (e !== this.right.check()) throw $70fd6868680e912c$var$fail();
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$70fd6868680e912c$var$LLRBNode.EMPTY = null, $70fd6868680e912c$var$LLRBNode.RED = !0, $70fd6868680e912c$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$70fd6868680e912c$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $70fd6868680e912c$var$fail();
    }
    get value() {
        throw $70fd6868680e912c$var$fail();
    }
    get color() {
        throw $70fd6868680e912c$var$fail();
    }
    get left() {
        throw $70fd6868680e912c$var$fail();
    }
    get right() {
        throw $70fd6868680e912c$var$fail();
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $70fd6868680e912c$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $70fd6868680e912c$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $70fd6868680e912c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $70fd6868680e912c$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $70fd6868680e912c$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $70fd6868680e912c$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $70fd6868680e912c$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $70fd6868680e912c$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $70fd6868680e912c$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $70fd6868680e912c$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($70fd6868680e912c$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $70fd6868680e912c$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $70fd6868680e912c$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $70fd6868680e912c$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $70fd6868680e912c$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $70fd6868680e912c$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $70fd6868680e912c$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $70fd6868680e912c$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $70fd6868680e912c$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $70fd6868680e912c$export$67460cdabfa21253("");
const $70fd6868680e912c$var$ne = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $70fd6868680e912c$var$ne.exec(e);
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e) : $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields.__previous_value__;
    return $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(t) ? $70fd6868680e912c$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);
    return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $70fd6868680e912c$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || "(default)";
    }
    static empty() {
        return new $70fd6868680e912c$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$re = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $70fd6868680e912c$var$ie = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $70fd6868680e912c$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $70fd6868680e912c$var$fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $70fd6868680e912c$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $70fd6868680e912c$var$__PRIVATE_typeOrder(e);
    if (n !== $70fd6868680e912c$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e).isEqual($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($70fd6868680e912c$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue) === $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $70fd6868680e912c$var$__PRIVATE_isNegativeZero(n) === $70fd6868680e912c$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $70fd6868680e912c$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($70fd6868680e912c$var$__PRIVATE_objectSize(n) !== $70fd6868680e912c$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$70fd6868680e912c$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $70fd6868680e912c$var$fail();
    }
}
function $70fd6868680e912c$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t));
}
function $70fd6868680e912c$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $70fd6868680e912c$var$__PRIVATE_typeOrder(e), r = $70fd6868680e912c$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareTimestamps($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e), $70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e), r = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_primitiveComparator($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.latitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.longitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                var n, r, i, s;
                const o = e.fields || {}, _ = t.fields || {}, a = null === (n = o.value) || void 0 === n ? void 0 : n.arrayValue, u = null === (r = _.value) || void 0 === r ? void 0 : r.arrayValue, c = $70fd6868680e912c$var$__PRIVATE_primitiveComparator((null === (i = null == a ? void 0 : a.values) || void 0 === i ? void 0 : i.length) || 0, (null === (s = null == u ? void 0 : u.values) || void 0 === s ? void 0 : s.length) || 0);
                if (0 !== c) return c;
                return $70fd6868680e912c$var$__PRIVATE_compareArrays(a, u);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $70fd6868680e912c$var$re.mapValue && t === $70fd6868680e912c$var$re.mapValue) return 0;
                if (e === $70fd6868680e912c$var$re.mapValue) return 1;
                if (t === $70fd6868680e912c$var$re.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $70fd6868680e912c$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $70fd6868680e912c$var$fail();
    }
}
function $70fd6868680e912c$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, t);
    const n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e), r = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(t), i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $70fd6868680e912c$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $70fd6868680e912c$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $70fd6868680e912c$var$canonicalId(e) {
    return $70fd6868680e912c$var$__PRIVATE_canonifyValue(e);
}
function $70fd6868680e912c$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $70fd6868680e912c$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $70fd6868680e912c$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$70fd6868680e912c$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_estimateByteSize(e) {
    switch($70fd6868680e912c$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $70fd6868680e912c$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $70fd6868680e912c$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $70fd6868680e912c$var$fail();
    }
}
function $70fd6868680e912c$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $70fd6868680e912c$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $70fd6868680e912c$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $70fd6868680e912c$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $70fd6868680e912c$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $70fd6868680e912c$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) {
    var t, n;
    return "__vector__" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/** Creates a deep copy of `source`. */ function $70fd6868680e912c$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $70fd6868680e912c$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $70fd6868680e912c$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $70fd6868680e912c$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) {
    return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
const $70fd6868680e912c$var$se = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__vector__"
            },
            value: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $70fd6868680e912c$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $70fd6868680e912c$var$ie : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $70fd6868680e912c$var$__PRIVATE_refValue($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? $70fd6868680e912c$var$se : {
        mapValue: {}
    } : $70fd6868680e912c$var$fail();
}
/** Returns the largest value for the given value type (exclusive). */ function $70fd6868680e912c$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $70fd6868680e912c$var$__PRIVATE_refValue($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $70fd6868680e912c$var$se : "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $70fd6868680e912c$var$re : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $70fd6868680e912c$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $70fd6868680e912c$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $70fd6868680e912c$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$70fd6868680e912c$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $70fd6868680e912c$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $70fd6868680e912c$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $70fd6868680e912c$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $70fd6868680e912c$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $70fd6868680e912c$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $70fd6868680e912c$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $70fd6868680e912c$var$ObjectValue($70fd6868680e912c$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $70fd6868680e912c$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $70fd6868680e912c$var$forEach(e.fields, (e, n)=>{
        const r = new $70fd6868680e912c$export$b7871852b967eaf1([
            e
        ]);
        if ($70fd6868680e912c$var$__PRIVATE_isMapValue(n)) {
            const e = $70fd6868680e912c$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $70fd6868680e912c$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $70fd6868680e912c$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $70fd6868680e912c$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $70fd6868680e912c$var$SnapshotVersion.min(), /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $70fd6868680e912c$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $70fd6868680e912c$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $70fd6868680e912c$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $70fd6868680e912c$var$SnapshotVersion.min(), /* createTime */ $70fd6868680e912c$var$SnapshotVersion.min(), $70fd6868680e912c$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $70fd6868680e912c$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $70fd6868680e912c$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $70fd6868680e912c$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $70fd6868680e912c$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $70fd6868680e912c$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $70fd6868680e912c$export$afc2e57c475b7810.comparator($70fd6868680e912c$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $70fd6868680e912c$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $70fd6868680e912c$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$70fd6868680e912c$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $70fd6868680e912c$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Filter {
}
class $70fd6868680e912c$var$FieldFilter extends $70fd6868680e912c$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $70fd6868680e912c$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $70fd6868680e912c$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $70fd6868680e912c$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $70fd6868680e912c$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $70fd6868680e912c$var$__PRIVATE_KeyFieldInFilter(e, n) : new $70fd6868680e912c$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && this.matchesComparison($70fd6868680e912c$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $70fd6868680e912c$var$__PRIVATE_typeOrder(this.value) === $70fd6868680e912c$var$__PRIVATE_typeOrder(t) && this.matchesComparison($70fd6868680e912c$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $70fd6868680e912c$var$fail();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $70fd6868680e912c$var$CompositeFilter extends $70fd6868680e912c$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.ae = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $70fd6868680e912c$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.ae || (this.ae = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.ae;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e) && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $70fd6868680e912c$var$CompositeFilter) return !1;
    return !0;
}
function $70fd6868680e912c$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $70fd6868680e912c$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $70fd6868680e912c$var$canonicalId(e.value);
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $70fd6868680e912c$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $70fd6868680e912c$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $70fd6868680e912c$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $70fd6868680e912c$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $70fd6868680e912c$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $70fd6868680e912c$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $70fd6868680e912c$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$70fd6868680e912c$var$canonicalId(e.value)}`;
    }(e) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($70fd6868680e912c$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $70fd6868680e912c$var$__PRIVATE_KeyFieldFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $70fd6868680e912c$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $70fd6868680e912c$var$__PRIVATE_KeyFieldInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $70fd6868680e912c$var$__PRIVATE_KeyFieldNotInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $70fd6868680e912c$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e)=>$70fd6868680e912c$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $70fd6868680e912c$var$__PRIVATE_ArrayContainsFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $70fd6868680e912c$var$isArray(t) && $70fd6868680e912c$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $70fd6868680e912c$var$__PRIVATE_InFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $70fd6868680e912c$var$__PRIVATE_NotInFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && !$70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $70fd6868680e912c$var$__PRIVATE_ArrayContainsAnyFilter extends $70fd6868680e912c$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$70fd6868680e912c$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$70fd6868680e912c$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.ue = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $70fd6868680e912c$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $70fd6868680e912c$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $70fd6868680e912c$var$__PRIVATE_canonifyTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (null === t.ue) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), t.ue = e;
    }
    return t.ue;
}
function $70fd6868680e912c$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$70fd6868680e912c$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$70fd6868680e912c$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$70fd6868680e912c$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $70fd6868680e912c$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $70fd6868680e912c$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $70fd6868680e912c$var$ie, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $70fd6868680e912c$var$ie, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $70fd6868680e912c$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $70fd6868680e912c$var$ie;
        }
        $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $70fd6868680e912c$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $70fd6868680e912c$var$re, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $70fd6868680e912c$var$re, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $70fd6868680e912c$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $70fd6868680e912c$var$re;
        }
        $70fd6868680e912c$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $70fd6868680e912c$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.ce = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.le = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.he = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $70fd6868680e912c$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $70fd6868680e912c$var$__PRIVATE_newQueryForPath(e) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (null === t.ce) {
        t.ce = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.ce.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new $70fd6868680e912c$var$OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($70fd6868680e912c$export$b7871852b967eaf1.keyField().canonicalString()) || t.ce.push(new $70fd6868680e912c$var$OrderBy($70fd6868680e912c$export$b7871852b967eaf1.keyField(), n));
    }
    return t.ce;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $70fd6868680e912c$var$__PRIVATE_queryToTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.le || (t.le = $70fd6868680e912c$var$__PRIVATE__queryToTarget(t, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))), t.le;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.he || // Do not include implicit order-bys for aggregate queries.
    (t.he = $70fd6868680e912c$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.he;
}
function $70fd6868680e912c$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $70fd6868680e912c$var$OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $70fd6868680e912c$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $70fd6868680e912c$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $70fd6868680e912c$var$__PRIVATE_queryEquals(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_targetEquals($70fd6868680e912c$var$__PRIVATE_queryToTarget(e), $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $70fd6868680e912c$var$__PRIVATE_canonifyQuery(e) {
    return `${$70fd6868680e912c$var$__PRIVATE_canonifyTarget($70fd6868680e912c$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $70fd6868680e912c$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$70fd6868680e912c$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($70fd6868680e912c$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $70fd6868680e912c$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $70fd6868680e912c$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e)){
            const e = $70fd6868680e912c$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $70fd6868680e912c$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $70fd6868680e912c$var$__PRIVATE_valueCompare(r, i) : $70fd6868680e912c$var$fail();
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $70fd6868680e912c$var$fail();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $70fd6868680e912c$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $70fd6868680e912c$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $70fd6868680e912c$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$oe = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap() {
    return $70fd6868680e912c$var$oe;
}
const $70fd6868680e912c$var$_e = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$documentMap(...e) {
    let t = $70fd6868680e912c$var$_e;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $70fd6868680e912c$var$_e;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $70fd6868680e912c$var$__PRIVATE_newOverlayMap() {
    return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
}
function $70fd6868680e912c$var$__PRIVATE_newMutationMap() {
    return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
}
function $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap() {
    return new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $70fd6868680e912c$var$ae = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
const $70fd6868680e912c$var$ue = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$__PRIVATE_documentKeySet(...e) {
    let t = $70fd6868680e912c$var$ue;
    for (const n of e)t = t.add(n);
    return t;
}
const $70fd6868680e912c$var$ce = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
function $70fd6868680e912c$var$__PRIVATE_targetIdSet() {
    return $70fd6868680e912c$var$ce;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $70fd6868680e912c$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $70fd6868680e912c$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $70fd6868680e912c$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $70fd6868680e912c$var$toNumber(e, t) {
    return $70fd6868680e912c$var$isSafeInteger(t) ? $70fd6868680e912c$var$__PRIVATE_toInteger(t) : $70fd6868680e912c$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $70fd6868680e912c$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $70fd6868680e912c$var$__PRIVATE_isServerTimestamp(t) && (t = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(t)), t && (n.fields.__previous_value__ = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $70fd6868680e912c$var$asNumber(n) + $70fd6868680e912c$var$asNumber(e.Pe);
        return $70fd6868680e912c$var$isInteger(n) && $70fd6868680e912c$var$isInteger(e.Pe) ? $70fd6868680e912c$var$__PRIVATE_toInteger(r) : $70fd6868680e912c$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $70fd6868680e912c$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform extends $70fd6868680e912c$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $70fd6868680e912c$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $70fd6868680e912c$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$70fd6868680e912c$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation extends $70fd6868680e912c$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Pe = t;
    }
}
function $70fd6868680e912c$var$asNumber(e) {
    return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $70fd6868680e912c$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $70fd6868680e912c$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $70fd6868680e912c$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $70fd6868680e912c$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation ? $70fd6868680e912c$var$__PRIVATE_arrayEquals(e.elements, t.elements, $70fd6868680e912c$var$__PRIVATE_valueEquals) : e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation ? $70fd6868680e912c$var$__PRIVATE_valueEquals(e.Pe, t.Pe) : e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform && t instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $70fd6868680e912c$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $70fd6868680e912c$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $70fd6868680e912c$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $70fd6868680e912c$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $70fd6868680e912c$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $70fd6868680e912c$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e.key, $70fd6868680e912c$var$Precondition.none()) : new $70fd6868680e912c$var$__PRIVATE_SetMutation(e.key, e.data, $70fd6868680e912c$var$Precondition.none());
    {
        const n = e.data, r = $70fd6868680e912c$var$ObjectValue.empty();
        let i = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e.key, r, new $70fd6868680e912c$var$FieldMask(i.toArray()), $70fd6868680e912c$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($70fd6868680e912c$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $70fd6868680e912c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $70fd6868680e912c$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($70fd6868680e912c$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($70fd6868680e912c$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $70fd6868680e912c$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $70fd6868680e912c$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $70fd6868680e912c$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$70fd6868680e912c$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $70fd6868680e912c$var$__PRIVATE_SetMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_PatchMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $70fd6868680e912c$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $70fd6868680e912c$var$__PRIVATE_hardAssert(e.length === n.length);
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $70fd6868680e912c$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $70fd6868680e912c$var$__PRIVATE_DeleteMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$__PRIVATE_VerifyMutation extends $70fd6868680e912c$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $70fd6868680e912c$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $70fd6868680e912c$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $70fd6868680e912c$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($70fd6868680e912c$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t)) && $70fd6868680e912c$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$70fd6868680e912c$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $70fd6868680e912c$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(e.mutations.length === n.length);
        let r = function __PRIVATE_documentVersionMap() {
            return $70fd6868680e912c$var$ae;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $70fd6868680e912c$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $70fd6868680e912c$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $70fd6868680e912c$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $70fd6868680e912c$var$le, $70fd6868680e912c$var$he;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $70fd6868680e912c$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        default:
            return $70fd6868680e912c$var$fail();
        case $70fd6868680e912c$var$D.CANCELLED:
        case $70fd6868680e912c$var$D.UNKNOWN:
        case $70fd6868680e912c$var$D.DEADLINE_EXCEEDED:
        case $70fd6868680e912c$var$D.RESOURCE_EXHAUSTED:
        case $70fd6868680e912c$var$D.INTERNAL:
        case $70fd6868680e912c$var$D.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $70fd6868680e912c$var$D.UNAUTHENTICATED:
            return !1;
        case $70fd6868680e912c$var$D.INVALID_ARGUMENT:
        case $70fd6868680e912c$var$D.NOT_FOUND:
        case $70fd6868680e912c$var$D.ALREADY_EXISTS:
        case $70fd6868680e912c$var$D.PERMISSION_DENIED:
        case $70fd6868680e912c$var$D.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $70fd6868680e912c$var$D.ABORTED:
        case $70fd6868680e912c$var$D.OUT_OF_RANGE:
        case $70fd6868680e912c$var$D.UNIMPLEMENTED:
        case $70fd6868680e912c$var$D.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $70fd6868680e912c$var$__PRIVATE_logError("GRPC error has no .code"), $70fd6868680e912c$var$D.UNKNOWN;
    switch(e){
        case $70fd6868680e912c$var$le.OK:
            return $70fd6868680e912c$var$D.OK;
        case $70fd6868680e912c$var$le.CANCELLED:
            return $70fd6868680e912c$var$D.CANCELLED;
        case $70fd6868680e912c$var$le.UNKNOWN:
            return $70fd6868680e912c$var$D.UNKNOWN;
        case $70fd6868680e912c$var$le.DEADLINE_EXCEEDED:
            return $70fd6868680e912c$var$D.DEADLINE_EXCEEDED;
        case $70fd6868680e912c$var$le.RESOURCE_EXHAUSTED:
            return $70fd6868680e912c$var$D.RESOURCE_EXHAUSTED;
        case $70fd6868680e912c$var$le.INTERNAL:
            return $70fd6868680e912c$var$D.INTERNAL;
        case $70fd6868680e912c$var$le.UNAVAILABLE:
            return $70fd6868680e912c$var$D.UNAVAILABLE;
        case $70fd6868680e912c$var$le.UNAUTHENTICATED:
            return $70fd6868680e912c$var$D.UNAUTHENTICATED;
        case $70fd6868680e912c$var$le.INVALID_ARGUMENT:
            return $70fd6868680e912c$var$D.INVALID_ARGUMENT;
        case $70fd6868680e912c$var$le.NOT_FOUND:
            return $70fd6868680e912c$var$D.NOT_FOUND;
        case $70fd6868680e912c$var$le.ALREADY_EXISTS:
            return $70fd6868680e912c$var$D.ALREADY_EXISTS;
        case $70fd6868680e912c$var$le.PERMISSION_DENIED:
            return $70fd6868680e912c$var$D.PERMISSION_DENIED;
        case $70fd6868680e912c$var$le.FAILED_PRECONDITION:
            return $70fd6868680e912c$var$D.FAILED_PRECONDITION;
        case $70fd6868680e912c$var$le.ABORTED:
            return $70fd6868680e912c$var$D.ABORTED;
        case $70fd6868680e912c$var$le.OUT_OF_RANGE:
            return $70fd6868680e912c$var$D.OUT_OF_RANGE;
        case $70fd6868680e912c$var$le.UNIMPLEMENTED:
            return $70fd6868680e912c$var$D.UNIMPLEMENTED;
        case $70fd6868680e912c$var$le.DATA_LOSS:
            return $70fd6868680e912c$var$D.DATA_LOSS;
        default:
            return $70fd6868680e912c$var$fail();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($70fd6868680e912c$var$he = $70fd6868680e912c$var$le || ($70fd6868680e912c$var$le = {}))[$70fd6868680e912c$var$he.OK = 0] = "OK", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.CANCELLED = 1] = "CANCELLED", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.UNKNOWN = 2] = "UNKNOWN", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.NOT_FOUND = 5] = "NOT_FOUND", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.ABORTED = 10] = "ABORTED", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.INTERNAL = 13] = "INTERNAL", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.UNAVAILABLE = 14] = "UNAVAILABLE", $70fd6868680e912c$var$he[$70fd6868680e912c$var$he.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $70fd6868680e912c$var$Pe = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $70fd6868680e912c$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Te = new (0, $906344b47e605252$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $906344b47e605252$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $70fd6868680e912c$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $70fd6868680e912c$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $70fd6868680e912c$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.Te = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Ie = (0, $906344b47e605252$export$70ffa26850098d01).fromNumber(this.Te);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Ee(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $906344b47e605252$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($70fd6868680e912c$var$Te) && (r = new (0, $906344b47e605252$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.Ie).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    de(e) {
        return 0 != (this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.Te) return !1;
        const t = $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $70fd6868680e912c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ee(n, r, e);
            if (!this.de(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $70fd6868680e912c$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.Te) return;
        const t = $70fd6868680e912c$var$__PRIVATE_getMd5HashValue(e), [n, r] = $70fd6868680e912c$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Ee(n, r, e);
            this.Ae(t);
        }
    }
    Ae(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $70fd6868680e912c$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $70fd6868680e912c$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $70fd6868680e912c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $70fd6868680e912c$var$RemoteEvent($70fd6868680e912c$var$SnapshotVersion.min(), r, new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $70fd6868680e912c$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $70fd6868680e912c$var$TargetChange(n, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet(), $70fd6868680e912c$var$__PRIVATE_documentKeySet(), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Re = e, this.removedTargetIds = t, this.key = n, this.Ve = r;
    }
}
class $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.me = t;
    }
}
class $70fd6868680e912c$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $70fd6868680e912c$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.fe = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.ge = $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.pe = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.ye = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.we = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.ye;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.pe;
    }
    /** Whether this target has pending target adds or target removes. */ get Se() {
        return 0 !== this.fe;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get be() {
        return this.we;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ De(e) {
        e.approximateByteSize() > 0 && (this.we = !0, this.pe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ve() {
        let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), t = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), n = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.ge.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $70fd6868680e912c$var$fail();
            }
        }), new $70fd6868680e912c$var$TargetChange(this.pe, this.ye, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Ce() {
        this.we = !1, this.ge = $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap();
    }
    Fe(e, t) {
        this.we = !0, this.ge = this.ge.insert(e, t);
    }
    Me(e) {
        this.we = !0, this.ge = this.ge.remove(e);
    }
    xe() {
        this.fe += 1;
    }
    Oe() {
        this.fe -= 1, $70fd6868680e912c$var$__PRIVATE_hardAssert(this.fe >= 0);
    }
    Ne() {
        this.we = !0, this.ye = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $70fd6868680e912c$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Le = e, /** The internal state of all tracked targets. */ this.Be = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ke = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), this.qe = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.Qe = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Ke = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ $e(e) {
        for (const t of e.Re)e.Ve && e.Ve.isFoundDocument() ? this.Ue(t, e.Ve) : this.We(t, e.key, e.Ve);
        for (const t of e.removedTargetIds)this.We(t, e.key, e.Ve);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ Ge(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.ze(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.je(t) && n.De(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Oe(), n.Se || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Ce(), n.De(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Oe(), n.Se || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.je(t) && (n.Ne(), n.De(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.je(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.He(t), n.De(e.resumeToken));
                    break;
                default:
                    $70fd6868680e912c$var$fail();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Be.forEach((e, n)=>{
            this.je(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ Je(e) {
        const t = e.targetId, n = e.me.count, r = this.Ye(t);
        if (r) {
            const i = r.target;
            if ($70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $70fd6868680e912c$export$afc2e57c475b7810(i.path);
                    this.We(t, e, $70fd6868680e912c$var$MutableDocument.newNoDocument(e, $70fd6868680e912c$var$SnapshotVersion.min()));
                } else $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === n);
            } else {
                const r = this.Ze(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.Xe(e), i = n ? this.et(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.He(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Ke = this.Ke.insert(t, e);
                    }
                    null == $70fd6868680e912c$var$Pe || $70fd6868680e912c$var$Pe.tt(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        var s, o, _, a, u, c;
                        const l = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, h = t.unchangedNames;
                        h && (l.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                            mightContain: (e)=>{
                                var t;
                                return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            }
                        });
                        return l;
                    }(r, e.me, this.Le.nt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ Xe(e) {
        const t = e.me.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $70fd6868680e912c$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $70fd6868680e912c$var$__PRIVATE_Base64DecodeError) return $70fd6868680e912c$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $70fd6868680e912c$var$BloomFilter(s, r, i);
        } catch (e) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb(e instanceof $70fd6868680e912c$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.Te ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ et(e, t, n) {
        return t.me.count === n - this.rt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ rt(e, t) {
        const n = this.Le.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Le.nt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.We(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ it(e) {
        const t = new Map;
        this.Be.forEach((n, r)=>{
            const i = this.Ye(r);
            if (i) {
                if (n.current && $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $70fd6868680e912c$export$afc2e57c475b7810(i.target.path);
                    this.st(t).has(r) || this.ot(r, t) || this.We(r, t, $70fd6868680e912c$var$MutableDocument.newNoDocument(t, e));
                }
                n.be && (t.set(r, n.ve()), n.Ce());
            }
        });
        let n = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Qe.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.Ye(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.ke.forEach((t, n)=>n.setReadTime(e));
        const r = new $70fd6868680e912c$var$RemoteEvent(e, t, this.Ke, this.ke, n);
        return this.ke = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), this.qe = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), this.Qe = $70fd6868680e912c$var$__PRIVATE_documentTargetMap(), this.Ke = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ue(e, t) {
        if (!this.je(e)) return;
        const n = this.ot(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.ze(e).Fe(t.key, n), this.ke = this.ke.insert(t.key, t), this.qe = this.qe.insert(t.key, this.st(t.key).add(e)), this.Qe = this.Qe.insert(t.key, this._t(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    We(e, t, n) {
        if (!this.je(e)) return;
        const r = this.ze(e);
        this.ot(e, t) ? r.Fe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Me(t), this.Qe = this.Qe.insert(t, this._t(t).delete(e)), this.Qe = this.Qe.insert(t, this._t(t).add(e)), n && (this.ke = this.ke.insert(t, n));
    }
    removeTarget(e) {
        this.Be.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ Ze(e) {
        const t = this.ze(e).ve();
        return this.Le.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ xe(e) {
        this.ze(e).xe();
    }
    ze(e) {
        let t = this.Be.get(e);
        return t || (t = new $70fd6868680e912c$var$__PRIVATE_TargetState, this.Be.set(e, t)), t;
    }
    _t(e) {
        let t = this.Qe.get(e);
        return t || (t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.Qe = this.Qe.insert(e, t)), t;
    }
    st(e) {
        let t = this.qe.get(e);
        return t || (t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.qe = this.qe.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ je(e) {
        const t = null !== this.Ye(e);
        return t || $70fd6868680e912c$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ Ye(e) {
        const t = this.Be.get(e);
        return t && t.Se ? null : this.Le.ut(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ He(e) {
        this.Be.set(e, new $70fd6868680e912c$var$__PRIVATE_TargetState);
        this.Le.getRemoteKeysForTarget(e).forEach((t)=>{
            this.We(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ ot(e, t) {
        return this.Le.getRemoteKeysForTarget(e).has(t);
    }
}
function $70fd6868680e912c$var$__PRIVATE_documentTargetMap() {
    return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
function $70fd6868680e912c$var$__PRIVATE_snapshotChangesMap() {
    return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
const $70fd6868680e912c$var$Ie = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $70fd6868680e912c$var$Ee = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $70fd6868680e912c$var$de = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $70fd6868680e912c$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $70fd6868680e912c$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $70fd6868680e912c$var$__PRIVATE_toVersion(e, t) {
    return $70fd6868680e912c$var$toTimestamp(e, t.toTimestamp());
}
function $70fd6868680e912c$var$__PRIVATE_fromVersion(e) {
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e), $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $70fd6868680e912c$var$__PRIVATE_toResourceName(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $70fd6868680e912c$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $70fd6868680e912c$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $70fd6868680e912c$var$__PRIVATE_fromResourceName(e) {
    const t = $70fd6868680e912c$var$ResourcePath.fromString(e);
    return $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isValidResourceName(t)), t;
}
function $70fd6868680e912c$var$__PRIVATE_toName(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $70fd6868680e912c$var$fromName(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $70fd6868680e912c$var$__PRIVATE_fromQueryPath(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $70fd6868680e912c$var$ResourcePath.emptyPath() : $70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $70fd6868680e912c$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $70fd6868680e912c$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $70fd6868680e912c$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $70fd6868680e912c$var$fromName(e, t.name), i = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), o = new $70fd6868680e912c$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $70fd6868680e912c$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $70fd6868680e912c$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        const n = $70fd6868680e912c$var$fromName(e, t.found.name), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.found.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), s = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $70fd6868680e912c$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.missing), $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t.readTime);
        const n = $70fd6868680e912c$var$fromName(e, t.missing), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime);
        return $70fd6868680e912c$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $70fd6868680e912c$var$fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(t || "")) : ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $70fd6868680e912c$require$Buffer || t instanceof Uint8Array), $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $70fd6868680e912c$var$D.UNKNOWN : $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $70fd6868680e912c$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $70fd6868680e912c$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $70fd6868680e912c$var$fromName(e, r.document.name), s = $70fd6868680e912c$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(r.document.createTime) : $70fd6868680e912c$var$SnapshotVersion.min(), _ = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $70fd6868680e912c$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $70fd6868680e912c$var$fromName(e, r.document), s = r.readTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(r.readTime) : $70fd6868680e912c$var$SnapshotVersion.min(), o = $70fd6868680e912c$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $70fd6868680e912c$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $70fd6868680e912c$var$fail();
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $70fd6868680e912c$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $70fd6868680e912c$var$toMutation(e, t) {
    let n;
    if (t instanceof $70fd6868680e912c$var$__PRIVATE_SetMutation) n = {
        update: $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_DeleteMutation) n = {
        delete: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation) n = {
        update: $70fd6868680e912c$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $70fd6868680e912c$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $70fd6868680e912c$var$__PRIVATE_VerifyMutation)) return $70fd6868680e912c$var$fail();
        n = {
            verify: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Pe
            };
            throw $70fd6868680e912c$var$fail();
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $70fd6868680e912c$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $70fd6868680e912c$var$fail();
    }(e, t.precondition)), n;
}
function $70fd6868680e912c$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $70fd6868680e912c$var$Precondition.updateTime($70fd6868680e912c$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $70fd6868680e912c$var$Precondition.exists(e.exists) : $70fd6868680e912c$var$Precondition.none();
    }(t.currentDocument) : $70fd6868680e912c$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $70fd6868680e912c$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), n = new $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $70fd6868680e912c$var$fail();
            const r = $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $70fd6868680e912c$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $70fd6868680e912c$var$fromName(e, t.update.name), s = new $70fd6868680e912c$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $70fd6868680e912c$var$FieldMask(t.map((e)=>$70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $70fd6868680e912c$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $70fd6868680e912c$var$fromName(e, t.delete);
        return new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $70fd6868680e912c$var$fromName(e, t.verify);
        return new $70fd6868680e912c$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(void 0 !== t), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(e.updateTime) : $70fd6868680e912c$var$__PRIVATE_fromVersion(t);
            return n.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $70fd6868680e912c$var$__PRIVATE_fromVersion(t)), new $70fd6868680e912c$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $70fd6868680e912c$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $70fd6868680e912c$var$__PRIVATE_toFilter($70fd6868680e912c$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $70fd6868680e912c$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        ct: n,
        parent: i
    };
}
function $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { ct: i, parent: s } = $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        lt: o,
        parent: s
    };
}
function $70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $70fd6868680e912c$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === r);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_fromFilter(e);
        if (t instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $70fd6868680e912c$var$OrderBy($70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $70fd6868680e912c$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $70fd6868680e912c$var$Bound(n, t);
    }(n.endAt)), $70fd6868680e912c$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $70fd6868680e912c$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $70fd6868680e912c$var$fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $70fd6868680e912c$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $70fd6868680e912c$var$fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $70fd6868680e912c$var$FieldFilter.create($70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $70fd6868680e912c$var$fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $70fd6868680e912c$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $70fd6868680e912c$var$fail();
            }
        }(e.compositeFilter.op));
    }(e) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_toDirection(e) {
    return $70fd6868680e912c$var$Ie[e];
}
function $70fd6868680e912c$var$__PRIVATE_toOperatorName(e) {
    return $70fd6868680e912c$var$Ee[e];
}
function $70fd6868680e912c$var$__PRIVATE_toCompositeOperatorName(e) {
    return $70fd6868680e912c$var$de[e];
}
function $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromFieldPathReference(e) {
    return $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $70fd6868680e912c$var$__PRIVATE_toFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($70fd6868680e912c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($70fd6868680e912c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($70fd6868680e912c$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($70fd6868680e912c$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $70fd6868680e912c$var$__PRIVATE_toFieldPathReference(e.field),
                op: $70fd6868680e912c$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $70fd6868680e912c$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$70fd6868680e912c$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $70fd6868680e912c$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $70fd6868680e912c$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $70fd6868680e912c$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $70fd6868680e912c$var$SnapshotVersion.min(), s = $70fd6868680e912c$var$SnapshotVersion.min(), o = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $70fd6868680e912c$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $70fd6868680e912c$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.ht = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $70fd6868680e912c$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $70fd6868680e912c$var$__PRIVATE_fromDocument(e.ht, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $70fd6868680e912c$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $70fd6868680e912c$var$fail();
        {
            const e = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $70fd6868680e912c$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $70fd6868680e912c$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $70fd6868680e912c$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $70fd6868680e912c$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.ht, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $70fd6868680e912c$var$fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $70fd6868680e912c$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$70fd6868680e912c$var$__PRIVATE_fromMutation(e.ht, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$70fd6868680e912c$var$__PRIVATE_fromMutation(e.ht, t)), i = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $70fd6868680e912c$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $70fd6868680e912c$var$__PRIVATE_fromDbTarget(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $70fd6868680e912c$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === e.documents.length), $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath($70fd6868680e912c$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $70fd6868680e912c$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $70fd6868680e912c$var$__PRIVATE_toDbTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e.ht, t.target) : $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e.ht, t.target).ct;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $70fd6868680e912c$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $70fd6868680e912c$var$Overlay(t.largestBatchId, $70fd6868680e912c$var$__PRIVATE_fromMutation(e.ht, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $70fd6868680e912c$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp($70fd6868680e912c$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $70fd6868680e912c$var$__PRIVATE_toDbTimestamp($70fd6868680e912c$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $70fd6868680e912c$var$__PRIVATE_bundlesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $70fd6868680e912c$var$__PRIVATE_namedQueriesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static Pt(e, t) {
        const n = t.uid || "";
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).get($70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $70fd6868680e912c$var$Overlay(t, i);
            r.push(this.Tt(e, s));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).j("collectionPathOverlayIndex", r));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).U("collectionPathOverlayIndex", s).next((e)=>{
            for (const t of e){
                const e = $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).J({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $70fd6868680e912c$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    Tt(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $70fd6868680e912c$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $70fd6868680e912c$var$toMutation(e.ht, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentOverlayStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "documentOverlays");
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbGlobalsCache {
    It(e) {
        return $70fd6868680e912c$var$__PRIVATE_getStore(e, "globals");
    }
    getSessionToken(e) {
        return this.It(e).get("sessionToken").next((e)=>{
            const t = null == e ? void 0 : e.value;
            return t ? $70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(t) : $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.It(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Et(e, t) {
        this.dt(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.At();
    }
    dt(e, t) {
        if ("nullValue" in e) this.Rt(t, 5);
        else if ("booleanValue" in e) this.Rt(t, 10), t.Vt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Rt(t, 15), t.Vt($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Rt(t, 13) : (this.Rt(t, 15), $70fd6868680e912c$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.Vt(0) : t.Vt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Rt(t, 20), "string" == typeof n && (n = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(n)), t.ft(`${n.seconds || ""}`), t.Vt(n.nanos || 0);
        } else if ("stringValue" in e) this.gt(e.stringValue, t), this.yt(t);
        else if ("bytesValue" in e) this.Rt(t, 30), t.wt($70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.yt(t);
        else if ("referenceValue" in e) this.St(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Rt(t, 45), t.Vt(n.latitude || 0), t.Vt(n.longitude || 0);
        } else "mapValue" in e ? $70fd6868680e912c$var$__PRIVATE_isMaxValue(e) ? this.Rt(t, Number.MAX_SAFE_INTEGER) : $70fd6868680e912c$var$__PRIVATE_isVectorValue(e) ? this.bt(e.mapValue, t) : (this.Dt(e.mapValue, t), this.yt(t)) : "arrayValue" in e ? (this.vt(e.arrayValue, t), this.yt(t)) : $70fd6868680e912c$var$fail();
    }
    gt(e, t) {
        this.Rt(t, 25), this.Ct(e, t);
    }
    Ct(e, t) {
        t.ft(e);
    }
    Dt(e, t) {
        const n = e.fields || {};
        this.Rt(t, 55);
        for (const e of Object.keys(n))this.gt(e, t), this.dt(n[e], t);
    }
    bt(e, t) {
        var n, r;
        const i = e.fields || {};
        this.Rt(t, 53);
        // Vectors sort first by length
        const s = "value", o = (null === (r = null === (n = i[s].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.length) || 0;
        this.Rt(t, 15), t.Vt($70fd6868680e912c$var$__PRIVATE_normalizeNumber(o)), // Vectors then sort by position value
        this.gt(s, t), this.dt(i[s], t);
    }
    vt(e, t) {
        const n = e.values || [];
        this.Rt(t, 50);
        for (const e of n)this.dt(e, t);
    }
    St(e, t) {
        this.Rt(t, 37);
        $70fd6868680e912c$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.Rt(t, 60), this.Ct(e, t);
        });
    }
    Rt(e, t) {
        e.Vt(t);
    }
    yt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Vt(2);
    }
}
$70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ft = new $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 == 0 && // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 == 0 && // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $70fd6868680e912c$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $70fd6868680e912c$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Mt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.xt(n.value), n = t.next();
        this.Ot();
    }
    Nt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Lt(n.value), n = t.next();
        this.Bt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ kt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.xt(e);
            else if (e < 2048) this.xt(960 | e >>> 6), this.xt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.xt(480 | e >>> 12), this.xt(128 | 63 & e >>> 6), this.xt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.xt(240 | e >>> 18), this.xt(128 | 63 & e >>> 12), this.xt(128 | 63 & e >>> 6), this.xt(128 | 63 & e);
            }
        }
        this.Ot();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ qt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Lt(e);
            else if (e < 2048) this.Lt(960 | e >>> 6), this.Lt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Lt(480 | e >>> 12), this.Lt(128 | 63 & e >>> 6), this.Lt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Lt(240 | e >>> 18), this.Lt(128 | 63 & e >>> 12), this.Lt(128 | 63 & e >>> 6), this.Lt(128 | 63 & e);
            }
        }
        this.Bt();
    }
    Qt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.Kt(e), n = $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(t);
        this.$t(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    Ut(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.Kt(e), n = $70fd6868680e912c$var$__PRIVATE_unsignedNumLength(t);
        this.$t(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ Wt() {
        this.Gt(255), this.Gt(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ zt() {
        this.jt(255), this.jt(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.$t(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Ht() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Kt(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = 0 != (128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ xt(e) {
        const t = 255 & e;
        0 === t ? (this.Gt(0), this.Gt(255)) : 255 === t ? (this.Gt(255), this.Gt(0)) : this.Gt(t);
    }
    /** Writes a single byte descending to the buffer.  */ Lt(e) {
        const t = 255 & e;
        0 === t ? (this.jt(0), this.jt(255)) : 255 === t ? (this.jt(255), this.jt(0)) : this.jt(e);
    }
    Ot() {
        this.Gt(0), this.Gt(1);
    }
    Bt() {
        this.jt(0), this.jt(1);
    }
    Gt(e) {
        this.$t(1), this.buffer[this.position++] = e;
    }
    jt(e) {
        this.$t(1), this.buffer[this.position++] = ~e;
    }
    $t(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $70fd6868680e912c$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.Jt = e;
    }
    wt(e) {
        this.Jt.Mt(e);
    }
    ft(e) {
        this.Jt.kt(e);
    }
    Vt(e) {
        this.Jt.Qt(e);
    }
    At() {
        this.Jt.Wt();
    }
}
class $70fd6868680e912c$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.Jt = e;
    }
    wt(e) {
        this.Jt.Nt(e);
    }
    ft(e) {
        this.Jt.qt(e);
    }
    Vt(e) {
        this.Jt.Ut(e);
    }
    At() {
        this.Jt.zt();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.Jt = new $70fd6868680e912c$var$__PRIVATE_OrderedCodeWriter, this.Yt = new $70fd6868680e912c$var$__PRIVATE_AscendingIndexByteEncoder(this.Jt), this.Zt = new $70fd6868680e912c$var$__PRIVATE_DescendingIndexByteEncoder(this.Jt);
    }
    seed(e) {
        this.Jt.seed(e);
    }
    Xt(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.Yt : this.Zt;
    }
    Ht() {
        return this.Jt.Ht();
    }
    reset() {
        this.Jt.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $70fd6868680e912c$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ en() {
        const e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.directionalValue, 0), t !== e ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $70fd6868680e912c$var$__PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 0 !== n ? n : (n = $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 0 !== n ? n : $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey)));
}
function $70fd6868680e912c$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.tn = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$export$b7871852b967eaf1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.nn = e.orderBy, this.rn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.tn = this.tn.add(e) : this.rn.push(e);
        }
    }
    get sn() {
        return this.tn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ on(e) {
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId), this.sn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this._n(t)) return !1;
        const n = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this._n(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.tn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.tn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.an(e, t) || !this.un(this.nn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.nn.length || !this.un(this.nn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ cn() {
        if (this.sn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        const t = [];
        for (const n of this.rn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $70fd6868680e912c$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $70fd6868680e912c$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.nn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $70fd6868680e912c$var$IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $70fd6868680e912c$var$FieldIndex($70fd6868680e912c$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $70fd6868680e912c$var$IndexState.empty());
    }
    _n(e) {
        for (const t of this.rn)if (this.an(t, e)) return !0;
        return !1;
    }
    an(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    un(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $70fd6868680e912c$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), e instanceof $70fd6868680e912c$var$FieldFilter) {
        if (e instanceof $70fd6868680e912c$var$__PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t)=>$70fd6868680e912c$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t))) || [];
            return $70fd6868680e912c$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const r = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_computeInExpansion(e));
    return $70fd6868680e912c$var$CompositeFilter.create(r, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $70fd6868680e912c$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm($70fd6868680e912c$var$__PRIVATE_computeInExpansion(e));
    return $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(t)), $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(t) || $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $70fd6868680e912c$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(e) || $70fd6868680e912c$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $70fd6868680e912c$var$CompositeFilter && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$70fd6868680e912c$var$__PRIVATE_isSingleFieldFilter(t) && !$70fd6868680e912c$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), e instanceof $70fd6868680e912c$var$FieldFilter) return e;
    if (1 === e.filters.length) return $70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $70fd6868680e912c$var$CompositeFilter.create(t, e.op);
    return n = $70fd6868680e912c$var$__PRIVATE_applyAssociation(n), $70fd6868680e912c$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($70fd6868680e912c$var$__PRIVATE_hardAssert(n instanceof $70fd6868680e912c$var$CompositeFilter), $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(n)), $70fd6868680e912c$var$__PRIVATE_hardAssert(n.filters.length > 1), n.filters.reduce((e, t)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t)));
}
function $70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), $70fd6868680e912c$var$__PRIVATE_hardAssert(t instanceof $70fd6868680e912c$var$FieldFilter || t instanceof $70fd6868680e912c$var$CompositeFilter), // FieldFilter FieldFilter
    n = e instanceof $70fd6868680e912c$var$FieldFilter ? t instanceof $70fd6868680e912c$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $70fd6868680e912c$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $70fd6868680e912c$var$FieldFilter ? $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(e) && $70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(t)) return $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $70fd6868680e912c$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, r));
        return $70fd6868680e912c$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $70fd6868680e912c$var$__PRIVATE_applyAssociation(n);
}
function $70fd6868680e912c$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $70fd6868680e912c$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$70fd6868680e912c$var$__PRIVATE_applyDistribution(e, t));
        return $70fd6868680e912c$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $70fd6868680e912c$var$__PRIVATE_applyAssociation(e) {
    if ($70fd6868680e912c$var$__PRIVATE_hardAssert(e instanceof $70fd6868680e912c$var$FieldFilter || e instanceof $70fd6868680e912c$var$CompositeFilter), e instanceof $70fd6868680e912c$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $70fd6868680e912c$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($70fd6868680e912c$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$70fd6868680e912c$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $70fd6868680e912c$var$FieldFilter ? r.push(t) : t instanceof $70fd6868680e912c$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $70fd6868680e912c$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.ln = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.ln.add(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.ln.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Ae = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.hn = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Pn = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), (e, t)=>$70fd6868680e912c$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.hn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.hn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r)
            };
            return $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e).U(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($70fd6868680e912c$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e), i = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), n = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return t.j().next(()=>n.j()).next(()=>r.j());
    }
    createTargetIndexes(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.Tn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher(t).cn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.Tn(t), (t)=>this.In(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                const r = [];
                return $70fd6868680e912c$var$PersistencePromise.forEach(i, (i, s)=>{
                    $70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbIndexManager", `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$70fd6868680e912c$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $70fd6868680e912c$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $70fd6868680e912c$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $70fd6868680e912c$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $70fd6868680e912c$var$Bound(n, r);
                    }(s, i), c = this.En(i, s, a), l = this.En(i, s, u), h = this.dn(i, s, _), P = this.An(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $70fd6868680e912c$var$PersistencePromise.forEach(P, (i)=>n.G(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $70fd6868680e912c$var$PersistencePromise.resolve(null);
        });
    }
    Tn(e) {
        let t = this.Pn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $70fd6868680e912c$var$__PRIVATE_getDnfTerms($70fd6868680e912c$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$70fd6868680e912c$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Pn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ An(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Rn(t[c / a]) : $70fd6868680e912c$var$Ae, l = this.Vn(e, _, n[c % a], r), h = this.mn(e, _, i[c % a], s), P = o.map((t)=>this.Vn(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ Vn(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_IndexEntry(e, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.en();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ mn(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_IndexEntry(e, $70fd6868680e912c$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.en() : i;
    }
    In(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.on(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.Tn(t);
        return $70fd6868680e912c$var$PersistencePromise.forEach(r, (t)=>this.In(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ fn(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        for (const r of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Xt(r.kind);
            $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, i);
        }
        return n.Ht();
    }
    /** Encodes a single value to the ascending index format. */ Rn(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        return $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, t.Xt(0 /* IndexKind.ASCENDING */ )), t.Ht();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ gn(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
        return $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ft.Et($70fd6868680e912c$var$__PRIVATE_refValue(this.databaseId, t), n.Xt(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.Ht();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ dn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $70fd6868680e912c$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.pn(t, s.fieldPath) && $70fd6868680e912c$var$isArray(e)) r = this.yn(r, s, e);
            else {
                const t = n.Xt(s.kind);
                $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, t);
            }
        }
        return this.wn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ En(e, t, n) {
        return this.dn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ wn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].Ht();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ yn(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $70fd6868680e912c$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.Ht()), $70fd6868680e912c$var$__PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, r.Xt(t.kind)), i.push(r);
        }
        return i;
    }
    pn(e, t) {
        return !!e.filters.find((e)=>e instanceof $70fd6868680e912c$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), r = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return (t ? n.U("collectionGroupIndex", IDBKeyRange.bound(t, t)) : n.U()).next((e)=>{
            const t = [];
            return $70fd6868680e912c$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $70fd6868680e912c$var$IndexState(t.sequenceNumber, new $70fd6868680e912c$var$IndexOffset($70fd6868680e912c$var$__PRIVATE_fromDbTimestamp(t.readTime), new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $70fd6868680e912c$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $70fd6868680e912c$var$IndexSegment($70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $70fd6868680e912c$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e), i = $70fd6868680e912c$var$__PRIVATE_indexStateStore(e);
        return this.Sn(e).next((e)=>r.U("collectionGroupIndex", IDBKeyRange.bound(t, t)).next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>i.put($70fd6868680e912c$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $70fd6868680e912c$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $70fd6868680e912c$var$PersistencePromise.forEach(i, (n)=>this.bn(e, t, n).next((t)=>{
                        const i = this.Dn(r, n);
                        return t.isEqual(i) ? $70fd6868680e912c$var$PersistencePromise.resolve() : this.vn(e, r, n, t, i);
                    }))));
        });
    }
    Cn(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e).put({
            indexId: r.indexId,
            uid: this.uid,
            arrayValue: r.arrayValue,
            directionalValue: r.directionalValue,
            orderedDocumentKey: this.gn(n, t.key),
            documentKey: t.key.path.toArray()
        });
    }
    Fn(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e).delete([
            r.indexId,
            this.uid,
            r.arrayValue,
            r.directionalValue,
            this.gn(n, t.key),
            t.key.path.toArray()
        ]);
    }
    bn(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e);
        let i = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_indexEntryComparator);
        return r.J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.gn(n, t)
            ])
        }, (e, r)=>{
            i = i.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Dn(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_indexEntryComparator);
        const r = this.fn(t, e);
        if (null == r) return n;
        const i = $70fd6868680e912c$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($70fd6868680e912c$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Rn(i), r));
        } else n = n.add(new $70fd6868680e912c$var$__PRIVATE_IndexEntry(t.indexId, e.key, $70fd6868680e912c$var$Ae, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ vn(e, t, n, r, i) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbIndexManager", "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s)) : (_ = $70fd6868680e912c$var$__PRIVATE_advanceIterator(s), a = $70fd6868680e912c$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $70fd6868680e912c$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.Cn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Fn(e, t, n, r));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(s);
    }
    Sn(e) {
        let t = 1;
        return $70fd6868680e912c$var$__PRIVATE_indexStateStore(e).J({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(i, e), s = $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.en();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.en());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Mn(r[e], r[e + 1])) return [];
            const t = [
                r[e].indexId,
                this.uid,
                r[e].arrayValue,
                r[e].directionalValue,
                $70fd6868680e912c$var$Ae,
                []
            ], n = [
                r[e + 1].indexId,
                this.uid,
                r[e + 1].arrayValue,
                r[e + 1].directionalValue,
                $70fd6868680e912c$var$Ae,
                []
            ];
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Mn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $70fd6868680e912c$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.mapArray(this.Tn(t), (t)=>this.In(e, t).next((e)=>e || $70fd6868680e912c$var$fail())).next($70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $70fd6868680e912c$var$__PRIVATE_collectionParentsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexEntriesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexConfigurationStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $70fd6868680e912c$var$__PRIVATE_indexStateStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "indexState");
}
function $70fd6868680e912c$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $70fd6868680e912c$var$__PRIVATE_hardAssert(0 !== e.length);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $70fd6868680e912c$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Re = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $70fd6868680e912c$var$LruParams {
    static withCacheSize(e) {
        return new $70fd6868680e912c$var$LruParams(e, $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $70fd6868680e912c$var$removeMutationBatch(e, t, n) {
    const r = e.store("mutations"), i = e.store("documentMutations"), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.J({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === _);
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $70fd6868680e912c$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $70fd6868680e912c$var$fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $70fd6868680e912c$var$LruParams.DEFAULT = new $70fd6868680e912c$var$LruParams(41943040, $70fd6868680e912c$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $70fd6868680e912c$var$LruParams.DISABLED = new $70fd6868680e912c$var$LruParams(-1, 0, 0);
class $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.xn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static Pt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $70fd6868680e912c$var$__PRIVATE_hardAssert("" !== e.uid);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e), s = $70fd6868680e912c$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $70fd6868680e912c$var$__PRIVATE_hardAssert("number" == typeof o);
            const _ = new $70fd6868680e912c$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$70fd6868680e912c$var$toMutation(e.ht, t)), i = n.mutations.map((t)=>$70fd6868680e912c$var$toMutation(e.ht, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $70fd6868680e912c$var$x));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.xn[o] = _.keys();
            }), $70fd6868680e912c$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId), $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    On(e, t) {
        return this.xn[t] ? $70fd6868680e912c$var$PersistencePromise.resolve(this.xn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.xn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($70fd6868680e912c$var$__PRIVATE_hardAssert(t.batchId >= n), i = $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).U("userMutationsIndex", t).next((e)=>e.map((e)=>$70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).J({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $70fd6868680e912c$var$fail();
                $70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId), i.push($70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).J({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r).next(()=>this.Nn(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).J({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.Nn(e, o));
    }
    Nn(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($70fd6868680e912c$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $70fd6868680e912c$var$fail();
                $70fd6868680e912c$var$__PRIVATE_hardAssert(e.userId === this.userId), n.push($70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $70fd6868680e912c$var$removeMutationBatch(e._e, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.Ln(t.batchId);
            }), $70fd6868680e912c$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    Ln(e) {
        delete this.xn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $70fd6868680e912c$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).J({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $70fd6868680e912c$var$__PRIVATE_hardAssert(0 === r.length);
            });
        });
    }
    containsKey(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Bn(e) {
        return $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e).J({
        range: s,
        H: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentMutationsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.kn = e;
    }
    next() {
        return this.kn += 2, this.kn;
    }
    static qn() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(0);
    }
    static Qn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.Kn(e).next((t)=>{
            const n = new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.$n(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.Kn(e).next((e)=>$70fd6868680e912c$var$SnapshotVersion.fromTimestamp(new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.Kn(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.Kn(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.$n(e, r)));
    }
    addTargetData(e, t) {
        return this.Un(e, t).next(()=>this.Kn(e).next((n)=>(n.targetCount += 1, this.Wn(t, n), this.$n(e, n))));
    }
    updateTargetData(e, t) {
        return this.Un(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$70fd6868680e912c$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.Kn(e)).next((t)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(t.targetCount > 0), t.targetCount -= 1, this.$n(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).J((s, o)=>{
            const _ = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).J((e, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    Kn(e) {
        return $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e).get("targetGlobalKey").next((e)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(null !== e), e));
    }
    $n(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e).put("targetGlobalKey", t);
    }
    Un(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).put($70fd6868680e912c$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Wn(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.Kn(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $70fd6868680e912c$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).J({
            range: r,
            index: "queryTargetsIndex"
        }, (e, n, r)=>{
            const s = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $70fd6868680e912c$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>{
            const i = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path);
            return $70fd6868680e912c$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        let i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return r.J({
            range: n,
            H: !0
        }, (e, t, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(e[1]), s = new $70fd6868680e912c$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $70fd6868680e912c$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).J({
            index: "documentTargetsIndex",
            H: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    ut(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $70fd6868680e912c$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $70fd6868680e912c$var$__PRIVATE_targetsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $70fd6868680e912c$var$__PRIVATE_globalTargetStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $70fd6868680e912c$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $70fd6868680e912c$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Gn = e, this.buffer = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_bufferEntryComparator), this.zn = 0;
    }
    jn() {
        return ++this.zn;
    }
    Hn(e) {
        const t = [
            e,
            this.jn()
        ];
        if (this.buffer.size < this.Gn) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $70fd6868680e912c$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $70fd6868680e912c$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Jn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Yn(6e4);
    }
    stop() {
        this.Jn && (this.Jn.cancel(), this.Jn = null);
    }
    get started() {
        return null !== this.Jn;
    }
    Yn(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`), this.Jn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Jn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e) ? $70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Yn(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $70fd6868680e912c$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Zn = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Zn.Xn(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$__PRIVATE_ListenSequence.oe);
        const n = new $70fd6868680e912c$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Zn.forEachTarget(e, (e)=>n.Hn(e.sequenceNumber)).next(()=>this.Zn.er(e, (e)=>n.Hn(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Zn.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Zn.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$Re)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $70fd6868680e912c$var$Re) : this.tr(e, t));
    }
    getCacheSize(e) {
        return this.Zn.getCacheSize(e);
    }
    tr(e, t) {
        let n, r, i, s, o, a, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, a = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) $70fd6868680e912c$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (a - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - a) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $70fd6868680e912c$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $70fd6868680e912c$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    Xn(e) {
        const t = this.nr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    nr(e) {
        let t = 0;
        return this.er(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    er(e, t) {
        return this.rr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ ir(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $70fd6868680e912c$var$__PRIVATE_mutationQueuesStore(e).Y((r)=>$70fd6868680e912c$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $70fd6868680e912c$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.rr(e, (s, o)=>{
            if (o <= t) {
                const t = this.ir(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $70fd6868680e912c$var$SnapshotVersion.min()), $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ rr(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e);
        let r, i = $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe;
        return n.J({
            index: "documentTargetsIndex"
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe && t(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe && t(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $70fd6868680e912c$var$__PRIVATE_writeSentinelKey(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $70fd6868680e912c$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.sr(e, n)));
    }
    getEntry(e, t) {
        let n = $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t);
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this._r(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ ar(e, t) {
        let n = {
            size: 0,
            document: $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t)
        };
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this._r(t, r),
                size: $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return this.ur(e, t, (e, t)=>{
            const r = this._r(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ cr(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), r = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        return this.ur(e, t, (e, t)=>{
            const i = this._r(e, t);
            n = n.insert(e, i), r = r.insert(e, $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                lr: r
            }));
    }
    ur(e, t, n) {
        if (t.isEmpty()) return $70fd6868680e912c$var$PersistencePromise.resolve();
        let r = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($70fd6868680e912c$var$__PRIVATE_dbKey(r.first()), $70fd6868680e912c$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: i
        }, (e, t, r)=>{
            const i = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $70fd6868680e912c$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.$($70fd6868680e912c$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).U(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            null == i || i.incrementDocumentReadCount(e.length);
            let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this._r($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($70fd6868680e912c$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        const s = $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(t, $70fd6868680e912c$var$IndexOffset.max());
        return $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e).J({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this._r($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e).get("remoteDocumentGlobalKey").next((e)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(!!e), e));
    }
    sr(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e).put("remoteDocumentGlobalKey", t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ _r(e, t) {
        if (t) {
            const e = $70fd6868680e912c$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($70fd6868680e912c$var$SnapshotVersion.min()))) return e;
        }
        return $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.hr = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Pr = new $70fd6868680e912c$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $70fd6868680e912c$var$SortedSet((e, t)=>$70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Pr.get(i);
            if (t.push(this.hr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(this.hr.serializer, s);
                r = r.add(i.path.popLast());
                const a = $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.hr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $70fd6868680e912c$var$__PRIVATE_toDbRemoteDocument(this.hr.serializer, s.convertToNoDocument($70fd6868680e912c$var$SnapshotVersion.min()));
                t.push(this.hr.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.hr.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.hr.updateMetadata(e, n)), $70fd6868680e912c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.hr.ar(e, t).next((e)=>(this.Pr.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.hr.cr(e, t).next(({ documents: e, lr: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Pr.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $70fd6868680e912c$var$__PRIVATE_documentGlobalStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteDocumentsStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $70fd6868680e912c$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $70fd6868680e912c$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $70fd6868680e912c$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $70fd6868680e912c$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $70fd6868680e912c$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $70fd6868680e912c$var$FieldMask.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $70fd6868680e912c$var$__PRIVATE_documentKeySet()) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $70fd6868680e912c$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $70fd6868680e912c$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        const s = $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $70fd6868680e912c$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $70fd6868680e912c$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>{
                var n;
                return o.set(e, new $70fd6868680e912c$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $70fd6868680e912c$var$SortedMap((e, t)=>e - t), i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $70fd6868680e912c$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $70fd6868680e912c$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $70fd6868680e912c$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $70fd6868680e912c$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $70fd6868680e912c$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $70fd6868680e912c$var$PersistencePromise.resolve($70fd6868680e912c$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, _ = i;
            return s.next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $70fd6868680e912c$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $70fd6868680e912c$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $70fd6868680e912c$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $70fd6868680e912c$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $70fd6868680e912c$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$70fd6868680e912c$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $70fd6868680e912c$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $70fd6868680e912c$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $70fd6868680e912c$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $70fd6868680e912c$var$FieldMask.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $70fd6868680e912c$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Tr = new Map, this.Ir = new Map;
    }
    getBundleMetadata(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Tr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Tr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $70fd6868680e912c$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Ir.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Ir.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $70fd6868680e912c$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $70fd6868680e912c$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator), this.Er = new Map;
    }
    getOverlay(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_newOverlayMap();
        return $70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.Tt(e, t, r);
        }), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Er.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Er.delete(n)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $70fd6868680e912c$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $70fd6868680e912c$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $70fd6868680e912c$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(o);
    }
    Tt(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Er.get(r.largestBatchId).delete(n.key);
            this.Er.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $70fd6868680e912c$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Er.get(t);
        void 0 === i && (i = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.Er.set(t, i)), this.Er.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $70fd6868680e912c$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.dr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.Ar), // A set of outstanding references to a document sorted by target id.
        this.Rr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.Vr);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.dr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, t);
        this.dr = this.dr.add(n), this.Rr = this.Rr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ mr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.gr(new $70fd6868680e912c$var$__PRIVATE_DocReference(e, t));
    }
    pr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ yr(e) {
        const t = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath([])), n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.Rr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.gr(e), i.push(e.key);
        }), i;
    }
    wr() {
        this.dr.forEach((e)=>this.gr(e));
    }
    gr(e) {
        this.dr = this.dr.delete(e), this.Rr = this.Rr.delete(e);
    }
    Sr(e) {
        const t = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ResourcePath([])), n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, e + 1);
        let i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        return this.Rr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, 0), n = this.dr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $70fd6868680e912c$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.br = t;
    }
    /** Compare by key then by ID */ static Ar(e, t) {
        return $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key) || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.br, t.br);
    }
    /** Compare by ID then by key */ static Vr(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(e.br, t.br) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Dr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.vr = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_DocReference.Ar);
    }
    checkEmpty(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Dr;
        this.Dr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $70fd6868680e912c$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.vr = this.vr.add(new $70fd6868680e912c$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $70fd6868680e912c$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.Cr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Fr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $70fd6868680e912c$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? -1 : this.Dr - 1);
    }
    getAllMutationBatches(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, 0), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.vr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Cr(e.br);
            i.push(t);
        }), $70fd6868680e912c$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, 0), r = new $70fd6868680e912c$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.vr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.br);
            });
        }), $70fd6868680e912c$var$PersistencePromise.resolve(this.Mr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $70fd6868680e912c$var$__PRIVATE_DocReference(new $70fd6868680e912c$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_primitiveComparator);
        return this.vr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.br)), !0);
        }, s), $70fd6868680e912c$var$PersistencePromise.resolve(this.Mr(o));
    }
    Mr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Cr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(0 === this.Or(t.batchId, "removed")), this.mutationQueue.shift();
        let n = this.vr;
        return $70fd6868680e912c$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $70fd6868680e912c$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.vr = n;
        });
    }
    Ln(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_DocReference(t, 0), r = this.vr.firstAfterOrEqual(n);
        return $70fd6868680e912c$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ Or(e, t) {
        return this.Fr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ Fr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Cr(e) {
        const t = this.Fr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.Nr = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.Nr(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $70fd6868680e912c$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $70fd6868680e912c$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $70fd6868680e912c$var$MutableDocument.newInvalidDocument(e));
        }), $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $70fd6868680e912c$export$afc2e57c475b7810(s.child("")), _ = this.docs.getIteratorFrom(o);
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $70fd6868680e912c$var$__PRIVATE_indexOffsetComparator($70fd6868680e912c$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $70fd6868680e912c$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $70fd6868680e912c$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $70fd6868680e912c$var$fail();
    }
    Lr(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $70fd6868680e912c$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.hr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.hr.addEntry(e, r)) : this.hr.removeEntry(n);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.hr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.hr.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.Br = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), $70fd6868680e912c$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $70fd6868680e912c$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.kr = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.qr = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.Qr = $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator.qn();
    }
    forEachTarget(e, t) {
        return this.Br.forEach((e, n)=>t(n)), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.kr);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.Qr.next(), $70fd6868680e912c$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.kr && (this.kr = t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    Un(e) {
        this.Br.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.Qr = new $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.kr && (this.kr = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Un(t), this.targetCount += 1, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Un(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.Br.delete(t.target), this.qr.yr(t.targetId), this.targetCount -= 1, $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.Br.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.Br.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.Br.get(t) || null;
        return $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.qr.mr(t, n), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.qr.pr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $70fd6868680e912c$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.qr.yr(t), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.qr.Sr(t);
        return $70fd6868680e912c$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.resolve(this.qr.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.Kr = {}, this.overlays = {}, this.$r = new $70fd6868680e912c$var$__PRIVATE_ListenSequence(0), this.Ur = !1, this.Ur = !0, this.Wr = new $70fd6868680e912c$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.Gr = new $70fd6868680e912c$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $70fd6868680e912c$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $70fd6868680e912c$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.zr(e)), this.serializer = new $70fd6868680e912c$var$__PRIVATE_LocalSerializer(t), this.jr = new $70fd6868680e912c$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.Ur = !1, Promise.resolve();
    }
    get started() {
        return this.Ur;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $70fd6868680e912c$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.Kr[e.toKey()];
        return n || (n = new $70fd6868680e912c$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.Kr[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.Wr;
    }
    getTargetCache() {
        return this.Gr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.jr;
    }
    runTransaction(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $70fd6868680e912c$var$__PRIVATE_MemoryTransaction(this.$r.next());
        return this.referenceDelegate.Hr(), n(r).next((e)=>this.referenceDelegate.Jr(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Yr(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.or(Object.values(this.Kr).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $70fd6868680e912c$var$__PRIVATE_MemoryTransaction extends $70fd6868680e912c$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Zr = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Xr = null;
    }
    static ei(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get ti() {
        if (this.Xr) return this.Xr;
        throw $70fd6868680e912c$var$fail();
    }
    addReference(e, t, n) {
        return this.Zr.addReference(n, t), this.ti.delete(n.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Zr.removeReference(n, t), this.ti.add(n.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.ti.add(t.toString()), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Zr.yr(t.targetId).forEach((e)=>this.ti.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.ti.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Hr() {
        this.Xr = new Set;
    }
    Jr(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.ti, (n)=>{
            const r = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(n);
            return this.ni(e, r).next((e)=>{
                e || t.removeEntry(r, $70fd6868680e912c$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Xr = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.ni(e, t).next((e)=>{
            e ? this.ti.delete(t.toString()) : this.ti.add(t.toString());
        });
    }
    zr(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    ni(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.or([
            ()=>$70fd6868680e912c$var$PersistencePromise.resolve(this.Zr.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Yr(e, t)
        ]);
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.ri = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $70fd6868680e912c$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static ei(e, t) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Hr() {}
    Jr(e) {
        return $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    Xn(e) {
        const t = this.nr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    nr(e) {
        let t = 0;
        return this.er(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    er(e, t) {
        return $70fd6868680e912c$var$PersistencePromise.forEach(this.ri, (n, r)=>this.ir(e, n, r).next((e)=>e ? $70fd6868680e912c$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.Lr(e, (r)=>this.ir(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $70fd6868680e912c$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.ri.set(t, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.ri.set(n, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.ri.set(n, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.ri.set(t, e.currentSequenceNumber), $70fd6868680e912c$var$PersistencePromise.resolve();
    }
    zr(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $70fd6868680e912c$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    ir(e, t, n) {
        return $70fd6868680e912c$var$PersistencePromise.or([
            ()=>this.persistence.Yr(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.ri.get(t);
                return $70fd6868680e912c$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $70fd6868680e912c$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ O(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore("owner");
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            e.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $70fd6868680e912c$var$M, {
                unique: !0
            }), e.createObjectStore("documentMutations");
        }(e), $70fd6868680e912c$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore("remoteDocuments");
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $70fd6868680e912c$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore("targetDocuments"), e.deleteObjectStore("targets"), e.deleteObjectStore("targetGlobal");
        }(e), $70fd6868680e912c$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $70fd6868680e912c$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put("targetGlobalKey", n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                return t.store("mutations").U().next((n)=>{
                    e.deleteObjectStore("mutations");
                    e.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $70fd6868680e912c$var$M, {
                        unique: !0
                    });
                    const r = t.store("mutations"), i = n.map((e)=>r.put(e));
                    return $70fd6868680e912c$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.ii(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore("remoteDocumentGlobal");
            })(e), this.si(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.oi(i))), n < 8 && r >= 8 && (s = s.next(()=>this._i(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.ai(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore("documentOverlays", {
                    keyPath: $70fd6868680e912c$var$G
                });
                t.createIndex("collectionPathOverlayIndex", $70fd6868680e912c$var$z, {
                    unique: !1
                }), t.createIndex("collectionGroupOverlayIndex", $70fd6868680e912c$var$j, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore("remoteDocumentsV14", {
                    keyPath: $70fd6868680e912c$var$O
                });
                t.createIndex("documentKeyIndex", $70fd6868680e912c$var$N), t.createIndex("collectionGroupIndex", $70fd6868680e912c$var$L);
            })(e)).next(()=>this.ui(e, i)).next(()=>e.deleteObjectStore("remoteDocuments"))), n < 14 && r >= 14 && (s = s.next(()=>this.ci(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                e.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                e.createObjectStore("indexState", {
                    keyPath: $70fd6868680e912c$var$K
                }).createIndex("sequenceNumberIndex", $70fd6868680e912c$var$$, {
                    unique: !1
                });
                e.createObjectStore("indexEntries", {
                    keyPath: $70fd6868680e912c$var$U
                }).createIndex("documentKeyIndex", $70fd6868680e912c$var$W, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore("indexState").clear();
        }).next(()=>{
            t.objectStore("indexEntries").clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore("globals", {
                    keyPath: "name"
                });
            }(e);
        })), s;
    }
    si(e) {
        let t = 0;
        return e.store("remoteDocuments").J((e, n)=>{
            t += $70fd6868680e912c$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    ii(e) {
        const t = e.store("mutationQueues"), n = e.store("mutations");
        return t.U().next((t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    -1
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.U("userMutationsIndex", r).next((n)=>$70fd6868680e912c$var$PersistencePromise.forEach(n, (n)=>{
                        $70fd6868680e912c$var$__PRIVATE_hardAssert(n.userId === t.userId);
                        const r = $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $70fd6868680e912c$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ oi(e) {
        const t = e.store("targetDocuments"), n = e.store("remoteDocuments");
        return e.store("targetGlobal").get("targetGlobalKey").next((e)=>{
            const r = [];
            return n.J((n, i)=>{
                const s = new $70fd6868680e912c$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $70fd6868680e912c$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r));
        });
    }
    _i(e, t) {
        // Create the index.
        e.createObjectStore("collectionParents", {
            keyPath: $70fd6868680e912c$var$Q
        });
        const n = t.store("collectionParents"), r = new $70fd6868680e912c$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $70fd6868680e912c$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store("remoteDocuments").J({
            H: !0
        }, (e, t)=>{
            const n = new $70fd6868680e912c$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store("documentMutations").J({
                H: !0
            }, ([e, t, n], r)=>{
                const i = $70fd6868680e912c$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    ai(e) {
        const t = e.store("targets");
        return t.J((e, n)=>{
            const r = $70fd6868680e912c$var$__PRIVATE_fromDbTarget(n), i = $70fd6868680e912c$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    ui(e, t) {
        const n = t.store("remoteDocuments"), r = [];
        return n.J((e, n)=>{
            const i = t.store("remoteDocumentsV14"), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $70fd6868680e912c$var$fail();
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(r));
    }
    ci(e, t) {
        const n = t.store("mutations"), r = $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence($70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate.ei, this.serializer.ht);
        return n.U().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                $70fd6868680e912c$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>r = r.add(e)), n.set(e.userId, r);
            }), $70fd6868680e912c$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $70fd6868680e912c$var$User(n), o = $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache.Pt(this.serializer, s), _ = i.getIndexManager(s), a = $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue.Pt(s, this.serializer, _, i.referenceDelegate);
                return new $70fd6868680e912c$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(t, $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe), e).next();
            });
        });
    }
}
function $70fd6868680e912c$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore("targetDocuments", {
        keyPath: $70fd6868680e912c$var$k
    }).createIndex("documentTargetsIndex", $70fd6868680e912c$var$q, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $70fd6868680e912c$var$B, {
        unique: !0
    }), e.createObjectStore("targetGlobal");
}
const $70fd6868680e912c$var$Ve = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 17){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.li = i, this.window = s, this.document = o, this.hi = a, this.Pi = u, this.Ti = c, this.$r = null, this.Ur = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Ii = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ei = null, /** The client metadata refresh task. */ this.di = null, /** The last time we garbage collected the client metadata object store. */ this.Ai = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Ri = (e)=>Promise.resolve(), !$70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence.p()) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $70fd6868680e912c$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Vi = t + "main", this.serializer = new $70fd6868680e912c$var$__PRIVATE_LocalSerializer(_), this.mi = new $70fd6868680e912c$var$__PRIVATE_SimpleDb(this.Vi, this.Ti, new $70fd6868680e912c$var$__PRIVATE_SchemaConverter(this.serializer)), this.Wr = new $70fd6868680e912c$var$__PRIVATE_IndexedDbGlobalsCache, this.Gr = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $70fd6868680e912c$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.jr = new $70fd6868680e912c$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.fi = this.window.localStorage : (this.fi = null, !1 === u && $70fd6868680e912c$var$__PRIVATE_logError("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.gi().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, $70fd6868680e912c$var$Ve);
            return this.pi(), this.yi(), this.wi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.Gr.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.$r = new $70fd6868680e912c$var$__PRIVATE_ListenSequence(e, this.hi);
        }).then(()=>{
            this.Ur = !0;
        }).catch((e)=>(this.mi && this.mi.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Si(e) {
        return this.Ri = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.mi.L(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.li.enqueueAndForget(async ()=>{
            this.started && await this.gi();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ gi() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.bi(e).next((e)=>{
                    e || (this.isPrimary = !1, this.li.enqueueRetryable(()=>this.Ri(!1)));
                });
            }).next(()=>this.Di(e)).next((t)=>this.isPrimary && !t ? this.vi(e).next(()=>!1) : !!t && this.Ci(e).next(()=>!0))).catch((e)=>{
            if ($70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbPersistence", "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.li.enqueueRetryable(()=>this.Ri(e)), this.isPrimary = e;
        });
    }
    bi(e) {
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>$70fd6868680e912c$var$PersistencePromise.resolve(this.Fi(e)));
    }
    Mi(e) {
        return $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async xi() {
        if (this.isPrimary && !this.Oi(this.Ai, 18e5)) {
            this.Ai = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_getStore(e, "clientMetadata");
                return t.U().next((e)=>{
                    const n = this.Ni(e, 18e5), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $70fd6868680e912c$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.fi) for (const t of e)this.fi.removeItem(this.Li(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ wi() {
        this.di = this.li.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.gi().then(()=>this.xi()).then(()=>this.wi()));
    }
    /** Checks whether `client` is the local client. */ Fi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Di(e) {
        if (this.Pi) return $70fd6868680e912c$var$PersistencePromise.resolve(!0);
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get("owner").next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.Oi(t.leaseTimestampMs, 5e3) && !this.Bi(t.ownerId)) {
                if (this.Fi(t) && this.networkEnabled) return !0;
                if (!this.Fi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, $70fd6868680e912c$var$Ve);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).U().next((e)=>void 0 === this.Ni(e, 5e3).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.Ur = !1, this.ki(), this.di && (this.di.cancel(), this.di = null), this.qi(), this.Qi(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.mi.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (e)=>{
            const t = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(e, $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe);
            return this.vi(t).next(()=>this.Mi(t));
        }), this.mi.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Ki();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ Ni(e, t) {
        return e.filter((e)=>this.Oi(e.updateTimeMs, t) && !this.Bi(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ $i() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e).U().next((e)=>this.Ni(e, 18e5).map((e)=>e.clientId)));
    }
    get started() {
        return this.Ur;
    }
    getGlobalsCache() {
        return this.Wr;
    }
    getMutationQueue(e, t) {
        return $70fd6868680e912c$var$__PRIVATE_IndexedDbMutationQueue.Pt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Gr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.ht.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $70fd6868680e912c$var$__PRIVATE_IndexedDbDocumentOverlayCache.Pt(this.serializer, e);
    }
    getBundleCache() {
        return this.jr;
    }
    runTransaction(e, t, n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbPersistence", "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 17 === e ? $70fd6868680e912c$var$te : 16 === e ? $70fd6868680e912c$var$ee : 15 === e ? $70fd6868680e912c$var$X : 14 === e ? $70fd6868680e912c$var$Z : 13 === e ? $70fd6868680e912c$var$Y : 12 === e ? $70fd6868680e912c$var$J : 11 === e ? $70fd6868680e912c$var$H : void $70fd6868680e912c$var$fail();
        }(this.Ti);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.mi.runTransaction(e, r, i, (r)=>(s = new $70fd6868680e912c$var$__PRIVATE_IndexedDbTransaction(r, this.$r ? this.$r.next() : $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe), "readwrite-primary" === t ? this.bi(s).next((e)=>!!e || this.Di(s)).next((t)=>{
                if (!t) throw $70fd6868680e912c$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.li.enqueueRetryable(()=>this.Ri(!1)), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, $70fd6868680e912c$var$C);
                return n(s);
            }).next((e)=>this.Ci(s).next(()=>e)) : this.Ui(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ui(e) {
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>{
            if (null !== e && this.Oi(e.leaseTimestampMs, 5e3) && !this.Bi(e.ownerId) && !this.Fi(e) && !(this.Pi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, $70fd6868680e912c$var$Ve);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Ci(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e).put("owner", t);
    }
    static p() {
        return $70fd6868680e912c$var$__PRIVATE_SimpleDb.p();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ vi(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e);
        return t.get("owner").next((e)=>this.Fi(e) ? ($70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing primary lease."), t.delete("owner")) : $70fd6868680e912c$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ Oi(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($70fd6868680e912c$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    pi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ei = ()=>{
            this.li.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.gi()));
        }, this.document.addEventListener("visibilitychange", this.Ei), this.inForeground = "visible" === this.document.visibilityState);
    }
    qi() {
        this.Ei && (this.document.removeEventListener("visibilitychange", this.Ei), this.Ei = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ yi() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.Ii = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.ki();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $c38e0f42709c826a$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.li.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.li.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Ii));
    }
    Qi() {
        this.Ii && (this.window.removeEventListener("pagehide", this.Ii), this.Ii = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Bi(e) {
        var t;
        try {
            const n = null !== (null === (t = this.fi) || void 0 === t ? void 0 : t.getItem(this.Li(e)));
            return $70fd6868680e912c$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $70fd6868680e912c$var$__PRIVATE_logError("IndexedDbPersistence", "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ ki() {
        if (this.fi) try {
            this.fi.setItem(this.Li(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $70fd6868680e912c$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ Ki() {
        if (this.fi) try {
            this.fi.removeItem(this.Li(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    Li(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $70fd6868680e912c$var$__PRIVATE_primaryClientStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $70fd6868680e912c$var$__PRIVATE_clientMetadataStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_getStore(e, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $70fd6868680e912c$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Wi = n, this.Gi = r;
    }
    static zi(e, t) {
        let n = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), r = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $70fd6868680e912c$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $70fd6868680e912c$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryEngine {
    constructor(){
        this.ji = !1, this.Hi = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Ji = 100, this.Yi = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $c38e0f42709c826a$export$95df08bae54cb4df)() ? 8 : $70fd6868680e912c$var$__PRIVATE_getAndroidVersion((0, $c38e0f42709c826a$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.Zi = e, this.indexManager = t, this.ji = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.Xi(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.es(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $70fd6868680e912c$var$QueryContext;
            return this.ts(e, t, n).next((r)=>{
                if (i.result = r, this.Hi) return this.ns(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    ns(e, t, n, r) {
        return n.documentReadCount < this.Ji ? ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Ji, "documents"), $70fd6868680e912c$var$PersistencePromise.resolve()) : ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Yi * r ? ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t))) : $70fd6868680e912c$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Xi(e, t) {
        if ($70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $70fd6868680e912c$var$PersistencePromise.resolve(null);
        let n = $70fd6868680e912c$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $70fd6868680e912c$var$__PRIVATE_documentKeySet(...r);
                return this.Zi.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.rs(t, r);
                        return this.ss(t, s, i, n.readTime) ? this.Xi(e, $70fd6868680e912c$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.os(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ es(e, t, n, r) {
        return $70fd6868680e912c$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? $70fd6868680e912c$var$PersistencePromise.resolve(null) : this.Zi.getDocuments(e, n).next((i)=>{
            const s = this.rs(t, i);
            return this.ss(t, s, n, r) ? $70fd6868680e912c$var$PersistencePromise.resolve(null) : ($70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t)), this.os(e, s, t, $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ rs(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $70fd6868680e912c$var$SortedSet($70fd6868680e912c$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $70fd6868680e912c$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ ss(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    ts(e, t, n) {
        return $70fd6868680e912c$var$__PRIVATE_getLogLevel() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $70fd6868680e912c$var$__PRIVATE_stringifyQuery(t)), this.Zi.getDocumentsMatchingQuery(e, t, $70fd6868680e912c$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ os(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Zi.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this._s = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.us = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.cs = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyTarget(e), $70fd6868680e912c$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.ls = new Map, this.hs = e.getRemoteDocumentCache(), this.Gr = e.getTargetCache(), this.jr = e.getBundleCache(), this.Ps(n);
    }
    Ps(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $70fd6868680e912c$var$LocalDocumentsView(this.hs, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.hs.setIndexManager(this.indexManager), this._s.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.us));
    }
}
function $70fd6868680e912c$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $70fd6868680e912c$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Ps(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Ts: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.hs.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $70fd6868680e912c$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $70fd6868680e912c$var$__PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.Gr.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.us;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.hs.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.us;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Gr.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.Gr.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, $70fd6868680e912c$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($70fd6868680e912c$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(a, u, s) && o.push(n.Gr.updateTargetData(e, u));
        });
        let _ = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), a = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Is, a = e.Es;
        })), !r.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) {
            const t = n.Gr.getLastRemoteSnapshotVersion(e).next((t)=>n.Gr.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $70fd6868680e912c$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.us = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), i = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $70fd6868680e912c$var$__PRIVATE_logDebug("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Is: r,
            Es: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.Gr.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $70fd6868680e912c$var$PersistencePromise.resolve(r)) : n.Gr.allocateTargetId(e).next((i)=>(r = new $70fd6868680e912c$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.Gr.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.us.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.us = n.us.insert(e.targetId, e), n.cs.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.us.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $70fd6868680e912c$var$__PRIVATE_logDebug("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.us = r.us.remove(t), r.cs.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let i = $70fd6868680e912c$var$SnapshotVersion.min(), s = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.cs.get(n);
            return void 0 !== i ? $70fd6868680e912c$var$PersistencePromise.resolve(r.us.get(i)) : r.Gr.getTargetData(t, n);
        })(r, e, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.Gr.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r._s.getDocumentsMatchingQuery(e, t, n ? i : $70fd6868680e912c$var$SnapshotVersion.min(), n ? s : $70fd6868680e912c$var$__PRIVATE_documentKeySet())).next((e)=>($70fd6868680e912c$var$__PRIVATE_setMaxReadTime(r, $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                ds: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_debugCast(n.Gr), i = n.us.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.ut(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.ls.get(t) || $70fd6868680e912c$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.hs.getAllFromCollectionGroup(e, t, $70fd6868680e912c$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($70fd6868680e912c$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.ls.get(t) || $70fd6868680e912c$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.ls.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $70fd6868680e912c$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let s = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), o = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.As(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.Rs(e);
        r.setReadTime(t.Vs(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.hs.newChangeBuffer({
        trackRemovals: !0
    }), a = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath($70fd6868680e912c$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$70fd6868680e912c$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.Gr.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.Gr.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Is, t.Es)).next(()=>t.Is)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $70fd6868680e912c$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $70fd6868680e912c$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e, $70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.jr.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.us = i.us.insert(o.targetId, o), i.Gr.updateTargetData(e, o).next(()=>i.Gr.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.Gr.addMatchingKeys(e, n, r.targetId)).next(()=>i.jr.saveNamedQuery(e, t));
    });
}
/** Assembles the key for a client state in WebStorage */ function $70fd6868680e912c$var$createWebStorageClientStateKey(e, t) {
    return `firestore_clients_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $70fd6868680e912c$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `firestore_mutations_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `firestore_targets_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static fs(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $70fd6868680e912c$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $70fd6868680e912c$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($70fd6868680e912c$var$__PRIVATE_logError("SharedClientState", `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    gs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static fs(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $70fd6868680e912c$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($70fd6868680e912c$var$__PRIVATE_logError("SharedClientState", `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    gs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $70fd6868680e912c$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static fs(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $70fd6868680e912c$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $70fd6868680e912c$var$__PRIVATE_RemoteClientState(e, i) : ($70fd6868680e912c$var$__PRIVATE_logError("SharedClientState", `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $70fd6868680e912c$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static fs(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $70fd6868680e912c$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($70fd6868680e912c$var$__PRIVATE_logError("SharedClientState", `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $70fd6868680e912c$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
    }
    ps(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    ys(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ gs() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.li = t, this.persistenceKey = n, this.ws = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.Ss = this.bs.bind(this), this.Ds = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.vs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Cs = $70fd6868680e912c$var$createWebStorageClientStateKey(this.persistenceKey, this.ws), this.Fs = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Ds = this.Ds.insert(this.ws, new $70fd6868680e912c$var$__PRIVATE_LocalClientState), this.Ms = new RegExp(`^firestore_clients_${s}_([^_]*)$`), this.xs = new RegExp(`^firestore_mutations_${s}_(\\d+)(?:_(.*))?$`), this.Os = new RegExp(`^firestore_targets_${s}_(\\d+)$`), this.Ns = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.Ls = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.Ss);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static p(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.$i();
        for (const t of e){
            if (t === this.ws) continue;
            const e = this.getItem($70fd6868680e912c$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $70fd6868680e912c$var$__PRIVATE_RemoteClientState.fs(t, e);
                n && (this.Ds = this.Ds.insert(n.clientId, n));
            }
        }
        this.Bs();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.Ns);
        if (t) {
            const e = this.ks(t);
            e && this.qs(e);
        }
        for (const e of this.vs)this.bs(e);
        this.vs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Fs, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.Qs(this.Ds);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Ds.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.Ks(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.Ks(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.$s(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata.fs(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.Us.ps(e), this.Bs(), n;
    }
    removeLocalQueryTarget(e) {
        this.Us.ys(e), this.Bs();
    }
    isLocalQueryTarget(e) {
        return this.Us.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.Ws(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.$s(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Gs(e);
    }
    notifyBundleLoaded(e) {
        this.zs(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.Ss), this.removeItem(this.Cs), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $70fd6868680e912c$var$__PRIVATE_logDebug("SharedClientState", "READ", e, t), t;
    }
    setItem(e, t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
    }
    bs(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($70fd6868680e912c$var$__PRIVATE_logDebug("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.Cs) return void $70fd6868680e912c$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.li.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.Ms.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.js(t.key);
                                return this.Hs(e, null);
                            }
                            {
                                const e = this.Js(t.key, t.newValue);
                                if (e) return this.Hs(e.clientId, e);
                            }
                        } else if (this.xs.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Ys(t.key, t.newValue);
                                if (e) return this.Zs(e);
                            }
                        } else if (this.Os.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Xs(t.key, t.newValue);
                                if (e) return this.eo(e);
                            }
                        } else if (t.key === this.Ns) {
                            if (null !== t.newValue) {
                                const e = this.ks(t.newValue);
                                if (e) return this.qs(e);
                            }
                        } else if (t.key === this.Fs) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $70fd6868680e912c$var$__PRIVATE_hardAssert("number" == typeof n), t = n;
                                } catch (e) {
                                    $70fd6868680e912c$var$__PRIVATE_logError("SharedClientState", "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe && this.sequenceNumberHandler(e);
                        } else if (t.key === this.Ls) {
                            const e = this.no(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.ro(e)));
                        }
                    }
                } else this.vs.push(t);
            });
        }
    }
    get Us() {
        return this.Ds.get(this.ws);
    }
    Bs() {
        this.setItem(this.Cs, this.Us.gs());
    }
    Ks(e, t, n) {
        const r = new $70fd6868680e912c$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $70fd6868680e912c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.gs());
    }
    $s(e) {
        const t = $70fd6868680e912c$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Gs(e) {
        const t = {
            clientId: this.ws,
            onlineState: e
        };
        this.storage.setItem(this.Ns, JSON.stringify(t));
    }
    Ws(e, t, n) {
        const r = $70fd6868680e912c$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.gs());
    }
    zs(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.Ls, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ js(e) {
        const t = this.Ms.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Js(e, t) {
        const n = this.js(e);
        return $70fd6868680e912c$var$__PRIVATE_RemoteClientState.fs(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ys(e, t) {
        const n = this.xs.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $70fd6868680e912c$var$__PRIVATE_MutationMetadata.fs(new $70fd6868680e912c$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Xs(e, t) {
        const n = this.Os.exec(e), r = Number(n[1]);
        return $70fd6868680e912c$var$__PRIVATE_QueryTargetMetadata.fs(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ ks(e) {
        return $70fd6868680e912c$var$__PRIVATE_SharedOnlineState.fs(e);
    }
    no(e) {
        return JSON.parse(e);
    }
    async Zs(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.io(e.batchId, e.state, e.error);
        $70fd6868680e912c$var$__PRIVATE_logDebug("SharedClientState", `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    eo(e) {
        return this.syncEngine.so(e.targetId, e.state, e.error);
    }
    Hs(e, t) {
        const n = t ? this.Ds.insert(e, t) : this.Ds.remove(e), r = this.Qs(this.Ds), i = this.Qs(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.oo(s, o).then(()=>{
            this.Ds = n;
        });
    }
    qs(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Ds.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    Qs(e) {
        let t = $70fd6868680e912c$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this._o = new $70fd6868680e912c$var$__PRIVATE_LocalClientState, this.ao = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this._o.ps(e), this.ao[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.ao[e] = t;
    }
    removeLocalQueryTarget(e) {
        this._o.ys(e);
    }
    isLocalQueryTarget(e) {
        return this._o.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.ao[e];
    }
    getAllActiveQueryTargets() {
        return this._o.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this._o.activeTargetIds.has(e);
    }
    start() {
        return this._o = new $70fd6868680e912c$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_NoopConnectivityMonitor {
    uo(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.co = ()=>this.lo(), this.ho = ()=>this.Po(), this.To = [], this.Io();
    }
    uo(e) {
        this.To.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.co), window.removeEventListener("offline", this.ho);
    }
    Io() {
        window.addEventListener("online", this.co), window.addEventListener("offline", this.ho);
    }
    lo() {
        $70fd6868680e912c$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const e of this.To)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    Po() {
        $70fd6868680e912c$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const e of this.To)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static p() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $70fd6868680e912c$var$me = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId() {
    return null === $70fd6868680e912c$var$me ? $70fd6868680e912c$var$me = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $70fd6868680e912c$var$me++, "0x" + $70fd6868680e912c$var$me.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$fe = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $70fd6868680e912c$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Eo = e.Eo, this.Ao = e.Ao;
    }
    Ro(e) {
        this.Vo = e;
    }
    mo(e) {
        this.fo = e;
    }
    po(e) {
        this.yo = e;
    }
    onMessage(e) {
        this.wo = e;
    }
    close() {
        this.Ao();
    }
    send(e) {
        this.Eo(e);
    }
    So() {
        this.Vo();
    }
    bo() {
        this.fo();
    }
    Do(e) {
        this.yo(e);
    }
    vo(e) {
        this.wo(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$ge = "WebChannelConnection";
class $70fd6868680e912c$var$__PRIVATE_WebChannelConnection extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class __PRIVATE_RestConnection {
    get Co() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Fo = t + "://" + e.host, this.Mo = `projects/${n}/databases/${r}`, this.xo = "(default)" === this.databaseId.database ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Oo(e, t, n, r, i) {
        const s = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId(), o = this.No(e, t.toUriEncodedString());
        $70fd6868680e912c$var$__PRIVATE_logDebug("RestConnection", `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Mo,
            "x-goog-request-params": this.xo
        };
        return this.Lo(_, r, i), this.Bo(e, o, _, n).then((t)=>($70fd6868680e912c$var$__PRIVATE_logDebug("RestConnection", `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $70fd6868680e912c$export$86cd73f49cc6e0bb("RestConnection", `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    ko(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Oo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Lo(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $70fd6868680e912c$var$S;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    No(e, t) {
        const n = $70fd6868680e912c$var$fe[e];
        return `${this.Fo}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
} {
    constructor(e){
        super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    Bo(e, t, n, r) {
        const i = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((s, o)=>{
            const _ = new (0, $33cb313d667e3306$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $33cb313d667e3306$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), s(t);
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' ${i} timed out`), o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' ${i} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = null == e ? void 0 : e.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($70fd6868680e912c$var$D).indexOf(t) >= 0 ? t : $70fd6868680e912c$var$D.UNKNOWN;
                                    }(t.status);
                                    o(new $70fd6868680e912c$export$8fada0bf726bf278(e, t.message));
                                } else o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $70fd6868680e912c$var$fail();
                    }
                } finally{
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' ${i} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' ${i} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    qo(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.Fo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $33cb313d667e3306$export$66869136fc133c3a)(), o = (0, $33cb313d667e3306$export$888d0d9ab79d08fc)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), this.Lo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $70fd6868680e912c$var$__PRIVATE_StreamBridge({
            Eo: (t)=>{
                h ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            Ao: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            h || ($70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} transport opened.`), P.So());
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            h || (h = !0, $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} transport closed`), P.Do());
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            h || (h = !0, $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} transport errored:`, t), P.Do(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            var n;
            if (!h) {
                const i = t.data[0];
                $70fd6868680e912c$var$__PRIVATE_hardAssert(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = (null == s ? void 0 : s.error) || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $70fd6868680e912c$var$le[e];
                        if (void 0 !== t) return $70fd6868680e912c$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = $70fd6868680e912c$var$D.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), // Mark closed so no further events are propagated
                    h = !0, P.Do(new $70fd6868680e912c$export$8fada0bf726bf278(n, i)), c.close();
                } else $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} received:`, i), P.vo(i);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $33cb313d667e3306$export$d61e24a684f9e51).STAT_EVENT, (t)=>{
            t.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).PROXY ? $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).NOPROXY && $70fd6868680e912c$var$__PRIVATE_logDebug($70fd6868680e912c$var$ge, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.bo();
        }, 0), P;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $70fd6868680e912c$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $70fd6868680e912c$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_newSerializer(e) {
    return new $70fd6868680e912c$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.li = e, this.timerId = t, this.Qo = n, this.Ko = r, this.$o = i, this.Uo = 0, this.Wo = null, /** The last backoff attempt, as epoch milliseconds. */ this.Go = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.Uo = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ zo() {
        this.Uo = this.$o;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ jo(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.Uo + this.Ho()), n = Math.max(0, Date.now() - this.Go), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $70fd6868680e912c$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.Uo} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.Wo = this.li.enqueueAfterDelay(this.timerId, r, ()=>(this.Go = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.Uo *= this.Ko, this.Uo < this.Qo && (this.Uo = this.Qo), this.Uo > this.$o && (this.Uo = this.$o);
    }
    Jo() {
        null !== this.Wo && (this.Wo.skipDelay(), this.Wo = null);
    }
    cancel() {
        null !== this.Wo && (this.Wo.cancel(), this.Wo = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ Ho() {
        return (Math.random() - .5) * this.Uo;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.li = e, this.Yo = n, this.Zo = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Xo = 0, this.e_ = null, this.t_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.n_ = 0, this.r_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ i_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.s_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ s_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.n_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.o_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.i_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ __() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.r_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ a_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.s_() && null === this.e_ && (this.e_ = this.li.enqueueAfterDelay(this.Yo, 6e4, ()=>this.u_()));
    }
    /** Sends a message to the underlying stream. */ c_(e) {
        this.l_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async u_() {
        if (this.s_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ l_() {
        this.e_ && (this.e_.cancel(), this.e_ = null);
    }
    /** Cancels the health check delayed operation. */ h_() {
        this.t_ && (this.t_.cancel(), this.t_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.l_(), this.h_(), this.r_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Xo++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.r_.reset() : t && t.code === $70fd6868680e912c$var$D.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($70fd6868680e912c$var$__PRIVATE_logError(t.toString()), $70fd6868680e912c$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.r_.zo()) : t && t.code === $70fd6868680e912c$var$D.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.P_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.po(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ P_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.T_(this.Xo), t = this.Xo;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Xo === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.I_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.E_(e);
            });
        });
    }
    I_(e, t) {
        const n = this.T_(this.Xo);
        this.stream = this.d_(e, t), this.stream.Ro(()=>{
            n(()=>this.listener.Ro());
        }), this.stream.mo(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.t_ = this.li.enqueueAfterDelay(this.Zo, 1e4, ()=>(this.s_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.mo()));
        }), this.stream.po((e)=>{
            n(()=>this.E_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.n_ ? this.A_(e) : this.onNext(e));
        });
    }
    o_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.r_.jo(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    E_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $70fd6868680e912c$var$__PRIVATE_logDebug("PersistentStream", `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ T_(e) {
        return (t)=>{
            this.li.enqueueAndForget(()=>this.Xo === e ? t() : ($70fd6868680e912c$var$__PRIVATE_logDebug("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentListenStream extends $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    d_(e, t) {
        return this.connection.qo("Listen", e, t);
    }
    A_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.r_.reset();
        const t = $70fd6868680e912c$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $70fd6868680e912c$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $70fd6868680e912c$var$SnapshotVersion.min() : t.readTime ? $70fd6868680e912c$var$__PRIVATE_fromVersion(t.readTime) : $70fd6868680e912c$var$SnapshotVersion.min();
        }(e);
        return this.listener.R_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ V_(e) {
        const t = {};
        t.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $70fd6868680e912c$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $70fd6868680e912c$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $70fd6868680e912c$var$__PRIVATE_toQueryTarget(e, r).ct
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $70fd6868680e912c$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($70fd6868680e912c$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $70fd6868680e912c$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $70fd6868680e912c$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $70fd6868680e912c$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.c_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ m_(e) {
        const t = {};
        t.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.c_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $70fd6868680e912c$var$__PRIVATE_PersistentWriteStream extends $70fd6868680e912c$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get f_() {
        return this.n_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    P_() {
        this.f_ && this.g_([]);
    }
    d_(e, t) {
        return this.connection.qo("Write", e, t);
    }
    A_(e) {
        // Always capture the last stream token.
        return $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.listener.p_();
    }
    onNext(e) {
        // Always capture the last stream token.
        $70fd6868680e912c$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.r_.reset();
        const t = $70fd6868680e912c$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $70fd6868680e912c$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.y_(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ w_() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $70fd6868680e912c$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.c_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ g_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$70fd6868680e912c$var$toMutation(this.serializer, e))
        };
        this.c_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $70fd6868680e912c$var$__PRIVATE_DatastoreImpl extends class Datastore {
} {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.S_ = !1;
    }
    b_() {
        if (this.S_) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Oo(e, t, n, r) {
        return this.b_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Oo(e, $70fd6868680e912c$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $70fd6868680e912c$var$D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ ko(e, t, n, r, i) {
        return this.b_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.ko(e, $70fd6868680e912c$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $70fd6868680e912c$var$D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.S_ = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $70fd6868680e912c$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.D_ = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.v_ = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.C_ = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ F_() {
        0 === this.D_ && (this.M_("Unknown" /* OnlineState.Unknown */ ), this.v_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.v_ = null, this.x_("Backend didn't respond within 10 seconds."), this.M_("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ O_(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.M_("Unknown" /* OnlineState.Unknown */ ) : (this.D_++, this.D_ >= 1 && (this.N_(), this.x_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.M_("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.N_(), this.D_ = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.C_ = !1), this.M_(e);
    }
    M_(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    x_(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.C_ ? ($70fd6868680e912c$var$__PRIVATE_logError(t), this.C_ = !1) : $70fd6868680e912c$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    N_() {
        null !== this.v_ && (this.v_.cancel(), this.v_ = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.L_ = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.B_ = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.k_ = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.q_ = [], this.Q_ = i, this.Q_.uo((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $70fd6868680e912c$var$__PRIVATE_canUseNetwork(this) && ($70fd6868680e912c$var$__PRIVATE_logDebug("RemoteStore", "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                    t.k_.add(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), t.K_.set("Unknown" /* OnlineState.Unknown */ ), t.k_.delete(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.K_ = new $70fd6868680e912c$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(e) {
    if ($70fd6868680e912c$var$__PRIVATE_canUseNetwork(e)) for (const t of e.q_)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.q_)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    n.B_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.B_.set(t.targetId, t), $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $70fd6868680e912c$var$__PRIVATE_startWatchStream(n) : $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(n).s_() && $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(n);
    n.B_.delete(t), r.s_() && $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.B_.size && (r.s_() ? r.a_() : $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.K_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.U_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($70fd6868680e912c$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).V_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.U_.xe(t), $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).m_(t);
}
function $70fd6868680e912c$var$__PRIVATE_startWatchStream(e) {
    e.U_ = new $70fd6868680e912c$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        ut: (t)=>e.B_.get(t) || null,
        nt: ()=>e.datastore.serializer.databaseId
    }), $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).start(), e.K_.F_();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && !$70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e).i_() && e.B_.size > 0;
}
function $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $70fd6868680e912c$var$__PRIVATE_debugCast(e).k_.size;
}
function $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.U_ = void 0;
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.K_.set("Online" /* OnlineState.Online */ );
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamOpen(e) {
    e.B_.forEach((t, n)=>{
        $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamClose(e, t) {
    $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) ? (e.K_.O_(t), $70fd6868680e912c$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.K_.set("Unknown" /* OnlineState.Unknown */ );
}
async function $70fd6868680e912c$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.K_.set("Online" /* OnlineState.Online */ ), t instanceof $70fd6868680e912c$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.B_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.B_.delete(r), e.U_.removeTarget(r));
        }(e, t);
    } catch (n) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $70fd6868680e912c$var$__PRIVATE_DocumentWatchChange ? e.U_.$e(t) : t instanceof $70fd6868680e912c$var$__PRIVATE_ExistenceFilterChange ? e.U_.Je(t) : e.U_.Ge(t), !n.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) try {
        const t = await $70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.U_.it(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.B_.get(r);
                    // A watched target might have been removed already.
                    i && e.B_.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.B_.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.B_.set(t, r.withResumeToken($70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $70fd6868680e912c$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $70fd6868680e912c$var$TargetData(r.target, t, n, r.sequenceNumber);
                $70fd6868680e912c$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t), await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.k_.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(e), e.K_.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$70fd6868680e912c$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $70fd6868680e912c$var$__PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access"), await n(), e.k_.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e), n = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(t);
    let r = t.L_.length > 0 ? t.L_[t.L_.length - 1].batchId : -1;
    for(; $70fd6868680e912c$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.L_.length && n.a_();
            break;
        }
        r = e.batchId, $70fd6868680e912c$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(t) && $70fd6868680e912c$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $70fd6868680e912c$var$__PRIVATE_canAddToWritePipeline(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && e.L_.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $70fd6868680e912c$var$__PRIVATE_addToWritePipeline(e, t) {
    e.L_.push(t);
    const n = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e);
    n.s_() && n.f_ && n.g_(t.mutations);
}
function $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(e) {
    return $70fd6868680e912c$var$__PRIVATE_canUseNetwork(e) && !$70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).i_() && e.L_.length > 0;
}
function $70fd6868680e912c$var$__PRIVATE_startWriteStream(e) {
    $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteStreamOpen(e) {
    $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).w_();
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.L_)t.g_(n.mutations);
}
async function $70fd6868680e912c$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.L_.shift(), i = $70fd6868680e912c$var$MutationBatchResult.from(r, t, n);
    await $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e);
}
async function $70fd6868680e912c$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).f_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $70fd6868680e912c$var$__PRIVATE_isPermanentError(e) && e !== $70fd6868680e912c$var$D.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.L_.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e).__(), await $70fd6868680e912c$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $70fd6868680e912c$var$__PRIVATE_shouldStartWriteStream(e) && $70fd6868680e912c$var$__PRIVATE_startWriteStream(e);
}
async function $70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
    const r = $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.k_.add(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.K_.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.k_.delete(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    t ? (n.k_.delete(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.k_.add(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(n), n.K_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$__PRIVATE_ensureWatchStream(e) {
    return e.W_ || // Create stream (but note that it is not started yet).
    (e.W_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        return r.b_(), new $70fd6868680e912c$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Ro: $70fd6868680e912c$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        mo: $70fd6868680e912c$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        po: $70fd6868680e912c$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        R_: $70fd6868680e912c$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.q_.push(async (t)=>{
        t ? (e.W_.__(), $70fd6868680e912c$var$__PRIVATE_shouldStartWatchStream(e) ? $70fd6868680e912c$var$__PRIVATE_startWatchStream(e) : e.K_.set("Unknown" /* OnlineState.Unknown */ )) : (await e.W_.stop(), $70fd6868680e912c$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.W_;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$__PRIVATE_ensureWriteStream(e) {
    return e.G_ || // Create stream (but note that it is not started yet).
    (e.G_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        return r.b_(), new $70fd6868680e912c$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Ro: ()=>Promise.resolve(),
        mo: $70fd6868680e912c$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        po: $70fd6868680e912c$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        p_: $70fd6868680e912c$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        y_: $70fd6868680e912c$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.q_.push(async (t)=>{
        t ? (e.G_.__(), // This will start the write stream if necessary.
        await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(e)) : (await e.G_.stop(), e.L_.length > 0 && ($70fd6868680e912c$var$__PRIVATE_logDebug("RemoteStore", `Stopping write stream with ${e.L_.length} pending writes`), e.L_ = []));
    })), e.G_;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $70fd6868680e912c$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $70fd6868680e912c$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $70fd6868680e912c$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($70fd6868680e912c$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $70fd6868680e912c$var$DocumentSet {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $70fd6868680e912c$var$DocumentSet(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $70fd6868680e912c$var$documentMap(), this.sortedSet = new $70fd6868680e912c$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $70fd6868680e912c$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $70fd6868680e912c$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.z_ = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.z_.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.z_ = this.z_.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.z_ = this.z_.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.z_ = this.z_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.z_ = this.z_.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.z_ = this.z_.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.z_ = this.z_.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.z_ = this.z_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $70fd6868680e912c$var$fail() : this.z_ = this.z_.insert(t, e);
    }
    j_() {
        const e = [];
        return this.z_.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $70fd6868680e912c$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $70fd6868680e912c$var$ViewSnapshot(e, t, $70fd6868680e912c$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $70fd6868680e912c$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.H_ = void 0, this.J_ = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    Y_() {
        return this.J_.some((e)=>e.Z_());
    }
}
class $70fd6868680e912c$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.X_ = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.J_)e.onError(t);
            });
        }(this, new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.ABORTED, "Firestore shutting down"));
    }
}
function $70fd6868680e912c$var$__PRIVATE_newQueriesObjectMap() {
    return new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyQuery(e), $70fd6868680e912c$var$__PRIVATE_queryEquals);
}
async function $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.Y_() && t.Z_() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $70fd6868680e912c$var$__PRIVATE_QueryListenersInfo, r = t.Z_() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.H_ = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.H_ = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$70fd6868680e912c$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.J_.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.ea(n.onlineState), s.H_) t.ta(s.H_) && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.J_.indexOf(t);
        e >= 0 && (s.J_.splice(e, 1), 0 === s.J_.length ? i = t.Z_() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.Y_() && t.Z_() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.J_)t.ta(e) && (r = !0);
            i.H_ = e;
        }
    }
    r && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.J_)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.X_.forEach((e)=>{
        e.next();
    });
}
var $70fd6868680e912c$var$pe, $70fd6868680e912c$var$ye;
/** Listen to both cache and server changes */ ($70fd6868680e912c$var$ye = $70fd6868680e912c$var$pe || ($70fd6868680e912c$var$pe = {})).na = "default", /** Listen to changes in cache only */ $70fd6868680e912c$var$ye.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.ra = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.ia = !1, this.sa = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ ta(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $70fd6868680e912c$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.ia ? this.oa(e) && (this.ra.next(e), t = !0) : this._a(e, this.onlineState) && (this.aa(e), t = !0), this.sa = e, t;
    }
    onError(e) {
        this.ra.error(e);
    }
    /** Returns whether a snapshot was raised. */ ea(e) {
        this.onlineState = e;
        let t = !1;
        return this.sa && !this.ia && this._a(this.sa, e) && (this.aa(this.sa), t = !0), t;
    }
    _a(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.Z_()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.ua || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    oa(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.sa && this.sa.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    aa(e) {
        e = $70fd6868680e912c$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.ia = !0, this.ra.next(e);
    }
    Z_() {
        return this.options.source !== $70fd6868680e912c$var$pe.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $70fd6868680e912c$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.ca = e, this.byteLength = t;
    }
    la() {
        return "metadata" in this.ca;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    As(e) {
        return $70fd6868680e912c$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ Rs(e) {
        return e.metadata.exists ? $70fd6868680e912c$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $70fd6868680e912c$var$MutableDocument.newNoDocument(this.As(e.metadata.name), this.Vs(e.metadata.readTime));
    }
    Vs(e) {
        return $70fd6868680e912c$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleLoader {
    constructor(e, t, n){
        this.ha = e, this.localStore = t, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Pa(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.ca.namedQuery) this.queries.push(e.ca.namedQuery);
        else if (e.ca.documentMetadata) {
            this.documents.push({
                metadata: e.ca.documentMetadata
            }), e.ca.documentMetadata.exists || ++t;
            const n = $70fd6868680e912c$var$ResourcePath.fromString(e.ca.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.ca.document && (this.documents[this.documents.length - 1].document = e.ca.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
    }
    Ta(e) {
        const t = new Map, n = new $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.As(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $70fd6868680e912c$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreApplyBundledDocuments(this.localStore, new $70fd6868680e912c$var$__PRIVATE_BundleConverterImpl(this.serializer), this.documents, this.ha.id), t = this.Ta(this.documents);
        for (const e of this.queries)await $70fd6868680e912c$var$__PRIVATE_localStoreSaveNamedQuery(this.localStore, e, t.get(e.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ia: this.collectionGroups,
            Ea: e
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $70fd6868680e912c$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.da = t, this.Aa = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Ra = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.Va = $70fd6868680e912c$var$__PRIVATE_newQueryComparator(e), this.ma = new $70fd6868680e912c$var$DocumentSet(this.Va);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get fa() {
        return this.da;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ga(e, t) {
        const n = t ? t.pa : new $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet, r = t ? t.ma : this.ma;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $70fd6868680e912c$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.ya(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.Va(c, _) > 0 || a && this.Va(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            ma: s,
            pa: n,
            ss: o,
            mutatedKeys: i
        };
    }
    ya(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.ma;
        this.ma = e.ma, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.pa.j_();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $70fd6868680e912c$var$fail();
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Va(e.doc, t.doc)), this.wa(n), r = null != r && r;
        const o = t && !r ? this.Sa() : [], _ = 0 === this.Ra.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.Aa;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Aa = _, 0 !== s.length || a) return {
            snapshot: new $70fd6868680e912c$var$ViewSnapshot(this.query, e.ma, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            ba: o
        };
        // no changes
        return {
            ba: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ ea(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            ma: this.ma,
            pa: new $70fd6868680e912c$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            ss: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            ba: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ Da(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.da.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.ma.has(e) && !this.ma.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ wa(e) {
        e && (e.addedDocuments.forEach((e)=>this.da = this.da.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.da = this.da.delete(e)), this.current = e.current);
    }
    Sa() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Ra;
        this.Ra = $70fd6868680e912c$var$__PRIVATE_documentKeySet(), this.ma.forEach((e)=>{
            this.Da(e.key) && (this.Ra = this.Ra.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Ra.has(e) || t.push(new $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Ra.forEach((n)=>{
            e.has(n) || t.push(new $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    va(e) {
        this.da = e.ds, this.Ra = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        const t = this.ga(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Ca() {
        return $70fd6868680e912c$var$ViewSnapshot.fromInitialDocuments(this.query, this.ma, this.mutatedKeys, 0 /* SyncState.Local */  === this.Aa, this.hasCachedResults);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $70fd6868680e912c$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $70fd6868680e912c$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Fa = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Ma = {}, this.xa = new $70fd6868680e912c$var$ObjectMap((e)=>$70fd6868680e912c$var$__PRIVATE_canonifyQuery(e), $70fd6868680e912c$var$__PRIVATE_queryEquals), this.Oa = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Na = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.La = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Ba = new Map, this.ka = new $70fd6868680e912c$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.qa = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Qa = new Map, this.Ka = $70fd6868680e912c$var$__PRIVATE_TargetIdGenerator.Qn(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.$a = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.$a;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.xa.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.Ca()) : i = await $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    await $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $70fd6868680e912c$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $70fd6868680e912c$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.Ua = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ga(n);
            i.ss && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ga(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.ba), _.snapshot;
        })(e, t, n, r);
    const s = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $70fd6868680e912c$var$__PRIVATE_View(t, s.ds), _ = o.ga(s.documents), a = $70fd6868680e912c$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, n, u.ba);
    const c = new $70fd6868680e912c$var$__PRIVATE_QueryView(t, n, o);
    return e.xa.set(t, c), e.Oa.has(n) ? e.Oa.get(n).push(t) : e.Oa.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = r.xa.get(t), s = r.Oa.get(i.targetId);
    if (s.length > 1) return r.Oa.set(i.targetId, s.filter((e)=>!$70fd6868680e912c$var$__PRIVATE_queryEquals(e, t))), void r.xa.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.xa.get(t), i = n.Oa.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $70fd6868680e912c$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $70fd6868680e912c$var$__PRIVATE_mutableDocumentMap(), a = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
                return n.hs.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $70fd6868680e912c$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e.key, t, $70fd6868680e912c$var$__PRIVATE_extractFieldMask(t.value.mapValue), $70fd6868680e912c$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $70fd6868680e912c$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.qa[e.currentUser.toKey()];
            r || (r = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.qa[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Ba.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($70fd6868680e912c$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.Fa = !0 : e.modifiedDocuments.size > 0 ? $70fd6868680e912c$var$__PRIVATE_hardAssert(r.Fa) : e.removedDocuments.size > 0 && ($70fd6868680e912c$var$__PRIVATE_hardAssert(r.Fa), r.Fa = !1));
        }), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.xa.forEach((n, r)=>{
            const i = r.view.ea(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.J_)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.ea(t) && (r = !0);
            }), r && $70fd6868680e912c$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Ma.R_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Ba.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $70fd6868680e912c$var$MutableDocument.newNoDocument(s, $70fd6868680e912c$var$SnapshotVersion.min()));
        const n = $70fd6868680e912c$var$__PRIVATE_documentKeySet().add(s), i = new $70fd6868680e912c$var$RemoteEvent($70fd6868680e912c$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$var$__PRIVATE_primitiveComparator), e, n);
        await $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.La = r.La.remove(s), r.Ba.delete(t), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $70fd6868680e912c$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($70fd6868680e912c$var$__PRIVATE_hardAssert(null !== t), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $70fd6868680e912c$var$__PRIVATE_processUserCallback(r, t, n), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    $70fd6868680e912c$var$__PRIVATE_canUseNetwork(n.remoteStore) || $70fd6868680e912c$var$__PRIVATE_logDebug("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (-1 === e) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.Qa.get(e) || [];
        r.push(t), n.Qa.set(e, r);
    } catch (e) {
        const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Qa.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.Qa.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $70fd6868680e912c$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    let i = r.qa[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.qa[r.currentUser.toKey()] = i;
    }
}
function $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Oa.get(t))e.xa.delete(r), n && e.Ma.Wa(r, n);
    if (e.Oa.delete(t), e.isPrimaryClient) e.ka.yr(t).forEach((t)=>{
        e.ka.containsKey(t) || // We removed the last reference for this key
        $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Na.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.La.get(t);
    null !== n && ($70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.La = e.La.remove(t), e.Ba.delete(n), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $70fd6868680e912c$var$__PRIVATE_AddedLimboDocument) e.ka.addReference(r.key, t), $70fd6868680e912c$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $70fd6868680e912c$var$__PRIVATE_RemovedLimboDocument) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SyncEngine", "Document no longer in limbo: " + r.key), e.ka.removeReference(r.key, t);
        e.ka.containsKey(r.key) || // We removed the last reference for this key
        $70fd6868680e912c$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.La.get(n) || e.Na.has(r) || ($70fd6868680e912c$var$__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n), e.Na.add(r), $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $70fd6868680e912c$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Na.size > 0 && e.La.size < e.maxConcurrentLimboResolutions;){
        const t = e.Na.values().next().value;
        e.Na.delete(t);
        const n = new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ResourcePath.fromString(t)), r = e.Ka.next();
        e.Ba.set(r, new $70fd6868680e912c$var$LimboResolution(n)), e.La = e.La.insert(n, r), $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $70fd6868680e912c$var$TargetData($70fd6868680e912c$var$__PRIVATE_queryToTarget($70fd6868680e912c$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $70fd6868680e912c$var$__PRIVATE_ListenSequence.oe));
    }
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.xa.isEmpty() || (r.xa.forEach((e, _)=>{
        o.push(r.Ua(_, t, n).then((e)=>{
            var t;
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const i = e ? !e.fromCache : null === (t = null == n ? void 0 : n.targetChanges.get(_.targetId)) || void 0 === t ? void 0 : t.current;
                r.sharedClientState.updateQueryState(_.targetId, i ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $70fd6868680e912c$var$__PRIVATE_LocalViewChanges.zi(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Ma.R_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$70fd6868680e912c$var$PersistencePromise.forEach(t, (t)=>$70fd6868680e912c$var$PersistencePromise.forEach(t.Wi, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$70fd6868680e912c$var$PersistencePromise.forEach(t.Gi, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $70fd6868680e912c$var$__PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.us.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.us = n.us.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $70fd6868680e912c$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $70fd6868680e912c$var$__PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
        const e = await $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.Qa.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.CANCELLED, t));
                });
            }), e.Qa.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Ts);
    }
}
function $70fd6868680e912c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.Ba.get(t);
    if (r && r.Fa) return $70fd6868680e912c$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $70fd6868680e912c$var$__PRIVATE_documentKeySet();
        const r = n.Oa.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.xa.get(t);
            e = e.unionWith(r.view.fa);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $70fd6868680e912c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.va(r);
    return n.isPrimaryClient && $70fd6868680e912c$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.ba), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.On(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $70fd6868680e912c$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($70fd6868680e912c$var$__PRIVATE_processUserCallback(i, t, r || null), $70fd6868680e912c$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $70fd6868680e912c$var$__PRIVATE_debugCast($70fd6868680e912c$var$__PRIVATE_debugCast(e).mutationQueue).Ln(t);
    }(i.localStore, t)) : $70fd6868680e912c$var$fail(), await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $70fd6868680e912c$var$__PRIVATE_logDebug("SyncEngine", "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if ($70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(n), $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.$a) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.$a = !0, await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$70fd6868680e912c$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.$a) {
        const e = [];
        let t = Promise.resolve();
        n.Oa.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(n, i), $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            t.Ba.forEach((e, n)=>{
                $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.ka.wr(), t.Ba = new Map, t.La = new $70fd6868680e912c$var$SortedMap($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(n), n.$a = !1, await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $70fd6868680e912c$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Oa.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $70fd6868680e912c$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.xa.get(e), n = await $70fd6868680e912c$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Ma.R_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $70fd6868680e912c$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $70fd6868680e912c$var$__PRIVATE_debugCast($70fd6868680e912c$var$__PRIVATE_debugCast(e).persistence).$i();
    }($70fd6868680e912c$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    if (i.$a) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $70fd6868680e912c$var$__PRIVATE_logDebug("SyncEngine", "Ignoring unexpected query state notification.");
    const s = i.Oa.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $70fd6868680e912c$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $70fd6868680e912c$var$__PRIVATE_queryCollectionGroup(s[0])), r = $70fd6868680e912c$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $70fd6868680e912c$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $70fd6868680e912c$var$fail();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $70fd6868680e912c$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.$a) {
        for (const e of t){
            if (r.Oa.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $70fd6868680e912c$var$__PRIVATE_logDebug("SyncEngine", "Adding an already active target " + e);
                continue;
            }
            const t = await $70fd6868680e912c$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $70fd6868680e912c$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $70fd6868680e912c$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $70fd6868680e912c$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $70fd6868680e912c$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Oa.has(e) && // Release queries that are still active.
        await $70fd6868680e912c$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $70fd6868680e912c$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $70fd6868680e912c$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($70fd6868680e912c$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $70fd6868680e912c$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $70fd6868680e912c$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $70fd6868680e912c$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $70fd6868680e912c$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Ma.R_ = $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Ma.Wa = $70fd6868680e912c$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $70fd6868680e912c$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $70fd6868680e912c$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $70fd6868680e912c$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = $70fd6868680e912c$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.jr.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($70fd6868680e912c$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $70fd6868680e912c$var$__PRIVATE_BundleLoader(r, e.localStore, t.serializer);
            let s = await t.Ga();
            for(; s;){
                const e = await i.Pa(s);
                e && n._updateProgress(e), s = await t.Ga();
            }
            const o = await i.complete();
            return await $70fd6868680e912c$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ea, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.jr.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Ia);
        } catch (e) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $70fd6868680e912c$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.za(e), this.persistence = this.ja(e), await this.persistence.start(), this.localStore = this.Ha(e), this.gcScheduler = this.Ja(e, this.localStore), this.indexBackfillerScheduler = this.Ya(e, this.localStore);
    }
    Ja(e, t) {
        return null;
    }
    Ya(e, t) {
        return null;
    }
    Ha(e) {
        return $70fd6868680e912c$var$__PRIVATE_newLocalStore(this.persistence, new $70fd6868680e912c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    ja(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence($70fd6868680e912c$var$__PRIVATE_MemoryEagerDelegate.ei, this.serializer);
    }
    za(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        var e, t;
        null === (e = this.gcScheduler) || void 0 === e || e.stop(), null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: ()=>new $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider
};
class $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Ja(e, t) {
        $70fd6868680e912c$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    ja(e) {
        const t = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$LruParams.DEFAULT;
        return new $70fd6868680e912c$var$__PRIVATE_MemoryPersistence((e)=>$70fd6868680e912c$var$__PRIVATE_MemoryLruDelegate.ei(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.Za = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Za.initialize(this, e), // Enqueue writes from a previous session
        await $70fd6868680e912c$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Za.syncEngine), await $70fd6868680e912c$var$__PRIVATE_fillWritePipeline(this.Za.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Si(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    Ha(e) {
        return $70fd6868680e912c$var$__PRIVATE_newLocalStore(this.persistence, new $70fd6868680e912c$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Ja(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Ya(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $70fd6868680e912c$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    ja(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$LruParams.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$LruParams.DEFAULT;
        return new $70fd6868680e912c$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $70fd6868680e912c$var$__PRIVATE_getWindow(), $70fd6868680e912c$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    za(e) {
        return new $70fd6868680e912c$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider extends $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.Za = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Za.syncEngine;
        this.sharedClientState instanceof $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            io: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            so: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            oo: $70fd6868680e912c$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            $i: $70fd6868680e912c$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            ro: $70fd6868680e912c$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Si(async (e)=>{
            await $70fd6868680e912c$var$__PRIVATE_syncEngineApplyPrimaryState(this.Za.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    za(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_getWindow();
        if (!$70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState.p(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $70fd6868680e912c$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $70fd6868680e912c$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $70fd6868680e912c$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $70fd6868680e912c$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $70fd6868680e912c$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $70fd6868680e912c$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $70fd6868680e912c$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $70fd6868680e912c$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$70fd6868680e912c$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor.p() ? new $70fd6868680e912c$var$__PRIVATE_BrowserConnectivityMonitor : new $70fd6868680e912c$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $70fd6868680e912c$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.$a = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        var e, t;
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            $70fd6868680e912c$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."), t.k_.add(5 /* OfflineCause.Shutdown */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), t.Q_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.K_.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), null === (e = this.datastore) || void 0 === e || e.terminate(), null === (t = this.eventManager) || void 0 === t || t.terminate();
    }
}
$70fd6868680e912c$var$OnlineComponentProvider.provider = {
    build: ()=>new $70fd6868680e912c$var$OnlineComponentProvider
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $70fd6868680e912c$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.Xa(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.Xa(this.observer.error, e) : $70fd6868680e912c$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    eu() {
        this.muted = !0;
    }
    Xa(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $70fd6868680e912c$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.tu = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $70fd6868680e912c$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.nu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.ru().then((e)=>{
            e && e.la() ? this.metadata.resolve(e.ca.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.ca)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.tu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Ga() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.ru();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async ru() {
        const e = await this.iu();
        if (null === e) return null;
        const t = this.nu.decode(e), n = Number(t);
        isNaN(n) && this.su(`length string (${t}) is not valid number`);
        const r = await this.ou(n);
        return new $70fd6868680e912c$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ _u() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async iu() {
        for(; this._u() < 0;){
            if (await this.au()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this._u();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.su("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async ou(e) {
        for(; this.buffer.length < e;)await this.au() && this.su("Reached the end of bundle when more is expected.");
        const t = this.nu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    su(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.tu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async au() {
        const e = await this.tu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $70fd6868680e912c$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$70fd6868680e912c$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.ko("BatchGetDocuments", n.serializer.databaseId, $70fd6868680e912c$var$ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $70fd6868680e912c$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $70fd6868680e912c$var$__PRIVATE_hardAssert(!!t), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $70fd6868680e912c$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$70fd6868680e912c$var$toMutation(n.serializer, e))
            };
            await n.Oo("Commit", n.serializer.databaseId, $70fd6868680e912c$var$ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $70fd6868680e912c$var$fail();
            // Represent a deleted doc using SnapshotVersion.min().
            t = $70fd6868680e912c$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($70fd6868680e912c$var$SnapshotVersion.min()) ? $70fd6868680e912c$var$Precondition.exists(!1) : $70fd6868680e912c$var$Precondition.updateTime(t) : $70fd6868680e912c$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($70fd6868680e912c$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $70fd6868680e912c$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $70fd6868680e912c$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $70fd6868680e912c$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.uu = n.maxAttempts, this.r_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ cu() {
        this.uu -= 1, this.lu();
    }
    lu() {
        this.r_.jo(async ()=>{
            const e = new $70fd6868680e912c$var$Transaction$2(this.datastore), t = this.hu(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Pu(e);
                    }));
            }).catch((e)=>{
                this.Pu(e);
            });
        });
    }
    hu(e) {
        try {
            const t = this.updateFunction(e);
            return !$70fd6868680e912c$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Pu(e) {
        this.uu > 0 && this.Tu(e) ? (this.uu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.lu(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Tu(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$70fd6868680e912c$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $70fd6868680e912c$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $70fd6868680e912c$var$User.UNAUTHENTICATED, this.clientId = $70fd6868680e912c$export$253bcaa5572dcc83.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $70fd6868680e912c$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e);
    $70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$70fd6868680e912c$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OfflineComponentProvider");
            try {
                await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $70fd6868680e912c$var$D.FAILED_PRECONDITION || e.code === $70fd6868680e912c$var$D.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $70fd6868680e912c$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, new $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider);
            }
        } else $70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Using default OfflineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOfflineComponentProvider(e, new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    }
    return e._offlineComponents;
}
async function $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OnlineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($70fd6868680e912c$var$__PRIVATE_logDebug("FirestoreClient", "Using default OnlineComponentProvider"), await $70fd6868680e912c$var$__PRIVATE_setOnlineComponentProvider(e, new $70fd6868680e912c$var$OnlineComponentProvider))), e._onlineComponents;
}
function $70fd6868680e912c$var$__PRIVATE_getPersistence(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $70fd6868680e912c$var$__PRIVATE_getLocalStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $70fd6868680e912c$var$__PRIVATE_getDatastore(e) {
    return $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $70fd6868680e912c$var$__PRIVATE_getEventManager(e) {
    const t = await $70fd6868680e912c$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $70fd6868680e912c$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $70fd6868680e912c$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $70fd6868680e912c$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $70fd6868680e912c$var$__PRIVATE_getPersistence(e), n = await $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return t.k_.delete(0 /* OfflineCause.UserDisabled */ ), $70fd6868680e912c$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $70fd6868680e912c$var$__PRIVATE_getPersistence(e), n = await $70fd6868680e912c$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            t.k_.add(0 /* OfflineCause.UserDisabled */ ), await $70fd6868680e912c$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.K_.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.eu(), t.enqueueAndForget(()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $70fd6868680e912c$var$__PRIVATE_QueryListener($70fd6868680e912c$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                ua: !0
            });
            return $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $70fd6868680e912c$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $70fd6868680e912c$var$__PRIVATE_View(t, r.ds), s = i.ga(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $70fd6868680e912c$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.eu(), t.enqueueAndForget(()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $70fd6868680e912c$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                ua: !0
            });
            return $70fd6868680e912c$var$__PRIVATE_eventManagerListen(e, o);
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $70fd6868680e912c$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                var r;
                const i = $70fd6868680e912c$var$__PRIVATE_debugCast(e), { request: s, lt: o, parent: _ } = $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(i.serializer, $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(t), n);
                i.connection.Co || delete s.parent;
                const a = (await i.ko("RunAggregationQuery", i.serializer.databaseId, _, s, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $70fd6868680e912c$var$__PRIVATE_hardAssert(1 === a.length);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                return Object.keys(u).reduce((e, t)=>(e[o[t]] = u[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $70fd6868680e912c$var$__PRIVATE_debugCast(e).X_.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.eu(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $70fd6868680e912c$var$__PRIVATE_debugCast(e).X_.delete(t);
            })(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $70fd6868680e912c$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $70fd6868680e912c$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $70fd6868680e912c$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $70fd6868680e912c$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $70fd6868680e912c$var$__PRIVATE_syncEngineLoadBundle(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.jr.getNamedQuery(e, t));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $70fd6868680e912c$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $70fd6868680e912c$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$70fd6868680e912c$var$PersistencePromise.waitFor(i)));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $70fd6868680e912c$var$__PRIVATE_debugCast(e)._s.Hi = t;
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e), t));
}
function $70fd6868680e912c$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $70fd6868680e912c$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $70fd6868680e912c$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$we = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $70fd6868680e912c$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(e) {
    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(e) {
    if ($70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $70fd6868680e912c$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $70fd6868680e912c$var$fail();
}
function $70fd6868680e912c$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $70fd6868680e912c$var$__PRIVATE_valueDescription(e);
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $70fd6868680e912c$var$FirestoreSettingsImpl {
    constructor(e){
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = e.host, this.ssl = null === (t = e.ssl) || void 0 === t || t;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $70fd6868680e912c$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $70fd6868680e912c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $70fd6868680e912c$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $70fd6868680e912c$var$FirestoreSettingsImpl(e), void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $70fd6868680e912c$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $70fd6868680e912c$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $70fd6868680e912c$var$we.get(e);
            t && ($70fd6868680e912c$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $70fd6868680e912c$var$we.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $70fd6868680e912c$export$966a03d25297d115(e, t, n, r = {}) {
    var i;
    const s = (e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$var$Firestore$1))._getSettings(), o = `${t}:${n}`;
    if ("firestore.googleapis.com" !== s.host && s.host !== o && $70fd6868680e912c$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), r.mockUserToken) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $70fd6868680e912c$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $c38e0f42709c826a$export$367bf224123348f1)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $70fd6868680e912c$var$User(s);
        }
        e._authCredentials = new $70fd6868680e912c$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $70fd6868680e912c$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $70fd6868680e912c$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $70fd6868680e912c$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, e, this._key);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $70fd6868680e912c$export$ab5a1a47940a200e extends $70fd6868680e912c$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $70fd6868680e912c$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $70fd6868680e912c$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $70fd6868680e912c$var$Firestore$1) {
        const r = $70fd6868680e912c$var$ResourcePath.fromString(t, ...n);
        return $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(r), new $70fd6868680e912c$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($70fd6868680e912c$var$ResourcePath.fromString(t, ...n));
        return $70fd6868680e912c$var$__PRIVATE_validateCollectionPath(r), new $70fd6868680e912c$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $70fd6868680e912c$export$473d82a73f88c107(e, t) {
    if (e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$var$Firestore$1), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $70fd6868680e912c$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $70fd6868680e912c$var$__PRIVATE_QueryImpl($70fd6868680e912c$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $70fd6868680e912c$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $70fd6868680e912c$export$253bcaa5572dcc83.newId()), $70fd6868680e912c$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $70fd6868680e912c$var$Firestore$1) {
        const r = $70fd6868680e912c$var$ResourcePath.fromString(t, ...n);
        return $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(r), new $70fd6868680e912c$export$6be62b059fb12175(e, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($70fd6868680e912c$var$ResourcePath.fromString(t, ...n));
        return $70fd6868680e912c$var$__PRIVATE_validateDocumentPath(r), new $70fd6868680e912c$export$6be62b059fb12175(e.firestore, e instanceof $70fd6868680e912c$export$ab5a1a47940a200e ? e.converter : null, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$62a32f2da6187d11(e, t) {
    return e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), (e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && (t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e instanceof $70fd6868680e912c$export$62297b13309008b2 && t instanceof $70fd6868680e912c$export$62297b13309008b2 && e.firestore === t.firestore && $70fd6868680e912c$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Iu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Eu = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.du = [], // visible for testing
        this.Au = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Ru = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Vu = !1, // List of TimerIds to fast-forward delays for.
        this.mu = [], // Backoff timer used to schedule retries for retryable operations
        this.r_ = new $70fd6868680e912c$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.fu = ()=>{
            const e = $70fd6868680e912c$var$getDocument();
            e && $70fd6868680e912c$var$__PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + e.visibilityState), this.r_.Jo();
        }, this.gu = e;
        const t = $70fd6868680e912c$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.fu);
    }
    get isShuttingDown() {
        return this.Eu;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.pu(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.yu(e);
    }
    enterRestrictedMode(e) {
        if (!this.Eu) {
            this.Eu = !0, this.Vu = e || !1;
            const t = $70fd6868680e912c$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.fu);
        }
    }
    enqueue(e) {
        if (this.pu(), this.Eu) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return this.yu(()=>this.Eu && this.Vu ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Iu.push(e), this.wu()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async wu() {
        if (0 !== this.Iu.length) {
            try {
                await this.Iu[0](), this.Iu.shift(), this.r_.reset();
            } catch (e) {
                if (!$70fd6868680e912c$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $70fd6868680e912c$var$__PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + e);
            }
            this.Iu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.r_.jo(()=>this.wu());
        }
    }
    yu(e) {
        const t = this.gu.then(()=>(this.Ru = !0, e().catch((e)=>{
                this.Au = e, this.Ru = !1;
                const t = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
                    let t = e.message || "";
                    e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                    return t;
                }(e);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $70fd6868680e912c$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
            }).then((e)=>(this.Ru = !1, e))));
        return this.gu = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.pu(), // Fast-forward delays for timerIds that have been overridden.
        this.mu.indexOf(e) > -1 && (t = 0);
        const r = $70fd6868680e912c$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.Su(e));
        return this.du.push(r), r;
    }
    pu() {
        this.Au && $70fd6868680e912c$var$fail();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async bu() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.gu, await e;
        while (e !== this.gu);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Du(e) {
        for (const t of this.du)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ vu(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.bu().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.du.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.du)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.bu();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Cu(e) {
        this.mu.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ Su(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.du.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.du.splice(t, 1);
    }
}
function $70fd6868680e912c$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $70fd6868680e912c$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $70fd6868680e912c$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $70fd6868680e912c$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $70fd6868680e912c$export$d0e2b3272814ce82 extends $70fd6868680e912c$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $70fd6868680e912c$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $70fd6868680e912c$export$9061557f3e3b42f9(e, t, n) {
    n || (n = "(default)");
    const r = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $70fd6868680e912c$export$f06a05d14c3a6678(t, n) {
    const r = "object" == typeof t ? t : (0, $57d436074e210fb5$export$f9962582c9e66d99)(), i = "string" == typeof t ? t : n || "(default)", s = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)("firestore");
        e && $70fd6868680e912c$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $70fd6868680e912c$export$8da5fbea04405656(e) {
    if (e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $70fd6868680e912c$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $70fd6868680e912c$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $70fd6868680e912c$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $70fd6868680e912c$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._componentsProvider || (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._componentsProvider = {
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    }), e._firestoreClient = new $70fd6868680e912c$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = null == e ? void 0 : e._online.build();
        return {
            _offline: null == e ? void 0 : e._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $70fd6868680e912c$export$cebe3b626a79c5f3(e, t) {
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, $70fd6868680e912c$var$OnlineComponentProvider.provider, {
        build: (e)=>new $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, null == t ? void 0 : t.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $70fd6868680e912c$export$6d4c055e91302ab9(e) {
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, $70fd6868680e912c$var$OnlineComponentProvider.provider, {
        build: (e)=>new $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $70fd6868680e912c$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82))._firestoreClient || e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $70fd6868680e912c$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $70fd6868680e912c$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$70fd6868680e912c$var$__PRIVATE_SimpleDb.p()) return Promise.resolve();
                const t = e + "main";
                await $70fd6868680e912c$var$__PRIVATE_SimpleDb.delete(t);
            }($70fd6868680e912c$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $70fd6868680e912c$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $70fd6868680e912c$export$ee6bdee8287ecc5f(e) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientEnableNetwork($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $70fd6868680e912c$export$f35b708ad73d52eb(e) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientDisableNetwork($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $70fd6868680e912c$export$9aff22d1ec357a14(e) {
    return (0, $57d436074e210fb5$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $70fd6868680e912c$export$4b8b93c690c9810b(e, t) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), r = new $70fd6868680e912c$export$6cac12425252ec14;
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $70fd6868680e912c$export$169d2c6fe0f7f4ea(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetNamedQuery($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), t).then((t)=>t ? new $70fd6868680e912c$export$62297b13309008b2(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $70fd6868680e912c$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(e = "count", t){
        this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $70fd6868680e912c$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $70fd6868680e912c$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $70fd6868680e912c$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $70fd6868680e912c$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $70fd6868680e912c$export$bf6e62266977b8eb() {
    return new $70fd6868680e912c$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $70fd6868680e912c$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $70fd6868680e912c$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $70fd6868680e912c$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with {@link FieldValue.vector}.
 *
 * @class VectorValue
 */ class $70fd6868680e912c$export$994bb3d317350b37 {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two VectorValue has the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$be = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $70fd6868680e912c$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $70fd6868680e912c$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $70fd6868680e912c$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $70fd6868680e912c$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $70fd6868680e912c$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $70fd6868680e912c$var$fail();
    }
}
/** A "context" object passed around while parsing user data. */ class $70fd6868680e912c$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Fu(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get Mu() {
        return this.settings.Mu;
    }
    /** Returns a new context with the specified settings overwritten. */ xu(e) {
        return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    Ou(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.xu({
            path: n,
            Nu: !1
        });
        return r.Lu(e), r;
    }
    Bu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.xu({
            path: n,
            Nu: !1
        });
        return r.Fu(), r;
    }
    ku(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.xu({
            path: void 0,
            Nu: !0
        });
    }
    qu(e) {
        return $70fd6868680e912c$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.Qu || !1, this.path, this.settings.Ku);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    Fu() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.Lu(this.path.get(e));
    }
    Lu(e) {
        if (0 === e.length) throw this.qu("Document fields must not be empty");
        if ($70fd6868680e912c$var$__PRIVATE_isWrite(this.Mu) && $70fd6868680e912c$var$be.test(e)) throw this.qu('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $70fd6868680e912c$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $70fd6868680e912c$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ $u(e, t, n, r = !1) {
        return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl({
            Mu: e,
            methodName: t,
            Ku: n,
            path: $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(),
            Nu: !1,
            Qu: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $70fd6868680e912c$var$__PRIVATE_newSerializer(e._databaseId);
    return new $70fd6868680e912c$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $70fd6868680e912c$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.$u(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $70fd6868680e912c$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $70fd6868680e912c$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $70fd6868680e912c$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $70fd6868680e912c$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $70fd6868680e912c$var$ParsedSetData(new $70fd6868680e912c$var$ObjectValue(_), a, u);
}
class $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.Mu) throw 1 /* UserDataSource.Update */  === e.Mu ? e.qu(`${this._methodName}() can only appear at the top level of your update data`) : e.qu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $70fd6868680e912c$var$__PRIVATE_ParseContextImpl({
        Mu: 3 /* UserDataSource.Argument */ ,
        Ku: t.settings.Ku,
        methodName: e._methodName,
        Nu: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $70fd6868680e912c$var$FieldTransform(e.path, new $70fd6868680e912c$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Uu = t;
    }
    _toFieldTransform(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Uu.map((e)=>$70fd6868680e912c$var$__PRIVATE_parseData(e, t)), r = new $70fd6868680e912c$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $70fd6868680e912c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(this.Uu, e.Uu);
    }
}
class $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Uu = t;
    }
    _toFieldTransform(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Uu.map((e)=>$70fd6868680e912c$var$__PRIVATE_parseData(e, t)), r = new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $70fd6868680e912c$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(this.Uu, e.Uu);
    }
}
class $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Wu = t;
    }
    _toFieldTransform(e) {
        const t = new $70fd6868680e912c$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $70fd6868680e912c$var$toNumber(e.serializer, this.Wu));
        return new $70fd6868680e912c$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Wu === e.Wu;
    }
}
/** Parse update data from an update() call. */ function $70fd6868680e912c$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.$u(1 /* UserDataSource.Update */ , t, n);
    $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $70fd6868680e912c$var$ObjectValue.empty();
    $70fd6868680e912c$var$forEach(r, (e, r)=>{
        const _ = $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(r);
        const a = i.Bu(_);
        if (r instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $70fd6868680e912c$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $70fd6868680e912c$var$FieldMask(s);
    return new $70fd6868680e912c$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.$u(1 /* UserDataSource.Update */ , t, n), _ = [
        $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $70fd6868680e912c$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$70fd6868680e912c$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n);
        const r = o.Bu(t);
        if (n instanceof $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $70fd6868680e912c$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $70fd6868680e912c$var$FieldMask(u);
    return new $70fd6868680e912c$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $70fd6868680e912c$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $70fd6868680e912c$var$__PRIVATE_parseData(n, e.$u(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $70fd6868680e912c$var$__PRIVATE_parseData(e, t) {
    if ($70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e))) return $70fd6868680e912c$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $70fd6868680e912c$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$70fd6868680e912c$var$__PRIVATE_isWrite(t.Mu)) throw t.qu(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.qu(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.Nu && 4 /* UserDataSource.ArrayArgument */  !== t.Mu) throw t.qu("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $70fd6868680e912c$var$__PRIVATE_parseData(i, t.ku(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $70fd6868680e912c$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $70fd6868680e912c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $70fd6868680e912c$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $70fd6868680e912c$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $70fd6868680e912c$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $70fd6868680e912c$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.qu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $70fd6868680e912c$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $70fd6868680e912c$export$994bb3d317350b37) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            return {
                mapValue: {
                    fields: {
                        __type__: {
                            stringValue: "__vector__"
                        },
                        value: {
                            arrayValue: {
                                values: e.toArray().map((e)=>{
                                    if ("number" != typeof e) throw t.qu("VectorValues must only contain numeric values.");
                                    return $70fd6868680e912c$var$__PRIVATE_toDouble(t.serializer, e);
                                })
                            }
                        }
                    }
                }
            };
        }(e, t);
        throw t.qu(`Unsupported field value: ${$70fd6868680e912c$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $70fd6868680e912c$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $70fd6868680e912c$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $70fd6868680e912c$var$forEach(e, (e, r)=>{
        const i = $70fd6868680e912c$var$__PRIVATE_parseData(r, t.Ou(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430 || e instanceof $70fd6868680e912c$export$f9f719d1b6419c4 || e instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1 || e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d || e instanceof $70fd6868680e912c$export$994bb3d317350b37);
}
function $70fd6868680e912c$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$70fd6868680e912c$var$__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        const r = $70fd6868680e912c$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.qu(e + " a custom object") : t.qu(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) instanceof $70fd6868680e912c$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $70fd6868680e912c$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $70fd6868680e912c$var$De = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($70fd6868680e912c$var$De) >= 0) throw $70fd6868680e912c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $70fd6868680e912c$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $70fd6868680e912c$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $70fd6868680e912c$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $70fd6868680e912c$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $70fd6868680e912c$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $70fd6868680e912c$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$var$QueryDocumentSnapshot$1 extends $70fd6868680e912c$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $70fd6868680e912c$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $70fd6868680e912c$export$b0e86f2c7431df4e extends $70fd6868680e912c$var$AppliableConstraint {
}
function $70fd6868680e912c$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $70fd6868680e912c$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $70fd6868680e912c$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $70fd6868680e912c$export$f765fc5789dfd439 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $70fd6868680e912c$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            return $70fd6868680e912c$var$FieldFilter.create(i, s, _);
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $70fd6868680e912c$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $70fd6868680e912c$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $70fd6868680e912c$export$6bbc7aef0717f3d2 extends $70fd6868680e912c$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $70fd6868680e912c$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $70fd6868680e912c$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(n, e), n = $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $70fd6868680e912c$export$65a9ba8bbd6ed9e3 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $70fd6868680e912c$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            return new $70fd6868680e912c$var$OrderBy(t, n);
        }(e._query, this._field, this._direction);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $70fd6868680e912c$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $70fd6868680e912c$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $70fd6868680e912c$export$49bb5356ca788047 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, $70fd6868680e912c$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$ee37e834aaad6f7e(e) {
    return $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber("limit", e), $70fd6868680e912c$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$f823b3589f69d3b8(e) {
    return $70fd6868680e912c$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $70fd6868680e912c$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $70fd6868680e912c$export$d92e2830aca1d816 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $70fd6868680e912c$export$859941c5fc8eba6b(...e) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $70fd6868680e912c$export$dd8dee5f7b804673(...e) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $70fd6868680e912c$export$fd1782fd870d1e06 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $70fd6868680e912c$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $70fd6868680e912c$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $70fd6868680e912c$export$57203950645b8b11(...e) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $70fd6868680e912c$export$28ec54a8428bdb3f(...e) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $70fd6868680e912c$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $70fd6868680e912c$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $70fd6868680e912c$var$__PRIVATE_queryNormalizedOrderBy(e))if (n.field.isKeyField()) s.push($70fd6868680e912c$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($70fd6868680e912c$var$__PRIVATE_isServerTimestamp(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $70fd6868680e912c$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($70fd6868680e912c$var$ResourcePath.fromString(a));
                    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(n)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $70fd6868680e912c$export$afc2e57c475b7810(n);
                    _.push($70fd6868680e912c$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $70fd6868680e912c$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $70fd6868680e912c$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $70fd6868680e912c$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$70fd6868680e912c$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($70fd6868680e912c$var$ResourcePath.fromString(n));
        if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(r)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $70fd6868680e912c$var$__PRIVATE_refValue(e, new $70fd6868680e912c$export$afc2e57c475b7810(r));
    }
    if (n instanceof $70fd6868680e912c$export$6be62b059fb12175) return $70fd6868680e912c$var$__PRIVATE_refValue(e, n._key);
    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$70fd6868680e912c$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $70fd6868680e912c$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $70fd6868680e912c$var$__PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $70fd6868680e912c$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $70fd6868680e912c$export$f765fc5789dfd439 || t instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($70fd6868680e912c$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($70fd6868680e912c$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $70fd6868680e912c$var$fail();
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $70fd6868680e912c$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        var t, n, r;
        const i = null === (r = null === (n = null === (t = e.fields) || void 0 === t ? void 0 : t.value.arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.map((e)=>$70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $70fd6868680e912c$export$994bb3d317350b37(i);
    }
    convertGeoPoint(e) {
        return new $70fd6868680e912c$export$f9f719d1b6419c4($70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.latitude), $70fd6868680e912c$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $70fd6868680e912c$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($70fd6868680e912c$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_normalizeTimestamp(e);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $70fd6868680e912c$var$ResourcePath.fromString(e);
        $70fd6868680e912c$var$__PRIVATE_hardAssert($70fd6868680e912c$var$__PRIVATE_isValidResourceName(n));
        const r = new $70fd6868680e912c$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $70fd6868680e912c$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $70fd6868680e912c$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function $70fd6868680e912c$export$8a63f25cc62965f1(e) {
    return new $70fd6868680e912c$export$fada2345be8928cf("sum", $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $70fd6868680e912c$export$cc6710ee5f037d57(e) {
    return new $70fd6868680e912c$export$fada2345be8928cf("avg", $70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $70fd6868680e912c$export$85b9a36db797e02b() {
    return new $70fd6868680e912c$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $70fd6868680e912c$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $70fd6868680e912c$export$fada2345be8928cf && t instanceof $70fd6868680e912c$export$fada2345be8928cf && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $70fd6868680e912c$export$104f59389a332076(e, t) {
    return $70fd6868680e912c$export$49b1d0de6ba30f41(e.query, t.query) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $70fd6868680e912c$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$export$acab0e6ef25eb301 extends $70fd6868680e912c$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($70fd6868680e912c$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$export$6d4d04e42af6b03c extends $70fd6868680e912c$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $70fd6868680e912c$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $70fd6868680e912c$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $70fd6868680e912c$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $70fd6868680e912c$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $70fd6868680e912c$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $70fd6868680e912c$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $70fd6868680e912c$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $70fd6868680e912c$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
}
function $70fd6868680e912c$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $70fd6868680e912c$var$fail();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $70fd6868680e912c$export$f243a5d948512846(e, t) {
    return e instanceof $70fd6868680e912c$export$acab0e6ef25eb301 && t instanceof $70fd6868680e912c$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $70fd6868680e912c$export$8f21149d8133945c && t instanceof $70fd6868680e912c$export$8f21149d8133945c && e._firestore === t._firestore && $70fd6868680e912c$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$11eb3b5ef9574821(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($70fd6868680e912c$export$8da5fbea04405656(t), e._key).then((n)=>$70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
class $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$a58bd92642f7fb58(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $70fd6868680e912c$export$acab0e6ef25eb301(t, r, e._key, n, new $70fd6868680e912c$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$35dd759aed9686b4(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($70fd6868680e912c$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$81d3477bd73c86ef(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$3fd010f18eac1dd(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$ec7d9e44f349c77b(e) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
    const t = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(t), r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(t, r, e, n));
}
function $70fd6868680e912c$export$5ff77ddaff3c9e12(e, t, n) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const r = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $70fd6868680e912c$export$1945f8fec9dda613(r, [
        $70fd6868680e912c$var$__PRIVATE_parseSetData($70fd6868680e912c$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $70fd6868680e912c$var$Precondition.none())
    ]);
}
function $70fd6868680e912c$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$6be62b059fb12175);
    const i = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $70fd6868680e912c$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $70fd6868680e912c$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a4f20481fae8f78b(e) {
    return $70fd6868680e912c$export$1945f8fec9dda613($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), [
        new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(e._key, $70fd6868680e912c$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a13890143fb1c2dd(e, t) {
    const n = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$export$2a111da947c407d2(e), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $70fd6868680e912c$export$1945f8fec9dda613(n, [
        $70fd6868680e912c$var$__PRIVATE_parseSetData($70fd6868680e912c$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $70fd6868680e912c$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $70fd6868680e912c$export$d36370812fb26935(e, ...t) {
    var n, r, i;
    e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e);
    let s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || $70fd6868680e912c$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if ($70fd6868680e912c$var$__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof $70fd6868680e912c$export$6be62b059fb12175) u = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), c = $70fd6868680e912c$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: (n)=>{
            t[o] && t[o]($70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        const n = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$62297b13309008b2);
        u = $70fd6868680e912c$export$572106fb5803752c(n.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), c = n._query;
        const r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: (e)=>{
                t[o] && t[o](new $70fd6868680e912c$export$8f21149d8133945c(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $70fd6868680e912c$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $70fd6868680e912c$var$__PRIVATE_AsyncObserver(r), s = new $70fd6868680e912c$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_eventManagerListen(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.eu(), e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_eventManagerUnlisten(await $70fd6868680e912c$var$__PRIVATE_getEventManager(e), s));
        };
    }($70fd6868680e912c$export$8da5fbea04405656(u), c, _, a);
}
function $70fd6868680e912c$export$9dff4f5aba83e348(e, t) {
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), $70fd6868680e912c$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $70fd6868680e912c$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$__PRIVATE_syncEngineWrite(await $70fd6868680e912c$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $70fd6868680e912c$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(e);
    return new $70fd6868680e912c$export$acab0e6ef25eb301(e, i, t._key, r, new $70fd6868680e912c$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $70fd6868680e912c$export$b1de1b12889d0afb(e) {
    return $70fd6868680e912c$export$a51511de2fae49b3(e, {
        count: $70fd6868680e912c$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $70fd6868680e912c$export$a51511de2fae49b3(e, t) {
    const n = $70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$export$8da5fbea04405656(n), i = $70fd6868680e912c$var$__PRIVATE_mapToArray(t, (e, t)=>new $70fd6868680e912c$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(e);
            return new $70fd6868680e912c$export$40257fef64be808b(t, r, n);
        })(n, e, t));
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = {
            build: ()=>new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $70fd6868680e912c$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = $70fd6868680e912c$var$__PRIVATE_MemoryOfflineComponentProvider.provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new $70fd6868680e912c$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $70fd6868680e912c$export$574728f3be606189() {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $70fd6868680e912c$export$2340f88905cc0c23(e) {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryLruGarbageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $70fd6868680e912c$export$72ef71adb739a32c(e) {
    return new $70fd6868680e912c$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $70fd6868680e912c$export$51b321e43d5331d5(e) {
    return new $70fd6868680e912c$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $70fd6868680e912c$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $70fd6868680e912c$var$__PRIVATE_IndexedDbOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $70fd6868680e912c$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $70fd6868680e912c$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $70fd6868680e912c$var$__PRIVATE_MultiTabOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $70fd6868680e912c$export$d5f96a3c009e86ac(e) {
    return new $70fd6868680e912c$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $70fd6868680e912c$export$57e9d290b0b4dc04() {
    return new $70fd6868680e912c$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$ve = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $70fd6868680e912c$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $70fd6868680e912c$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $70fd6868680e912c$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $70fd6868680e912c$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $70fd6868680e912c$var$__PRIVATE_DeleteMutation(t._key, $70fd6868680e912c$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $70fd6868680e912c$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)).firestore !== t) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$export$febc5573c75cefb0 extends class Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $70fd6868680e912c$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), n = new $70fd6868680e912c$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $70fd6868680e912c$var$fail();
            const r = e[0];
            if (r.isFoundDocument()) return new $70fd6868680e912c$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $70fd6868680e912c$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $70fd6868680e912c$var$fail();
        });
    }
    set(e, t, n) {
        const r = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), i = $70fd6868680e912c$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $70fd6868680e912c$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)) || t instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $70fd6868680e912c$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
} {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $70fd6868680e912c$var$__PRIVATE_validateReference(e, this._firestore), n = new $70fd6868680e912c$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $70fd6868680e912c$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $70fd6868680e912c$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $70fd6868680e912c$export$3c54e006bf9c93b7(e, t, n) {
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82);
    const r = Object.assign(Object.assign({}, $70fd6868680e912c$var$ve), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $70fd6868680e912c$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $70fd6868680e912c$var$__PRIVATE_getDatastore(e);
            new $70fd6868680e912c$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).cu();
        }), r.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(e), (n)=>t(new $70fd6868680e912c$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $70fd6868680e912c$export$2bbad96c62fdba3e() {
    return new $70fd6868680e912c$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $70fd6868680e912c$export$3ff8e7e00c3264b7() {
    return new $70fd6868680e912c$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $70fd6868680e912c$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$a2647aa13413c947(e) {
    return new $70fd6868680e912c$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $70fd6868680e912c$export$6074e20ba5c64bef(e) {
    return new $70fd6868680e912c$export$994bb3d317350b37(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $70fd6868680e912c$export$44cd1c9d57edd9b1(e) {
    return $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82)), new $70fd6868680e912c$export$d94ed661b1cfd435(e, (t)=>$70fd6868680e912c$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$export$ff1663c0c1304f1a(e, t) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82));
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $70fd6868680e912c$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $70fd6868680e912c$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $70fd6868680e912c$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $70fd6868680e912c$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $70fd6868680e912c$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $70fd6868680e912c$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $70fd6868680e912c$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $70fd6868680e912c$var$FieldIndex($70fd6868680e912c$var$FieldIndex.UNKNOWN_ID, t, r, $70fd6868680e912c$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $70fd6868680e912c$var$__PRIVATE_firestoreClientSetIndexConfiguration(n, r);
}
function $70fd6868680e912c$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $70fd6868680e912c$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(e){
        this._firestore = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $70fd6868680e912c$export$61c6347b57bdfa06(e) {
    var t;
    e = $70fd6868680e912c$export$572106fb5803752c(e, $70fd6868680e912c$export$d0e2b3272814ce82);
    const n = $70fd6868680e912c$var$Ce.get(e);
    if (n) return n;
    if ("persistent" !== (null === (t = $70fd6868680e912c$export$8da5fbea04405656(e)._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offline.kind)) return null;
    const r = new $70fd6868680e912c$export$cf4db3c220e88bd8(e);
    return $70fd6868680e912c$var$Ce.set(e, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $70fd6868680e912c$export$9b2c0a7aacbcd151(e) {
    $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $70fd6868680e912c$export$5b460d5f48076743(e) {
    $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $70fd6868680e912c$export$72809fc2fc5083d5(e) {
    $70fd6868680e912c$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes($70fd6868680e912c$export$8da5fbea04405656(e._firestore)).then((e)=>$70fd6868680e912c$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded")).catch((e)=>$70fd6868680e912c$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e));
}
function $70fd6868680e912c$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    $70fd6868680e912c$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled($70fd6868680e912c$export$8da5fbea04405656(e._firestore), t).then((e)=>$70fd6868680e912c$var$__PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`)).catch((e)=>$70fd6868680e912c$export$86cd73f49cc6e0bb(`setting persistent cache index auto creation isEnabled=${t} failed`, e));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $70fd6868680e912c$var$Ce = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $70fd6868680e912c$export$b22c6725d8899bb4(e) {
    var t;
    const n = null === (t = $70fd6868680e912c$export$8da5fbea04405656($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : $70fd6868680e912c$var$__PRIVATE_toQueryTarget(n, $70fd6868680e912c$var$__PRIVATE_queryToTarget(e._query)).ct;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $70fd6868680e912c$export$5bcaa7c32a88925e(e, t) {
    var n;
    const r = $70fd6868680e912c$var$__PRIVATE_mapToArray(t, (e, t)=>new $70fd6868680e912c$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), i = null === (n = $70fd6868680e912c$export$8da5fbea04405656($70fd6868680e912c$export$572106fb5803752c(e.firestore, $70fd6868680e912c$export$d0e2b3272814ce82))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : $70fd6868680e912c$var$__PRIVATE_toRunAggregationQueryRequest(i, $70fd6868680e912c$var$__PRIVATE_queryToAggregateTarget(e._query), r, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $70fd6868680e912c$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(e) {
        return $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.Gu = new Map;
    }
    static get instance() {
        return $70fd6868680e912c$var$Fe || ($70fd6868680e912c$var$Fe = new $70fd6868680e912c$var$__PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if ($70fd6868680e912c$var$Pe) throw new Error("a TestingHooksSpi instance is already set");
            $70fd6868680e912c$var$Pe = e;
        }($70fd6868680e912c$var$Fe)), $70fd6868680e912c$var$Fe;
    }
    tt(e) {
        this.Gu.forEach((t)=>t(e));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Gu;
        return n.set(t, e), ()=>n.delete(t);
    }
}
let $70fd6868680e912c$var$Fe = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $70fd6868680e912c$var$S = e;
    }((0, $57d436074e210fb5$export$31499a9cd224b78c)), (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $70fd6868680e912c$export$d0e2b3272814ce82(new $70fd6868680e912c$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $70fd6868680e912c$var$__PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$D.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $70fd6868680e912c$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$w, "4.7.5", e), // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$w, "4.7.5", "esm2017");
}();




const $b03a20a2d7a048cf$var$MainOneOnOverTheOther = document.getElementById("MainOneOnOverTheOther");
let $b03a20a2d7a048cf$var$debounceTimeout;
const $b03a20a2d7a048cf$var$images = [
    "355c0a80-0eb4-4bc7-b28e-cbe202dfa29b.jpg",
    "e612ac7a-ee51-466f-a682-79c2db0c6ee3.jpg",
    "7bee6f00-cdf6-415d-ae51-ff197f76f61b.jpg",
    "c0b2dfa0-f006-487b-9ee8-ef21d2245af3.jpg"
];
class $b03a20a2d7a048cf$var$display {
    #currentListing;
    #currentBusiness;
    #inititlazied = false;
    #listingEventsInitialized = false;
    #currentImgIndex = 1;
    constructor(){
        this._windowEvents();
    }
    _getCurrentImageIndex() {
        return this.#currentImgIndex;
    }
    _resetCurrentImageIndex() {
        console.log('CALLED');
        this.#currentImgIndex = 1;
    }
    _windowEvents() {
        // Scroll sync logic
        window.addEventListener("click", (e)=>{
            const mini = e.target.closest(".nvImgDisplayerListingEachCon3");
            if (!mini) return;
            const wrapper = mini.closest(".nvListingEachCon1A");
            if (!wrapper) return;
            const bigScroller = wrapper.querySelector(".nvImgDisplayerListingEachCon1");
            const miniContainer = wrapper.querySelector(".nvImgDisplayerListingEachCon5");
            if (!bigScroller || !miniContainer) return;
            const allMinis = Array.from(miniContainer.querySelectorAll(".nvImgDisplayerListingEachCon3"));
            const index = allMinis.indexOf(mini);
            if (index < 0) return;
            // Scroll big container to the corresponding big image
            const target = bigScroller.querySelectorAll(".nvImgDisplayerListingEachCon2")[index];
            if (target) target.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
            });
        // Update active class
        // Happening in the sroll detector
        // allMinis.forEach((m, i) => {
        //   m.classList.toggle("nvImgDisplayerListingEachCon3ACT", i === index);
        // });
        });
    }
    // Detect scroll to update active mini image
    _detectBigImageScroll() {
        document.querySelectorAll(".nvImgDisplayerListingEachCon1").forEach((bigScroller)=>{
            bigScroller.addEventListener("scroll", ()=>{
                const wrapper = bigScroller.closest(".nvListingEachCon1A");
                const miniContainer = wrapper?.querySelector(".nvImgDisplayerListingEachCon5");
                if (!miniContainer) return;
                const bigImages = Array.from(bigScroller.querySelectorAll(".nvImgDisplayerListingEachCon2"));
                const minis = Array.from(miniContainer.querySelectorAll(".nvImgDisplayerListingEachCon3"));
                // Find current visible big image
                const scrollLeft = bigScroller.scrollLeft;
                const width = bigScroller.clientWidth;
                const index = Math.round(scrollLeft / width);
                this.#currentImgIndex = index + 1;
                console.log(index);
                minis.forEach((mini, i)=>{
                    mini.classList.toggle("nvImgDisplayerListingEachCon3ACT", i === index);
                });
            });
        });
    }
    _returnMiniSpinner() {
        return `<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="20"
      height="20"
      class="miniSpinneForButtons">
      <circle
        cx="25"
        cy="25"
        r="20"
        stroke="#2B2B2B"
        stroke-width="4"
        fill="none"
        stroke-dasharray="125.6"
        stroke-dashoffset="94.2"
        stroke-linecap="round">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.8s"
          repeatCount="indefinite" />
      </circle>
    </svg>`;
    }
    _videoHandler() {
        document.addEventListener("click", function(event) {
            // Close button logic
            if (event.target.classList.contains("close-btn")) {
                const wrapper = event.target.closest(".floating-video");
                if (wrapper) wrapper.remove();
                return;
            }
            // Play overlay logic
            const overlay = event.target.closest(".video-overlay");
            if (overlay) {
                const video = overlay.parentElement.querySelector("video");
                if (video) {
                    overlay.remove();
                    // overlay.style.display = "none";
                    video.play();
                }
            }
        });
        function enableDrag(el) {
            const handle = el.querySelector(".drag-handle");
            if (!handle) return;
            let isDragging = false;
            let offsetX = 0;
            let offsetY = 0;
            function onPointerDown(e) {
                isDragging = true;
                const rect = el.getBoundingClientRect();
                offsetX = e.clientX - rect.left;
                offsetY = e.clientY - rect.top;
                el.style.transition = "none";
                document.addEventListener("pointermove", onPointerMove);
                document.addEventListener("pointerup", onPointerUp);
                // Prevent text selection while dragging
                e.preventDefault();
            }
            function onPointerMove(e) {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.clientX - offsetX;
                const y = e.clientY - offsetY;
                el.style.left = `${x}px`;
                el.style.top = `${y}px`;
                el.style.right = "auto"; // override inline right positioning
            }
            function onPointerUp(e) {
                if (!isDragging) return;
                isDragging = false;
                const winWidth = window.innerWidth;
                const rect = el.getBoundingClientRect();
                // Snap to nearest edge (20px margin)
                if (rect.left + rect.width / 2 < winWidth / 2) el.style.left = "20px";
                else {
                    el.style.left = "auto";
                    el.style.right = "20px";
                }
                document.removeEventListener("pointermove", onPointerMove);
                document.removeEventListener("pointerup", onPointerUp);
                // Smooth snap
                el.style.transition = "left 0.2s ease, right 0.2s ease";
            }
            handle.addEventListener("pointerdown", onPointerDown);
        }
        document.querySelectorAll(".floating-video").forEach(enableDrag);
    }
    async _init(dataIn, businessIn, openFrom, share, fromEdit, rationClass) {
        console.error("INIT DISPLAY LISTING EACH");
        this.#currentImgIndex = 1;
        let data = dataIn;
        console.log(data);
        // this.#currentBusiness = business;
        let callNumber = "";
        let whatsAppNumber = "";
        let viewsData = "";
        let account = null;
        let business = null;
        if (data?.sellerId) {
            account = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${data?.sellerId}`);
            const countryCodeCall = (account?.callNumberCountryCode || '52').replace('+', '');
            const countryCodeWhats = (account?.whatsAppNumberCountryCode || '52').replace('+', '');
            callNumber = countryCodeCall + account?.callNumber || '';
            whatsAppNumber = countryCodeWhats + account?.whatsAppNumber || '';
        }
        if (data?.businessId) {
            business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${data?.businessId}`);
            const countryCodeCall = (business?.contacts?.call?.countryCode || '52').replace('+', '');
            const countryCodeWhats = (business?.contacts?.whatsApp?.countryCode || '52').replace('+', '');
            callNumber = countryCodeCall + business?.contacts?.call?.contact || '';
            whatsAppNumber = countryCodeWhats + business?.contacts?.whatsApp?.contact || '';
        }
        if (fromEdit === "true") {
            data = (0, $aacf0c292643cb7f$export$2e2bcd8739ae039)._getPlaceHolderListingData();
            console.log("OPEN LISTING FROM EDIT");
        } else {
            if (business) viewsData = {
                businessId: business.businessId,
                listingId: data.listingId
            };
            else viewsData = {
                listingId: data.listingId
            };
            (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateViewsOnListings(viewsData);
        }
        console.log(business);
        this.#currentListing = null;
        this.#currentBusiness = null;
        this.#currentListing = data;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando informaci\xf3n");
        const idForConTainer = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUniqueIdfunction();
        const imgUrls = data.listingImgsIds;
        const dataForListing = {
            data: data,
            ads: (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._makeAddSetToInsert()
        };
        let listingHTML = (0, $17669737d3cc7ae6$export$2e2bcd8739ae039)._generateListing(dataForListing, business, imgUrls, null, {
            callNumber: callNumber,
            whatsAppNumber: whatsAppNumber
        }, openFrom, fromEdit, rationClass);
        (0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._display(listingHTML);
        console.log(data);
        if (data?.place?.locationUrl) {
            const nvListingEachConLocationContainerParent = document.getElementById('nvListingEachConLocationContainerParent');
            const openMapsButton = document.getElementById('nvListingEachConLocationContainerButtonOpenMaps');
            const listignDataForLocation = {
                title: data.listingName,
                description: data.listingDescription,
                imageUrl: data.listingImgsIds[0].res_200,
                lat: data.place.lat,
                lng: data.place.lng,
                price: data.onDiscount.finalPrice,
                city: data.place.city,
                state: data.place.state,
                locationUrl: data.place.locationUrl
            };
            console.log(listignDataForLocation);
            nvListingEachConLocationContainerParent.style.display = 'flex';
            (0, $a082c89adac62edb$export$2e2bcd8739ae039)._displayListingLocation(listignDataForLocation, 'nvListingEachConLocationContainer');
            openMapsButton.addEventListener('click', ()=>{
                (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink(listignDataForLocation.locationUrl);
            });
        }
        console.log(share);
        if (share) {
            const listingCon = document.getElementById(`${idForConTainer}ForInstantSharing`);
            console.log(listingCon);
            const shareButton = listingCon.querySelector("#DisplayListingEachButtonActionShare");
            console.log(shareButton);
            // shareButton.click();
            this._shareListing(shareButton);
        }
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        // if (this.#inititlazied) return;
        // this.#inititlazied = true;
        this._videoHandler();
        this._detectBigImageScroll();
        this._listingEvents();
        const historySaveUrl = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(dataIn.businessId, null, dataIn.listingId, null);
        const historyData = {
            href: historySaveUrl,
            title: dataIn.listingName,
            image: data?.listingImgsIds?.[0]?.res_200 || null,
            type: 'listing'
        };
        (0, $a082c89adac62edb$export$2e2bcd8739ae039)._pushUserHistory(historyData);
        this._setExpandedContactsButton(false);
        setTimeout(()=>{
            this._setExpandedContactsButton(true);
        }, 500);
        this._initScrollListener();
    }
    _initScrollListener() {
        const container = document.querySelector('.nvListingEachCon1C');
        let isAtTop = true;
        container.addEventListener('scroll', ()=>{
            const nowAtTop = container.scrollTop <= 0;
            // Left the top
            if (isAtTop && !nowAtTop) {
                isAtTop = false;
                this._setExpandedContactsButton(false);
            } else if (!isAtTop && nowAtTop) {
                isAtTop = true;
                this._setExpandedContactsButton(true);
            }
        });
    }
    _setExpandedContactsButton(expanded = true) {
        const parent = document.getElementById('nvListingsContactEachCon13C');
        const el = parent.querySelector('.nvBusinessContactEachCon14ListingEach');
        const el2 = parent.querySelector('.nvBusinessContactEachCon13CListingEach');
        const text1 = parent.querySelector('.nvBusinessContactEachText12ListingEach');
        const text2 = parent.querySelector('.nvBusinessContactEachText11ListingEach');
        const text3 = parent.querySelector('.nvListingEachCon17ListingEach');
        if (expanded) {
            parent.classList.add('expanded');
            el.classList.add('expanded');
            el2.classList.add('expanded');
            text1.style.display = 'flex';
            text2.style.display = 'flex';
            text3.style.display = 'flex';
        } else {
            parent.classList.remove('expanded');
            el.classList.remove('expanded');
            el2.classList.remove('expanded');
            text1.style.display = 'none';
            text2.style.display = 'none';
            text3.style.display = 'none';
        }
    }
    _shareListing = async (e)=>{
        const parentEL = e.closest(".ActionForShare");
        const shareWhat = parentEL.dataset.share;
        const businessId = parentEL.dataset.businessid;
        const listingId = parentEL.dataset.listingid;
        const businessName = parentEL.dataset.businessname;
        const listingName = parentEL.dataset.listingname;
        const listingPrice = parentEL.dataset.listingprice;
        const listingPriceBefore = parentEL.dataset.listingpricebefore;
        const listingCoin = parentEL.dataset.listingcoin;
        let imgsUrls = [];
        let imgsUrlsAll = [];
        const siblingWithImgCon = parentEL.nextElementSibling?.classList.contains("imgCon") ? parentEL.nextElementSibling : parentEL.previousElementSibling?.classList.contains("ListingDisplayImagesDisplayCon1") ? parentEL.previousElementSibling : null;
        if (siblingWithImgCon) {
            siblingWithImgCon.querySelectorAll(".ListingDisplayImagesDisplayImage").forEach((img)=>{
                imgsUrlsAll.push(img.src);
            });
            imgsUrls = [
                imgsUrlsAll[0]
            ];
        }
        console.log("Sibling with class 'imgCon':", siblingWithImgCon);
        let businessNameForUse = false;
        console.log(businessName);
        if (businessName !== "null" && businessName !== null) businessNameForUse = businessName;
        const url = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessId, businessNameForUse, listingId, listingName);
        const dataToSendToShareFunction = {
            listing: this.#currentListing,
            business: this.#currentBusiness,
            listingUrl: url
        };
        (0, $dc7988840845b777$export$2e2bcd8739ae039)._open(dataToSendToShareFunction, "listing");
    };
    _listingEvents() {
        if (this.#listingEventsInitialized) return;
        this.#listingEventsInitialized = true;
        window.addEventListener('click', (e)=>{
            const isWhatsAppButton = e.target.closest('#btnActionListingContactWhatsApp');
            const isShareButton = e.target.closest('#btnActionListingShare');
            const isSaveButton = e.target.closest('#btnActionListingSave');
            const isOptionsButton = e.target.closest('#btnActionListingOptions');
            if (isWhatsAppButton || isShareButton || isSaveButton || isOptionsButton) {
                const isListingBigParent = e.target.closest('.nvListingEachCon1A');
                const businessId = isListingBigParent.getAttribute("data-businessid") || "";
                const sellerId = isListingBigParent.getAttribute("data-sellerid") || "";
                const listingId = isListingBigParent.getAttribute("data-listingid") || "";
                const lives = isListingBigParent.getAttribute("data-lives") || "";
                const from = isListingBigParent.getAttribute("data-from") || "";
                if (isWhatsAppButton) {
                    const whatsAppNumber = isWhatsAppButton.dataset.whatsappnumber || "";
                    console.log('open WhatsApp');
                    if (!whatsAppNumber) return;
                    this._contactWhatsApp(listingId, sellerId, businessId, whatsAppNumber);
                }
                if (isShareButton) {
                    console.log('open share');
                    this._share(listingId, businessId, sellerId);
                }
                if (isSaveButton) {
                    console.log('open save');
                    this._save(listingId);
                }
                if (isOptionsButton) console.log('open options');
            }
        });
    }
    _hideImgOnSwipe() {
        const viewer = document.getElementById("MainContainerForImgDisplayer");
        const imageStrip = document.getElementById("MyOwnImgDisplayerNotAIsCon1");
        const dismissThreshold = 65;
        const directionLockDistance = 10;
        const maxDragDistance = window.innerHeight * 0.75;
        let startX = 0;
        let startY = 0;
        let isDraggingDown = false;
        let directionLocked = false;
        const resetDrag = ()=>{
            imageStrip.style.transition = "transform 180ms ease-out";
            imageStrip.style.transform = "translateY(0)";
            viewer.style.transition = "background-color 180ms ease-out";
            viewer.style.backgroundColor = "";
            setTimeout(()=>{
                imageStrip.style.transition = "";
                viewer.style.transition = "";
            }, 180);
        };
        imageStrip.addEventListener("touchstart", (e)=>{
            if (e.touches.length !== 1) return;
            const image = e.target.closest(".IsForZoom");
            // Zoom state is assigned by updateTransform below.
            if (image?.dataset.zoomed === "true") return;
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            isDraggingDown = false;
            directionLocked = false;
        }, {
            passive: true
        });
        imageStrip.addEventListener("touchmove", (e)=>{
            if (e.touches.length !== 1) return;
            const image = e.target.closest(".IsForZoom");
            // Never dismiss while the image is zoomed.
            if (image?.dataset.zoomed === "true") {
                if (isDraggingDown) resetDrag();
                isDraggingDown = false;
                return;
            }
            const touch = e.touches[0];
            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            // Wait for intentional movement, then decide whether it is vertical.
            if (!directionLocked) {
                if (Math.abs(deltaX) < directionLockDistance && Math.abs(deltaY) < directionLockDistance) return;
                directionLocked = true;
                // Preserve horizontal swiping between images and upward gestures.
                if (deltaY <= 0 || Math.abs(deltaX) > Math.abs(deltaY)) return;
                isDraggingDown = true;
            }
            if (!isDraggingDown) return;
            e.preventDefault();
            const dragY = Math.min(deltaY, maxDragDistance);
            const progress = Math.min(dragY / maxDragDistance, 1);
            imageStrip.style.transition = "none";
            imageStrip.style.transform = `translateY(${dragY}px)`;
            // Optional: fade the backdrop as the image moves down.
            viewer.style.backgroundColor = `rgba(0, 0, 0, ${1 - progress * 0.7})`;
        }, {
            passive: false
        });
        const finishDrag = ()=>{
            if (!isDraggingDown) return;
            const currentTransform = imageStrip.style.transform;
            const draggedDistance = Number(currentTransform.match(/translateY\(([\d.]+)px\)/)?.[1] || 0);
            isDraggingDown = false;
            if (draggedDistance >= dismissThreshold) {
                imageStrip.style.transition = "transform 180ms ease-in";
                imageStrip.style.transform = `translateY(${window.innerHeight}px)`;
                viewer.style.backgroundColor = "rgba(0, 0, 0, 0)";
                setTimeout(()=>{
                    viewer.style.display = "none";
                    imageStrip.style.transform = "";
                    imageStrip.style.transition = "";
                    viewer.style.backgroundColor = "";
                    viewer.style.transition = "";
                }, 180);
                return;
            }
            resetDrag();
        };
        imageStrip.addEventListener("touchend", finishDrag, {
            passive: true
        });
        imageStrip.addEventListener("touchcancel", resetDrag, {
            passive: true
        });
    }
    _myOwnImgDisplayerNotAIs(imgUrls, goTo = 1) {
        const container = document.getElementById("MainContainerForImgDisplayer");
        container.style.display = "flex";
        container.addEventListener("click", (e)=>{
            const isCloseButton = e.target.closest(".closeImgBig");
            if (isCloseButton) container.style.display = "none";
        });
        let imgHtml = ``;
        imgUrls.forEach((img)=>{
            imgHtml += `
      <div class="MyOwnImgDisplayerNotAIsCon1B">
        <img 
          class="MyOwnImgDisplayerNotAIsConIMG IsForZoom"
          src="${img}"
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </div>
    `;
        });
        const finalHtml = `
    <div class="ExitButtonForImgDisplayer closeImgBig topRightExitButtonOnFullScreenWindow">
      <img height="20px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($22804ceefbfec0a6$exports)))}" alt="" />
    </div>

    <div class="imgBackButtonForImgDisplayer">
      <img height="20px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($1364613338738de8$exports)))}" alt="" />
    </div>

    <div class="imgForwardButtonForImgDisplayer">
      <img height="20px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($8dc38640dbfd56a1$exports)))}" alt="" />
    </div>
    
    <div class="imgTrackerForImgDisplayer">
      <div id="imgTrackerForImgDisplayerText" class="imgTrackerForImgDisplayerText">1/${imgUrls.length}</div>
    </div>

    <div id="MyOwnImgDisplayerNotAIsCon1" class="MyOwnImgDisplayerNotAIsCon1">${imgHtml}</div>
  `;
        container.innerHTML = finalHtml;
        const scrollContainer = document.getElementById("MyOwnImgDisplayerNotAIsCon1");
        const trackerText = document.getElementById("imgTrackerForImgDisplayerText");
        const backBtn = container.querySelector(".imgBackButtonForImgDisplayer");
        const forwardBtn = container.querySelector(".imgForwardButtonForImgDisplayer");
        const totalImages = imgUrls.length;
        let currentIndex = Math.max(0, Math.min(goTo - 1, totalImages - 1));
        function scrollToIndex(index) {
            currentIndex = Math.max(0, Math.min(index, totalImages - 1));
            const scrollAmount = currentIndex * scrollContainer.clientWidth;
            scrollContainer.scrollTo({
                left: scrollAmount,
                behavior: "smooth"
            });
            trackerText.textContent = `${currentIndex + 1}/${totalImages}`;
            updateNavButtons();
        }
        function updateNavButtons() {
            if (backBtn) backBtn.style.opacity = currentIndex === 0 ? "0.3" : "1";
            if (forwardBtn) forwardBtn.style.opacity = currentIndex === totalImages - 1 ? "0.3" : "1";
        }
        // 🎯 Initial scroll
        requestAnimationFrame(()=>{
            const scrollAmount = currentIndex * scrollContainer.clientWidth;
            scrollContainer.scrollTo({
                left: scrollAmount,
                behavior: "auto"
            });
            trackerText.textContent = `${currentIndex + 1}/${totalImages}`;
            updateNavButtons();
        });
        // 🔄 Scroll tracking
        let scrollTimeout = null;
        scrollContainer.addEventListener("scroll", ()=>{
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(()=>{
                const index = Math.round(scrollContainer.scrollLeft / scrollContainer.clientWidth);
                currentIndex = Math.max(0, Math.min(index, totalImages - 1));
                trackerText.textContent = `${currentIndex + 1}/${totalImages}`;
                updateNavButtons();
            }, 50);
        });
        // ⬅️➡️ Buttons
        if (backBtn) backBtn.addEventListener("click", ()=>{
            scrollToIndex(currentIndex - 1);
        });
        if (forwardBtn) forwardBtn.addEventListener("click", ()=>{
            scrollToIndex(currentIndex + 1);
        });
        // 🔍 Zoom logic (unchanged)
        let scale = 1;
        function updateContainerHeight(image) {
            const imageHeight = image.naturalHeight * scale;
            const container = document.getElementById("MyOwnImgDisplayerNotAIsCon1");
            container.style.height = `${Math.min(imageHeight, window.innerHeight)}px`;
        }
        const enableZoomForAll = ()=>{
            const images = document.querySelectorAll(".IsForZoom");
            images.forEach((image)=>{
                let scale = 1;
                let offsetX = 0;
                let offsetY = 0;
                let renderedOffsetX = 0;
                let renderedOffsetY = 0;
                let panStartX = 0;
                let panStartY = 0;
                let pinchStartDistance = 0;
                let pinchStartScale = 1;
                let pinchImageX = 0;
                let pinchImageY = 0;
                let pinchBaseLeft = 0;
                let pinchBaseTop = 0;
                let lastTapTime = 0;
                let lastTapX = 0;
                let lastTapY = 0;
                const clampScale = (value)=>Math.min(Math.max(value, 1), 3);
                // const updateTransform = () => {
                //   image.dataset.zoomed = scale > 1 ? "true" : "false";
                //   image.style.transformOrigin = "0 0";
                //   image.style.willChange = "transform";
                //   image.style.transition = "none";
                //   image.style.transform =
                //     `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
                //   renderedOffsetX = offsetX;
                //   renderedOffsetY = offsetY;
                // };
                const updateTransform = (animate = false)=>{
                    image.dataset.zoomed = scale > 1 ? "true" : "false";
                    image.style.transformOrigin = "0 0";
                    image.style.willChange = "transform";
                    image.style.transition = animate ? "transform 280ms cubic-bezier(0.22, 1, 0.36, 1)" : "none";
                    image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
                    renderedOffsetX = offsetX;
                    renderedOffsetY = offsetY;
                };
                const getDistance = (touches)=>{
                    const dx = touches[0].clientX - touches[1].clientX;
                    const dy = touches[0].clientY - touches[1].clientY;
                    return Math.hypot(dx, dy);
                };
                const getMidpoint = (touches)=>({
                        x: (touches[0].clientX + touches[1].clientX) / 2,
                        y: (touches[0].clientY + touches[1].clientY) / 2
                    });
                const keepImageVisible = ()=>{
                    const viewerRect = container.getBoundingClientRect();
                    const imageRect = image.getBoundingClientRect();
                    const baseLeft = imageRect.left - renderedOffsetX;
                    const baseTop = imageRect.top - renderedOffsetY;
                    const scaledWidth = image.offsetWidth * scale;
                    const scaledHeight = image.offsetHeight * scale;
                    const minimumVisible = 48;
                    const minX = scaledWidth > viewerRect.width ? viewerRect.right - baseLeft - scaledWidth : viewerRect.left - baseLeft - scaledWidth + minimumVisible;
                    const maxX = scaledWidth > viewerRect.width ? viewerRect.left - baseLeft : viewerRect.right - baseLeft - minimumVisible;
                    const minY = scaledHeight > viewerRect.height ? viewerRect.bottom - baseTop - scaledHeight : viewerRect.top - baseTop - scaledHeight + minimumVisible;
                    const maxY = scaledHeight > viewerRect.height ? viewerRect.top - baseTop : viewerRect.bottom - baseTop - minimumVisible;
                    offsetX = Math.min(maxX, Math.max(minX, offsetX));
                    offsetY = Math.min(maxY, Math.max(minY, offsetY));
                };
                const toggleDoubleTapZoom = (clientX, clientY)=>{
                    const imageRect = image.getBoundingClientRect();
                    const baseLeft = imageRect.left - renderedOffsetX;
                    const baseTop = imageRect.top - renderedOffsetY;
                    const imagePointX = (clientX - imageRect.left) / scale;
                    const imagePointY = (clientY - imageRect.top) / scale;
                    scale = scale > 1 ? 1 : 2;
                    if (scale === 1) {
                        offsetX = 0;
                        offsetY = 0;
                    } else {
                        offsetX = clientX - baseLeft - imagePointX * scale;
                        offsetY = clientY - baseTop - imagePointY * scale;
                        keepImageVisible();
                    }
                    updateTransform(true);
                };
                image.addEventListener("wheel", (e)=>{
                    e.preventDefault();
                    const imageRect = image.getBoundingClientRect();
                    const baseLeft = imageRect.left - renderedOffsetX;
                    const baseTop = imageRect.top - renderedOffsetY;
                    const imagePointX = (e.clientX - imageRect.left) / scale;
                    const imagePointY = (e.clientY - imageRect.top) / scale;
                    scale = clampScale(scale + (e.deltaY < 0 ? 0.15 : -0.15));
                    offsetX = e.clientX - baseLeft - imagePointX * scale;
                    offsetY = e.clientY - baseTop - imagePointY * scale;
                    if (scale === 1) {
                        offsetX = 0;
                        offsetY = 0;
                    } else keepImageVisible();
                    updateTransform();
                }, {
                    passive: false
                });
                image.addEventListener("touchstart", (e)=>{
                    if (e.touches.length === 1) {
                        const touch = e.touches[0];
                        const now = Date.now();
                        const elapsed = now - lastTapTime;
                        const movedX = Math.abs(touch.clientX - lastTapX);
                        const movedY = Math.abs(touch.clientY - lastTapY);
                        if (elapsed < 280 && movedX < 35 && movedY < 35) {
                            e.preventDefault();
                            lastTapTime = 0;
                            toggleDoubleTapZoom(touch.clientX, touch.clientY);
                            return;
                        }
                        lastTapTime = now;
                        lastTapX = touch.clientX;
                        lastTapY = touch.clientY;
                    }
                    if (e.touches.length === 2) {
                        e.preventDefault();
                        const midpoint = getMidpoint(e.touches);
                        const imageRect = image.getBoundingClientRect();
                        pinchStartDistance = getDistance(e.touches);
                        pinchStartScale = scale;
                        pinchBaseLeft = imageRect.left - renderedOffsetX;
                        pinchBaseTop = imageRect.top - renderedOffsetY;
                        pinchImageX = (midpoint.x - imageRect.left) / scale;
                        pinchImageY = (midpoint.y - imageRect.top) / scale;
                    } else if (e.touches.length === 1 && scale > 1) {
                        panStartX = e.touches[0].clientX;
                        panStartY = e.touches[0].clientY;
                    }
                }, {
                    passive: false
                });
                image.addEventListener("touchmove", (e)=>{
                    if (e.touches.length === 2) {
                        e.preventDefault();
                        const midpoint = getMidpoint(e.touches);
                        const currentDistance = getDistance(e.touches);
                        scale = clampScale(pinchStartScale * (currentDistance / pinchStartDistance));
                        offsetX = midpoint.x - pinchBaseLeft - pinchImageX * scale;
                        offsetY = midpoint.y - pinchBaseTop - pinchImageY * scale;
                        if (scale === 1) {
                            offsetX = 0;
                            offsetY = 0;
                        } else keepImageVisible();
                        updateTransform();
                    } else if (e.touches.length === 1 && scale > 1) {
                        e.preventDefault();
                        const touch = e.touches[0];
                        offsetX += touch.clientX - panStartX;
                        offsetY += touch.clientY - panStartY;
                        panStartX = touch.clientX;
                        panStartY = touch.clientY;
                        keepImageVisible();
                        updateTransform();
                    }
                }, {
                    passive: false
                });
                image.addEventListener("touchend", (e)=>{
                    pinchStartDistance = 0;
                    if (e.touches.length === 1 && scale > 1) {
                        panStartX = e.touches[0].clientX;
                        panStartY = e.touches[0].clientY;
                    }
                    if (scale <= 1) {
                        scale = 1;
                        offsetX = 0;
                        offsetY = 0;
                        updateTransform();
                    }
                });
                image.addEventListener("touchcancel", ()=>{
                    pinchStartDistance = 0;
                });
            });
            this._hideImgOnSwipe();
        };
        enableZoomForAll();
        const images = container.querySelectorAll(".IsForZoom");
        images.forEach((imgEl)=>{
            let retries = 0;
            const maxRetries = 2;
            imgEl.addEventListener("error", ()=>{
                if (retries >= maxRetries) return;
                retries++;
                const url = new URL(imgEl.src);
                url.searchParams.set("retry", Date.now());
                imgEl.src = url.toString();
            });
        });
    }
    // New stuff down
    async _contactWhatsApp(id, sellerId, businessId, whatsAppNumber) {
        let seller = null;
        let business = null;
        let contactName = '';
        let contactNamePrefix = 'Les';
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Preparando Contacto");
        if (businessId) business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getBusinessById(businessId);
        else seller = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${sellerId}`);
        if (business) contactName = business?.name || '';
        else {
            contactName = seller?.userName || '';
            contactNamePrefix = 'Te';
        }
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        const getUrlToCurrentListing = async ()=>{
            console.log(businessId);
            const url = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessId, sellerId, id);
            return url;
        };
        const url = await getUrlToCurrentListing();
        // console.log(this.#currentListing);
        const openWhatsApp = (phoneNumber, message)=>{
            try {
                const encodedMessage = encodeURIComponent(message);
                const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
                return whatsappUrl;
            } catch (error) {
                console.error("Error opening WhatsApp link:", error);
            }
        };
        const message = `${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._getSpanishGreetingForDay()}, *${contactName}*.\n${contactNamePrefix} estoy contactando desde ${url}\n\n*Mesaje:*`;
        (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink(openWhatsApp(whatsAppNumber, message));
    }
    async _share(id) {
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Preparando informaci\xf3n para compartir");
        let business = null;
        if (this.#currentListing.businessId) {
            business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getBusinessById(this.#currentListing.businessId);
            console.log(business);
        }
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        const listingName = this.#currentListing.listingName;
        const listingId = this.#currentListing.listingId;
        let businessName = "";
        let sellerId = this.#currentListing.sellerId || '';
        let businessId = this.#currentListing.businessId || '';
        console.log(id, businessId, sellerId);
        if (listingId !== id) {
            alert("Hay un error en identificar este negocio. Por favor cierra este negocio y \xe1brelo de nuevo.");
            return;
        }
        console.warn(this.#currentListing.businessId);
        const getUrlToCurrentListing = async ()=>{
            console.log(businessId);
            if (this.#currentListing.businessId) {
                businessName = business.name;
                businessId = business.businessId;
            }
            const url = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createUrlForSharing(businessId, sellerId, id);
            return url;
        };
        const url = await getUrlToCurrentListing();
        const dataToSendToShareFunction = {
            listing: this.#currentListing,
            business: business,
            listingUrl: url
        };
        (0, $dc7988840845b777$export$2e2bcd8739ae039)._open(dataToSendToShareFunction, "listing");
    }
    async _save(id) {
        const btnActionListingSave = document.getElementById("btnActionListingSave");
        const business = (0, $fa6b7443c0c8b64b$export$2e2bcd8739ae039)._getCurrentBusiness();
        const listingId = this.#currentListing.listingId;
        let businessId = "";
        let path = `listings/${listingId}`;
        if (this.#currentListing.businessId) {
            businessId = business.businessId;
            path = `businesses/${businessId}/listings/${listingId}`;
        }
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (account) {
            console.log("clicked");
            const dataSendToShare = {
                listingId: listingId,
                businessId: businessId
            };
            btnActionListingSave.insertAdjacentHTML("beforeend", this._returnMiniSpinner());
            console.log(businessId);
            const saveResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateSavesOnListings(dataSendToShare);
            console.log(saveResult);
            if (saveResult.data.status === "success") {
                if (saveResult.data.action === "saved") {
                    (0, $747dcf33e8614cd4$export$2e2bcd8739ae039)._getAccountState();
                    btnActionListingSave.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($5cf7715425f15f40$exports)));
                    btnActionListingSave.querySelector(".miniSpinneForButtons").remove();
                }
                if (saveResult.data.action === "removed") {
                    (0, $747dcf33e8614cd4$export$2e2bcd8739ae039)._getAccountState();
                    btnActionListingSave.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($0a4c20255f61e245$exports)));
                    btnActionListingSave.querySelector(".miniSpinneForButtons").remove();
                }
            }
        } else (0, $5b997bd2b2817dfd$export$2e2bcd8739ae039)._displayOptions(null, "Para guardar un negocio tienes que tener una cuenta activa en este dispositivo.");
    }
    _more(id) {
        alert("Estamos desarollando mas funciones para ti. Gracias por tenernos paciencia mientras estamos trabajando. Si tienes algunas sugerencias, cont\xe1ctanos.");
    }
}
var $b03a20a2d7a048cf$export$2e2bcd8739ae039 = new $b03a20a2d7a048cf$var$display();






var $2ef7a81065138f4b$exports = {};
$2ef7a81065138f4b$exports = new URL("video-mercado-mai.6f6246d3.png", import.meta.url).toString();


class $52612880b382edba$var$generateHtml {
    _helpVideo(data, sections) {
        return `
        <div data-videourl="${data.videoUrl}" class="HelpSectionVideoCon1 openVideo">
            <div class="HelpSectionVideoCon2">
              <div class="HelpSectionVideoCon3">
                <img
                  class="HelpSectionVideoThumbnailCon"
                  src="${data.thumbnailImgUrl}"
                  alt=""
                />
                <img
                  class="HelpSectionVideoPLayVideoIcon"
                  height="32px"
                  src="${0, (/*@__PURE__*/$parcel$interopDefault($2ef7a81065138f4b$exports))}"
                  alt=""
                />
              </div>
            </div>
            <div class="HelpSectionVideoCon4">
              <div class="HelpSectionVideoText1">${data.name}</div>
              <div class="HelpSectionVideoCon5">
                <div class="HelpSectionVideoText2">
                  ${data.description}
                </div>
              </div>    
                <div class="HelpSectionVideoCon5">
                    ${sections}
                </div>
            </div>
        </div>`;
    }
}
var $52612880b382edba$export$2e2bcd8739ae039 = new $52612880b382edba$var$generateHtml();



const $490f6a1b66767e47$var$HelpOpenCon1Main = document.getElementById("HelpOpenCon1Main");
const $490f6a1b66767e47$var$MainContainerForVideoDisplayer = document.getElementById("MainContainerForVideoDisplayer");
const $490f6a1b66767e47$var$HelpOpenCon1MainButtonBack = document.getElementById("HelpOpenCon1MainButtonBack");
// const HelpSectionChatButton = document.getElementById("HelpSectionChatButton");
const $490f6a1b66767e47$var$HelpSectionInsertVideos = document.getElementById("HelpSectionInsertVideos");
const $490f6a1b66767e47$var$HelpSectionSearchInput = document.getElementById("HelpSectionSearchInput");
const $490f6a1b66767e47$var$HelpSectionCon9All = document.querySelectorAll(".HelpSectionCon9");
class $490f6a1b66767e47$var$help {
    #helpVideos;
    #generalEventInitialized = false;
    constructor(){
        this._eventsGeneral();
    }
    async _open(openOn) {
        console.log(openOn);
        $490f6a1b66767e47$var$HelpOpenCon1Main.style.display = "flex";
        await this._getAllVideos();
        if (openOn) this._searchWhat(openOn);
        this._setHelpMessageForWhatsAppButton(openOn);
    }
    _close() {
        console.log("Close help was called");
        $490f6a1b66767e47$var$HelpOpenCon1Main.style.display = "none";
    }
    _setHelpMessageForWhatsAppButton(input) {
        const whatsAppHelpButton = document.getElementById("whatsAppHelpButton");
        let helpMessage = "https://wa.me/9967306118?text=Necesito%20ayuda%20en%20Mercado%20Mai%20con:%20";
        if (input === "mercadoMai") helpMessage += "la%20aplicaci\xf3n.";
        if (input === "createAccount") helpMessage += "crear%20una%20cuenta.";
        if (input === "logIn") helpMessage += "ingresar%20a%20mi%20cuenta.";
        if (input === "wallet") helpMessage += "mi%20wallet.";
        whatsAppHelpButton.href = helpMessage;
    }
    _search(input) {
        let vids = [];
        if (!input || input.length < 1) vids = this.#helpVideos;
        else {
            const words = input.toLowerCase().split(" "); // Convert to lowercase for better matching
            console.log("Search words:", words);
            const videoScores = new Map(); // Stores video ID → score mapping
            words.forEach((word)=>{
                this.#helpVideos.forEach((vid)=>{
                    console.log(vid);
                    const matchCount = vid.tokens.filter((token)=>token.includes(word)).length; // Count matches
                    if (matchCount > 0) {
                        if (!videoScores.has(vid)) videoScores.set(vid, matchCount); // Initialize with match count
                        else videoScores.set(vid, videoScores.get(vid) + matchCount); // Add to existing score
                    }
                });
            });
            // Convert Map to sorted array based on score (higher first)
            vids = [
                ...videoScores.entries()
            ].sort((a, b)=>b[1] - a[1]) // Sort by score (descending)
            .map((entry)=>entry[0]); // Extract video objects
            console.log("Sorted videos by relevance:", vids);
        }
        this._insertVideos(vids);
    }
    _openChat() {
        const chatButton = document.getElementById("whatsAppHelpButton");
        chatButton.click();
    }
    _myOwnVidDisplayerNotAIs(vidUrls) {
        const container = document.getElementById("MainContainerForVideoDisplayer");
        container.style.display = "flex";
        container.addEventListener("click", (e)=>{
            const isCloseButton = e.target.closest(".ExitButtonForImgDisplayer");
            if (isCloseButton) container.style.display = "none";
        });
        function getYouTubeVideoId(url) {
            const regex = /(?:youtube\.com\/(?:.*v=|.*\/embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = url.match(regex);
            return match ? match[1] : null;
        }
        let imgHtml = ``;
        vidUrls.forEach((vid)=>{
            // src="https://www.youtube.com/embed/${getYouTubeVideoId(vid)}?autoplay=1"
            imgHtml += `
        <iframe 
        id="iframForVideoForClose"
        width="600"
        height="500"
        src="https://www.youtube.com/embed/${vid}?autoplay=1"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen
        ></iframe>
`;
            console.log(vid);
            console.log(getYouTubeVideoId(vid));
        });
        const finalHtml = `
            <div id="ExitButtonForVidDisplayer" class="ExitButtonForVidDisplayer closeVidBig">
              <img height="32px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($9ac61311daad3145$exports)))}" alt="" />
            </div>
            <div id="MyOwnImgDisplayerNotAIsCon1" class="MyOwnImgDisplayerNotAIsCon1">${imgHtml}</div>`;
        container.innerHTML = finalHtml;
        this._eventSBigVid();
    }
    _eventSBigVid() {
        const ExitButtonForVidDisplayer = document.getElementById("ExitButtonForVidDisplayer");
        ExitButtonForVidDisplayer.addEventListener("click", (e)=>{
            console.log("also clicked here");
            console.log("click here");
            const iframForVideoForClose = document.getElementById("iframForVideoForClose");
            console.log(iframForVideoForClose);
            if (iframForVideoForClose) iframForVideoForClose.remove();
            $490f6a1b66767e47$var$MainContainerForVideoDisplayer.style.display = "none";
        });
    }
    async _getAllVideos() {
        // helper._logToConsole("here it worked");
        this.#helpVideos = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllDocsFromPathByMostRecent("helpVideos");
        console.log(this.#helpVideos);
        this._insertVideos(this.#helpVideos);
    // this._myOwnVidDisplayerNotAIs([this.#helpVideos[0].videoUrl]);
    }
    //   <div class="HelpSectionVideoText2">
    //    </div>
    _insertVideos(videos) {
        let html = ``;
        videos.forEach((video)=>{
            let sections = ``;
            console.log(video.sections);
            video.sections.forEach((section)=>{
                console.log("here");
                sections += `<div class="HelpSectionVideoText2B">
        ${section}
                        </div>`;
            });
            console.log(sections);
            html += (0, $52612880b382edba$export$2e2bcd8739ae039)._helpVideo(video, sections);
        });
        $490f6a1b66767e47$var$HelpSectionInsertVideos.innerHTML = "";
        $490f6a1b66767e47$var$HelpSectionInsertVideos.insertAdjacentHTML("beforeend", html);
    }
    _searchWhat(input) {
        let vids = [];
        this.#helpVideos.forEach((vid)=>{
            if (vid.shortcut === input) vids.push(vid);
        });
        if (vids.length < 1) this.#helpVideos.forEach((vid)=>{
            if (vid.shortcut === "unavailable") vids.push(vid);
        });
        $490f6a1b66767e47$var$HelpSectionSearchInput.value = input;
        this._insertVideos(vids);
        console.log(input);
    }
    _eventsGeneral() {
        $490f6a1b66767e47$var$HelpOpenCon1MainButtonBack.addEventListener("click", ()=>{
            this._close();
        });
        $490f6a1b66767e47$var$HelpSectionCon9All.forEach((button)=>{
            button.addEventListener("click", ()=>{
                const searchWhat = button.dataset.searchwhat;
                this._searchWhat(searchWhat);
            });
        });
        // HelpSectionChatButton.addEventListener("click", () => {
        //   console.log("open whatsApp");
        // });
        if (this.#generalEventInitialized) return;
        $490f6a1b66767e47$var$HelpSectionInsertVideos.addEventListener("click", (e)=>{
            const thisVideo = e.target.closest(".HelpSectionVideoCon1");
            if (thisVideo) {
                const allvids = document.querySelectorAll(".HelpSectionVideoCon1");
                allvids.forEach((vid)=>{
                    if (vid !== thisVideo) vid.classList.remove("HelpSectionVideoCon1Active");
                    else thisVideo.classList.add("HelpSectionVideoCon1Active");
                });
                const url = thisVideo.dataset.videourl;
                if (url) this._myOwnVidDisplayerNotAIs([
                    url
                ]);
            }
        });
        $490f6a1b66767e47$var$HelpSectionSearchInput.addEventListener("keyup", ()=>{
            this._search($490f6a1b66767e47$var$HelpSectionSearchInput.value.trim());
        });
        $490f6a1b66767e47$var$HelpSectionSearchInput.addEventListener("blur", ()=>{
            this._search($490f6a1b66767e47$var$HelpSectionSearchInput.value.trim());
        });
        this.#generalEventInitialized = true;
    }
}
var $490f6a1b66767e47$export$2e2bcd8739ae039 = new $490f6a1b66767e47$var$help();











class $6f7df25f5169883c$var$generateHtml {
    _NVGenerateSeller(data, businessHtml, listingsHtml) {
        let sellerLevel = data.sellerLevel || 'standart';
        sellerLevel = 'standart'; // just gaurd for now, to later get seller levels in place
        let proLevelDataDisp = 'none';
        let about = data.aboutMe || 'Vendedor en Mercado MAI.';
        let profileImageUrl = data?.profileImages?.[0]?.res_200 ?? data?.profileImageUrl;
        let origImg = [];
        origImg.push(data?.profileImages?.[0]?.res_1000 ?? data?.profileImageUrl);
        let listingsNum = data?.numberOfListings || 0;
        let sellerLevelBackgroundClass = '';
        let sellerLevelText1Class = '';
        let sellerLevelText2Class = '';
        let sellerLevelStandartClass = '';
        let sellerLevelText1 = '';
        let sellerLevelText2 = '';
        if (sellerLevel === 'gold') {
            proLevelDataDisp = 'flex';
            sellerLevelBackgroundClass = 'sellerLevelGold';
            sellerLevelText1 = 'Vendedor nivel ORO';
            sellerLevelText2 = 'Mercado MAI recomienda este vendedor por publicar frecuentemente.';
        } else if (sellerLevel === 'silver') {
            proLevelDataDisp = 'flex';
            sellerLevelBackgroundClass = 'sellerLevelSilver';
            sellerLevelText1 = 'Vendedor nivel PLATA';
            sellerLevelText2 = 'Mercado MAI recomienda este vendedor por su esfuerzo de subir nuevas publicaciones.';
        } else if (sellerLevel === 'reported') {
            proLevelDataDisp = 'flex';
            sellerLevelBackgroundClass = 'sellerLevelReported';
            sellerLevelText1Class = 'sellerLevelReportedText1';
            sellerLevelText2Class = 'sellerLevelReportedText2';
            sellerLevelText1 = 'Vendedor REPORTADO';
            sellerLevelText2 = 'Mercado MAI no recomienda este vendedor por tener reportes negativos de nuestros usuarios.';
        } else sellerLevelStandartClass = 'nvSellerProfileCon1Standart';
        const sellerHtml = `
        
          <div data-sellerid="${data.userId}" class="ActionOpenForDisplaySeller nvSellerProfileCon1 ${sellerLevelStandartClass}">
            <div class="nvSellerProfileCon2">
              <div class="nvSellerProfileCon3 ${sellerLevelBackgroundClass}">
                <img data-origimg="${origImg.join("\xb0-\xb0|\xb0-\xb0?\xb0-\xb0|\xb0-\xb0")}" class="nvSellerProfileCon3Image ImgForBigDisplay hasOriginalImages" src="${profileImageUrl}">
              </div>
              <div class="nvSellerProfileCon4">
                <div class="nvSellerProfileCon5">
                  <div class="nvSellerProfileText1">${data.userName}</div>
                </div>
                <div class="nvSellerProfileCon6">
                  <div class="nvSellerProfileText4">${about}</div>
                </div>
              </div>
            </div>
            <div class="nvSellerProfileCon7A">
              <div class="nvSellerProfileCon7">
                <div class="nvSellerProfileCon11">
                  <div class="nvSellerProfileText3">Datos sobre este vendedor</div>
                </div>
                <div class="nvSellerProfileCon8">
                  <div class="nvSellerProfileCon9">
                    <div class="nvSellerProfileText4">Registrado desde</div>
                    <div class="nvSellerProfileText5">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.createdAt, false)}</div>
                  </div>
                  <div class="nvSellerProfileCon9" style="display: none">
                    <div class="nvSellerProfileText4">Publicaciones</div>
                    <div class="nvSellerProfileText5">${listingsNum}</div>
                  </div>
                  <div class="nvSellerProfileCon9">
                    <div class="nvSellerProfileText4">Numero de WhatsApp</div>
                    <div class="nvSellerProfileText5">${data.callNumber}</div>
                  </div>
                  <div class="nvSellerProfileCon9">
                    <div class="nvSellerProfileText4">Numero de llamadas</div>
                    <div class="nvSellerProfileText5">${data.whatsAppNumber}</div>
                  </div>
                </div>
              </div>
              <div class="nvSellerProfileCon13" style="display: ${proLevelDataDisp}">
                <div class="nvSellerProfileCon11">
                  <div class="nvSellerProfileText3">Listados del perfil del vendedor</div>
                </div>
                <div class="nvSellerProfileCon14">
                  <div class="nvSellerProfileCon15">${listingsHtml}</div>
                </div>
              </div>
              <div class="nvSellerProfileCon10" style="display: ${proLevelDataDisp}">
                <div class="nvSellerProfileCon11">
                  <div class="nvSellerProfileText3">Negocio del vendedor</div>
                </div>
                <div class="nvSellerProfileCon12">${businessHtml}</div>
              </div>
            </div>
            <div class="nvSellerProfileCon16">
              <div class="nvSellerProfileCon18">
                <div class="nvSellerProfileCon19">
                  <div class="nvSellerProfileText6">Ver Perfil</div>
                   <img height="16px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($8dc38640dbfd56a1$exports)))}">
                </div>
              </div>
            </div>
          </div>
        
    `;
        let finalSellerHtml1 = sellerHtml;
        if (sellerLevel === 'gold' || sellerLevel === 'silver' || sellerLevel === 'reported') finalSellerHtml1 = `
      <div class="sellersV2LevelCon1 ">
        <div class="sellersV2LevelCon2 ${sellerLevelBackgroundClass}">
          <div class="sellersV2LevelText1 ${sellerLevelText1Class}">${sellerLevelText1}</div>
          <div class="sellersV2LevelText2 ${sellerLevelText2Class}">${sellerLevelText2}</div>
        </div>
        <div class="sellersV2LevelCon3">${sellerHtml}</div>
      </div>
  `;
        let finalSellerHtml = `
        <div class="nvListingVerCon1A">${finalSellerHtml1}</div>
  `;
        return finalSellerHtml;
    }
    _NVSellerEach(data, businessHtml, listingsHtml) {
        const whatsAppNumber = (data.whatsAppNumberCountryCode + data.whatsAppNumber).replace(/\D/g, '');
        const phoneNumber = (data.callNumberCountryCode + data.callNumber).replace(/\D/g, '');
        let sellerLevel = data.sellerLevel || 'standart';
        sellerLevel = 'standart'; // just gaurd for now, to later get seller levels in place
        let proStatusClass = '';
        let about = data.aboutMe || 'Vendedor en Mercado MAI.';
        let profileImageUrl = data?.profileImages?.[0]?.res_200 ?? data?.profileImageUrl;
        let origImg = [];
        origImg.push(data?.profileImages?.[0]?.res_1000 ?? data?.profileImageUrl);
        let listingsNum = data?.numberOfListings || 0;
        let sellerLevelBadgeHtml = ``;
        let sellerLevelText1 = '';
        let sellerLevelText2 = '';
        let sellerLevelText1Class = '';
        let sellerLevelText2Class = '';
        if (sellerLevel === 'gold') {
            proStatusClass = 'sellerLevelGold';
            sellerLevelText1 = 'Vendedor nivel ORO';
            sellerLevelText2 = 'Mercado MAI recomienda este vendedor por publicar frecuentemente.';
        } else if (sellerLevel === 'silver') {
            proStatusClass = 'sellerLevelSilver';
            sellerLevelText1 = 'Vendedor nivel PLATA';
            sellerLevelText2 = 'Mercado MAI recomienda este vendedor por su esfuerzo de subir nuevas publicaciones.';
        } else if (sellerLevel === 'reported') {
            proStatusClass = 'sellerLevelReported';
            sellerLevelText1Class = 'sellerLevelReportedText1';
            sellerLevelText2Class = 'sellerLevelReportedText2';
            sellerLevelText1 = 'Vendedor REPORTADO';
            sellerLevelText2 = 'Mercado MAI no recomienda este vendedor por tener reportes negativos de nuestros usuarios.';
        }
        if (sellerLevel === 'gold' || sellerLevel === 'silver' || sellerLevel === 'reported') sellerLevelBadgeHtml = `
        <div class="sellersV2LevelCon1A">
          <div class="sellersV2LevelCon2A ${proStatusClass}">
            <div class="sellersV2LevelText1 ${sellerLevelText1Class}">${sellerLevelText1}</div>
            <div class="sellersV2LevelText2 ${sellerLevelText2Class}">${sellerLevelText2}</div>
          </div>
        </div>
      `;
        return `
<div class="nvSellerEachCon1">
  <div class="nvSellerEachCon2">

      <div class="nvSellerEachCon4">
        <div class="BnvBusinessEachCon2 CloseCurrentStackPageButton">
          <div class="BnvBusinessEachCon3">
            <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($8fd602925f160669$exports))}"/>
          </div>
        </div>
      </div>
      
      <div class="nvSellerEachCon5">
        <div class="nvSellerEachCon6">
          <div class="nvSellerEachCon7">
            <div class="nvSellerEachText1">${data.userName}</div>
          </div>
          <div class="nvSellerEachCon8">
            <div class="nvSellerProfileText4">${about}</div>
          </div>
        </div>
        <div class="nvSellerProfileCon3 ${proStatusClass}">
          <img data-origimg="${origImg.join("\xb0-\xb0|\xb0-\xb0?\xb0-\xb0|\xb0-\xb0")}" class="nvSellerProfileCon3Image ImgForBigDisplay hasOriginalImages" src="${profileImageUrl}">
        </div>
      </div>
  </div>

  ${sellerLevelBadgeHtml}

  <div id="nvSellerEachCon10ScrollCon" class="nvSellerEachCon10">
    <div class="nvSellerEachCon11">
      <div class="nvSellerEachCon11B">
        <div class="nvSellerEachCon11C">
          <div class="nvSellerEachText3">Datos sobre este vendedor</div>
        </div>
        <div class="nvSellerEachCon12">
          <div class="nvSellerProfileCon9">
            <div class="nvSellerProfileText4">Registrado desde</div>
            <div class="nvSellerProfileText5">${(0, $a082c89adac62edb$export$2e2bcd8739ae039)._convertServerTimestampToReadableTime(data.createdAt, false)}</div>
          </div>
          <div class="nvSellerProfileCon9" style="display: none">
            <div class="nvSellerProfileText4">Publicaciones</div>
            <div class="nvSellerProfileText5">${listingsNum}</div>
          </div>
          <div class="nvSellerProfileCon9">
            <div class="nvSellerProfileText4">Numero de WhatsApp</div>
            <div class="nvSellerProfileText5">${data.callNumber}</div>
          </div>
          <div class="nvSellerProfileCon9">
            <div class="nvSellerProfileText4">Numero de llamadas</div>
            <div class="nvSellerProfileText5">${data.whatsAppNumber}</div>
          </div>
        </div>
      </div>
      <div class="nvListingEachCon14">

        <a class="nvListingEachCon16B" href="tel:${phoneNumber}">
          <div class="nvSellerEachText5">Llamar</div>
          <img height="18px" class="nvSellerEachCon4Image" src="${0, (/*@__PURE__*/$parcel$interopDefault($ac3abc5c3e0decae$exports))}">
        </a>

        <a class="nvSellerEachCon15" href="https://wa.me/${whatsAppNumber}?text=${encodeURIComponent('Te estoy contactando desde Mercado MAI')}" target="_blank" rel="noopener" >
          <div class="nvSellerEachText4">WhatsApp</div>
          <img height="18px" class="nvSellerEachCon4Image" src="${0, (/*@__PURE__*/$parcel$interopDefault($070672480c5f4a25$exports))}">
        </a>

      </div>
    </div>
    <div class="nvSellerEachCon17">
      <div class="nvSellerEachCon18">
        <div class="nvSellerEachCon19">
          <div class="nvSellerEachText6">Empresas del vendedor</div>
        </div>
        <div id="nvSellerEachCon20InsertBusinesses" class="nvSellerEachCon20">${businessHtml}</div>
      </div>
      <div class="nvSellerEachCon21">
        <div class="nvSellerEachCon19">
          <div class="nvSellerEachText6">Listados del perfil del vendedor</div>
        </div>
        <div id="nvSellerEachCon22InsertListings"  class="nvSellerEachCon22">${listingsHtml}</div>
      </div>
    </div>
  </div>
</div>

  

    `;
    }
}
var $6f7df25f5169883c$export$2e2bcd8739ae039 = new $6f7df25f5169883c$var$generateHtml();







class $3f7c3a69d36c3418$var$displayIndSellers {
    #lastVisListingDoc = null;
    #isLastListing = false;
    #isLoadingListing = false;
    async _displaySellerEach(sellerId) {
        this.#lastVisListingDoc = null;
        this.#isLastListing = false;
        this.#isLoadingListing = false;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Estamos cargando el vendedor");
        let data = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${sellerId}`);
        const sellerHtml = (0, $6f7df25f5169883c$export$2e2bcd8739ae039)._NVSellerEach(data);
        (0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._display(sellerHtml);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        this._detectNearBottom(data, 'nvSellerEachCon10ScrollCon', 100);
        const nvSellerEachCon20InsertBusinesses = document.getElementById("nvSellerEachCon20InsertBusinesses");
        const nvSellerEachCon22InsertListings = document.getElementById("nvSellerEachCon22InsertListings");
        let sellerLevel = data.sellerLevel || 'basic';
        nvSellerEachCon20InsertBusinesses.innerHTML = `
      <div class="indsellerText7">Este vendedor no tiene una Empresa en Mercado MAI</div>
    `;
        nvSellerEachCon22InsertListings.innerHTML = `
      <div class="indsellerText7">Este vendedor no tiene listados publicados en Mercado MAI en este momento</div>
    `;
        function _getOwnerBusinessId(businesses) {
            if (!Array.isArray(businesses)) return null;
            const ownerBusiness = businesses.find((b)=>b?.role === 'owner' && b?.id);
            return ownerBusiness ? ownerBusiness.id : null;
        }
        const businessIdOwn = _getOwnerBusinessId(data.businesses);
        console.log(data.businesses);
        if (data?.businesses?.length > 0) {
            nvSellerEachCon20InsertBusinesses.innerHTML = `
      <div class="indsellerText7">Cargando Empresas...</div>
    `;
            for (const [index, businessLog] of data?.businesses?.entries()){
                if (index === 0) nvSellerEachCon20InsertBusinesses.innerHTML = '';
                let businessHtml = '';
                let listingsHtml = ``;
                const business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${businessLog.id}`);
                const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(null, 6, `businesses/${business.businessId}/listings`);
                if (listings.length < 1) listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings();
                else for (const listing of listings)listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing, null, null, true);
                businessHtml += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._generateBusiness2v(listingsHtml, business, 'flex');
                nvSellerEachCon20InsertBusinesses.insertAdjacentHTML("beforeend", businessHtml);
            }
        }
        this._fillInListings(data);
    }
    async _fillInListings(data) {
        if (this.#isLastListing) return;
        if (this.#isLoadingListing) return;
        this.#isLoadingListing = true;
        const nvSellerEachCon22InsertListings = document.getElementById("nvSellerEachCon22InsertListings");
        const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(this.#lastVisListingDoc, 5, `accounts/${data.userId}/listings`);
        if (listings?.length > 0) {
            console.log('here');
            if (!this.#lastVisListingDoc) nvSellerEachCon22InsertListings.innerHTML = `
      <div class="indsellerText7">Cargando Listados...</div>
    `;
            for (const [index, listing] of listings.entries()){
                if (index === 0 && !this.#lastVisListingDoc) nvSellerEachCon22InsertListings.innerHTML = '';
                const ListingsHtml = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing, false, "listing", false);
                nvSellerEachCon22InsertListings.insertAdjacentHTML('beforeend', ListingsHtml);
            }
            this.#lastVisListingDoc = lastVisibleDoc;
            nvSellerEachCon22InsertListings.insertAdjacentHTML('beforeend', (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._makeAddSetToInsert());
        } else {
            console.log('here');
            this.#isLastListing = true;
        }
        this.#isLoadingListing = false;
    }
    _detectNearBottom(data, containerId, margin = 100) {
        const container = document.getElementById(containerId);
        if (!container) return;
        let isTriggered = false;
        container.addEventListener("scroll", ()=>{
            const distanceToBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
            if (distanceToBottom <= margin) // 🔒 prevent spam triggers while still near bottom
            {
                if (!isTriggered) {
                    isTriggered = true;
                    this._fillInListings(data);
                }
            } else // 🔓 reset when user scrolls up again
            isTriggered = false;
        });
    }
    async _display(data) {
        let sellerLevel = data.sellerLevel || 'basic';
        let businessHtml = `
      <div class="indsellerText7">Este vendedor no tiene un negocio en Mercado MAI</div>
    `;
        let ListingsHtml = `
      <div class="indsellerText7">Este vendedor no tiene listados publicados en Mercado MAI en este momento</div>
    `;
        function _getOwnerBusinessId(businesses) {
            if (!Array.isArray(businesses)) return null;
            const ownerBusiness = businesses.find((b)=>b?.role === 'owner' && b?.id);
            return ownerBusiness ? ownerBusiness.id : null;
        }
        const businessId = _getOwnerBusinessId(data.businesses);
        if (sellerLevel === 'gold' || sellerLevel === 'silver' || sellerLevel === 'bronze') {
            if (businessId) {
                businessHtml = "";
                let listingsHtml = ``;
                const business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${businessId}`);
                const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(null, 6, `businesses/${business.businessId}/listings`);
                if (listings.length < 1) listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings();
                else for (const listing of listings)listingsHtml += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMini(listing, business.colors, "listingInBusiness", business.businessId);
                businessHtml = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._generateBusiness2v(listingsHtml, business, 'flex', true);
            }
            // const loadedListings = await firebase._getAllDocsFromPathByMostRecent(`accounts/${data.userId}/listings`, true, 5)
            // console.log(loadedListings)
            // if (loadedListings) {
            // }
            const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(null, 6, `accounts/${data.userId}/listings`);
            if (listings) {
                ListingsHtml = '';
                for (const listing of listings)ListingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing, null, null, true);
            }
        }
        return (0, $6f7df25f5169883c$export$2e2bcd8739ae039)._NVGenerateSeller(data, businessHtml, ListingsHtml);
    }
    async _insertSellerListings(data) {
        const sellersListingCon = document.getElementById(`${data.id}`);
        console.log(sellersListingCon);
        if (!sellersListingCon) return;
        if (data?.listings?.length > 0) {
            sellersListingCon.innerHTML = "";
            for (const listinId of data.listings){
                const listing = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`listings/${listinId}`);
                const sellersListingHtml = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVertical(listing, (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._getColors(), "listing", null);
                sellersListingCon.insertAdjacentHTML("beforeend", sellersListingHtml);
            }
        }
    }
}
var $3f7c3a69d36c3418$export$2e2bcd8739ae039 = new $3f7c3a69d36c3418$var$displayIndSellers();






var $79ef4071ec7971f4$exports = {};
$79ef4071ec7971f4$exports = new URL("MAI hand shake.452d57f2.png", import.meta.url).toString();


class $82c43ca230401e51$var$generateHtml {
    _CTARegister(siteVisits, appInstalls, listings, users, sellers, businesses, headerText = "Registrate, y empieza a publicar", header2Text = "\xdanete a", Btn1Disp = "flex", Btn2Text = "Despu\xe9s", DoNotShowDisp = "flex") {
        return `
    <div class="ctaRegisterCon1">
        <div class="ctaRegisterCon2">
          <div class="ctaRegisterCon3">
            <div class="ctaRegisterText1">${headerText}</div>
          </div>
          <div class="ctaRegisterCon3B">
            <img height="40px" src="${0, (/*@__PURE__*/$parcel$interopDefault($79ef4071ec7971f4$exports))}" />
          </div>
          <div class="ctaRegisterCon4">
            <div class="ctaRegisterCon5">
              <div class="ctaRegisterText2">${header2Text}</div>
            </div>
            <div class="ctaRegisterCon6">
              <div class="ctaRegisterCon7">
                <div class="ctaRegisterCon8">
                  <div class="ctaRegisterStatCon1">
                    <div data-stat="sitevisits" class="ctaRegisterStatText1">
                     ${siteVisits}
                    </div>
                  </div>
                  <div class="ctaRegisterStatCon1">
                    <div data-stat="appinstalls" class="ctaRegisterStatText1">
                      ${appInstalls}
                    </div>
                  </div>
                  <div class="ctaRegisterStatCon1">
                    <div data-stat="listings" class="ctaRegisterStatText1">
                      ${listings}
                    </div>
                  </div>
                  <div class="ctaRegisterStatCon1">
                    <div data-stat="users" class="ctaRegisterStatText1">
                      ${users}
                    </div>
                  </div>
                  <div class="ctaRegisterStatCon1">
                    <div data-stat="sellers" class="ctaRegisterStatText1">
                      ${sellers}
                    </div>
                  </div>
                  <div class="ctaRegisterStatCon1">
                    <div data-stat="businesses" class="ctaRegisterStatText1">
                      ${businesses}
                    </div>
                  </div>
                </div>
                <div class="ctaRegisterCon9">
                  <div class="ctaRegisterStatCon2">
                    <div class="ctaRegisterStatText2">Visitas a la app</div>
                  </div>
                  <div class="ctaRegisterStatCon2">
                    <div class="ctaRegisterStatText2">
                      Instalaciones de la app
                    </div>
                  </div>
                  <div class="ctaRegisterStatCon2">
                    <div class="ctaRegisterStatText2">Publicaciones</div>
                  </div>
                  <div class="ctaRegisterStatCon2">
                    <div class="ctaRegisterStatText2">Usuarios registrados</div>
                  </div>
                  <div class="ctaRegisterStatCon2">
                    <div class="ctaRegisterStatText2">Vendedores</div>
                  </div>
                  <div class="ctaRegisterStatCon2">
                    <div class="ctaRegisterStatText2">Negocios</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ctaRegisterCon10">
          <div id="ctaRegisterButtonRegister" class="ctaRegisterCon11" style="display: ${Btn1Disp}">
            <div class="ctaRegisterText3">Registrate GRATIS</div>
          </div>
          <div id="ctaRegisterButtonLater" class="ctaRegisterCon12 topRightExitButtonOnFullScreenWindow">
            <div class="ctaRegisterConText4">${Btn2Text}</div>
          </div>
            <label for="ctaRegisterNotShowAnyMoreCheckBox" class="ctaRegisterCon13" style="display: ${DoNotShowDisp}">
                <input class="ctaRegisterCon14" type="checkbox" id="ctaRegisterNotShowAnyMoreCheckBox">
                <div class="ctaRegisterConText5">Ya no mostrar esta ventana</div>
            </label>
        </div>
    </div>
        `;
    }
}
var $82c43ca230401e51$export$2e2bcd8739ae039 = new $82c43ca230401e51$var$generateHtml();


class $345d151430356fa0$var$CTAAlert {
    async _closeCTARegister() {
        const ctaRegisterConMain = document.getElementById("ctaRegisterConMain");
        ctaRegisterConMain.style.display = "none";
    }
    async _openCTARegister(stats = false, header1Text, header2Text) {
        return; // not needed for now
        function isHideRegisterAlertSet() {
            return document.cookie.split(";").some((cookie)=>{
                return cookie.trim().startsWith("hideregisteralert=");
            });
        }
    }
    _eventCTARegister() {
        function handleCheckboxAndSetCookie() {
            const checkbox = document.getElementById("ctaRegisterNotShowAnyMoreCheckBox");
            if (checkbox.checked) {
                // Set cookie for 10 days
                const d = new Date();
                // d.setTime(d.getTime() + 30 * 1000); // 10 days in ms
                d.setTime(d.getTime() + 864000000); // 10 days in ms
                const expires = "expires=" + d.toUTCString();
                document.cookie = "hideregisteralert=true;" + expires + ";path=/";
            }
        }
        const ctaRegisterButtonRegister = document.getElementById("ctaRegisterButtonRegister");
        const ctaRegisterButtonLater = document.getElementById("ctaRegisterButtonLater");
        ctaRegisterButtonRegister.addEventListener("click", ()=>{
            (0, $5b997bd2b2817dfd$export$2e2bcd8739ae039)._displayOptions("account_and_profile", "Registrate si no tienes una cuenta", "register");
            this._closeCTARegister();
        });
        ctaRegisterButtonLater.addEventListener("click", ()=>{
            handleCheckboxAndSetCookie();
            this._closeCTARegister();
        });
    }
}
var $345d151430356fa0$export$2e2bcd8739ae039 = new $345d151430356fa0$var$CTAAlert();





class $83f84e92f5d1be87$var$promotedItems {
    constructor(){
        this._windowEvents();
    }
    _windowEvents() {
        window.addEventListener("click", (e)=>{
            const isItem = e.target.closest(".promotedItemViewMiniCon1");
            if (isItem) {
                const url = isItem.dataset.openurl;
                if (url) (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink(url);
            }
        });
    }
    _chimmerFucntion() {
        // 1️⃣ Inject shimmer CSS dynamically
        const style = document.createElement("style");
        style.innerHTML = `
    .__vp_shimmer {
      position: relative !important;
      overflow: hidden !important;
    }

    .__vp_shimmer::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
        120deg,
        transparent,
        rgba(255,255,255,0.5),
        transparent
      );
      transform: skewX(-20deg);
      animation: __vp_shimmer_anim 3s infinite;
    }

    @keyframes __vp_shimmer_anim {
      0% { left: -150%; }
      100% { left: 150%; }
    }
  `;
        document.head.appendChild(style);
        // 2️⃣ Observe visibility
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) entry.target.classList.add("__vp_shimmer");
                else entry.target.classList.remove("__vp_shimmer");
            });
        }, {
            threshold: 0.4
        });
        // 3️⃣ Observe all current buttons
        document.querySelectorAll(".promotedItemViewMiniCon10").forEach((btn)=>observer.observe(btn));
    }
    async _setHeaderTexts() {
        const header1Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedText1Parent");
        const header1 = document.getElementById("NVHeaderConSearchCon2B1PromotedText1");
        const header2Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedCuponParent");
        const header2 = document.getElementById("NVHeaderConSearchCon2B1PromotedCupon");
        const header3Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedText2Parent");
        const header3 = document.getElementById("NVHeaderConSearchCon2B1PromotedText2");
        // header1Parent.style.display = 'none'
        // header2Parent.style.display = 'none'
        // header3Parent.style.display = 'none'
        const textData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById('adds/promotedItemsTexts');
        console.log(textData);
        if (textData) {
            header1Parent.style.display = 'flex';
            header1.textContent = textData.text1 || 'Productos Promocionados';
            if (textData.textPro) {
                header2Parent.style.display = 'flex';
                header2.textContent = textData.textPro || '';
            }
            if (textData.text2) {
                header3Parent.style.display = 'flex';
                header3.textContent = textData.text2 || '';
            }
        }
    }
    async _renderAll(conId, items, reset = false) {
        if (reset) this._setHeaderTexts();
        setTimeout(()=>{
            this._chimmerFucntion();
        }, 5000);
        const renderCon1 = document.getElementById(conId);
        if (reset) renderCon1.innerHTML = '';
        const batchSize = 3;
        for(let i = 0; i < items.length; i += batchSize){
            const batch = items.slice(i, i + batchSize);
            for (const item of batch){
                const data = await this._fetchLinkPreviewData(item.url, item.platform);
                if (data?.image) {
                    console.warn(data);
                    console.log(data);
                    const html = (0, $f512c4c2fe359fda$export$2e2bcd8739ae039)._generateItem(data, item);
                    renderCon1.insertAdjacentHTML('beforeend', html);
                }
            }
        }
    }
    async _renderAllV2(conId, items, reset = false) {
        // const ske = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        // const renderCon = document.getElementById(conId)
        // if (reset) {
        //     renderCon.innerHTML = ''
        //     ske.forEach(skeNum => {
        //         renderCon.insertAdjacentHTML(
        //             'beforeend',
        //             generateHtml._generateSkeleton(skeNum)
        //         )
        //     });
        // }
        for (const item of items)// const skeletonId = `skeleton-${crypto.randomUUID()}`
        // // 1️⃣ Insert skeleton immediately
        // renderCon.insertAdjacentHTML(
        //     'beforeend',
        //     generateHtml._generateSkeleton(skeletonId)
        // )
        // 2️⃣ Fetch data async (no await blocking UI)
        this._fetchLinkPreviewData(item.url, item.platform).then((data)=>{
            if (reset) renderCon.innerHTML = '';
            const html = (0, $f512c4c2fe359fda$export$2e2bcd8739ae039)._generateItem(data, item);
            renderCon.insertAdjacentHTML('beforeend', html);
        // const skeleton = document.getElementById(skeletonId)
        // if (skeleton) {
        //     skeleton.outerHTML = html
        // }
        }).catch(()=>{
        // const skeleton = document.getElementById(skeletonId)
        // if (skeleton) skeleton.remove()
        });
    }
    async _renderAllV3(conId, items, reset = false) {
        const renderCon1 = document.getElementById(conId);
        if (reset) {
            renderCon1.innerHTML = '';
            // Insert 10 skeletons immediately
            let skeletonHTML = '';
            for(let i = 0; i < 10; i++)skeletonHTML += (0, $f512c4c2fe359fda$export$2e2bcd8739ae039)._generateSkeleton();
            renderCon1.insertAdjacentHTML('beforeend', skeletonHTML);
        }
        let firstItemRendered = false;
        for (const item of items)this._fetchLinkPreviewData(item.url, item.platform).then((data)=>{
            // Remove skeletons when first item arrives
            if (!firstItemRendered) {
                firstItemRendered = true;
                const skeletons = renderCon1.querySelectorAll('.promotedItemSkeleton');
                skeletons.forEach((el)=>el.remove());
            }
            const html = (0, $f512c4c2fe359fda$export$2e2bcd8739ae039)._generateItem(data, item);
            renderCon1.insertAdjacentHTML('beforeend', html);
        }).catch(()=>{
            console.warn("Failed preview:", item.url);
        });
    }
    async _fetchLinkPreviewData(url, platform) {
        // const result = await firebase._NVPreviewAffiliatedItem({ url, platform });
        // return result
        function isValidUrl(value) {
            try {
                new URL(value);
                return true;
            } catch  {
                return false;
            }
        }
        try {
            if (!isValidUrl(url)) throw new Error("Invalid URL");
            // ⭐ STEP 1 — Resolve redirects first
            let finalUrl = url;
            try {
                const redirectRes = await fetch(url, {
                    method: "GET",
                    redirect: "follow"
                });
                finalUrl = redirectRes.url || url;
            } catch (e) {
                // If redirect resolving fails, continue with original URL
                finalUrl = url;
            }
            // ⭐ STEP 2 — Call Microlink with resolved URL
            const response = await fetch(`https://api.microlink.io?url=${encodeURIComponent(finalUrl)}&screenshot=false`);
            if (!response.ok) throw new Error("Microlink request failed");
            const res = await response.json();
            if (!res || res.status !== "success") throw new Error("Microlink failed");
            const data = res.data;
            // ⭐ STEP 3 — Smarter image fallback logic
            const image = data.image?.url || data.images?.find((img)=>img?.url)?.url || data.logo?.url || data.favicon || null;
            return {
                success: true,
                platform: platform,
                url: finalUrl,
                title: data.title || "",
                description: data.description || "",
                image: image
            };
        } catch (error) {
            return {
                success: false,
                platform: platform,
                url: url,
                error: error.message
            };
        }
    }
    async _fetchLinkPreviewDataV1(url, platform) {
        function isValidUrl(value) {
            try {
                new URL(value);
                return true;
            } catch  {
                return false;
            }
        }
        try {
            if (!isValidUrl(url)) throw new Error("Invalid URL");
            const response = await fetch(`https://api.microlink.io?url=${encodeURIComponent(url)}`);
            const res = await response.json();
            if (!res || res.status !== "success") throw new Error("Microlink failed");
            const data = res.data;
            return {
                success: true,
                platform: platform,
                url: url,
                title: data.title || "",
                description: data.description || "",
                image: data.image?.url || data.images?.[0]?.url || null
            };
        } catch (error) {
            return {
                success: false,
                platform: platform,
                url: url,
                error: error.message
            };
        }
    }
    _renderAffiliatedItems(containerId, items = []) {
        const container = document.getElementById(containerId);
        if (!container || !Array.isArray(items)) return;
        container.innerHTML = "";
        items.forEach((item)=>{
            if (!item?.url) return;
            if (!isValidUrl(item.url)) return;
            if (item.platform === "mercado-libre" && isMercadoLibreSecLink(item.url)) {
                const itemContainer = document.createElement("div");
                itemContainer.className = "afItemWrapper";
                container.appendChild(itemContainer);
                showLoading(itemContainer);
                fetchMercadoLibrePreview(item.url, itemContainer);
            }
            // For now i just have all mercado libre items on my database
            if (item.platform === "amazon" && isMercadoLibreSecLink(item.url)) {
                const itemContainer = document.createElement("div");
                itemContainer.className = "afItemWrapper";
                container.appendChild(itemContainer);
                showLoading(itemContainer);
                fetchMercadoLibrePreview(item.url, itemContainer);
            }
            // For now i just have all mercado libre items on my database
            if (item.platform === "ebay" && isMercadoLibreSecLink(item.url)) {
                const itemContainer = document.createElement("div");
                itemContainer.className = "afItemWrapper";
                container.appendChild(itemContainer);
                showLoading(itemContainer);
                fetchMercadoLibrePreview(item.url, itemContainer);
            }
        });
        /* -------------------- MERCADOLIBRE -------------------- */ function fetchMercadoLibrePreview(url, itemContainer) {
            fetch(`https://api.microlink.io?url=${encodeURIComponent(url)}`).then((res)=>res.json()).then((res)=>{
                if (!res || res.status !== "success") throw new Error("Microlink failed");
                renderMercadoLibrePreview(itemContainer, res.data, url);
            }).catch((err)=>{
                console.error("ML preview error:", err);
                itemContainer.innerHTML = `
                    <div class="link-preview-error">
                        No se pudo cargar la vista previa
                    </div>
                `;
            });
        }
        function renderMercadoLibrePreview(container, data, url) {
            const image = data.image?.url || data.images?.[0]?.url || null;
            container.innerHTML = `
<div class="afItemMercadoLibreCon1">
  <div class="afItemMercadoLibreCon2">
    ${image ? `<img class="afItemMercadoLibreCon2Image" src="${image}" alt="Producto Mercado Libre">` : ""}
  </div>
  <div class="afItemMercadoLibreCon3">
    <div class="afItemMercadoLibreText1">
      ${escapeHtml(data.title || "Producto en Mercado Libre")}
    </div>
    <div class="afItemMercadoLibreText2">
      ${escapeHtml(data.description || "")}
    </div>
  </div>
  <div class="afItemMercadoLibreCon4">
    <a
      href="${url}"
      target="_blank"
      rel="noopener noreferrer"
      class="afItemMercadoLibreButtonOpenCon1 afItemMercadoLibreButtonOpenText1"
    >
      Comprar en Mercado Libre
    </a>
    <div class="afItemMercadoLibreButtonDeleteCon1">
      <div class="afItemMercadoLibreButtonDeleteText1">Delete</div>
    </div>
  </div>
</div>
        `;
        }
        /* -------------------- HELPERS -------------------- */ function isMercadoLibreSecLink(url) {
            try {
                const u = new URL(url);
                let isMercadoLibre = false;
                if (u.hostname.includes("mercadolibre.") && u.pathname.startsWith("/sec/")) isMercadoLibre = true;
                if (u.hostname.includes("meli.la")) isMercadoLibre = true;
                return isMercadoLibre;
            } catch  {
                return false;
            }
        }
        function isValidUrl(value) {
            try {
                new URL(value);
                return true;
            } catch  {
                return false;
            }
        }
        function showLoading(container) {
            container.innerHTML = `
            <div class="link-preview-loading">
                Cargando vista previa\u{2026}
            </div>
        `;
        }
        function escapeHtml(text) {
            const div = document.createElement("div");
            div.textContent = text;
            return div.innerHTML;
        }
    }
}
var $83f84e92f5d1be87$export$2e2bcd8739ae039 = new $83f84e92f5d1be87$var$promotedItems();









const $da38ac6aa733c404$var$name = "@firebase/database";
const $da38ac6aa733c404$var$version = "1.0.10";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $da38ac6aa733c404$var$SDK_VERSION = '';
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $da38ac6aa733c404$export$c9fb972242fcb3c4(version) {
    $da38ac6aa733c404$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $da38ac6aa733c404$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $c38e0f42709c826a$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $da38ac6aa733c404$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $c38e0f42709c826a$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $da38ac6aa733c404$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $da38ac6aa733c404$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $da38ac6aa733c404$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $da38ac6aa733c404$var$PersistentStorage = $da38ac6aa733c404$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ const $da38ac6aa733c404$var$SessionStorage = $da38ac6aa733c404$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $da38ac6aa733c404$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $da38ac6aa733c404$var$sha1 = function(str) {
    const utf8Bytes = (0, $c38e0f42709c826a$export$655666783217a925)(str);
    const sha1 = new (0, $c38e0f42709c826a$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $c38e0f42709c826a$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $da38ac6aa733c404$var$buildLogMessage_ = function(...varArgs) {
    let message = '';
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $da38ac6aa733c404$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += (0, $c38e0f42709c826a$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $da38ac6aa733c404$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $da38ac6aa733c404$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $da38ac6aa733c404$var$enableLogging$1 = function(logger_, persistent) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $da38ac6aa733c404$var$logClient.logLevel = (0, $45b460d9de9b230f$export$243e62d78d3b544d).VERBOSE;
        $da38ac6aa733c404$var$logger = $da38ac6aa733c404$var$logClient.log.bind($da38ac6aa733c404$var$logClient);
        if (persistent) $da38ac6aa733c404$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $da38ac6aa733c404$var$logger = logger_;
    else {
        $da38ac6aa733c404$var$logger = null;
        $da38ac6aa733c404$var$SessionStorage.remove('logging_enabled');
    }
};
const $da38ac6aa733c404$var$log = function(...varArgs) {
    if ($da38ac6aa733c404$var$firstLog_ === true) {
        $da38ac6aa733c404$var$firstLog_ = false;
        if ($da38ac6aa733c404$var$logger === null && $da38ac6aa733c404$var$SessionStorage.get('logging_enabled') === true) $da38ac6aa733c404$var$enableLogging$1(true);
    }
    if ($da38ac6aa733c404$var$logger) {
        const message = $da38ac6aa733c404$var$buildLogMessage_.apply(null, varArgs);
        $da38ac6aa733c404$var$logger(message);
    }
};
const $da38ac6aa733c404$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $da38ac6aa733c404$var$log(prefix, ...varArgs);
    };
};
const $da38ac6aa733c404$var$error = function(...varArgs) {
    const message = 'FIREBASE INTERNAL ERROR: ' + $da38ac6aa733c404$var$buildLogMessage_(...varArgs);
    $da38ac6aa733c404$var$logClient.error(message);
};
const $da38ac6aa733c404$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$da38ac6aa733c404$var$buildLogMessage_(...varArgs)}`;
    $da38ac6aa733c404$var$logClient.error(message);
    throw new Error(message);
};
const $da38ac6aa733c404$var$warn = function(...varArgs) {
    const message = 'FIREBASE WARNING: ' + $da38ac6aa733c404$var$buildLogMessage_(...varArgs);
    $da38ac6aa733c404$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $da38ac6aa733c404$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $da38ac6aa733c404$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $da38ac6aa733c404$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $da38ac6aa733c404$var$executeWhenDOMReady = function(fn) {
    if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', ()=>{
                if (document.readyState === 'complete') wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $da38ac6aa733c404$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $da38ac6aa733c404$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $da38ac6aa733c404$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $da38ac6aa733c404$var$MIN_NAME || b === $da38ac6aa733c404$var$MAX_NAME) return -1;
    else if (b === $da38ac6aa733c404$var$MIN_NAME || a === $da38ac6aa733c404$var$MAX_NAME) return 1;
    else {
        const aAsInt = $da38ac6aa733c404$var$tryParseInt(a), bAsInt = $da38ac6aa733c404$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $da38ac6aa733c404$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $da38ac6aa733c404$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(obj));
};
const $da38ac6aa733c404$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return (0, $c38e0f42709c826a$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = '{';
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += (0, $c38e0f42709c826a$export$fac44ee5b035f737)(keys[i]);
        key += ':';
        key += $da38ac6aa733c404$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $da38ac6aa733c404$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $da38ac6aa733c404$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $da38ac6aa733c404$var$doubleToIEEE754String = function(v) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join('');
    // Return the data as a hex string. --MJL
    let hexByteString = '';
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $da38ac6aa733c404$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $da38ac6aa733c404$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a JavaScript Error
 */ function $da38ac6aa733c404$var$errorForServerCode(code, query) {
    let reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    const error = new Error(code + ' at ' + query._path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $da38ac6aa733c404$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $da38ac6aa733c404$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in keys, the maximum possible 32-bit integer.
 */ const $da38ac6aa733c404$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $da38ac6aa733c404$var$tryParseInt = function(str) {
    if ($da38ac6aa733c404$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $da38ac6aa733c404$var$INTEGER_32_MIN && intVal <= $da38ac6aa733c404$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $da38ac6aa733c404$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || '';
            $da38ac6aa733c404$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $da38ac6aa733c404$var$beingCrawled = function() {
    const userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $da38ac6aa733c404$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === 'number' && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== 'undefined' && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno['unrefTimer']) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $da38ac6aa733c404$var$AppCheckTokenProvider {
    constructor(appName_, appCheckProvider){
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $da38ac6aa733c404$var$warn(`Provided AppCheck credentials for the app named "${this.appName_}" ` + 'are invalid. This usually indicates your app was not initialized correctly.');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $da38ac6aa733c404$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $da38ac6aa733c404$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $da38ac6aa733c404$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $da38ac6aa733c404$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $da38ac6aa733c404$var$EmulatorTokenProvider.OWNER = 'owner';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$PROTOCOL_VERSION = '5';
const $da38ac6aa733c404$var$VERSION_PARAM = 'v';
const $da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM = 's';
const $da38ac6aa733c404$var$REFERER_PARAM = 'r';
const $da38ac6aa733c404$var$FORGE_REF = 'f';
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $da38ac6aa733c404$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $da38ac6aa733c404$var$LAST_SESSION_PARAM = 'ls';
const $da38ac6aa733c404$var$APPLICATION_ID_PARAM = 'p';
const $da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM = 'ac';
const $da38ac6aa733c404$var$WEBSOCKET = 'websocket';
const $da38ac6aa733c404$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $da38ac6aa733c404$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = '', includeNamespaceInQueryParams = false, isUsingEmulator = false){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf('.') + 1);
        this.internalHost = $da38ac6aa733c404$var$PersistentStorage.get('host:' + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === 's-';
    }
    isCustomHost() {
        return this._domain !== 'firebaseio.com' && this._domain !== 'firebaseio-demo.com';
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $da38ac6aa733c404$var$PersistentStorage.set('host:' + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    }
    toURLString() {
        const protocol = this.secure ? 'https://' : 'http://';
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : '';
        return `${protocol}${this.host}/${query}`;
    }
}
function $da38ac6aa733c404$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof type === 'string', 'typeof type must == string');
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof params === 'object', 'typeof params must == object');
    let connURL;
    if (type === $da38ac6aa733c404$var$WEBSOCKET) connURL = (repoInfo.secure ? 'wss://' : 'ws://') + repoInfo.internalHost + '/.ws?';
    else if (type === $da38ac6aa733c404$var$LONG_POLLING) connURL = (repoInfo.secure ? 'https://' : 'http://') + repoInfo.internalHost + '/.lp?';
    else throw new Error('Unknown connection type: ' + type);
    if ($da38ac6aa733c404$var$repoInfoNeedsQueryParam(repoInfo)) params['ns'] = repoInfo.namespace;
    const pairs = [];
    $da38ac6aa733c404$var$each(params, (key, value)=>{
        pairs.push(key + '=' + value);
    });
    return connURL + pairs.join('&');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $da38ac6aa733c404$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $c38e0f42709c826a$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $c38e0f42709c826a$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$collections = {};
const $da38ac6aa733c404$var$reporters = {};
function $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$da38ac6aa733c404$var$collections[hashString]) $da38ac6aa733c404$var$collections[hashString] = new $da38ac6aa733c404$var$StatsCollection();
    return $da38ac6aa733c404$var$collections[hashString];
}
function $da38ac6aa733c404$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$da38ac6aa733c404$var$reporters[hashString]) $da38ac6aa733c404$var$reporters[hashString] = creatorFunction();
    return $da38ac6aa733c404$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $da38ac6aa733c404$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $da38ac6aa733c404$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
const $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $da38ac6aa733c404$var$MAX_URL_DATA_SIZE = 1870;
const $da38ac6aa733c404$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $da38ac6aa733c404$var$MAX_PAYLOAD_SIZE = $da38ac6aa733c404$var$MAX_URL_DATA_SIZE - $da38ac6aa733c404$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $da38ac6aa733c404$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $da38ac6aa733c404$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $da38ac6aa733c404$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $da38ac6aa733c404$var$logWrapper(connId);
        this.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, $da38ac6aa733c404$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $da38ac6aa733c404$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($da38ac6aa733c404$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $da38ac6aa733c404$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $da38ac6aa733c404$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $da38ac6aa733c404$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$da38ac6aa733c404$var$VERSION_PARAM] = $da38ac6aa733c404$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$da38ac6aa733c404$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$da38ac6aa733c404$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== 'undefined' && location.hostname && $da38ac6aa733c404$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$da38ac6aa733c404$var$REFERER_PARAM] = $da38ac6aa733c404$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_('Connecting via long-poll to ' + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $da38ac6aa733c404$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $da38ac6aa733c404$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) return false;
        else if ($da38ac6aa733c404$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$da38ac6aa733c404$var$BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$da38ac6aa733c404$var$isChromeExtensionContentScript() && !$da38ac6aa733c404$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $c38e0f42709c826a$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $da38ac6aa733c404$var$splitStringBySize(base64data, $da38ac6aa733c404$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        const urlParams = {};
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $da38ac6aa733c404$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are received from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $da38ac6aa733c404$var$LUIDGenerator();
            window[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $da38ac6aa733c404$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $da38ac6aa733c404$var$log('frame writing exception');
                if (e.stack) $da38ac6aa733c404$var$log(e.stack);
                $da38ac6aa733c404$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $da38ac6aa733c404$var$log('No IE domain setting required');
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = '';
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$da38ac6aa733c404$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = '';
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $da38ac6aa733c404$var$SEG_HEADER_SIZE + curDataString.length <= $da38ac6aa733c404$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $da38ac6aa733c404$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($da38ac6aa733c404$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $da38ac6aa733c404$var$log('Long-poll script failed to load: ' + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $da38ac6aa733c404$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $da38ac6aa733c404$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $da38ac6aa733c404$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $da38ac6aa733c404$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $da38ac6aa733c404$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $da38ac6aa733c404$var$logWrapper(this.connId);
        this.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repoInfo);
        this.connURL = $da38ac6aa733c404$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$da38ac6aa733c404$var$VERSION_PARAM] = $da38ac6aa733c404$var$PROTOCOL_VERSION;
        if (!(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)() && typeof location !== 'undefined' && location.hostname && $da38ac6aa733c404$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$da38ac6aa733c404$var$REFERER_PARAM] = $da38ac6aa733c404$var$FORGE_REF;
        if (transportSessionId) urlParams[$da38ac6aa733c404$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$da38ac6aa733c404$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$da38ac6aa733c404$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$da38ac6aa733c404$var$APPLICATION_ID_PARAM] = applicationId;
        return $da38ac6aa733c404$var$repoInfoConnectionURL(repoInfo, $da38ac6aa733c404$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $da38ac6aa733c404$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            let options;
            if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        'User-Agent': `Firebase/${$da38ac6aa733c404$var$PROTOCOL_VERSION}/${$da38ac6aa733c404$var$SDK_VERSION}/${$cfae44f0dfdf62c0$exports.platform}/${device}`,
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers['Authorization'] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers['X-Firebase-AppCheck'] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
            }
            this.mySock = new $da38ac6aa733c404$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_('Websocket connected.');
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_('Websocket connection was disconnected.');
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $da38ac6aa733c404$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $da38ac6aa733c404$var$WebSocketImpl !== null && !$da38ac6aa733c404$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $da38ac6aa733c404$var$PersistentStorage.isInMemoryStorage || $da38ac6aa733c404$var$PersistentStorage.get('previous_websocket_failure') === true;
    }
    markConnectionHealthy() {
        $da38ac6aa733c404$var$PersistentStorage.remove('previous_websocket_failure');
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join('');
            this.frames = null;
            const jsonMess = (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $da38ac6aa733c404$var$splitStringBySize(dataStr, $da38ac6aa733c404$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_('0');
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($da38ac6aa733c404$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $da38ac6aa733c404$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $da38ac6aa733c404$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $da38ac6aa733c404$var$TransportManager {
    static get ALL_TRANSPORTS() {
        return [
            $da38ac6aa733c404$var$BrowserPollConnection,
            $da38ac6aa733c404$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $da38ac6aa733c404$var$WebSocketConnection && $da38ac6aa733c404$var$WebSocketConnection['isAvailable']();
        let isSkipPollConnection = isWebSocketsAvailable && !$da38ac6aa733c404$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $da38ac6aa733c404$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $da38ac6aa733c404$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $da38ac6aa733c404$var$TransportManager.ALL_TRANSPORTS)if (transport && transport['isAvailable']()) transports.push(transport);
            $da38ac6aa733c404$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$da38ac6aa733c404$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $da38ac6aa733c404$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $da38ac6aa733c404$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $da38ac6aa733c404$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $da38ac6aa733c404$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $da38ac6aa733c404$var$MESSAGE_TYPE = 't';
const $da38ac6aa733c404$var$MESSAGE_DATA = 'd';
const $da38ac6aa733c404$var$CONTROL_SHUTDOWN = 's';
const $da38ac6aa733c404$var$CONTROL_RESET = 'r';
const $da38ac6aa733c404$var$CONTROL_ERROR = 'e';
const $da38ac6aa733c404$var$CONTROL_PONG = 'o';
const $da38ac6aa733c404$var$SWITCH_ACK = 'a';
const $da38ac6aa733c404$var$END_TRANSMISSION = 'n';
const $da38ac6aa733c404$var$PING = 'p';
const $da38ac6aa733c404$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $da38ac6aa733c404$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $da38ac6aa733c404$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $da38ac6aa733c404$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $da38ac6aa733c404$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_('Connection exceeded healthy timeout but has received ' + this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $da38ac6aa733c404$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_('Connection exceeded healthy timeout but has sent ' + this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    this.log_('Closing unhealthy connection after timeout.');
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_('Secondary connection lost.');
                this.onSecondaryConnectionLost_();
            } else this.log_('closing an old connection');
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_('message on old connection');
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($da38ac6aa733c404$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$da38ac6aa733c404$var$MESSAGE_TYPE];
            if (cmd === $da38ac6aa733c404$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $da38ac6aa733c404$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $da38ac6aa733c404$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $da38ac6aa733c404$var$requireKey('t', parsedData);
        const data = $da38ac6aa733c404$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $da38ac6aa733c404$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $da38ac6aa733c404$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $da38ac6aa733c404$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $da38ac6aa733c404$var$requireKey('t', parsedData);
        const data = $da38ac6aa733c404$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $da38ac6aa733c404$var$requireKey($da38ac6aa733c404$var$MESSAGE_TYPE, controlData);
        if ($da38ac6aa733c404$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$da38ac6aa733c404$var$MESSAGE_DATA];
            if (cmd === $da38ac6aa733c404$var$SERVER_HELLO) {
                const handshakePayload = Object.assign({}, payload);
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $da38ac6aa733c404$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $da38ac6aa733c404$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_ERROR) $da38ac6aa733c404$var$error('Server Error: ' + payload);
            else if (cmd === $da38ac6aa733c404$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $da38ac6aa733c404$var$error('Unknown control packet command: ' + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($da38ac6aa733c404$var$PROTOCOL_VERSION !== version) $da38ac6aa733c404$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_('Timed out trying to upgrade.');
                this.secondaryConn_.close();
            }
        }, Math.floor($da38ac6aa733c404$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $da38ac6aa733c404$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($da38ac6aa733c404$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $da38ac6aa733c404$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $da38ac6aa733c404$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $da38ac6aa733c404$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $da38ac6aa733c404$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $da38ac6aa733c404$var$OnlineMonitor extends $da38ac6aa733c404$var$EventEmitter {
    static getInstance() {
        return new $da38ac6aa733c404$var$OnlineMonitor();
    }
    constructor(){
        super([
            'online'
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, $c38e0f42709c826a$export$872f8323f01d7ae0)()) {
            window.addEventListener('online', ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger('online', false);
                }
            }, false);
        }
    }
    getInitialEvent(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $da38ac6aa733c404$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $da38ac6aa733c404$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = '';
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    }
}
function $da38ac6aa733c404$var$newEmptyPath() {
    return new $da38ac6aa733c404$var$Path('');
}
function $da38ac6aa733c404$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $da38ac6aa733c404$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $da38ac6aa733c404$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $da38ac6aa733c404$var$Path(path.pieces_, pieceNum);
}
function $da38ac6aa733c404$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $da38ac6aa733c404$var$pathToUrlEncodedString(path) {
    let pathString = '';
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(path.pieces_[i]));
    return pathString || '/';
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $da38ac6aa733c404$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $da38ac6aa733c404$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $da38ac6aa733c404$var$Path(pieces, 0);
}
function $da38ac6aa733c404$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $da38ac6aa733c404$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split('/');
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $da38ac6aa733c404$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $da38ac6aa733c404$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $da38ac6aa733c404$var$newRelativePath(outerPath, innerPath) {
    const outer = $da38ac6aa733c404$var$pathGetFront(outerPath), inner = $da38ac6aa733c404$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $da38ac6aa733c404$var$newRelativePath($da38ac6aa733c404$var$pathPopFront(outerPath), $da38ac6aa733c404$var$pathPopFront(innerPath));
    else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $da38ac6aa733c404$var$pathCompare(left, right) {
    const leftKeys = $da38ac6aa733c404$var$pathSlice(left, 0);
    const rightKeys = $da38ac6aa733c404$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $da38ac6aa733c404$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $da38ac6aa733c404$var$pathEquals(path, other) {
    if ($da38ac6aa733c404$var$pathGetLength(path) !== $da38ac6aa733c404$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $da38ac6aa733c404$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($da38ac6aa733c404$var$pathGetLength(path) > $da38ac6aa733c404$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $da38ac6aa733c404$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $da38ac6aa733c404$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(this.parts_[i]);
        $da38ac6aa733c404$var$validationPathCheckValid(this);
    }
}
function $da38ac6aa733c404$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(child);
    $da38ac6aa733c404$var$validationPathCheckValid(validationPath);
}
function $da38ac6aa733c404$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $da38ac6aa733c404$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + 'has a key path longer than ' + $da38ac6aa733c404$var$MAX_PATH_LENGTH_BYTES + ' bytes (' + validationPath.byteLength_ + ').');
    if (validationPath.parts_.length > $da38ac6aa733c404$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + $da38ac6aa733c404$var$MAX_PATH_DEPTH + ') or object contains a cycle ' + $da38ac6aa733c404$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $da38ac6aa733c404$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return '';
    return "in property '" + validationPath.parts_.join('.') + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$VisibilityMonitor extends $da38ac6aa733c404$var$EventEmitter {
    static getInstance() {
        return new $da38ac6aa733c404$var$VisibilityMonitor();
    }
    constructor(){
        super([
            'visible'
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger('visible', visible);
            }
        }, false);
    }
    getInitialEvent(eventType) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$RECONNECT_MIN_DELAY = 1000;
const $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $da38ac6aa733c404$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $da38ac6aa733c404$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $da38ac6aa733c404$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $da38ac6aa733c404$var$PersistentConnection extends $da38ac6aa733c404$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $da38ac6aa733c404$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $da38ac6aa733c404$var$logWrapper('p:' + this.id + ':');
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        $da38ac6aa733c404$var$VisibilityMonitor.getInstance().on('visible', this.onVisible_, this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $da38ac6aa733c404$var$OnlineMonitor.getInstance().on('online', this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $c38e0f42709c826a$export$fac44ee5b035f737)(msg));
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: 'g',
            request: request,
            onComplete: (message)=>{
                const payload = message['d'];
                if (message['s'] === 'ok') deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'listen() called for non-default but complete query');
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest('g', get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query._queryObject;
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ 'd'];
            const status = message[/*status*/ 's'];
            // print warnings in any case...
            $da38ac6aa733c404$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_('listen response', message);
                if (status !== 'ok') this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === 'object' && (0, $c38e0f42709c826a$export$2344b14b097df817)(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $da38ac6aa733c404$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $c38e0f42709c826a$export$fc970ed23da99565)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_('App check token refreshed');
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest('unappeck', {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $c38e0f42709c826a$export$9565ca3d387f8aa0)(token) ? 'auth' : 'gauth';
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ 's'];
                const data = res[/*data*/ 'd'] || 'error';
                if (this.authToken_ === token) {
                    if (status === 'ok') this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest('appcheck', {
            'token': this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ 's'];
            const data = res[/*data*/ 'd'] || 'error';
            if (status === 'ok') this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'unlisten() called for non-default but complete query');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + ' response', message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, (result)=>{
                const status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    const errorReason = result[/* data */ 'd'];
                    this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(message));
            const reqNum = message['r'];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    }
    onDataPush_(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'apc') this.onAppCheckRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $da38ac6aa733c404$var$error('Unrecognized action received from server: ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(action) + '\nAre you using the latest client?');
    }
    onReady_(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $da38ac6aa733c404$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $da38ac6aa733c404$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ':' + $da38ac6aa733c404$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $da38ac6aa733c404$var$log('getToken() completed. Creating connection.');
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $da38ac6aa733c404$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $da38ac6aa733c404$var$warn(reason + ' (' + this.repoInfo_.toString() + ')');
                        this.interrupt($da38ac6aa733c404$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $da38ac6aa733c404$var$log('getToken() completed but was canceled');
            } catch (error) {
                this.log_('Failed to get token: ' + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $da38ac6aa733c404$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $da38ac6aa733c404$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $da38ac6aa733c404$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = 'default';
        else queryId = query.map((q)=>$da38ac6aa733c404$var$ObjectToUniqueKey(q)).join('$');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $da38ac6aa733c404$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $da38ac6aa733c404$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $da38ac6aa733c404$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $da38ac6aa733c404$var$log('App check token revoked: ' + statusCode + '/' + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $da38ac6aa733c404$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = 'js';
        if ((0, $c38e0f42709c826a$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = 'admin_node';
            else clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + $da38ac6aa733c404$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, $c38e0f42709c826a$export$872f8323f01d7ae0)()) stats['framework.cordova'] = 1;
        else if ((0, $c38e0f42709c826a$export$f7a1e23e542d38e3)()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $da38ac6aa733c404$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$da38ac6aa733c404$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $da38ac6aa733c404$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $da38ac6aa733c404$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, oldNode);
        const newWrapped = new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$__EMPTY_NODE;
class $da38ac6aa733c404$var$KeyIndex extends $da38ac6aa733c404$var$Index {
    static get __EMPTY_NODE() {
        return $da38ac6aa733c404$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $da38ac6aa733c404$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('KeyIndex.isDefinedOn not expected to be called.');
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, $da38ac6aa733c404$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $da38ac6aa733c404$var$NamedNode(indexValue, $da38ac6aa733c404$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.key';
    }
}
const $da38ac6aa733c404$var$KEY_INDEX = new $da38ac6aa733c404$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $da38ac6aa733c404$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $da38ac6aa733c404$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $da38ac6aa733c404$var$LLRBNode.RED;
        this.left = left != null ? left : $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $da38ac6aa733c404$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $da38ac6aa733c404$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $da38ac6aa733c404$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $da38ac6aa733c404$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$da38ac6aa733c404$var$LLRBNode.RED = true;
$da38ac6aa733c404$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $da38ac6aa733c404$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $da38ac6aa733c404$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $da38ac6aa733c404$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $da38ac6aa733c404$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $da38ac6aa733c404$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $da38ac6aa733c404$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $da38ac6aa733c404$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $da38ac6aa733c404$var$SortedMap.EMPTY_NODE = new $da38ac6aa733c404$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$NAME_ONLY_COMPARATOR(left, right) {
    return $da38ac6aa733c404$var$nameCompare(left.name, right.name);
}
function $da38ac6aa733c404$var$NAME_COMPARATOR(left, right) {
    return $da38ac6aa733c404$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$MAX_NODE$2;
function $da38ac6aa733c404$var$setMaxNode$1(val) {
    $da38ac6aa733c404$var$MAX_NODE$2 = val;
}
const $da38ac6aa733c404$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $da38ac6aa733c404$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $da38ac6aa733c404$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && (0, $c38e0f42709c826a$export$2344b14b097df817)(val, '.sv'), 'Priority must be a string or number.');
    } else (0, $c38e0f42709c826a$export$a7a9523472993e97)(priorityNode === $da38ac6aa733c404$var$MAX_NODE$2 || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(priorityNode === $da38ac6aa733c404$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $da38ac6aa733c404$var$LeafNode {
    static set __childrenNodeConstructor(val) {
        $da38ac6aa733c404$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $da38ac6aa733c404$var$__childrenNodeConstructor;
    }
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $da38ac6aa733c404$var$validatePriorityNode(this.priorityNode_);
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $da38ac6aa733c404$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($da38ac6aa733c404$var$pathIsEmpty(path)) return this;
        else if ($da38ac6aa733c404$var$pathGetFront(path) === '.priority') return this.priorityNode_;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(front !== '.priority' || $da38ac6aa733c404$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($da38ac6aa733c404$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $da38ac6aa733c404$var$priorityHashText(this.priorityNode_.val()) + ':';
            const type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $da38ac6aa733c404$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $da38ac6aa733c404$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $da38ac6aa733c404$var$LeafNode.VALUE_TYPE_ORDER = [
    'object',
    'boolean',
    'number',
    'string'
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$nodeFromJSON$1;
let $da38ac6aa733c404$var$MAX_NODE$1;
function $da38ac6aa733c404$var$setNodeFromJSON(val) {
    $da38ac6aa733c404$var$nodeFromJSON$1 = val;
}
function $da38ac6aa733c404$var$setMaxNode(val) {
    $da38ac6aa733c404$var$MAX_NODE$1 = val;
}
class $da38ac6aa733c404$var$PriorityIndex extends $da38ac6aa733c404$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, new $da38ac6aa733c404$var$LeafNode('[PRIORITY-POST]', $da38ac6aa733c404$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $da38ac6aa733c404$var$nodeFromJSON$1(indexValue);
        return new $da38ac6aa733c404$var$NamedNode(name, new $da38ac6aa733c404$var$LeafNode('[PRIORITY-POST]', priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.priority';
    }
}
const $da38ac6aa733c404$var$PRIORITY_INDEX = new $da38ac6aa733c404$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$LOG_2 = Math.log(2);
class $da38ac6aa733c404$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $da38ac6aa733c404$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join('1'), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $da38ac6aa733c404$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, $da38ac6aa733c404$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, $da38ac6aa733c404$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $da38ac6aa733c404$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $da38ac6aa733c404$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $da38ac6aa733c404$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $da38ac6aa733c404$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$_defaultIndexMap;
const $da38ac6aa733c404$var$fallbackObject = {};
class $da38ac6aa733c404$var$IndexMap {
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$fallbackObject && $da38ac6aa733c404$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
        $da38ac6aa733c404$var$_defaultIndexMap = $da38ac6aa733c404$var$_defaultIndexMap || new $da38ac6aa733c404$var$IndexMap({
            '.priority': $da38ac6aa733c404$var$fallbackObject
        }, {
            '.priority': $da38ac6aa733c404$var$PRIORITY_INDEX
        });
        return $da38ac6aa733c404$var$_defaultIndexMap;
    }
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    get(indexKey) {
        const sortedMap = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $da38ac6aa733c404$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $c38e0f42709c826a$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(indexDefinition !== $da38ac6aa733c404$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($da38ac6aa733c404$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $da38ac6aa733c404$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $da38ac6aa733c404$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $da38ac6aa733c404$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($da38ac6aa733c404$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $da38ac6aa733c404$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $da38ac6aa733c404$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $da38ac6aa733c404$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $da38ac6aa733c404$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $da38ac6aa733c404$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $da38ac6aa733c404$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $da38ac6aa733c404$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $da38ac6aa733c404$var$ChildrenNode {
    static get EMPTY_NODE() {
        return $da38ac6aa733c404$var$EMPTY_NODE || ($da38ac6aa733c404$var$EMPTY_NODE = new $da38ac6aa733c404$var$ChildrenNode(new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$NAME_COMPARATOR), null, $da38ac6aa733c404$var$IndexMap.Default));
    }
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $da38ac6aa733c404$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $c38e0f42709c826a$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $da38ac6aa733c404$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $da38ac6aa733c404$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $da38ac6aa733c404$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($da38ac6aa733c404$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            const namedNode = new $da38ac6aa733c404$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $da38ac6aa733c404$var$EMPTY_NODE : this.priorityNode_;
            return new $da38ac6aa733c404$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $da38ac6aa733c404$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(path) !== '.priority' || $da38ac6aa733c404$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            const newImmediateChild = this.getImmediateChild(front).updateChild($da38ac6aa733c404$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $da38ac6aa733c404$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.getPriority().isEmpty()) toHash += 'priority:' + $da38ac6aa733c404$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== '') toHash += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash === '' ? '' : $da38ac6aa733c404$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $da38ac6aa733c404$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $da38ac6aa733c404$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $da38ac6aa733c404$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $da38ac6aa733c404$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $da38ac6aa733c404$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $da38ac6aa733c404$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $da38ac6aa733c404$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $da38ac6aa733c404$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $da38ac6aa733c404$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($da38ac6aa733c404$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($da38ac6aa733c404$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $da38ac6aa733c404$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$da38ac6aa733c404$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $da38ac6aa733c404$var$MaxNode extends $da38ac6aa733c404$var$ChildrenNode {
    constructor(){
        super(new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$NAME_COMPARATOR), $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, $da38ac6aa733c404$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $da38ac6aa733c404$var$MAX_NODE = new $da38ac6aa733c404$var$MaxNode();
Object.defineProperties($da38ac6aa733c404$var$NamedNode, {
    MIN: {
        value: new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MIN_NAME, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, $da38ac6aa733c404$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $da38ac6aa733c404$var$KeyIndex.__EMPTY_NODE = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
$da38ac6aa733c404$var$LeafNode.__childrenNodeConstructor = $da38ac6aa733c404$var$ChildrenNode;
$da38ac6aa733c404$var$setMaxNode$1($da38ac6aa733c404$var$MAX_NODE);
$da38ac6aa733c404$var$setMaxNode($da38ac6aa733c404$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $da38ac6aa733c404$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        const jsonLeaf = json;
        return new $da38ac6aa733c404$var$LeafNode(jsonLeaf, $da38ac6aa733c404$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $da38ac6aa733c404$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $da38ac6aa733c404$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                const childNode = $da38ac6aa733c404$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $da38ac6aa733c404$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        const childSet = $da38ac6aa733c404$var$buildChildSet(children, $da38ac6aa733c404$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $da38ac6aa733c404$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $da38ac6aa733c404$var$buildChildSet(children, $da38ac6aa733c404$var$PRIORITY_INDEX.getCompare());
            return new $da38ac6aa733c404$var$ChildrenNode(childSet, $da38ac6aa733c404$var$nodeFromJSON(priority), new $da38ac6aa733c404$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $da38ac6aa733c404$var$PRIORITY_INDEX
            }));
        } else return new $da38ac6aa733c404$var$ChildrenNode(childSet, $da38ac6aa733c404$var$nodeFromJSON(priority), $da38ac6aa733c404$var$IndexMap.Default);
    } else {
        let node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        $da38ac6aa733c404$var$each(json, (key, childData)=>{
            if ((0, $c38e0f42709c826a$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    const childNode = $da38ac6aa733c404$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($da38ac6aa733c404$var$nodeFromJSON(priority));
    }
}
$da38ac6aa733c404$var$setNodeFromJSON($da38ac6aa733c404$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$PathIndex extends $da38ac6aa733c404$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$pathIsEmpty(indexPath_) && $da38ac6aa733c404$var$pathGetFront(indexPath_) !== '.priority', "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $da38ac6aa733c404$var$nodeFromJSON(indexValue);
        const node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $da38ac6aa733c404$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $da38ac6aa733c404$var$MAX_NODE);
        return new $da38ac6aa733c404$var$NamedNode($da38ac6aa733c404$var$MAX_NAME, node);
    }
    toString() {
        return $da38ac6aa733c404$var$pathSlice(this.indexPath_, 0).join('/');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ValueIndex extends $da38ac6aa733c404$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $da38ac6aa733c404$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $da38ac6aa733c404$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $da38ac6aa733c404$var$nodeFromJSON(indexValue);
        return new $da38ac6aa733c404$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.value';
    }
}
const $da38ac6aa733c404$var$VALUE_INDEX = new $da38ac6aa733c404$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $da38ac6aa733c404$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $da38ac6aa733c404$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $da38ac6aa733c404$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $da38ac6aa733c404$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $da38ac6aa733c404$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(key, oldChild));
                else (0, $c38e0f42709c826a$export$a7a9523472993e97)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $da38ac6aa733c404$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $da38ac6aa733c404$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $da38ac6aa733c404$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $da38ac6aa733c404$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $da38ac6aa733c404$var$NamedNode(key, newChild))) newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $da38ac6aa733c404$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $da38ac6aa733c404$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $da38ac6aa733c404$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $da38ac6aa733c404$var$NamedNode(key, newChild))) newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, '');
        const newChildNamedNode = new $da38ac6aa733c404$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($da38ac6aa733c404$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $da38ac6aa733c404$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $da38ac6aa733c404$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $da38ac6aa733c404$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $da38ac6aa733c404$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== '';
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $da38ac6aa733c404$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $da38ac6aa733c404$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $da38ac6aa733c404$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $da38ac6aa733c404$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $da38ac6aa733c404$var$LimitedFilter(queryParams);
    else return new $da38ac6aa733c404$var$RangedFilter(queryParams);
}
function $da38ac6aa733c404$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = '';
    }
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX || !!key) params = $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $da38ac6aa733c404$var$queryParamsStartAt(queryParams, indexValue, $da38ac6aa733c404$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = '';
    }
    return newParams;
}
function $da38ac6aa733c404$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX || !!key) params = $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $da38ac6aa733c404$var$queryParamsEndAt(queryParams, indexValue, $da38ac6aa733c404$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $da38ac6aa733c404$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $da38ac6aa733c404$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $da38ac6aa733c404$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $da38ac6aa733c404$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(queryParams.index_ instanceof $da38ac6aa733c404$var$PathIndex, 'Unrecognized index type!');
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += ',' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += ',' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $da38ac6aa733c404$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === '') {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $da38ac6aa733c404$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $da38ac6aa733c404$var$ReadonlyRestClient extends $da38ac6aa733c404$var$ServerActions {
    reportStats(stats) {
        throw new Error('Method not implemented.');
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $da38ac6aa733c404$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $da38ac6aa733c404$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $c38e0f42709c826a$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = 'ok';
                else if (error === 401) status = 'permission_denied';
                else status = 'rest_error:' + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $da38ac6aa733c404$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $da38ac6aa733c404$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters['format'] = 'export';
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters['auth'] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters['ac'] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host + pathString + '?' + 'ns=' + this.repoInfo_.namespace + (0, $c38e0f42709c826a$export$ac4103b836844853)(queryStringParameters);
            this.log_('Sending REST request for ' + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $c38e0f42709c826a$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $da38ac6aa733c404$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $da38ac6aa733c404$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $da38ac6aa733c404$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $da38ac6aa733c404$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        $da38ac6aa733c404$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, tree)=>{
                    $da38ac6aa733c404$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $da38ac6aa733c404$var$Path(key), tree);
                });
                return $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $da38ac6aa733c404$var$pathGetFront(path);
            path = $da38ac6aa733c404$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $da38ac6aa733c404$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $da38ac6aa733c404$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $da38ac6aa733c404$var$Path(prefixPath.toString() + '/' + key);
        $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $da38ac6aa733c404$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $da38ac6aa733c404$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $da38ac6aa733c404$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME = 10000;
const $da38ac6aa733c404$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $da38ac6aa733c404$var$REPORT_STATS_INTERVAL = 300000;
class $da38ac6aa733c404$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $da38ac6aa733c404$var$StatsListener(collection);
        const timeout = $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME + ($da38ac6aa733c404$var$FIRST_STATS_MAX_TIME - $da38ac6aa733c404$var$FIRST_STATS_MIN_TIME) * Math.random();
        $da38ac6aa733c404$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $da38ac6aa733c404$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $c38e0f42709c826a$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $da38ac6aa733c404$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $da38ac6aa733c404$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $da38ac6aa733c404$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($da38ac6aa733c404$var$OperationType || ($da38ac6aa733c404$var$OperationType = {}));
function $da38ac6aa733c404$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $da38ac6aa733c404$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $da38ac6aa733c404$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$da38ac6aa733c404$var$pathIsEmpty(this.path)) {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(this.path) === childName, 'operationForChild called for unrelated child.');
            return new $da38ac6aa733c404$var$AckUserWrite($da38ac6aa733c404$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $da38ac6aa733c404$var$Path(childName));
            return new $da38ac6aa733c404$var$AckUserWrite($da38ac6aa733c404$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) return new $da38ac6aa733c404$var$ListenComplete(this.source, $da38ac6aa733c404$var$newEmptyPath());
        else return new $da38ac6aa733c404$var$ListenComplete(this.source, $da38ac6aa733c404$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $da38ac6aa733c404$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($da38ac6aa733c404$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $da38ac6aa733c404$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $da38ac6aa733c404$var$Overwrite(this.source, $da38ac6aa733c404$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $da38ac6aa733c404$var$Merge(this.source, $da38ac6aa733c404$var$newEmptyPath(), childTree);
        } else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $da38ac6aa733c404$var$Merge(this.source, $da38ac6aa733c404$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $da38ac6aa733c404$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($da38ac6aa733c404$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $da38ac6aa733c404$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $da38ac6aa733c404$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $da38ac6aa733c404$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($da38ac6aa733c404$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $da38ac6aa733c404$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$da38ac6aa733c404$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $da38ac6aa733c404$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $da38ac6aa733c404$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === 'value' || change.type === 'child_removed') return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $da38ac6aa733c404$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('Should only compare child_ events.');
    const aWrapped = new $da38ac6aa733c404$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $da38ac6aa733c404$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $da38ac6aa733c404$var$newViewCache(new $da38ac6aa733c404$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $da38ac6aa733c404$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $da38ac6aa733c404$var$newViewCache(viewCache.eventCache, new $da38ac6aa733c404$var$CacheNode(serverSnap, complete, filtered));
}
function $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $da38ac6aa733c404$var$EmptyChildren = ()=>{
    if (!$da38ac6aa733c404$var$emptyChildrenSingleton) $da38ac6aa733c404$var$emptyChildrenSingleton = new $da38ac6aa733c404$var$SortedMap($da38ac6aa733c404$var$stringCompare);
    return $da38ac6aa733c404$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $da38ac6aa733c404$var$ImmutableTree {
    static fromObject(obj) {
        let tree = new $da38ac6aa733c404$var$ImmutableTree(null);
        $da38ac6aa733c404$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $da38ac6aa733c404$var$Path(childPath), childSnap);
        });
        return tree;
    }
    constructor(value, children = $da38ac6aa733c404$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $da38ac6aa733c404$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($da38ac6aa733c404$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $da38ac6aa733c404$var$pathChild(new $da38ac6aa733c404$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($da38ac6aa733c404$var$pathPopFront(relativePath));
            else return new $da38ac6aa733c404$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return new $da38ac6aa733c404$var$ImmutableTree(toSet, this.children);
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $da38ac6aa733c404$var$ImmutableTree(null);
            const newChild = child.set($da38ac6aa733c404$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $da38ac6aa733c404$var$ImmutableTree(null);
            else return new $da38ac6aa733c404$var$ImmutableTree(null, this.children);
        } else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($da38ac6aa733c404$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $da38ac6aa733c404$var$ImmutableTree(null);
                else return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($da38ac6aa733c404$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $da38ac6aa733c404$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $da38ac6aa733c404$var$ImmutableTree(null);
            const newChild = child.setTree($da38ac6aa733c404$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $da38ac6aa733c404$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($da38ac6aa733c404$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($da38ac6aa733c404$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $da38ac6aa733c404$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($da38ac6aa733c404$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $da38ac6aa733c404$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($da38ac6aa733c404$var$pathPopFront(pathToFollow), $da38ac6aa733c404$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $da38ac6aa733c404$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($da38ac6aa733c404$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $da38ac6aa733c404$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($da38ac6aa733c404$var$pathPopFront(pathToFollow), $da38ac6aa733c404$var$pathChild(currentRelativePath, front), f);
            else return new $da38ac6aa733c404$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($da38ac6aa733c404$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($da38ac6aa733c404$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $da38ac6aa733c404$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(null));
    }
}
function $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $da38ac6aa733c404$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $da38ac6aa733c404$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $da38ac6aa733c404$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $da38ac6aa733c404$var$CompoundWrite(newWriteTree);
        }
    }
}
function $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $da38ac6aa733c404$var$each(updates, (childKey, node)=>{
        newWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(newWrite, $da38ac6aa733c404$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $da38ac6aa733c404$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return $da38ac6aa733c404$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $da38ac6aa733c404$var$ImmutableTree(null));
        return new $da38ac6aa733c404$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $da38ac6aa733c404$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($da38ac6aa733c404$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $da38ac6aa733c404$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $da38ac6aa733c404$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $da38ac6aa733c404$var$CompoundWrite(new $da38ac6aa733c404$var$ImmutableTree(shadowingNode));
        else return new $da38ac6aa733c404$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $da38ac6aa733c404$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $da38ac6aa733c404$var$compoundWriteApply(compoundWrite, node) {
    return $da38ac6aa733c404$var$applySubtreeWrite($da38ac6aa733c404$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $da38ac6aa733c404$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite = childTree.value;
            } else node = $da38ac6aa733c404$var$applySubtreeWrite($da38ac6aa733c404$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($da38ac6aa733c404$var$pathChild(relativePath, '.priority'), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $da38ac6aa733c404$var$writeTreeChildWrites(writeTree, path) {
    return $da38ac6aa733c404$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $da38ac6aa733c404$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older write on top of newer ones');
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $da38ac6aa733c404$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older merge on top of newer ones');
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $da38ac6aa733c404$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $da38ac6aa733c404$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(idx >= 0, 'removeWrite called with nonexistent writeId.');
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $da38ac6aa733c404$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($da38ac6aa733c404$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $da38ac6aa733c404$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $da38ac6aa733c404$var$each(children, (childName)=>{
                writeTree.visibleWrites = $da38ac6aa733c404$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $da38ac6aa733c404$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $da38ac6aa733c404$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $da38ac6aa733c404$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $da38ac6aa733c404$var$pathContains($da38ac6aa733c404$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $da38ac6aa733c404$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $da38ac6aa733c404$var$writeTreeLayerTree_(writeTree.allWrites, $da38ac6aa733c404$var$writeTreeDefaultFilter_, $da38ac6aa733c404$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $da38ac6aa733c404$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $da38ac6aa733c404$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $da38ac6aa733c404$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($da38ac6aa733c404$var$pathContains(treeRoot, writePath)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($da38ac6aa733c404$var$pathContains(writePath, treeRoot)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($da38ac6aa733c404$var$pathContains(treeRoot, writePath)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($da38ac6aa733c404$var$pathContains(writePath, treeRoot)) {
                    relativePath = $da38ac6aa733c404$var$newRelativePath(writePath, treeRoot);
                    if ($da38ac6aa733c404$var$pathIsEmpty(relativePath)) compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrites(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(write.children, $da38ac6aa733c404$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($da38ac6aa733c404$var$pathPopFront(relativePath));
                            compoundWrite = $da38ac6aa733c404$var$compoundWriteAddWrite(compoundWrite, $da38ac6aa733c404$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('WriteRecord should have .snap or .children');
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($da38ac6aa733c404$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$da38ac6aa733c404$var$compoundWriteHasCompleteWrite(subMerge, $da38ac6aa733c404$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                return $da38ac6aa733c404$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $da38ac6aa733c404$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$da38ac6aa733c404$var$compoundWriteHasCompleteWrite(merge, $da38ac6aa733c404$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($da38ac6aa733c404$var$pathContains(write.path, treePath) || $da38ac6aa733c404$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $da38ac6aa733c404$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                return $da38ac6aa733c404$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $da38ac6aa733c404$var$compoundWriteApply($da38ac6aa733c404$var$compoundWriteChildCompoundWrite(merge, new $da38ac6aa733c404$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $da38ac6aa733c404$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $da38ac6aa733c404$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
    const path = $da38ac6aa733c404$var$pathChild(treePath, childPath);
    if ($da38ac6aa733c404$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($da38ac6aa733c404$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $da38ac6aa733c404$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $da38ac6aa733c404$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $da38ac6aa733c404$var$pathChild(treePath, childKey);
    const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $da38ac6aa733c404$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $da38ac6aa733c404$var$writeTreeShadowingWrite(writeTree, path) {
    return $da38ac6aa733c404$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $da38ac6aa733c404$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $da38ac6aa733c404$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $da38ac6aa733c404$var$compoundWriteGetCompleteNode(merge, $da38ac6aa733c404$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $da38ac6aa733c404$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $da38ac6aa733c404$var$newWriteTree() {
    return {
        visibleWrites: $da38ac6aa733c404$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $da38ac6aa733c404$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $da38ac6aa733c404$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $da38ac6aa733c404$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $da38ac6aa733c404$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $da38ac6aa733c404$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $da38ac6aa733c404$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $da38ac6aa733c404$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $da38ac6aa733c404$var$writeTreeRefChild(writeTreeRef, childName) {
    return $da38ac6aa733c404$var$newWriteTreeRef($da38ac6aa733c404$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $da38ac6aa733c404$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , 'Only child changes supported for tracking');
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $da38ac6aa733c404$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $da38ac6aa733c404$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE = new $da38ac6aa733c404$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $da38ac6aa733c404$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $da38ac6aa733c404$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $da38ac6aa733c404$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $da38ac6aa733c404$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Event snap not indexed');
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Server snap not indexed');
}
function $da38ac6aa733c404$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $da38ac6aa733c404$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $da38ac6aa733c404$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(overwrite.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$da38ac6aa733c404$var$pathIsEmpty(overwrite.path);
            newViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(merge.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $da38ac6aa733c404$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $da38ac6aa733c404$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $da38ac6aa733c404$var$OperationType.LISTEN_COMPLETE) newViewCache = $da38ac6aa733c404$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $c38e0f42709c826a$export$a39cad550e7ab28a)('Unknown operation type: ' + operation.type);
    const changes = accumulator.getChanges();
    $da38ac6aa733c404$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $da38ac6aa733c404$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($da38ac6aa733c404$var$changeValue($da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), 'If change path is empty, we must have complete server data');
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $da38ac6aa733c404$var$ChildrenNode ? serverCache : $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
            if (childKey === '.priority') {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $da38ac6aa733c404$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $da38ac6aa733c404$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $da38ac6aa733c404$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($da38ac6aa733c404$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $da38ac6aa733c404$var$pathGetFront(changePath);
        if (childKey === '.priority') {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $da38ac6aa733c404$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($da38ac6aa733c404$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($da38ac6aa733c404$var$pathGetBack(childChangePath) === '.priority' && childNode.getChild($da38ac6aa733c404$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $da38ac6aa733c404$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $da38ac6aa733c404$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $da38ac6aa733c404$var$pathChild(path, relativePath);
        if ($da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, $da38ac6aa733c404$var$pathGetFront(writePath))) curViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $da38ac6aa733c404$var$pathChild(path, relativePath);
        if (!$da38ac6aa733c404$var$viewProcessorCacheHasChild(viewCache, $da38ac6aa733c404$var$pathGetFront(writePath))) curViewCache = $da38ac6aa733c404$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($da38ac6aa733c404$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $da38ac6aa733c404$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $da38ac6aa733c404$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $da38ac6aa733c404$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $da38ac6aa733c404$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $da38ac6aa733c404$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($da38ac6aa733c404$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $da38ac6aa733c404$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($da38ac6aa733c404$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $da38ac6aa733c404$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($da38ac6aa733c404$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $da38ac6aa733c404$var$Path(name), node);
            });
            return $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $da38ac6aa733c404$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $da38ac6aa733c404$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $da38ac6aa733c404$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $da38ac6aa733c404$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $da38ac6aa733c404$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $da38ac6aa733c404$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $da38ac6aa733c404$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $da38ac6aa733c404$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $da38ac6aa733c404$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $da38ac6aa733c404$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($da38ac6aa733c404$var$pathIsEmpty(path) || $da38ac6aa733c404$var$pathGetFront(path) === '.priority') {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(serverChildren instanceof $da38ac6aa733c404$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                newNode = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $da38ac6aa733c404$var$pathGetFront(path);
            let newChild = $da38ac6aa733c404$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $da38ac6aa733c404$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, $da38ac6aa733c404$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $da38ac6aa733c404$var$writeTreeRefShadowingWrite(writesCache, $da38ac6aa733c404$var$newEmptyPath()) != null;
        return $da38ac6aa733c404$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $da38ac6aa733c404$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $da38ac6aa733c404$var$IndexedFilter(params.getIndex());
        const filter = $da38ac6aa733c404$var$queryParamsGetNodeFilter(params);
        this.processor_ = $da38ac6aa733c404$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $da38ac6aa733c404$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $da38ac6aa733c404$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $da38ac6aa733c404$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $da38ac6aa733c404$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $da38ac6aa733c404$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $da38ac6aa733c404$var$viewGetCompleteNode(view) {
    return $da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $da38ac6aa733c404$var$viewGetCompleteServerCache(view, path) {
    const cache = $da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$da38ac6aa733c404$var$pathIsEmpty(path) && !cache.getImmediateChild($da38ac6aa733c404$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $da38ac6aa733c404$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $da38ac6aa733c404$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(eventRegistration == null, 'A cancel should cancel all event registrations.');
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $da38ac6aa733c404$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$viewCacheGetCompleteServerSnap(view.viewCache_), 'We should always have a full cache before handling merges');
        (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$viewCacheGetCompleteEventSnap(view.viewCache_), 'Missing event cache, even though we have a server cache');
    }
    const oldViewCache = view.viewCache_;
    const result = $da38ac6aa733c404$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $da38ac6aa733c404$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), 'Once a server snap is complete, it should never go back');
    view.viewCache_ = result.viewCache;
    return $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $da38ac6aa733c404$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($da38ac6aa733c404$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($da38ac6aa733c404$var$changeValue(eventSnap.getNode()));
    return $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $da38ac6aa733c404$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $da38ac6aa733c404$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $da38ac6aa733c404$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $da38ac6aa733c404$var$syncPointSetReferenceConstructor(val) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$referenceConstructor$1, '__referenceConstructor has already been defined');
    $da38ac6aa733c404$var$referenceConstructor$1 = val;
}
function $da38ac6aa733c404$var$syncPointGetReferenceConstructor() {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$referenceConstructor$1, 'Reference.ts has not been loaded');
    return $da38ac6aa733c404$var$referenceConstructor$1;
}
function $da38ac6aa733c404$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(view != null, 'SyncTree gave us an op for an invalid query.');
        return $da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($da38ac6aa733c404$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $da38ac6aa733c404$var$ChildrenNode) {
            eventCache = $da38ac6aa733c404$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $da38ac6aa733c404$var$newViewCache(new $da38ac6aa733c404$var$CacheNode(eventCache, eventCacheComplete, false), new $da38ac6aa733c404$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $da38ac6aa733c404$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $da38ac6aa733c404$var$viewAddEventRegistration(view, eventRegistration);
    return $da38ac6aa733c404$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $da38ac6aa733c404$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint);
    if (queryId === 'default') // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($da38ac6aa733c404$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($da38ac6aa733c404$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($da38ac6aa733c404$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($da38ac6aa733c404$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $da38ac6aa733c404$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $da38ac6aa733c404$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $da38ac6aa733c404$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint) {
    return $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint) != null;
}
function $da38ac6aa733c404$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $da38ac6aa733c404$var$referenceConstructor;
function $da38ac6aa733c404$var$syncTreeSetReferenceConstructor(val) {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$referenceConstructor, '__referenceConstructor has already been defined');
    $da38ac6aa733c404$var$referenceConstructor = val;
}
function $da38ac6aa733c404$var$syncTreeGetReferenceConstructor() {
    (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$referenceConstructor, 'Reference.ts has not been loaded');
    return $da38ac6aa733c404$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $da38ac6aa733c404$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $da38ac6aa733c404$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $da38ac6aa733c404$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $da38ac6aa733c404$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $da38ac6aa733c404$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $da38ac6aa733c404$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $da38ac6aa733c404$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $da38ac6aa733c404$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $da38ac6aa733c404$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($da38ac6aa733c404$var$newEmptyPath(), true);
        else $da38ac6aa733c404$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $da38ac6aa733c404$var$Path(pathString), true);
        });
        return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyListenComplete(syncTree, path) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $da38ac6aa733c404$var$ListenComplete($da38ac6aa733c404$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const op = new $da38ac6aa733c404$var$ListenComplete($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === 'default' || $da38ac6aa733c404$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $da38ac6aa733c404$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($da38ac6aa733c404$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$da38ac6aa733c404$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $da38ac6aa733c404$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($da38ac6aa733c404$var$syncTreeQueryForListening_(newQuery), $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($da38ac6aa733c404$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $da38ac6aa733c404$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const op = new $da38ac6aa733c404$var$Overwrite($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(queryPath, path);
        const changeTree = $da38ac6aa733c404$var$ImmutableTree.fromObject(changedChildren);
        const op = new $da38ac6aa733c404$var$Merge($da38ac6aa733c404$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $da38ac6aa733c404$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $da38ac6aa733c404$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $da38ac6aa733c404$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $da38ac6aa733c404$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(childSyncPoint, $da38ac6aa733c404$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $da38ac6aa733c404$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
        const tag = $da38ac6aa733c404$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $da38ac6aa733c404$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $da38ac6aa733c404$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($da38ac6aa733c404$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathSoFar, path);
        const serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $da38ac6aa733c404$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $da38ac6aa733c404$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $da38ac6aa733c404$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $da38ac6aa733c404$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $da38ac6aa733c404$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $da38ac6aa733c404$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $da38ac6aa733c404$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $da38ac6aa733c404$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $da38ac6aa733c404$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($da38ac6aa733c404$var$pathIsEmpty(operation.path)) return $da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($da38ac6aa733c404$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
        let events = [];
        const childName = $da38ac6aa733c404$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $da38ac6aa733c404$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($da38ac6aa733c404$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($da38ac6aa733c404$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $da38ac6aa733c404$var$syncPointGetCompleteServerCache(syncPoint, $da38ac6aa733c404$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $da38ac6aa733c404$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($da38ac6aa733c404$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $da38ac6aa733c404$var$viewGetServerCache(view) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === 'ok') {
                if (tag) return $da38ac6aa733c404$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $da38ac6aa733c404$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $da38ac6aa733c404$var$errorForServerCode(status, query);
                return $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $da38ac6aa733c404$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + '$' + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $da38ac6aa733c404$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $da38ac6aa733c404$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf('$');
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $da38ac6aa733c404$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $da38ac6aa733c404$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $da38ac6aa733c404$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $da38ac6aa733c404$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $da38ac6aa733c404$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $da38ac6aa733c404$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $da38ac6aa733c404$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $da38ac6aa733c404$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $da38ac6aa733c404$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $da38ac6aa733c404$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($da38ac6aa733c404$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $da38ac6aa733c404$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $da38ac6aa733c404$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $da38ac6aa733c404$var$syncTreeGetNextQueryTag_() {
    return $da38ac6aa733c404$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $da38ac6aa733c404$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, query);
    const listener = $da38ac6aa733c404$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($da38ac6aa733c404$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $c38e0f42709c826a$export$a7a9523472993e97)(!$da38ac6aa733c404$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$da38ac6aa733c404$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $da38ac6aa733c404$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $da38ac6aa733c404$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($da38ac6aa733c404$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $da38ac6aa733c404$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($da38ac6aa733c404$var$syncTreeQueryForListening_(queryToStop), $da38ac6aa733c404$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $da38ac6aa733c404$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $da38ac6aa733c404$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $da38ac6aa733c404$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $da38ac6aa733c404$var$pathChild(this.path_, childName);
        return new $da38ac6aa733c404$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $da38ac6aa733c404$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $da38ac6aa733c404$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    (0, $c38e0f42709c826a$export$a7a9523472993e97)('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $da38ac6aa733c404$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $da38ac6aa733c404$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
const $da38ac6aa733c404$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected server value: ' + op);
    }
};
const $da38ac6aa733c404$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    const delta = op['increment'];
    if (typeof delta !== 'number') (0, $c38e0f42709c826a$export$a7a9523472993e97)(false, 'Unexpected increment value: ' + delta);
    const existingNode = existing.node();
    (0, $c38e0f42709c826a$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $da38ac6aa733c404$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $da38ac6aa733c404$var$resolveDeferredValue(node, new $da38ac6aa733c404$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $da38ac6aa733c404$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $da38ac6aa733c404$var$resolveDeferredValue(node, new $da38ac6aa733c404$var$ExistingValueProvider(existing), serverValues);
};
function $da38ac6aa733c404$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $da38ac6aa733c404$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $da38ac6aa733c404$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $da38ac6aa733c404$var$LeafNode(value, $da38ac6aa733c404$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $da38ac6aa733c404$var$LeafNode(priority));
        childrenNode.forEachChild($da38ac6aa733c404$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $da38ac6aa733c404$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $da38ac6aa733c404$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = '', parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $da38ac6aa733c404$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $da38ac6aa733c404$var$Path ? pathObj : new $da38ac6aa733c404$var$Path(pathObj);
    let child = tree, next = $da38ac6aa733c404$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $da38ac6aa733c404$var$Tree(next, child, childNode);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        next = $da38ac6aa733c404$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $da38ac6aa733c404$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $da38ac6aa733c404$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $da38ac6aa733c404$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $da38ac6aa733c404$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whether the tree is empty (no value or children).
 */ function $da38ac6aa733c404$var$treeIsEmpty(tree) {
    return $da38ac6aa733c404$var$treeGetValue(tree) === undefined && !$da38ac6aa733c404$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $da38ac6aa733c404$var$treeForEachChild(tree, action) {
    $da38ac6aa733c404$var$each(tree.node.children, (child, childTree)=>{
        action(new $da38ac6aa733c404$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $da38ac6aa733c404$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $da38ac6aa733c404$var$treeForEachChild(tree, (child)=>{
        $da38ac6aa733c404$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $da38ac6aa733c404$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $da38ac6aa733c404$var$treeGetPath(tree) {
    return new $da38ac6aa733c404$var$Path(tree.parent === null ? tree.name : $da38ac6aa733c404$var$treeGetPath(tree.parent) + '/' + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $da38ac6aa733c404$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $da38ac6aa733c404$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $da38ac6aa733c404$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $da38ac6aa733c404$var$treeIsEmpty(child);
    const childExists = (0, $c38e0f42709c826a$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $da38ac6aa733c404$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $da38ac6aa733c404$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $da38ac6aa733c404$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $da38ac6aa733c404$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $da38ac6aa733c404$var$MAX_LEAF_SIZE_ = 10485760;
const $da38ac6aa733c404$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$da38ac6aa733c404$var$INVALID_KEY_REGEX_.test(key);
};
const $da38ac6aa733c404$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$da38ac6aa733c404$var$INVALID_PATH_REGEX_.test(pathString);
};
const $da38ac6aa733c404$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $da38ac6aa733c404$var$isValidPathString(pathString);
};
const $da38ac6aa733c404$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$da38ac6aa733c404$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $c38e0f42709c826a$export$2344b14b097df817)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $da38ac6aa733c404$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $da38ac6aa733c404$var$validateFirebaseData((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'value'), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $da38ac6aa733c404$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $da38ac6aa733c404$var$Path ? new $da38ac6aa733c404$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + $da38ac6aa733c404$var$validationPathToErrorString(path));
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + ' with contents = ' + data.toString());
    if ($da38ac6aa733c404$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + $da38ac6aa733c404$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $da38ac6aa733c404$var$MAX_LEAF_SIZE_ / 3 && (0, $c38e0f42709c826a$export$9536dc0a75b20bf9)(data) > $da38ac6aa733c404$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $da38ac6aa733c404$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        let hasDotValue = false;
        let hasActualChild = false;
        $da38ac6aa733c404$var$each(data, (key, value)=>{
            if (key === '.value') hasDotValue = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild = true;
                if (!$da38ac6aa733c404$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $da38ac6aa733c404$var$validationPathPush(path, key);
            $da38ac6aa733c404$var$validateFirebaseData(errorPrefix, value, path);
            $da38ac6aa733c404$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $da38ac6aa733c404$var$validationPathToErrorString(path) + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $da38ac6aa733c404$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $da38ac6aa733c404$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$da38ac6aa733c404$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($da38ac6aa733c404$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $da38ac6aa733c404$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $da38ac6aa733c404$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'values');
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    const mergePaths = [];
    $da38ac6aa733c404$var$each(data, (key, value)=>{
        const curPath = new $da38ac6aa733c404$var$Path(key);
        $da38ac6aa733c404$var$validateFirebaseData(errorPrefix$1, value, $da38ac6aa733c404$var$pathChild(path, curPath));
        if ($da38ac6aa733c404$var$pathGetBack(curPath) === '.priority') {
            if (!$da38ac6aa733c404$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $da38ac6aa733c404$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $da38ac6aa733c404$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($da38ac6aa733c404$var$isInvalidJSONNumber(priority)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'priority') + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$da38ac6aa733c404$var$isValidPriority(priority)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'priority') + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
const $da38ac6aa733c404$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$da38ac6aa733c404$var$isValidKey(key)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $da38ac6aa733c404$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$da38ac6aa733c404$var$isValidPathString(pathString)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $da38ac6aa733c404$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $da38ac6aa733c404$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $da38ac6aa733c404$export$8d83036122ae444e = function(fnName, path) {
    if ($da38ac6aa733c404$var$pathGetFront(path) === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $da38ac6aa733c404$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$da38ac6aa733c404$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$da38ac6aa733c404$var$isValidRootPathString(pathString)) throw new Error((0, $c38e0f42709c826a$export$adea4917e02d93dc)(fnName, 'url') + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $da38ac6aa733c404$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$da38ac6aa733c404$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$da38ac6aa733c404$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $da38ac6aa733c404$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$da38ac6aa733c404$var$pathContains(eventPath, changedPath) || $da38ac6aa733c404$var$pathContains(changedPath, eventPath));
}
function $da38ac6aa733c404$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $da38ac6aa733c404$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $da38ac6aa733c404$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($da38ac6aa733c404$var$logger) $da38ac6aa733c404$var$log('event: ' + eventData.toString());
            $da38ac6aa733c404$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $da38ac6aa733c404$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $da38ac6aa733c404$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $da38ac6aa733c404$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $da38ac6aa733c404$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $da38ac6aa733c404$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    }
}
function $da38ac6aa733c404$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $da38ac6aa733c404$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $da38ac6aa733c404$var$beingCrawled()) {
        repo.server_ = new $da38ac6aa733c404$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$da38ac6aa733c404$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== 'undefined' && authOverride !== null) {
            if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
            try {
                (0, $c38e0f42709c826a$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error('Invalid authOverride provided: ' + e);
            }
        }
        repo.persistentConnection_ = new $da38ac6aa733c404$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $da38ac6aa733c404$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $da38ac6aa733c404$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $da38ac6aa733c404$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $da38ac6aa733c404$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $da38ac6aa733c404$var$SnapshotHolder();
    repo.infoSyncTree_ = new $da38ac6aa733c404$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete('ok');
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $da38ac6aa733c404$var$repoUpdateInfo(repo, 'connected', false);
    repo.serverSyncTree_ = new $da38ac6aa733c404$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $da38ac6aa733c404$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $da38ac6aa733c404$var$Path('.info/serverTimeOffset'));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $da38ac6aa733c404$var$repoGenerateServerValues(repo) {
    return $da38ac6aa733c404$var$generateWithValues({
        timestamp: $da38ac6aa733c404$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $da38ac6aa733c404$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $da38ac6aa733c404$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(data, (raw)=>$da38ac6aa733c404$var$nodeFromJSON(raw));
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $da38ac6aa733c404$var$nodeFromJSON(data);
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $c38e0f42709c826a$export$871de8747c9eaa88)(data, (raw)=>$da38ac6aa733c404$var$nodeFromJSON(raw));
        events = $da38ac6aa733c404$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $da38ac6aa733c404$var$nodeFromJSON(data);
        events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $da38ac6aa733c404$var$repoRerunTransactions(repo, path);
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $da38ac6aa733c404$var$repoOnConnectStatus(repo, connectStatus) {
    $da38ac6aa733c404$var$repoUpdateInfo(repo, 'connected', connectStatus);
    if (connectStatus === false) $da38ac6aa733c404$var$repoRunOnDisconnectEvents(repo);
}
function $da38ac6aa733c404$var$repoOnServerInfoUpdate(repo, updates) {
    $da38ac6aa733c404$var$each(updates, (key, value)=>{
        $da38ac6aa733c404$var$repoUpdateInfo(repo, key, value);
    });
}
function $da38ac6aa733c404$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $da38ac6aa733c404$var$Path('/.info/' + pathString);
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $da38ac6aa733c404$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $da38ac6aa733c404$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $da38ac6aa733c404$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $da38ac6aa733c404$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $da38ac6aa733c404$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $da38ac6aa733c404$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $da38ac6aa733c404$var$repoLog(repo, 'get for query ' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(query) + ' failed: ' + err);
        return Promise.reject(new Error(err));
    });
}
function $da38ac6aa733c404$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $da38ac6aa733c404$var$repoLog(repo, 'set', {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $da38ac6aa733c404$var$nodeFromJSON(newVal, newPriority);
    const existing = $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
    const events = $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $da38ac6aa733c404$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === 'ok';
        if (!success) $da38ac6aa733c404$var$warn('set at ' + path + ' failed: ' + status);
        const clearEvents = $da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, path);
    $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $da38ac6aa733c404$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $da38ac6aa733c404$var$repoLog(repo, 'update', {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $da38ac6aa733c404$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $da38ac6aa733c404$var$resolveDeferredValueTree($da38ac6aa733c404$var$pathChild(path, changedKey), $da38ac6aa733c404$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
        const events = $da38ac6aa733c404$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $da38ac6aa733c404$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === 'ok';
            if (!success) $da38ac6aa733c404$var$warn('update at ' + path + ' failed: ' + status);
            const clearEvents = $da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $da38ac6aa733c404$var$repoRerunTransactions(repo, path) : path;
            $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $da38ac6aa733c404$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, $da38ac6aa733c404$var$pathChild(path, changedPath));
            $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $da38ac6aa733c404$var$log("update() called with empty data.  Don't do anything.");
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $da38ac6aa733c404$var$repoRunOnDisconnectEvents(repo) {
    $da38ac6aa733c404$var$repoLog(repo, 'onDisconnectEvents');
    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $da38ac6aa733c404$var$newSparseSnapshotTree();
    $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $da38ac6aa733c404$var$newEmptyPath(), (path, node)=>{
        const resolved = $da38ac6aa733c404$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $da38ac6aa733c404$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $da38ac6aa733c404$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $da38ac6aa733c404$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($da38ac6aa733c404$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $da38ac6aa733c404$var$repoAbortTransactions(repo, path);
        $da38ac6aa733c404$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $da38ac6aa733c404$var$newSparseSnapshotTree();
    $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $da38ac6aa733c404$var$newEmptyPath(), events);
}
function $da38ac6aa733c404$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $da38ac6aa733c404$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $da38ac6aa733c404$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === 'ok') $da38ac6aa733c404$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $da38ac6aa733c404$var$nodeFromJSON(childNode);
            $da38ac6aa733c404$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $da38ac6aa733c404$var$pathChild(path, childName), newChildNode);
        });
        $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $da38ac6aa733c404$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($da38ac6aa733c404$var$pathGetFront(query._path) === '.info') events = $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $da38ac6aa733c404$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($da38ac6aa733c404$var$pathGetFront(query._path) === '.info') events = $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $da38ac6aa733c404$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $da38ac6aa733c404$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $da38ac6aa733c404$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($da38ac6aa733c404$var$INTERRUPT_REASON);
}
function $da38ac6aa733c404$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($da38ac6aa733c404$var$INTERRUPT_REASON);
}
function $da38ac6aa733c404$var$repoLog(repo, ...varArgs) {
    let prefix = '';
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ':';
    $da38ac6aa733c404$var$log(prefix, ...varArgs);
}
function $da38ac6aa733c404$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $da38ac6aa733c404$var$exceptionGuard(()=>{
        if (status === 'ok') callback(null);
        else {
            const code = (status || 'error').toUpperCase();
            let message = code;
            if (errorReason) message += ': ' + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $da38ac6aa733c404$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $da38ac6aa733c404$var$repoLog(repo, 'transaction on ' + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $da38ac6aa733c404$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $da38ac6aa733c404$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $da38ac6aa733c404$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $da38ac6aa733c404$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $da38ac6aa733c404$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === 'object' && newVal !== null && (0, $c38e0f42709c826a$export$2344b14b097df817)(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $c38e0f42709c826a$export$e51ae4db7b428f67)(newVal, '.priority');
            (0, $c38e0f42709c826a$export$a7a9523472993e97)($da38ac6aa733c404$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $da38ac6aa733c404$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
        const events = $da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $da38ac6aa733c404$var$repoGetLatestState(repo, path, excludeSets) {
    return $da38ac6aa733c404$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $da38ac6aa733c404$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $da38ac6aa733c404$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($da38ac6aa733c404$var$treeGetValue(node)) {
        const queue = $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, node);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(queue.length > 0, 'Sending zero length transaction queue');
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $da38ac6aa733c404$var$repoSendTransactionQueue(repo, $da38ac6aa733c404$var$treeGetPath(node), queue);
    } else if ($da38ac6aa733c404$var$treeHasChildren(node)) $da38ac6aa733c404$var$treeForEachChild(node, (childNode)=>{
        $da38ac6aa733c404$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $da38ac6aa733c404$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $da38ac6aa733c404$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(txn.status === 0 /* TransactionStatus.RUN */ , 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $da38ac6aa733c404$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $da38ac6aa733c404$var$repoLog(repo, 'transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $da38ac6aa733c404$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $da38ac6aa733c404$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $da38ac6aa733c404$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $da38ac6aa733c404$var$treeGetPath(rootMostTransactionNode);
    const queue = $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $da38ac6aa733c404$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $da38ac6aa733c404$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $da38ac6aa733c404$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $da38ac6aa733c404$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $da38ac6aa733c404$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $da38ac6aa733c404$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    let newDataNode = $da38ac6aa733c404$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === 'object' && newData != null && (0, $c38e0f42709c826a$export$2344b14b097df817)(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $da38ac6aa733c404$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $da38ac6aa733c404$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $da38ac6aa733c404$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($da38ac6aa733c404$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $da38ac6aa733c404$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $da38ac6aa733c404$var$pathGetFront(path);
    while(front !== null && $da38ac6aa733c404$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $da38ac6aa733c404$var$treeSubTree(transactionNode, front);
        path = $da38ac6aa733c404$var$pathPopFront(path);
        front = $da38ac6aa733c404$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $da38ac6aa733c404$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $da38ac6aa733c404$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $da38ac6aa733c404$var$treeForEachChild(node, (child)=>{
        $da38ac6aa733c404$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $da38ac6aa733c404$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $da38ac6aa733c404$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $da38ac6aa733c404$var$treeForEachChild(node, (childNode)=>{
        $da38ac6aa733c404$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $da38ac6aa733c404$var$repoAbortTransactions(repo, path) {
    const affectedPath = $da38ac6aa733c404$var$treeGetPath($da38ac6aa733c404$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $da38ac6aa733c404$var$treeSubTree(repo.transactionQueueTree_, path);
    $da38ac6aa733c404$var$treeForEachAncestor(transactionNode, (node)=>{
        $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node);
    });
    $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $da38ac6aa733c404$var$treeForEachDescendant(transactionNode, (node)=>{
        $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $da38ac6aa733c404$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $da38ac6aa733c404$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = 'set';
            } else {
                (0, $c38e0f42709c826a$export$a7a9523472993e97)(queue[i].status === 0 /* TransactionStatus.RUN */ , 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($da38ac6aa733c404$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $da38ac6aa733c404$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $da38ac6aa733c404$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $da38ac6aa733c404$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$da38ac6aa733c404$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$decodePath(pathString) {
    let pathStringDecoded = '';
    const pieces = pathString.split('/');
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $da38ac6aa733c404$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    for (const segment of queryString.split('&')){
        if (segment.length === 0) continue;
        const kv = segment.split('=');
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $da38ac6aa733c404$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $da38ac6aa733c404$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $da38ac6aa733c404$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $da38ac6aa733c404$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $da38ac6aa733c404$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $da38ac6aa733c404$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $da38ac6aa733c404$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $da38ac6aa733c404$var$Path(parsedUrl.pathString)
    };
};
const $da38ac6aa733c404$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        let colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $da38ac6aa733c404$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $da38ac6aa733c404$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $da38ac6aa733c404$var$PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $da38ac6aa733c404$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $da38ac6aa733c404$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(now === 0, 'Cannot push at time == 0');
        let id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $da38ac6aa733c404$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $da38ac6aa733c404$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === 'value') return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, $c38e0f42709c826a$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $da38ac6aa733c404$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return 'cancel';
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ':cancel';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $da38ac6aa733c404$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(this.hasCancelCallback, 'Raising a cancel event on a listener with no cancel callback');
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $da38ac6aa733c404$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.remove', this._path);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.set', this._path);
        $da38ac6aa733c404$var$validateFirebaseDataArg('OnDisconnect.set', value, this._path, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.setWithPriority', this._path);
        $da38ac6aa733c404$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', value, this._path, false);
        $da38ac6aa733c404$var$validatePriority('OnDisconnect.setWithPriority', priority, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $da38ac6aa733c404$export$8d83036122ae444e('OnDisconnect.update', this._path);
        $da38ac6aa733c404$var$validateFirebaseMergeDataArg('OnDisconnect.update', values, this._path, false);
        const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
        $da38ac6aa733c404$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $da38ac6aa733c404$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($da38ac6aa733c404$var$pathIsEmpty(this._path)) return null;
        else return $da38ac6aa733c404$var$pathGetBack(this._path);
    }
    get ref() {
        return new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $da38ac6aa733c404$var$queryParamsGetQueryObject(this._queryParams);
        const id = $da38ac6aa733c404$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $da38ac6aa733c404$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $da38ac6aa733c404$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $da38ac6aa733c404$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $da38ac6aa733c404$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $da38ac6aa733c404$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $da38ac6aa733c404$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $da38ac6aa733c404$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $da38ac6aa733c404$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $da38ac6aa733c404$var$PRIORITY_INDEX) {
        if (startNode != null && !$da38ac6aa733c404$var$isValidPriority(startNode) || endNode != null && !$da38ac6aa733c404$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(params.getIndex() instanceof $da38ac6aa733c404$var$PathIndex || params.getIndex() === $da38ac6aa733c404$var$VALUE_INDEX, 'unknown index type.');
        if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $da38ac6aa733c404$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $da38ac6aa733c404$export$35c3a5e7c9d1033c extends $da38ac6aa733c404$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $da38ac6aa733c404$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $da38ac6aa733c404$var$pathParent(this._path);
        return parentPath === null ? null : new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $da38ac6aa733c404$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $da38ac6aa733c404$var$Path(path);
        const childRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(this.ref, path);
        return new $da38ac6aa733c404$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $da38ac6aa733c404$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `IteratedDataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $da38ac6aa733c404$export$80b98bcbc246c942(node, $da38ac6aa733c404$export$f9574b70e1d95d9d(this.ref, key), $da38ac6aa733c404$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $da38ac6aa733c404$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $da38ac6aa733c404$export$eff4d24c3ff7876e(db, path) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('ref');
    return path !== undefined ? $da38ac6aa733c404$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $da38ac6aa733c404$export$291fc3c05735451(db, url) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('refFromURL');
    const parsedURL = $da38ac6aa733c404$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $da38ac6aa733c404$var$validateUrl('refFromURL', parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $da38ac6aa733c404$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + ' but expected ' + db._repo.repoInfo_.host + ')');
    return $da38ac6aa733c404$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(parent);
    if ($da38ac6aa733c404$var$pathGetFront(parent._path) === null) $da38ac6aa733c404$var$validateRootPathString('child', 'path', path, false);
    else $da38ac6aa733c404$export$8637b026ace8abb1('child', 'path', path, false);
    return new $da38ac6aa733c404$export$35c3a5e7c9d1033c(parent._repo, $da38ac6aa733c404$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $da38ac6aa733c404$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    return new $da38ac6aa733c404$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $da38ac6aa733c404$export$4cbf152802aa238(parent, value) {
    parent = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(parent);
    $da38ac6aa733c404$export$8d83036122ae444e('push', parent._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg('push', value, parent._path, true);
    const now = $da38ac6aa733c404$var$repoServerTime(parent._repo);
    const name = $da38ac6aa733c404$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thenablePushRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $da38ac6aa733c404$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thenablePushRef.then = promise.then.bind(promise);
    thenablePushRef.catch = promise.then.bind(promise, undefined);
    return thenablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $da38ac6aa733c404$export$cd7f480d6b8286c3(ref) {
    $da38ac6aa733c404$export$8d83036122ae444e('remove', ref._path);
    return $da38ac6aa733c404$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e('set', ref._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg('set', value, ref._path, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e('setPriority', ref._path);
    $da38ac6aa733c404$var$validatePriority('setPriority', priority, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, $da38ac6aa733c404$var$pathChild(ref._path, '.priority'), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $da38ac6aa733c404$export$1fa5d5bf488088f3(ref, value, priority) {
    $da38ac6aa733c404$export$8d83036122ae444e('setWithPriority', ref._path);
    $da38ac6aa733c404$var$validateFirebaseDataArg('setWithPriority', value, ref._path, false);
    $da38ac6aa733c404$var$validatePriority('setWithPriority', priority, false);
    if (ref.key === '.length' || ref.key === '.keys') throw 'setWithPriority failed: ' + ref.key + ' is a read-only object.';
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $da38ac6aa733c404$export$722fbec263ad908a(ref, values) {
    $da38ac6aa733c404$var$validateFirebaseMergeDataArg('update', values, ref._path, false);
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    $da38ac6aa733c404$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $da38ac6aa733c404$export$3988ae62b71be9a3(query) {
    query = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(query);
    const callbackContext = new $da38ac6aa733c404$var$CallbackContext(()=>{});
    const container = new $da38ac6aa733c404$var$ValueEventRegistration(callbackContext);
    return $da38ac6aa733c404$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $da38ac6aa733c404$export$80b98bcbc246c942(node, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $da38ac6aa733c404$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === 'value';
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $da38ac6aa733c404$var$DataEvent('value', this, new $da38ac6aa733c404$export$80b98bcbc246c942(change.snapshotNode, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $da38ac6aa733c404$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $da38ac6aa733c404$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $da38ac6aa733c404$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $da38ac6aa733c404$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $c38e0f42709c826a$export$a7a9523472993e97)(change.childName != null, 'Child events should have a childName.');
        const childRef = $da38ac6aa733c404$export$f9574b70e1d95d9d(new $da38ac6aa733c404$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $da38ac6aa733c404$var$DataEvent(change.type, this, new $da38ac6aa733c404$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $da38ac6aa733c404$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $da38ac6aa733c404$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === 'object') {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === 'function') cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $da38ac6aa733c404$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === 'value' ? new $da38ac6aa733c404$var$ValueEventRegistration(callbackContext) : new $da38ac6aa733c404$var$ChildEventRegistration(eventType, callbackContext);
    $da38ac6aa733c404$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $da38ac6aa733c404$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'value', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_added', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_changed', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_moved', callback, cancelCallbackOrListenOptions, options);
}
function $da38ac6aa733c404$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $da38ac6aa733c404$var$addEventListener(query, 'child_removed', callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $da38ac6aa733c404$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $da38ac6aa733c404$var$CallbackContext(callback) : null;
    if (eventType === 'value') container = new $da38ac6aa733c404$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $da38ac6aa733c404$var$ChildEventRegistration(eventType, expCallback);
    $da38ac6aa733c404$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $da38ac6aa733c404$export$b0e86f2c7431df4e {
}
class $da38ac6aa733c404$var$QueryEndAtConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endAt';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('endAt', this._value, query._path, true);
        const newParams = $da38ac6aa733c404$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $da38ac6aa733c404$export$28ec54a8428bdb3f(value, key) {
    $da38ac6aa733c404$var$validateKey('endAt', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryEndAtConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryEndBeforeConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endBefore';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('endBefore', this._value, query._path, false);
        const newParams = $da38ac6aa733c404$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $da38ac6aa733c404$export$57203950645b8b11(value, key) {
    $da38ac6aa733c404$var$validateKey('endBefore', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryEndBeforeConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryStartAtConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAt';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('startAt', this._value, query._path, true);
        const newParams = $da38ac6aa733c404$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $da38ac6aa733c404$export$859941c5fc8eba6b(value = null, key) {
    $da38ac6aa733c404$var$validateKey('startAt', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryStartAtConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryStartAfterConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAfter';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('startAfter', this._value, query._path, false);
        const newParams = $da38ac6aa733c404$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $da38ac6aa733c404$var$validateLimit(newParams);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $da38ac6aa733c404$export$dd8dee5f7b804673(value, key) {
    $da38ac6aa733c404$var$validateKey('startAfter', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryStartAfterConstraint(value, key);
}
class $da38ac6aa733c404$var$QueryLimitToFirstConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToFirst';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, $da38ac6aa733c404$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $da38ac6aa733c404$export$9d02e839f813b99d(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToFirst: First argument must be a positive integer.');
    return new $da38ac6aa733c404$var$QueryLimitToFirstConstraint(limit);
}
class $da38ac6aa733c404$var$QueryLimitToLastConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToLast';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, $da38ac6aa733c404$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $da38ac6aa733c404$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToLast: First argument must be a positive integer.');
    return new $da38ac6aa733c404$var$QueryLimitToLastConstraint(limit);
}
class $da38ac6aa733c404$var$QueryOrderByChildConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
        this.type = 'orderByChild';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByChild');
        const parsedPath = new $da38ac6aa733c404$var$Path(this._path);
        if ($da38ac6aa733c404$var$pathIsEmpty(parsedPath)) throw new Error('orderByChild: cannot pass in empty path. Use orderByValue() instead.');
        const index = new $da38ac6aa733c404$var$PathIndex(parsedPath);
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, index);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $da38ac6aa733c404$export$5162bd9025f8e144(path) {
    if (path === '$key') throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === '$priority') throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === '$value') throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $da38ac6aa733c404$export$8637b026ace8abb1('orderByChild', 'path', path, false);
    return new $da38ac6aa733c404$var$QueryOrderByChildConstraint(path);
}
class $da38ac6aa733c404$var$QueryOrderByKeyConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByKey';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByKey');
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$KEY_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $da38ac6aa733c404$export$d5ab8b3bbd8afbf8() {
    return new $da38ac6aa733c404$var$QueryOrderByKeyConstraint();
}
class $da38ac6aa733c404$var$QueryOrderByPriorityConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByPriority';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByPriority');
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$PRIORITY_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $da38ac6aa733c404$export$19e8ae5500cf2e55() {
    return new $da38ac6aa733c404$var$QueryOrderByPriorityConstraint();
}
class $da38ac6aa733c404$var$QueryOrderByValueConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByValue';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateNoPreviousOrderByCall(query, 'orderByValue');
        const newParams = $da38ac6aa733c404$var$queryParamsOrderBy(query._queryParams, $da38ac6aa733c404$var$VALUE_INDEX);
        $da38ac6aa733c404$var$validateQueryEndpoints(newParams);
        return new $da38ac6aa733c404$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $da38ac6aa733c404$export$7f2f62793c39d0c0() {
    return new $da38ac6aa733c404$var$QueryOrderByValueConstraint();
}
class $da38ac6aa733c404$var$QueryEqualToValueConstraint extends $da38ac6aa733c404$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'equalTo';
    }
    _apply(query) {
        $da38ac6aa733c404$var$validateFirebaseDataArg('equalTo', this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $da38ac6aa733c404$var$QueryEndAtConstraint(this._value, this._key)._apply(new $da38ac6aa733c404$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $da38ac6aa733c404$export$bdcdec1f91f16dff(value, key) {
    $da38ac6aa733c404$var$validateKey('equalTo', 'key', key, true);
    return new $da38ac6aa733c404$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $da38ac6aa733c404$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $da38ac6aa733c404$var$syncPointSetReferenceConstructor($da38ac6aa733c404$export$35c3a5e7c9d1033c);
$da38ac6aa733c404$var$syncTreeSetReferenceConstructor($da38ac6aa733c404$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $da38ac6aa733c404$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
/**
 * Creates and caches `Repo` instances.
 */ const $da38ac6aa733c404$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $da38ac6aa733c404$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $da38ac6aa733c404$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $da38ac6aa733c404$var$RepoInfo(`${host}:${port}`, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $da38ac6aa733c404$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $da38ac6aa733c404$var$log('Using default host for project ', app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $da38ac6aa733c404$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (typeof $cfae44f0dfdf62c0$exports !== 'undefined' && $cfae44f0dfdf62c0$exports.env) dbEmulatorHost = $cfae44f0dfdf62c0$exports.env[$da38ac6aa733c404$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $da38ac6aa733c404$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $da38ac6aa733c404$var$EmulatorTokenProvider($da38ac6aa733c404$var$EmulatorTokenProvider.OWNER) : new $da38ac6aa733c404$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $da38ac6aa733c404$var$validateUrl('Invalid Firebase Database URL', parsedUrl);
    if (!$da38ac6aa733c404$var$pathIsEmpty(parsedUrl.path)) $da38ac6aa733c404$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $da38ac6aa733c404$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $da38ac6aa733c404$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $da38ac6aa733c404$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $da38ac6aa733c404$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $da38ac6aa733c404$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $da38ac6aa733c404$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $da38ac6aa733c404$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $da38ac6aa733c404$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $da38ac6aa733c404$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $da38ac6aa733c404$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $da38ac6aa733c404$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
    repo = new $da38ac6aa733c404$var$Repo(repoInfo, $da38ac6aa733c404$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $da38ac6aa733c404$var$repoManagerForceRestClient(forceRestClient) {
    $da38ac6aa733c404$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $da38ac6aa733c404$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this['type'] = 'database';
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $da38ac6aa733c404$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options['databaseAuthVariableOverride']);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $da38ac6aa733c404$export$35c3a5e7c9d1033c(this._repo, $da38ac6aa733c404$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $da38ac6aa733c404$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $da38ac6aa733c404$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    }
}
function $da38ac6aa733c404$var$checkTransportInit() {
    if ($da38ac6aa733c404$var$TransportManager.IS_TRANSPORT_INITIALIZED) $da38ac6aa733c404$var$warn('Transport has already been initialized. Please call this function before calling ref or setting up a listener');
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $da38ac6aa733c404$export$752b38c15a5377b6() {
    $da38ac6aa733c404$var$checkTransportInit();
    $da38ac6aa733c404$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $da38ac6aa733c404$export$387cff57f2608869() {
    $da38ac6aa733c404$var$checkTransportInit();
    $da38ac6aa733c404$var$WebSocketConnection.forceDisallow();
    $da38ac6aa733c404$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated with the provided
 * {@link @firebase/app#FirebaseApp}. Initializes a new instance with default settings if
 * no instance exists or if the existing instance uses a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $da38ac6aa733c404$export$d0dd861204d0bf72(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), url) {
    const db = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'database').getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)('database');
        if (emulator) $da38ac6aa733c404$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $da38ac6aa733c404$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('useEmulator');
    if (db._instanceStarted) $da38ac6aa733c404$var$fatal('Cannot call useEmulator() after instance has already been initialized.');
    const repo = db._repoInternal;
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $da38ac6aa733c404$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $da38ac6aa733c404$var$EmulatorTokenProvider($da38ac6aa733c404$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === 'string' ? options.mockUserToken : (0, $c38e0f42709c826a$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $da38ac6aa733c404$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $da38ac6aa733c404$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $da38ac6aa733c404$export$bee838355d017f0a(db) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOffline');
    $da38ac6aa733c404$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $da38ac6aa733c404$export$e0eecaabee32dd(db) {
    db = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOnline');
    $da38ac6aa733c404$var$repoResume(db._repo);
}
function $da38ac6aa733c404$export$4e1d237eb9e560af(logger, persistent) {
    $da38ac6aa733c404$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $da38ac6aa733c404$var$registerDatabase(variant) {
    $da38ac6aa733c404$export$c9fb972242fcb3c4((0, $57d436074e210fb5$export$31499a9cd224b78c));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('database', (container, { instanceIdentifier: url })=>{
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider('auth-internal');
        const appCheckProvider = container.getProvider('app-check-internal');
        return $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($da38ac6aa733c404$var$name, $da38ac6aa733c404$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($da38ac6aa733c404$var$name, $da38ac6aa733c404$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $da38ac6aa733c404$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $da38ac6aa733c404$export$3ff8e7e00c3264b7() {
    return $da38ac6aa733c404$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $da38ac6aa733c404$export$a2647aa13413c947(delta) {
    return {
        '.sv': {
            'increment': delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $da38ac6aa733c404$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $da38ac6aa733c404$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(ref);
    $da38ac6aa733c404$export$8d83036122ae444e('Reference.transaction', ref._path);
    if (ref.key === '.length' || ref.key === '.keys') throw 'Reference.transaction failed: ' + ref.key + ' is a read-only object.';
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $da38ac6aa733c404$export$80b98bcbc246c942(node, new $da38ac6aa733c404$export$35c3a5e7c9d1033c(ref._repo, ref._path), $da38ac6aa733c404$var$PRIORITY_INDEX);
            deferred.resolve(new $da38ac6aa733c404$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $da38ac6aa733c404$export$ad30f661f41f4d90(ref, ()=>{});
    $da38ac6aa733c404$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $da38ac6aa733c404$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$da38ac6aa733c404$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$da38ac6aa733c404$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$da38ac6aa733c404$var$Connection;
/**
 * @internal
 */ const $da38ac6aa733c404$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $da38ac6aa733c404$var$PersistentConnection.prototype.put;
    $da38ac6aa733c404$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $da38ac6aa733c404$var$PersistentConnection.prototype.put = oldPut;
    };
};
$da38ac6aa733c404$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $da38ac6aa733c404$export$868c9f20a76f0839 = function(forceRestClient) {
    $da38ac6aa733c404$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 * @internal
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAppCheckImpl - custom app check implementation
 * @param customAuthImpl - custom auth implementation
 */ function $da38ac6aa733c404$export$8efb8ed30f837963({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, nodeAdmin: nodeAdmin = false }) {
    $da38ac6aa733c404$export$c9fb972242fcb3c4(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const componentContainer = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)('database-standalone');
    const authProvider = new (0, $a83e7ccd68ca8d4e$export$2881499e37b75b9a)('auth-internal', componentContainer);
    let appCheckProvider;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $a83e7ccd68ca8d4e$export$2881499e37b75b9a)('app-check-internal', componentContainer);
        appCheckProvider.setComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    authProvider.setComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    return $da38ac6aa733c404$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin);
}
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $da38ac6aa733c404$var$registerDatabase();




// import openUrls from "../open-app-urls/open-urls";
// display._init(data);
const $3932d5095c13a35b$var$omittedWords = [
    "the"
];
let $3932d5095c13a35b$var$data = {
    listings: [],
    businesses: {}
};
const $3932d5095c13a35b$var$colors = {
    headerPrimary: "FFFFFF",
    headerSecondary: "E0E0E0",
    packTitles: "6D6D6D",
    packTitlesHighlight: "3A7D44",
    itemBackgroundPrimary: "3A7D44",
    itemBackgroundSecondary: "fff",
    itemTextPrimary: "FFFFFF",
    itemTextSecondary: "2B2B2B",
    itemTextTerteriary: "3A7D44",
    itemTextFour: "3A7D44",
    itemHighlight: "FF7043",
    itemHighlightText: "FFFFFF"
};
class $3932d5095c13a35b$var$AllDisplaysInitial {
    #isMoreLoadingInitializedForBusinesses;
    #trackedRequestNumber = 0;
    #startSearchIsActive = false;
    #userIsInSearch = false;
    #CTAShareEventsInitialized = false;
    // START REWRITE
    // listings
    #listingsDevided = 'all';
    #inCurrentCategory = "listings";
    #displayFromMostRecentListings = false;
    #isLoadingListings = false;
    #listingsMostRecentLastVisDoc = null;
    #isListingSearch = false;
    #isCalledFrom = 'home';
    #isListingLocationFilter = false;
    #allListingsLoaded = false;
    #nextLoopIndex = 0;
    #currentSearchListingCount = 0;
    #currentSearchListingLimit = 10;
    #listingsSearchResultpathsArr = [];
    #userMachineInterestArr = [];
    #userMachineInterestSortedShowArr = [];
    #detectBottomScrollListingnsOn = false;
    #isExitSearch = false;
    #currentSearchQuery = '';
    #locationFilterData = {};
    #locationFilterLastVisibleDoc = null;
    // Busiensses
    #businessLastVisDoc = null;
    #allBusinessesLoaded = false;
    #isLoadingBusinesses = false;
    #isBusinessesSearch = false;
    #currentSearchBusinessesCount = 0;
    #currentSearchBusinessesLimit = 6;
    #businessesSearchResultpathsArr = [];
    // Sellers
    #sellersLastVisDoc = null;
    #allSellersLoaded = false;
    #isLoadingSellers = false;
    #isSellersSearch = false;
    #currentSearchSellersCount = 0;
    #currentSearchSellersLimit = 8;
    #sellersSearchResultpathsArr = [];
    #allListingsLoadedInLocationFilter = false;
    // Promoted items
    #allPromotedLoaded = false;
    #blockAutoPaddingTop = false;
    #miniHeight = 0;
    #scrollStates = new Map();
    #dinaMaxHeight = false;
    #isProgrammaticScroll = false;
    #lastStage = 'FULL';
    #stageResetTimer = null;
    #currentScrollId = null;
    #lockHeaderStage = false;
    #lockHeaderStageDrag = false;
    // START Promoted items
    #lastVisDocMercadoLibre = null;
    #lastVisDocAmazon = null;
    #lastVisDocEbay = null;
    #isLoadingPromotedItems = false;
    #allPromotedMercadoLibreItemsLoaded = false;
    #allPromotedAmazonItemsLoaded = false;
    #allPromotedEbayItemsLoaded = false;
    #listingInEditElement = null;
    #listingInEditType = null;
    #listingInEditDotsButton = null;
    #listingInEditId = null;
    constructor(){
        this.abortController = new AbortController(); // Initialize AbortController
        const myArr = [
            {
                machine: "rastra",
                time: Date.now()
            },
            {
                machine: "retroexcavadora",
                time: Date.now()
            }
        ];
        // GENRALHELPERS._saveArrayLocalStorage(
        //   "UserMachineInterestTrackerArr",
        //   myArr
        // );
        this._getUserMachineInterest();
    // this._CTAShareLiting()
    // MercadoLibre link preview is experimental and the 'previewContainer' has to be in set to display flex in the HTML
    // this._handleLinkPreview("previewContentContainer", "previewLinkInput");
    }
    _getIsInSearchState() {
        let inSearch = false;
        if (this.#isListingSearch || this.#isBusinessesSearch || this.#isSellersSearch) inSearch = true;
        return inSearch;
    }
    _getCurrentCategory() {
        return this.#inCurrentCategory;
    }
    _getUserMachineInterest() {
        const retrievedMachineInterest = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getArrayLocalStorage("UserMachineInterestTrackerArr");
        console.log(retrievedMachineInterest);
        this.#userMachineInterestArr = [];
        retrievedMachineInterest.forEach((machine)=>{
            this.#userMachineInterestArr.push({
                ...machine,
                numberGet: 4,
                lastDocVisible: null,
                skip: false
            });
        });
    }
    async _preparaAllMachineTypes() {
        this.#userMachineInterestSortedShowArr = [];
        const data = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData("machineTypes");
        // console.log(data);
        const mergeUserMachineInterest = (data)=>{
            // console.log(data);
            const currentMachines = this.#userMachineInterestArr.map((obj)=>obj.machine);
            const newMachines = data.filter((item)=>!currentMachines.includes(item.data.name)).map((item)=>({
                    machine: item.data.name,
                    lastDocVisible: null,
                    numberGet: 4,
                    skip: false
                }));
            this.#userMachineInterestArr = this.#userMachineInterestArr.concat(newMachines);
        };
        mergeUserMachineInterest(data);
        // console.log(this.#userMachineInterestArr);
        const logMachinesSortedAndShuffled = async (arr)=>{
            const withTime = [];
            const withoutTime = [];
            // Separate the entries
            arr.forEach((obj)=>{
                if ("time" in obj) withTime.push(obj);
                else withoutTime.push(obj);
            });
            // Helper: Shuffle array in place (Fisher-Yates)
            function shuffle(array) {
                for(let i = array.length - 1; i > 0; i--){
                    const j = Math.floor(Math.random() * (i + 1));
                    [array[i], array[j]] = [
                        array[j],
                        array[i]
                    ];
                }
                return array;
            }
            // Group by time and shuffle ties
            const timeGroups = {};
            withTime.forEach((obj)=>{
                if (!timeGroups[obj.time]) timeGroups[obj.time] = [];
                timeGroups[obj.time].push(obj);
            });
            let sortedWithTime = Object.entries(timeGroups).sort((a, b)=>b[0] - a[0]) // sort time DESC
            .flatMap(([_, group])=>shuffle(group)); // shuffle same time group
            const shuffledWithoutTime = shuffle(withoutTime);
            // Final ordered list
            const finalList = [
                ...sortedWithTime,
                ...shuffledWithoutTime
            ];
            // Log machine names
            finalList.forEach((obj)=>this.#userMachineInterestSortedShowArr.push(obj));
        };
        logMachinesSortedAndShuffled(this.#userMachineInterestArr);
    }
    _scrollContainerToTop(conId) {
        const el = document.getElementById(conId);
        if (!el) return;
        el.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    _scrollToTopOfCurrentCategory() {
        console.log(this.#inCurrentCategory);
        if (this.#inCurrentCategory === 'promotedItems') this._scrollContainerToTop("NVHomeMainContainerPromotedItems");
        if (this.#inCurrentCategory === 'listings') this._scrollContainerToTop("NVHomeMainContainerListings");
        if (this.#inCurrentCategory === 'businesses') this._scrollContainerToTop("NVHomeMainContainerBusinesses");
        if (this.#inCurrentCategory === 'indsellers') this._scrollContainerToTop("NVHomeMainContainerSellers");
    }
    _changeMainCategory(category) {
        const NVHomeMainContainerListings = document.getElementById("NVHomeMainContainerListings");
        const NVHomeMainContainerBusinesses = document.getElementById("NVHomeMainContainerBusinesses");
        const NVHomeMainContainerSellers = document.getElementById("NVHomeMainContainerSellers");
        const locationFilterParentCon = document.getElementById("locationFilterParentCon");
        const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
        const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");
        const buttonScrollTop = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
        buttonScrollTop.style.display = "none";
        console.log(category);
        if (category === "listings") {
            locationFilterParentCon.style.display = "none";
            if (!this.#isListingSearch) locationFilterParentCon.style.display = "flex";
            NVHomeMainContainerBusinesses.style.display = "none";
            NVHomeMainContainerSellers.style.display = "none";
            this._headerStageReseter('HALF');
            this._addHeader3Stage('NVHomeMainContainerListings');
            this._alignItemsConToHeaderBottom('NVHomeMainContainerListings');
            console.log('here');
            NVHomeMainContainerListings.style.display = "flex";
            this.#listingsDevided = 'all';
            this._loadListings(true);
        }
        if (category === "businesses") {
            this._changeBetweenPromotedItems();
            NVHomeMainContainerListings.style.display = "none";
            NVHomeMainContainerSellers.style.display = "none";
            locationFilterParentCon.style.display = "none";
            this._headerStageReseter('HALF');
            this._addHeader3Stage('NVHomeMainContainerBusinesses');
            this._alignItemsConToHeaderBottom('NVHomeMainContainerBusinesses');
            NVHomeMainContainerBusinesses.style.display = "flex";
            this._initBusinessLoads();
        }
        if (category === "indsellers") {
            this._changeBetweenPromotedItems();
            NVHomeMainContainerListings.style.display = "none";
            NVHomeMainContainerBusinesses.style.display = "none";
            locationFilterParentCon.style.display = "none";
            this._headerStageReseter('HALF');
            this._addHeader3Stage('NVHomeMainContainerSellers');
            this._alignItemsConToHeaderBottom('NVHomeMainContainerSellers');
            NVHomeMainContainerSellers.style.display = "flex";
            this._initSellersLoads();
        }
        if (category === "promotedItems") {
            this._changeBetweenPromotedItems(true);
            console.log('Promoted items now');
            NVHomeMainContainerListings.style.display = "none";
            NVHomeMainContainerBusinesses.style.display = "none";
            NVHomeMainContainerSellers.style.display = "none";
            this._headerStageReseter('HALF');
            this._addHeader3Stage('NVHomeMainContainerPromotedItems');
            this._alignItemsConToHeaderBottom('NVHomeMainContainerPromotedItems');
            this._initPromotedItmesLoad(true);
        }
        this.#inCurrentCategory = category;
    }
    _changeBetweenPromotedItems(promoted = false) {
        return;
    }
    _activateDetectScrollToBottomListings = (margin = 0, recent = false)=>{
        if (this.#detectBottomScrollListingnsOn) return;
        this.#detectBottomScrollListingnsOn = true;
        const reuseFunction = (id)=>{
            const container = document.getElementById(id);
            if (!container) {
                console.log("Error: Container not found.");
                return;
            }
            this._detectScrollDirection(container);
            // Add a scroll event listener
            container.addEventListener("scroll", async ()=>{
                const isScrolledToBottom = container.scrollHeight - container.scrollTop - container.clientHeight <= margin;
                if (isScrolledToBottom) {
                    console.log('here');
                    if (this.#inCurrentCategory === "listings") {
                        console.log("Scroll event detected in container, listings:", id);
                        this._loadListings(false, true);
                    }
                    if (this.#inCurrentCategory === "businesses") {
                        console.log("Scroll event detected in container, businesses:", id);
                        if (!this.#allBusinessesLoaded) this._loadBusinesses();
                    }
                    if (this.#inCurrentCategory === "indsellers") {
                        console.log("Scroll event detected in container, indsellers:", id);
                        if (!this.#allSellersLoaded) this._loadSellers();
                    }
                    if (this.#inCurrentCategory === "promotedItems") {
                        if (!this.#allPromotedLoaded) this._initPromotedItmesLoad();
                    }
                }
            });
        };
        reuseFunction('NVHomeMainContainerListings');
        reuseFunction('NVHomeMainContainerBusinesses');
        reuseFunction('NVHomeMainContainerSellers');
    };
    _emptyContainer(id) {
        const MainHomeContainerForAllItemsDisplay = document.getElementById(id);
        MainHomeContainerForAllItemsDisplay.innerHTML = "";
    }
    _addTheRightPaddingToItemsCon(id, extraPadding = 20) {
        const header = document.getElementById("homeHeaderSearchCon1");
        const target = document.getElementById(id);
        if (!header || !target) return;
        const updatePadding = ()=>{
            if (this.#dinaMaxHeight) return;
            if (this.#blockAutoPaddingTop) return;
            const headerHeight = header.offsetHeight;
            target.style.paddingTop = `${headerHeight + extraPadding}px`;
        };
        // Initial set
        updatePadding();
        // Observe real height changes
        const resizeObserver = new ResizeObserver(()=>{
            updatePadding();
        });
        resizeObserver.observe(header);
    }
    // START Listings Handeling
    async _initListingLoads(reset) {
        console.log("Initializing listing loads, reset =", reset);
        if (reset) {
            await this._preparaAllMachineTypes();
            this._emptyContainer('NVHomeMainContainerListings');
            this.#userMachineInterestSortedShowArr.forEach((m)=>{
                m.lastDocVisible = null;
                m.skip = false;
            });
            this.#nextLoopIndex = 0;
            this.#allListingsLoaded = false;
            this.#allListingsLoadedInLocationFilter = false;
            this.#isListingSearch = false; // Maybe this line should be removed, if any abnormalies are noted.
            this.#isListingLocationFilter = false;
            this.#currentSearchListingCount = 0;
            this.#currentSearchListingLimit = 10;
            this.#listingsSearchResultpathsArr = [];
            setTimeout(()=>{
                this._addTheRightPaddingToItemsCon('NVHomeMainContainerListings', 20);
            }, 10);
        }
        this._searchPlaceHolderChangeTo("Buscar Listados");
        this._loadListings(reset);
    }
    async _loadListings(reset, isfromScroll = false) {
        this._searchPlaceHolderChangeTo("Buscar Listados");
        console.log(this.#listingsDevided);
        try {
            setTimeout(()=>{
                this._addTheRightPaddingToItemsCon('NVHomeMainContainerListings', 20);
            }, 10);
            if (reset) {
                console.log('yep here');
                this.#allListingsLoaded = false;
                if (this.#listingsDevided === 'all') {
                    await this._preparaAllMachineTypes();
                    this.#userMachineInterestSortedShowArr.forEach((m)=>{
                        m.lastDocVisible = null;
                        m.skip = false;
                    });
                }
                this._emptyContainer('NVHomeMainContainerListings');
            }
            console.log(this.#isLoadingListings, this.#allListingsLoaded);
            if (this.#isLoadingListings) return;
            if (this.#allListingsLoaded) return;
            if (this.#listingsDevided === 'all') {
                this.#isLoadingListings = true;
                await this._allListingsGetLoop(this.#userMachineInterestSortedShowArr, 12);
                this.#isLoadingListings = false;
            }
            if (this.#listingsDevided === 'search') {
                this.#isLoadingListings = true;
                await this._searchListingsGetLoop();
                this.#isLoadingListings = false;
            }
            if (this.#listingsDevided === 'locationFilter') {
                this.#isLoadingListings = true;
                await this._locationFilterListingsGetLoop(isfromScroll);
                this.#isLoadingListings = false;
            }
        } catch (err) {
            console.error("Error in _loadListings:", err);
        } finally{
            console.log('Finished loading listings');
            // this._activateDetectScrollToBottomListings(100);
            setTimeout(()=>{
                this._addTheRightPaddingToItemsCon('NVHomeMainContainerListings', 20);
            }, 10);
        }
    }
    async _allListingsGetLoop(arr = this.#userMachineInterestSortedShowArr, maxListings = 12) {
        try {
            console.log('HERE Now');
            if (this.#nextLoopIndex === undefined) this.#nextLoopIndex = 0;
            const arrLength = arr.length;
            let index = this.#nextLoopIndex;
            let iterations = 0;
            let loadedCount = 0;
            while(iterations < arrLength && loadedCount < maxListings){
                const machineObj = arr[index];
                const { machine: machine, numberGet: numberGet, skip: skip } = machineObj;
                if (!skip) try {
                    const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMostRelevantListingsWithFilter(machineObj.lastDocVisible, numberGet, "listingMachineType", machine);
                    if (listings && listings.length > 0) {
                        machineObj.lastDocVisible = lastVisibleDoc;
                        loadedCount += listings.length;
                        if (listings.length < numberGet) machineObj.skip = true;
                        this.#isCalledFrom = 'home';
                        this._fillListings(listings.slice(0, maxListings - loadedCount), 'all');
                    } else machineObj.skip = true;
                } catch (err) {
                    console.error(`Error for ${machine}:`, err);
                    machineObj.skip = true;
                }
                index = (index + 1) % arrLength;
                iterations++;
            }
            this.#nextLoopIndex = index;
        } finally{
            if (this.#isListingSearch) return;
            const ListingsContianer = document.getElementById("NVHomeMainContainerListings");
            const addSet = (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._makeAddSetToInsert();
            ListingsContianer.insertAdjacentHTML("beforeend", addSet);
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _searchListingsGetLoop() {
        try {
            if (this.#currentSearchQuery?.length < 1) return;
            if (this.#allListingsLoaded) return;
            console.warn("Searching for:", this.#currentSearchQuery);
            let resultpathsArr = this.#listingsSearchResultpathsArr;
            if (this.#listingsSearchResultpathsArr.length < 1) {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner();
                this.#listingsSearchResultpathsArr = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVsearchListings({
                    query: this.#currentSearchQuery
                });
                resultpathsArr = this.#listingsSearchResultpathsArr;
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
            console.warn(resultpathsArr);
            if (!resultpathsArr || resultpathsArr?.data?.listings?.length < 1) {
                if (this.#currentSearchListingCount < 1) alert(`No hemos encontrado nada con ${this.#currentSearchQuery}.`);
                return;
            } else {
                while(this.#currentSearchListingCount <= this.#currentSearchListingLimit && this.#currentSearchListingCount < resultpathsArr?.data?.listings?.length){
                    const index = this.#currentSearchListingCount;
                    const listingsArr = resultpathsArr.data.listings;
                    // If this is the LAST available listing
                    if (index === listingsArr.length - 1) this.#allListingsLoaded = true;
                    const resultpathArr = listingsArr[index];
                    if (!this.#isListingSearch) return;
                    const listing = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(resultpathArr);
                    if (!this.#isListingSearch) return;
                    this.#isCalledFrom = 'search';
                    this._fillListings([
                        listing
                    ], 'search');
                    this.#currentSearchListingCount++;
                }
                // ✅ Increase limit AFTER loading this batch
                this.#currentSearchListingLimit += 10;
            }
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _locationFilterListingsGetLoop(isfromScroll = false) {
        console.error('yeo, used', this.#listingsDevided);
        try {
            if (this.#isListingLocationFilter) {
                console.log('HERE Now');
                if (this.#allListingsLoadedInLocationFilter) return;
                console.log('still going');
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner();
                const filterData = {
                    lat: this.#locationFilterData.lat,
                    lng: this.#locationFilterData.lng,
                    radiusKm: this.#locationFilterData.radius,
                    lastVisibleMap: this.#locationFilterLastVisibleDoc
                };
                if (!filterData.lat || !filterData.lng || !filterData.radiusKm) {
                    console.error('Missing location filter data:', filterData);
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                    return;
                }
                const { listings: listings, lastVisibleMap: lastVisibleMap, isAllListingsLoaded: isAllListingsLoaded } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getListingsNearby(filterData);
                setTimeout(()=>{
                    if (listings?.length < 3 && !isfromScroll) {
                        this.#lockHeaderStageDrag = true;
                        this._headerStageReseter('FULL');
                    } else this.#lockHeaderStageDrag = false;
                }, 500);
                this.#allListingsLoadedInLocationFilter = isAllListingsLoaded;
                this.#locationFilterLastVisibleDoc = lastVisibleMap;
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                this._fillListings(listings, 'locationFilter');
            }
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _fillListings(listings, isCalledFrom = 'all') {
        const ListingsContianer = document.getElementById("NVHomeMainContainerListings");
        for (const listing of listings){
            if (isCalledFrom !== this.#listingsDevided) return;
            if (this.#inCurrentCategory === "listings") {
                let html = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing, true);
                if (isCalledFrom !== this.#listingsDevided) return;
                ListingsContianer.insertAdjacentHTML("beforeend", html);
            }
        }
    // const addSet = homeScreen._makeAddSetToInsert();
    // ListingsContianer.insertAdjacentHTML(
    //   "beforeend",
    //   addSet
    // );
    }
    // END Listings Handeling
    // START Businesses Handeling
    async _initBusinessLoads(reset) {
        console.log("Initializing businesses loads, reset =", reset);
        if (reset) {
            this._emptyContainer('NVHomeMainContainerBusinesses');
            this.#businessLastVisDoc = null;
            this.#allBusinessesLoaded = false;
            this.#isLoadingBusinesses = false;
            this.#businessesSearchResultpathsArr = [];
            this.#currentSearchBusinessesCount = 0;
            this.#currentSearchBusinessesLimit = 6;
        }
        setTimeout(()=>{
            this._addTheRightPaddingToItemsCon('NVHomeMainContainerBusinesses', 20);
        }, 10);
        this._searchPlaceHolderChangeTo("Buscar Empresas");
        this._loadBusinesses();
    }
    async _loadBusinesses() {
        if (this.#isLoadingBusinesses) return;
        this.#isLoadingBusinesses = true;
        await this._startGetLoopForBusinesses();
        this.#isLoadingBusinesses = false;
    }
    async _startGetLoopForBusinesses(numberGet = 5) {
        console.error('Called load');
        if (this.#allBusinessesLoaded) return;
        console.warn("called");
        if (!this.#isBusinessesSearch) {
            console.warn("called here");
            const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(this.#businessLastVisDoc, numberGet, "businesses", "status", "active");
            console.log(listings, lastVisibleDoc);
            this._fillBusinesses(listings);
            if (listings.length < numberGet) this.#allBusinessesLoaded = true;
            this.#businessLastVisDoc = lastVisibleDoc;
        } else {
            console.error('Called load');
            if (this.#currentSearchQuery?.length < 1) return;
            console.warn("Searching for:", this.#currentSearchQuery);
            let resultpathsArr = this.#businessesSearchResultpathsArr;
            if (this.#businessesSearchResultpathsArr.length < 1) {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner();
                this.#businessesSearchResultpathsArr = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVsearchBusinesses({
                    query: this.#currentSearchQuery
                });
                resultpathsArr = this.#businessesSearchResultpathsArr;
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
            console.warn(resultpathsArr);
            if (!resultpathsArr || resultpathsArr?.data?.businesses?.length < 1) {
                if (this.#currentSearchListingCount < 1) alert(`No hemos encontrado nada con ${this.#currentSearchQuery}.`);
                return;
            } else {
                while(this.#currentSearchBusinessesCount <= this.#currentSearchBusinessesLimit && this.#currentSearchBusinessesCount < resultpathsArr?.data?.businesses?.length){
                    const index = this.#currentSearchBusinessesCount;
                    const businessesArr = resultpathsArr.data.businesses;
                    // If this is the LAST available listing
                    if (index === businessesArr.length - 1) this.#allListingsLoaded = true;
                    const resultpathArr = businessesArr[index];
                    if (!this.#isBusinessesSearch) return;
                    const business = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${resultpathArr}`);
                    if (!this.#isBusinessesSearch) return;
                    this._fillBusinesses([
                        business
                    ], true);
                    this.#currentSearchBusinessesCount++;
                }
                // ✅ Increase limit AFTER loading this batch
                this.#currentSearchBusinessesLimit += 6;
            }
        }
    }
    async _fillBusinesses(businessesIn, isCalledFromSearch = false) {
        if (businessesIn.length < 1) (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        const dataLocal = {
            businesses: {}
        }; // Initialize data object
        try {
            let businesses = businessesIn;
            // Process businesses
            const processedBusinesses = await Promise.all(businesses.map(async (business)=>{
                // Fetch listings for the business
                const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(null, 6, `businesses/${business.businessId}/listings`);
                // Overwrite business in the data object
                dataLocal.businesses[business.businessId] = {
                    ...business,
                    listings: listings || []
                };
                return {
                    ...business,
                    listings: listings
                };
            }));
            // Generate and display HTML for businesses and their listings
            const businessCon = document.getElementById("NVHomeMainContainerBusinesses");
            for (const business of processedBusinesses){
                let listingsHtml = ``;
                if (this.#isBusinessesSearch !== isCalledFromSearch) return;
                if (!Array.isArray(business.listings) || business.listings.length === 0) listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings();
                else for (const listing of business.listings)listingsHtml += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMini(listing, business.colors, "listingInBusiness", business.businessId);
                const businessInPackHtml = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._generateBusiness2v(listingsHtml, business);
                if (this.#isBusinessesSearch !== isCalledFromSearch) return;
                businessCon.insertAdjacentHTML("beforeend", businessInPackHtml);
            }
            // const addSet = homeScreen._makeAddSetToInsert();
            // businessCon.insertAdjacentHTML(
            //   "beforeend",
            //   addSet
            // );
            if (this.#isMoreLoadingInitializedForBusinesses) return;
            this.#isMoreLoadingInitializedForBusinesses = true;
        } catch (err) {
            if (err.name === "AbortError") ;
            else console.error(err);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
        $3932d5095c13a35b$var$data.businesses = dataLocal.businesses;
    }
    // END Businesses Handeling
    // START Sellers Handeling
    async _initSellersLoads(reset) {
        console.log("Initializing sellers loads, reset =", reset);
        if (reset) {
            this._emptyContainer('NVHomeMainContainerSellers');
            this.#sellersLastVisDoc = null;
            this.#allSellersLoaded = false;
            this.#isLoadingSellers = false;
            this.#currentSearchSellersCount = 0;
            this.#currentSearchSellersLimit = 8;
            this.#sellersSearchResultpathsArr = [];
        }
        setTimeout(()=>{
            this._addTheRightPaddingToItemsCon('NVHomeMainContainerSellers', 20);
        }, 10);
        this._searchPlaceHolderChangeTo("Buscar Vendedores");
        this._loadSellers();
    }
    async _loadSellers() {
        if (this.#isLoadingSellers) return;
        this.#isLoadingSellers = true;
        await this._startGetLoopForIndSellers();
        this.#isLoadingSellers = false;
    }
    async _startGetLoopForIndSellers(numberGet = 10) {
        console.warn("called");
        if (!this.#isSellersSearch) {
            console.warn("called here");
            const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(this.#sellersLastVisDoc, numberGet, "accounts", "sellerProfileStatus", "active", true);
            console.log(listings, lastVisibleDoc);
            this._fillIndSellers(listings);
            if (listings.length < numberGet) this.#allSellersLoaded = true;
            // lastVisibleDocToUse = lastVisibleDoc;
            this.#sellersLastVisDoc = lastVisibleDoc;
        } else {
            if (this.#currentSearchQuery?.length < 1) return;
            console.warn("Searching for:", this.#currentSearchQuery);
            let resultpathsArr = this.#sellersSearchResultpathsArr;
            if (this.#sellersSearchResultpathsArr.length < 1) {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner();
                this.#sellersSearchResultpathsArr = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVsearchSellers({
                    query: this.#currentSearchQuery
                });
                resultpathsArr = this.#sellersSearchResultpathsArr;
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
            console.warn(resultpathsArr);
            if (!resultpathsArr || resultpathsArr?.data?.sellers?.length < 1) {
                if (this.#currentSearchListingCount < 1) alert(`No hemos encontrado nada con ${this.#currentSearchQuery}.`);
                return;
            } else {
                while(this.#currentSearchSellersCount <= this.#currentSearchSellersLimit && this.#currentSearchSellersCount < resultpathsArr?.data?.sellers?.length){
                    const index = this.#currentSearchSellersCount;
                    const sellersArr = resultpathsArr.data.sellers;
                    // If this is the LAST available listing
                    if (index === sellersArr.length - 1) this.#allListingsLoaded = true;
                    const resultpathArr = sellersArr[index];
                    if (!this.#isSellersSearch) return;
                    const seller = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${resultpathArr}`);
                    if (!this.#isSellersSearch) return;
                    this._fillIndSellers([
                        seller
                    ], true);
                    this.#currentSearchSellersCount++;
                }
                // ✅ Increase limit AFTER loading this batch
                this.#currentSearchSellersLimit += 6;
            }
        }
    }
    async _fillIndSellers(indSellersIn, isCalledFromSearch = false) {
        if (indSellersIn.length < 1) (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        try {
            // Generate and display HTML for businesses and their listings
            const sellersCon = document.getElementById("NVHomeMainContainerSellers");
            for (const sellerProfile of indSellersIn){
                if (this.#isSellersSearch !== isCalledFromSearch) return;
                let sellersHtml = await (0, $3f7c3a69d36c3418$export$2e2bcd8739ae039)._display(sellerProfile);
                if (this.#isSellersSearch !== isCalledFromSearch) return;
                sellersCon.insertAdjacentHTML("beforeend", sellersHtml);
            // displayIndSellers._insertSellerListings(sellerProfile);
            }
            const addSet = (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._makeAddSetToInsert();
            sellersCon.insertAdjacentHTML("beforeend", addSet);
        // if (this.#isMoreLoadingInitializedForBusinesses) return;
        // this.#isMoreLoadingInitializedForBusinesses = true;
        } catch (err) {
            if (err.name === "AbortError") ;
            else console.error(err);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    // END Sellers Handeling
    // START Promoted Items Handeling
    _mixPlatforms(mercadoLibre, amazon, ebay) {
        const sources = [
            {
                name: 'ml',
                items: [
                    ...mercadoLibre
                ]
            },
            {
                name: 'az',
                items: [
                    ...amazon
                ]
            },
            {
                name: 'eb',
                items: [
                    ...ebay
                ]
            }
        ];
        const result = [];
        while(sources.some((s)=>s.items.length > 0)){
            // only pick from non-empty sources
            const available = sources.filter((s)=>s.items.length > 0);
            // randomly choose one source
            const randomSource = available[Math.floor(Math.random() * available.length)];
            // take the NEXT item (preserves createdAt order)
            result.push(randomSource.items.shift());
        }
        return result;
    }
    async _initPromotedItmesLoad(reset = false) {
        if (this.#isLoadingPromotedItems) return;
        this.#isLoadingPromotedItems = true;
        setTimeout(()=>{
            this._addTheRightPaddingToItemsCon('NVHomeMainContainerPromotedItems', 20);
        }, 10);
        if (reset) {
            this.#lastVisDocMercadoLibre = null;
            this.#lastVisDocAmazon = null;
            this.#lastVisDocEbay = null;
            this.#allPromotedMercadoLibreItemsLoaded = false;
            this.#allPromotedAmazonItemsLoaded = false;
            this.#allPromotedEbayItemsLoaded = false;
        }
        let mercadoLibreItems = [];
        let amazonItems = [];
        let ebayItems = [];
        const getMercadoLibreItems = async ()=>{
            if (this.#allPromotedMercadoLibreItemsLoaded) return;
            const { items: items, lastDoc: lastDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllAffiliatedItemsPaginated('afiliated/mercado-libre/afiliatedItems', 10, this.#lastVisDocMercadoLibre);
            this.#lastVisDocMercadoLibre = lastDoc;
            mercadoLibreItems = items;
            if (items.length < 1) this.#allPromotedMercadoLibreItemsLoaded = true;
        };
        const getAmazonItems = async ()=>{
            if (this.#allPromotedAmazonItemsLoaded) return;
            const { items: items, lastDoc: lastDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllAffiliatedItemsPaginated('afiliated/amazon/afiliatedItems', 10, this.#lastVisDocAmazon);
            this.#lastVisDocAmazon = lastDoc;
            amazonItems = items;
            if (items.length < 1) this.#allPromotedAmazonItemsLoaded = true;
        };
        const getEbayItems = async ()=>{
            if (this.#allPromotedEbayItemsLoaded) return;
            const { items: items, lastDoc: lastDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllAffiliatedItemsPaginated('afiliated/ebay/afiliatedItems', 10, this.#lastVisDocEbay);
            this.#lastVisDocEbay = lastDoc;
            ebayItems = items;
            if (items.length < 1) this.#allPromotedEbayItemsLoaded = true;
        };
        const ske = [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10
        ];
        const renderCon = document.getElementById('NVHomeMainContainerPromotedItems');
        if (reset) {
            renderCon.innerHTML = '';
            ske.forEach((skeNum)=>{
                renderCon.insertAdjacentHTML('beforeend', (0, $f512c4c2fe359fda$export$2e2bcd8739ae039)._generateSkeleton(skeNum));
            });
        }
        try {
            await Promise.all([
                getMercadoLibreItems(),
                getAmazonItems(),
                getEbayItems()
            ]);
            const allItems = this._mixPlatforms(mercadoLibreItems, amazonItems, ebayItems);
            (0, $83f84e92f5d1be87$export$2e2bcd8739ae039)._renderAll('NVHomeMainContainerPromotedItems', allItems, reset);
        } catch (error) {
            console.error('Promoted items load failed:', error);
        } finally{
            this.#isLoadingPromotedItems = false;
        }
    }
    // END Promoted Items Handeling
    _endSearch() {
        const locationFilterParentCon = document.getElementById("locationFilterParentCon");
        const SearchStartUpComponentSearchInput = document.getElementById("SearchStartUpComponentSearchInput");
        this.#lockHeaderStageDrag = false;
        this.#isExitSearch = true;
        SearchStartUpComponentSearchInput.blur();
        this.#currentSearchQuery = '';
        if (this.#inCurrentCategory === "listings") {
            locationFilterParentCon.style.display = 'flex';
            this.#listingsSearchResultpathsArr = [];
            this.#currentSearchListingCount = 0;
            this.#currentSearchListingLimit = 10;
            this.#isListingSearch = false;
            this.#listingsDevided = 'all';
            this._loadListings(true);
        }
        if (this.#inCurrentCategory === "businesses") {
            locationFilterParentCon.style.display = 'none';
            this.#businessesSearchResultpathsArr = [];
            this.#currentSearchBusinessesCount = 0;
            this.#currentSearchBusinessesLimit = 6;
            this.#isBusinessesSearch = false;
            this._initBusinessLoads(true);
        }
        if (this.#inCurrentCategory === "indsellers") {
            locationFilterParentCon.style.display = 'none';
            this.#currentSearchSellersCount = 0;
            this.#currentSearchSellersLimit = 8;
            this.#sellersSearchResultpathsArr = [];
            this.#isSellersSearch = false;
            this._initSellersLoads(true);
        }
    }
    _startSearch() {
        const locationFilterParentCon = document.getElementById("locationFilterParentCon");
        locationFilterParentCon.style.display = 'none';
        this.#lockHeaderStageDrag = true;
        if (this.#isListingSearch || this.#isBusinessesSearch || this.#isSellersSearch) return;
        console.warn('called here');
        const SearchStartUpComponentSearchInput = document.getElementById("SearchStartUpComponentSearchInput");
        if (this.#inCurrentCategory === "listings") {
            this._resetHeaderPosition('NVHomeMainContainerListings', true);
            this.#listingsSearchResultpathsArr = [];
            this.#currentSearchListingCount = 0;
            this.#currentSearchListingLimit = 10;
            this.#isListingSearch = true;
            this.#listingsDevided = 'search';
            this._emptyContainer('NVHomeMainContainerListings');
            this._headerStageReseter('FULL');
        }
        if (this.#inCurrentCategory === "businesses") {
            this._resetHeaderPosition('NVHomeMainContainerBusinesses', true);
            this.#businessesSearchResultpathsArr = [];
            this.#currentSearchBusinessesCount = 0;
            this.#currentSearchBusinessesLimit = 6;
            this.#isBusinessesSearch = true;
            this._initBusinessLoads(true, true);
            this._headerStageReseter('FULL');
        }
        if (this.#inCurrentCategory === "indsellers") {
            this._resetHeaderPosition('NVHomeMainContainerSellers', true);
            this.#currentSearchSellersCount = 0;
            this.#currentSearchSellersLimit = 8;
            this.#sellersSearchResultpathsArr = [];
            this.#isSellersSearch = true;
            this._initSellersLoads(true, true);
            this._headerStageReseter('FULL');
        }
        this.#isExitSearch = false;
        if (this.#startSearchIsActive) return;
        this.#startSearchIsActive = true;
        SearchStartUpComponentSearchInput.addEventListener("blur", (e)=>{
            setTimeout(()=>{
                if (this.#isExitSearch) return;
                const searchQueryVal = e.target.value.trim();
                console.log(searchQueryVal.length);
                if (searchQueryVal.length < 3 && searchQueryVal.length > 0) {
                    alert("B\xfasqueda no v\xe1lida. Tiene que ser mayor a 2 car\xe1cteres.");
                    return;
                }
                if (searchQueryVal.length < 3) return;
                console.log(searchQueryVal);
                this.#currentSearchQuery = searchQueryVal;
                if (this.#inCurrentCategory == "listings") {
                    this.#listingsSearchResultpathsArr = [];
                    this.#currentSearchListingCount = 0;
                    this.#currentSearchListingLimit = 10;
                    this.#listingsMostRecentLastVisDoc = null;
                    this.#allListingsLoaded = false;
                    this._emptyContainer('NVHomeMainContainerListings');
                    this._loadListings(true);
                }
                if (this.#inCurrentCategory == "businesses") {
                    this.#businessesSearchResultpathsArr = [];
                    this.#currentSearchBusinessesCount = 0;
                    this.#currentSearchBusinessesLimit = 6;
                    this.#businessLastVisDoc = null;
                    this.#allBusinessesLoaded = false;
                    this._emptyContainer('NVHomeMainContainerBusinesses');
                    this._initBusinessLoads();
                }
                if (this.#inCurrentCategory == "indsellers") {
                    this.#currentSearchSellersCount = 0;
                    this.#currentSearchSellersLimit = 8;
                    this.#sellersSearchResultpathsArr = [];
                    this.#businessLastVisDoc = null;
                    this.#allBusinessesLoaded = false;
                    this._emptyContainer('NVHomeMainContainerSellers');
                    this._initSellersLoads();
                }
            }, 200);
        });
        SearchStartUpComponentSearchInput.addEventListener("keyup", async (e)=>{
            if (e.key === "Enter") e.target.blur();
        });
        this._resetHeaderPositionToTop();
    }
    _endLocationFilter() {
        const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
        const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");
        this.#lockHeaderStageDrag = false;
        this.#isListingLocationFilter = false;
        this.#isExitSearch = true;
        this.#currentSearchQuery = '';
        if (this.#inCurrentCategory === "listings") {
            locationFilterAdjCon.style.display = 'none';
            locationFilterOpenerCon.style.display = 'flex';
            this.#listingsSearchResultpathsArr = [];
            this.#currentSearchListingCount = 0;
            this.#currentSearchListingLimit = 10;
            this.#listingsDevided = 'all';
            this._loadListings(true);
        }
        if (this.#inCurrentCategory === "businesses") {
            locationFilterAdjCon.style.display = 'none';
            locationFilterOpenerCon.style.display = 'none';
            this.#businessesSearchResultpathsArr = [];
            this.#currentSearchBusinessesCount = 0;
            this.#currentSearchBusinessesLimit = 6;
            this.#isBusinessesSearch = false;
            this._initBusinessLoads(true);
        }
        if (this.#inCurrentCategory === "indsellers") {
            locationFilterAdjCon.style.display = 'none';
            locationFilterOpenerCon.style.display = 'none';
            this.#currentSearchSellersCount = 0;
            this.#currentSearchSellersLimit = 8;
            this.#sellersSearchResultpathsArr = [];
            this.#isSellersSearch = false;
            this._initSellersLoads(true);
        }
    }
    _startLocationFilter() {
        this.#lockHeaderStageDrag = true;
        this._emptyContainer('NVHomeMainContainerListings');
        this._headerStageReseter('FULL');
        this._resetHeaderPosition('NVHomeMainContainerListings', true);
        this.#isListingLocationFilter = true;
        this.#listingsDevided = 'locationFilter';
        const applyFilter = (locationData)=>{
            this.#locationFilterData = locationData;
            console.log('triggered:', locationData);
            if (!this.#locationFilterData.lat || !this.#locationFilterData.lng) {
                alert("Debes seleccionar una ubicaci\xf3n para filtrar sus alrededores.");
                return;
            }
            this.#locationFilterLastVisibleDoc = null;
            this.#allListingsLoadedInLocationFilter = false;
            this.#lockHeaderStageDrag = true;
            this._emptyContainer('NVHomeMainContainerListings');
            this._loadListings(true);
        };
        this._resetHeaderPositionToTop();
        return {
            applyFilter: applyFilter
        };
    }
    // START Used Uop Here NEW
    _handleLinkPreview(containerId, inputId) {
        const container = document.getElementById(containerId);
        const input = document.getElementById(inputId);
        if (!container || !input) return;
        let lastUrl = null;
        let debounceTimer = null;
        input.addEventListener("input", ()=>{
            const url = input.value.trim();
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(()=>{
                if (!isValidUrl(url) || url === lastUrl) {
                    container.innerHTML = "";
                    return;
                }
                lastUrl = url;
                if (!isMercadoLibreSecLink(url)) {
                    container.innerHTML = "";
                    return;
                }
                showLoading(container);
                fetchMercadoLibrePreview(url, container);
            }, 400);
        });
        /* -------------------- MERCADOLIBRE -------------------- */ function fetchMercadoLibrePreview(url, container) {
            fetch(`https://api.microlink.io?url=${encodeURIComponent(url)}`).then((res)=>res.json()).then((res)=>{
                if (!res || res.status !== "success") throw new Error("Microlink failed");
                renderMercadoLibrePreview(container, res.data, url);
            }).catch((err)=>{
                console.error("ML preview error:", err);
                container.innerHTML = `
          <div class="link-preview-error">
            No se pudo cargar la vista previa
          </div>
        `;
            });
        }
        function renderMercadoLibrePreview(container, data, url) {
            const image = data.image?.url || data.images?.[0]?.url || null;
            container.innerHTML = `
      <div class="link-preview-card ml-preview">
        ${image ? `<img src="${image}" alt="Producto Mercado Libre">` : ""}

        <div class="link-preview-content">
          <strong>${escapeHtml(data.title || "Producto en Mercado Libre")}</strong>
          <p>${escapeHtml(data.description || "")}</p>

          <a
            href="${url}"
            target="_blank"
            rel="noopener noreferrer"
            class="ml-buy-button"
          >
            Comprar en Mercado Libre
          </a>
        </div>
      </div>
    `;
        }
        /* -------------------- HELPERS -------------------- */ function isMercadoLibreSecLink(url) {
            try {
                const u = new URL(url);
                return u.hostname.includes("mercadolibre.") && u.pathname.startsWith("/sec/");
            } catch  {
                return false;
            }
        }
        function isValidUrl(value) {
            try {
                new URL(value);
                return true;
            } catch  {
                return false;
            }
        }
        function showLoading(container) {
            container.innerHTML = `
      <div class="link-preview-loading">
        Cargando vista previa\u{2026}
      </div>
    `;
        }
        function escapeHtml(text) {
            const div = document.createElement("div");
            div.textContent = text;
            return div.innerHTML;
        }
    }
    async _CTAShareLiting(dataIn, what = 'listing', onlyShare = false) {
        let data = dataIn;
        const ctaShareListingLabelText = document.getElementById('ctaShareListingLabelText');
        const CTAShareListing = document.getElementById('CTAShareListing');
        const CTAShareListingImage = document.getElementById('CTAShareListingImage');
        const CTAShareListingLabel = document.getElementById('CTAShareListingLabel');
        const CTAShareListingDescription = document.getElementById('CTAShareListingDescription');
        const CTAShareListingButtonShare = document.getElementById('CTAShareListingButtonShare');
        const CTAShareListingButtonClose = document.getElementById('CTAShareListingButtonClose');
        CTAShareListing.style.display = 'flex';
        let CTALabel = '';
        let label = '';
        let description = '';
        let image = '';
        if (what === 'listing') {
            CTALabel = "\xa1Listado Publicado con \xc9xito!";
            console.log('CTAShareLiting');
            let isOnDiscountText = '';
            if (data.onDiscount.amount > 0) isOnDiscountText = 'En descuento ahora';
            image = data.listingImgsIds[0].res_200;
            label = `${data.onDiscount.finalPrice} ${data.listingCoin} \u{2022} ${data.listingName}`;
            description = `${data.listingCondition} | ${isOnDiscountText} | ${data.listingDescription}`;
        }
        if (what === 'business') {
            CTALabel = "\xa1Empresa Publicado con \xc9xito!";
            console.log('CTAShareBusiness');
            image = data.images.profile[0].res_500;
            label = `${data.name} \u{2022} ${data.shortDescription}`;
            description = data.about;
        }
        CTAShareListingImage.src = image;
        ctaShareListingLabelText.textContent = CTALabel;
        CTAShareListingLabel.textContent = label;
        CTAShareListingDescription.textContent = description;
        // }, 500)
        if (this.#CTAShareEventsInitialized) return;
        this.#CTAShareEventsInitialized = true;
        CTAShareListing.addEventListener('click', (e)=>{
            const ignoreClick = e.target.closest(".ctaShareListingCon2");
            if (ignoreClick) return;
            CTAShareListing.style.display = 'none';
        });
        CTAShareListingButtonClose.addEventListener('click', (e)=>{
            CTAShareListing.style.display = 'none';
        });
        CTAShareListingButtonShare.addEventListener('click', (e)=>{
            if (what === 'listing') {
                const btnActionListingShare = document.getElementById('btnActionListingShare');
                btnActionListingShare.click();
                console.log('should share now');
                CTAShareListing.style.display = 'none';
            }
            if (what === 'business') {
                const btnActionBusinessShare = document.getElementById('btnActionBusinessShare');
                if (btnActionBusinessShare) {
                    btnActionBusinessShare.click();
                    CTAShareListing.style.display = 'none';
                    return;
                }
                console.log(dataIn);
                if (onlyShare) this._displayTheRightWay(dataIn.businessId, '', 'business', '', null, '', true, null, false);
                console.log('should share now');
                CTAShareListing.style.display = 'none';
            }
        });
    }
    _getColors() {
        return $3932d5095c13a35b$var$colors;
    }
    _listenAddContainerHeightChanges() {
        const content = document.getElementById('nvHeaderCon2BigAddContainer');
        if (!content) return;
        // Ensure map exists
        if (!this._dynamicHeightStates) this._dynamicHeightStates = new Map();
        // Prevent creating multiple observers
        if (this._addContainerResizeObserver) return;
        let lastHeight = content.offsetHeight;
        this._addContainerResizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const newHeight = this._getTallestChildHeight(content);
                // Ignore if no real change
                if (newHeight === lastHeight) return;
                lastHeight = newHeight;
                // 🔥 Update ALL states
                this._dynamicHeightStates.forEach((state)=>{
                    state.currentHeight = newHeight;
                });
            }
        });
        this._addContainerResizeObserver.observe(content);
    }
    _getTallestChildHeight(container, extra = 20) {
        let tallest = 0;
        for (const child of container.children){
            const h = child.offsetHeight;
            if (h > tallest) tallest = h;
        }
        return tallest + extra;
    }
    _alignItemsConToHeaderBottom(id) {
        this.#lockHeaderStage = true;
        const MAX_ATTEMPTS = 50;
        const RETRY_DELAY = 200;
        const SCROLL_SETTLE_TIME = 400;
        let attempts = 0;
        const tryScroll = ()=>{
            const content = document.getElementById('nvHeaderCon2BigAddContainer');
            const scrollEl = document.getElementById(id);
            if (!content || !scrollEl) return;
            const gottenDelta = this._getTallestChildHeight(content);
            if (!gottenDelta || gottenDelta <= 0) return retry();
            const target = gottenDelta - 20;
            // ⭐ already aligned
            if (scrollEl.scrollTop >= target - 2) {
                this.#lockHeaderStage = false;
                console.log('UNLOCKED (already aligned)');
                return;
            }
            const calcDelta = target - scrollEl.scrollTop;
            scrollEl.scrollBy({
                top: calcDelta,
                behavior: 'smooth'
            });
            const startScrollTop = scrollEl.scrollTop;
            setTimeout(()=>{
                const current = scrollEl.scrollTop;
                // ⭐ SUCCESS
                if (current >= target - 2) {
                    this.#lockHeaderStage = false;
                    console.log('UNLOCKED (scroll finished)');
                    return;
                }
                // ⭐ NO PROGRESS → retry
                if (Math.abs(current - startScrollTop) < 1) {
                    retry();
                    return;
                }
                // ⭐ partial progress → try again
                retry();
            }, SCROLL_SETTLE_TIME);
        };
        const retry = ()=>{
            attempts++;
            if (attempts < MAX_ATTEMPTS) setTimeout(tryScroll, RETRY_DELAY);
            else {
                this.#lockHeaderStage = false;
                console.log('UNLOCKED (max attempts reached)');
            }
        };
        setTimeout(tryScroll, 30);
    }
    _headerStageReseter(stage) {
        const scrollEl = document.getElementById(this.#currentScrollId);
        const header = document.getElementById('homeHeaderSearchCon1');
        const ads = document.getElementById('nvHeaderCon2BigAddContainer');
        if (!scrollEl || !header || !ads) return;
        const heights = {
            adsHeight: ads.offsetHeight,
            headerHeight: header.offsetHeight
        };
        let translate = 0;
        let scrollTarget = 0;
        switch(stage){
            case 'FULL':
                translate = 0;
                scrollTarget = 0;
                break;
            case 'HALF':
                translate = -heights.adsHeight;
                scrollTarget = heights.adsHeight;
                break;
            case 'HIDDEN':
                translate = -heights.headerHeight;
                scrollTarget = heights.headerHeight;
                break;
            default:
                console.warn('_headerStageReseter: invalid stage', stage);
                return;
        }
        // ⭐ Guard scroll logic
        this.#isProgrammaticScroll = true;
        this.#lastStage = stage;
        // ⭐ Animate header
        header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';
        header.style.transform = `translateY(${translate}px)`;
        // ⭐ Sync scroll
        scrollEl.scrollTo({
            top: scrollTarget,
            behavior: 'smooth'
        });
        // ⭐ Release guard after animation
        clearTimeout(this.#stageResetTimer);
        this.#stageResetTimer = setTimeout(()=>{
            this.#isProgrammaticScroll = false;
        }, 350);
    }
    _addHeader3Stage1(scrollId) {
        this.#currentScrollId = scrollId;
        const scrollEl = document.getElementById(scrollId);
        const header = document.getElementById('homeHeaderSearchCon1');
        const ads = document.getElementById('nvHeaderCon2BigAddContainer');
        console.warn(ads);
        if (!scrollEl || !header || !ads) return;
        const BUFFER_DOWN = -5;
        const BUFFER_UP = 5;
        const UP_SCROLL_SPEED_THRESHOLD = 2.5;
        let lastStage = 'FULL';
        let lastScrollTop = scrollEl.scrollTop;
        let lowestScrollReached = scrollEl.scrollTop;
        let lastScrollTime = performance.now();
        let isDragging = false;
        let isDragScroll = false;
        let dragStartY = 0;
        let dragStartX = 0;
        let horizontalDragLock = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let dragDirection = 0;
        const getHeights = ()=>({
                adsHeight: ads.offsetHeight,
                headerHeight: header.offsetHeight,
                halfDistance: header.offsetHeight - ads.offsetHeight
            });
        const clamp = (val, min, max)=>Math.max(min, Math.min(max, val));
        const getCurrentTranslate = ()=>{
            const style = window.getComputedStyle(header);
            const transform = style.transform;
            if (transform === 'none') return 0;
            const matrix = new DOMMatrixReadOnly(transform);
            return matrix.m42;
        };
        const applyTranslate = (y)=>{
            header.style.transform = `translateY(${y}px)`;
            const buttonBack = document.getElementById('homeScreenDisplayAllButtonBack');
            if (buttonBack) {
                if (y < 10) {
                    console.log('here');
                    buttonBack.style.opacity = '.1';
                    buttonBack.style.position = 'absolute';
                } else {
                    buttonBack.style.opacity = '1';
                    buttonBack.style.position = 'flex';
                }
            }
            console.log('here', y);
        };
        const syncScrollToStage = (stage, heights, isInScroll = true)=>{
            if (isInScroll) return;
            const isNearTop = scrollEl.scrollTop <= heights.headerHeight + 40;
            if (!isNearTop) return;
            let target = 0;
            if (stage === 'FULL') target = 0;
            if (stage === 'HALF') target = heights.adsHeight;
            if (stage === 'HIDDEN') target = heights.headerHeight;
            isDragScroll = true;
            scrollEl.scrollTo({
                top: target,
                behavior: 'smooth'
            });
            clearTimeout(scrollEl._scrollGuardTimer);
            scrollEl._scrollGuardTimer = setTimeout(()=>{
                isDragScroll = false;
            }, 350);
        };
        const setStage = (stage, heights, isFromScroll)=>{
            if (this.#lockHeaderStage) return;
            if (stage === lastStage) return;
            lastStage = stage;
            header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';
            switch(stage){
                case 'FULL':
                    applyTranslate(0);
                    break;
                case 'HALF':
                    applyTranslate(-heights.adsHeight);
                    break;
                case 'HIDDEN':
                    applyTranslate(-heights.headerHeight);
                    break;
            }
            syncScrollToStage(stage, heights, isFromScroll);
        };
        const snapByDirection = (isFromScroll)=>{
            const heights = getHeights();
            if (dragDirection < 0) {
                if (lastStage === 'FULL') return setStage('HALF', heights, isFromScroll);
                if (lastStage === 'HALF') return setStage('HIDDEN', heights, isFromScroll);
                return setStage('HIDDEN', heights, isFromScroll);
            }
            if (dragDirection > 0) {
                if (lastStage === 'HIDDEN') return setStage('HALF', heights, isFromScroll);
                if (lastStage === 'HALF') return setStage('FULL', heights, isFromScroll);
                return setStage('FULL', heights, isFromScroll);
            }
            setStage(lastStage, heights, isFromScroll);
        };
        scrollEl.addEventListener('scroll', ()=>{
            if (isDragScroll) return;
            if (this.#lockHeaderStageDrag) return;
            if (this.#lockHeaderStage) return;
            if (isDragging) return;
            const now = performance.now();
            const timeDelta = now - lastScrollTime;
            lastScrollTime = now;
            const scrollTop = scrollEl.scrollTop;
            const heights = getHeights();
            const delta = scrollTop - lastScrollTop;
            const speed = Math.abs(delta) / (timeDelta || 1);
            const distanceToTop = scrollTop;
            if (scrollTop <= BUFFER_UP) {
                header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';
                setStage('FULL', heights);
                lowestScrollReached = 0;
                lastScrollTop = scrollTop;
                return;
            }
            if (scrollTop > lowestScrollReached) lowestScrollReached = scrollTop;
            if (delta > 0) {
                if (scrollTop <= heights.adsHeight + BUFFER_DOWN) setStage('FULL', heights);
                else if (scrollTop <= heights.headerHeight + BUFFER_DOWN) setStage('HALF', heights);
                else setStage('HIDDEN', heights);
            }
            if (delta < 0) {
                const shouldUseSpeedGuard = distanceToTop > heights.headerHeight;
                if (shouldUseSpeedGuard && speed < UP_SCROLL_SPEED_THRESHOLD) {
                    lastScrollTop = scrollTop;
                    return;
                }
                const distanceUp = lowestScrollReached - scrollTop;
                if (distanceUp >= heights.halfDistance + BUFFER_UP) setStage('HALF', heights);
                if (scrollTop <= heights.adsHeight + BUFFER_UP && distanceUp >= heights.adsHeight + BUFFER_UP) setStage('FULL', heights);
                if (scrollTop <= heights.adsHeight + BUFFER_UP) lowestScrollReached = scrollTop;
            }
            lastScrollTop = scrollTop;
        }, {
            passive: true
        });
        /* ---------------- DRAG SYSTEM ---------------- */ header.addEventListener('pointerdown', (e)=>{
            if (this.#lockHeaderStageDrag) return;
            if (this.#lockHeaderStage) return;
            if (e.pointerType !== 'touch') return;
            isDragging = true;
            dragDirection = 0;
            dragStartY = e.clientY;
            dragStartX = e.clientX;
            horizontalDragLock = false;
            startTranslate = getCurrentTranslate();
            header.style.transition = 'none';
            header.setPointerCapture(e.pointerId);
        });
        header.addEventListener('pointermove', (e)=>{
            if (this.#lockHeaderStageDrag) return;
            if (!isDragging) return;
            const heights = getHeights();
            const deltaY = e.clientY - dragStartY;
            const deltaX = e.clientX - dragStartX;
            if (!horizontalDragLock) {
                if (Math.abs(deltaX) > Math.abs(deltaY)) {
                    horizontalDragLock = true;
                    return;
                }
            }
            if (horizontalDragLock) return;
            const delta = deltaY;
            dragDirection = delta > 0 ? 1 : -1;
            currentTranslate = startTranslate + delta;
            currentTranslate = clamp(currentTranslate, -heights.headerHeight, 0);
            applyTranslate(currentTranslate);
        });
        const endDrag = (e)=>{
            if (!isDragging) return;
            isDragging = false;
            header.releasePointerCapture(e.pointerId);
            snapByDirection(false);
        };
        header.addEventListener('pointerup', endDrag);
        header.addEventListener('pointercancel', endDrag);
    }
    _addHeader3Stage(scrollId) {
        this.#currentScrollId = scrollId;
        const scrollEl = document.getElementById(scrollId);
        const header = document.getElementById('homeHeaderSearchCon1');
        const ads = document.getElementById('nvHeaderCon2BigAddContainer');
        if (!scrollEl || !header || !ads) return;
        const BUFFER_DOWN = -5;
        const BUFFER_UP = 5;
        const UP_SCROLL_SPEED_THRESHOLD = 2.5;
        let lastStage = 'FULL';
        let lastScrollTop = scrollEl.scrollTop;
        let lowestScrollReached = scrollEl.scrollTop;
        let lastScrollTime = performance.now();
        let isDragging = false;
        let isDragScroll = false;
        let dragStartY = 0;
        let dragStartX = 0;
        let horizontalDragLock = false;
        let startTranslate = 0;
        let currentTranslate = 0;
        let dragDirection = 0;
        const getHeights = ()=>({
                adsHeight: ads.offsetHeight,
                headerHeight: header.offsetHeight,
                halfDistance: header.offsetHeight - ads.offsetHeight
            });
        const clamp = (val, min, max)=>Math.max(min, Math.min(max, val));
        const getCurrentTranslate = ()=>{
            const style = window.getComputedStyle(header);
            const transform = style.transform;
            if (transform === 'none') return 0;
            return new DOMMatrixReadOnly(transform).m42;
        };
        const applyTranslate = (y)=>{
            header.style.transform = `translateY(${y}px)`;
        };
        const updateBackButton = (stage)=>{
            const buttonBack = document.getElementById('homeScreenDisplayAllButtonBack');
            if (!buttonBack) return;
            // Header hidden: subtle button remains available.
            // Header visible or half-visible: restore normal opacity.
            buttonBack.style.opacity = stage === 'HIDDEN' ? '0.001' : '1';
        };
        // Ensure its initial state matches the fully visible header.
        updateBackButton('FULL');
        const syncScrollToStage = (stage, heights, isInScroll = true)=>{
            if (isInScroll) return;
            const isNearTop = scrollEl.scrollTop <= heights.headerHeight + 40;
            if (!isNearTop) return;
            let target = 0;
            if (stage === 'FULL') target = 0;
            if (stage === 'HALF') target = heights.adsHeight;
            if (stage === 'HIDDEN') target = heights.headerHeight;
            isDragScroll = true;
            scrollEl.scrollTo({
                top: target,
                behavior: 'smooth'
            });
            clearTimeout(scrollEl._scrollGuardTimer);
            scrollEl._scrollGuardTimer = setTimeout(()=>{
                isDragScroll = false;
            }, 350);
        };
        const setStage = (stage, heights, isFromScroll)=>{
            if (this.#lockHeaderStage) return;
            if (stage === lastStage) return;
            lastStage = stage;
            updateBackButton(stage);
            header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';
            switch(stage){
                case 'FULL':
                    applyTranslate(0);
                    break;
                case 'HALF':
                    applyTranslate(-heights.adsHeight);
                    break;
                case 'HIDDEN':
                    applyTranslate(-heights.headerHeight);
                    break;
            }
            syncScrollToStage(stage, heights, isFromScroll);
        };
        const snapByDirection = (isFromScroll)=>{
            const heights = getHeights();
            if (dragDirection < 0) {
                if (lastStage === 'FULL') return setStage('HALF', heights, isFromScroll);
                if (lastStage === 'HALF') return setStage('HIDDEN', heights, isFromScroll);
                return setStage('HIDDEN', heights, isFromScroll);
            }
            if (dragDirection > 0) {
                if (lastStage === 'HIDDEN') return setStage('HALF', heights, isFromScroll);
                if (lastStage === 'HALF') return setStage('FULL', heights, isFromScroll);
                return setStage('FULL', heights, isFromScroll);
            }
            setStage(lastStage, heights, isFromScroll);
        };
        scrollEl.addEventListener('scroll', ()=>{
            if (isDragScroll) return;
            if (this.#lockHeaderStageDrag) return;
            if (this.#lockHeaderStage) return;
            if (isDragging) return;
            const now = performance.now();
            const timeDelta = now - lastScrollTime;
            lastScrollTime = now;
            const scrollTop = scrollEl.scrollTop;
            const heights = getHeights();
            const delta = scrollTop - lastScrollTop;
            const speed = Math.abs(delta) / (timeDelta || 1);
            const distanceToTop = scrollTop;
            if (scrollTop <= BUFFER_UP) {
                header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';
                setStage('FULL', heights);
                lowestScrollReached = 0;
                lastScrollTop = scrollTop;
                return;
            }
            if (scrollTop > lowestScrollReached) lowestScrollReached = scrollTop;
            if (delta > 0) {
                if (scrollTop <= heights.adsHeight + BUFFER_DOWN) setStage('FULL', heights);
                else if (scrollTop <= heights.headerHeight + BUFFER_DOWN) setStage('HALF', heights);
                else setStage('HIDDEN', heights);
            }
            if (delta < 0) {
                const shouldUseSpeedGuard = distanceToTop > heights.headerHeight;
                if (shouldUseSpeedGuard && speed < UP_SCROLL_SPEED_THRESHOLD) {
                    lastScrollTop = scrollTop;
                    return;
                }
                const distanceUp = lowestScrollReached - scrollTop;
                if (distanceUp >= heights.halfDistance + BUFFER_UP) setStage('HALF', heights);
                if (scrollTop <= heights.adsHeight + BUFFER_UP && distanceUp >= heights.adsHeight + BUFFER_UP) setStage('FULL', heights);
                if (scrollTop <= heights.adsHeight + BUFFER_UP) lowestScrollReached = scrollTop;
            }
            lastScrollTop = scrollTop;
        }, {
            passive: true
        });
        /* ---------------- DRAG SYSTEM ---------------- */ header.addEventListener('pointerdown', (e)=>{
            if (this.#lockHeaderStageDrag) return;
            if (this.#lockHeaderStage) return;
            if (e.pointerType !== 'touch') return;
            isDragging = true;
            dragDirection = 0;
            dragStartY = e.clientY;
            dragStartX = e.clientX;
            horizontalDragLock = false;
            startTranslate = getCurrentTranslate();
            header.style.transition = 'none';
            header.setPointerCapture(e.pointerId);
        });
        header.addEventListener('pointermove', (e)=>{
            if (this.#lockHeaderStageDrag) return;
            if (!isDragging) return;
            const heights = getHeights();
            const deltaY = e.clientY - dragStartY;
            const deltaX = e.clientX - dragStartX;
            if (!horizontalDragLock) {
                if (Math.abs(deltaX) > Math.abs(deltaY)) {
                    horizontalDragLock = true;
                    return;
                }
            }
            if (horizontalDragLock) return;
            dragDirection = deltaY > 0 ? 1 : -1;
            currentTranslate = clamp(startTranslate + deltaY, -heights.headerHeight, 0);
            applyTranslate(currentTranslate);
        });
        const endDrag = (e)=>{
            if (!isDragging) return;
            isDragging = false;
            header.releasePointerCapture(e.pointerId);
            snapByDirection(false);
        };
        header.addEventListener('pointerup', endDrag);
        header.addEventListener('pointercancel', endDrag);
    }
    _setActiveDynamicHeightContainer(scrollId) {
        console.log('here');
        const scrollEl = document.getElementById(scrollId);
        const wrapper = document.getElementById('nvHeaderCon2BigAddContainerA');
        if (!scrollEl || !this._dynamicHeightStates) return;
        const state = this._dynamicHeightStates.get(scrollEl);
        if (!state) return;
        this._activeScrollContainer = scrollEl;
        wrapper.style.maxHeight = state.currentHeight > 0 ? state.currentHeight + 'px' : '0px';
        state.lastScrollTop = scrollEl.scrollTop;
    }
    _getNaturalHeight(el) {
        const prevDisplay = el.style.display;
        const prevMaxHeight = el.style.maxHeight;
        el.style.display = 'flex';
        el.style.maxHeight = 'none';
        const height = el.scrollHeight;
        el.style.display = prevDisplay;
        el.style.maxHeight = prevMaxHeight;
        return height;
    }
    _resetHeaderPosition(id, reset = false) {
        const header = document.getElementById("homeHeaderSearchCon1");
        const scrollCon = document.getElementById(id);
        if (!header || !scrollCon) return;
        const state = this.#scrollStates.get(id);
        if (!state) return;
        // 🔥 If reset requested → wipe state
        if (reset) {
            state.lastScrollTop = 0;
            state.currentTranslate = 0;
            state.ticking = false;
            header.style.transform = "translateY(0px)";
            scrollCon.scrollTop = 0;
            return;
        }
        // 🔄 Otherwise restore saved position
        header.style.transform = `translateY(${state.currentTranslate}px)`;
        scrollCon.scrollTop = state.lastScrollTop;
    }
    _resetHeaderPositionToTop() {
        const header = document.getElementById("homeHeaderSearchCon1");
        if (!header) return;
        header.style.transform = "translateY(0px)";
    }
    _detectScrollDirection(container, callback) {
        let lastScrollTop = container.scrollTop;
        container.addEventListener("scroll", ()=>{
            const currentScrollTop = container.scrollTop;
            const diff = currentScrollTop - lastScrollTop;
            if (currentScrollTop < 0) return;
            if (Math.abs(diff) > 50) {
                const direction = diff > 0 ? "down" : "up";
                this._scrollDirectionDecide(direction);
                lastScrollTop = currentScrollTop; // reset after trigger
            }
        });
    }
    _scrollDirectionDecide(direction) {
        if (direction === "up") {
            if (!this.#userIsInSearch) (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._show();
        }
        if (direction === "down") {
            if (!this.#userIsInSearch) (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._hide();
        }
    }
    _abortDisplays() {
        this.abortController.abort(); // Abort all ongoing tasks
        console.log("All display tasks have been aborted.");
        // Reset for future calls
        this.abortController = new AbortController();
    }
    async _getBusinessDataById(id) {
        return $3932d5095c13a35b$var$data.businesses.find((business)=>business.businessId === id);
    }
    // Start Initial Displays
    async _displayTheRightWay(parrentId, listingId = null, lives, from, share, imgRatio, CTAShare, listIn, onlyShare = false) {
        let listingDataBase = null;
        let businessData = null;
        let sharingOverWrite = false;
        console.log('parrentId:', parrentId, 'listingId:', listingId, 'lives:', lives, 'from:', from, 'share:', share, 'imgRatio:', imgRatio, 'CTAShare:', CTAShare, 'onlyShare:', onlyShare);
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando...');
            if (lives === 'business') {
                let listingData = null;
                let list = listIn;
                if (from !== 'business') {
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando negocio...');
                    businessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getBusinessById(parrentId);
                    console.log(businessData);
                }
                if (CTAShare && onlyShare) {
                    this._CTAShareLiting(businessData, 'business', onlyShare);
                    return;
                }
                if (listingId) {
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando listado...', 5000);
                    listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${parrentId}/listings/${listingId}`);
                    listingDataBase = listingData;
                }
                (0, $fa6b7443c0c8b64b$export$2e2bcd8739ae039)._init(businessData, share, list);
                if (listingData) {
                    list = listingData?.listingMachineType;
                    (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._init(listingData, null, null, share, null, imgRatio);
                }
            }
            if (lives === 'seller') {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando listado...');
                let listingData = null;
                listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${parrentId}/listings/${listingId}`);
                if (!listingData) listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`listings/${listingId}`);
                if (!listingData) {
                    alert('No se pudo encontrar el listado.');
                    sharingOverWrite = true;
                    return;
                }
                listingDataBase = listingData;
                (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._init(listingData, null, null, share, null, imgRatio);
            }
        } catch (error) {
            alert(error.message);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            if (CTAShare && !sharingOverWrite) {
                if (lives === 'business' && !listingId) this._CTAShareLiting(businessData, 'business');
                else this._CTAShareLiting(listingDataBase, 'listing');
            }
        }
    }
    _displaySellerEach(sellerId) {
        console.log('seller clicked:', sellerId);
        // indSellersIn._displaySellerEach(sellerId)
        (0, $3f7c3a69d36c3418$export$2e2bcd8739ae039)._displaySellerEach(sellerId);
    }
    _setActiveCategory(category, listingsDevided) {
        this.#listingsDevided = listingsDevided;
        const target = document.querySelector(`.headerCatSelectorOnClick[data-category="${category}"]`);
        setTimeout(()=>{
            if (listingsDevided === 'search') {
                const input = document.getElementById('SearchStartUpComponentSearchInput');
                input.focus();
            }
            if (listingsDevided === 'locationFilter') (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._openLocationFilter();
        }, 200);
        if (!target) {
            console.warn("Category not found:", category);
            return;
        }
        target.click(); // 🔥 reuse your existing logic
    }
    async _actionsOnListingInEditElement(action = null, sellerId = null, businessId = null, listingIdIn = null) {
        console.log('El dots', this.#listingInEditDotsButton);
        console.warn('HERE');
        let listingId = listingIdIn || this.#listingInEditId;
        console.warn('HERE');
        console.log(action, sellerId, businessId, listingId);
        if (!action) return;
        console.warn('HERE');
        if (action === 'remove') {
            console.warn('HERE');
            if (this.#listingInEditType === 'vertical' || this.#listingInEditType === 'business') {
                console.warn('HERE');
                this.#listingInEditElement.remove();
            } else if (this.#listingInEditType === 'each') {
                console.warn('HERE');
                (0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._goBackOnStack(null, this.#listingInEditDotsButton);
            }
        }
        if (action === 'edit') {
            console.warn('HERE');
            let listingData;
            if (businessId) {
                console.warn('HERE');
                listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${businessId}/listings/${listingId}`);
            } else {
                console.warn('HERE');
                listingData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`accounts/${sellerId}/listings/${listingId}`);
            }
            console.log('listingData', listingData);
            if (this.#listingInEditType === 'vertical' || this.#listingInEditType === 'business') {
                console.warn('HERE');
                // Handle vertical listing edit
                function htmlToElement(html) {
                    const temp = document.createElement("div");
                    temp.innerHTML = html.trim();
                    return temp.firstElementChild;
                }
                let business = false;
                if (this.#listingInEditType === 'business') business = true;
                const newEl = htmlToElement((0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listingData, null, null, business));
                console.log(newEl, this.#listingInEditElement);
                if (!newEl || !this.#listingInEditElement) return;
                this.#listingInEditElement.replaceWith(newEl);
            } else if (this.#listingInEditType === 'each') {
                console.warn('HERE');
                (0, $642fdc7e4da030b9$export$2e2bcd8739ae039)._goBackOnStack(null, this.#listingInEditDotsButton);
            }
        }
    }
    _events() {
        window.addEventListener("click", async (e)=>{
            const targetElementListing = e.target.closest(".ActionOpenForDisplayListing"); // Find the closest ancestor with the class
            const targetElementBusiness = e.target.closest(".ActionOpenForDisplay"); // Find the closest ancestor with the class
            const targetElementSeller = e.target.closest(".ActionOpenForDisplaySeller"); // Find the closest ancestor with the class
            if (targetElementListing) {
                const isReturn = e.target.closest(".returnForActionOpenForDisplay");
                if (isReturn) return;
                const businessId = targetElementListing.getAttribute("data-businessid") || "";
                const sellerId = targetElementListing.getAttribute("data-sellerid") || "";
                const listingId = targetElementListing.getAttribute("data-listingid") || "";
                const lives = targetElementListing.getAttribute("data-lives") || "";
                const from = targetElementListing.getAttribute("data-from") || "";
                const imgIn = targetElementListing.querySelector('.nvListingVerCon2').querySelector('.nvListingVerCon2Img');
                // get ration here
                function getClosestAspectRatioClassFromElement(el) {
                    console.log(el);
                    const ratioMap = {
                        "aspectRatio_16-9": 16 / 9,
                        "aspectRatio_9-6": 1.5,
                        "aspectRatio_4-3": 4 / 3,
                        "aspectRatio_1-1": 1,
                        "aspectRatio_3-4": 3 / 4
                    };
                    const width = el.naturalWidth || el.clientWidth || el.offsetWidth;
                    const height = el.naturalHeight || el.clientHeight || el.offsetHeight;
                    if (!width || !height) return "aspectRatio_16-9"; // fallback
                    const actual = width / height;
                    let closestClass = "aspectRatio_16-9";
                    let smallestDiff = Infinity;
                    for (const [cls, ratio] of Object.entries(ratioMap)){
                        const diff = Math.abs(actual - ratio);
                        if (diff < smallestDiff) {
                            smallestDiff = diff;
                            closestClass = cls;
                        }
                    }
                    return closestClass;
                }
                let parrentId = sellerId;
                if (businessId && businessId !== 'undefined') parrentId = businessId;
                const imgRatio = getClosestAspectRatioClassFromElement(imgIn);
                console.warn(imgRatio);
                // Ensure correct data is passed
                this._displayTheRightWay(parrentId, listingId, lives, from, null, imgRatio);
            }
            if (targetElementBusiness) try {
                let businessIdLocal = '';
                const businessParent = e.target.closest(".v20BusinessCon1A");
                const businessParentMain = e.target.closest(".nvBusinessVerCon1A");
                if (businessParent) businessIdLocal = businessParent.dataset.businessid;
                const isReturn = e.target.closest(".returnForActionOpenForDisplay");
                const isDelete = e.target.closest(".v20BusinessCon14Delete");
                const isEdit = e.target.closest(".v20BusinessCon14Edit");
                if (isDelete && businessIdLocal) {
                    const confirmDelete = confirm("Est\xe1s seguro que quieres eliminar este negocio? Esto elimina tambi\xe9n todos los listados publicado en este negocio. Esta acci\xf3n no se puede deshacer.");
                    if (!confirmDelete) return;
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Por favor espera mientras estamos eliminando tu empresa.');
                    const { data: data } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVDeleteBusiness({
                        businessId: businessIdLocal
                    });
                    console.log(data);
                    if (data.status === 'success') {
                        const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
                        (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getUserDataFromBase(userData.userId);
                        alert("Tu empresa ha side eliminado con \xe9xito.");
                        if (businessParentMain) businessParentMain.remove();
                    // StackDisplay._goBackOnStack(businessOpenOptionsEvent, btnActionBusinessDelete)
                    }
                    return;
                }
                if (isEdit && businessIdLocal) {
                    (0, $fa6b7443c0c8b64b$export$2e2bcd8739ae039)._EditBusinessCall(businessIdLocal);
                    return;
                }
                if (isReturn) return;
                const businessId = targetElementBusiness.getAttribute("data-businessid") || "";
                const lives = targetElementBusiness.getAttribute("data-lives") || "";
                console.log("Extracted Data:", {
                    businessId: businessId,
                    lives: lives
                });
                let listingId = '';
                let from = '';
                let imgRatio = '';
                // Ensure correct data is passed
                this._displayTheRightWay(businessId, listingId, lives, from, null, imgRatio);
            } catch (error) {
                console.log(error);
            } finally{
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            }
            if (targetElementSeller) {
                const isEmail = e.target.closest(".nvSellerProfileText2");
                const isBusiness = e.target.closest(".v20BusinessCon1A");
                const isListing = e.target.closest(".nvListingVerCon1");
                if (isEmail || isBusiness || isListing) return;
                const sellerId = targetElementSeller.getAttribute("data-sellerid") || null;
                if (!sellerId) return;
                this._displaySellerEach(sellerId);
            }
        });
        window.addEventListener("click", (e)=>{
            const targetElementListing = e.target.closest(".ActionOpenForDisplayListing");
            const targetElementListingEach = e.target.closest(".nvListingEachCon1A");
            // ActionOpenForDisplay;
            const openListingEditOptions = e.target.closest(".openListingEditOptionsGlobal");
            const openListingShareGlobal = e.target.closest(".openListingShareGlobal");
            const openListingBoostGlobal = e.target.closest(".openListingBoostGlobal");
            const PopOverActionsMenuCon1Closest = e.target.closest(".PopOverActionsMenuCon1");
            const listingParent = e.target.closest(".nvListingVerCon1");
            PopOverActionsMenuCon1Closest;
            if (openListingShareGlobal) {
                const actionCon = e.target.closest(".ActionOpenForDisplay");
                if (!actionCon) return;
                const listingId = actionCon.dataset.id;
                const businessId = actionCon.dataset.businessid;
                (0, $4b8d317367ae1d6a$export$2e2bcd8739ae039)._openPopOver("share", businessId, listingId, e);
                console.log("should open share");
                return;
            }
            if (openListingBoostGlobal) {
                const actionCon = e.target.closest(".ActionOpenForDisplay");
                if (!actionCon) return;
                const listingId = actionCon.dataset.id;
                const businessId = actionCon.dataset.businessid;
                (0, $4b8d317367ae1d6a$export$2e2bcd8739ae039)._openPopOver("boost", businessId, listingId, e);
                console.log("should open boost");
                return;
            }
            if (openListingEditOptions) {
                let element = '';
                let deleteOnly = false;
                if (listingParent) {
                    const dO = listingParent.dataset.deleteonly;
                    if (dO === 'true') deleteOnly = true;
                }
                this.#listingInEditType = 'vertical';
                if (targetElementListingEach) {
                    element = targetElementListingEach;
                    this.#listingInEditType = 'each';
                } else {
                    const hasPaddingParent = targetElementListing.closest(".nvListingVerCon1A");
                    const hasPaddingParentBusiness = targetElementListing.closest(".nvBusinessVerCon1A");
                    if (hasPaddingParentBusiness) this.#listingInEditType = 'business';
                    if (hasPaddingParent) element = hasPaddingParent;
                    else element = targetElementListing;
                }
                console.log('here');
                const businessId = targetElementListing?.getAttribute("data-businessid") || targetElementListingEach?.getAttribute("data-businessid") || "";
                const listingId = targetElementListing?.getAttribute("data-listingid") || targetElementListingEach?.getAttribute("data-listingid") || "";
                (0, $4b8d317367ae1d6a$export$2e2bcd8739ae039)._openPopOver("options", businessId, listingId, e, deleteOnly);
                this.#listingInEditElement = element;
                this.#listingInEditDotsButton = openListingEditOptions;
                this.#listingInEditId = listingId;
                return;
            }
            const isImg = e.target.closest(".ImgForBigDisplay");
            const isImgParent = e.target.closest(".ImgForBigDisplayParentCon");
            const hasOriginalImages = e.target.closest(".hasOriginalImages");
            if (hasOriginalImages && isImg) {
                console.log('here');
                const imgs = hasOriginalImages.dataset.origimg.split("\xb0-\xb0|\xb0-\xb0?\xb0-\xb0|\xb0-\xb0");
                console.log(imgs);
                (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._myOwnImgDisplayerNotAIs(imgs, (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._getCurrentImageIndex());
            } else if (hasOriginalImages && isImgParent) {
                console.log('here');
                const imgs = hasOriginalImages.dataset.origimg.split("\xb0-\xb0|\xb0-\xb0?\xb0-\xb0|\xb0-\xb0");
                console.log(imgs);
                (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._myOwnImgDisplayerNotAIs(imgs, (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._getCurrentImageIndex());
            } else {
                console.log('here');
                if (isImg) {
                    console.log('here');
                    (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._myOwnImgDisplayerNotAIs([
                        isImg.src
                    ]);
                }
                if (isImgParent) {
                    console.log('here');
                    const img = isImgParent.querySelector('img');
                    (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._myOwnImgDisplayerNotAIs([
                        img.src
                    ]);
                }
            }
        });
        window.addEventListener("click", (e)=>{
            const openHelp = e.target.closest(".openHelp");
            if (openHelp) {
                const helpWith = openHelp.dataset.helpwith;
                if (helpWith) (0, $490f6a1b66767e47$export$2e2bcd8739ae039)._open(helpWith);
            }
        });
        const categoryContainers = document.querySelectorAll(".headerCatSelectorOnClick");
        categoryContainers.forEach((container)=>{
            container.addEventListener("click", (e)=>{
                const activeContainer = e.target.closest(".headerCatSelectorOnClick");
                if (!activeContainer) return;
                const { category: category } = activeContainer.dataset;
                // 🔄 Reset all
                categoryContainers.forEach((item)=>{
                    // if (category !== 'promotedItems') {
                    item.classList.remove("homeHeaderCategorySelectCon1Act");
                    const con2 = item.querySelector(".homeHeaderCategorySelectCon2");
                    const text = item.querySelector(".homeHeaderSearchText1");
                    const text2 = item.querySelector(".homeHeaderSearchText1B");
                    con2?.classList.remove("homeHeaderCategorySelectCon2Act");
                    text?.classList.remove("homeHeaderSearchText1ACT");
                    text2?.classList.remove("homeHeaderSearchText1BACT");
                    item?.classList.remove("homeHeaderCategorySelectCon1ACT");
                    item.classList.remove("homeHeaderCategorySelectorPromotedItemsCon1ACT");
                    const con2Pro = item.querySelector(".homeHeaderCategorySelectorPromotedItemsCon4");
                    con2Pro?.classList.remove("homeHeaderCategorySelectorPromotedItemsCon4ACT");
                });
                // 🎯 Activate clicked
                if (category !== 'promotedItems') {
                    const selector1 = activeContainer.querySelector(".homeHeaderCategorySelectCon2");
                    const text = activeContainer.querySelector(".homeHeaderSearchText1");
                    const text2 = activeContainer.querySelector(".homeHeaderSearchText1B");
                    if (!selector1) return;
                    activeContainer.classList.add("homeHeaderCategorySelectCon1Act");
                    selector1.classList.add("homeHeaderCategorySelectCon2Act");
                    text?.classList.add("homeHeaderSearchText1ACT");
                    text2?.classList.add("homeHeaderSearchText1BACT");
                    activeContainer?.classList.add("homeHeaderCategorySelectCon1ACT");
                } else {
                    activeContainer.classList.add("homeHeaderCategorySelectorPromotedItemsCon1ACT");
                    const con2 = activeContainer.querySelector(".homeHeaderCategorySelectorPromotedItemsCon4");
                    con2?.classList.add("homeHeaderCategorySelectorPromotedItemsCon4ACT");
                }
                this._changeMainCategory(category);
                // 🎯 Center the active container
                const scrollParent = activeContainer.parentElement;
                if (scrollParent) {
                    const parentRect = scrollParent.getBoundingClientRect();
                    const childRect = activeContainer.getBoundingClientRect();
                    const offset = childRect.left - parentRect.left - parentRect.width / 2 + childRect.width / 2;
                    scrollParent.scrollBy({
                        left: offset,
                        behavior: "smooth"
                    });
                }
            });
        });
    }
    async _getSetStats() {
        // return
        const appvisits = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getStats("stats/siteVisits/count");
        const numListingsCreated = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getStats("stats/listingsCreated/count");
        const numListingsDeleted = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getStats("stats/listingsDeleted/count");
        const numListings = numListingsCreated - numListingsDeleted;
        const numBusinessesCreated = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getStats("stats/businessesCreated/count");
        const numBusinessesDeleted = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getStats("stats/businessDeleted/count");
        // const numBusinessesDeleted = await firebase._getStats(
        //   "stats/BusinessesDeleted/count"
        // );
        const numBusinesses = numBusinessesCreated - numBusinessesDeleted;
        const numSellerProfilesCreated = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getStats("stats/sellerProfilesCreated/count");
        // const numSellerProfilesDeleted = await firebase._getStats(
        //   "stats/SellerProfilesDeleted/count"
        // );
        const numSellerProfiles = numSellerProfilesCreated;
        // - numSellerProfilesDeleted;
        const homeHeaderSearchText1BListings = document.getElementById("homeHeaderSearchText1BListings");
        const homeHeaderSearchText1BBusinesses = document.getElementById("homeHeaderSearchText1BBusinesses");
        const homeHeaderSearchText1BSellers = document.getElementById("homeHeaderSearchText1BSellers");
        // const appVisitsStats = document.getElementById("appVisitsStats");
        // const appVisitsStatsMainCon = document.getElementById(
        //   "appVisitsStatsMainCon"
        // );
        // appVisitsStatsMainCon.addEventListener("click", () => {
        //   // alert(
        //   //   `¡Esta página ya cuenta con ${GENRALHELPERS._formatToPrice(
        //   //     appvisits
        //   //   )} visitas!`
        //   // );
        //   ctaAlert._openCTARegister(
        //     true,
        //     "Estadísticas de Mercado MAI",
        //     "¡Ya logramos!"
        //   );
        // });
        // GENRALHELPERS._startLoopAnimation("appVisitsStatsMainCon");
        homeHeaderSearchText1BListings.textContent = numListings;
        homeHeaderSearchText1BBusinesses.textContent = numBusinesses;
        homeHeaderSearchText1BSellers.textContent = numSellerProfiles;
    // appVisitsStats.textContent = GENRALHELPERS._formatNumberShort(appvisits);
    }
    async _init() {
        this.#isMoreLoadingInitializedForBusinesses = false;
        this.#startSearchIsActive = false;
        // console.warn("yep called it here");
        this._events();
        // this._getSetStats();
        this._addHeader3Stage('NVHomeMainContainerListings');
        this._activateDetectScrollToBottomListings(100);
    // const conatinerForBackgroundImage = document.getElementById(
    //   "MainHomeContainerForAllItemsDisplay"
    // );
    // conatinerForBackgroundImage.style.backgroundSize = "cover";
    // conatinerForBackgroundImage.style.backgroundPosition = "center";
    // conatinerForBackgroundImage.style.backgroundRepeat = "no-repeat";
    }
    _searchPlaceHolderChangeTo(changeTo) {
        const SearchStartUpComponentSearchInput = document.getElementById("SearchStartUpComponentSearchInput");
        console.log(changeTo);
        SearchStartUpComponentSearchInput.placeholder = changeTo;
    }
    // _handleFromMostRecentSwitch(status) {
    //   this._headerStageReseter('HALF')
    //   this._alignItemsConToHeaderBottom('NVHomeMainContainerListings')
    //   const MainHomeContainerForAllItemsDisplay = document.getElementById(
    //     "NVHomeMainContainerListings"
    //   );
    //   MainHomeContainerForAllItemsDisplay.innerHTML = "";
    //   if (status === false) {
    //   }
    //   if (status) {
    //     this.#displayFromMostRecentListings = true;
    //     this.#trackedRequestNumber++;
    //   } else {
    //     this.#displayFromMostRecentListings = false;
    //   }
    // this._startInitialLoading();
    _getLocalBusinessData(businessId) {
        return $3932d5095c13a35b$var$data.businesses[businessId];
    }
}
var $3932d5095c13a35b$export$2e2bcd8739ae039 = new $3932d5095c13a35b$var$AllDisplaysInitial();









var $5096d35640f6d8d2$exports = {};
$5096d35640f6d8d2$exports = new URL("logo-128.dcba3ec1.png", import.meta.url).toString();


var $9cb97a0140c04199$exports = {};
$9cb97a0140c04199$exports = new URL("error.a820cd8f.png", import.meta.url).toString();






var $18fa326b373aac9b$exports = {};
$18fa326b373aac9b$exports = new URL("help.836683b0.png", import.meta.url).toString();




var $5337ed41807df65f$exports = {};
$5337ed41807df65f$exports = new URL("icon-install.a82f879d.png", import.meta.url).toString();






class $407baa523363756b$var$GenerateHtml {
    _mainMenuGenerate(userName, email, origImg) {
        let profileImgPlaceHolderUse = (0, (/*@__PURE__*/$parcel$interopDefault($f7e2830c161aaed5$exports)));
        if (origImg) profileImgPlaceHolderUse = origImg;
        let userNameForUse = userName;
        let style = "";
        console.log(userName);
        if (!userName || userName === "sin nombre") {
            userNameForUse = "! completa tu perfil de vendedor";
            style = 'style="color: #FF8400"';
            console.log("NOT LOGGED IN");
        }
        return `  
<div class="MainMenuCon1A">
  <div id="MainMenuCon1" class="MainMenuCon1">
    <div class="MainMenuCon2B">
      <div class="ButtonCloseMenuParrentCon">
        <button class="ButtonCloseMenu topRightExitButtonOnFullScreenWindow" id="ButtonCloseMenu">
          <img height="12px" src="${0, (/*@__PURE__*/$parcel$interopDefault($92d6f0f713f0d9c5$exports))}"/>
        </button>
      </div>
    <div class="MainMenuCon2">
      <div id="MainMenuCon3OpenProfile" class="MainMenuCon3">
        <div class="ProfileOpenFotoConBForMenu">
        <img data-origimg="${origImg.join("\xb0-\xb0|\xb0-\xb0?\xb0-\xb0|\xb0-\xb0")}" id="ProfileFotoInMenuTop" class="ProfileOpenFoto ImgForBigDisplay hasOriginalImages" src="${profileImgPlaceHolderUse}"/>
        </div>
        <div class="MainMenuCon4">
          <div ${style} class="MainMenuProfileName">
            ${userNameForUse}
          </div>
          <div class="MainMenuProfileEmail">
            ${email}
          </div>
        </div>
      </div>
      <div
        id="PreInstallConInMenu"
        class="PrePageConForInstallationConB"
      >
        <div class="PrePageCon2A3">
          <div class="PrePageCon2A3Title">Instalar esta aplicaci\xf3n</div>
          <div class="PrePageCon2A4">
            <div class="PrePageCon2A4Description">
              Ahora tambi\xe9n puedes instalar Mercado MAI en tu celular como una
              aplicaci\xf3n m\xf3vil, y lo puedes abrir con un solo click.
            </div>
            <div id="ButtonInstallAppInMenu" class="PrePageCon2A4Button">
              <img height="32px" src="${0, (/*@__PURE__*/$parcel$interopDefault($5337ed41807df65f$exports))}"/>
              <div id="installBtn" class="PrePageCon2A4ButtonText">
                Instalar ahora
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="MainMenuCon5" style="display: none">
        <div class="MainMenuCon5B">
          <div class="MainMenuCon6 openButtonFromMenu" data-open="home" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($58e6274e123f7274$exports))}" alt="" />
              <div class="MainMenuOptionText">Inicio</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="notifications">
              <div class="MainMenuCon7">
              <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($3d1e6e71eb7e5348$exports))}" alt="" />
              <div class="MainMenuOptionText">Notificaciones</div>
              </div>
          </div>
        </div>
      </div>
      <div class="MainMenuCon5" style="display: none">
        <div class="MainMenuCon5B">        
          <div class="MainMenuCon6 openButtonFromMenu" data-open="business">
              <div class="MainMenuCon7">
              <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($532b86f0cc5dafb6$exports))}" alt="" />
              <div class="MainMenuOptionText">Mis publicaciones</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="saved" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($532b86f0cc5dafb6$exports))}" alt="" />
              <div class="MainMenuOptionText">Mis guardados</div>
              </div>
          </div>
        </div>
      </div>
      <div class="MainMenuCon5">
        <div class="MainMenuCon5B">
          <div class="MainMenuCon6 openButtonFromMenu" data-open="about">
              <div class="MainMenuCon7">
              <img class="MainMenuCon7B" height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($5096d35640f6d8d2$exports))}" alt="" />
              <div class="MainMenuOptionText">Acerca de Mercado MAI</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="moreapps" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($99954c935005cf66$exports))}" alt="" />
              <div class="MainMenuOptionText">Mas aplicaciones</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="help" style="display: none;">
              <div class="MainMenuCon7">
              <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($18fa326b373aac9b$exports))}" alt="" />
              <div class="MainMenuOptionText">Ayuda</div>
              </div>
          </div>
          <div class="MainMenuCon6 openButtonFromMenu" data-open="termsofuse">
              <div class="MainMenuCon7">
              <img height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($54f80ec6c63d9279$exports))}" alt="" />
              <div class="MainMenuOptionText">Terminos de uso de la aplicaci\xf3n y pol\xedtica de privacidad</div>
              </div>
          </div>
        </div>

      </div>


      <div class="MainMenuCon5">
        <div class="MainMenuCon5B">
          <div class="MainMenuCon6 openButtonFromMenu" data-open="report-an-error">
              <div class="MainMenuCon7">
              <img class="MainMenuCon7B" height="16px" src="${0, (/*@__PURE__*/$parcel$interopDefault($9cb97a0140c04199$exports))}" alt="" />
              <div class="MainMenuOptionText">Reportar un error</div>
              </div>
          </div>
        </div>

      </div>



    </div>
    </div>
  </div>
</div>`;
    }
}
var $407baa523363756b$export$2e2bcd8739ae039 = new $407baa523363756b$var$GenerateHtml();











class $3ac641e112e66bf5$var$InAppNotification {
    constructor(){
    // this._showNotification("title", "body here", "Open Wallet", "openwallet");
    }
    _notificationAction(action) {
        console.warn(action);
        action;
        if (action === "installnow") (0, $a7738523b33a53ea$export$2e2bcd8739ae039)._installNow();
        if (action === "openhelpchat") (0, $490f6a1b66767e47$export$2e2bcd8739ae039)._openChat();
    }
    _showNotification(title, body, buttonLabel, buttonAction, showTime = 8000) {
        const notificationContainer = document.getElementById("notification-container");
        // Create the notification element
        const notification = document.createElement("div");
        notification.classList.add("notification");
        let actionButtonHtml = ``;
        if (buttonAction) actionButtonHtml = `
        <div class="InnAppNotificationCon3">
            <div data-action="${buttonAction}"
                id="InnAppNotificationButtonAction"
                class="InnAppNotificationText4">
                ${buttonLabel}
            </div>
        </div>
        `;
        // Add title and body
        notification.innerHTML = `
          <p class="InnAppNotificationText1">${title}</p>
          <p class="InnAppNotificationText2">${body}</p>
          <div class="InnAppNotificationCon2">
                ${actionButtonHtml}
                <div class="InnAppNotificationCon4">
                  <img height="20px" src="${0, (/*@__PURE__*/$parcel$interopDefault($9ac61311daad3145$exports))}"/>
                </div>
            </div>
        `;
        // Append the notification to the container
        notificationContainer.appendChild(notification);
        // Show the notification by adding the 'show' class
        setTimeout(()=>{
            notification.classList.add("show");
        }, 0);
        // Auto hide after 8 seconds
        setTimeout(()=>{
            hideNotification(notification);
        }, showTime);
        const InnAppNotificationButtonAction = document.getElementById("InnAppNotificationButtonAction");
        if (InnAppNotificationButtonAction) InnAppNotificationButtonAction.addEventListener("click", ()=>{
            const action = InnAppNotificationButtonAction.dataset.action;
            if (action) this._notificationAction(action);
        });
        // Allow user to slide it up to dismiss
        notification.addEventListener("click", ()=>{
            hideNotification(notification);
        });
        // Function to hide the notification (slide it up)
        function hideNotification(notification) {
            notification.classList.add("hide");
            // Remove notification from the DOM after the animation ends
            notification.addEventListener("transitionend", ()=>{
                notification.remove();
            });
        }
    }
}
var $3ac641e112e66bf5$export$2e2bcd8739ae039 = new $3ac641e112e66bf5$var$InAppNotification();



class $a7738523b33a53ea$var$installApp {
    #isOniOS = false;
    #promtLoaded = false;
    #needsInstalation = false;
    #deferredPrompt;
    #eventsInitialized = false;
    constructor(){
    // TODO later add iOS install CTA
    // console.error('Install called. In DEV mode. NV is in test mode.');
    // console.error('Install not called. In DEV mode. Should be turned back on fro production.');
    // this._initiateInstallApp();
    // setTimeout(() => {
    //   this._IOSInstalled();
    // }, 1000);
    }
    _getMobileOS() {
        const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
        // iOS detection
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "iOS";
        // Android detection
        if (/android/i.test(userAgent)) return "Android";
        return "Other"; // Desktop or something else
    }
    _IOSInstalled() {
        if (this._getMobileOS() === "iOS") {
            const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true; // For iOS Safari
            if (!isStandalone) {
                this.#isOniOS = true;
                this._showInstallModule();
                this._events();
            }
        }
    }
    _setPromtLoaded() {
        console.warn("trigered");
        this.#promtLoaded = true;
    }
    _getNeedsInstalation() {
        return this.#needsInstalation;
    }
    _installNow() {
        if (this.#isOniOS) {
            (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._myOwnImgDisplayerNotAIs([
                "https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/instructions%20imgs%2FiOS%20install%20instructions%20margin.png?alt=media&token=c5b8cbf3-753f-4018-9606-7b8855bf657e"
            ]);
            // displayListing._myOwnImgDisplayerNotAIs([
            //   "https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/instructions%20imgs%2FiOS%20install%20instructions.png?alt=media&token=2a20d689-9b54-467d-bcbe-fcfacc387f5b",
            // ]);
            return;
        }
        this.#deferredPrompt.prompt();
        this.#deferredPrompt.userChoice.then((choiceResult)=>{
            if (choiceResult.outcome === "accepted") console.log("User accepted the A2HS prompt");
            else {
                console.log("User dismissed the A2HS prompt");
                setTimeout(()=>{
                    (0, $3ac641e112e66bf5$export$2e2bcd8739ae039)._showNotification("\xbfYa est\xe1s convencido? \xa1Puede ser m\xe1s f\xe1cil!", "Si est\xe1s disfrutando esta aplicaci\xf3n, inst\xe1lalo ahora y lo tendr\xe1s a un solo click.", "Si quiero instalar", "installmodule", 12000);
                }, 420000);
            }
            this.#deferredPrompt = null;
            // Hide the button after installation attempt
            PreInstallCon.classList.remove("PrePageConForInstallationConDisplay");
        });
    }
    _showInstallModule() {
        console.error("trigered");
        // const PreInstallCon = document.getElementById("PreInstallCon");
        // PreInstallCon.classList.add("PrePageConForInstallationConDisplay");
        const CTAInstallApp = document.getElementById("CTAInstallApp");
        CTAInstallApp.style.display = "flex";
    }
    // Function to wait until this.#promtLoaded is true
    async #waitForPromptLoaded() {
        while(!this.#promtLoaded)// Sleep for a short time before checking again
        await new Promise((resolve)=>setTimeout(resolve, 100));
    }
    _events() {
        if (this.#eventsInitialized) return;
        this.#eventsInitialized = true;
        const CTAInstallAppButtonClose = document.getElementById("CTAInstallAppButtonClose");
        const installButton = document.getElementById("CTAInstallAppButtonInstall");
        // const PreInstallCon = document.getElementById("PreInstallCon");
        // PreInstallCon.classList.add("PrePageConForInstallationConDisplay");
        const CTAInstallApp = document.getElementById("CTAInstallApp");
        CTAInstallApp.style.display = "flex";
        this.#needsInstalation = true;
        // Trigger the install prompt when the button is clicked
        installButton.addEventListener("click", ()=>{
            this._installNow();
        });
        CTAInstallAppButtonClose.addEventListener("click", ()=>{
            CTAInstallApp.style.display = "none";
        //   this.#deferredPrompt = null;
        // PreInstallCon.classList.remove("PrePageConForInstallationConDisplay");
        // setTimeout(() => {
        //   inAppNotification._showNotification(
        //     "¿Quieres Instalar Mercado MAI?",
        //     "Si estás disfrutando esta aplicación, instálalo ahora y lo tendrás a un solo click.",
        //     "Instalar ahora",
        //     "installnow",
        //     12000
        //   );
        // }, 300000);
        });
    }
    async _initiateInstallApp() {
        // // Start Installation
        // Listen for the beforeinstallprompt event
        window.addEventListener("beforeinstallprompt", async (e)=>{
            // Prevent the default installation prompt
            e.preventDefault();
            this.#deferredPrompt = null;
            // Storing the event to trigger it later
            this.#deferredPrompt = e;
            // Show the install button
            await this.#waitForPromptLoaded();
            this._events();
        });
        // Listen for the appinstalled event to track the installation
        window.addEventListener("appinstalled", async (e)=>{
            console.log("PWA was installed");
            const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._registerPWAInstalls((0, $5df95a5c365eca14$export$2e2bcd8739ae039)._getGatheredUserData());
            console.log(result);
            this.#needsInstalation = false;
            // Optionally, you can hide the button permanently once the app is installed
            PreInstallCon.classList.remove("PrePageConForInstallationConDisplay");
        });
    }
}
var $a7738523b33a53ea$export$2e2bcd8739ae039 = new $a7738523b33a53ea$var$installApp();








class $89e0c71703350fdb$var$terms {
    constructor(){
        this._events();
    }
    _close() {
        const TermsConditions = document.getElementById("TermsConditions");
        TermsConditions.style.display = "none";
    }
    _open() {
        // const TermsConditions = document.getElementById("TermsConditions");
        // TermsConditions.style.display = "";
        (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink('https://mercadomaiprivacy.netlify.app');
    }
    _events() {
        const ButtonCloseTermsConditions = document.getElementById("ButtonCloseTermsConditions");
        ButtonCloseTermsConditions.addEventListener("click", ()=>{
            this._close();
        });
    }
}
var $89e0c71703350fdb$export$2e2bcd8739ae039 = new $89e0c71703350fdb$var$terms();




// import startUp from "../main-start-up-screen/start-up";
class $5328a9c179d47403$var$Menu {
    #accountState;
    constructor(){}
    async _setMenu() {
        const container = document.getElementById("MainAppContentContainer");
        const consToRemove = container.querySelectorAll(".MainMenuCon1A");
        if (consToRemove.length > 0) consToRemove.forEach((con)=>{
            con.remove();
        });
        this.#accountState = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        let userName = "Perfil de vendedor";
        let email = "Tu cuenta";
        if (this.#accountState) {
            userName = this.#accountState.userName;
            email = "Cuenta: " + this.#accountState.email;
        }
        let origImg = [];
        origImg.push(this.#accountState?.profileImages?.[0]?.res_1000 ?? this.#accountState?.profileImageUrl);
        const menuScreen = (0, $407baa523363756b$export$2e2bcd8739ae039)._mainMenuGenerate(userName, email, origImg);
        container.insertAdjacentHTML("beforeend", menuScreen);
        const MainMenuCon2 = document.querySelector(".MainMenuCon2B");
        setTimeout(()=>{
            MainMenuCon2.style.left = "0%";
        }, 1);
        const MainMenuCon1A = document.querySelector(".MainMenuCon1A");
        // MainMenuCon1A.innerHTML = "";
        let startX = 0; // Starting X coordinate
        let startY = 0; // Starting Y coordinate
        let currentX = 0; // Current X coordinate
        let isSwiping = false; // Flag to track if a swipe is happening
        let isClick = false; // Flag to track if it's a click event
        MainMenuCon1A.addEventListener("touchstart", (e)=>{
            // Record the initial touch position
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            isSwiping = true; // Start tracking swipe
            isClick = true; // Assume it's a click until proven otherwise
            MainMenuCon2.style.transition = "none"; // Disable smooth transition during swipe
        });
        MainMenuCon1A.addEventListener("touchmove", (e)=>{
            if (!isSwiping) return;
            isClick = false; // Not a click anymore since there's movement
            currentX = e.touches[0].clientX;
            const deltaX = startX - currentX;
            const deltaY = Math.abs(e.touches[0].clientY - startY);
            // Ensure the swipe is horizontal
            if (deltaY < 20 && deltaX > 0) {
                // Swipe must be horizontal and to the left
                const leftPosition = Math.min(0, -deltaX); // Calculate new position (clamp to 0%)
                MainMenuCon2.style.left = `${leftPosition}%`; // Move MainMenuCon2 as user swipes
            }
        });
        MainMenuCon1A.addEventListener("touchend", ()=>{
            if (!isSwiping) return;
            const deltaX = startX - currentX;
            isSwiping = false;
            MainMenuCon2.style.transition = "left 0.3s ease"; // Re-enable smooth transition
            // If it was a click, do nothing
            if (isClick) return;
            // Check swipe length and finalize position
            if (deltaX > 100) {
                MainMenuCon2.style.left = "0%"; // Keep MainMenuCon2 hidden
                setTimeout(()=>{
                    MainMenuCon1A.remove();
                }, 1); // Adjust time if needed
                (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("last");
            } else MainMenuCon2.style.left = "0%"; // Reset to the initial position
        });
        if (this.#accountState) {
            if (this.#accountState.profileImageUrl) {
                const ProfileFotoInMenuTop = document.getElementById("ProfileFotoInMenuTop");
                const displayProfileImg = async ()=>{
                    let imageUrl = this.#accountState?.profileImages?.[0]?.res_200 || accountdata?.profileImage || '';
                    // const profileImgUrl = await firebase._getImageUrl(
                    //   this.#accountState.profileImageUrl
                    // );
                    ProfileFotoInMenuTop.src = imageUrl;
                };
                displayProfileImg();
            }
        }
        this._eventsMenu();
    }
    _close() {
        const MainMenuCon1A = document.querySelector(".MainMenuCon1A");
        MainMenuCon1A.remove();
        (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("last");
    }
    _eventsMenu() {
        const PreInstallConInMenu = document.getElementById("PreInstallConInMenu");
        const MainMenuCon3OpenProfile = document.getElementById("MainMenuCon3OpenProfile");
        (0, $a082c89adac62edb$export$2e2bcd8739ae039)._animateCTA("MainMenuCon3OpenProfile");
        const isInstalled = (0, $a7738523b33a53ea$export$2e2bcd8739ae039)._getNeedsInstalation();
        if (isInstalled) {
            PreInstallConInMenu.classList.add("PrePageConForInstallationConDisplayB");
            const ButtonInstallAppInMenu = document.getElementById("ButtonInstallAppInMenu");
            ButtonInstallAppInMenu.addEventListener("click", ()=>{
                this._close();
                (0, $a7738523b33a53ea$export$2e2bcd8739ae039)._installNow();
            });
        } else PreInstallConInMenu.classList.remove("PrePageConForInstallationConDisplayB");
        const openButtonFromMenuAll = document.querySelectorAll(".openButtonFromMenu");
        openButtonFromMenuAll.forEach((button)=>{
            button.addEventListener("click", (e)=>{
                console.log(button);
                const dataOpen = e.target.closest(".openButtonFromMenu").dataset.open;
                console.log(dataOpen);
                if (dataOpen === "report-an-error") {
                    this._close();
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._reportAProblem(null, "Describe que error tienes con esta aplicaci\xf3n, para que podamos trabajar en mejorarlo.");
                    return;
                }
                if (dataOpen === "ownlistings") {
                    (0, $d9ba51cb0b7d0ef7$export$2e2bcd8739ae039)._open();
                    return;
                }
                if (dataOpen === "wallet") {
                    this._close();
                    (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("Wallet");
                    return;
                }
                if (dataOpen === "home") {
                    (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._init();
                    this._close();
                    (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("Home");
                    return;
                }
                if (dataOpen === "business") {
                    (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init();
                    this._close();
                    (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("Activity");
                    return;
                }
                if (dataOpen === "saved") {
                    (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._open();
                    this._close();
                    (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("Saved");
                    return;
                }
                if (dataOpen === "notifications") {
                    this._close();
                    (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
                    (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("Notification");
                    return;
                }
                if (dataOpen === "about") {
                    // about._open();
                    (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink('https://mercadomaiabout.netlify.app');
                    // this._close();
                    return;
                }
                if (dataOpen === "help") {
                    // help._open();
                    (0, $490f6a1b66767e47$export$2e2bcd8739ae039)._open();
                    // this._close();
                    return;
                }
                if (dataOpen === "moreapps") {
                    // moreApps._open();
                    alert("Proximamente. Esta funci\xf3n a\xfan no est\xe1 lista.");
                    // this._close();
                    return;
                }
                if (dataOpen === "termsofuse") {
                    (0, $89e0c71703350fdb$export$2e2bcd8739ae039)._open();
                    return;
                }
            });
        });
        // const MainMenuCon6OpenListings = document.getElementById(
        //   "MainMenuCon6OpenListings"
        // );
        const ButtonCloseMenu = document.getElementById("ButtonCloseMenu");
        MainMenuCon3OpenProfile.addEventListener("click", (e)=>{
            if (e.target.closest("#ProfileFotoInMenuTop")) return;
            // ManageAccountAndProfileChanges._open();
            (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open();
        });
        // MainMenuCon6OpenListings.addEventListener("click", (e) => {
        //   if (e.target.closest("#ProfileFotoInMenuTop")) return;
        //   yourListings._open();
        // });
        ButtonCloseMenu.addEventListener("click", ()=>{
            this._close();
        });
        const MainMenuCon1 = document.getElementById("MainMenuCon1");
        MainMenuCon1.addEventListener("click", (e)=>{
            const isInside = e.target.closest('.MainMenuCon2B');
            if (isInside) return;
            this._close();
        });
    }
}
var $5328a9c179d47403$export$2e2bcd8739ae039 = new $5328a9c179d47403$var$Menu();


const $d9ba51cb0b7d0ef7$var$yourListingsMainCon = document.getElementById("yourListingsMainCon");
const $d9ba51cb0b7d0ef7$var$yourListingsMainCon4 = document.querySelector(".yourListingsMainCon4");
const $d9ba51cb0b7d0ef7$var$YourListingsMainButtonNewListing = document.getElementById("YourListingsMainButtonNewListing");
const $d9ba51cb0b7d0ef7$var$YourListingsMainButtonOpenBusiness = document.getElementById("YourListingsMainButtonOpenBusiness");
const $d9ba51cb0b7d0ef7$var$yourListingsMainConButtonBack = document.getElementById("yourListingsMainConButtonBack");
const $d9ba51cb0b7d0ef7$var$yourListingsAllListingsCon = document.getElementById("yourListingsAllListingsCon");
const $d9ba51cb0b7d0ef7$var$yourListingsAtentionRequieredListingsCon = document.getElementById("yourListingsAtentionRequieredListingsCon");
class $d9ba51cb0b7d0ef7$var$yourListings {
    #listings = [];
    constructor(){
        this._events();
    }
    _getLocalListings() {
        return this.#listings;
    }
    async _open() {
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando tus listados");
        $d9ba51cb0b7d0ef7$var$yourListingsMainCon.style.display = "flex";
        console.log("opining now");
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (!account) {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            return;
        }
        if (!account.listings) {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            return;
        }
        const listingsIdsArray = account.listings.slice().reverse();
        // const listings = [];
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        $d9ba51cb0b7d0ef7$var$yourListingsAllListingsCon.innerHTML = "";
        $d9ba51cb0b7d0ef7$var$yourListingsAtentionRequieredListingsCon.innerHTML = "";
        const atentionNeededParrentCon = $d9ba51cb0b7d0ef7$var$yourListingsAtentionRequieredListingsCon.closest(".ListingPackDisplayCon1");
        this.#listings = [];
        for (const id of listingsIdsArray){
            const listing = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`listings/${id}`);
            if (listing) {
                this.#listings.push(listing);
                let listingHtml;
                if (listing.status === "waitingPayment") listingHtml = await (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._listing(listing, "waitingPayment");
                else listingHtml = await (0, $95daa10db0d540ef$export$2e2bcd8739ae039)._listing(listing);
                $d9ba51cb0b7d0ef7$var$yourListingsAllListingsCon.insertAdjacentHTML("beforeend", listingHtml);
                //   Check for atention needed
                if (listing.status === "waitingPayment") {
                    atentionNeededParrentCon.style.display = "";
                    $d9ba51cb0b7d0ef7$var$yourListingsMainCon4.style.display = "";
                    $d9ba51cb0b7d0ef7$var$yourListingsMainCon4.textContent = "Pagar todos";
                    $d9ba51cb0b7d0ef7$var$yourListingsMainCon4.dataset.action = "payall";
                    $d9ba51cb0b7d0ef7$var$yourListingsMainCon4.classList.add("yourListingsMainCon4Action");
                    $d9ba51cb0b7d0ef7$var$yourListingsAtentionRequieredListingsCon.insertAdjacentHTML("beforeend", listingHtml);
                }
            }
        }
        if (this.#listings.length < 1) {
            let listingHtml = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings(true);
            $d9ba51cb0b7d0ef7$var$yourListingsAllListingsCon.innerHTML = "";
            $d9ba51cb0b7d0ef7$var$yourListingsAllListingsCon.insertAdjacentHTML("beforeend", listingHtml);
        }
        console.log(this.#listings);
    }
    _close() {
        $d9ba51cb0b7d0ef7$var$yourListingsMainCon.style.display = "none";
    }
    _events() {
        $d9ba51cb0b7d0ef7$var$YourListingsMainButtonNewListing.addEventListener("click", ()=>{
            (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
        });
        $d9ba51cb0b7d0ef7$var$YourListingsMainButtonOpenBusiness.addEventListener("click", ()=>{
            (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init();
            this._close();
            (0, $5328a9c179d47403$export$2e2bcd8739ae039)._close();
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav("Business");
        });
        $d9ba51cb0b7d0ef7$var$yourListingsMainConButtonBack.addEventListener("click", this._close.bind(this));
        $d9ba51cb0b7d0ef7$var$yourListingsMainCon.addEventListener("click", (e)=>{
            const targetOfClicked = e.target;
            if (targetOfClicked.closest(".yourListingsMainActionButton")) {
                if (targetOfClicked.dataset.action === "payall") {
                    const data = [];
                    this.#listings.forEach((listing)=>{
                        if (listing.status !== "waitingPayment") return;
                        let listingImgUrl = "";
                        const children = $d9ba51cb0b7d0ef7$var$yourListingsAtentionRequieredListingsCon.children;
                        // Iterate over each child element
                        Array.from(children).forEach((child)=>{
                            if (child.dataset.id === listing.listingId) // Use dataset.imgid to access the data-imgid attribute
                            listingImgUrl = child.dataset.imgid;
                        });
                        // Push the gathered data to the data array
                        data.push({
                            id: listing.listingId,
                            imgId: listingImgUrl,
                            name: listing.listingName,
                            type: "listado"
                        });
                    });
                }
            }
            if (targetOfClicked.closest("#OwnBusinessListingButtonActionPayNow")) {
                const listing = targetOfClicked.closest(".ActionOpenForDisplay");
                if (!listing) return;
                const data = [
                    {
                        id: listing.dataset.id,
                        imgId: listing.dataset.imgid,
                        name: listing.dataset.name,
                        type: "listado"
                    }
                ];
            }
        });
    }
}
var $d9ba51cb0b7d0ef7$export$2e2bcd8739ae039 = new $d9ba51cb0b7d0ef7$var$yourListings();




const $4b8d317367ae1d6a$var$PopOverActionsMenuCon1 = document.getElementById("PopOverActionsMenuCon1");
class $4b8d317367ae1d6a$var$ownListings {
    #listingId;
    #e;
    #businessId;
    constructor(){
        // this._events();
        this._initEditOptionsDrag();
        this._editOptionsEvents();
    }
    _openPopOver(option, businessId, listingId, e, deleteOnly) {
        this.#listingId = listingId;
        this.#businessId = businessId;
        this._handelEditOptinsShow(true, deleteOnly);
    }
    // _closePopOver() {
    // }
    // call this to show/hide the sheet
    _handelEditOptinsShow(open, deleteOnly = false) {
        const NVEditOptionsEditListing = document.getElementById('NVEditOptionsEditListing');
        const NVEditOptions = document.getElementById('NVEditOptionsListing');
        if (!NVEditOptions) return;
        if (NVEditOptionsEditListing) {
            if (deleteOnly) NVEditOptionsEditListing.style.display = 'none';
            else NVEditOptionsEditListing.style.display = 'flex';
        }
        const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
        if (!sheet) return;
        // Ensure transition style is set once
        sheet.style.transition = 'transform 0.35s ease, opacity 0.35s ease';
        if (open) {
            // Make container visible first
            NVEditOptions.style.display = 'flex';
            NVEditOptions.style.pointerEvents = 'auto';
            sheet.style.pointerEvents = 'auto';
            // Start from off-screen
            sheet.style.transform = 'translateY(100%)';
            sheet.style.opacity = '0';
            // Animate in on the next frame
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    sheet.style.transform = 'translateY(0)';
                    sheet.style.opacity = '1';
                });
            });
        } else {
            // Animate out
            sheet.style.transform = 'translateY(100%)';
            sheet.style.opacity = '0';
            sheet.style.pointerEvents = 'none';
            NVEditOptions.style.pointerEvents = 'none';
            // After transition, hide completely
            const cleanup = ()=>{
                NVEditOptions.style.display = 'none';
                sheet.removeEventListener('transitionend', cleanup);
            };
            sheet.addEventListener('transitionend', cleanup);
            // Fallback timeout in case transitionend doesn’t fire
            setTimeout(cleanup, 350);
        }
    }
    _initEditOptionsDrag() {
        const NVEditOptions = document.getElementById('NVEditOptionsListing');
        if (!NVEditOptions) return;
        const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
        const handle = NVEditOptions.querySelector('#NVEditOptionsHideBarListing');
        if (!sheet || !handle) return;
        // Prevent duplicate listener setup
        if (this.__nvEditOptionsDragInit) return;
        this.__nvEditOptionsDragInit = true;
        let startY = 0;
        let currentY = 0;
        let lastY = 0;
        let lastTime = 0;
        let dragging = false;
        let velocity = 0;
        const originalTransition = getComputedStyle(sheet).transition || 'transform 0.35s ease, opacity 0.35s ease';
        const startDrag = (e)=>{
            if (NVEditOptions.style.display === 'none' || NVEditOptions.style.display === '') return;
            dragging = true;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            startY = clientY;
            currentY = clientY;
            lastY = clientY;
            lastTime = performance.now();
            sheet.style.transition = 'none';
            sheet.style.willChange = 'transform, opacity';
        };
        const onDrag = (e)=>{
            if (!dragging) return;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            const diff = Math.max(0, clientY - startY);
            currentY = clientY;
            // velocity calculation
            const now = performance.now();
            const deltaTime = now - lastTime;
            velocity = (clientY - lastY) / deltaTime;
            lastY = clientY;
            lastTime = now;
            sheet.style.transform = `translateY(${diff}px)`;
            sheet.style.opacity = `${Math.max(0.3, 1 - diff / 300)}`;
        };
        const endDrag = ()=>{
            if (!dragging) return;
            dragging = false;
            sheet.style.transition = originalTransition;
            sheet.style.willChange = '';
            const diff = currentY - startY;
            const dismissThreshold = 120;
            const velocityThreshold = 0.6;
            if (diff > dismissThreshold || velocity > velocityThreshold) {
                // dismiss
                sheet.style.transform = 'translateY(100%)';
                sheet.style.opacity = '0';
                this._handelEditOptinsShow(false);
            } else {
                // snap back
                sheet.style.transform = 'translateY(0)';
                sheet.style.opacity = '1';
            }
        };
        // === Event Listeners ===
        const dragTargets = [
            sheet,
            handle,
            NVEditOptions
        ];
        dragTargets.forEach((el)=>{
            el.addEventListener('touchstart', startDrag, {
                passive: true
            });
            el.addEventListener('mousedown', (ev)=>{
                ev.preventDefault();
                startDrag(ev);
            });
        });
        window.addEventListener('touchmove', onDrag, {
            passive: true
        });
        window.addEventListener('mousemove', onDrag);
        window.addEventListener('touchend', endDrag);
        window.addEventListener('mouseup', endDrag);
        // Close when tapping backdrop (outside sheet)
        NVEditOptions.addEventListener('click', (ev)=>{
            // Only close if clicked outside the sheet
            if (ev.target === NVEditOptions) this._handelEditOptinsShow(false);
        });
    }
    // _shareListing() {
    //   console.log(this.#e.target);
    //   let openTo = "listing";
    //   if (this.#businessId && this.#businessId !== "undefined") {
    //     openTo = "listingInBusiness";
    //   }
    //   allHandeling._displayTheRightWay(
    //     this.#businessId,
    //     this.#listingId,
    //     openTo,
    //     null,
    //     true
    //   );
    //   this._closePopOver();
    //   yourListings._close();
    // }
    // _boostListing() {
    //   alert("Proximamente. Esta funcion aún no está lista.");
    // }
    async _editCurrentListing() {
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        console.log("here");
        let path = `accounts/${account.userId}/listings/${this.#listingId}`;
        // let path = `listings/${this.#listingId}`;
        console.log(path);
        console.log(this.#businessId, this.#listingId);
        if (this.#businessId && this.#businessId !== "undefined") path = `businesses/${this.#businessId}/listings/${this.#listingId}`;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando listado...");
        console.log(path);
        const data = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(path);
        console.log(data);
        if (!data || data.length < 1) {
            alert("Hubo un error. Intenta de nuevo mas tarde.");
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            return;
        }
        (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init(data);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        this._handelEditOptinsShow(false);
    }
    async _deleteCurrentListing() {
        try {
            const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            let lives = 'seller';
            let parentId = account.userId;
            let listingId = this.#listingId;
            if (this.#businessId && this.#businessId !== "undefined") {
                lives = 'business';
                parentId = this.#businessId;
            }
            const confirmDelete = confirm("\xbfEstas seguro que quieres eliminar este listado?");
            if (!confirmDelete) return;
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Eliminando listado...");
            const deleteResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVDeleteListing({
                lives: lives,
                parentId: parentId,
                listingId: listingId
            });
            if (deleteResult.data.status === "success") {
                alert("Listado eliminado con \xe9xito.");
                (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._actionsOnListingInEditElement('remove');
            // DisplayBusinessOwn._init();
            }
            if (deleteResult.data.status === "error") alert(`Ocurio un error: ${deleteResult.data.message}`);
        } catch (error) {} finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            this._handelEditOptinsShow(false);
        }
    }
    _editOptionsEvents() {
        const NVEditOptionsEdit = document.getElementById('NVEditOptionsEditListing');
        const NVEditOptionsDelete = document.getElementById('NVEditOptionsDeleteListing');
        const NVEditOptionsHideBarListing = document.getElementById('NVEditOptionsHideBarListing');
        NVEditOptionsEdit.addEventListener('click', ()=>{
            this._editCurrentListing();
        });
        NVEditOptionsDelete.addEventListener('click', ()=>{
            this._deleteCurrentListing();
        });
        NVEditOptionsHideBarListing.addEventListener('click', ()=>{
            this._handelEditOptinsShow(false);
        });
    }
}
var $4b8d317367ae1d6a$export$2e2bcd8739ae039 = new $4b8d317367ae1d6a$var$ownListings();


const $45b62c8178516fd3$var$deleteAccountDeleteAllWindowButtonDeleteAccount = document.getElementById("deleteAccountDeleteAllWindowButtonDeleteAccount");
const $45b62c8178516fd3$var$deleteAccountDeleteAllWindowButtonDeleteAll = document.getElementById("deleteAccountDeleteAllWindowButtonDeleteAll");
const $45b62c8178516fd3$var$deleteAccountDeleteAllItemsCon = document.getElementById("deleteAccountDeleteAllItemsCon");
const $45b62c8178516fd3$var$deleteAccountDeleteAllWindow = document.getElementById("deleteAccountDeleteAllWindow");
const $45b62c8178516fd3$var$deleteAccountDeleteAllWindowButtonClose = document.getElementById("deleteAccountDeleteAllWindowButtonClose");
const $45b62c8178516fd3$var$SingUpWindow = document.getElementById("SingUpWindow");
const $45b62c8178516fd3$var$SingUpWindowButtonClose = document.getElementById("SingUpWindowButtonClose");
const $45b62c8178516fd3$var$SingUpWindowButtonSelectSignUp = document.getElementById("SingUpWindowButtonSelectSignUp");
const $45b62c8178516fd3$var$createAccountTermsPrivacyPolicyTextForLink = document.getElementById("createAccountTermsPrivacyPolicyTextForLink");
const $45b62c8178516fd3$var$SingUpWindowButtonSelectSignIn = document.getElementById("SingUpWindowButtonSelectSignIn");
const $45b62c8178516fd3$var$SingUpInputEmail = document.getElementById("SingUpInputEmail");
const $45b62c8178516fd3$var$SingUpInputPassword = document.getElementById("SingUpInputPassword");
const $45b62c8178516fd3$var$SingUpInputPasswordConfirm = document.getElementById("SingUpInputPasswordConfirm");
const $45b62c8178516fd3$var$SingInInputEmail = document.getElementById("SingInInputEmail");
const $45b62c8178516fd3$var$SingInInputPassword = document.getElementById("SingInInputPassword");
const $45b62c8178516fd3$var$SignUpWindowPartSignUp = document.getElementById("SignUpWindowPartSignUp");
const $45b62c8178516fd3$var$SignUpWindowPartConfirmEmail = document.getElementById("SignUpWindowPartConfirmEmail");
const $45b62c8178516fd3$var$SignUpWindowPartSingIn = document.getElementById("SignUpWindowPartSingIn");
const $45b62c8178516fd3$var$SignUpWindowPartParrentSignUpSignIn = document.getElementById("SignUpWindowPartParrentSignUpSignIn");
const $45b62c8178516fd3$var$SignUpWindowPartParrentProfileAccount = document.getElementById("SignUpWindowPartParrentProfileAccount");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountEmailVerifyAlert = document.getElementById("SignUpWindowProfileAccountEmailVerifyAlert");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountEmailVerifyAlertButtonVerify = document.getElementById("SignUpWindowProfileAccountEmailVerifyAlertButtonVerify");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountAccount = document.getElementById("SignUpWindowProfileAccountAccount");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountProfileAlert = document.getElementById("SignUpWindowProfileAccountProfileAlert");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountProfile = document.getElementById("SignUpWindowProfileAccountProfile");
const $45b62c8178516fd3$var$SignUpWindowButtonSignUp = document.getElementById("SignUpWindowButtonSignUp");
const $45b62c8178516fd3$var$SignUpWindowButtonConfirmEmailConfirmEmail = document.getElementById("SignUpWindowButtonConfirmEmailConfirmEmail");
const $45b62c8178516fd3$var$SignUpWindowButtonConfirmEmailResendCode = document.getElementById("SignUpWindowButtonConfirmEmailResendCode");
const $45b62c8178516fd3$var$SignUpWindowButtonConfirmEmailChangeEmail = document.getElementById("SignUpWindowButtonConfirmEmailChangeEmail");
const $45b62c8178516fd3$var$SignUpWindowButtonSignIn = document.getElementById("SignUpWindowButtonSignIn");
const $45b62c8178516fd3$var$SignUpWindowButtonForgotPassword = document.getElementById("SignUpWindowButtonForgotPassword");
const $45b62c8178516fd3$var$SignUpWindowButtonChangePassword = document.getElementById("SignUpWindowButtonChangePassword");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountButtonSignOut = document.getElementById("SignUpWindowProfileAccountButtonSignOut");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountButtonDeleteAccount = document.getElementById("SignUpWindowProfileAccountButtonDeleteAccount");
const $45b62c8178516fd3$var$SignUpWindowProfileAccountDisplayEmail = document.getElementById("SignUpWindowProfileAccountDisplayEmail");
const $45b62c8178516fd3$var$ProfileInputName = document.getElementById("ProfileInputName");
const $45b62c8178516fd3$var$ProfileInputWhatsAppNumber = document.getElementById("ProfileInputWhatsAppNumber");
const $45b62c8178516fd3$var$ProfileSelectWhatsAppNumberContryCode = document.getElementById("ProfileSelectWhatsAppNumberContryCode");
const $45b62c8178516fd3$var$ProfileInputMobileNumber = document.getElementById("ProfileInputMobileNumber");
const $45b62c8178516fd3$var$ProfileSelectCallNumberContryCode = document.getElementById("ProfileSelectCallNumberContryCode");
const $45b62c8178516fd3$var$ProfileImgContainer = document.getElementById("ProfileImgContainer");
const $45b62c8178516fd3$var$ProfileButtonSaveProfile = document.getElementById("ProfileButtonSaveProfile");
class $45b62c8178516fd3$var$signUpProfile {
    #changedProfileImg = false;
    #changesToBeSaved = false;
    #sellerProfile = {
        userName: "",
        callNumber: "",
        whatsAppNumber: "",
        profileImageUrl: "",
        sellerProfileStatus: "active",
        sellerProfileTokens: []
    };
    #loadedBusinessesForDeletion = [];
    #loadedListingsForDeletion = [];
    #openEmailVerificationEventInitialized = false;
    #emailVerificationResendInterval = null;
    #profileImageChanged = false;
    constructor(){
        console.log("signUpProfile module loaded");
        this._events();
        this._togglePassword('SingUpInputPassword');
        this._togglePassword('SingUpInputPasswordConfirm');
        this._togglePassword('SingInInputPassword');
    // this._displaySignUpWindow("profileAccount");
    // this._displaySignUpWindow("completeProfile");
    // this._displaySignUpWindow("signUp");
    }
    async _saveSellerProfile(close) {
        let valid = true;
        const name = $45b62c8178516fd3$var$ProfileInputName.value.trim();
        const whatsAppNumber = $45b62c8178516fd3$var$ProfileInputWhatsAppNumber.value.trim();
        const whatsAppNumberCountryCode = $45b62c8178516fd3$var$ProfileSelectWhatsAppNumberContryCode.value;
        const callNumber = $45b62c8178516fd3$var$ProfileInputMobileNumber.value.trim();
        const callNumberCountryCode = $45b62c8178516fd3$var$ProfileSelectCallNumberContryCode.value;
        try {
            if (name?.length < 2) throw new Error("El nombre no es un nombre v\xe1lido. Tiene que tener por lo menos 3 car\xe1teres.");
            if (callNumber?.length < 2) throw new Error("El n\xfamero de Llamandas no es un n\xfamero v\xe1lido.");
            if (whatsAppNumber?.length < 2) throw new Error("El n\xfamero de WhatsApp no es un n\xfamero v\xe1lido.");
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Subiendo imagen de perfil");
            const imgs = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImagesAndGetReferences("ProfileImgContainerA", 'imageProgressCon', null, 'public/tempUploads/');
            const accountData = {
                userName: name,
                whatsAppNumber: whatsAppNumber,
                whatsAppNumberCountryCode: whatsAppNumberCountryCode,
                callNumber: callNumber,
                callNumberCountryCode: callNumberCountryCode,
                profileImages: imgs,
                about: 'Vendedor en Mercado MAI',
                profileImageChanged: this.#profileImageChanged
            };
            console.log(accountData);
            // spinner._hideSpinner()
            // return
            // const profileImgUrl = await firebase._uploadImagesByUrls(
            //     [ProfileImgContainer.src]
            // );
            // accountData.profileImageUrl = profileImgUrl[0];
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Subiendo perfil de vendedor");
            accountData.sellerProfileTokens = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._generateTokens([
                name,
                whatsAppNumber,
                callNumber
            ], [
                "&",
                "de",
                "y",
                "para"
            ]);
            const updateProfileResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateUserTemplate(accountData);
            console.log(updateProfileResult);
            if (updateProfileResult.data.status === "error") throw new Error(`Hubo un error en actualizar tu perfil de vendedor. ${updateProfileResult.data.message}`);
            if (updateProfileResult.data.status === "success") {
                ProfileOpenSellerProfileSaveButton.style.display = "none";
                ProfileOpenSellerProfileSaveButton.classList.remove("ProfileOpenSellerProfileSaveButtonNoneAct");
                this.#changesToBeSaved = false;
                if (close) this._close();
                alert("\xc9xito. \xa1Perfil de vendedor actualizado correctamente!");
            }
        } catch (error) {
            alert(error.message);
            console.error(error);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    _checkIfReady = (what)=>{
        this.#changesToBeSaved = true;
        let allValid = true; // Tracks overall validity
        const checkImg = ()=>{
            const messageCon = profileImage.closest(".ProfileOpenFotoCon").querySelector(".ProfileOpenInputMessage");
            // Check if the profile image is the placeholder or empty
            if (profileImage.src.includes("profile-img-placeholder") || profileImage.src === "") {
                console.warn("this was true somehow");
                console.log(profileImage.src.includes("profile-img-placeholder"));
                console.log(profileImage.src);
                messageCon.classList.add("ProfileOpenInputMessageError");
                messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Una foto de perfil es requerida"; // Grammar correction
                return false;
            } else {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = ""; // Provide positive feedback
                return true;
            }
        };
        const checkName = ()=>{
            const messageCon = ProfileOpenInputSellerName.closest(".ProfileOpenInputCon2").querySelector(".ProfileOpenInputMessage");
            if (!this.#sellerProfile.userName || this.#sellerProfile.userName.length < 3) {
                if (what === "name") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.userName ? "El nombre de vendedor es requerido" : "El nombre de vendedor no puede ser menor a 3 car\xe1cteres";
                }
                return false;
            }
            if (what === "name") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "Nombre v\xe1lido";
            }
            return true;
        };
        const checkCallNumber = ()=>{
            const messageCon = ProfileOpenInputPhoneNumber.closest(".ProfileOpenInputCon2").querySelector(".ProfileOpenInputMessage");
            if (!this.#sellerProfile.callNumber || this.#sellerProfile.callNumber.length !== 10) {
                if (what === "callNumber") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.callNumber ? "N\xfamero de llamadas es requerido" : "N\xfamero de llamadas no v\xe1lido";
                }
                return false;
            }
            if (what === "callNumber") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "N\xfamero v\xe1lido";
            }
            return true;
        };
        const checkWhatsAppNumber = ()=>{
            const messageCon = ProfileOpenInputWhatsAppNumber.closest(".ProfileOpenInputCon2").querySelector(".ProfileOpenInputMessage");
            if (!this.#sellerProfile.whatsAppNumber || this.#sellerProfile.whatsAppNumber.length !== 10) {
                if (what === "whatsAppNumber") {
                    messageCon.classList.add("ProfileOpenInputMessageError");
                    messageCon.classList.remove("ProfileOpenInputMessageSuccess");
                    messageCon.textContent = !this.#sellerProfile.whatsAppNumber ? "N\xfamero de WhatsApp es requerido" : "N\xfamero de WhatsApp no v\xe1lido";
                }
                return false;
            }
            if (what === "whatsAppNumber") {
                messageCon.classList.remove("ProfileOpenInputMessageError");
                messageCon.classList.add("ProfileOpenInputMessageSuccess");
                messageCon.textContent = "N\xfamero v\xe1lido";
            }
            return true;
        };
        // Perform all checks and track validity
        allValid = checkImg() && allValid;
        allValid = checkName() && allValid;
        allValid = checkCallNumber() && allValid;
        allValid = checkWhatsAppNumber() && allValid;
        // Toggle save button based on overall validity
        if (allValid) {
            ProfileOpenSellerProfileSaveButton.classList.remove("ProfileOpenSellerProfileSaveButtonNoneAct");
            return allValid;
        } else {
            ProfileOpenSellerProfileSaveButton.classList.add("ProfileOpenSellerProfileSaveButtonNoneAct");
            return allValid;
        }
    };
    _open(completeProfile) {
        try {
            const decide = ()=>{
                const accountdata = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
                console.log(accountdata);
                if (!accountdata) {
                    this._displaySignUpWindow("signUp");
                    this._select('signIn');
                    return;
                }
                if (!accountdata.userName && completeProfile) this._displaySignUpWindow("completeProfile");
                else this._displaySignUpWindow("profileAccount");
                if (accountdata.userName) this._displaySignUpWindow("profileAccount");
            };
            decide();
            $45b62c8178516fd3$var$SingUpWindow.style.display = "flex";
        } catch (error) {}
    }
    _close() {
        $45b62c8178516fd3$var$SingUpWindow.style.display = "none";
    }
    async _deleteAllNow() {
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Procesando...', 10000);
            const itemsCon = document.getElementById('deleteAccountDeleteAllItemsCon');
            console.log(itemsCon);
            const confirmDelete = confirm("\xa1ADVERTENCIA!\n\xbfEst\xe1s seguro que quieres eliminar todas tus publicaciones? Esta acci\xf3n es irreversible.");
            if (!confirmDelete) {
                console.log('Canceled');
                return false;
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Eliminando...', 20000);
            await Promise.all([
                ...this.#loadedBusinessesForDeletion.map(async (bus)=>{
                    console.log(bus);
                    const delRes = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVDeleteBusiness({
                        businessId: bus.businessId
                    });
                    if (delRes.data.status === 'success') {
                        // if ('success' === 'success') {
                        const items = itemsCon.querySelectorAll('.v20BusinessCon1A');
                        items.forEach((el)=>{
                            console.log(el);
                            const lisId = el.dataset.listignid;
                            // console.log('li.listingId:', li.listingId, 'lisId:', lisId);
                            if (el.dataset.listingid === bus.listingId) {
                                console.log(el);
                                el?.closest('.v20BusinessCon1A')?.remove();
                            }
                        });
                    }
                // return delRes;
                }),
                ...this.#loadedListingsForDeletion.map(async (li)=>{
                    const delRes = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVDeleteListing({
                        lives: 'seller',
                        parentId: li.sellerId,
                        listingId: li.listingId
                    });
                    // This was `deleteResult`, but that variable does not exist.
                    if (delRes.data.status === 'success') {
                        // if ('success' === 'success') {
                        console.log(itemsCon);
                        console.log('here now');
                        const items = itemsCon.querySelectorAll('.nvListingVerCon1');
                        items.forEach((el)=>{
                            console.log(el);
                            const lisId = el.dataset.listignid;
                            console.log('li.listingId:', li.listingId, 'lisId:', lisId);
                            if (el.dataset.listingid === li.listingId) {
                                console.log(el);
                                el?.closest('.nvListingVerCon1A')?.remove();
                            }
                        });
                        console.log(items);
                    }
                    return delRes;
                })
            ]);
            return true;
        } catch (error) {
            console.error('Could not delete all items:', error);
            throw error; // lets the caller react to failure
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _deleteAccountNow() {
        try {
            const confirmDelete = confirm("\xa1ADVERTENCIA!\n \xbfEst\xe1s seguro que quieres eliminar tu cuenta? Esta acci\xf3n es ireversible.");
            if (confirmDelete) {
                console.log('Deleting account now.');
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Eliminando tu cuenta. Esto puede tardar un poco.', 20000);
                const { data: data } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._deleteAccount({
                    accountId: 'currentAccount'
                });
                console.log(data);
                if (data.success) window.location.reload();
                else alert(data.message);
            } else console.log('Canceled');
        } catch (error) {} finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _openDeleteAll() {
        console.log('here');
        let showDelete = false;
        try {
            const parent1 = document.getElementById('deleteAccountDeleteAllWindowButtonDeleteAccounParent');
            const parent2 = document.getElementById('deleteAccountDeleteAllWindowButtonDeleteAllParent');
            //
            parent1.style.display = 'none';
            parent2.style.display = 'none';
            this.#loadedBusinessesForDeletion = [];
            this.#loadedListingsForDeletion = [];
            $45b62c8178516fd3$var$deleteAccountDeleteAllItemsCon.innerHTML = '';
            console.log('here');
            $45b62c8178516fd3$var$deleteAccountDeleteAllWindow.style.display = "flex";
            console.log('here');
            const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            // await firebase._getUserDataFromBase(userData.userId)
            // const account = firebase._getLatestCurrentUserData()
            console.log(account);
            if (account?.businesses?.length > 0) {
                console.log('here');
                for (const bus of account.businesses){
                    console.log('here');
                    if (bus.role === 'owner') {
                        console.log('here');
                        console.log(`businesses/${bus.id}`);
                        const loadedBusiness = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${bus.id}`);
                        console.log(loadedBusiness);
                        if (!loadedBusiness) {
                            console.log('here');
                            alert(`Este negocio ya no existe.`);
                            continue; // 👈 skip this business and move on
                        }
                        console.log('here');
                        this.#loadedBusinessesForDeletion.push(loadedBusiness);
                        console.log('here');
                        const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(null, 3, `businesses/${bus.id}/listings`);
                        console.log('here');
                        let listingsHtml = ``;
                        console.log('here');
                        if (!listings || listings.length === 0) {
                            console.log('here');
                            listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings();
                        } else {
                            console.log('here');
                            for (const listing of listings){
                                console.log('here');
                                listingsHtml += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMini(listing, null, "listingInBusiness", bus.id);
                                console.log('listingsHtml', listingsHtml);
                            }
                            console.log('here');
                        }
                        console.log('here');
                        const businessInPackHtml = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._generateBusiness2v(listingsHtml, loadedBusiness, null, null, true, false);
                        console.log('here');
                        $45b62c8178516fd3$var$deleteAccountDeleteAllItemsCon.insertAdjacentHTML("beforeend", businessInPackHtml);
                        console.log('here');
                        showDelete = true;
                        console.log('here');
                    }
                }
            }
            const loadedListings = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAllDocsFromPathByMostRecent(`accounts/${account.userId}/listings`, true);
            console.log(loadedListings);
            if (!loadedListings) throw new Error("No hemos podido cargar tus listados en este momento. Intenta de nuevo mas tarde.");
            this.#loadedListingsForDeletion = loadedListings;
            if (loadedListings.length > 0) loadedListings.forEach((listing)=>{
                const listingHtml = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing, true, 'listing', false, true);
                $45b62c8178516fd3$var$deleteAccountDeleteAllItemsCon.insertAdjacentHTML("beforeend", listingHtml);
                showDelete = true;
            });
            console.log(account);
            console.log(showDelete);
            if (!showDelete) {
                parent2.style.display = 'none';
                parent1.style.display = 'flex';
            } else {
                parent2.style.display = 'flex';
                parent1.style.display = 'none';
            }
        } catch (error) {}
    }
    _closeDeleteAll() {
        $45b62c8178516fd3$var$deleteAccountDeleteAllWindow.style.display = "none";
    }
    async _signOut() {
        const confirmLogOut = confirm(`\xbfEst\xe1s seguro que quieres cerar sesi\xf3n con esta cuenta?
                Tus datos no se borar\xe1n.
                Los podras acceder al iniciar sesi\xf3n con esta cuenta otra vez.`);
        console.log(confirmLogOut);
        if (!confirmLogOut) return;
        await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._signOutUser();
    }
    async _signUp() {
        console.log("process");
        try {
            const signUpData = {
                email: $45b62c8178516fd3$var$SingUpInputEmail.value.trim().toLowerCase(),
                password: $45b62c8178516fd3$var$SingUpInputPassword.value.trim(),
                passwordConfirm: $45b62c8178516fd3$var$SingUpInputPasswordConfirm.value.trim()
            };
            const termsCheckbox = document.getElementById("createAccountTermsPrivacyPolicyCheckbox");
            // Check for empty fields
            if (!signUpData.email || !signUpData.password || !signUpData.passwordConfirm) throw new Error("Por favor, completa todos los campos.");
            // Check if email format is valid
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(signUpData.email)) throw new Error("Por favor, ingresa un correo v\xe1lido.");
            // Check password strength
            // Minimum 6 characters, at least one letter and one number
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;
            if (!passwordRegex.test(signUpData.password)) throw new Error("La contrase\xf1a debe tener al menos 6 caracteres y contener una letra y un n\xfamero.");
            // Check if passwords match
            if (signUpData.password !== signUpData.passwordConfirm) throw new Error("Las contrase\xf1as no coinciden.");
            // Check terms checkbox
            if (!termsCheckbox.checked) throw new Error("Debes aceptar los t\xe9rminos y la pol\xedtica de privacidad.");
            // Continue signup process...
            console.log(signUpData);
            const signUpResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._authenticateNewUser(signUpData.email, signUpData.password);
            if (signUpResult.success) {
                this._close();
                this._openEmailVerification(null, true);
            } else {
                console.error(signUpResult);
                switch(signUpResult.errorCode){
                    case "auth/email-already-in-use":
                        alert("Ya existe una cuenta con este correo electr\xf3nico. Por favor inicia sesi\xf3n.");
                        break;
                    case "auth/invalid-email":
                        alert("El correo electr\xf3nico no es v\xe1lido.");
                        break;
                    case "auth/weak-password":
                        alert("La contrase\xf1a es demasiado d\xe9bil.");
                        break;
                    case "auth/network-request-failed":
                        alert("Error de conexi\xf3n. Verifica tu internet e int\xe9ntalo nuevamente.");
                        break;
                    case "auth/too-many-requests":
                        alert("Demasiados intentos. Int\xe9ntalo nuevamente m\xe1s tarde.");
                        break;
                    default:
                        alert("Ocurri\xf3 un error al crear la cuenta. Int\xe9ntalo nuevamente.");
                        break;
                }
            }
        } catch (error) {
            console.error(error);
            alert(error.message);
        }
    }
    async _signIn() {
        console.log("process");
        // this._addInputFocusListenersToRemoveMessage();
        // Check for empty fields
        if (!$45b62c8178516fd3$var$SingInInputEmail.value.trim() || !$45b62c8178516fd3$var$SingInInputPassword.value.trim()) {
            alert("Por favor, completa todos los campos.");
            return;
        }
        const logInData = {
            email: $45b62c8178516fd3$var$SingInInputEmail.value.trim(),
            password: $45b62c8178516fd3$var$SingInInputPassword.value.trim()
        };
        try {
            const singInResult = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._signInUser(logInData.email, logInData.password);
            this._close();
        // this._displayAccountInDone("Has iniciado sesión con éxito");
        } catch (error) {
            if (error.message.includes("auth/invalid-credential")) alert("No podimos encontrar tu cuenta. Asegurate que los dato son los datos corectos. O si a\xfan no tienes una cuenta en Mercado MAI, crea una primero.");
        }
    }
    async _displaySignUpWindow(optionIn) {
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._checkEmailVerificationStatus();
        console.log(result);
        console.log(result.verified);
        this.#profileImageChanged = false;
        if (!account?.emailVerified) {
            if (account?.emailVerifiedPendingFrom) $45b62c8178516fd3$var$SignUpWindowProfileAccountEmailVerifyAlert.style.display = "flex";
            else $45b62c8178516fd3$var$SignUpWindowProfileAccountEmailVerifyAlert.style.display = "flex";
        } else $45b62c8178516fd3$var$SignUpWindowProfileAccountEmailVerifyAlert.style.display = "none";
        console.log(optionIn);
        let option = optionIn;
        $45b62c8178516fd3$var$SignUpWindowPartSignUp.style.display = "none";
        $45b62c8178516fd3$var$SignUpWindowPartConfirmEmail.style.display = "none";
        $45b62c8178516fd3$var$SignUpWindowPartSingIn.style.display = "none";
        $45b62c8178516fd3$var$SignUpWindowProfileAccountAccount.style.display = "none";
        $45b62c8178516fd3$var$SignUpWindowProfileAccountProfileAlert.style.display = "none";
        $45b62c8178516fd3$var$SignUpWindowProfileAccountProfile.style.display = "none";
        $45b62c8178516fd3$var$SignUpWindowPartParrentSignUpSignIn.style.display = "none";
        $45b62c8178516fd3$var$SignUpWindowPartParrentProfileAccount.style.display = "none";
        const accountdata = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        console.log(accountdata);
        if (option === "signUp") {
            setTimeout(()=>{
                $45b62c8178516fd3$var$SingUpInputEmail.focus();
            }, 1000);
            $45b62c8178516fd3$var$SignUpWindowPartParrentSignUpSignIn.style.display = "flex";
            $45b62c8178516fd3$var$SignUpWindowPartSignUp.style.display = "flex";
        }
        if (option === "signIn") {
            setTimeout(()=>{
                $45b62c8178516fd3$var$SingInInputEmail.focus();
            }, 1000);
            $45b62c8178516fd3$var$SignUpWindowPartParrentSignUpSignIn.style.display = "flex";
            $45b62c8178516fd3$var$SignUpWindowPartSingIn.style.display = "flex";
        }
        if (option === "confirmEmail") {
            $45b62c8178516fd3$var$SignUpWindowPartParrentSignUpSignIn.style.display = "flex";
            $45b62c8178516fd3$var$SignUpWindowPartConfirmEmail.style.display = "flex";
        }
        if (option === "profileAccount") {
            let sellerStatus = true;
            let name = accountdata.userName;
            let whatsApp = accountdata.whatsAppNumber;
            let call = accountdata.callNumber;
            let imageUrl = accountdata?.profileImages?.[0]?.res_200 || accountdata?.profileImage || '';
            if (!name) {
                name = '';
                sellerStatus = false;
            }
            if (!whatsApp) {
                whatsApp = '';
                sellerStatus = false;
            }
            if (!call) {
                call = '';
                sellerStatus = false;
            }
            if (!imageUrl) {
                imageUrl = '';
                sellerStatus = false;
            }
            sellerStatus;
            $45b62c8178516fd3$var$SignUpWindowProfileAccountDisplayEmail.textContent = accountdata.email;
            $45b62c8178516fd3$var$ProfileInputName.value = name;
            $45b62c8178516fd3$var$ProfileInputWhatsAppNumber.value = whatsApp;
            $45b62c8178516fd3$var$ProfileInputMobileNumber.value = call;
            $45b62c8178516fd3$var$ProfileImgContainer.src = imageUrl;
            $45b62c8178516fd3$var$SignUpWindowPartParrentProfileAccount.style.display = "flex";
            $45b62c8178516fd3$var$SignUpWindowProfileAccountAccount.style.display = "flex";
            $45b62c8178516fd3$var$SignUpWindowProfileAccountProfile.style.display = "flex";
        }
        if (option === "completeProfile") {
            $45b62c8178516fd3$var$SignUpWindowProfileAccountDisplayEmail.textContent = accountdata.email;
            $45b62c8178516fd3$var$SignUpWindowPartParrentProfileAccount.style.display = "flex";
            $45b62c8178516fd3$var$SignUpWindowProfileAccountProfile.style.display = "flex";
            $45b62c8178516fd3$var$SignUpWindowProfileAccountProfileAlert.style.display = "flex";
        }
    }
    _select(option) {
        setTimeout(()=>{
            if (option === "signUp") {
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignUp.classList.add("nvSignUpOrSignInCon2ACT");
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignIn.classList.remove("nvSignUpOrSignInCon2ACT");
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignUp.children[0].classList.add("nvSignUpOrSignInText1ACT");
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignIn.children[0].classList.remove("nvSignUpOrSignInText1ACT");
                this._displaySignUpWindow("signUp");
            } else if (option === "signIn") {
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignIn.classList.add("nvSignUpOrSignInCon2ACT");
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignUp.classList.remove("nvSignUpOrSignInCon2ACT");
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignIn.children[0].classList.add("nvSignUpOrSignInText1ACT");
                $45b62c8178516fd3$var$SingUpWindowButtonSelectSignUp.children[0].classList.remove("nvSignUpOrSignInText1ACT");
                this._displaySignUpWindow("signIn");
            }
        }, 200);
    }
    _togglePassword(id) {
        const input = document.getElementById(id);
        if (!input) return;
        const inputParrent = input.parentElement;
        if (!inputParrent) return;
        const eyeIcon = inputParrent.querySelector(".passwordToggleButton");
        eyeIcon.addEventListener("click", ()=>{
            input.type = input.type === "password" ? "text" : "password";
        });
    }
    async _sendVerificationEmail() {
        const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._sendVerificationEmail();
        return result;
    }
    async _checkEmailVerificationStatus() {
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Procesando verificaci\xf3n");
        const nvEmailVerificationCon5 = document.getElementById("nvEmailVerificationCon5");
        const nvEmailVerificationCon14 = document.getElementById("nvEmailVerificationCon14");
        try {
            const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._checkEmailVerificationStatus();
            console.log(result);
            console.log(result.verified);
            if (result.verified) {
                // nvEmailVerificationCon5.style.display = "none";
                // nvEmailVerificationCon14.style.display = "flex";
                // console.log("User verified");
                const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
                if (!account.emailVerified) {
                    const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._updateUserEmailVerifiedStatus();
                    if (result.data.status === 'success') {
                        nvEmailVerificationCon5.style.display = "none";
                        nvEmailVerificationCon14.style.display = "flex";
                        $45b62c8178516fd3$var$SignUpWindowProfileAccountEmailVerifyAlert.style.display = 'none';
                    } else {
                        nvEmailVerificationCon5.style.display = "flex";
                        nvEmailVerificationCon14.style.display = "none";
                        alert("Tu correo aun no est\xe1 verificado. Necesitas seguir las instrucciones para verificar tu correo.");
                    }
                } else {
                    nvEmailVerificationCon5.style.display = "none";
                    nvEmailVerificationCon14.style.display = "flex";
                }
                return true;
            } else {
                nvEmailVerificationCon5.style.display = "flex";
                nvEmailVerificationCon14.style.display = "none";
                alert("Tu correo aun no est\xe1 verificado. Necesitas seguir las instrucciones para verificar tu correo.");
                console.log("User NOT verified");
                return false;
            }
        } catch (error) {
            console.log(error);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _openEmailVerification(email, fromNewAuth = true) {
        console.log('is here');
        const nvEmailVerificationCon1 = document.getElementById("nvEmailVerificationCon1");
        const nvEmailVerificationButtonBack = document.getElementById("nvEmailVerificationButtonBack");
        const nvEmailVerificationButtonOpenApp = document.getElementById("nvEmailVerificationButtonOpenApp");
        const nvEmailVerificationButtonCompleted = document.getElementById("nvEmailVerificationButtonCompleted");
        const nvEmailVerificationButtonResend = document.getElementById("nvEmailVerificationButtonResend");
        const nvEmailVerificationButtonWhatsApp = document.getElementById("nvEmailVerificationButtonWhatsApp");
        const nvEmailVerificationText1Email = document.getElementById("nvEmailVerificationText1Email");
        const nvEmailVerificationText5Timer = document.getElementById("nvEmailVerificationText5Timer");
        const nvEmailVerificationCon5 = document.getElementById("nvEmailVerificationCon5");
        const nvEmailVerificationCon14 = document.getElementById("nvEmailVerificationCon14");
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Verificaci\xf3n");
            const userAccount = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            nvEmailVerificationText1Email.textContent = `${userAccount?.email || "tu correo electr\xf3nico"}`;
            console.log('is here', userAccount);
            // =========================
            // RESEND TIMER
            // =========================
            const RESEND_SECONDS = 60;
            // clear previous timer if exists
            if (this.#emailVerificationResendInterval) clearInterval(this.#emailVerificationResendInterval);
            const startResendCooldown = ()=>{
                let secondsLeft = RESEND_SECONDS;
                // disable button
                nvEmailVerificationButtonResend.style.opacity = "0.5";
                nvEmailVerificationButtonResend.style.pointerEvents = "none";
                nvEmailVerificationText5Timer.textContent = `${secondsLeft} segundos`;
                this.#emailVerificationResendInterval = setInterval(()=>{
                    secondsLeft--;
                    nvEmailVerificationText5Timer.textContent = `${secondsLeft} segundos`;
                    if (secondsLeft <= 0) {
                        clearInterval(this.#emailVerificationResendInterval);
                        nvEmailVerificationButtonResend.style.opacity = "1";
                        nvEmailVerificationButtonResend.style.pointerEvents = "auto";
                        nvEmailVerificationText5Timer.textContent = "Puedes reenviar el correo";
                    }
                }, 1000);
            };
            const result = this._checkEmailVerificationStatus();
            nvEmailVerificationCon1.style.display = "flex";
            // =========================
            // VERIFIED
            // =========================
            if (result) ;
            else {
                console.log('is here');
                // send email automatically
                // only when NOT coming from fresh signup
                if (!fromNewAuth) {
                    const result = await this._sendVerificationEmail();
                    if (!result.success) {
                        alert("No hemos podido enviar el enlace de verificaci\xf3n en este momento. Intenta de nuevo mas tarde, o ponte en contacto con nuestro equipo de soporte. WhatsApp al 981 107 2143");
                        return;
                    }
                }
                nvEmailVerificationCon5.style.display = "flex";
                nvEmailVerificationCon14.style.display = "none";
                console.log(email);
                // start cooldown immediately
                startResendCooldown();
            }
            // =========================
            // EVENTS
            // =========================
            console.log('is here');
            if (this.#openEmailVerificationEventInitialized) return;
            this.#openEmailVerificationEventInitialized = true;
            console.log('is here');
            nvEmailVerificationButtonBack.addEventListener("click", ()=>{
                nvEmailVerificationCon1.style.display = "none";
            });
            nvEmailVerificationButtonResend.addEventListener("click", async ()=>{
                // extra protection
                if (nvEmailVerificationButtonResend.style.pointerEvents === "none") return;
                await this._sendVerificationEmail();
                // restart cooldown
                startResendCooldown();
            });
            nvEmailVerificationButtonCompleted.addEventListener("click", async ()=>{
                this._checkEmailVerificationStatus();
            });
            nvEmailVerificationButtonOpenApp.addEventListener("click", async ()=>{
                nvEmailVerificationCon1.style.display = "none";
            });
            nvEmailVerificationButtonWhatsApp.addEventListener("click", ()=>{
                (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink("https://wa.me/529811072143?text=Necesito%20ayuda%20en%20verificar%20mi%20correo%20electr%C3%B3nico%20en%20Mercado%20MAI");
            });
            console.log('is here');
        } catch (error) {
            console.log(error);
        } finally{
            console.log('is here');
        }
    }
    async _forgotPassword() {
        let email = $45b62c8178516fd3$var$SingInInputEmail.value.trim().toLowerCase();
        if (!email) {
            const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            email = account?.email || null;
        }
        if (!email) {
            alert("Debes ingresar tu correo electr\xf3nico en el campo de arriba.");
            return;
        }
        // basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert("Debes ingresar un correo electr\xf3nico v\xe1lido.");
            return;
        }
        const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._sendPasswordResetEmail(email);
        if (result.success) alert(`Hemos enviado un enlace a ${email} para restablecer tu contrase\xf1a.`);
        else switch(result.errorCode){
            case "auth/user-not-found":
                alert("No encontramos una cuenta con este correo electr\xf3nico.");
                break;
            case "auth/too-many-requests":
                alert("Demasiados intentos. Int\xe9ntalo nuevamente m\xe1s tarde.");
                break;
            default:
                alert("Ocurri\xf3 un error al enviar el correo.");
                break;
        }
    }
    _events() {
        $45b62c8178516fd3$var$createAccountTermsPrivacyPolicyTextForLink.addEventListener("click", ()=>{
            (0, $a082c89adac62edb$export$2e2bcd8739ae039)._openOutboundLink('https://mercadomaiprivacy.netlify.app');
        });
        $45b62c8178516fd3$var$SingUpWindowButtonClose.addEventListener("click", ()=>{
            this._close();
        });
        $45b62c8178516fd3$var$deleteAccountDeleteAllWindowButtonClose.addEventListener("click", ()=>{
            this._closeDeleteAll();
        });
        $45b62c8178516fd3$var$SignUpWindowProfileAccountEmailVerifyAlertButtonVerify.addEventListener("click", ()=>{
            this._openEmailVerification();
        });
        $45b62c8178516fd3$var$deleteAccountDeleteAllWindowButtonDeleteAll.addEventListener("click", async ()=>{
            try {
                const completed = await this._deleteAllNow();
                if (completed) {
                    this._closeDeleteAll();
                    this._openDeleteAll();
                }
            } catch (error) {
                alert("Nos encontramos con un error. Sugerimos que cieras la app, e intentas de nuevo. si sigue el problema, cont\xe1ctanos.");
            // At least one deletion failed.
            }
        });
        $45b62c8178516fd3$var$deleteAccountDeleteAllWindowButtonDeleteAccount.addEventListener("click", ()=>{
            this._deleteAccountNow();
        });
        $45b62c8178516fd3$var$SingUpWindowButtonSelectSignUp.addEventListener("click", ()=>{
            this._select("signUp");
        });
        $45b62c8178516fd3$var$SingUpWindowButtonSelectSignIn.addEventListener("click", ()=>{
            this._select("signIn");
        });
        $45b62c8178516fd3$var$SignUpWindowButtonSignUp.addEventListener("click", ()=>{
            this._signUp();
        });
        $45b62c8178516fd3$var$SignUpWindowButtonConfirmEmailConfirmEmail.addEventListener("click", ()=>{
            this._signIn();
        });
        $45b62c8178516fd3$var$SignUpWindowButtonConfirmEmailResendCode.addEventListener("click", ()=>{
            this._resendCode();
        });
        $45b62c8178516fd3$var$SignUpWindowButtonConfirmEmailChangeEmail.addEventListener("click", ()=>{
            this._changeEmail();
        });
        $45b62c8178516fd3$var$SignUpWindowButtonSignIn.addEventListener("click", ()=>{
            this._signIn();
        });
        $45b62c8178516fd3$var$SignUpWindowButtonForgotPassword.addEventListener("click", ()=>{
            this._forgotPassword();
        });
        $45b62c8178516fd3$var$SignUpWindowButtonChangePassword.addEventListener("click", ()=>{
            this._forgotPassword();
        });
        $45b62c8178516fd3$var$SignUpWindowProfileAccountButtonSignOut.addEventListener("click", ()=>{
            this._signOut();
        });
        $45b62c8178516fd3$var$SignUpWindowProfileAccountButtonDeleteAccount.addEventListener("click", ()=>{
            this._openDeleteAll();
        });
        $45b62c8178516fd3$var$ProfileButtonSaveProfile.addEventListener("click", ()=>{
            this._saveSellerProfile();
        });
        const profileImageInput = document.getElementById('profileImageInput');
        const ProfileImgContainer = document.getElementById('ProfileImgContainer');
        profileImageInput.addEventListener('change', (event)=>{
            const file = event.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (e)=>{
                ProfileImgContainer.src = e.target.result; // sets the image src
                this.#profileImageChanged = true;
            };
            reader.readAsDataURL(file);
        });
    }
}
var $45b62c8178516fd3$export$2e2bcd8739ae039 = new $45b62c8178516fd3$var$signUpProfile();


class $5b997bd2b2817dfd$var$Register {
    _displayOptions(actionAfter, title = "Cuenta necesaria", open = "none") {
        (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open();
    }
}
var $5b997bd2b2817dfd$export$2e2bcd8739ae039 = new $5b997bd2b2817dfd$var$Register();










var $10ee18ef470898e1$exports = {};
$10ee18ef470898e1$exports = new URL("drag-white.46699ad8.png", import.meta.url).toString();




var $gJCIb = parcelRequire("gJCIb");

var $gJCIb = parcelRequire("gJCIb");
class $2626b9a8ccda2dd5$export$7c0eebd88a7f92af extends (0, $gJCIb.WebPlugin) {
    async write(options) {
        if (typeof navigator === 'undefined' || !navigator.clipboard) throw this.unavailable('Clipboard API not available in this browser');
        if (options.string !== undefined) await this.writeText(options.string);
        else if (options.url) await this.writeText(options.url);
        else if (options.image) {
            if (typeof ClipboardItem !== 'undefined') try {
                const blob = await (await fetch(options.image)).blob();
                const clipboardItemInput = new ClipboardItem({
                    [blob.type]: blob
                });
                await navigator.clipboard.write([
                    clipboardItemInput
                ]);
            } catch (err) {
                throw new Error('Failed to write image');
            }
            else throw this.unavailable('Writing images to the clipboard is not supported in this browser');
        } else throw new Error('Nothing to write');
    }
    async read() {
        if (typeof navigator === 'undefined' || !navigator.clipboard) throw this.unavailable('Clipboard API not available in this browser');
        if (typeof ClipboardItem !== 'undefined') try {
            const clipboardItems = await navigator.clipboard.read();
            const type = clipboardItems[0].types[0];
            const clipboardBlob = await clipboardItems[0].getType(type);
            const data = await this._getBlobData(clipboardBlob, type);
            return {
                value: data,
                type: type
            };
        } catch (err) {
            return this.readText();
        }
        else return this.readText();
    }
    async readText() {
        if (typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.readText) throw this.unavailable('Reading from clipboard not supported in this browser');
        const text = await navigator.clipboard.readText();
        return {
            value: text,
            type: 'text/plain'
        };
    }
    async writeText(text) {
        if (typeof navigator === 'undefined' || !navigator.clipboard || !navigator.clipboard.writeText) throw this.unavailable('Writting to clipboard not supported in this browser');
        await navigator.clipboard.writeText(text);
    }
    _getBlobData(clipboardBlob, type) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            if (type.includes('image')) reader.readAsDataURL(clipboardBlob);
            else reader.readAsText(clipboardBlob);
            reader.onloadend = ()=>{
                const r = reader.result;
                resolve(r);
            };
            reader.onerror = (e)=>{
                reject(e);
            };
        });
    }
}




const $7092590103cf3cfa$export$8b44c43c7d8f0830 = (0, $gJCIb.registerPlugin)('Clipboard', {
    web: ()=>new (0, $2626b9a8ccda2dd5$export$7c0eebd88a7f92af)()
});



var $gJCIb = parcelRequire("gJCIb");

var $gJCIb = parcelRequire("gJCIb");
/**
 * @deprecated This enum is only meant to be used for deprecated `getPhoto` method.
 * It will be removed in a future major version of the plugin, along with `getPhoto`.
 */ var $0c387fff03372330$export$9a93ce53f488cb2e;
(function(CameraSource) {
    /**
     * Prompts the user to select either the photo album or take a photo.
     */ CameraSource["Prompt"] = "PROMPT";
    /**
     * Take a new photo using the camera.
     */ CameraSource["Camera"] = "CAMERA";
    /**
     * Pick an existing photo from the gallery or photo album.
     */ CameraSource["Photos"] = "PHOTOS";
})($0c387fff03372330$export$9a93ce53f488cb2e || ($0c387fff03372330$export$9a93ce53f488cb2e = {}));
var $0c387fff03372330$export$6acf6612da66fe89;
(function(CameraDirection) {
    CameraDirection["Rear"] = "REAR";
    CameraDirection["Front"] = "FRONT";
})($0c387fff03372330$export$6acf6612da66fe89 || ($0c387fff03372330$export$6acf6612da66fe89 = {}));
var $0c387fff03372330$export$ae0d39b337b8694c;
(function(CameraResultType) {
    CameraResultType["Uri"] = "uri";
    CameraResultType["Base64"] = "base64";
    CameraResultType["DataUrl"] = "dataUrl";
})($0c387fff03372330$export$ae0d39b337b8694c || ($0c387fff03372330$export$ae0d39b337b8694c = {}));
var $0c387fff03372330$export$483c11740a902fcd;
(function(MediaType) {
    MediaType[MediaType["Photo"] = 0] = "Photo";
    MediaType[MediaType["Video"] = 1] = "Video";
})($0c387fff03372330$export$483c11740a902fcd || ($0c387fff03372330$export$483c11740a902fcd = {}));
var $0c387fff03372330$export$6136b4f9c8d93a7d;
(function(MediaTypeSelection) {
    MediaTypeSelection[MediaTypeSelection["Photo"] = 0] = "Photo";
    MediaTypeSelection[MediaTypeSelection["Video"] = 1] = "Video";
    MediaTypeSelection[MediaTypeSelection["All"] = 2] = "All";
})($0c387fff03372330$export$6136b4f9c8d93a7d || ($0c387fff03372330$export$6136b4f9c8d93a7d = {}));
var $0c387fff03372330$export$456871da275f7922;
(function(EncodingType) {
    EncodingType[EncodingType["JPEG"] = 0] = "JPEG";
    EncodingType[EncodingType["PNG"] = 1] = "PNG";
})($0c387fff03372330$export$456871da275f7922 || ($0c387fff03372330$export$456871da275f7922 = {}));
var $0c387fff03372330$export$ed27101a47bb1c20;
(function(CameraErrorCode) {
    // Permissions
    /**
     * Camera access was denied by the user.
     */ CameraErrorCode["CameraPermissionDenied"] = "OS-PLUG-CAMR-0003";
    /**
     * Photo library / gallery access was denied by the user.
     */ CameraErrorCode["GalleryPermissionDenied"] = "OS-PLUG-CAMR-0005";
    /**
     * No camera hardware is available on the device.
     */ CameraErrorCode["NoCameraAvailable"] = "OS-PLUG-CAMR-0007";
    // Take Photo
    /**
     * The user cancelled the take photo action.
     */ CameraErrorCode["TakePhotoCancelled"] = "OS-PLUG-CAMR-0006";
    /**
     * Failed to take photo.
     */ CameraErrorCode["TakePhotoFailed"] = "OS-PLUG-CAMR-0010";
    /**
     * The take photo action received invalid arguments.
     * @platform ios
     */ CameraErrorCode["TakePhotoInvalidArguments"] = "OS-PLUG-CAMR-0014";
    // Edit Photo
    /**
     * The selected file contains invalid image data.
     * @platform ios
     */ CameraErrorCode["InvalidImageData"] = "OS-PLUG-CAMR-0008";
    /**
     * Failed to edit image.
     */ CameraErrorCode["EditPhotoFailed"] = "OS-PLUG-CAMR-0009";
    /**
     * The user cancelled the edit photo action.
     */ CameraErrorCode["EditPhotoCancelled"] = "OS-PLUG-CAMR-0013";
    /**
     * The URI parameter for editing is empty.
     * @platform android
     */ CameraErrorCode["EditPhotoEmptyUri"] = "OS-PLUG-CAMR-0024";
    // Choose from Gallery
    /**
     * Failed to retrieve an image from the gallery.
     */ CameraErrorCode["ImageNotFound"] = "OS-PLUG-CAMR-0011";
    /**
     * Failed to process the selected image.
     */ CameraErrorCode["ProcessImageFailed"] = "OS-PLUG-CAMR-0012";
    /**
     * Failed to choose media from the gallery.
     */ CameraErrorCode["ChooseMediaFailed"] = "OS-PLUG-CAMR-0018";
    /**
     * The user cancelled choosing media from the gallery.
     */ CameraErrorCode["ChooseMediaCancelled"] = "OS-PLUG-CAMR-0020";
    /**
     * Failed to retrieve the media file path.
     * @platform android
     */ CameraErrorCode["MediaPathError"] = "OS-PLUG-CAMR-0021";
    /**
     * Failed to retrieve an image from the provided URI.
     */ CameraErrorCode["FetchImageFromUriFailed"] = "OS-PLUG-CAMR-0028";
    // Record Video
    /**
     * Failed to record video.
     */ CameraErrorCode["RecordVideoFailed"] = "OS-PLUG-CAMR-0016";
    /**
     * The user cancelled the video recording.
     */ CameraErrorCode["RecordVideoCancelled"] = "OS-PLUG-CAMR-0017";
    /**
     * Failed to retrieve a video from the gallery.
     * @platform ios
     */ CameraErrorCode["VideoNotFound"] = "OS-PLUG-CAMR-0025";
    // Play Video
    /**
     * Failed to play video.
     */ CameraErrorCode["PlayVideoFailed"] = "OS-PLUG-CAMR-0023";
    // General
    /**
     * Failed to encode the media result.
     * @platform ios
     */ CameraErrorCode["EncodeResultFailed"] = "OS-PLUG-CAMR-0019";
    /**
     * The selected file does not exist.
     */ CameraErrorCode["FileNotFound"] = "OS-PLUG-CAMR-0027";
    /**
     * Invalid argument provided to a plugin method.
     * @platform android
     */ CameraErrorCode["InvalidArgument"] = "OS-PLUG-CAMR-0031";
    /**
     * A general plugin error occurred.
     * @platform ios
     */ CameraErrorCode["GeneralError"] = "OS-PLUG-CAMR-0026";
})($0c387fff03372330$export$ed27101a47bb1c20 || ($0c387fff03372330$export$ed27101a47bb1c20 = {}));


class $c2e477b8b2a40724$export$125d5d4d1dd2bd91 extends (0, $gJCIb.WebPlugin) {
    async takePhoto(options) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            if (options.webUseInput) this.takePhotoCameraInputExperience(options, resolve, reject);
            else this.takePhotoCameraExperience(options, resolve, reject);
        });
    }
    async recordVideo(_options) {
        throw this.unimplemented('recordVideo is not implemented on Web.');
    }
    async playVideo(_options) {
        throw this.unimplemented('playVideo is not implemented on Web.');
    }
    async chooseFromGallery(options) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            this.galleryInputExperience(options, resolve, reject);
        });
    }
    async editPhoto(_options) {
        throw this.unimplemented('editPhoto is not implemented on Web.');
    }
    async editURIPhoto(_options) {
        throw this.unimplemented('editURIPhoto is not implemented on Web.');
    }
    async getPhoto(options) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            if (options.webUseInput || options.source === (0, $0c387fff03372330$export$9a93ce53f488cb2e).Photos) this.fileInputExperience(options, resolve, reject);
            else if (options.source === (0, $0c387fff03372330$export$9a93ce53f488cb2e).Prompt) {
                let actionSheet = document.querySelector('pwa-action-sheet');
                if (!actionSheet) {
                    actionSheet = document.createElement('pwa-action-sheet');
                    document.body.appendChild(actionSheet);
                }
                actionSheet.header = options.promptLabelHeader || 'Photo';
                actionSheet.cancelable = false;
                actionSheet.options = [
                    {
                        title: options.promptLabelPhoto || 'From Photos'
                    },
                    {
                        title: options.promptLabelPicture || 'Take Picture'
                    }
                ];
                actionSheet.addEventListener('onSelection', async (e)=>{
                    const selection = e.detail;
                    if (selection === 0) this.fileInputExperience(options, resolve, reject);
                    else this.cameraExperience(options, resolve, reject);
                });
            } else this.cameraExperience(options, resolve, reject);
        });
    }
    async pickImages(_options) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            this.multipleFileInputExperience(resolve, reject);
        });
    }
    async cameraExperience(options, resolve, reject) {
        await this._setupPWACameraModal(options.direction, (photo)=>this._getCameraPhoto(photo, options), ()=>this.fileInputExperience(options, resolve, reject), resolve, reject);
    }
    fileInputExperience(options, resolve, reject) {
        let input = document.querySelector('#_capacitor-camera-input');
        const cleanup = ()=>{
            var _a;
            (_a = input.parentNode) === null || _a === void 0 || _a.removeChild(input);
        };
        if (!input) {
            input = document.createElement('input');
            input.id = '_capacitor-camera-input';
            input.type = 'file';
            input.hidden = true;
            document.body.appendChild(input);
            input.addEventListener('change', (_e)=>{
                const file = input.files[0];
                let format = 'jpeg';
                if (file.type === 'image/png') format = 'png';
                else if (file.type === 'image/gif') format = 'gif';
                if (options.resultType === 'dataUrl' || options.resultType === 'base64') {
                    const reader = new FileReader();
                    reader.addEventListener('load', ()=>{
                        if (options.resultType === 'dataUrl') resolve({
                            dataUrl: reader.result,
                            format: format
                        });
                        else if (options.resultType === 'base64') {
                            const b64 = reader.result.split(',')[1];
                            resolve({
                                base64String: b64,
                                format: format
                            });
                        }
                        cleanup();
                    });
                    reader.readAsDataURL(file);
                } else {
                    resolve({
                        webPath: URL.createObjectURL(file),
                        format: format
                    });
                    cleanup();
                }
            });
            input.addEventListener('cancel', (_e)=>{
                reject(new (0, $gJCIb.CapacitorException)('User cancelled photos app'));
                cleanup();
            });
        }
        input.accept = 'image/*';
        input.capture = true;
        if (options.source === (0, $0c387fff03372330$export$9a93ce53f488cb2e).Photos || options.source === (0, $0c387fff03372330$export$9a93ce53f488cb2e).Prompt) input.removeAttribute('capture');
        else if (options.direction === (0, $0c387fff03372330$export$6acf6612da66fe89).Front) input.capture = 'user';
        else if (options.direction === (0, $0c387fff03372330$export$6acf6612da66fe89).Rear) input.capture = 'environment';
        input.click();
    }
    multipleFileInputExperience(resolve, reject) {
        let input = document.querySelector('#_capacitor-camera-input-multiple');
        const cleanup = ()=>{
            var _a;
            (_a = input.parentNode) === null || _a === void 0 || _a.removeChild(input);
        };
        if (!input) {
            input = document.createElement('input');
            input.id = '_capacitor-camera-input-multiple';
            input.type = 'file';
            input.hidden = true;
            input.multiple = true;
            document.body.appendChild(input);
            input.addEventListener('change', (_e)=>{
                const photos = [];
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for(let i = 0; i < input.files.length; i++){
                    const file = input.files[i];
                    let format = 'jpeg';
                    if (file.type === 'image/png') format = 'png';
                    else if (file.type === 'image/gif') format = 'gif';
                    photos.push({
                        webPath: URL.createObjectURL(file),
                        format: format
                    });
                }
                resolve({
                    photos: photos
                });
                cleanup();
            });
            input.addEventListener('cancel', (_e)=>{
                reject(new (0, $gJCIb.CapacitorException)('User cancelled photos app'));
                cleanup();
            });
        }
        input.accept = 'image/*';
        input.click();
    }
    _getCameraPhoto(photo, options) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            const format = this._getFileFormat(photo);
            if (options.resultType === 'uri') resolve({
                webPath: URL.createObjectURL(photo),
                format: format,
                saved: false
            });
            else {
                reader.readAsDataURL(photo);
                reader.onloadend = ()=>{
                    const r = reader.result;
                    if (options.resultType === 'dataUrl') resolve({
                        dataUrl: r,
                        format: format,
                        saved: false
                    });
                    else resolve({
                        base64String: r.split(',')[1],
                        format: format,
                        saved: false
                    });
                };
                reader.onerror = (e)=>{
                    reject(e);
                };
            }
        });
    }
    async takePhotoCameraExperience(options, resolve, reject) {
        await this._setupPWACameraModal(options.cameraDirection, (photo)=>{
            var _a;
            return this._buildPhotoMediaResult(photo, (_a = options.includeMetadata) !== null && _a !== void 0 ? _a : false);
        }, ()=>this.takePhotoCameraInputExperience(options, resolve, reject), resolve, reject);
    }
    takePhotoCameraInputExperience(options, resolve, reject) {
        const input = this._createFileInput('_capacitor-camera-input-takephoto');
        const cleanup = ()=>{
            var _a;
            (_a = input.parentNode) === null || _a === void 0 || _a.removeChild(input);
        };
        input.onchange = async (_e)=>{
            var _a;
            if (!this._validateFileInput(input, reject, cleanup)) return;
            const file = input.files[0];
            resolve(await this._buildPhotoMediaResult(file, (_a = options.includeMetadata) !== null && _a !== void 0 ? _a : false));
            cleanup();
        };
        input.oncancel = ()=>{
            reject(new (0, $gJCIb.CapacitorException)('User cancelled photos app'));
            cleanup();
        };
        input.accept = 'image/*';
        if (options.cameraDirection === (0, $0c387fff03372330$export$6acf6612da66fe89).Front) input.capture = 'user';
        else // CameraDirection.Rear
        input.capture = 'environment';
        input.click();
    }
    galleryInputExperience(options, resolve, reject) {
        var _a, _b;
        const input = this._createFileInput('_capacitor-camera-input-gallery');
        input.multiple = (_a = options.allowMultipleSelection) !== null && _a !== void 0 ? _a : false;
        const cleanup = ()=>{
            var _a;
            (_a = input.parentNode) === null || _a === void 0 || _a.removeChild(input);
        };
        input.onchange = async (_e)=>{
            var _a;
            if (!this._validateFileInput(input, reject, cleanup)) return;
            const results = [];
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for(let i = 0; i < input.files.length; i++){
                const file = input.files[i];
                if (file.type.startsWith('image/')) results.push(await this._buildPhotoMediaResult(file, (_a = options.includeMetadata) !== null && _a !== void 0 ? _a : false));
                else if (file.type.startsWith('video/')) {
                    const format = this._getFileFormat(file);
                    let thumbnail;
                    let resolution;
                    let duration;
                    try {
                        const videoInfo = await this._getVideoMetadata(file);
                        thumbnail = videoInfo.thumbnail;
                        if (options.includeMetadata) {
                            resolution = videoInfo.resolution;
                            duration = videoInfo.duration;
                        }
                    } catch (e) {
                        console.warn('Failed to get video metadata:', e);
                    }
                    const result = {
                        type: (0, $0c387fff03372330$export$483c11740a902fcd).Video,
                        thumbnail: thumbnail,
                        webPath: URL.createObjectURL(file),
                        saved: false
                    };
                    if (options.includeMetadata) result.metadata = {
                        format: format,
                        resolution: resolution,
                        size: file.size,
                        creationDate: new Date(file.lastModified).toISOString(),
                        duration: duration
                    };
                    results.push(result);
                }
            }
            resolve({
                results: results
            });
            cleanup();
        };
        input.oncancel = ()=>{
            reject(new (0, $gJCIb.CapacitorException)('User cancelled photos app'));
            cleanup();
        };
        // Set accept attribute based on mediaType
        const mediaType = (_b = options.mediaType) !== null && _b !== void 0 ? _b : (0, $0c387fff03372330$export$6136b4f9c8d93a7d).Photo;
        if (mediaType === (0, $0c387fff03372330$export$6136b4f9c8d93a7d).Photo) input.accept = 'image/*';
        else if (mediaType === (0, $0c387fff03372330$export$6136b4f9c8d93a7d).Video) input.accept = 'video/*';
        else // MediaTypeSelection.All
        input.accept = 'image/*,video/*';
        input.click();
    }
    _getFileFormat(file) {
        if (file.type === 'image/png') return 'png';
        else if (file.type === 'image/gif') return 'gif';
        else if (file.type.startsWith('video/')) return file.type.split('/')[1];
        else if (file.type.startsWith('image/')) return 'jpeg';
        return file.type.split('/')[1] || 'jpeg';
    }
    async _buildPhotoMediaResult(file, includeMetadata) {
        const format = this._getFileFormat(file);
        const thumbnail = await this._getBase64FromFile(file);
        const result = {
            type: (0, $0c387fff03372330$export$483c11740a902fcd).Photo,
            thumbnail: thumbnail,
            webPath: URL.createObjectURL(file),
            saved: false
        };
        if (includeMetadata) {
            const resolution = await this._getImageResolution(file);
            result.metadata = {
                format: format,
                resolution: resolution,
                size: file.size,
                creationDate: 'lastModified' in file ? new Date(file.lastModified).toISOString() : new Date().toISOString()
            };
        }
        return result;
    }
    _validateFileInput(input, reject, cleanup) {
        if (!input.files || input.files.length === 0) {
            const message = input.multiple ? 'No files selected' : 'No file selected';
            reject(new (0, $gJCIb.CapacitorException)(message));
            cleanup();
            return false;
        }
        return true;
    }
    async _setupPWACameraModal(cameraDirection, onPhotoCallback, fallbackCallback, resolve, reject) {
        if (customElements.get('pwa-camera-modal')) {
            const cameraModal = document.createElement('pwa-camera-modal');
            cameraModal.facingMode = cameraDirection === (0, $0c387fff03372330$export$6acf6612da66fe89).Front ? 'user' : 'environment';
            document.body.appendChild(cameraModal);
            try {
                await cameraModal.componentOnReady();
                cameraModal.addEventListener('onPhoto', async (e)=>{
                    const photo = e.detail;
                    if (photo === null) reject(new (0, $gJCIb.CapacitorException)('User cancelled photos app'));
                    else if (photo instanceof Error) reject(photo);
                    else resolve(await onPhotoCallback(photo));
                    cameraModal.dismiss();
                    document.body.removeChild(cameraModal);
                });
                cameraModal.present();
            } catch (e) {
                fallbackCallback();
            }
        } else {
            console.error(`Unable to load PWA Element 'pwa-camera-modal'. See the docs: https://capacitorjs.com/docs/web/pwa-elements.`);
            fallbackCallback();
        }
    }
    _createFileInput(id) {
        let input = document.querySelector(`#${id}`);
        if (!input) {
            input = document.createElement('input');
            input.id = id;
            input.type = 'file';
            input.hidden = true;
            document.body.appendChild(input);
        }
        return input;
    }
    async _getImageResolution(image) {
        try {
            const bitmap = await createImageBitmap(image);
            const resolution = `${bitmap.width}x${bitmap.height}`;
            bitmap.close();
            return resolution;
        } catch (e) {
            console.warn('Failed to get image resolution:', e);
            return undefined;
        }
    }
    _getBase64FromFile(file) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>{
                const dataUrl = reader.result;
                const base64 = dataUrl.split(',')[1];
                resolve(base64);
            };
            reader.onerror = (e)=>{
                reject(e);
            };
            reader.readAsDataURL(file);
        });
    }
    _getVideoMetadata(videoFile) {
        return new Promise((resolve)=>{
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.muted = true;
            video.onloadedmetadata = ()=>{
                // Seek to 1 second or 10% of duration to capture thumbnail
                const seekTime = Math.min(1, video.duration * 0.1);
                video.currentTime = seekTime;
            };
            video.onseeked = ()=>{
                const result = {
                    resolution: `${video.videoWidth}x${video.videoHeight}`,
                    duration: video.duration
                };
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext('2d');
                    if (ctx) {
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        result.thumbnail = canvas.toDataURL('image/jpeg', 0.8).split(',')[1];
                    }
                } catch (e) {
                    console.warn('Failed to generate video thumbnail:', e);
                }
                URL.revokeObjectURL(video.src);
                resolve(result);
            };
            video.onerror = ()=>{
                // Clean up and return defaults
                URL.revokeObjectURL(video.src);
                resolve({});
            };
            video.src = URL.createObjectURL(videoFile);
        });
    }
    async checkPermissions() {
        if (typeof navigator === 'undefined' || !navigator.permissions) throw this.unavailable('Permissions API not available in this browser');
        try {
            // https://developer.mozilla.org/en-US/docs/Web/API/Permissions/query
            // the specific permissions that are supported varies among browsers that implement the
            // permissions API, so we need a try/catch in case 'camera' is invalid
            const permission = await window.navigator.permissions.query({
                name: 'camera'
            });
            return {
                camera: permission.state,
                photos: 'granted'
            };
        } catch (_a) {
            throw this.unavailable('Camera permissions are not available in this browser');
        }
    }
    async requestPermissions() {
        throw this.unimplemented('Not implemented on web.');
    }
    async pickLimitedLibraryPhotos() {
        throw this.unavailable('Not implemented on web.');
    }
    async getLimitedLibraryPhotos() {
        throw this.unavailable('Not implemented on web.');
    }
}
const $c2e477b8b2a40724$export$79f141de891a5fed = new $c2e477b8b2a40724$export$125d5d4d1dd2bd91();



const $f461ddf16de51fc1$export$79f141de891a5fed = (0, $gJCIb.registerPlugin)('Camera', {
    web: ()=>new (0, $c2e477b8b2a40724$export$125d5d4d1dd2bd91)()
});





let $4f930c604957bd07$var$listingDataEmpty = {
    listingName: "",
    listingMachineType: "",
    listingBrand: "",
    listingModel: "",
    listingCondition: "",
    listingYear: "",
    listingPrice: "",
    listingPriceMarkedAs: "",
    listingItemsAvailable: 0,
    listingCoin: "",
    listingDescription: "",
    listingTokens: [],
    onDiscount: {
        finalPrice: "",
        percent: "",
        amount: ""
    },
    listingMainImg: "",
    listingImgsIds: [],
    listingWhatsAppNumber: "",
    listingCallNumber: "",
    listingMarkedAs: "",
    videoUrl: "",
    adminNotes: "",
    place: {
        description: "",
        lat: "",
        lng: "",
        locationUrl: "",
        name: "",
        city: "",
        country: "",
        state: ""
    },
    filterLat: '',
    filterLng: '',
    filterState: '',
    filterCountry: '',
    filterCity: '',
    filterGeoHash: ''
};
let $4f930c604957bd07$var$listingData = {
    listingName: "",
    listingMachineType: "",
    listingBrand: "",
    listingModel: "",
    listingCondition: "",
    listingYear: "",
    listingPrice: "",
    listingPriceMarkedAs: "",
    listingItemsAvailable: 0,
    listingCoin: "",
    listingDescription: "",
    listingTokens: [],
    onDiscount: {
        finalPrice: "",
        percent: "",
        amount: ""
    },
    listingMainImg: "",
    listingImgsIds: [],
    listingWhatsAppNumber: "",
    listingCallNumber: "",
    listingMarkedAs: "",
    videoUrl: "",
    adminNotes: "",
    place: {
        description: "",
        lat: "",
        lng: "",
        locationUrl: "",
        name: "",
        city: "",
        country: "",
        state: ""
    },
    filterLat: '',
    filterLng: '',
    filterState: '',
    filterCountry: '',
    filterCity: '',
    filterGeoHash: ''
};
class $4f930c604957bd07$var$CreateListing {
    #machineBrandsOnCleared = false;
    #machineModelsOnCleared = false;
    #initialPreselectedSet = false;
    #prefixId = "";
    #publishIn = null;
    #isInEdit = false;
    #listingId = null;
    #businessId = null;
    #listingCreatedAt;
    #listingUpdatedAt;
    #newType = false;
    #newPlace = false;
    #isValidVideo = false;
    #eventsInitialized = false;
    #CTAShareEventsInitialized = false;
    #finalPublishListingButtonActivated = false;
    #hasChanges = false;
    #loadedOptionsDataCategories = null;
    #loadedOptionsDataBrands = null;
    #loadedOptionsDataModels = null;
    #publishNowButtonFinalClickedAt = 0;
    #isStillUploadingImages = false;
    async _init(dataIn, draftId) {
        this.#hasChanges = false;
        if (this.#isStillUploadingImages) {
            alert("Por favor espera a que se complete la subida de im\xe1genes antes de continuar.");
            return;
        }
        console.log(draftId);
        // GENRALHELPERS._startTimer('createListingInit')
        console.log(dataIn);
        this.#initialPreselectedSet = false;
        this.#eventsInitialized = false;
        this.#newType = false;
        this.#newPlace = false;
        this.#prefixId = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUniqueIdfunction();
        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (!account) {
            (0, $5b997bd2b2817dfd$export$2e2bcd8739ae039)._displayOptions("create_listing");
            return;
        } else {
            if (!account.whatsAppNumber) {
                // accountProfileChange._open();
                alert("Debes tener un perfil de vendedor para poder publicar listados.");
                (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open(true);
                return;
            }
            let drafts = [];
            if (dataIn) {
                if (dataIn?.place) $4f930c604957bd07$var$listingData = dataIn;
                else $4f930c604957bd07$var$listingData = {
                    ...dataIn,
                    place: {
                        description: "",
                        lat: "",
                        lng: "",
                        locationUrl: "",
                        name: "",
                        city: "",
                        country: "",
                        state: ""
                    },
                    filterLat: dataIn?.filterLat ?? '',
                    filterLng: dataIn?.filterLng ?? '',
                    filterState: dataIn?.filterState ?? '',
                    filterCountry: dataIn?.filterCountry ?? '',
                    filterCity: dataIn?.filterCity ?? '',
                    filterGeoHash: dataIn?.filterGeoHash ?? ''
                };
                this.#isInEdit = true;
                this.#listingId = dataIn.listingId;
                this.#businessId = dataIn.businessId;
                this.#listingCreatedAt = dataIn.createdAt;
                this.#listingUpdatedAt = dataIn.updatedAt;
                if (!$4f930c604957bd07$var$listingData.listingItemsAvailable) $4f930c604957bd07$var$listingData.listingItemsAvailable = 0;
            } else {
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando...");
                drafts = await this._getDrafts();
                drafts.splice(0, drafts.length, ...drafts.filter((draft)=>draft.uploadStatus !== 'uploading'));
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                console.log(drafts);
                if (draftId) {
                    const draft = drafts.find((draft)=>draft.prefixId === Number(draftId));
                    console.log(draft, "draft encontrado");
                    if (draft) drafts = [
                        draft
                    ];
                    else drafts = [];
                }
                const hiddenStatuses = [
                    'uploading'
                ];
                drafts = drafts.filter((draft)=>!hiddenStatuses.includes(draft.status));
                if (drafts?.length > 0 && !draftId) {
                    const action = await this._confirmContinueListing();
                    const modal = document.getElementById('confirmContinueListingConMain');
                    if (action === 'new') {
                        drafts = [];
                        modal.style.display = 'none';
                    }
                    if (action === 'seeDrafts') {
                        modal.style.display = 'none';
                        (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init('listing-drafts');
                        return;
                    // const con = document.getElementById(
                    //   `SearchStartUpComponentAllCon`
                    // );
                    // con.remove();
                    }
                    if (action === 'cancel') {
                        modal.style.display = 'none';
                        return;
                    }
                    if (action === 'Continue') modal.style.display = 'none';
                }
                $4f930c604957bd07$var$listingData.listingName = drafts[0]?.listingName || "";
                $4f930c604957bd07$var$listingData.listingMachineType = drafts[0]?.listingMachineType || "";
                $4f930c604957bd07$var$listingData.listingBrand = drafts[0]?.listingBrand || "";
                $4f930c604957bd07$var$listingData.listingModel = drafts[0]?.listingModel || "";
                $4f930c604957bd07$var$listingData.listingCondition = drafts[0]?.listingCondition || "";
                $4f930c604957bd07$var$listingData.listingYear = drafts[0]?.listingYear || "";
                $4f930c604957bd07$var$listingData.listingPrice = drafts[0]?.listingPrice || "";
                $4f930c604957bd07$var$listingData.listingCoin = drafts[0]?.listingCoin || "";
                $4f930c604957bd07$var$listingData.listingDescription = drafts[0]?.listingDescription || "";
                $4f930c604957bd07$var$listingData.listingMainImg = drafts[0]?.listingMainImg || "";
                $4f930c604957bd07$var$listingData.listingMarkedAs = drafts[0]?.listingMarkedAs || "";
                $4f930c604957bd07$var$listingData.listingPriceMarkedAs = drafts[0]?.listingPriceMarkedAs || "";
                $4f930c604957bd07$var$listingData.listingImgsIds = [];
                $4f930c604957bd07$var$listingData.listingWhatsAppNumber = drafts[0]?.listingWhatsAppNumber || "";
                $4f930c604957bd07$var$listingData.listingCallNumber = drafts[0]?.listingCallNumber || "";
                $4f930c604957bd07$var$listingData.listingItemsAvailable = drafts[0]?.listingItemsAvailable || 0;
                $4f930c604957bd07$var$listingData.videoUrl = drafts[0]?.videoUrl || "";
                $4f930c604957bd07$var$listingData.adminNotes = drafts[0]?.adminNotes || "";
                if (drafts[0]?.place) {
                    $4f930c604957bd07$var$listingData.place = drafts[0]?.place;
                    $4f930c604957bd07$var$listingData.filterLat = drafts[0]?.filterLat ?? '';
                    $4f930c604957bd07$var$listingData.filterLng = drafts[0]?.filterLng ?? '';
                    $4f930c604957bd07$var$listingData.filterState = drafts[0]?.filterState ?? '';
                    $4f930c604957bd07$var$listingData.filterCountry = drafts[0]?.filterCountry ?? '';
                    $4f930c604957bd07$var$listingData.filterCity = drafts[0]?.filterCity ?? '';
                    $4f930c604957bd07$var$listingData.filterGeoHash = drafts[0]?.filterGeoHash ?? '';
                } else {
                    $4f930c604957bd07$var$listingData.place = {
                        description: "",
                        lat: "",
                        lng: "",
                        locationUrl: "",
                        name: "",
                        city: "",
                        country: "",
                        state: ""
                    };
                    $4f930c604957bd07$var$listingData.filterLat = '';
                    $4f930c604957bd07$var$listingData.filterLng = '';
                    $4f930c604957bd07$var$listingData.filterState = '';
                    $4f930c604957bd07$var$listingData.filterCountry = '';
                    $4f930c604957bd07$var$listingData.filterCity = '';
                    $4f930c604957bd07$var$listingData.filterGeoHash = '';
                }
                console.log('listingData', $4f930c604957bd07$var$listingData);
                this.#isInEdit = false;
                this.#listingId = null;
                this.#businessId = null;
                this.#listingCreatedAt = null;
                this.#listingUpdatedAt = null;
            }
            if (!$4f930c604957bd07$var$listingData.onDiscount) $4f930c604957bd07$var$listingData["onDiscount"] = {
                finalPrice: $4f930c604957bd07$var$listingData.listingPrice,
                amount: 0,
                percent: 0
            };
            console.log(this.#listingId);
            console.log($4f930c604957bd07$var$listingData);
            const container = document.getElementById("MainAppContentContainer");
            const content = (0, $ac56fd6b84e2bb3e$export$2e2bcd8739ae039)._display($4f930c604957bd07$var$listingData);
            const numberOfListingsAvailable = document.querySelector(".numberOfListingsAvailable");
            if (numberOfListingsAvailable) numberOfListingsAvailable.remove();
            container.insertAdjacentHTML("beforeend", content);
            let imgs = dataIn?.listingImgsIds;
            if (dataIn?.listingImgsIds[0]?.res_20) {
                imgs = [];
                dataIn?.listingImgsIds.forEach((imgSet)=>{
                    imgs.push(imgSet?.res_original);
                });
            } else {
                imgs = [];
                // drafts[0]?.images?.forEach(img => {
                //   console.log(img);
                //   imgs.push(img?.src)
                // });
                drafts[0]?.images?.forEach((img)=>{
                    const url = URL.createObjectURL(img.blob);
                    imgs.push(url);
                });
            }
            if (drafts?.length > 0) this._deleteDraft(drafts[0]?.prefixId);
            if (imgs?.length > 0) this.#hasChanges = true;
            this._imageHandle(imgs);
            this.#finalPublishListingButtonActivated = false;
            this._events(this.#prefixId);
            this._eventsForOptions(this.#prefixId);
            this._initializeCatBrandModelSelects($4f930c604957bd07$var$listingData?.listingMachineType, $4f930c604957bd07$var$listingData?.listingBrand, $4f930c604957bd07$var$listingData?.listingModel);
            this._initializeYearSelect($4f930c604957bd07$var$listingData?.listingYear);
            this._initializeConditionSelect($4f930c604957bd07$var$listingData?.listingCondition);
            this._setOtherData();
            document.querySelectorAll('input, textarea').forEach((el)=>{
                el.addEventListener('focus', ()=>{
                    document.body.style.overflow = 'hidden';
                });
                el.addEventListener('blur', ()=>{
                    document.body.style.overflow = '';
                });
            });
            const titleInput = document.getElementById('CreateListingName');
            function autoGrow() {
                titleInput.style.height = 'auto';
                titleInput.style.height = titleInput.scrollHeight + 'px';
            }
            titleInput.addEventListener('input', autoGrow);
            autoGrow();
            this._eventsForMoreOptions();
        }
    }
    // START Draft
    // _getUploadImages() {
    //   const imagesCon = document.getElementById('uploaded-images-container');
    //   const images = imagesCon.querySelectorAll('.uploadSpecific');
    //   return Array.from(images).map(img => ({
    //     src: img.src,
    //     alt: img.alt || ''
    //   }));
    // }
    async _getUploadImages() {
        const imagesCon = document.getElementById('uploaded-images-container');
        const images = imagesCon.querySelectorAll('.uploadSpecific');
        const result = [];
        for (const img of images){
            const response = await fetch(img.src);
            const blob = await response.blob();
            result.push({
                blob: blob
            });
        }
        return result;
    }
    _openDraftDB() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open('listingDraftsDB', 1);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                if (!db.objectStoreNames.contains('drafts')) db.createObjectStore('drafts', {
                    keyPath: 'prefixId'
                });
            };
            request.onsuccess = ()=>resolve(request.result);
            request.onerror = ()=>reject(request.error);
        });
    }
    async _saveDraft(prefixIdIn, uploadStatus) {
        console.log('Saving draft...', prefixIdIn);
        const prefixId = prefixIdIn || Date.now();
        const images = await this._getUploadImages();
        const dataToStore = {
            ...$4f930c604957bd07$var$listingData,
            images: images,
            uploadStatus: uploadStatus,
            prefixId: prefixId,
            savedAt: Date.now()
        };
        const db = await this._openDraftDB();
        const tx = db.transaction('drafts', 'readwrite');
        tx.objectStore('drafts').put(dataToStore);
        return new Promise((resolve, reject)=>{
            tx.oncomplete = ()=>resolve(dataToStore);
            tx.onerror = ()=>reject(tx.error);
        });
    }
    async _getDrafts() {
        const db = await this._openDraftDB();
        return new Promise((resolve, reject)=>{
            const request = db.transaction('drafts', 'readonly').objectStore('drafts').getAll();
            request.onsuccess = ()=>{
                const drafts = request.result.sort((a, b)=>b.savedAt - a.savedAt);
                resolve(drafts);
            };
            request.onerror = ()=>reject(request.error);
        });
    }
    async _getDraft(prefixId) {
        const db = await this._openDraftDB();
        return new Promise((resolve, reject)=>{
            const request = db.transaction('drafts', 'readonly').objectStore('drafts').get(prefixId);
            request.onsuccess = ()=>resolve(request.result);
            request.onerror = ()=>reject(request.error);
        });
    }
    async _deleteDraft(prefixId) {
        const db = await this._openDraftDB();
        return new Promise((resolve, reject)=>{
            const request = db.transaction('drafts', 'readwrite').objectStore('drafts').delete(Number(prefixId));
            request.onsuccess = ()=>resolve('deleted');
            request.onerror = ()=>reject(request.error);
        });
    }
    // END Draft
    _eventsForMoreOptions() {
        const CreateListingOptionalMoreDescriptionSection = document.getElementById('CreateListingOptionalMoreDescriptionSection');
        const CreateListingOptionalCategorySection = document.getElementById('CreateListingOptionalCategorySection');
        const CreateListingOptionalItemsAvailableSection = document.getElementById('CreateListingOptionalItemsAvailableSection');
        const CreateListingMoreOptionsButton = document.getElementById('CreateListingMoreOptionsButton');
        const CreateListingOptionsPicPriceMArkedAs = document.getElementById('CreateListingOptionsPicPriceMArkedAs');
        const CreateListingDiscount = document.getElementById('CreateListingDiscount');
        const CreateListingPriceMoreOptionsCon = document.getElementById('CreateListingPriceMoreOptionsCon');
        const CreateListingPriceMoreOptionsButton = document.getElementById('CreateListingPriceMoreOptionsButton');
        CreateListingMoreOptionsButton.addEventListener('click', ()=>{
            CreateListingOptionalMoreDescriptionSection.style.display = 'flex';
            CreateListingOptionalCategorySection.style.display = 'flex';
            CreateListingOptionalItemsAvailableSection.style.display = 'flex';
            CreateListingMoreOptionsButton.style.display = 'none';
        });
        CreateListingPriceMoreOptionsButton.addEventListener('click', ()=>{
            CreateListingOptionsPicPriceMArkedAs.style.display = 'flex';
            CreateListingDiscount.style.display = 'flex';
            CreateListingPriceMoreOptionsCon.style.display = 'none';
        });
    }
    async _initializeCatBrandModelSelects(category = null, brand = null, model = null) {
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando caracter\xedsticas...");
            const useOptions = [];
            const loadedOptionsDataCategories = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData("machineTypes");
            this.#loadedOptionsDataCategories = loadedOptionsDataCategories;
            loadedOptionsDataCategories.forEach((opt)=>{
                useOptions.push(this._deslug(opt.data.name));
            });
            // Initialize chain
            const chain = this._chainSelects([
                'CreateListingSelectCategory',
                'CreateListingSelectBrand',
                'CreateListingSelectModel'
            ]);
            // Set category options
            chain['CreateListingSelectCategory'].setOptions(useOptions);
            // =========================
            // 🔥 PREFILL LOGIC
            // =========================
            if (category) {
                // 1. Set category
                chain['CreateListingSelectCategory'].setValue(category);
                // 2. Load brands
                const brandOptions = await this._loadOptions([
                    category
                ]);
                chain['CreateListingSelectBrand'].setOptions(brandOptions);
                chain['CreateListingSelectBrand'].enable();
                if (brand) {
                    // 3. Set brand
                    chain['CreateListingSelectBrand'].setValue(brand);
                    // 4. Load models
                    const modelOptions = await this._loadOptions([
                        category,
                        brand
                    ]);
                    chain['CreateListingSelectModel'].setOptions(modelOptions);
                    chain['CreateListingSelectModel'].enable();
                    if (model) // 5. Set model
                    chain['CreateListingSelectModel'].setValue(model);
                }
            }
        } catch (error) {
            console.log(error.message);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _initializeYearSelect(year) {
        const years = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._generateYearsArray(1990);
        const useOptions = years.map((y)=>y.toString());
        const chain = this._chainSelects([
            'CreateListingSelectYear'
        ]);
        const yearSelect = chain['CreateListingSelectYear'];
        yearSelect.setOptions(useOptions);
        // 🔥 PREFILL
        if (year && useOptions.includes(year.toString())) yearSelect.setValue(year.toString());
    }
    async _initializeConditionSelect(condition) {
        const options = [
            "Nuevo",
            "Usado"
        ];
        const chain = this._chainSelects([
            'CreateListingSelectCondition'
        ]);
        const conditionSelect = chain['CreateListingSelectCondition'];
        conditionSelect.setOptions(options);
        // 🔥 PREFILL
        if (condition && options.includes(condition)) conditionSelect.setValue(condition);
    }
    // Create a custom select instance
    _createCustomSelect(selectId, options = [], onChange = null) {
        const container = document.getElementById(selectId);
        container.innerHTML = `
    <div class="cs-display">Seleccionar\u{2026}</div>
    <div class="cs-dropdown">
      <input type="text" class="cs-search" placeholder="Buscar opciones\u{2026}">
      <div class="cs-options"></div>
    </div>
  `;
        const display = container.querySelector('.cs-display');
        const dropdown = container.querySelector('.cs-dropdown');
        const search = container.querySelector('.cs-search');
        const optionsCon = container.querySelector('.cs-options');
        let currentOptions = [
            ...options
        ];
        let selectedValue = null;
        let isDisabled = false; // NEW
        function renderOptions(filter = "") {
            optionsCon.innerHTML = "";
            const filtered = currentOptions.filter((o)=>o.toLowerCase().includes(filter.toLowerCase()));
            filtered.forEach((opt)=>{
                const div = document.createElement("div");
                div.className = "cs-option";
                div.textContent = opt;
                div.onclick = ()=>{
                    if (isDisabled) return; // NEW
                    selectedValue = opt;
                    display.textContent = opt;
                    dropdown.style.display = "none";
                    if (onChange) onChange(opt);
                };
                optionsCon.appendChild(div);
            });
            if (filter.length > 0 && !currentOptions.includes(filter)) {
                const createDiv = document.createElement("div");
                createDiv.className = "cs-create-option";
                createDiv.textContent = `Agregar "${filter}"`;
                createDiv.onclick = ()=>{
                    if (isDisabled) return; // NEW
                    currentOptions.push(filter);
                    selectedValue = filter;
                    display.textContent = filter;
                    dropdown.style.display = "none";
                    if (onChange) onChange(filter);
                };
                optionsCon.appendChild(createDiv);
            }
        }
        // Toggle dropdown
        display.onclick = ()=>{
            if (isDisabled) return; // NEW
            dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
            search.value = "";
            renderOptions("");
        };
        search.oninput = ()=>{
            if (isDisabled) return; // NEW
            renderOptions(search.value);
        };
        document.addEventListener("click", (e)=>{
            if (!container.contains(e.target)) dropdown.style.display = "none";
        });
        return {
            setOptions (newOptions) {
                currentOptions = [
                    ...newOptions
                ];
                renderOptions("");
            },
            reset () {
                selectedValue = null;
                display.textContent = "Seleccionar\u2026";
                search.value = "";
                renderOptions("");
            },
            // >>> NEW: DISABLE SELECT <<<
            disable () {
                isDisabled = true;
                container.classList.add("cs-disabled");
                dropdown.style.display = "none";
            },
            // >>> NEW: ENABLE SELECT <<<
            enable () {
                isDisabled = false;
                container.classList.remove("cs-disabled");
            },
            getValue () {
                return selectedValue;
            },
            setValue (value, trigger = true) {
                selectedValue = value;
                display.textContent = value;
                if (trigger && onChange) onChange(value);
            }
        };
    }
    _chainSelects(selectIds) {
        const selects = {};
        // Initialize selects
        selectIds.forEach((id)=>{
            selects[id] = this._createCustomSelect(id, [], (value)=>handleChange(id, value));
        });
        // Disable all except the first
        selectIds.forEach((id, index)=>{
            if (index !== 0) selects[id].disable();
        });
        const handleChange = (changedId, value)=>{
            const index = selectIds.indexOf(changedId);
            // Reset + disable all after
            for(let i = index + 1; i < selectIds.length; i++){
                selects[selectIds[i]].reset();
                selects[selectIds[i]].setOptions([]);
                selects[selectIds[i]].disable();
            }
            // Enable + populate next select
            const nextId = selectIds[index + 1];
            if (nextId) {
                const selectedValues = selectIds.slice(0, index + 1).map((id)=>selects[id].getValue());
                this._loadOptions(selectedValues).then((options)=>{
                    selects[nextId].setOptions(options);
                    selects[nextId].enable();
                });
            }
            // 👉 Save the actual selected value:
            this._storeSelectedValue(changedId, value.toLowerCase());
            this._checkIfNewCategory(value, changedId);
        };
        return selects;
    }
    _checkIfNewCategory(value, changedId) {
        console.log(value);
        let loadedData = null;
        const categoryName = value.trim().toLowerCase().replace(/\s+/g, '-');
        if (changedId === 'CreateListingSelectCategory') loadedData = this.#loadedOptionsDataCategories;
        else if (changedId === 'CreateListingSelectBrand') loadedData = this.#loadedOptionsDataBrands;
        else if (changedId === 'CreateListingSelectModel') loadedData = this.#loadedOptionsDataModels;
        else return;
        const exists = loadedData.some((category)=>category.data.name.toLowerCase() === categoryName);
        if (!exists) this.#newType = true;
        console.log(this.#newType);
    }
    async _loadOptions(selectedValues) {
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando carateristicas...');
            const useOptions = [];
            if (selectedValues.length === 1) {
                const loadedData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData(`machineTypes/${this._cleanText(selectedValues[0])}/brands`);
                this.#loadedOptionsDataBrands = loadedData;
                loadedData.forEach((opt)=>{
                    useOptions.push(this._deslug(opt.data.name));
                });
            }
            if (selectedValues.length === 2) {
                const loadedData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData(`machineTypes/${this._cleanText(selectedValues[0])}/brands/${this._cleanText(selectedValues[1])}/models`);
                this.#loadedOptionsDataModels = loadedData;
                loadedData.forEach((opt)=>{
                    useOptions.push(this._deslug(opt.data.name));
                });
            }
            // You return an array.
            return useOptions;
        } catch (error) {
            console.log(error.message);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    _storeSelectedValue(id, value) {
        if (id === "CreateListingSelectCategory") {
            $4f930c604957bd07$var$listingData.listingMachineType = value;
            const CreateListingSelectCategory = document.getElementById('CreateListingSelectCategory');
            CreateListingSelectCategory.classList.remove('CreateListingSelectCategoryRedBorder');
        }
        if (id === "CreateListingSelectBrand") $4f930c604957bd07$var$listingData.listingBrand = value;
        if (id === "CreateListingSelectModel") $4f930c604957bd07$var$listingData.listingModel = value;
        if (id === "CreateListingSelectYear") $4f930c604957bd07$var$listingData.listingYear = value;
        if (id === "CreateListingSelectCondition") $4f930c604957bd07$var$listingData.listingCondition = value;
        console.log(id, value);
    }
    _cleanText(text) {
        return text.toLowerCase()// remove accents
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")// replace any non-alphanumeric characters with spaces
        .replace(/[^a-z0-9]+/g, "-")// remove starting/ending hyphens
        .replace(/^-+|-+$/g, "");
    }
    _deslug(text) {
        if (!text) return "";
        return text.replace(/-/g, " ") // dashes → spaces
        .trim().split(/\s+/) // split into words
        .map((w)=>w.charAt(0).toUpperCase() + w.slice(1)) // capitalize
        .join(" ");
    }
    _confirmLeaveListing() {
        return new Promise((resolve)=>{
            const modal = document.getElementById('confirmLeaveListingConMain');
            const saveBtn = document.getElementById('confirmLeaveListingButtonSave');
            const leaveBtn = document.getElementById('confirmLeaveListingButtonLeave');
            const cancelBtn = document.getElementById('confirmLeaveListingButtonCancel');
            if (!modal || !saveBtn || !leaveBtn || !cancelBtn) {
                resolve('cancel');
                return;
            }
            modal.style.display = 'flex';
            const cleanup = ()=>{
                saveBtn.removeEventListener('click', handleSave);
                leaveBtn.removeEventListener('click', handleLeave);
                cancelBtn.removeEventListener('click', handleCancel);
                modal.style.display = 'none';
            };
            const handleSave = ()=>{
                cleanup();
                resolve('save');
            };
            const handleLeave = ()=>{
                cleanup();
                resolve('leave');
            };
            const handleCancel = ()=>{
                cleanup();
                resolve('cancel');
            };
            saveBtn.addEventListener('click', handleSave);
            leaveBtn.addEventListener('click', handleLeave);
            cancelBtn.addEventListener('click', handleCancel);
        });
    }
    _confirmContinueListing() {
        return new Promise((resolve)=>{
            const modal = document.getElementById('confirmContinueListingConMain');
            const newBtn = document.getElementById('confirmContinueListingButtonNew');
            const seeDraftsBtn = document.getElementById('confirmContinueListingButtonSeeDrafts');
            const cancelBtn = document.getElementById('confirmContinueListingButtonCancel');
            const continueBtn = document.getElementById('confirmContinueListingButtonContinue');
            if (!modal || !newBtn || !seeDraftsBtn || !cancelBtn || !continueBtn) {
                resolve('cancel');
                return;
            }
            modal.style.display = 'flex';
            const cleanup = ()=>{
                newBtn.removeEventListener('click', handleNew);
                seeDraftsBtn.removeEventListener('click', handleSeeDrafts);
                cancelBtn.removeEventListener('click', handleCancel);
                continueBtn.removeEventListener('click', handleContinue);
                modal.style.display = 'none';
            };
            const handleNew = ()=>{
                cleanup();
                resolve('new');
            };
            const handleSeeDrafts = ()=>{
                cleanup();
                resolve('seeDrafts');
            };
            const handleCancel = ()=>{
                cleanup();
                resolve('cancel');
            };
            const handleContinue = ()=>{
                cleanup();
                resolve('continue');
            };
            newBtn.addEventListener('click', handleNew);
            seeDraftsBtn.addEventListener('click', handleSeeDrafts);
            cancelBtn.addEventListener('click', handleCancel);
            continueBtn.addEventListener('click', handleContinue);
        });
    }
    _confirmSelectListingCategoryCreateLiting() {
        return new Promise((resolve)=>{
            const modal = document.getElementById('selectListingCategoryCreateLiting');
            const btnOk = document.getElementById('selectListingCategoryCreateLitingOk');
            if (!modal || !btnOk) {
                resolve('cancel');
                return;
            }
            modal.style.display = 'flex';
            const cleanup = ()=>{
                btnOk.removeEventListener('click', handleOk);
                modal.style.display = 'none';
            };
            const handleOk = ()=>{
                cleanup();
                resolve('Ok');
            };
            btnOk.addEventListener('click', handleOk);
        });
    }
    async _cancelCreateListing(noDraft = false, tab = 'listing-drafts') {
        let hasChanges = false;
        hasChanges = this.#hasChanges;
        console.log(this.#hasChanges);
        if (JSON.stringify($4f930c604957bd07$var$listingDataEmpty) !== JSON.stringify($4f930c604957bd07$var$listingData)) hasChanges = true;
        if (!hasChanges) {
            const con = document.getElementById(`SearchStartUpComponentAllCon`);
            con.remove();
            return;
        }
        if (this.#isInEdit) {
            const con = document.getElementById(`SearchStartUpComponentAllCon`);
            con.remove();
            return;
        }
        if (noDraft) // const con = document.getElementById(
        //   `SearchStartUpComponentAllCon`
        // );
        // con.remove();
        return;
        const action = await this._confirmLeaveListing();
        const modal = document.getElementById('confirmLeaveListingConMain');
        if (action === 'save') {
            modal.style.display = 'none';
            const dataStored = await this._saveDraft();
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._init('Activity');
            (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init(tab);
            console.log(dataStored);
            modal.style.display = 'none';
            const con = document.getElementById(`SearchStartUpComponentAllCon`);
            con.remove();
        }
        if (action === 'leave') {
            modal.style.display = 'none';
            const con = document.getElementById(`SearchStartUpComponentAllCon`);
            con.remove();
        }
        if (action === 'cancel') modal.style.display = 'none';
    }
    async _handleSelectPublishProfile(selected) {
        this.#finalPublishListingButtonActivated = false;
        console.log(this.#isInEdit);
        function setObjectToLocalStorage(key, value) {
            try {
                localStorage.setItem(key, JSON.stringify(value));
            } catch (err) {
                console.error('Error saving to localStorage:', err);
            }
        }
        function getObjectFromLocalStorage(key) {
            try {
                const item = localStorage.getItem(key);
                return item ? JSON.parse(item) : null;
            } catch (err) {
                console.error('Error reading from localStorage:', err);
                return null;
            }
        }
        try {
            let publishIn = getObjectFromLocalStorage('lastPublishProfile');
            // Check the listing form validity
            const isValid = this._checkForm();
            // const isValid = true
            if (!isValid) throw new Error("Completa todos los campos requeridos antes de continuar.");
            // Select DOM elements
            const SelectPublishProfileCon1ButtonBack = document.getElementById("CreateListingBtnBack");
            const SelectPublishProfileCon1ButtonPublish = document.getElementById("CreateListingBtnPublishNow");
            const SelectPublishProfileCon1 = document.getElementById("SelectPublishProfileCon1");
            const loadProfilesToPublishIn = async ()=>{
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Cargando perfiles para publicar...');
                console.log("Loading profiles to publish in...");
                const SelectPublishProfileConProfile = document.getElementById("SelectPublishProfileConProfile");
                const SelectPublishProfileConBusinesses = document.getElementById("SelectPublishProfileConBusinesses");
                SelectPublishProfileConProfile.innerHTML = '';
                SelectPublishProfileConBusinesses.innerHTML = '';
                const userData = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
                if (!userData) throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.");
                let activeOnProfile = false;
                if (publishIn?.type === 'profile') activeOnProfile = true;
                let imageForSellerProfileUse = '';
                if (userData?.profileImages?.[0]?.res_200) imageForSellerProfileUse = userData?.profileImages?.[0]?.res_200;
                else imageForSellerProfileUse = userData.profileImageUrl;
                console.log(userData);
                const profile = (0, $ac56fd6b84e2bb3e$export$2e2bcd8739ae039)._returProfileHTML({
                    act: activeOnProfile,
                    type: 'profile',
                    name: userData.userName,
                    description: 'Vendedor',
                    photoURL: imageForSellerProfileUse,
                    id: userData.userId,
                    role: 'Usuario'
                }, userData);
                console.log('profile here', profile);
                SelectPublishProfileConProfile.insertAdjacentHTML("beforeend", profile);
                console.log('profile here');
                // if (0 > 0) {
                if (userData?.businesses?.length > 0) for (const business of userData.businesses){
                    const loadedBusinessData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getAnyDocById(`businesses/${business.id}`);
                    if (!loadedBusinessData) throw new Error("No hemos podido cargar tu negocio en este momento. Intenta de nuevo mas tarde.");
                    let image = '';
                    let role = '';
                    if (business.role === 'admin') role = 'Admin';
                    if (business.role === 'owner') role = 'Propio';
                    if (business.role === 'manager') role = 'Gerente';
                    console.log('loadedBusinessData', loadedBusinessData);
                    if (!loadedBusinessData?.images?.profile[0]?.res_200) image = loadedBusinessData.profileImg;
                    else image = loadedBusinessData.images?.profile[0]?.res_200;
                    let activeOnBusiness = false;
                    if (publishIn?.businessId === loadedBusinessData.businessId) activeOnBusiness = true;
                    const businessHtml = (0, $ac56fd6b84e2bb3e$export$2e2bcd8739ae039)._returProfileHTML({
                        act: activeOnBusiness,
                        type: 'business',
                        name: loadedBusinessData.name,
                        description: loadedBusinessData.shortDescription,
                        photoURL: image,
                        id: loadedBusinessData.businessId,
                        role: role,
                        businessId: loadedBusinessData.businessId
                    }, userData);
                    SelectPublishProfileConBusinesses.insertAdjacentHTML("beforeend", businessHtml);
                    (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                }
                else {
                    const noBusinessHtml = (0, $ac56fd6b84e2bb3e$export$2e2bcd8739ae039)._returNoProfileHTML();
                    SelectPublishProfileConBusinesses.insertAdjacentHTML("beforeend", noBusinessHtml);
                }
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            };
            const handleSelectPublishProfile = ()=>{
                const profiles = document.querySelectorAll("#SelectPublishProfileConProfile .nvSelectPublishProfileProfileCon1, #SelectPublishProfileConBusinesses .nvSelectPublishProfileProfileCon1");
                console.log('profiles', profiles);
                profiles.forEach((profile)=>{
                    console.log('profile here');
                    profile.addEventListener('click', ()=>{
                        console.log('profile here');
                        // remove active from all
                        profiles.forEach((p)=>p.classList.remove('nvSelectPublishProfileProfileCon1Act'));
                        console.log('profile here');
                        // activate clicked one
                        profile.classList.add('nvSelectPublishProfileProfileCon1Act');
                        const publishData = {
                            type: profile.dataset.type,
                            sellerId: profile.dataset.sellerid,
                            businessId: profile.dataset.businessid
                        };
                        publishIn = publishData;
                        console.log('publishIn', publishIn);
                        setObjectToLocalStorage('lastPublishProfile', publishData);
                    });
                });
            };
            // await loadProfilesToPublishIn()
            // handleSelectPublishProfile();
            if (!this.#isInEdit) {
                SelectPublishProfileCon1.style.display = "flex";
                await loadProfilesToPublishIn();
                handleSelectPublishProfile();
            } else {
                let publishInSend = {
                    type: 'profile',
                    sellerId: $4f930c604957bd07$var$listingData?.sellerId || '',
                    businessId: $4f930c604957bd07$var$listingData?.businessId || ''
                };
                if ($4f930c604957bd07$var$listingData?.businessId) publishInSend = {
                    type: 'business',
                    sellerId: $4f930c604957bd07$var$listingData?.sellerId || '',
                    businessId: $4f930c604957bd07$var$listingData?.businessId || ''
                };
                await this._publishNow(publishInSend);
                (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._actionsOnListingInEditElement('edit', publishInSend.sellerId, publishInSend.businessId, this.#listingId);
            }
            // Event listener for the "Back" button
            SelectPublishProfileCon1ButtonBack.addEventListener("click", ()=>{
                SelectPublishProfileCon1.style.display = "none";
            });
            // Event listener for the "Publish" button
            if (this.#finalPublishListingButtonActivated) return;
            this.#finalPublishListingButtonActivated = true;
            SelectPublishProfileCon1ButtonPublish.addEventListener("click", ()=>{
                const diference = Date.now() - this.#publishNowButtonFinalClickedAt;
                if (diference < 2000) return;
                this.#publishNowButtonFinalClickedAt = Date.now();
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Publicando listado...');
                console.log(publishIn);
                if (!publishIn) throw new Error("Selecciona un perfil para publicar el listado.");
                if (!publishIn.type) throw new Error("En este momento hay un error al intentar publicar en este perfile. Favor intenta con otro perfil.");
                if (!publishIn.sellerId && !publishIn.businessId) throw new Error("En este momento hay un error al intentar publicar en este perfile. Favor intenta con otro perfil.");
                this._publishNow(publishIn);
            });
        } catch (error) {
            // console.error(error.message);
            alert(error.message);
        } finally{
            const CreateListingBtnCreateBusiness = document.getElementById('CreateListingBtnCreateBusiness');
            const SelectPublishProfileCon1 = document.getElementById("SelectPublishProfileCon1");
            if (CreateListingBtnCreateBusiness) CreateListingBtnCreateBusiness.addEventListener('click', ()=>{
                SelectPublishProfileCon1.style.display = "none";
                this._cancelCreateListing(false, 'businesses');
            });
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _publishNow(publishIn) {
        this.#isStillUploadingImages = true;
        console.log('publishing now in', publishIn);
        console.log('publishing now data', $4f930c604957bd07$var$listingData);
        if (publishIn?.type !== 'profile' && $4f930c604957bd07$var$listingData?.listingMachineType?.length < 1) {
            const resultOk = await this._confirmSelectListingCategoryCreateLiting();
            console.log(resultOk);
            // Logic of going back, opening advanced options, and scrolling to categories
            if (resultOk === 'Ok') {
                // User confirmed, proceed with the action
                const SelectPublishProfileCon1 = document.getElementById("SelectPublishProfileCon1");
                SelectPublishProfileCon1.style.display = "none";
                const CreateListingMoreOptionsButton = document.getElementById('CreateListingMoreOptionsButton');
                CreateListingMoreOptionsButton.click();
                const CreateListingSelectCategory = document.getElementById('CreateListingSelectCategory');
                CreateListingSelectCategory.classList.add('CreateListingSelectCategoryRedBorder');
                CreateListingSelectCategory?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                return;
            } else // User canceled, handle accordingly
            return;
        }
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        try {
            let adminImgPath = `public/accounts/${publishIn.sellerId}/listings`;
            if (publishIn.type === 'business') adminImgPath = `public/businesses/${publishIn.businessId}/listings`;
            // Testing live upload in drafts.
            const dataStored = await this._saveDraft(null, 'uploading');
            console.log(dataStored);
            // this._cancelCreateListing(true);
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._init('Activity');
            (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init('listing-drafts');
            setTimeout(async ()=>{
                // Spinner._displaySpinner("Subiendo imágenes");
                this.#isStillUploadingImages = true;
                const imgs = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._uploadImagesAndGetReferences("uploaded-images-container", `${dataStored.prefixId}imageProgressDisplay`, null, 'public/tempUploads/');
                this.#isStillUploadingImages = false;
                // listingData.listingMainImg = imgs[0];
                $4f930c604957bd07$var$listingData.listingImgsIds = imgs;
                console.log($4f930c604957bd07$var$listingData);
                console.log(imgs);
                // Spinner._hideSpinner()
                // return
                // Spinner._displaySpinner("Creando listado");
                let metaData = {
                    publishIn: publishIn,
                    isInEdit: this.#isInEdit,
                    id: this.#listingId,
                    createdAt: this.#listingCreatedAt,
                    updatedAt: this.#listingUpdatedAt,
                    newType: this.#newType,
                    newPlace: this.#newPlace,
                    adminImgPath: adminImgPath,
                    status: (0, $5e2d2197cd245583$export$2e2bcd8739ae039)._getAppUploadStatus()
                };
                let dataToSend = {
                    listingData: $4f930c604957bd07$var$listingData,
                    metaData: metaData
                };
                console.log(dataToSend);
                // return
                const resultUploadListing = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NvUploadNewListing(dataToSend);
                console.log(resultUploadListing);
                if (resultUploadListing.data.success) {
                    // console.log("Listing uploaded successfully. Should open listing now, and trigger CTA share.");
                    // let lives = 'seller'
                    // let from = 'seller'
                    // if (publishIn.type !== 'profile') {
                    //   lives = 'business'
                    // }
                    // Spinner._displaySpinner("Abriendo listado");
                    // let useId = publishIn?.businessId || publishIn?.sellerId || ''
                    // await allHandeling._displayTheRightWay(useId, resultUploadListing.data.listingId, lives, 'publish', false, "aspectRatio_9-6", true)
                    // this._cancelCreateListing();
                    this._deleteDraft(dataStored.prefixId);
                    const con = document.getElementById(`${dataStored.prefixId}actiListingDraftCon1A`);
                    if (con) con.remove();
                } else alert(`Hubo un error al subir este listado. Error: ${resultUploadListing.data.message}`);
            }, 200);
            this.#isStillUploadingImages = false;
        } catch (error) {
            //error log should be removed for production
            console.error("Image upload failed:", error.message);
            alert(error.message);
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    _setVideoStatus(status) {
        console.log(status);
        const CreateListingVideoURL = document.getElementById('CreateListingVideoURL');
        if (status) {
            $4f930c604957bd07$var$listingData.videoUrl = CreateListingVideoURL.value.trim();
            const CreateListingImagesCon5C1 = document.getElementById('CreateListingImagesCon5C1');
            CreateListingImagesCon5C1.style.display = 'flex';
        } else $4f930c604957bd07$var$listingData.videoUrl = '';
    }
    _events(prefixId) {
        if (this.#eventsInitialized) return;
        this.#eventsInitialized = true;
        window.addEventListener("click", (e)=>{
            const isVideoSectionOpenButton = e.target.closest(`#upload-trigger-video`);
            const isVideoDeleteButton = e.target.closest(`#CreateListingVideoURLDeleteVideoButton`);
            if (isVideoSectionOpenButton) this._vidInputShowToggler(true);
            if (isVideoDeleteButton) {
                const video = e.target.closest(`.nvV1CreateListignPreviewVidCon2`);
                if (video) {
                    $4f930c604957bd07$var$listingData.videoUrl = '';
                    video.remove();
                    const CreateListingVideoURL = document.getElementById('CreateListingVideoURL');
                    CreateListingVideoURL.value = '';
                    const CreateListingImagesCon5C1 = document.getElementById('CreateListingImagesCon5C1');
                    CreateListingImagesCon5C1.style.display = 'none';
                }
            }
        });
        const CreateListingBtnPublish = document.getElementById("CreateListingBtnPublish");
        const CreateListingBtnPublishP = CreateListingBtnPublish.querySelector('p');
        const CreateListingBtnCancel = document.getElementById("CreateListingBtnCancel");
        const CreateListingSelectCategory = document.getElementById(`CreateListingSelectCategory`);
        const CreateListingSelectBrand = document.getElementById(`CreateListingSelectBrand`);
        const CreateListingSelectModel = document.getElementById(`CreateListingSelectModel`);
        const CreateListingSelectYear = document.getElementById(`CreateListingSelectYear`);
        const CreateListingSelectCondition = document.getElementById(`CreateListingSelectCondition`);
        const CreateListingName = document.getElementById(`CreateListingName`);
        const CreateListingVideoURL = document.getElementById(`CreateListingVideoURL`);
        const CreateListingPrice = document.getElementById(`CreateListingPrice`);
        const CreateListingItemsAvailable = document.getElementById(`CreateListingItemsAvailable`);
        const CreateListingDiscountPercent = document.getElementById(`CreateListingDiscountPercent`);
        const CreateListingDiscountAmount = document.getElementById(`CreateListingDiscountAmount`);
        const CreateListingDiscountFinalPrice = document.getElementById(`CreateListingDiscountFinalPrice`);
        const CreateLisitngDescription = document.getElementById(`CreateListingDescription`);
        const CreateListingAdminNotes = document.getElementById(`CreateListingAdminNotes`);
        const CreateListingVideoURLPasteFromClipBoardButton = document.getElementById(`CreateListingVideoURLPasteFromClipBoardButton`);
        const CreateListingVideoURLPreviewVideoButton = document.getElementById(`CreateListingVideoURLPreviewVideoButton`);
        const CreateListingVideoURLCloseVideoButton = document.getElementById(`CreateListingVideoURLCloseVideoButton`);
        const nvCreateNewListingButtonOpenLocationSelector = document.getElementById(`nvCreateNewListingButtonOpenLocationSelector`);
        const CreateListingLocationUseMyLocationButton = document.getElementById(`CreateListingLocationUseMyLocationButton`);
        nvCreateNewListingButtonOpenLocationSelector.addEventListener('click', async (e)=>{
            try {
                e.target.closest(".CreateListingCon2").querySelector(".CreateListingErrorMessage").textContent = "";
                const locationData = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._locationPicker($4f930c604957bd07$var$listingData.place);
                const locationTag = document.getElementById('nvCreateNewListingButtonOpenLocationSelectorLocationTag');
                locationTag.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getDisplayLocationName(locationData);
                $4f930c604957bd07$var$listingData.place.lat = locationData.lat;
                $4f930c604957bd07$var$listingData.place.lng = locationData.lng;
                $4f930c604957bd07$var$listingData.place.state = locationData.state;
                $4f930c604957bd07$var$listingData.place.country = locationData.country;
                $4f930c604957bd07$var$listingData.place.city = locationData.city;
                $4f930c604957bd07$var$listingData.place.locationUrl = locationData.locationUrl;
                $4f930c604957bd07$var$listingData.place.name = locationData.name;
                $4f930c604957bd07$var$listingData.place.address = locationData.address;
                $4f930c604957bd07$var$listingData.filterLat = locationData.lat;
                $4f930c604957bd07$var$listingData.filterLng = locationData.lng;
                $4f930c604957bd07$var$listingData.filterState = locationData.state;
                $4f930c604957bd07$var$listingData.filterCountry = locationData.country;
                $4f930c604957bd07$var$listingData.filterCity = locationData.city;
                $4f930c604957bd07$var$listingData.filterGeoHash = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._geoHash(locationData.lat, locationData.lng);
                this.#newPlace = true;
                console.log('LocationData', locationData, 'listingData', $4f930c604957bd07$var$listingData);
            } catch (error) {
                console.log(error);
                if (error === 'cancelled') {
                    if ($4f930c604957bd07$var$listingData?.filterLng) {
                        console.log('here A');
                        console.log($4f930c604957bd07$var$listingData);
                        if ($4f930c604957bd07$var$listingData?.filterLng?.length < 1) {
                            console.log('here A');
                            e.target.closest(".CreateListingCon2").querySelector(".CreateListingErrorMessage").textContent = "La ubicaci\xf3n es obligatoria. Por favor selecciona la ubicaci\xf3n.";
                        }
                    } else {
                        console.log('here A');
                        console.log($4f930c604957bd07$var$listingData);
                        e.target.closest(".CreateListingCon2").querySelector(".CreateListingErrorMessage").textContent = "La ubicaci\xf3n es obligatoria. Por favor selecciona la ubicaci\xf3n.";
                    }
                }
            }
        });
        CreateListingLocationUseMyLocationButton.addEventListener('click', async (e)=>{
            try {
                e.target.closest(".CreateListingCon2").querySelector(".CreateListingErrorMessage").textContent = "";
                const locationTag = document.getElementById('nvCreateNewListingButtonOpenLocationSelectorLocationTag');
                locationTag.textContent = 'Cargando...';
                const locationData = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getCurrentLocation();
                locationTag.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getDisplayLocationName(locationData);
                $4f930c604957bd07$var$listingData.place.lat = locationData.lat;
                $4f930c604957bd07$var$listingData.place.lng = locationData.lng;
                $4f930c604957bd07$var$listingData.place.state = locationData.state;
                $4f930c604957bd07$var$listingData.place.country = locationData.country;
                $4f930c604957bd07$var$listingData.place.city = locationData.city;
                $4f930c604957bd07$var$listingData.place.locationUrl = locationData.locationUrl;
                $4f930c604957bd07$var$listingData.place.name = locationData.name;
                $4f930c604957bd07$var$listingData.place.address = locationData.address;
                $4f930c604957bd07$var$listingData.filterLat = locationData.lat;
                $4f930c604957bd07$var$listingData.filterLng = locationData.lng;
                $4f930c604957bd07$var$listingData.filterState = locationData.state;
                $4f930c604957bd07$var$listingData.filterCountry = locationData.country;
                $4f930c604957bd07$var$listingData.filterCity = locationData.city;
                $4f930c604957bd07$var$listingData.filterGeoHash = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._geoHash(locationData.lat, locationData.lng);
                this.#newPlace = true;
                console.log('LocationData', locationData, 'listingData', $4f930c604957bd07$var$listingData);
            } catch (error) {
                console.log(error);
                if (error === 'cancelled') {
                    if ($4f930c604957bd07$var$listingData?.filterLng) {
                        console.log('here A');
                        console.log($4f930c604957bd07$var$listingData);
                        if ($4f930c604957bd07$var$listingData?.filterLng?.length < 1) {
                            console.log('here A');
                            e.target.closest(".CreateListingCon2").querySelector(".CreateListingErrorMessage").textContent = "La ubicaci\xf3n es obligatoria. Por favor selecciona la ubicaci\xf3n.";
                        }
                    } else {
                        console.log('here A');
                        console.log($4f930c604957bd07$var$listingData);
                        e.target.closest(".CreateListingCon2").querySelector(".CreateListingErrorMessage").textContent = "La ubicaci\xf3n es obligatoria. Por favor selecciona la ubicaci\xf3n.";
                    }
                }
            }
        });
        CreateListingVideoURLPreviewVideoButton.addEventListener('click', ()=>{
            const CreateListingVideoURL = document.getElementById('CreateListingVideoURL');
            CreateListingVideoURL.focus();
            CreateListingVideoURL.blur();
        });
        CreateListingVideoURLCloseVideoButton.addEventListener('click', ()=>{
            this._vidInputShowToggler(false);
        });
        CreateListingVideoURLPasteFromClipBoardButton.addEventListener('click', ()=>{
            this._pasteClipboardToInput('CreateListingVideoURL');
        });
        const SearchStartUpComponentAllCon = document.getElementById(`SearchStartUpComponentAllCon`);
        const pickerActivate = (id, picker, preset)=>{
            let currentPicked = preset;
            const CreateListingMarkItemAsCon = document.getElementById(id);
            const markedCons = CreateListingMarkItemAsCon.querySelectorAll(".CreateListingOptionsPicCon3");
            const errorMessage = document.getElementById(`CreateListingErrorMessageCoin`);
            const setPicked = (setTo)=>{
                markedCons.forEach((con)=>{
                    if (con.dataset.picked === setTo) con.classList.add("CreateListingOptionsPicCon3Active");
                    else con.classList.remove("CreateListingOptionsPicCon3Active");
                });
                if (picker === "markItemAs") $4f930c604957bd07$var$listingData.listingMarkedAs = setTo;
                if (picker === "markPriceAs") {
                    $4f930c604957bd07$var$listingData.listingPriceMarkedAs = setTo;
                    const priceCon = document.getElementById(`CreateListingPrice`);
                    const coinCon = document.getElementById(`CreateListingCoin`);
                    const discountCon = document.getElementById(`CreateListingDiscount`);
                    if (setTo === "preguntar") {
                        priceCon.style.opacity = ".3";
                        coinCon.style.opacity = ".3";
                        discountCon.style.opacity = ".3";
                    } else {
                        priceCon.style.opacity = "1";
                        coinCon.style.opacity = "1";
                        discountCon.style.opacity = "1";
                    }
                }
                if (picker === "priceCoin") {
                    $4f930c604957bd07$var$listingData.listingCoin = setTo;
                    CreateListingPrice.closest(".CreateListingOptionsInputCon2").querySelector(".CreateListingErrorMessage").textContent = "";
                }
            };
            setPicked(preset);
            CreateListingMarkItemAsCon.addEventListener("click", (e)=>{
                const closestMarked = e.target.closest(".CreateListingOptionsPicCon3");
                if (!closestMarked) return;
                if (errorMessage) errorMessage.textContent = "";
                const markedClicked = closestMarked.dataset.picked;
                if (currentPicked === markedClicked) {
                    markedCons.forEach((con)=>{
                        con.classList.remove("CreateListingOptionsPicCon3Active");
                    });
                    setPicked("");
                    currentPicked = "";
                    if (picker === "markItemAs") $4f930c604957bd07$var$listingData.listingMarkedAs = "";
                    if (picker === "markPriceAs") $4f930c604957bd07$var$listingData.listingPriceMarkedAs = "";
                    if (picker === "priceCoin") $4f930c604957bd07$var$listingData.listingCoin = "";
                    return;
                }
                setPicked(markedClicked);
                currentPicked = markedClicked;
            });
        };
        pickerActivate("CreateListingCoinPic", "priceCoin", $4f930c604957bd07$var$listingData.listingCoin);
        pickerActivate("CreateListingPicMarkPrice", "markPriceAs", $4f930c604957bd07$var$listingData.listingPriceMarkedAs);
        pickerActivate("CreateListingMarkItemAsCon", "markItemAs", $4f930c604957bd07$var$listingData.listingMarkedAs);
        console.log('listingData.listingMarkedAs', $4f930c604957bd07$var$listingData.listingMarkedAs);
        // this._imageHandle(listingData.listingImgsIds);
        // TODO find out why the button do not work after reload.
        if (this.#isInEdit) CreateListingBtnPublishP.textContent = "Actualizar Listado";
        else CreateListingBtnPublishP.textContent = "Publicar Gratis";
        CreateListingBtnPublish.addEventListener("click", async ()=>{
            // GENRALHELPERS._stopTimer('createListingInit')
            console.log($4f930c604957bd07$var$listingData);
            console.log('here');
            this._handleSelectPublishProfile();
        // this._handleListingPublish();
        });
        CreateListingBtnCancel.addEventListener("click", ()=>{
            this._cancelCreateListing();
        });
        CreateListingSelectCategory.addEventListener('click', ()=>{
            CreateListingSelectCategory.closest(".nvCreateNewListingCustomSelectCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        CreateListingSelectBrand.addEventListener('click', ()=>{
            CreateListingSelectBrand.closest(".nvCreateNewListingCustomSelectCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        CreateListingSelectModel.addEventListener('click', ()=>{
            CreateListingSelectModel.closest(".nvCreateNewListingCustomSelectCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        CreateListingSelectYear.addEventListener('click', ()=>{
            CreateListingSelectYear.closest(".nvCreateNewListingCustomSelectCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        CreateListingSelectCondition.addEventListener('click', ()=>{
            CreateListingSelectCondition.closest(".nvCreateNewListingCustomSelectCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        CreateListingName.addEventListener("keyup", (e)=>{
            const targetValue = e.target.value.trim();
            $4f930c604957bd07$var$listingData.listingName = targetValue;
            CreateListingName.closest(".CreateListingNameCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        CreateListingVideoURL.addEventListener("blur", async (e)=>{
            const nvV1CreateListignPreviewVidCon1 = document.getElementById('nvV1CreateListignPreviewVidCon1');
            const targetValue = e.target.value.trim();
            const videoInCreateListing = document.getElementById("videoInCreateListing");
            if (videoInCreateListing) videoInCreateListing.remove();
            const videoHTML = (0, $ac56fd6b84e2bb3e$export$2e2bcd8739ae039)._returnVideoPreviewHTML(targetValue);
            if (videoHTML === "ERROR" || !videoHTML) {
                this.#isValidVideo = false;
                $4f930c604957bd07$var$listingData.videoUrl = "";
            } else {
                nvV1CreateListignPreviewVidCon1.innerHTML = "";
                nvV1CreateListignPreviewVidCon1.insertAdjacentHTML("afterbegin", videoHTML);
                const el = document.querySelector(".nvV1CreateListignPreviewVidCon4");
                if (!el) return;
                if (el.tagName === "VIDEO") {
                    el.addEventListener("loadedmetadata", ()=>{
                        console.log("video loaded");
                        this._setVideoStatus(true);
                    });
                    el.addEventListener("error", ()=>{
                        console.log("video failed");
                        this._setVideoStatus(false);
                    });
                }
                if (el.tagName === "IFRAME") el.addEventListener("load", ()=>{
                    console.log("iframe loaded");
                    this._setVideoStatus(true);
                });
                (0, $b03a20a2d7a048cf$export$2e2bcd8739ae039)._videoHandler();
            }
        });
        CreateListingPrice.addEventListener("keyup", (e)=>{
            const targetValue = e.target.value;
            // Remove any non-numeric characters except periods
            const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
            // Format the number with thousands separators
            const formattedPrice = formatToPriceWithThousands(extractedNumbers);
            // Update the input value with the formatted price
            e.target.value = formattedPrice;
            $4f930c604957bd07$var$listingData.listingPrice = formattedPrice.replace(/,/g, "");
            CreateListingPrice.closest(".CreateListingOptionsInputCon2").querySelector(".CreateListingErrorMessage").textContent = "";
            discountTakeCare("percent");
        });
        CreateListingItemsAvailable.addEventListener("keyup", (e)=>{
            const targetValue = e.target.value;
            // Remove any non-numeric characters except periods
            const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
            // Format the number with thousands separators
            const formattedPrice = formatToPriceWithThousands(extractedNumbers);
            // Update the input value with the formatted price
            e.target.value = formattedPrice;
            $4f930c604957bd07$var$listingData.listingItemsAvailable = Number(formattedPrice.replace(/,/g, ""));
            CreateListingItemsAvailable.closest(".CreateListingOptionsInputCon2").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        function formatToPriceWithThousands(value) {
            if (!value) return ""; // Handle empty input gracefully
            // Ensure there are no multiple decimals and format to two decimal places
            const parts = value.split(".");
            const integerPart = parts[0].replace(/^0+/, ""); // Remove leading zeros
            const decimalPart = parts[1] ? parts[1].slice(0, 2) : "";
            // Add thousands separators to the integer part
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
        }
        const discountTakeCare = (calculateOn)=>{
            const price = parseInt(CreateListingPrice.value.trim().replace(/,/g, "") // ✅ Removes commas
            ) || 0;
            const discountPercent = parseInt(CreateListingDiscountPercent.value.trim().replace(/,/g, "")) || 0;
            const discountAmount = parseInt(CreateListingDiscountAmount.value.trim().replace(/,/g, "")) || 0;
            const finalPrice = parseInt(CreateListingDiscountFinalPrice.value.trim().replace(/,/g, "")) || 0;
            let calcdiscountPercent = discountPercent;
            let calcdiscountAmount = discountAmount;
            let calcfinalPrice = finalPrice;
            if (calculateOn === "percent") {
                const ad = parseFloat(price * (discountPercent / 100)).toFixed(2);
                calcdiscountAmount = ad;
                calcfinalPrice = parseFloat(price - ad).toFixed(2);
                CreateListingDiscountAmount.value = formatToPriceWithThousands(calcdiscountAmount);
                CreateListingDiscountFinalPrice.value = formatToPriceWithThousands(calcfinalPrice);
            }
            if (calculateOn === "amount") {
                const pd = price !== 0 ? parseFloat(discountAmount / price * 100).toFixed(2) : 0;
                calcfinalPrice = parseFloat(price - discountAmount).toFixed(2);
                calcdiscountPercent = pd;
                CreateListingDiscountPercent.value = formatToPriceWithThousands(calcdiscountPercent);
                CreateListingDiscountFinalPrice.value = formatToPriceWithThousands(calcfinalPrice);
            }
            if (calculateOn === "final") {
                const ad = parseFloat(price - finalPrice).toFixed(2);
                calcdiscountAmount = ad;
                const pd = price !== 0 ? parseFloat(ad / price * 100).toFixed(2) : 0;
                calcdiscountPercent = pd;
                CreateListingDiscountPercent.value = formatToPriceWithThousands(calcdiscountPercent);
                CreateListingDiscountAmount.value = formatToPriceWithThousands(calcdiscountAmount);
            }
            $4f930c604957bd07$var$listingData.onDiscount.finalPrice = parseInt(calcfinalPrice);
            $4f930c604957bd07$var$listingData.onDiscount.percent = calcdiscountPercent;
            $4f930c604957bd07$var$listingData.onDiscount.amount = parseInt(calcdiscountAmount);
            console.log($4f930c604957bd07$var$listingData);
        };
        const discountEvents = ()=>{
            CreateListingDiscountPercent.addEventListener("keyup", (e)=>{
                const targetValue = e.target.value;
                const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
                e.target.value = extractedNumbers;
                discountTakeCare("percent");
            });
            CreateListingDiscountAmount.addEventListener("keyup", (e)=>{
                const targetValue = e.target.value;
                const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
                const formattedPrice = formatToPriceWithThousands(extractedNumbers);
                e.target.value = formattedPrice;
                discountTakeCare("amount");
            });
            CreateListingDiscountFinalPrice.addEventListener("keyup", (e)=>{
                const targetValue = e.target.value;
                const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
                const formattedPrice = formatToPriceWithThousands(extractedNumbers);
                e.target.value = formattedPrice;
                discountTakeCare("final");
            });
        };
        discountEvents();
        CreateLisitngDescription.addEventListener("keyup", (e)=>{
            const targetValue = e.target.value.trim();
            $4f930c604957bd07$var$listingData.listingDescription = targetValue;
            CreateLisitngDescription.closest(".CreateListingDescriptionCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
        CreateListingAdminNotes.addEventListener("keyup", (e)=>{
            const targetValue = e.target.value.trim();
            $4f930c604957bd07$var$listingData.adminNotes = targetValue;
            CreateListingAdminNotes.closest(".CreateListingDescriptionCon1").querySelector(".CreateListingErrorMessage").textContent = "";
        });
    }
    async _handleListingPublish() {
        this._handleSelectPublishProfile();
    }
    _checkForm() {
        console.log('here');
        let validForm = true;
        const imagesPresent = this._hasImagesInContainer("uploaded-images-container");
        if (!imagesPresent) {
            const images = document.getElementById("CreateListingErrorMessageImages");
            images.textContent = "Agrega unos im\xe1genes a este listado. Puedes agregar hasta 6 im\xe1genes.";
            validForm = false;
        }
        if ($4f930c604957bd07$var$listingData.listingName === "") {
            const name = document.getElementById("CreateListingErrorMessageName");
            name.textContent = "El titulo no puede estar vac\xedo";
            validForm = false;
        } else if ($4f930c604957bd07$var$listingData.listingName.length < 8) {
            const name = document.getElementById("CreateListingErrorMessageName");
            name.textContent = "El titulo tiene que ser al menos 8 car\xe1cteres";
            validForm = false;
        }
        if ($4f930c604957bd07$var$listingData?.place?.lat < 1) {
            const location = document.getElementById("CreateListingErrorMessageLocation");
            location.textContent = "La ubicaci\xf3n es obligatorio";
            validForm = false;
        }
        if ($4f930c604957bd07$var$listingData.listingPrice === "" && $4f930c604957bd07$var$listingData.listingPriceMarkedAs !== "preguntar") {
            const price = document.getElementById("CreateListingErrorMessagePrice");
            price.textContent = "Ponle un precio a este listado";
            validForm = false;
        }
        if ($4f930c604957bd07$var$listingData.listingCoin === "" && $4f930c604957bd07$var$listingData.listingPriceMarkedAs !== "preguntar") {
            const price = document.getElementById("CreateListingErrorMessagePrice");
            price.textContent = "Selecciona la moneda del precio";
            validForm = false;
        }
        // START Optional.
        // if (listingData.listingMachineType === "") {
        //   const machine = document.getElementById(
        //     "CreateListingErrorMessageSelectMachine"
        //   );
        //   machine.textContent = "Seleciona la categoría";
        //   validForm = false
        // }
        // if (listingData.listingBrand === "") {
        //   const brand = document.getElementById(
        //     "CreateListingErrorMessageSelectBrand"
        //   );
        //   brand.textContent = "Seleciona una marca";
        //   validForm = false
        // }
        // if (listingData.listingModel === "") {
        //   const model = document.getElementById(
        //     "CreateListingErrorMessageSelectModel"
        //   );
        //   model.textContent = "Seleciona un modelo";
        //   validForm = false
        // }
        // if (listingData.listingYear === "") {
        //   const year = document.getElementById(
        //     "CreateListingErrorMessageSelectYear"
        //   );
        //   year.textContent = "Seleciona un año";
        //   validForm = false
        // }
        // if (listingData.listingCondition === "") {
        //   const condition = document.getElementById(
        //     "CreateListingErrorMessageSelectCondition"
        //   );
        //   condition.textContent = "Seleciona una condición";
        //   validForm = false
        // }
        // if (listingData.listingDescription === "") {
        //   const description = document.getElementById(
        //     "CreateListingErrorMessageDescription"
        //   );
        //   description.textContent = "Agrega una descripción a este listado. Con más información es mejor.";
        //   validForm = false
        // } else if (listingData.listingDescription.split(" ").length < 8) {
        //   const description = document.getElementById(
        //     "CreateListingErrorMessageDescription"
        //   );
        //   description.textContent = "La descripción tiene que tener a lo menos 8 palabras. Con más información es mejor.";
        //   validForm = false
        // }
        return validForm;
    }
    _hasImagesInContainer(containerId) {
        const imagesContainer = document.getElementById(containerId);
        // Check if the container exists and has any children
        if (!imagesContainer || imagesContainer.children.length === 0) return false;
        return true;
    }
    _vidInputShowToggler(show = false) {
        const CreateListingCon2InputForVidUrl = document.getElementById('CreateListingCon2InputForVidUrl');
        if (show) CreateListingCon2InputForVidUrl.classList.remove('CreateListingCon2Hidden');
        else CreateListingCon2InputForVidUrl.classList.add('CreateListingCon2Hidden');
    }
    // async _pasteClipboardToInput(inputId) {
    //   const input = document.getElementById(inputId);
    //   if (!input) return;
    //   try {
    //     const text = await navigator.clipboard.readText();
    //     if (!text || text.trim() === "") {
    //       alert("No hay nada en el portapapeles.");
    //       return;
    //     }
    //     input.value = text;
    //     input.focus()
    //     input.blur()
    //   } catch (err) {
    //     alert("No se pudo acceder al portapapeles.");
    //     console.error(err);
    //   }
    // }}
    async _pasteClipboardToInput(inputId) {
        const input = document.getElementById(inputId);
        if (!input) return;
        try {
            let text = '';
            // ✅ 1. Native (Android / iOS)
            if (window.Capacitor?.isNativePlatform?.()) {
                const result = await (0, $7092590103cf3cfa$export$8b44c43c7d8f0830).read();
                text = result?.value || '';
            // ✅ 2. Web
            } else if (navigator.clipboard && navigator.clipboard.readText) text = await navigator.clipboard.readText();
            else {
                alert("El portapapeles no est\xe1 disponible en este dispositivo.");
                return;
            }
            if (!text.trim()) {
                alert("No hay nada en el portapapeles.");
                return;
            }
            input.value = text;
            // trigger UI updates if needed
            input.dispatchEvent(new Event('input', {
                bubbles: true
            }));
            input.focus();
            input.blur();
        } catch (err) {
            console.error(err);
            alert("No se pudo acceder al portapapeles.");
        }
    }
    _imageHandle(imgsArr) {
        // console.log(imgsArr);
        console.warn("HandleImages is called");
        const createListingImageUploadText1 = document.getElementById("createListingImageUploadText1");
        const CreateListingImageOrganizeMessage = document.getElementById("CreateListingImageOrganizeMessage");
        const CreateListingImagesCon2 = document.getElementById("CreateListingImagesCon2");
        const uploadTrigger = document.getElementById("upload-trigger");
        const fileInput = document.getElementById("image-upload-input");
        const imagesContainer = document.getElementById("uploaded-images-container");
        const MAX_IMAGES = 6;
        fileInput.setAttribute("accept", "image/*");
        fileInput.setAttribute("multiple", "true");
        // uploadTrigger.addEventListener("click", () => {
        //   uploadTrigger
        //     .closest(".CreateListingImagesCon1")
        //     .querySelector(".CreateListingErrorMessage").textContent = "";
        //   if (imagesContainer.children.length >= MAX_IMAGES) {
        //     alert(`You can only upload up to ${MAX_IMAGES} images.`);
        //     return;
        //   }
        //   fileInput.click();
        // });
        uploadTrigger.addEventListener("click", async ()=>{
            uploadTrigger.closest(".CreateListingImagesCon1").querySelector(".CreateListingErrorMessage").textContent = "";
            if (imagesContainer.children.length >= MAX_IMAGES) {
                alert(`Solo es permitido subir ${MAX_IMAGES} imagenes.`);
                return;
            }
            // ✅ Native (Android / iOS)
            // if (window.Capacitor?.isNativePlatform?.()) {
            //   try {
            //     const image = await Camera.getPhoto({
            //       quality: 80,
            //       allowEditing: false,
            //       resultType: CameraResultType.Uri,
            //       source: CameraSource.Prompt,
            //     });
            //     if (!image?.webPath) return;
            //     // 🔥 Convert to File (THIS is the key)
            //     const response = await fetch(image.webPath);
            //     const blob = await response.blob();
            //     const file = new File([blob], `image-${Date.now()}.jpg`, {
            //       type: blob.type,
            //     });
            //     // 🔥 Reuse your existing logic EXACTLY
            //     const reader = new FileReader();
            //     reader.onload = (e) => {
            //       const imageUrl = e.target.result;
            //       const imageDiv = createImageDiv(imageUrl, file.name);
            //       imagesContainer.appendChild(imageDiv);
            //       this.#hasChanges = true;
            //     };
            //     reader.readAsDataURL(file);
            //     createListingImageUploadText1.style.display = 'none'
            //     CreateListingImageOrganizeMessage.classList.remove(
            //       "CreateListingImagesAddImagesTextHidden"
            //     );
            //     CreateListingImagesCon2.style.display = "flex";
            //   } catch (err) {
            //     if (err?.message?.includes("User cancelled")) return;
            //     console.error("Camera error:", err);
            //     alert("No se pudo abrir la cámara o galería.");
            //   }
            // } else {
            //   // ✅ Web stays EXACTLY the same
            //   fileInput.click();
            // }
            // ✅ Native (Android / iOS)
            if (window.Capacitor?.isNativePlatform?.()) try {
                const remainingSlots = MAX_IMAGES - imagesContainer.children.length;
                if (remainingSlots <= 0) {
                    alert(`Solo es permitido subir ${MAX_IMAGES} im\xe1genes.`);
                    return;
                }
                const result = await (0, $f461ddf16de51fc1$export$79f141de891a5fed).pickImages({
                    quality: 80
                });
                if (!result?.photos?.length) return;
                const photosToProcess = result.photos.slice(0, remainingSlots);
                for (const image of photosToProcess){
                    if (!image?.webPath) continue;
                    const response = await fetch(image.webPath);
                    const blob = await response.blob();
                    const file = new File([
                        blob
                    ], `image-${Date.now()}-${Math.random()}.jpg`, {
                        type: blob.type || "image/jpeg"
                    });
                    const reader = new FileReader();
                    reader.onload = (e)=>{
                        const imageUrl = e.target.result;
                        const imageDiv = createImageDiv(imageUrl, file.name);
                        imagesContainer.appendChild(imageDiv);
                        this.#hasChanges = true;
                    };
                    reader.readAsDataURL(file);
                }
                createListingImageUploadText1.style.display = 'none';
                CreateListingImageOrganizeMessage.classList.remove("CreateListingImagesAddImagesTextHidden");
                CreateListingImagesCon2.style.display = "flex";
                if (result.photos.length > remainingSlots) alert(`Solo se agregaron ${remainingSlots} im\xe1genes porque el m\xe1ximo es ${MAX_IMAGES}.`);
            } catch (err) {
                console.error("Image picker error:", err);
                if (err?.message?.includes("cancel") || err?.message?.includes("User cancelled")) return;
                alert("No se pudo abrir la galer\xeda.");
            }
            else // ✅ Web stays EXACTLY the same
            fileInput.click();
        });
        fileInput.addEventListener("change", (event)=>{
            const files = Array.from(event.target.files);
            const remainingSlots = MAX_IMAGES - imagesContainer.children.length;
            const limitedFiles = files.slice(0, remainingSlots);
            limitedFiles.forEach((file)=>{
                if (!file.type.startsWith("image/")) return;
                const reader = new FileReader();
                reader.onload = (e)=>{
                    const imageUrl = e.target.result;
                    const imageDiv = createImageDiv(imageUrl, file.name);
                    imagesContainer.appendChild(imageDiv);
                    this.#hasChanges = true;
                };
                reader.readAsDataURL(file);
            });
            if (files.length > limitedFiles.length) alert(`Seleccionastes ${files.length} imagenes, pero solo ${remainingSlots} mas pueden ser subidos.`);
            fileInput.value = "";
            createListingImageUploadText1.style.display = 'none';
            CreateListingImageOrganizeMessage.classList.remove("CreateListingImagesAddImagesTextHidden");
            CreateListingImagesCon2.style.display = "flex";
        });
        const createImageDiv = (imageUrl, fileName)=>{
            const imageHtml = `
          <div class="nvV1CreateListignImagesCon1">

            <div class="nvV1CreateListignImagesCon2">
              <img class="nvV1CreateListignImagesCon2B" height="16px" src="${(0, (/*@__PURE__*/$parcel$interopDefault($10ee18ef470898e1$exports)))}">
            </div>

            <div class="nvV1CreateListignImagesCon3">
              <div class="nvV1CreateListignImagesCon4">
                <img class="nvV1CreateListignImagesCon4Image uploadSpecific" src="${imageUrl}">
              </div>

              <div class="nvV1CreateListignImagesCon5">

                <div class="nvV1CreateListignImagesText1">${fileName}</div>

                <div class="nvV1CreateListignImagesCon6">

                  <div class="nvV1CreateListignImagesCon7 delete-btn">
                    <div class="nvV1CreateListignImagesText2">Eliminar</div>
                  </div>

                </div>

              </div>

            </div>

          </div>
        `;
            const imageDiv = document.createElement("div");
            imageDiv.classList.add("CreateListingImagesImageCon1");
            imageDiv.setAttribute("draggable", "true");
            imageDiv.innerHTML = imageHtml;
            const img = imageDiv.querySelector(".nvV1CreateListignImagesCon4");
            const deleteBtn = imageDiv.querySelector(".delete-btn");
            img.addEventListener("contextmenu", (e)=>{
                e.preventDefault();
            });
            deleteBtn.addEventListener("click", ()=>{
                imageDiv.remove();
                this.#hasChanges = true;
            });
            return imageDiv;
        };
        /* ---------------- DESKTOP DRAG ---------------- */ let draggedItem = null;
        imagesContainer.addEventListener("dragstart", (e)=>{
            const item = e.target.closest(".CreateListingImagesImageCon1");
            if (!item) return;
            draggedItem = item;
            item.classList.add("dragging");
        });
        imagesContainer.addEventListener("dragend", ()=>{
            if (draggedItem) draggedItem.classList.remove("dragging");
            draggedItem = null;
            this.#hasChanges = true;
        });
        imagesContainer.addEventListener("dragover", (e)=>{
            e.preventDefault();
            const afterElement = getDragAfterElement(imagesContainer, e.clientY);
            if (afterElement == null) imagesContainer.appendChild(draggedItem);
            else imagesContainer.insertBefore(draggedItem, afterElement);
        });
        let touchItem = null;
        let startY = 0;
        imagesContainer.addEventListener("touchstart", (e)=>{
            const item = e.target.closest(".CreateListingImagesImageCon1");
            if (!item) return;
            touchItem = item;
            startY = e.touches[0].clientY;
            item.classList.add("dragging");
        }, {
            passive: true
        });
        imagesContainer.addEventListener("touchmove", (e)=>{
            if (!touchItem) return;
            e.preventDefault(); // prevents page scroll while dragging
            const touch = e.touches[0];
            const currentY = touch.clientY;
            const afterElement = getDragAfterElement(imagesContainer, currentY);
            if (afterElement == null) imagesContainer.appendChild(touchItem);
            else imagesContainer.insertBefore(touchItem, afterElement);
        }, {
            passive: false
        });
        imagesContainer.addEventListener("touchend", ()=>{
            if (touchItem) touchItem.classList.remove("dragging");
            touchItem = null;
            this.#hasChanges = true;
        });
        /* ---------------- REORDER HELPER ---------------- */ function getDragAfterElement(container, y) {
            const draggableElements = [
                ...container.querySelectorAll(".CreateListingImagesImageCon1:not(.dragging)")
            ];
            return draggableElements.reduce((closest, child)=>{
                const box = child.getBoundingClientRect();
                const offset = y - box.top - box.height / 2;
                if (offset < 0 && offset > closest.offset) return {
                    offset: offset,
                    element: child
                };
                else return closest;
            }, {
                offset: Number.NEGATIVE_INFINITY
            }).element;
        }
        /* ---------------- LOAD EXISTING IMAGES ---------------- */ if (Array.isArray(imgsArr) && imgsArr.length) {
            const remainingSlots = MAX_IMAGES - imagesContainer.children.length;
            const limitedImages = imgsArr.slice(0, remainingSlots);
            limitedImages.forEach((img)=>{
                const imageDiv = createImageDiv(img, "foto de listado");
                imagesContainer.appendChild(imageDiv);
            });
            if (imagesContainer.children.length > 0) {
                createListingImageUploadText1.style.display = 'none';
                CreateListingImageOrganizeMessage.classList.remove("CreateListingImagesAddImagesTextHidden");
                CreateListingImagesCon2.style.display = "flex";
            }
        }
    }
    _getListingImageArr() {
        return $4f930c604957bd07$var$listingData.listingImgsIds;
    }
    _eventsForOptions(prefixId) {
        return;
    }
    // Start Inovation with new selects
    // _initiateSelectOptions = async (
    //   isMultiple,
    //   parrentId,
    //   parrentAllId,
    //   prefixId,
    //   optionsData
    // ) => {
    //   // return
    //   const options = [];
    //   if (!optionsData) {
    //     return;
    //   } else if (!optionsData.length > 0) return;
    //   optionsData.forEach((option) => {
    //     options.push({
    //       id: option.id,
    //       label: GENRALHELPERS._formatReadableString(option.id),
    //     });
    //   });
    //   let selectedValues = [];
    //   let createdOptions = []; // To track options created by the user
    //   const parentAllConEl = document.getElementById(parrentAllId);
    //   const parentConEl = document.getElementById(parrentId);
    //   const selectedOptionsDiv = parentConEl.querySelector(`#selected-options`);
    //   const searchInput = parentConEl.querySelector(`#search-input`);
    //   const optionList = parentConEl.querySelector(`#option-list`);
    //   parentConEl.classList.add("SearchStartUpComponentCon10Clear");
    //   searchInput.addEventListener("click", () => {
    //     searchInput
    //       .closest(".SearchStartUpComponentCon8")
    //       .querySelector(".CreateListingErrorMessage").textContent = "";
    //   });
    //   // Function to render the selected options
    //   const renderSelectedOptions = () => {
    //     selectedOptionsDiv.innerHTML = "";
    //     selectedValues.forEach((value) => {
    //       const option =
    //         options.find((opt) => opt.id === value) ||
    //         createdOptions.find((opt) => opt.id === value);
    //       const optionDiv = document.createElement("div");
    //       optionDiv.classList.add("selected-option");
    //       optionDiv.innerHTML = `${option.label} ${option.isCreated ? "<span class='created-tag'>(Creado)</span>" : ""
    //         } <span class="remove" data-id="${option.id}">x</span>`;
    //       selectedOptionsDiv.appendChild(optionDiv);
    //     });
    //     // Attach remove functionality to each selected option
    //     parentConEl.querySelectorAll(".remove").forEach((removeButton) => {
    //       removeButton.addEventListener("click", (e) => {
    //         const id = e.target.dataset.id;
    //         selectedValues = selectedValues.filter((value) => value !== id);
    //         let Type;
    //         if (parentConEl.id.includes("Type")) {
    //           Type = "Type";
    //           listingData.listingMachineType = "";
    //           listingData.listingBrand = "";
    //           listingData.listingModel = "";
    //         } else if (parentConEl.id.includes("Brand")) {
    //           Type = "Brand";
    //           listingData.listingBrand = "";
    //           listingData.listingModel = "";
    //         } else if (parentConEl.id.includes("Model")) {
    //           Type = "Model";
    //           listingData.listingModel = "";
    //         } else if (parentConEl.id.includes("Year")) {
    //           Type = "Year";
    //           listingData.listingYear = "";
    //         } else if (parentConEl.id.includes("Condition")) {
    //           Type = "Condition";
    //           listingData.listingCondition = "";
    //         }
    //         this._callTheRightFunction(prefixId, Type);
    //         // Log when a value is removed
    //         renderSelectedOptions();
    //         renderOptionList();
    //       });
    //     });
    //   };
    //   // Function to render the option list based on search input
    //   const renderOptionList = () => {
    //     if (parrentId.includes("Brand") && this.#machineBrandsOnCleared) {
    //       return;
    //     }
    //     if (parrentId.includes("Model") && this.#machineModelsOnCleared) {
    //       return;
    //     }
    //     const query = searchInput.value.toLowerCase();
    //     const filteredOptions = options
    //       .concat(createdOptions)
    //       .filter(
    //         (option) =>
    //           option.label.toLowerCase().includes(query) &&
    //           !selectedValues.includes(option.id)
    //       );
    //     optionList.innerHTML = ""; // Clear the current list
    //     if (filteredOptions.length > 0) {
    //       filteredOptions.forEach((option) => {
    //         const optionItem = document.createElement("div");
    //         optionItem.classList.add("option-item");
    //         optionItem.textContent = option.label;
    //         optionItem.addEventListener("click", () => {
    //           if (isMultiple) {
    //             if (!selectedValues.includes(option.id)) {
    //               selectedValues.push(option.id);
    //             }
    //           } else {
    //             selectedValues = [option.id];
    //           }
    //           let Type;
    //           console.log(option.id);
    //           if (parentConEl.id.includes("Type")) {
    //             Type = "Type";
    //             listingData.listingMachineType = option.id;
    //             listingData.listingBrand = "";
    //             listingData.listingModel = "";
    //           } else if (parentConEl.id.includes("Brand")) {
    //             Type = "Brand";
    //             listingData.listingBrand = option.id;
    //             listingData.listingModel = "";
    //           } else if (parentConEl.id.includes("Model")) {
    //             Type = "Model";
    //             listingData.listingModel = option.id;
    //           } else if (parentConEl.id.includes("Year")) {
    //             Type = "Year";
    //             listingData.listingYear = option.id;
    //           } else if (parentConEl.id.includes("Condition")) {
    //             Type = "Condition";
    //             listingData.listingCondition = option.id;
    //           }
    //           this._callTheRightFunction(prefixId, Type);
    //           renderSelectedOptions();
    //           renderOptionList();
    //           searchInput.value = "";
    //         });
    //         optionList.appendChild(optionItem);
    //       });
    //     } else if (query.trim() !== "") {
    //       const createOption = document.createElement("div");
    //       createOption.classList.add("create-option");
    //       createOption.textContent = `Crear nueva opción: "${query.trim()}"`;
    //       createOption.addEventListener("click", () => {
    //         const optionIdForHere = query
    //           .trim()
    //           .toLowerCase()
    //           .split(" ")
    //           .join("-"); // Unique ID for created options
    //         const newOption = {
    //           id: optionIdForHere,
    //           label: GENRALHELPERS._formatReadableString(query.trim()),
    //           isCreated: true,
    //         };
    //         this.#newType = true;
    //         console.log(`User created and selected: ${newOption.label}`); // Log the created and selected value
    //         let Type;
    //         if (parentConEl.id.includes("Type")) {
    //           Type = "Type";
    //           console.log(`User selected: ${optionIdForHere}`);
    //           console.log(`selected: Type`);
    //           listingData.listingMachineType = optionIdForHere;
    //           listingData.listingBrand = "";
    //           listingData.listingModel = "";
    //         } else if (parentConEl.id.includes("Brand")) {
    //           Type = "Brand";
    //           console.log(`User selected: ${optionIdForHere}`);
    //           console.log(`selected: Brand`);
    //           listingData.listingBrand = optionIdForHere;
    //           listingData.listingModel = "";
    //         } else if (parentConEl.id.includes("Model")) {
    //           Type = "Model";
    //           console.log(`User selected: ${optionIdForHere}`);
    //           console.log(`selected: model`);
    //           listingData.listingModel = optionIdForHere;
    //         } else if (parentConEl.id.includes("Year")) {
    //           Type = "Year";
    //           console.log(`User selected: ${optionIdForHere}`);
    //           console.log(`selected: year`);
    //           listingData.listingYear = optionIdForHere;
    //         } else if (parentConEl.id.includes("Condition")) {
    //           Type = "Condition";
    //           console.log(`User selected: ${optionIdForHere}`);
    //           console.log(`selected: condition`);
    //           listingData.listingCondition = optionIdForHere;
    //         }
    //         this._callTheRightFunction(prefixId, Type);
    //         createdOptions.push(newOption);
    //         if (isMultiple) {
    //           // Allow multiple selections
    //           selectedValues.push(newOption.id);
    //         } else {
    //           // Single selection: Replace the current selection
    //           selectedValues = [newOption.id];
    //         }
    //         renderSelectedOptions();
    //         renderOptionList();
    //         searchInput.value = "";
    //       });
    //       optionList.appendChild(createOption);
    //     }
    //     optionList.classList.add("active");
    //   };
    //   // Handle the search input
    //   searchInput.addEventListener("input", renderOptionList);
    //   // Show option list when input is focused
    //   searchInput.addEventListener("focus", () => {
    //     renderOptionList();
    //     searchInput.placeholder = "Buscar opciones";
    //     optionList.classList.add("active");
    //   });
    //   // Hide option list when input loses focus or user clicks outside
    //   parentAllConEl.addEventListener("click", (e) => {
    //     if (!searchInput.contains(e.target) && !optionList.contains(e.target)) {
    //       optionList.classList.remove("active");
    //     }
    //   });
    //   // Prevent closing the dropdown when clicking on the options or removing selected options
    //   optionList.addEventListener("click", (e) => {
    //     if (
    //       e.target.classList.contains("option-item") ||
    //       e.target.classList.contains("create-option")
    //     ) {
    //       if (isMultiple) {
    //         e.stopPropagation(); // Prevent closing the dropdown when an option is clicked
    //       }
    //     }
    //   });
    //   selectedOptionsDiv.addEventListener("click", (e) => {
    //     if (e.target.classList.contains("remove")) {
    //       e.stopPropagation(); // Prevent closing the dropdown when the "x" is clicked
    //     }
    //   });
    //   if (
    //     listingData.listingBrand &&
    //     listingData.listingModel &&
    //     !this.#initialPreselectedSet
    //   ) {
    //     console.log("these here");
    //     this._setMachineBrand(prefixId);
    //     this._setMachineModel(prefixId);
    //     this.#initialPreselectedSet = true;
    //     this._setOtherData();
    //   } else {
    //     console.log("not set");
    //   }
    // };
    _callTheRightFunction = (prefixId, Type)=>{
        console.log("called with:", prefixId, Type);
        console.log("data now:", $4f930c604957bd07$var$listingData);
        const machineSelect = document.getElementById(`SearchStartUpComponentSelectMachineType`);
        const brandSelect = document.getElementById(`SearchStartUpComponentSelectMachineBrand`);
        const modelSelect = document.getElementById(`SearchStartUpComponentSelectMachineModel`);
        if (Type === "Type") {
            brandSelect.querySelector("#selected-options").innerHTML = "";
            brandSelect.querySelector("#option-list").innerHTML = "";
            this.#machineBrandsOnCleared = true;
            this.#machineModelsOnCleared = true;
            brandSelect.classList.remove("SearchStartUpComponentCon10Clear");
            modelSelect.classList.remove("SearchStartUpComponentCon10Clear");
            brandSelect.querySelector("#search-input").placeholder = "Selecionar";
            modelSelect.querySelector("#search-input").placeholder = "Selecionar";
            // SearchStartUpComponentCon10Clear
            modelSelect.querySelector("#selected-options").innerHTML = "";
            modelSelect.querySelector("#option-list").innerHTML = "";
            if (!$4f930c604957bd07$var$listingData.listingMachineType) return;
            this._setMachineBrand(prefixId);
        }
        if (Type === "Brand") {
            this.#machineModelsOnCleared = true;
            modelSelect.classList.remove("SearchStartUpComponentCon10Clear");
            modelSelect.querySelector("#selected-options").innerHTML = "";
            modelSelect.querySelector("#option-list").innerHTML = "";
            modelSelect.querySelector("#search-input").placeholder = "Selecionar";
            if (!$4f930c604957bd07$var$listingData.listingBrand) return;
            this._setMachineModel(prefixId);
        }
    };
    _setMachineTypes = async (prefixId)=>{
        const SearchStartUpComponentSelectMachineType = document.getElementById(`SearchStartUpComponentSelectMachineType`);
        SearchStartUpComponentSelectMachineType.querySelector("#search-input").value = $4f930c604957bd07$var$listingData.listingMachineType;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando informaci\xf3n");
        const machineData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData("machineTypes");
        this._initiateSelectOptions(false, `SearchStartUpComponentSelectMachineType`, `SearchStartUpComponentAllCon`, prefixId, machineData);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
    };
    _setMachineBrand = async (prefixId)=>{
        const SearchStartUpComponentSelectMachineBrand = document.getElementById(`SearchStartUpComponentSelectMachineBrand`);
        SearchStartUpComponentSelectMachineBrand.querySelector("#search-input").value = $4f930c604957bd07$var$listingData.listingBrand;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando marcas");
        let machineDataForUse;
        const machineData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData(`machineTypes/${$4f930c604957bd07$var$listingData.listingMachineType}/brands`);
        if (machineData.length < 1) machineDataForUse = [
            {
                id: "marca"
            }
        ];
        else machineDataForUse = machineData;
        this.#machineBrandsOnCleared = false;
        this.#machineModelsOnCleared = false;
        this._initiateSelectOptions(false, `SearchStartUpComponentSelectMachineBrand`, `SearchStartUpComponentAllCon`, prefixId, machineDataForUse, $4f930c604957bd07$var$listingData.listingBrand);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
    };
    _setMachineModel = async (prefixId)=>{
        const SearchStartUpComponentSelectMachineModel = document.getElementById(`SearchStartUpComponentSelectMachineModel`);
        SearchStartUpComponentSelectMachineModel.querySelector("#search-input").value = $4f930c604957bd07$var$listingData.listingModel;
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando modelos");
        let machineDataForUse;
        const machineData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData(`machineTypes/${$4f930c604957bd07$var$listingData.listingMachineType}/brands/${$4f930c604957bd07$var$listingData.listingBrand}/models`);
        if (machineData.length < 1) machineDataForUse = [
            {
                id: "modelo"
            }
        ];
        else machineDataForUse = machineData;
        this.#machineModelsOnCleared = false;
        this._initiateSelectOptions(false, `SearchStartUpComponentSelectMachineModel`, `SearchStartUpComponentAllCon`, prefixId, machineDataForUse, $4f930c604957bd07$var$listingData.listingModel);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
    };
    _setMachineYears = async (prefixId)=>{
        const SearchStartUpComponentSelectMachineYear = document.getElementById(`SearchStartUpComponentSelectMachineYear`);
        SearchStartUpComponentSelectMachineYear.querySelector("#search-input").value = $4f930c604957bd07$var$listingData.listingYear;
        const years = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._generateYearsArray(1990);
        const stringYearsOptions = [];
        years.forEach((year)=>{
            stringYearsOptions.push({
                id: year.toString()
            });
        });
        this._initiateSelectOptions(false, `SearchStartUpComponentSelectMachineYear`, `SearchStartUpComponentAllCon`, prefixId, stringYearsOptions, $4f930c604957bd07$var$listingData.listingYear);
    };
    _setMachineConditions = async (prefixId)=>{
        const SearchStartUpComponentSelectMachineCondition = document.getElementById(`SearchStartUpComponentSelectMachineCondition`);
        SearchStartUpComponentSelectMachineCondition.querySelector("#search-input").value = $4f930c604957bd07$var$listingData.listingCondition;
        const conditions = [
            "nuevo",
            "usado"
        ];
        const stringConditionOptions = [];
        conditions.forEach((condition)=>{
            stringConditionOptions.push({
                id: condition.toString()
            });
        });
        this._initiateSelectOptions(false, `SearchStartUpComponentSelectMachineCondition`, `SearchStartUpComponentAllCon`, prefixId, stringConditionOptions, $4f930c604957bd07$var$listingData.listingCondition);
    };
    _setOtherData() {
        // const coinPickerCon = document.getElementById("CreateListingCoinPic");
        // const coinMXN = document.getElementById("CreateListingCoinPicMXN");
        // const coinUSD = document.getElementById("CreateListingCoinPicUSD");
        const CreateListingPrice = document.getElementById(`CreateListingPrice`);
        const CreateListingItemsAvailable = document.getElementById(`CreateListingItemsAvailable`);
        const CreateListingName = document.getElementById(`CreateListingName`);
        const CreateListingVideoURL = document.getElementById(`CreateListingVideoURL`);
        const CreateListingDiscountPercent = document.getElementById(`CreateListingDiscountPercent`);
        const CreateListingDiscountAmount = document.getElementById(`CreateListingDiscountAmount`);
        const CreateListingDiscountFinalPrice = document.getElementById(`CreateListingDiscountFinalPrice`);
        const CreateListingDescription = document.getElementById(`CreateListingDescription`);
        const CreateListingAdminNotes = document.getElementById(`CreateListingAdminNotes`);
        console.log($4f930c604957bd07$var$listingData.onDiscount);
        let videoUrl = $4f930c604957bd07$var$listingData.videoUrl;
        if (!videoUrl) videoUrl = "";
        CreateListingName.value = $4f930c604957bd07$var$listingData.listingName;
        CreateListingVideoURL.value = videoUrl;
        CreateListingPrice.value = $4f930c604957bd07$var$listingData.listingPrice;
        CreateListingItemsAvailable.value = $4f930c604957bd07$var$listingData.listingItemsAvailable;
        CreateListingDescription.textContent = $4f930c604957bd07$var$listingData.listingDescription;
        CreateListingAdminNotes.textContent = $4f930c604957bd07$var$listingData?.adminNotes || '';
        CreateListingDiscountPercent.value = $4f930c604957bd07$var$listingData.onDiscount.percent;
        CreateListingDiscountAmount.value = $4f930c604957bd07$var$listingData.onDiscount.amount;
        CreateListingDiscountFinalPrice.value = $4f930c604957bd07$var$listingData.onDiscount.finalPrice;
        if (videoUrl.length > 1) this._setVideoStatus(true);
    // if (listingData.listingCoin === "MXN") {
    //   listingData.listingCoin = "MXN";
    //   // coinPickerCon.dataset.coin = "MXN";
    //   coinUSD.classList.remove("CreateListingOptionsPicCon3Active");
    //   coinMXN.classList.add("CreateListingOptionsPicCon3Active");
    // }
    // if (listingData.listingCoin === "USD") {
    //   listingData.listingCoin = "USD";
    //   coinPickerCon.dataset.coin = "USD";
    //   coinUSD.classList.add("CreateListingOptionsPicCon3Active");
    //   coinMXN.classList.remove("CreateListingOptionsPicCon3Active");
    // }
    }
}
var $4f930c604957bd07$export$2e2bcd8739ae039 = new $4f930c604957bd07$var$CreateListing();








var $34284abc3ce83a73$exports = {};
$34284abc3ce83a73$exports = new URL("filter.deadecb4.png", import.meta.url).toString();


var $62a2d837d8d86c66$exports = {};
$62a2d837d8d86c66$exports = new URL("filter-open.b4cabde2.png", import.meta.url).toString();


var $f15221692aadc2df$exports = {};
$f15221692aadc2df$exports = new URL("filter-reset.84367387.png", import.meta.url).toString();




// import iconDarkBusiness from "../../../Icons/nav-icons/active/business.png";
class $2188db6b68abec1b$var$generateHtml {
    _createPriceSliderContainer(minPrice, maxPrice, slider, id) {
        return `
  <div id="${id}" class="PriceAdjustComponentCon1">
    <div class="PriceAdjustComponentCon2">${slider}</div>
    <div class="PriceAdjustComponentCon2">
      <div class="PriceAdjustComponentCon13">
        <div id="PriceAdjustComponentConTextMin" class="PriceAdjustComponentConText">
          ${minPrice}
        </div>
        <div id="PriceAdjustComponentConTextMax" class="PriceAdjustComponentConText">
          ${maxPrice}
        </div>
      </div>
      <div class="PriceAdjustComponentCon14">
        <div class="PriceAdjustComponentCon14Text">
          Hemos convertido los precios a MXN para facilitar tu experiencia, pero
          es posible que la tasa de conversi\xf3n no sea la m\xe1s reciente.
        </div>
      </div>
    </div>
  </div>
    `;
    }
    _silderComponentCreator(presetMin, presetMax) {
        // Insert HTML for the slider
        return `
        <div class="price-slider-container">
          <div class="input-container">
            <div class="input-group">
              <input class="input-group-input" type="text" inputmode="numeric" id="min-input" value="${presetMin}" />
              <div class="input-label">M\xednimo</div>
            </div>
            <div class="input-group">
              <input class="input-group-input" type="text" inputmode="numeric" id="max-input" value="${presetMax}" />
              <div class="input-label">M\xe1ximo</div>
            </div>
          </div>
          <div class="slider-track">
            <div class="slider-range" id="slider-range"></div>
            <div class="slider-handle" id="min-handle"></div>
            <div class="slider-handle" id="max-handle"></div>
          </div>
        </div>
      `;
    }
    //   <div class="SearchStartUpComponentCon11">
    //   <select
    //     class="SearchStartUpComponentCon12"
    //     name=""
    //     id="${prefixId}SearchStartUpComponentSelectMachineType"
    //   >
    //     <option value="todos">Todos</option>
    //   </select>
    // </div>
    _createWholeSearchComponent(htmlPriceAdjuster, backgroundClass, prefixId) {
        return;
    //     return `
    // <div
    //   id="${prefixId}SearchStartUpComponentAllCon"
    //   class="SearchStartUpComponentCon1 ${backgroundClass}"
    // >
    //   <div class="SearchStartUpComponentCon2">
    //     <div class="SearchStartUpComponentCon3">
    //       <div class="SearchStartUpComponentCon4">
    //         <label class="SearchStartUpComponentCon5">
    //           <img height="20px" src="${iconDarkSearch}" alt="" />
    //           <input
    //             id="${prefixId}SearchStartUpComponentSearchInput"
    //             class="SearchStartUpComponentCon5Input"
    //             type="text"
    //             placeholder="Buscar listados"
    //             enterkeyhint="search" 
    //           />
    //           <div data-active="false" id="${prefixId}ActivateOnlyBusinessSeachingButton" class="ActivateOnlyBusinessSeachingButton">
    //             <img height="12px" src="${iconDarkBusiness}" alt="" />
    //           </div>
    //         </label>
    //       </div>
    //       <div id="${prefixId}SearchStartUpComponentFilterButton" class="SearchStartUpComponentCon6">
    //       <div id="" class="SearchStartUpComponentCon6B">
    //         <p>búsqueda avanzada</p>
    //         </div>
    //         <img height="14px" src="${iconDarkFilter}" alt="" />
    //       </div>
    //     </div>
    //     <div
    //       id="${prefixId}SearchStartUpComponentCon7"
    //       class="SearchStartUpComponentCon7"
    //     >
    //       <div
    //         id="${prefixId}SearchStartUpComponentSelectMachineType"
    //         class="SearchStartUpComponentCon8"
    //       >
    //         <div class="SearchStartUpComponentCon9">
    //           <div class="SearchStartUpComponentCon10">
    //             <div class="SearchStartUpComponentCon10Label">Maquina</div>
    //             <div class="select-wrapper">
    //               <div class="selected-options" id="selected-options"></div>
    //               <input
    //                 type="text"
    //                 id="search-input"
    //                 class="search-input"
    //                 placeholder="Buscar opciones de maquina"
    //               />
    //               <div id="option-list" class="option-list"></div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div
    //         id="${prefixId}SearchStartUpComponentSelectMachineBrand"
    //         class="SearchStartUpComponentCon8"
    //       >
    //         <div class="SearchStartUpComponentCon9">
    //           <div class="SearchStartUpComponentCon10">
    //             <div class="SearchStartUpComponentCon10Label">Marca</div>
    //             <div class="select-wrapper">
    //               <div class="selected-options" id="selected-options"></div>
    //               <input
    //                 type="text"
    //                 id="search-input"
    //                 class="search-input"
    //                 placeholder="Buscar opciones de marca"
    //               />
    //               <div id="option-list" class="option-list"></div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div
    //         id="${prefixId}SearchStartUpComponentSelectMachineModel"
    //         class="SearchStartUpComponentCon8"
    //       >
    //         <div class="SearchStartUpComponentCon9">
    //           <div class="SearchStartUpComponentCon10">
    //             <div class="SearchStartUpComponentCon10Label">Modelo</div>
    //             <div class="select-wrapper">
    //               <div class="selected-options" id="selected-options"></div>
    //               <input
    //                 type="text"
    //                 id="search-input"
    //                 class="search-input"
    //                 placeholder="Buscar opciones modelo"
    //               />
    //               <div id="option-list" class="option-list option-list-for-bottom-list"></div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div class="SearchStartUpComponentCon14">
    //         <div
    //           id="${prefixId}SearchStartUpComponentFilterNowButton"
    //           class="SearchStartUpComponentCon15"
    //         >
    //           <img height="18px" src="${iconDarkSearch}" alt="" />
    //           <div class="Button">buscar ahora</div>
    //         </div>
    //         <p class="SearchStartUpComponentFilterButtonClose" id="${prefixId}SearchStartUpComponentFilterButtonClose">Cerrar</p>
    //       </div>
    //     </div>
    //   </div>
    //   <div  id="${prefixId}SearchStartUpComponentByTrends" class="SearchStartUpComponentCategoryCon1">
    //     <div class="SearchStartUpComponentCategoryCon1Label">Acceso rápido</div>
    //     <div class="SearchStartUpComponentCategoryCon2">
    //       <button data-openby="other" data-openwhat="businesses" class="SearchStartUpComponentCategoryCon3">Negocios
    //       </button>
    //       <button data-openby="other" data-openwhat="discount" class="SearchStartUpComponentCategoryCon3">En oferta
    //       </button>
    //       <button data-openby="category" data-openwhat="tractor" class="SearchStartUpComponentCategoryCon3">Tractores
    //       </button>
    //       <button data-openby="category" data-openwhat="sembradora" class="SearchStartUpComponentCategoryCon3">Sembradoras
    //       </button>
    //     </div>
    //   </div>
    //   <div class="SearchListingsResultsContianerForSnap">
    //   <div id="${prefixId}SearchStartUpComponentCon13" class="SearchStartUpComponentCon13">
    //   <div class="SearchStartUpComponentCon13B">
    //       <button data-actiondo="hide" id="${prefixId}SearchUicSearchFilterResultsShowHide" data-prefixid="${prefixId}" class="SearchUicSearchFilterResultsButton ">
    //         <img height="10px" src="${iconDarkMenuUp}"/>
    //       </button>
    //         <button id="${prefixId}SearchUicSearchFilterResultsButton" data-prefixid="${prefixId}" class="SearchUicSearchFilterResultsButton ">
    //         <img height="10px" src="${iconDarkFilterOpen}"/> <p>Filtrar resultados</p> 
    //       </button>
    //       <button id="${prefixId}SearchUicSearchRemoveFilterResultsButton" data-prefixid="${prefixId}" class="SearchUicSearchFilterResultsButton">
    //         <img height="10px" src="${iconDarkFilterReset}"/>Quitar filtros
    //       </button>
    //       </div>
    //     <div id="${prefixId}SearchStartUpComponentCon13Number" class="SearchStartUpComponentCon13Text"><span class="SearchStartUpComponentCon13Text"></span></div>
    //   </div>
    //   <div class="SearchListingsResultsContianer" id="${prefixId}SearchListingsResultsContianer"></div> 
    //   <div class="SearchListingsResultsContianerTrigerLoadMore" id="${prefixId}SearchListingsResultsContianerTrigerLoadMore"></div>
    //   </div>
    // </div>
    // <div id="${prefixId}SearchStartUpComponentSelectFilter" class="SearchStartUpComponentSelectForFilter" >
    //      <div class="SearchStartUpComponentSelectForFilterCon2">
    //      <div class="SearchStartUpComponentSelectForFilterCon3">
    //       <div
    //         id="${prefixId}SearchStartUpComponentSelectMachineYear"
    //         class="SearchStartUpComponentCon8 SearchStartUpComponentCon8B"
    //       >
    //         <div class="SearchStartUpComponentCon9">
    //           <div
    //             class="SearchStartUpComponentCon10 SearchStartUpComponentCon10Clear"
    //           >
    //             <div class="SearchStartUpComponentCon10Label">Año</div>
    //             <div class="select-wrapper-2">
    //               <div class="selected-options" id="selected-options"></div>
    //               <input
    //                 type="text"
    //                 id="search-input"
    //                 class="search-input"
    //                 placeholder="Seleccionar años"
    //               />
    //               <div id="option-list" class="option-list"></div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       <div
    //         id="${prefixId}SearchStartUpComponentSelectMachineCondition"
    //         class="SearchStartUpComponentCon8 SearchStartUpComponentCon8B"
    //       >
    //         <div class="SearchStartUpComponentCon9">
    //           <div
    //             class="SearchStartUpComponentCon10 SearchStartUpComponentCon10Clear"
    //           >
    //             <div class="SearchStartUpComponentCon10Label">Condición</div>
    //             <div class="select-wrapper-2">
    //               <div class="selected-options" id="selected-options"></div>
    //               <input
    //                 type="text"
    //                 id="search-input"
    //                 class="search-input"
    //                 placeholder="Seleccionar Condición"
    //               />
    //               <div id="option-list" class="option-list"></div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       </div>
    //       <div class="SearchStartUpComponentCon16">${htmlPriceAdjuster}</div>
    //         </div>
    //       </div>
    //     `;
    }
}
var $2188db6b68abec1b$export$2e2bcd8739ae039 = new $2188db6b68abec1b$var$generateHtml();







const $3178e601840a635e$var$messages = [
    {
        message: "Take this onboarding tour",
        attachEl: "step1",
        hideAfter: 3000
    },
    {
        message: "Here's another feature",
        attachEl: "step2",
        hideAfter: 3000
    },
    {
        message: "Finally, explore this section",
        attachEl: "step3",
        hideAfter: 3000
    }
];
// OnboardingTour.start(messages);
// import SelectPure from "select-pure"; // Import the SelectPure librar
const $3178e601840a635e$var$colors = {
    headerPrimary: "FFFFFF",
    headerSecondary: "E0E0E0",
    packTitles: "6D6D6D",
    packTitlesHighlight: "3A7D44",
    itemBackgroundPrimary: "3A7D44",
    itemBackgroundSecondary: "fff",
    itemTextPrimary: "FFFFFF",
    itemTextSecondary: "2B2B2B",
    itemTextTerteriary: "3A7D44",
    itemTextFour: "3A7D44",
    itemHighlight: "FF7043",
    itemHighlightText: "FFFFFF"
};
const $3178e601840a635e$var$omittedWords = [
    "de",
    "para",
    "el",
    "del",
    "y",
    "en",
    "con"
];
class $3178e601840a635e$var$search {
    #filterEventsInitialized = false;
    #lastVisibleUseForSearch;
    #bottomScrollDetectActivatedGenral;
    #isCurrentDisplayResultsOnfilter = false;
    #wasFilterReset = false;
    #lasVisibleForTagetedSearchNew;
    #lastVisbleForDiscount;
    #bottomScrollDetectActivatedTargeted;
    #bottomScrollDetectActivatedbusiness;
    #lastVisibleDocForBusiness;
    #lastSearchQuery = "";
    #lastSearchBusinessQuery = "";
    #machineBrandsOnCleared = false;
    #machineModelsOnCleared = false;
    #prefixId;
    #resultsTotalInDisplayNow = 0;
    #isLoading;
    #searchType;
    #currentDisplayedResultsWithOutFilter = [];
    #currentDisplayedBusinessResultsWithOutFilter = [];
    #isSearchingForBusiness = false;
    displayedData = {};
    #businessesLoadedForColors = [];
    #filterData = {
        machine: "",
        brand: "",
        model: "",
        years: [],
        condition: "todos",
        priceMin: 0,
        priceMax: 0
    };
    _toggleSearchResultsConShowHide(what) {
        let whatForUse = what;
        const SearchUicSearchFilterResultsShowHide = document.getElementById(`${this.#prefixId}SearchUicSearchFilterResultsShowHide`);
        const searchResultsContainer = document.getElementById(`${this.#prefixId}SearchListingsResultsContianer`);
        const status = SearchUicSearchFilterResultsShowHide.dataset.actiondo;
        if (!what) whatForUse = status;
        console.log(whatForUse);
        if (whatForUse === "hide") {
            searchResultsContainer.style.maxHeight = "50px";
            SearchUicSearchFilterResultsShowHide.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($d3332e1704519a30$exports)));
            SearchUicSearchFilterResultsShowHide.dataset.actiondo = "show";
        }
        if (whatForUse === "show") {
            searchResultsContainer.style.maxHeight = "";
            SearchUicSearchFilterResultsShowHide.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($86cbc6500278ca92$exports)));
            SearchUicSearchFilterResultsShowHide.dataset.actiondo = "hide";
        }
        console.log(status);
    }
    _filterResultsNow(display, results) {
        const SearchUicSearchFilterResultsButton = document.getElementById(`${this.#prefixId}SearchUicSearchFilterResultsButton`);
        let resultsLocal = this.#currentDisplayedResultsWithOutFilter;
        if (results) resultsLocal = results;
        if (!this.#filterData || Object.keys(this.#filterData).length === 0) return this.#currentDisplayedResultsWithOutFilter; // No filters applied
        this.#isCurrentDisplayResultsOnfilter = true;
        let filteredResults = [];
        console.log(this.#filterData);
        console.log(this.#currentDisplayedResultsWithOutFilter);
        console.log(resultsLocal);
        resultsLocal.forEach((result)=>{
            let takeCurrent = true;
            // Filter by condition
            if (this.#filterData.condition && this.#filterData.condition !== "todos" && this.#filterData.condition !== result.listingCondition) {
                takeCurrent = false;
                console.log("rej condition");
            }
            // Filter by price range
            let listingPrice = result.listingPrice;
            let UDSinMXN = 19;
            if (result.listingCoin === "USD") listingPrice *= UDSinMXN;
            if (this.#filterData.priceMin && listingPrice < this.#filterData.priceMin) {
                takeCurrent = false;
                console.log("rej minprice");
            }
            if (this.#filterData.priceMax && listingPrice > this.#filterData.priceMax) {
                takeCurrent = false;
                console.log("rej maxprice");
            }
            // Filter by year
            if (this.#filterData.years && this.#filterData.years.length > 0) {
                let takeYear = false;
                this.#filterData.years.forEach((year)=>{
                    if (result.listingYear === year) takeYear = true;
                });
                if (!takeYear) {
                    console.log("rej year");
                    takeCurrent = false;
                }
            }
            if (takeCurrent) filteredResults.push(result);
        });
        if (display) {
            if (this.#currentDisplayedResultsWithOutFilter.length !== filteredResults.length) {
                SearchUicSearchFilterResultsButton.querySelector("p").textContent = "Filtros aplicados";
                SearchUicSearchFilterResultsButton.classList.add("SearchUicSearchFilterResultsButtonActive");
            }
            this._displaySearchResults(filteredResults, null, null, true, true);
        }
        console.log(filteredResults);
        return filteredResults; // Return filtered results
    }
    _removeAndAddActiveForTrends = (addTo)=>{
        const SearchStartUpComponentByTrends = document.getElementById(`${this.#prefixId}SearchStartUpComponentByTrends`);
        const allTrends = SearchStartUpComponentByTrends.querySelectorAll(".SearchStartUpComponentCategoryCon3");
        allTrends.forEach((trend)=>{
            if (trend.dataset.openwhat !== addTo) trend.classList.remove("SearchStartUpComponentCategoryCon3Active");
            else trend.classList.add("SearchStartUpComponentCategoryCon3Active");
        });
    };
    _initializeSelectLists() {
        const SearchStartUpComponentByTrends = document.getElementById(`${this.#prefixId}SearchStartUpComponentByTrends`);
        const allTrends = SearchStartUpComponentByTrends.querySelectorAll(".SearchStartUpComponentCategoryCon3");
        const resetFilterdata = ()=>{
            this.#filterData.machine = "";
            this.#filterData.brand = "";
            this.#filterData.model = "";
        };
        const makeSearchforTrendCategory = async ()=>{
            this._handleActivatedBusinessSearch("true");
            this.#lasVisibleForTagetedSearchNew = null;
            const results = await this._makeTargetedSearch();
            // await target();
            console.log(this.#lasVisibleForTagetedSearchNew);
            this.#currentDisplayedResultsWithOutFilter = results;
            this._displaySearchResults(results, null, null, true);
            // toggleSearchContainer();
            this.#lastSearchQuery = "";
            this._activateDetectScrollToBottomForTarNew(100);
        };
        const makeSearchforTrendOther = async (openWhat)=>{
            this._handleActivatedBusinessSearch("true");
            if (openWhat === "discount") {
                console.log(" looking for discounts");
                this.#lasVisibleForTagetedSearchNew = null;
                const results = await this._makeTargetedSearch(true);
                console.log(this.#lasVisibleForTagetedSearchNew);
                this._displaySearchResults(results, null, null, true);
                this.#currentDisplayedResultsWithOutFilter = results;
                // toggleSearchContainer();
                this.#lastSearchQuery = "";
            // this._activateDetectScrollToBottomForTarNew(100);
            }
            if (openWhat === "businesses") {
                this.#lastVisibleDocForBusiness = null;
                const results = await this._makeBusinessSearch();
                console.log(this.#lastVisibleDocForBusiness);
                this.#currentDisplayedBusinessResultsWithOutFilter = results;
                this._displaySearchBusinessResults(results, null, true);
                this._handleActivatedBusinessSearch("false");
                // toggleSearchContainer();
                this.#lastSearchQuery = "";
                this._activateDetectScrollToBottomForBusiness(100);
                console.log(results);
                console.log(" looking for business");
            }
        };
        SearchStartUpComponentByTrends.addEventListener("click", async (e)=>{
            const isTrend = e.target.closest(".SearchStartUpComponentCategoryCon3");
            if (isTrend) {
                const openBy = isTrend.dataset.openby;
                const openWhat = isTrend.dataset.openwhat;
                this._removeAndAddActiveForTrends(openWhat);
                resetFilterdata();
                if (openBy === "category") {
                    this.#filterData.machine = openWhat;
                    makeSearchforTrendCategory();
                } else makeSearchforTrendOther(openWhat);
            }
        });
    }
    _handleFilteringResultsAndInit(business) {
        if (this.#filterEventsInitialized) return;
        const SearchUicSearchRemoveFilterResultsButton = document.getElementById(`${this.#prefixId}SearchUicSearchRemoveFilterResultsButton`);
        const SearchUicSearchFilterResultsButton = document.getElementById(`${this.#prefixId}SearchUicSearchFilterResultsButton`);
        const SearchUicSearchFilterResultsShowHide = document.getElementById(`${this.#prefixId}SearchUicSearchFilterResultsShowHide`);
        const SearchStartUpComponentCon13 = document.getElementById(`${this.#prefixId}SearchStartUpComponentCon13`);
        const SearchStartUpComponentSelectFilter = document.getElementById(`${this.#prefixId}SearchStartUpComponentSelectFilter`);
        SearchStartUpComponentCon13.style.display = "flex";
        SearchUicSearchFilterResultsShowHide.addEventListener("click", ()=>{
            this._toggleSearchResultsConShowHide();
        });
        this._setMachineYears();
        this._setMachineConditions();
        this._handlePriceSliderEvents(2000, 5000000, 2000, 5000000, this.#prefixId);
        // Start functions
        SearchUicSearchRemoveFilterResultsButton.addEventListener("click", ()=>{
            if (this.#searchType === "business") {
                alert("Filtrar resultados de b\xfaquedas de negocios no est\xe1 disponible por el momento");
                return;
            }
            this.#filterData.machine = "";
            this.#filterData.brand = "";
            this.#filterData.model = "";
            this.#filterData.condition = "";
            this.#filterData.priceMax = "";
            this.#filterData.priceMin = "";
            this.#filterData.years = [];
            this.#isCurrentDisplayResultsOnfilter = false;
            SearchUicSearchFilterResultsButton.querySelector("p").textContent = "Filtrar resultados";
            SearchUicSearchFilterResultsButton.classList.remove("SearchUicSearchFilterResultsButtonActive");
            this.#wasFilterReset = true;
            this._filterResultsNow(true);
        });
        SearchUicSearchFilterResultsButton.addEventListener("click", ()=>{
            console.log("click");
            if (this.#searchType === "business") {
                alert("Filtrar resultados de b\xfaquedas de negocios no est\xe1 disponible por el momento");
                return;
            }
            SearchStartUpComponentSelectFilter.classList.add("SearchStartUpComponentSelectForFilterDisp");
            if (!this.#wasFilterReset) return;
            this._handlePriceSliderEvents(2000, 5000000, 2000, 5000000, this.#prefixId);
            this._setMachineYears();
            this._setMachineConditions();
        });
        SearchStartUpComponentSelectFilter.addEventListener("click", (e)=>{
            const el = e.target.closest(".option-item");
            console.log(el);
            console.log(e.target);
            if (e.target.closest(".option-item")) return;
            if (!e.target.closest(".SearchStartUpComponentSelectForFilterCon2")) {
                SearchStartUpComponentSelectFilter.classList.remove("SearchStartUpComponentSelectForFilterDisp");
                this.#wasFilterReset = false;
                this._filterResultsNow(true);
            } else if (e.target.closest(".SearchStartUpComponentSelectForFilterCon2")) {
                if (e.target.closest("#search-input")) return;
                const options = e.target.closest(".SearchStartUpComponentSelectForFilterCon2").querySelectorAll(".option-list");
                options.forEach((opt)=>{
                    opt.classList.remove("active");
                });
            }
        });
        this.#filterEventsInitialized = true;
    }
    _setMachineYears = async ()=>{
        const years = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._generateYearsArray(1990);
        const stringYearsOptions = [];
        years.forEach((year)=>{
            stringYearsOptions.push({
                id: year.toString()
            });
        });
        this._initiateSelectOptions(true, `${this.#prefixId}SearchStartUpComponentSelectMachineYear`, `${this.#prefixId}SearchStartUpComponentAllCon`, this.#prefixId, stringYearsOptions, true);
    };
    _setMachineConditions = async ()=>{
        const conditions = [
            "nuevo",
            "usado"
        ];
        const stringConditionOptions = [];
        conditions.forEach((condition)=>{
            stringConditionOptions.push({
                id: condition.toString()
            });
        });
        this._initiateSelectOptions(false, `${this.#prefixId}SearchStartUpComponentSelectMachineCondition`, `${this.#prefixId}SearchStartUpComponentAllCon`, this.#prefixId, stringConditionOptions, true);
    };
    _displaySearchResults = async (results, searchQuery, omittedWords, isNewDisplay, fromFilter)=>{
        console.log(results, searchQuery, omittedWords, isNewDisplay, fromFilter);
        // Start elements
        const searchResultsContainer = document.getElementById(`${this.#prefixId}SearchListingsResultsContianer`);
        const NumberOfSearchResults = document.getElementById(`${this.#prefixId}SearchStartUpComponentCon13Number`);
        const SearchStartUpComponentCon13 = document.getElementById(`${this.#prefixId}SearchStartUpComponentCon13`);
        // Start Functionality
        if (searchQuery && !results && isNewDisplay) {
            SearchStartUpComponentCon13.style.display = "flex";
            searchResultsContainer.innerHTML = "";
            NumberOfSearchResults.textContent = `No encontramos nada con '${searchQuery}'`;
        }
        if (!results) return;
        // Ranking
        let rankedResults = results;
        if (searchQuery) rankedResults = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._rankListings(results, searchQuery, omittedWords);
        console.log(rankedResults);
        if (isNewDisplay) {
            fromFilter;
            this.#resultsTotalInDisplayNow = 0;
            searchResultsContainer.innerHTML = "";
        }
        let html = ``;
        let displayNum = 0;
        for (const listing of rankedResults){
            fromFilter;
            this.#resultsTotalInDisplayNow++;
            // if (displayNum === 4 || displayNum === 7) {
            //   if (listing.businessId) {
            //     html += await generateListings._listingHorizontal(
            //       listing,
            //       colors,
            //       "listingInBusiness",
            //       listing.businessId
            //     );
            //   } else {
            //     html += await generateListings._listingHorizontal(
            //       listing,
            //       colors,
            //       "listing"
            //     );
            //   }
            // } else {
            if (listing.businessId) {
                let colorsLocal = $3178e601840a635e$var$colors;
                const businessInDownloads = (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._getLocalBusinessData(listing.businessId);
                if (businessInDownloads) colorsLocal = businessInDownloads.colors;
                else {
                    const alreadyDownloadedBusiness = this.#businessesLoadedForColors.find((business)=>business.businessId === listing.businessId);
                    if (alreadyDownloadedBusiness) colorsLocal = alreadyDownloadedBusiness.colors;
                    else {
                        // TODO this else block will load business for colors from fire store. deactivate if not needed.
                        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando");
                        const businessDownloaded = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getBusinessById(listing.businessId);
                        if (businessDownloaded) {
                            this.#businessesLoadedForColors.push(businessDownloaded);
                            colorsLocal = businessDownloaded.colors;
                        }
                        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
                    }
                }
                // const business
                // html += await generateListings._listingHorizontal(
                //   listing,
                //   colorsLocal,
                //   "listingInBusiness",
                //   listing.businessId
                // );
                html += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVertical(listing, colorsLocal, "listingInBusiness", listing.businessId);
            } else // html += await generateListings._listingHorizontal(
            //   listing,
            //   colors,
            //   "listing"
            // );
            html += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVertical(listing, $3178e601840a635e$var$colors, "listing");
            // }
            displayNum++;
        }
        this._toggleSearchResultsConShowHide("show");
        searchResultsContainer.insertAdjacentHTML("beforeend", html);
        searchResultsContainer.style.display = "flex";
        this._handleFilteringResultsAndInit();
        if (!fromFilter) this.#isLoading = false;
        NumberOfSearchResults.textContent = `${this.#resultsTotalInDisplayNow} resultados`;
        console.log(this.#currentDisplayedResultsWithOutFilter);
    };
    _displaySearchBusinessResults = async (results, searchQuery, isNewDisplay)=>{
        const searchResultsContainer = document.getElementById(`${this.#prefixId}SearchListingsResultsContianer`);
        const NumberOfSearchResults = document.getElementById(`${this.#prefixId}SearchStartUpComponentCon13Number`);
        const SearchStartUpComponentCon13 = document.getElementById(`${this.#prefixId}SearchStartUpComponentCon13`);
        // Initialize displayedData object
        this.displayedData = {
            businesses: {}
        };
        if (searchQuery && !results && isNewDisplay) {
            SearchStartUpComponentCon13.style.display = "flex";
            searchResultsContainer.innerHTML = "";
            NumberOfSearchResults.textContent = `No encontramos nada con '${searchQuery}'`;
        }
        if (!results) return;
        // Ranking
        let rankedResults = results;
        if (searchQuery) rankedResults = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._rankBusinesses(results, searchQuery, $3178e601840a635e$var$omittedWords);
        if (isNewDisplay) {
            this.#resultsTotalInDisplayNow = 0;
            searchResultsContainer.innerHTML = "";
        }
        try {
            // Store businesses in data object
            const businessesLocal = await Promise.all(rankedResults.map(async (business)=>{
                // Fetch listings for each business
                const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getRecentListingsWithFilter(null, 6, `businesses/${business.businessId}/listings`);
                // Attach listings to the business object
                return {
                    ...business,
                    listings: listings
                };
            }));
            // Generate and display HTML for businesses and their listings
            for (const business of businessesLocal){
                const generateBusiness = async ()=>{
                    if (business.status !== "active") return;
                    let listingsHtml = ``;
                    if (!Array.isArray(business.listings) || business.listings.length === 0) listingsHtml += (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMiniNoListings();
                    else for (const listing of business.listings)listingsHtml += await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalMini(listing, business.colors, "listingInBusiness", business.businessId);
                    const businessInPackHtml = await (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._businessInPack(listingsHtml, business);
                    this.#resultsTotalInDisplayNow++;
                    searchResultsContainer.style.display = "flex";
                    searchResultsContainer.insertAdjacentHTML("beforeend", businessInPackHtml);
                    // Store business and its listings in displayedData
                    this.displayedData.businesses[business.businessId] = {
                        ...business,
                        listings: business.listings || []
                    };
                };
                generateBusiness();
            }
        } catch (err) {
            if (err.name === "AbortError") console.log("Display Businesses aborted.");
            else console.error(err);
        } finally{
            console.log(this.displayedData);
            this.#isLoading = false;
            (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._dataMerge(this.displayedData);
        }
        this._toggleSearchResultsConShowHide("show");
        this._handleFilteringResultsAndInit("business");
        NumberOfSearchResults.textContent = `${this.#resultsTotalInDisplayNow} resultados`;
    };
    async _doSearch(searchQuery) {
        this.#searchType = "general";
        this.#isLoading = true;
        console.warn("General searching...");
        const { listings: listings, lastVisible: lastVisible } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._searchListingsGlobal(searchQuery, $3178e601840a635e$var$omittedWords, this.#lastVisibleUseForSearch);
        this.#lastVisibleUseForSearch = lastVisible;
        return listings;
    }
    async _makeTargetedSearch(discount) {
        console.warn(this.#lasVisibleForTagetedSearchNew);
        this.#searchType = "targeted";
        this.#isLoading = true;
        console.warn("Targeted searching...");
        if (this.#lasVisibleForTagetedSearchNew === "itwaslast") return;
        const { results: results, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._globalTargetedSearch(this.#lasVisibleForTagetedSearchNew, this.#filterData.machine, this.#filterData.brand, this.#filterData.model, discount, 10);
        console.log(results, lastVisibleDoc);
        this.#lasVisibleForTagetedSearchNew = lastVisibleDoc;
        if (!lastVisibleDoc) this.#lasVisibleForTagetedSearchNew = "itwaslast";
        console.log(this.#lasVisibleForTagetedSearchNew);
        return results;
    }
    async _makeBusinessSearch(searchQuery) {
        console.warn(this.#lastVisibleDocForBusiness);
        this.#searchType = "business";
        this.#isLoading = true;
        console.warn("Business searching...");
        if (this.#lastVisibleDocForBusiness === "itwaslast") return;
        const { results: results, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._searchBusinesses(searchQuery, $3178e601840a635e$var$omittedWords, this.#lastVisibleDocForBusiness, 10);
        console.log(results, lastVisibleDoc);
        this.#lastVisibleDocForBusiness = lastVisibleDoc;
        if (!lastVisibleDoc) this.#lastVisibleDocForBusiness = "itwaslast";
        console.log(this.#lastVisibleDocForBusiness);
        return results;
    }
    async _activateDetectScrollToBottomForTarNew(margin = 0) {
        console.log("detect targeted called");
        console.log("search type:", this.#searchType);
        if (this.#bottomScrollDetectActivatedTargeted) return;
        const searchResultsContainer = document.getElementById(`${this.#prefixId}SearchListingsResultsContianer`);
        if (!searchResultsContainer) {
            console.log("Error: Container not found.");
            return;
        }
        // Add a scroll event listener
        searchResultsContainer.addEventListener("scroll", async ()=>{
            const isScrolledToBottom = searchResultsContainer.scrollHeight - searchResultsContainer.scrollTop - searchResultsContainer.clientHeight <= margin;
            if (isScrolledToBottom) {
                if (this.#isLoading) return;
                if (this.#searchType !== "targeted") return;
                console.log("detect targeted accepted");
                const results = await this._makeTargetedSearch();
                let resultsToUse = results;
                if (results) {
                    results.forEach((result)=>{
                        this.#currentDisplayedResultsWithOutFilter.push(result);
                    });
                    if (this.#isCurrentDisplayResultsOnfilter) {
                        console.log("Is on filter, displaying new resluts through filter.");
                        const filteredResults = this._filterResultsNow(false, results);
                        if (!filteredResults && results) this.#isLoading = false;
                        resultsToUse = filteredResults;
                    }
                }
                this._displaySearchResults(resultsToUse, null, null, false);
                console.log(results);
                console.log("Scrolled near the bottom");
            }
        });
        this.#bottomScrollDetectActivatedTargeted = true;
    }
    async _activateDetectScrollToBottomForBusiness(margin = 0) {
        console.log("detect business called");
        console.log("search type:", this.#searchType);
        if (this.#bottomScrollDetectActivatedbusiness) return;
        const searchResultsContainer = document.getElementById(`${this.#prefixId}SearchListingsResultsContianer`);
        if (!searchResultsContainer) {
            console.log("Error: Container not found.");
            return;
        }
        // Add a scroll event listener
        searchResultsContainer.addEventListener("scroll", async ()=>{
            const isScrolledToBottom = searchResultsContainer.scrollHeight - searchResultsContainer.scrollTop - searchResultsContainer.clientHeight <= margin;
            if (isScrolledToBottom) {
                if (this.#isLoading) return;
                if (this.#searchType !== "business") return;
                console.log("detect business acepted");
                const results = await this._makeBusinessSearch(this.#lastSearchBusinessQuery);
                let resultsToUse = results;
                this._displaySearchBusinessResults(resultsToUse, this.#lastSearchBusinessQuery, false);
                console.log(results);
                console.log("Scrolled near the bottom");
            }
        });
        this.#bottomScrollDetectActivatedbusiness = true;
    }
    _activateDetectScrollToBottom = (margin = 0)=>{
        if (this.#bottomScrollDetectActivatedGenral) return;
        const searchResultsContainer = document.getElementById(`${this.#prefixId}SearchListingsResultsContianer`);
        if (!searchResultsContainer) {
            console.log("Error: Container not found.");
            return;
        }
        // Add a scroll event listener
        searchResultsContainer.addEventListener("scroll", async ()=>{
            const isScrolledToBottom = searchResultsContainer.scrollHeight - searchResultsContainer.scrollTop - searchResultsContainer.clientHeight <= margin;
            if (isScrolledToBottom) {
                if (this.#isLoading) return;
                let resultsToUse;
                if (this.#searchType !== "general") return;
                const results = await this._doSearch(this.#lastSearchQuery);
                resultsToUse = results;
                if (results) {
                    results.forEach((result)=>{
                        this.#currentDisplayedResultsWithOutFilter.push(result);
                    });
                    if (this.#isCurrentDisplayResultsOnfilter) {
                        // console.log("Is on filter, displaying new resluts through filter.");
                        const filteredResults = this._filterResultsNow(false, results);
                        if (!filteredResults && results) this.#isLoading = false;
                        resultsToUse = filteredResults;
                    }
                }
                // if (this.#searchType === "targeted") {
                //   this._displaySearchResults(resultsToUse, null, null, false);
                // } else {
                this._displaySearchResults(resultsToUse, this.#lastSearchQuery, $3178e601840a635e$var$omittedWords, false);
                // }
                console.log("Scrolled near the bottom");
            }
        });
        this.#bottomScrollDetectActivatedGenral = true;
    };
    async _makeSearchFromSearchInput() {
        this.#isLoading = false;
        const searchInput = document.getElementById(`${this.#prefixId}SearchStartUpComponentSearchInput`);
        const NumberOfSearchResults = document.getElementById(`${this.#prefixId}SearchStartUpComponentCon13Number`);
        const SearchStartUpComponentCon13 = document.getElementById(`${this.#prefixId}SearchStartUpComponentCon13`);
        const searchResultsContainer = document.getElementById(`${this.#prefixId}SearchListingsResultsContianer`);
        searchResultsContainer.innerHTML = "";
        // let lastVisibleUse;
        searchInput.addEventListener("keyup", async (e)=>{
            if (e.key === "Enter") e.target.blur();
        });
        searchInput.addEventListener("blur", async (e)=>{
            const targetValueUp = e.target.value.trim();
            const targetValue = targetValueUp.toLowerCase();
            if (targetValue.length > 3) {
                // lastVisibleUse = null;
                this._removeAndAddActiveForTrends();
                if (this.#isSearchingForBusiness) {
                    if (this.#lastSearchBusinessQuery !== targetValue) {
                        this.#lastVisibleDocForBusiness = null;
                        const results = await this._makeBusinessSearch(targetValue);
                        this.#currentDisplayedBusinessResultsWithOutFilter = results;
                        this._displaySearchBusinessResults(results, targetValue, true);
                        this._handleActivatedBusinessSearch("false");
                        // toggleSearchContainer();
                        this.#lastSearchQuery = "";
                        this.#lastSearchBusinessQuery = targetValue;
                        this._activateDetectScrollToBottomForBusiness(100);
                    }
                } else if (this.#lastSearchQuery !== targetValue) {
                    this.#lastVisibleUseForSearch = null;
                    const results = await this._doSearch(targetValue);
                    this.#currentDisplayedResultsWithOutFilter = results;
                    this._displaySearchResults(results, targetValue, $3178e601840a635e$var$omittedWords, true);
                    this.#lastSearchQuery = targetValue;
                    this.#lastSearchBusinessQuery = "";
                }
            } else {
                SearchStartUpComponentCon13.style.display = "flex";
                NumberOfSearchResults.textContent = `Busqueda no v\xe1lida`;
            }
        });
        this._activateDetectScrollToBottom(100);
    }
    _setSearchComponentHtml(listName, CategoriesArr, id) {
        let minPrice = 0;
        let maxPrice = 0;
        let minPreset = 0;
        let maxPreset = 0;
        this.#prefixId = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getUniqueIdfunction();
        const prefixId = this.#prefixId;
        const [Html, idForEvents] = this._displayPriceAdjuster(minPrice, maxPrice, minPreset, maxPreset);
        const allSearchHtml = (0, $2188db6b68abec1b$export$2e2bcd8739ae039)._createWholeSearchComponent(Html, null, prefixId);
        const con = document.getElementById(id);
        con.insertAdjacentHTML("beforeend", allSearchHtml);
        this._otherSearchEvents(prefixId);
        this._makeSearchFromSearchInput();
        this._initializeSelectLists();
    }
    _displayPriceAdjuster(minPrice, maxPrice, presetMin, presetMax) {
        const sliderHtml = (0, $2188db6b68abec1b$export$2e2bcd8739ae039)._silderComponentCreator(presetMin, presetMax);
        const priceContainerHtml = (0, $2188db6b68abec1b$export$2e2bcd8739ae039)._createPriceSliderContainer(minPrice, maxPrice, sliderHtml, this.#prefixId);
        return [
            priceContainerHtml
        ];
    }
    _handlePriceSliderEvents(minPrice, maxPrice, presetMin, presetMax, attachContainerId) {
        const container = document.getElementById(attachContainerId);
        this.#filterData.priceMin = presetMin;
        this.#filterData.priceMax = presetMax;
        // Get elements
        const minInput = container.querySelector("#min-input");
        const maxInput = container.querySelector("#max-input");
        const sliderRange = container.querySelector("#slider-range");
        const minHandle = container.querySelector("#min-handle");
        const maxHandle = container.querySelector("#max-handle");
        const minAvailable = container.querySelector(`#PriceAdjustComponentConTextMin`);
        const maxAvailable = container.querySelector(`#PriceAdjustComponentConTextMax`);
        minInput.value = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatToPrice(presetMin);
        minAvailable.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatToPrice(minPrice);
        maxInput.value = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatToPrice(presetMax);
        maxAvailable.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatToPrice(maxPrice);
        // Constants
        const trackWidth = 100; // Slider track width in percentage
        const minHandleLimit = 0; // Minimum position of the left handle
        const maxHandleLimit = trackWidth; // Maximum position of the right handle
        let minPosition = (presetMin - minPrice) / (maxPrice - minPrice) * trackWidth;
        let maxPosition = (presetMax - minPrice) / (maxPrice - minPrice) * trackWidth;
        function updateSlider() {
            sliderRange.style.left = `${minPosition}%`;
            sliderRange.style.width = `${maxPosition - minPosition}%`;
            minHandle.style.left = `${minPosition}%`;
            maxHandle.style.left = `${maxPosition}%`;
        }
        function validateInput(value, isMin) {
            let num = Math.round(value / 1000) * 1000; // Round to thousands
            if (num < minPrice) num = minPrice;
            if (num > maxPrice) num = maxPrice;
            if (isMin && num >= presetMax) num = presetMax - 1000;
            if (!isMin && num <= presetMin) num = presetMin + 1000;
            return num;
        }
        const handleInputBlur = (e, isMin)=>{
            const value = parseInt(e.target.value.replace(/,/g, ""), 10) || 0;
            if (isMin) {
                presetMin = validateInput(value, true);
                minPosition = (presetMin - minPrice) / (maxPrice - minPrice) * trackWidth;
            } else {
                presetMax = validateInput(value, false);
                maxPosition = (presetMax - minPrice) / (maxPrice - minPrice) * trackWidth;
            }
            minInput.value = presetMin.toLocaleString();
            maxInput.value = presetMax.toLocaleString();
            this.#filterData.priceMin = presetMin;
            this.#filterData.priceMax = presetMax;
            updateSlider();
        };
        function handleInputChange(e) {
            const value = e.target.value.replace(/,/g, ""); // Remove commas
            const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
            e.target.value = parseInt(numericValue || 0, 10).toLocaleString(); // Format as thousands
        }
        const handleDrag = (event, isMin, isTouch = false)=>{
            const trackRect = sliderRange.parentNode.getBoundingClientRect();
            const clientX = isTouch ? event.touches[0].clientX : event.clientX;
            const offsetX = (clientX - trackRect.left) / trackRect.width * trackWidth;
            if (isMin) {
                minPosition = Math.min(Math.max(minHandleLimit, offsetX), maxPosition - 1);
                presetMin = Math.round(minPosition / trackWidth * (maxPrice - minPrice) + minPrice);
                presetMin = validateInput(presetMin, true);
            } else {
                maxPosition = Math.max(Math.min(maxHandleLimit, offsetX), minPosition + 1);
                presetMax = Math.round(maxPosition / trackWidth * (maxPrice - minPrice) + minPrice);
                presetMax = validateInput(presetMax, false);
            }
            minInput.value = presetMin.toLocaleString();
            maxInput.value = presetMax.toLocaleString();
            this.#filterData.priceMin = presetMin;
            this.#filterData.priceMax = presetMax;
            updateSlider();
        };
        function addDragEvent(handle, isMin) {
            const onMove = (event)=>handleDrag(event, isMin, event.type.startsWith("touch"));
            const onEnd = ()=>{
                window.removeEventListener("mousemove", onMove);
                window.removeEventListener("mouseup", onEnd);
                window.removeEventListener("touchmove", onMove);
                window.removeEventListener("touchend", onEnd);
            };
            const onStart = (event)=>{
                event.preventDefault();
                window.addEventListener("mousemove", onMove);
                window.addEventListener("mouseup", onEnd);
                window.addEventListener("touchmove", onMove);
                window.addEventListener("touchend", onEnd);
            };
            handle.addEventListener("mousedown", onStart);
            handle.addEventListener("touchstart", onStart);
        }
        minInput.addEventListener("input", handleInputChange);
        maxInput.addEventListener("input", handleInputChange);
        minInput.addEventListener("blur", (e)=>handleInputBlur(e, true));
        maxInput.addEventListener("blur", (e)=>handleInputBlur(e, false));
        addDragEvent(minHandle, true);
        addDragEvent(maxHandle, false);
        // Initialize the slider
        updateSlider();
    }
    _handleActivatedBusinessSearch(active) {
        const buttonFilter = document.getElementById(`${this.#prefixId}SearchStartUpComponentFilterButton`);
        const ActivateOnlyBusinessSeachingButton = document.getElementById(`${this.#prefixId}ActivateOnlyBusinessSeachingButton`);
        const searchInput = ActivateOnlyBusinessSeachingButton.parentElement.querySelector("input");
        console.log(active);
        if (active === "true") {
            this.#isSearchingForBusiness = false;
            ActivateOnlyBusinessSeachingButton.dataset.active = "false";
            ActivateOnlyBusinessSeachingButton.classList.remove("ActivateOnlyBusinessSeachingButtonActive");
            ActivateOnlyBusinessSeachingButton.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($86cbc6500278ca92$exports)));
            searchInput.placeholder = "Buscar listados";
            buttonFilter.style.display = "";
        }
        if (active === "false") {
            this.#isSearchingForBusiness = true;
            ActivateOnlyBusinessSeachingButton.dataset.active = "true";
            ActivateOnlyBusinessSeachingButton.classList.add("ActivateOnlyBusinessSeachingButtonActive");
            ActivateOnlyBusinessSeachingButton.querySelector("img").src = (0, (/*@__PURE__*/$parcel$interopDefault($86cbc6500278ca92$exports)));
            searchInput.placeholder = "Buscar negocios";
            buttonFilter.style.display = "none";
        }
    }
    async _otherSearchEvents(prefixId) {
        const searchInputParent = document.getElementById(`${prefixId}SearchStartUpComponentSearchInput`).parentElement.parentElement;
        const searchInput = document.getElementById(`${prefixId}SearchStartUpComponentSearchInput`);
        const buttonFilterNow = document.getElementById(`${prefixId}SearchStartUpComponentFilterNowButton`);
        const buttonFilter = document.getElementById(`${prefixId}SearchStartUpComponentFilterButton`);
        const buttonFilterClose = document.getElementById(`${prefixId}SearchStartUpComponentFilterButtonClose`);
        const allFiltersCon = document.getElementById(`${prefixId}SearchStartUpComponentCon7`);
        const ActivateOnlyBusinessSeachingButton = document.getElementById(`${prefixId}ActivateOnlyBusinessSeachingButton`);
        // Start Functions
        //toogle FilterContainer
        const toggleSearchContainer = (hide)=>{
            if (hide) {
                allFiltersCon.classList.remove("SearchStartUpComponentCon7Display");
                searchInputParent.classList.remove("SearchStartUpComponentCon4WithPadding");
                setTimeout(()=>{
                    allFiltersCon.style.display = "none"; // Hide after transition
                }, 300); // Match the transition duration
                return;
            }
            if (allFiltersCon.classList.contains("SearchStartUpComponentCon7Display")) {
                allFiltersCon.classList.remove("SearchStartUpComponentCon7Display");
                searchInputParent.classList.remove("SearchStartUpComponentCon4WithPadding");
                setTimeout(()=>{
                    allFiltersCon.style.display = "none"; // Hide after transition
                }, 300); // Match the transition duration
            } else {
                this._setSelectOptionTakecare(prefixId);
                searchInputParent.classList.add("SearchStartUpComponentCon4WithPadding");
                allFiltersCon.style.display = "flex"; // Show immediately before adding class
                setTimeout(()=>{
                    allFiltersCon.classList.add("SearchStartUpComponentCon7Display");
                }, 10); // Slight delay to ensure display change is applied
            }
        };
        ActivateOnlyBusinessSeachingButton.addEventListener("click", ()=>{
            const isActive = ActivateOnlyBusinessSeachingButton.dataset.active;
            this._handleActivatedBusinessSearch(isActive);
        });
        searchInput.addEventListener("focus", ()=>{
            console.log("focus");
            toggleSearchContainer(true);
            buttonFilter.querySelector(".SearchStartUpComponentCon6B").classList.add("SearchStartUpComponentCon6BHide");
        });
        buttonFilter.addEventListener("click", ()=>{
            console.log("click");
            buttonFilter.querySelector(".SearchStartUpComponentCon6B").classList.remove("SearchStartUpComponentCon6BHide");
            toggleSearchContainer();
        // allFiltersCon.classList.add("SearchStartUpComponentCon7Display");
        // console.log(searchInputParent);
        });
        buttonFilterClose.addEventListener("click", toggleSearchContainer);
        buttonFilterNow.addEventListener("click", async ()=>{
            console.log(this.#filterData);
            if (!this.#filterData.machine) {
                alert("Necesitas especificar al menos una opci\xf3n antes de hacer la busqueda.");
                return;
            }
            this.#lasVisibleForTagetedSearchNew = null;
            this._removeAndAddActiveForTrends();
            const results = await this._makeTargetedSearch();
            // await target();
            console.log(this.#lasVisibleForTagetedSearchNew);
            this.#currentDisplayedResultsWithOutFilter = results;
            this._displaySearchResults(results, null, null, true);
            toggleSearchContainer();
            this.#lastSearchQuery = "";
            this._activateDetectScrollToBottomForTarNew(100);
        });
    }
    _initiateSelectOptions = async (isMultiple, parrentId, parrentAllId, prefixId, optionsData, isForReset)=>{
        const options = [
            {
                id: "todos",
                label: "Todos"
            }
        ];
        if (!optionsData) return;
        else if (!optionsData.length > 0) return;
        optionsData.forEach((option)=>{
            options.push({
                id: option.id,
                label: (0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatReadableString(option.id)
            });
        });
        let selectedValues = [];
        let createdOptions = []; // To track options created by the user
        const parentAllConEl = document.getElementById(parrentAllId);
        const parentConEl = document.getElementById(parrentId);
        const selectedOptionsDiv = parentConEl.querySelector(`#selected-options`);
        const searchInput = parentConEl.querySelector(`#search-input`);
        const optionList = parentConEl.querySelector(`#option-list`);
        parentConEl.classList.add("SearchStartUpComponentCon10Clear");
        if (isForReset) selectedOptionsDiv.innerHTML = "";
        // Function to render the selected options
        const renderSelectedOptions = ()=>{
            selectedOptionsDiv.innerHTML = "";
            selectedValues.forEach((value)=>{
                const option = options.find((opt)=>opt.id === value) || createdOptions.find((opt)=>opt.id === value);
                const optionDiv = document.createElement("div");
                optionDiv.classList.add("selected-option");
                optionDiv.innerHTML = `${option.label} ${option.isCreated ? "<span class='created-tag'>(Creado)</span>" : ""} <span class="remove" data-id="${option.id}">x</span>`;
                selectedOptionsDiv.appendChild(optionDiv);
            });
            // Attach remove functionality to each selected option
            parentConEl.querySelectorAll(".remove").forEach((removeButton)=>{
                removeButton.addEventListener("click", (e)=>{
                    const id = e.target.dataset.id;
                    selectedValues = selectedValues.filter((value)=>value !== id);
                    let Type;
                    if (parentConEl.id.includes("Type")) {
                        Type = "Type";
                        this.#filterData.machine = "";
                        this.#filterData.brand = "";
                        this.#filterData.model = "";
                    } else if (parentConEl.id.includes("Brand")) {
                        Type = "Brand";
                        this.#filterData.brand = "";
                        this.#filterData.model = "";
                    } else if (parentConEl.id.includes("Model")) {
                        Type = "Model";
                        this.#filterData.model = "";
                    } else if (parentConEl.id.includes("Year")) {
                        Type = "Year";
                        const indexToRemove = this.#filterData.years.indexOf(id);
                        if (indexToRemove !== -1) this.#filterData.years.splice(indexToRemove, 1);
                    } else if (parentConEl.id.includes("Condition")) {
                        Type = "Condition";
                        this.#filterData.condition = "";
                    }
                    this._callTheRightFunction(prefixId, Type);
                    // Log when a value is removed
                    renderSelectedOptions();
                    renderOptionList();
                });
            });
        };
        // Function to render the option list based on search input
        const renderOptionList = ()=>{
            if (parrentId.includes("Brand") && this.#machineBrandsOnCleared) return;
            if (parrentId.includes("Model") && this.#machineModelsOnCleared) return;
            const query = searchInput.value.toLowerCase();
            const filteredOptions = options.concat(createdOptions).filter((option)=>option.label.toLowerCase().includes(query) && !selectedValues.includes(option.id));
            optionList.innerHTML = ""; // Clear the current list
            if (filteredOptions.length > 0) filteredOptions.forEach((option)=>{
                const optionItem = document.createElement("div");
                optionItem.classList.add("option-item");
                optionItem.textContent = option.label;
                optionItem.addEventListener("click", ()=>{
                    if (isMultiple) {
                        if (!selectedValues.includes(option.id)) selectedValues.push(option.id);
                    } else selectedValues = [
                        option.id
                    ];
                    let Type;
                    if (parentConEl.id.includes("Type")) {
                        Type = "Type";
                        this.#filterData.machine = option.id;
                        this.#filterData.brand = "";
                        this.#filterData.model = "";
                    } else if (parentConEl.id.includes("Brand")) {
                        Type = "Brand";
                        this.#filterData.brand = option.id;
                        this.#filterData.model = "";
                    } else if (parentConEl.id.includes("Model")) {
                        Type = "Model";
                        this.#filterData.model = option.id;
                    } else if (parentConEl.id.includes("Year")) {
                        Type = "Year";
                        this.#filterData.years.push(option.id);
                    } else if (parentConEl.id.includes("Condition")) {
                        Type = "Condition";
                        this.#filterData.condition = option.id;
                    }
                    this._callTheRightFunction(prefixId, Type);
                    renderSelectedOptions();
                    renderOptionList();
                    searchInput.value = "";
                });
                optionList.appendChild(optionItem);
            });
            else if (query.trim() !== "") {
                const createOption = document.createElement("div");
                createOption.classList.add("create-option");
                createOption.textContent = `Crear nueva opci\xf3n: "${query}"`;
                createOption.addEventListener("click", ()=>{
                    const optionIdForHere = query.toLowerCase().split(" ").join("-"); // Unique ID for created options
                    const newOption = {
                        id: optionIdForHere,
                        label: (0, $a082c89adac62edb$export$2e2bcd8739ae039)._formatReadableString(query),
                        isCreated: true
                    };
                    console.log(`User created and selected: ${newOption.label}`); // Log the created and selected value
                    let Type;
                    if (parentConEl.id.includes("Type")) {
                        Type = "Type";
                        console.log(`User selected: ${optionIdForHere}`);
                        console.log(`selected: Type`);
                        this.#filterData.machine = optionIdForHere;
                        this.#filterData.brand = "";
                        this.#filterData.model = "";
                    } else if (parentConEl.id.includes("Brand")) {
                        Type = "Brand";
                        console.log(`User selected: ${optionIdForHere}`);
                        console.log(`selected: Brand`);
                        this.#filterData.brand = optionIdForHere;
                        this.#filterData.model = "";
                    } else if (parentConEl.id.includes("Model")) {
                        Type = "Model";
                        console.log(`User selected: ${optionIdForHere}`);
                        console.log(`selected: model`);
                        this.#filterData.model = optionIdForHere;
                    } else if (parentConEl.id.includes("Year")) {
                        Type = "Year";
                        console.log(`User selected: ${optionIdForHere}`);
                        console.log(`selected: year`);
                        this.#filterData.years.push(optionIdForHere);
                    } else if (parentConEl.id.includes("Condition")) {
                        Type = "Condition";
                        console.log(`User selected: ${optionIdForHere}`);
                        console.log(`selected: condition`);
                        this.#filterData.condition = optionIdForHere;
                    }
                    this._callTheRightFunction(prefixId, Type);
                    createdOptions.push(newOption);
                    if (isMultiple) // Allow multiple selections
                    selectedValues.push(newOption.id);
                    else // Single selection: Replace the current selection
                    selectedValues = [
                        newOption.id
                    ];
                    renderSelectedOptions();
                    renderOptionList();
                    searchInput.value = "";
                });
                optionList.appendChild(createOption);
            }
            optionList.classList.add("active");
        };
        // Handle the search input
        searchInput.addEventListener("input", renderOptionList);
        // Show option list when input is focused
        searchInput.addEventListener("focus", ()=>{
            renderOptionList();
            searchInput.placeholder = "Buscar opciones";
            optionList.classList.add("active");
        });
        // Hide option list when input loses focus or user clicks outside
        parentAllConEl.addEventListener("click", (e)=>{
            if (!searchInput.contains(e.target) && !optionList.contains(e.target)) optionList.classList.remove("active");
        });
        // Prevent closing the dropdown when clicking on the options or removing selected options
        optionList.addEventListener("click", (e)=>{
            if (e.target.classList.contains("option-item") || e.target.classList.contains("create-option")) {
                if (isMultiple) e.stopPropagation(); // Prevent closing the dropdown when an option is clicked
            }
        });
        selectedOptionsDiv.addEventListener("click", (e)=>{
            if (e.target.classList.contains("remove")) e.stopPropagation(); // Prevent closing the dropdown when the "x" is clicked
        });
    };
    async _setSelectOptionTakecare(prefixId) {
        this._setMachineTypes(prefixId);
    }
    _callTheRightFunction = (prefixId, Type)=>{
        const machineSelect = document.getElementById(`${prefixId}SearchStartUpComponentSelectMachineType`);
        const brandSelect = document.getElementById(`${prefixId}SearchStartUpComponentSelectMachineBrand`);
        const modelSelect = document.getElementById(`${prefixId}SearchStartUpComponentSelectMachineModel`);
        if (Type === "Type") {
            brandSelect.querySelector("#selected-options").innerHTML = "";
            brandSelect.querySelector("#option-list").innerHTML = "";
            this.#machineBrandsOnCleared = true;
            this.#machineModelsOnCleared = true;
            brandSelect.classList.remove("SearchStartUpComponentCon10Clear");
            modelSelect.classList.remove("SearchStartUpComponentCon10Clear");
            brandSelect.querySelector("#search-input").placeholder = "Todos";
            modelSelect.querySelector("#search-input").placeholder = "Todos";
            // SearchStartUpComponentCon10Clear
            modelSelect.querySelector("#selected-options").innerHTML = "";
            modelSelect.querySelector("#option-list").innerHTML = "";
            if (!this.#filterData.machine) return;
            this._setMachineBrand(prefixId);
        }
        if (Type === "Brand") {
            this.#machineModelsOnCleared = true;
            modelSelect.classList.remove("SearchStartUpComponentCon10Clear");
            modelSelect.querySelector("#selected-options").innerHTML = "";
            modelSelect.querySelector("#option-list").innerHTML = "";
            modelSelect.querySelector("#search-input").placeholder = "Todos";
            if (!this.#filterData.brand) return;
            this._setMachineModel(prefixId);
        }
    };
    _setMachineTypes = async (prefixId)=>{
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando informaci\xf3n");
        const machineData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData("machineTypes");
        this._initiateSelectOptions(false, `${prefixId}SearchStartUpComponentSelectMachineType`, `${prefixId}SearchStartUpComponentAllCon`, prefixId, machineData);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
    };
    _setMachineBrand = async (prefixId)=>{
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando marcas");
        const machineData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData(`machineTypes/${this.#filterData.machine}/brands`);
        this.#machineBrandsOnCleared = false;
        this.#machineModelsOnCleared = false;
        this._initiateSelectOptions(false, `${prefixId}SearchStartUpComponentSelectMachineBrand`, `${prefixId}SearchStartUpComponentAllCon`, prefixId, machineData);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
    };
    _setMachineModel = async (prefixId)=>{
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando modelos");
        const machineData = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMachineData(`machineTypes/${this.#filterData.machine}/brands/${this.#filterData.brand}/models`);
        this.#machineModelsOnCleared = false;
        this._initiateSelectOptions(false, `${prefixId}SearchStartUpComponentSelectMachineModel`, `${prefixId}SearchStartUpComponentAllCon`, prefixId, machineData);
        (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
    };
}
var $3178e601840a635e$export$2e2bcd8739ae039 = new $3178e601840a635e$var$search();












// maiHomeScreenTipsCon5TipsCon

// import iconVided from "../../../Icons/NV/tips/tips-video-icon.png";
var $5bcdaae67de039d7$exports = {};
$5bcdaae67de039d7$exports = new URL("play-vid-black.f880948d.png", import.meta.url).toString();


class $c381627b4f215766$var$generateHtml {
    // <img class="maiHomeScreenTipsCon7" src="${data.images[0].res_500}">
    _generateTip(data, i) {
        console.log(data);
        return `
            <div data-index="${i}" class="maiHomeScreenTipsCon6">
                <div
                    class="maiHomeScreenTipsCon7"
                    style="background-image:url('${data.images[0].res_500}')"
                ></div> 
                <img class="maiHomeScreenTipsCon8" src="${0, (/*@__PURE__*/$parcel$interopDefault($5bcdaae67de039d7$exports))}">
            </div>
        `;
    }
}
var $c381627b4f215766$export$2e2bcd8739ae039 = new $c381627b4f215766$var$generateHtml();


var $a41947c1d7272ebb$exports = {};
$a41947c1d7272ebb$exports = new URL("play.114464ac.png", import.meta.url).toString();


var $fe9a941670dc96ba$exports = {};
$fe9a941670dc96ba$exports = new URL("pause.c54c57cb.png", import.meta.url).toString();




// maiTipsCommentsInput
class $dfd0ebd7df3b40be$var$maiTips {
    #tipsToUse = [];
    constructor(){}
    _showTips() {
        const parentCon = document.getElementById('maiHomeScreenTipsCon5TipsParentCon');
        parentCon.style.display = 'flex';
    }
    async _initTips() {
        // // just for now
        // return
        const con = document.getElementById('maiHomeScreenTipsCon5TipsCon');
        con.innerHTML = '';
        // Just to take the nesasary screen shots, on return
        this.#tipsToUse = [];
        const loadedTips = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getTips('catGeneral');
        console.log(loadedTips);
        // const tips = [...loadedTips].reverse();
        const tips = loadedTips;
        console.log(tips);
        tips.forEach((tip)=>{
            if (!tip.processing && tip.vidRes?.vid720Url) this.#tipsToUse.push(tip);
        });
        console.log(this.#tipsToUse);
        if (this.#tipsToUse.length < 1) return;
        this._videoClickEvents();
        this._showTips();
        this.#tipsToUse.forEach((tip, i)=>{
            console.log(tip);
            const html = (0, $c381627b4f215766$export$2e2bcd8739ae039)._generateTip(tip, i);
            con.insertAdjacentHTML('beforeend', html);
        });
        setTimeout(()=>{
        // this._openVideo(this.#tipsToUse[0])
        }, 10000);
    }
    _videoClickEvents() {
        const maiHomeScreenTipsCon5TipsCon = document.getElementById('maiHomeScreenTipsCon5TipsCon');
        maiHomeScreenTipsCon5TipsCon.addEventListener('click', (e)=>{
            console.log('This line');
            const isVideo = e.target.closest('.maiHomeScreenTipsCon6');
            if (!isVideo) return;
            console.log('This line');
            const videoIndex = isVideo.dataset.index;
            if (!videoIndex) return;
            console.log('This line');
            // this._openVideo(this.#tipsToUse[Number(videoIndex)])
            this._openVideo(this.#tipsToUse, videoIndex);
        });
    }
    async _sendNewComment(id, comment) {
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Enviando comentario');
            const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            if (!account) {
                (0, $5b997bd2b2817dfd$export$2e2bcd8739ae039)._displayOptions();
                return {
                    status: 'no-account'
                };
            }
            console.log(id, 'comment1:', comment);
            const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVCommentOnTips({
                tipId: id,
                comment: comment
            });
            console.log(result);
            if (result.data.success) return {
                status: 'success'
            };
            else throw new Error(result.data.message);
        } catch (error) {
            alert(error);
            return {
                status: 'error'
            };
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    async _deleteTipComment(tipId, commentId) {
        console.log(tipId, commentId);
        try {
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner('Eliminando comentario');
            const result = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._NVDeleteTipComment({
                tipId: tipId,
                commentId: commentId
            });
            console.log(result);
            if (result.data.success) return {
                success: true
            };
            else throw new Error(result.data.message);
        } catch (error) {
            alert(error);
            return {
                success: false
            };
        } finally{
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    _openVideo(tips, startIndex = 0) {
        const maiTipsReelsCloseButtonMain = document.getElementById("maiTipsReelsClose");
        const self = this;
        const openMaiTipsReels = async ()=>{
            const player = document.getElementById("maiTipsReelsPlayer");
            const scroll = document.getElementById("maiTipsReelsScroll");
            const template = document.getElementById("maiTipsReelTemplate");
            const closeButton = document.getElementById("maiTipsReelsClose");
            const commentsSheet = document.getElementById("maiTipsCommentsSheet");
            const commentsList = document.getElementById("maiTipsCommentsList");
            const commentsInput = document.getElementById("maiTipsCommentsInput");
            const commentsSend = document.getElementById("maiTipsCommentsSend");
            scroll.innerHTML = "";
            commentsInput.scrollIntoView({
                block: "nearest"
            });
            // =========================
            // BUILD REELS
            // =========================
            tips.forEach((tip, index)=>{
                const clone = template.content.cloneNode(true);
                const reel = clone.querySelector(".maiTipsReel");
                const video = clone.querySelector(".maiTipsReelVideo");
                const controls = clone.querySelector(".maiTipsReelControls");
                const title = clone.querySelector(".maiTipsReelTitle");
                const desc = clone.querySelector(".maiTipsReelDescription");
                const cta = clone.querySelector(".maiTipsReelCTA");
                const quality = clone.querySelector(".maiTipsReelQuality");
                const seek = clone.querySelector(".maiTipsReelSeek");
                const currentTimeEl = clone.querySelector(".maiTipsReelCurrentTime");
                const durationEl = clone.querySelector(".maiTipsReelDuration");
                const playPause = clone.querySelector(".maiTipsReelPlayPause");
                const commentsPreview = clone.querySelector(".maiTipsReelCommentsPreviewB");
                const openComments = clone.querySelector(".maiTipsReelCommentsPreview");
                const tapLayer = clone.querySelector(".maiTipsReelTapLayer");
                // =========================
                // CONTENT
                // =========================
                title.innerText = tip.title || "";
                desc.innerText = tip.context || "";
                // =========================
                // AUTO QUALITY
                // =========================
                const fast = navigator.connection && navigator.connection.downlink > 5;
                video.src = fast ? tip.vidRes?.vid1080Url : tip.vidRes?.vid720Url;
                video.poster = tip.images?.[0]?.res_1000 || tip.images?.[0]?.res_500 || "";
                // =========================
                // CTA
                // =========================
                if (tip.buttonType !== "none" && tip.buttonLink) {
                    cta.style.display = "flex";
                    cta.innerText = tip.buttonLabel || "Abrir";
                    cta.onclick = ()=>{
                        window.open(tip.buttonLink, "_blank");
                    };
                } else cta.style.display = "none";
                // =========================
                // SHOW CONTROLS
                // =========================
                function showControlsTemporarily() {
                    controls.classList.remove("hidden");
                    clearTimeout(reel.hideTimeout);
                    reel.hideTimeout = setTimeout(()=>{
                        if (!video.paused) controls.classList.add("hidden");
                    }, 2000);
                }
                // =========================
                // TAP LAYER
                // =========================
                tapLayer.onclick = ()=>{
                    const controlsVisible = !controls.classList.contains("hidden");
                    // CONTROLS VISIBLE
                    // → HIDE
                    if (controlsVisible) {
                        controls.classList.add("hidden");
                        return;
                    }
                    // CONTROLS HIDDEN
                    controls.classList.remove("hidden");
                    // VIDEO PAUSED
                    if (video.paused) {
                        video.play();
                        playPause.classList.add("playing");
                    } else {
                        video.pause();
                        playPause.classList.remove("playing");
                    }
                    showControlsTemporarily();
                };
                // =========================
                // SEEK BAR
                // =========================
                function formatTime(seconds) {
                    if (!seconds) return "0:00";
                    const mins = Math.floor(seconds / 60);
                    const secs = Math.floor(seconds % 60);
                    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
                }
                video.ontimeupdate = ()=>{
                    if (!video.duration) return;
                    seek.value = video.currentTime / video.duration * 100;
                    currentTimeEl.innerText = formatTime(video.currentTime);
                    durationEl.innerText = formatTime(video.duration);
                };
                seek.oninput = ()=>{
                    video.currentTime = seek.value / 100 * video.duration;
                    showControlsTemporarily();
                };
                // =========================
                // PLAY BUTTON
                // =========================
                playPause.onclick = ()=>{
                    if (video.paused) {
                        video.play();
                        playPause.classList.add("playing");
                    } else {
                        video.pause();
                        playPause.classList.remove("playing");
                    }
                    showControlsTemporarily();
                };
                // =========================
                // REWIND
                // =========================
                clone.querySelector(".rewind").onclick = ()=>{
                    video.currentTime -= 5;
                    showControlsTemporarily();
                };
                // =========================
                // FORWARD
                // =========================
                clone.querySelector(".forward").onclick = ()=>{
                    video.currentTime += 5;
                    showControlsTemporarily();
                };
                // =========================
                // QUALITY SWITCH
                // =========================
                quality.onchange = ()=>{
                    const current = video.currentTime;
                    if (quality.value === "720") video.src = tip.vidRes?.vid720Url;
                    else if (quality.value === "1080") video.src = tip.vidRes?.vid1080Url;
                    else video.src = fast ? tip.vidRes?.vid1080Url : tip.vidRes?.vid720Url;
                    video.load();
                    video.onloadedmetadata = ()=>{
                        video.currentTime = current;
                        video.play();
                    };
                };
                // =========================
                // COMMENTS PREVIEW
                // =========================
                (async ()=>{
                    try {
                        const comments = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._loadComments(`mercado_mai_tips/videos/tips/${tip.id}/comments`);
                        commentsPreview.innerHTML = "";
                        comments.slice(0, 1).forEach((comment)=>{
                            const div = document.createElement("div");
                            div.className = "maiTipsReelComment";
                            div.innerHTML = `

                            <div class="maiTipsReelCommentText1">
                                ${comment.name || "Usuario"}
                            </div>

                            <div class="maiTipsReelCommentText2">
                                ${comment.comment || ""}
                            </div>

                        `;
                            commentsPreview.appendChild(div);
                        });
                    } catch (err) {
                        console.error("Comments preview error:", err);
                    }
                })();
                // =========================
                // OPEN COMMENTS
                // =========================
                openComments.onclick = async ()=>{
                    try {
                        maiTipsReelsCloseButtonMain.style.display = "none";
                        commentsSheet.classList.add("open");
                        commentsList.innerHTML = "";
                        const comments = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._loadComments(`mercado_mai_tips/videos/tips/${tip.id}/comments`);
                        console.log(comments);
                        const account = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
                        comments.forEach((comment)=>{
                            const div = document.createElement("div");
                            div.className = "maiTipsCommentsItem";
                            // =========================
                            // CAN DELETE?
                            // =========================
                            const canDelete = account && account.userId && comment.uid === account.userId;
                            div.innerHTML = `

                                    <div class="maiTipsCommentsItemTop">

                                        <div class="maiTipsCommentsItemName">
                                            ${comment.name || "Usuario"}
                                        </div>

                                        ${canDelete ? `

                                            <div
                                                class="maiTipsCommentsDelete"
                                                data-comment-id="${comment.id}"
                                            >
                                                Eliminar
                                            </div>

                                        ` : ""}

                                    </div>

                                    <div class="maiTipsCommentsItemText">
                                        ${comment.comment || ""}
                                    </div>

                                `;
                            // =========================
                            // DELETE COMMENT
                            // =========================
                            if (canDelete) {
                                const deleteBtn = div.querySelector(".maiTipsCommentsDelete");
                                deleteBtn.onclick = async ()=>{
                                    try {
                                        const confirmDelete = confirm("\xbfEliminar comentario?");
                                        if (!confirmDelete) return;
                                        const res = await this._deleteTipComment(tip.id, comment.id);
                                        if (res?.success) div.remove();
                                    } catch (err) {
                                        console.error("Delete comment failed:", err);
                                    }
                                };
                            }
                            commentsList.appendChild(div);
                        });
                        // =========================
                        // SEND COMMENT
                        // =========================
                        commentsSend.onclick = async ()=>{
                            const value = commentsInput.value.trim();
                            if (!value) return;
                            try {
                                const res = await this._sendNewComment(tip.id, value);
                                if (res?.status === 'success') {
                                    console.log('Yep Here');
                                    commentsInput.value = "";
                                    openComments.click();
                                } else if (res?.status === 'no-account') {
                                    console.log('Yep Here');
                                    commentsSheet.classList.remove("open");
                                    maiTipsReelsCloseButtonMain.style.display = "flex";
                                    commentsInput.blur();
                                }
                            } catch (err) {
                                console.error("Comment send failed:", err);
                            }
                        };
                    } catch (err) {
                        console.error("Comments sheet error:", err);
                    }
                };
                scroll.appendChild(clone);
            });
            // =========================
            // SHOW PLAYER
            // =========================
            player.style.display = "block";
            requestAnimationFrame(()=>{
                scroll.scrollTo({
                    top: window.innerHeight * startIndex,
                    behavior: "auto"
                });
            });
            // =========================
            // AUTOPLAY
            // =========================
            setupReelsAutoplay();
            // =========================
            // CLOSE PLAYER
            // =========================
            closeButton.onclick = ()=>{
                player.style.display = "none";
                document.querySelectorAll(".maiTipsReelVideo").forEach((video)=>{
                    video.pause();
                    video.src = "";
                });
                commentsSheet.classList.remove("open");
                maiTipsReelsCloseButtonMain.style.display = "flex";
                commentsInput.blur();
            };
        };
        openMaiTipsReels();
        // =========================
        // COMMENTS CLICK OUTSIDE
        // =========================
        const clickButton = document.getElementById("maiTipsCommentsSheetHandle2");
        const commentsSheet = document.getElementById("maiTipsCommentsSheet");
        clickButton.onclick = (e)=>{
            commentsSheet.classList.remove("open");
            maiTipsReelsCloseButtonMain.style.display = "flex";
            const commentsInput = document.getElementById("maiTipsCommentsInput");
            commentsInput.blur();
        };
        // =========================
        // DRAG COMMENTS SHEET
        // =========================
        const handle = document.querySelector(".maiTipsCommentsSheetHandle2");
        let startY = 0;
        let currentY = 0;
        let dragging = false;
        handle.addEventListener("touchstart", (e)=>{
            // scroll.style.overflow = "hidden";
            dragging = true;
            startY = e.touches[0].clientY;
        });
        window.addEventListener("touchmove", (e)=>{
            if (!dragging) return;
            // 🚫 BLOCK PAGE/REELS SCROLL
            e.preventDefault();
            currentY = e.touches[0].clientY;
            const diff = currentY - startY;
            if (diff > 0) commentsSheet.style.transform = `translateY(${diff}px)`;
        }, // IMPORTANT
        {
            passive: false
        });
        window.addEventListener("touchend", ()=>{
            if (!dragging) return;
            dragging = false;
            // scroll.style.overflow = "";
            const diff = currentY - startY;
            // CLOSE
            if (diff > 120) {
                commentsSheet.classList.remove("open");
                maiTipsReelsCloseButtonMain.style.display = "flex";
                const commentsInput = document.getElementById("maiTipsCommentsInput");
                commentsInput.blur();
                commentsSheet.style.transform = "";
            } else commentsSheet.style.transform = "";
        });
        // =========================
        // AUTOPLAY VISIBLE
        // =========================
        function setupReelsAutoplay() {
            const videos = document.querySelectorAll(".maiTipsReelVideo");
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const video = entry.target;
                    const reel = video.closest(".maiTipsReel");
                    const controls = reel.querySelector(".maiTipsReelControls");
                    const playPause = reel.querySelector(".maiTipsReelPlayPause");
                    if (entry.isIntersecting) {
                        video.play();
                        commentsSheet.classList.remove("open");
                        maiTipsReelsCloseButtonMain.style.display = "flex";
                        const commentsInput = document.getElementById("maiTipsCommentsInput");
                        commentsInput.blur();
                        playPause.classList.add("playing");
                        setTimeout(()=>{
                            if (!video.paused) controls.classList.add("hidden");
                        }, 2000);
                    } else {
                        video.pause();
                        playPause.classList.remove("playing");
                    }
                });
            }, {
                threshold: 0.7
            });
            videos.forEach((video)=>observer.observe(video));
        }
        function handleIOSKeyboard() {
            const inputWrap = document.querySelector(".maiTipsCommentsInputWrap");
            if (!window.visualViewport) return;
            const viewport = window.visualViewport;
            const keyboardHeight = window.innerHeight - viewport.height - viewport.offsetTop;
            // =========================
            // KEYBOARD OPEN
            // =========================
            if (keyboardHeight > 100) inputWrap.style.transform = `translateY(-${keyboardHeight}px)`;
            else inputWrap.style.transform = `translateY(0px)`;
        }
        if (window.visualViewport) {
            visualViewport.addEventListener("resize", handleIOSKeyboard);
            visualViewport.addEventListener("scroll", handleIOSKeyboard);
        }
    }
}
var $dfd0ebd7df3b40be$export$2e2bcd8739ae039 = new $dfd0ebd7df3b40be$var$maiTips();


const $8e7556506143d1fe$var$omittedWords = [
    "for",
    "a",
    "the",
    "and"
];
// TODO these should be replaced with dinamic loaded adds for Production
const $8e7556506143d1fe$var$topAdds = [
    {
        id: 'ucibo3jbedcib3rend',
        title: {
            text: "Hasta 35% OFF",
            color: '#fff'
        },
        description: {
            text: "Ofertas en Mercado Libre",
            color: '#fff'
        },
        ctaText: {
            text: "\xa1No te lo pierdas!",
            color: '#fff'
        },
        items: [
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1815.jpg?alt=media&token=ed4853d1-28e1-4c99-a037-020cfa950a2d',
                text: 'VICTUS',
                openLink: 'https://meli.la/2KGtT8T'
            },
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1816.jpg?alt=media&token=bdf0b9a7-f9ae-40df-8020-be44d682b22f',
                text: 'VICTUS',
                openLink: 'https://meli.la/1MZyFkf'
            },
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1817.jpg?alt=media&token=cb8381c4-9d02-4ab9-a13d-837e53bddf1d',
                text: 'Laptop Hp',
                openLink: 'https://meli.la/2Z4aAHh'
            },
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1818.jpg?alt=media&token=630c4c5d-e4cd-4bee-9fa2-c4dc841d98d7',
                text: 'Laptop Acer Nitro',
                openLink: 'https://meli.la/1tDLr6D'
            }
        ],
        gradient: {
            type: "linear",
            angle: 135,
            stops: [
                {
                    color: "#F6E27A",
                    pos: 0
                },
                {
                    color: "#D4AF37",
                    pos: 45
                },
                {
                    color: "#B8962E",
                    pos: 100
                }
            ]
        },
        openLink: 'https://meli.la/263CnVV',
        button: {
            text: 'Ver Lista',
            textColor: '#000',
            buttonColor: '#ffffff'
        }
    },
    {
        id: 'ucibo3jbedcib3rend',
        title: {
            text: "iPhone ofertas",
            color: '#fff'
        },
        description: {
            text: "\xa1Encuentra el tuyo!",
            color: '#fff'
        },
        ctaText: {
            text: "Compra en Mercado Libre",
            color: '#fff'
        },
        items: [
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1820.jpg?alt=media&token=4e250ec0-4fbb-4edc-b0cf-4c1418e64591',
                text: 'iPhone 16e',
                openLink: 'https://meli.la/2n8bHCj'
            },
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1822.jpg?alt=media&token=c8f71b94-6e46-4141-8537-608554ee7942',
                text: 'iPhone 17 Pro Max',
                openLink: 'https://meli.la/2g4qa4g'
            },
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1823.jpg?alt=media&token=b22aa44f-c05f-4c0d-b8ee-4389d0df1e15',
                text: 'iPhone 15',
                openLink: 'https://meli.la/2j9dyrD'
            },
            {
                imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/images%20for%20test%2FIMG_1824.jpg?alt=media&token=bd3b518b-58e1-488e-b9c3-4631fed3a498',
                text: 'iPhone 16 Plus',
                openLink: 'https://meli.la/2ovmCEn'
            }
        ],
        gradient: {
            type: "linear",
            angle: 135,
            stops: [
                {
                    color: "#000000",
                    pos: 0
                },
                {
                    color: "#000000",
                    pos: 45
                },
                {
                    color: "#000000",
                    pos: 100
                }
            ]
        },
        openLink: 'https://meli.la/2xPumY8',
        button: {
            text: 'Ver Lista',
            textColor: '#000',
            buttonColor: '#ffffff'
        }
    }
];
class $8e7556506143d1fe$var$HomeScreen {
    #accountState;
    #alreadlyInitialized;
    #locationFilterTrigerFunctions = null;
    #listingsLastVisDoc = null;
    #allListingsLoaded = false;
    #detectBottomScrollListingnsOn = false;
    #isDoneLoadingListings = true;
    #isInitScreen = true;
    selectedLocationForFilter = {};
    #locationDataForFilter = {
        lat: null,
        lng: null,
        radius: 10
    };
    constructor(){}
    async _try() {
        const foundTargetedListings = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._globalTargetedSearch("sembradora");
        console.log(foundTargetedListings);
    }
    async _populateMachineDataInFireBase() {
        setTimeout(async ()=>{
            await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._storeMachineData("trilladora", "john-deere", "7721");
        }, 5000);
    }
    _observeElementTopVisibility(targetId, callback) {
        const el = document.getElementById(targetId);
        if (!el) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // 👇 element is visible in viewport
                if (entry.isIntersecting) {
                    if (!this.#isInitScreen) return;
                    callback(true, entry);
                } else {
                    if (!this.#isInitScreen) return;
                    // 👇 element is out of view (top or bottom)
                    callback(false, entry);
                }
            });
        }, {
            root: null,
            threshold: 0
        });
        observer.observe(el);
        return observer; // optional if you want to disconnect later
    }
    _detectScrollActivity(containerId, onScrollStart, onScrollStop, delay = 150) {
        const el = document.getElementById(containerId);
        if (!el) return;
        let scrollTimeout = null;
        let isScrolling = false;
        el.addEventListener("scroll", ()=>{
            // 🔥 SCROLL START
            if (!isScrolling) {
                isScrolling = true;
                onScrollStart?.();
            }
            // reset timer every scroll event
            clearTimeout(scrollTimeout);
            // 🛑 SCROLL STOP (after delay)
            scrollTimeout = setTimeout(()=>{
                isScrolling = false;
                onScrollStop?.();
            }, delay);
        });
    }
    _scrollToTop(containerId) {
        const el = document.getElementById(containerId);
        if (!el) return;
        el.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    async _handleSelectLocationForFilter() {
        try {
            const locationData = await (0, $a082c89adac62edb$export$2e2bcd8739ae039)._locationPicker(this.selectedLocationForFilter);
            this.selectedLocationForFilter = locationData;
            const locationTag = document.getElementById('locationFilterSelectedLocationTag');
            locationTag.textContent = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getDisplayLocationName(locationData);
            this.#locationDataForFilter.lat = locationData.lat;
            this.#locationDataForFilter.lng = locationData.lng;
            console.log('LocationData', locationData, this.#locationDataForFilter);
        } catch (error) {
            console.log(error);
            if (error === 'cancelled') {
                if (!this.selectedLocationForFilter?.address) alert("Nesecitas seleccionar una ubicaci\xf3n para poder filtrar 'Cerca de mi'");
            }
        }
    }
    async _events() {
        if (this.#alreadlyInitialized) return;
        const buttonToScrollToTop = document.getElementById('homeScreenDisplayInitialScreenScrollButtonScrollTop');
        buttonToScrollToTop.addEventListener('click', ()=>{
            this._scrollToTop('homeScreenDisplayInitialScreenScroll');
        });
        this._observeElementTopVisibility('initScreenCon3', (view)=>{
            const button = document.getElementById('homeScreenDisplayInitialScreenScrollButtonScrollTop');
            if (view) {
                console.log(view);
                // button.classList.remove('initScreenButtonScrollTopCon1Translate10Px')
                button.classList.add('initScreenButtonScrollTopCon1Translate100');
            } else {
                console.log(view);
                button.classList.remove('initScreenButtonScrollTopCon1Translate100');
                button.classList.add('initScreenButtonScrollTopCon1Translate10Px');
            }
        });
        this._detectScrollActivity("homeScreenDisplayInitialScreenScroll", // 🚀 scrolling started
        ()=>{
            const button = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
            button.classList.add("initScreenButtonScrollTopCon1Translate10Px");
        }, // 🛑 scrolling stopped
        ()=>{
            const button = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
            button.classList.remove("initScreenButtonScrollTopCon1Translate10Px");
        });
        // const HomeScreenButtonCreateListing = document.getElementById(
        //   "HomeScreenButtonCreateListing"
        // );
        window.addEventListener("click", async (e)=>{
            if (e.target.closest(".model1AddButtonClose")) {
                const parentAdd = e.target.closest(".model1AddCon1");
                if (parentAdd) parentAdd.remove();
            }
            if (e.target.closest("#HomeScreenButtonCreateListing")) {
                console.log("create lisitng called");
                (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
            }
            if (e.target.closest("#HomeScreenButtonCreateListingFloating")) {
                console.log("create listing called");
                (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
            }
            if (e.target.closest("#HomeScreenButtonHelp")) {
                console.log("create listing called");
                (0, $490f6a1b66767e47$export$2e2bcd8739ae039)._open();
            // CreateListing._init();
            }
            if (e.target.closest("#HeaderConWellcomeWithName")) // accountProfileChange._open();
            (0, $45b62c8178516fd3$export$2e2bcd8739ae039)._open();
            if (e.target.dataset.generall === "expandforviewall") {
                console.log("here");
                const parent = e.target.closest(".ListingPackDisplayCon1");
                const parentCon2 = parent.querySelector(".ListingPackDisplayCon3");
                const lastChild = parentCon2.lastElementChild; // Get the last child
                console.log(lastChild);
                if (lastChild) parentCon2.scrollTo({
                    left: lastChild.offsetLeft - parentCon2.offsetLeft,
                    behavior: "smooth"
                });
            // child.classList.toggle("VIEW-ALL-CLASS");
            }
            if (e.target.dataset.generall === "viewMore") {
                console.log("here");
                const parent = e.target.closest(".ListingPackDisplayCon1");
                const HomeScreenContenConForSeachAndAdd = document.getElementById("MainAppConWithNavigationContentConHome");
                const parentCon2 = parent.querySelector(".ListingPackDisplayCon3");
                const lastChild = parentCon2.lastElementChild; // Get the last child
                console.log(lastChild);
                if (lastChild) HomeScreenContenConForSeachAndAdd.scrollTo({
                    top: lastChild.offsetTop - parentCon2.offsetTop + lastChild.clientHeight,
                    behavior: "smooth"
                });
            // child.classList.toggle("VIEW-ALL-CLASS");
            }
            if (e.target.dataset.generall === "expandforviewallEditMode") {
                const parent = e.target.closest(".OwnBusinessListingsCon2");
                const parentCon2 = parent.querySelector(".OwnBusinessListingsCon4");
                const lastChild = parentCon2.lastElementChild; // Get the last child
                if (lastChild) parentCon2.scrollTo({
                    left: lastChild.offsetLeft - parentCon2.offsetLeft,
                    behavior: "smooth"
                });
            }
            if (e.target.dataset.generall === "expandforviewallbusiness") {
                const parent = e.target.closest(".BusinessesPackDisplayCon1");
                const parentCon2 = parent.querySelector(".BusinessesPackDisplayCon3");
                const lastChild = parentCon2.lastElementChild; // Get the last child
                if (lastChild) parentCon2.scrollTo({
                    left: lastChild.offsetLeft - parentCon2.offsetLeft,
                    behavior: "smooth"
                });
            }
        });
        window.addEventListener("click", (e)=>{
            const help = e.target.closest(".openHelp");
            if (help) {
                const helpWith = help.dataset.helpwith;
            }
        });
        const locationFilterTagButtonOpenLocation = document.getElementById("locationFilterTagButtonOpenLocation");
        const locationFilterButtonOpenLocation = document.getElementById("locationFilterButtonOpenLocation");
        const locationFilterButtonCloseFilter = document.getElementById("locationFilterButtonCloseFilter");
        const locationFilterButtonAplyFilter = document.getElementById("locationFilterButtonAplyFilter");
        const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");
        locationFilterButtonCloseFilter.addEventListener("click", ()=>{
            this._closeLocationFilter();
        });
        locationFilterButtonAplyFilter.addEventListener("click", ()=>{
            this.#locationFilterTrigerFunctions.applyFilter(this.#locationDataForFilter);
            console.log('this.#locationDataForFilter', this.#locationDataForFilter);
        });
        locationFilterOpenerCon.addEventListener("click", ()=>{
            this._openLocationFilter();
        });
        locationFilterButtonOpenLocation.addEventListener("click", async ()=>{
            this._handleSelectLocationForFilter();
        });
        locationFilterTagButtonOpenLocation.addEventListener("click", async ()=>{
            this._handleSelectLocationForFilter();
        });
        const SearchStartUpComponentSearchInput = document.getElementById("SearchStartUpComponentSearchInput");
        const homeScreenDisplayAllButtonCloseSearch = document.getElementById("homeScreenDisplayAllButtonCloseSearch");
        homeScreenDisplayAllButtonCloseSearch.addEventListener("click", (e)=>{
            const close = homeScreenDisplayAllButtonCloseSearch.dataset.close;
            console.log(close);
            if (close) {
                if (close === 'location') this._closeLocationFilter();
                if (close === 'search') this._closeSearch();
            }
        });
        SearchStartUpComponentSearchInput.addEventListener("focus", ()=>{
            this._openSearch();
        });
        const initKmSelector = (containerSelector)=>{
            let currentLocationRadius = '10';
            const container = document.getElementById(containerSelector);
            const items = Array.from(container.querySelectorAll('.locationFilterKmCon7'));
            const updateActive = ()=>{
                const containerRect = container.getBoundingClientRect();
                const centerY = containerRect.top + containerRect.height / 2;
                let closestItem = null;
                let closestDistance = Infinity;
                items.forEach((item)=>{
                    const rect = item.getBoundingClientRect();
                    const itemCenter = rect.top + rect.height / 2;
                    const distance = Math.abs(centerY - itemCenter);
                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestItem = item;
                    }
                });
                items.forEach((item)=>item.classList.remove('active'));
                if (closestItem) {
                    closestItem.classList.add('active');
                    // ✅ log selected km
                    const km = closestItem.dataset.km;
                    if (currentLocationRadius !== km) {
                        currentLocationRadius = km;
                        this.#locationDataForFilter.radius = Number(km);
                    }
                }
            };
            // Run on scroll
            container.addEventListener('scroll', updateActive);
            // Run once on init
            updateActive();
        };
        initKmSelector('locationFilterKmCon5');
    }
    _clearContainer() {
        const HomeScreenContenConForAll = document.getElementById("MainAppConWithNavigationContentConHome");
        HomeScreenContenConForAll.innerHTML = "";
    }
    //
    //
    _displayRightNavWindow() {
        const windows = document.querySelectorAll(".MainAppConWithNavigationContentCon");
        windows.forEach((window1)=>{
            if (window1.id === "MainAppConWithNavigationContentConHome") window1.style.display = "";
            else window1.style.display = "none";
        });
    }
    _screensSwitch(initial = true) {
        const homeScreenDisplayAll = document.getElementById("homeScreenDisplayAll");
        const homeScreenDisplayInitialScreen = document.getElementById("homeScreenDisplayInitialScreen");
        if (initial) {
            homeScreenDisplayAll.style.display = "none";
            homeScreenDisplayInitialScreen.style.display = "flex";
            this.#isInitScreen = true;
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._show(false);
        } else {
            homeScreenDisplayAll.style.display = "flex";
            homeScreenDisplayInitialScreen.style.display = "none";
            this.#isInitScreen = false;
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._hide(true);
        }
    }
    async _init(init) {
        if (this.#alreadlyInitialized && !init) (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._scrollToTopOfCurrentCategory();
        else {
            this.#accountState = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
            this._clearContainer();
            this._inserntSearchComponent();
            (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._init();
            this._events();
            (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._initNavObserver();
            this._displayRightNavWindow();
            this.#alreadlyInitialized = true;
            this._screensSwitch(true);
            this._navigateFromInitScreenInit();
            this._startGetLoop(10, true);
        // this._setTopAdds()
        }
        this._displayRightNavWindow();
        (0, $dfd0ebd7df3b40be$export$2e2bcd8739ae039)._initTips();
    }
    _makeAddSetToInsert() {
        var add;
        return '';
    }
    _setTopAdds() {
        var add, e;
        return;
    }
    async _startGetLoop(maxListings = 10, reset) {
        // 🔥 BLOCK immediately
        if (!this.#isDoneLoadingListings) return;
        if (this.#allListingsLoaded) return;
        this.#isDoneLoadingListings = false;
        if (reset) {
            this.#listingsLastVisDoc = null;
            this.#allListingsLoaded = false;
        }
        try {
            const { listings: listings, lastVisibleDoc: lastVisibleDoc } = await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getMostRecentListingsWithOutFilterGlobal(this.#listingsLastVisDoc, maxListings);
            if (!listings || listings.length === 0) {
                this.#allListingsLoaded = true;
                return;
            }
            console.log(listings);
            this._fillListings(listings, reset);
            this.#listingsLastVisDoc = lastVisibleDoc;
        } finally{
            // ✅ UNLOCK after everything is done
            this.#isDoneLoadingListings = true;
            this._activateDetectScrollToBottomListings(100);
        }
    }
    async _fillListings(listings, reset) {
        const ListingsContianer = document.getElementById("initScreenInsertListings");
        if (reset) ListingsContianer.innerHTML = "";
        for (const listing of listings){
            let html = (0, $64185892d2bdb50b$export$2e2bcd8739ae039)._listingVerticalNV(listing);
            ListingsContianer.insertAdjacentHTML("beforeend", html);
        }
        const addSet = this._makeAddSetToInsert();
        ListingsContianer.insertAdjacentHTML("beforeend", addSet);
    }
    _activateDetectScrollToBottomListings = (margin = 0)=>{
        if (this.#detectBottomScrollListingnsOn) return;
        this.#detectBottomScrollListingnsOn = true;
        const reuseFunction = (id)=>{
            const container = document.getElementById(id);
            if (!container) {
                console.log("Error: Container not found.");
                return;
            }
            // Add a scroll event listener
            container.addEventListener("scroll", async ()=>{
                if (!this.#isDoneLoadingListings) return;
                const isScrolledToBottom = container.scrollHeight - container.scrollTop - container.clientHeight <= margin;
                if (isScrolledToBottom) this._startGetLoop(10);
            });
        };
        reuseFunction('homeScreenDisplayInitialScreenScroll');
    };
    _navigateFromInitScreenInit() {
        const initScreenOpenSearch = document.getElementById('initScreenOpenSearch');
        const initScreenOpenListings = document.getElementById('initScreenOpenListings');
        const initScreenOpenBusinesses = document.getElementById('initScreenOpenBusinesses');
        const initScreenOpenSellers = document.getElementById('initScreenOpenSellers');
        const homeScreenDisplayAllButtonBack = document.getElementById('homeScreenDisplayAllButtonBack');
        const homeScreenLocationFilterCtaCon2 = document.getElementById("homeScreenLocationFilterCtaCon2");
        const homeScreenUploadCtaCon2 = document.getElementById("homeScreenUploadCtaCon2");
        homeScreenLocationFilterCtaCon2.addEventListener("click", async ()=>{
            this._screensSwitch(false);
            (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._setActiveCategory('listings', 'locationFilter');
        // setTimeout(() => {
        //   this._openLocationFilter();
        // }, 500);
        });
        homeScreenUploadCtaCon2.addEventListener("click", async ()=>{
            (0, $4f930c604957bd07$export$2e2bcd8739ae039)._init();
        });
        initScreenOpenSearch.addEventListener('click', ()=>{
            this._screensSwitch(false);
            (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._setActiveCategory('listings', 'search');
        });
        initScreenOpenListings.addEventListener('click', ()=>{
            this._screensSwitch(false);
            (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._setActiveCategory('listings', 'all');
        });
        initScreenOpenBusinesses.addEventListener('click', ()=>{
            this._screensSwitch(false);
            (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._setActiveCategory('businesses');
        });
        initScreenOpenSellers.addEventListener('click', ()=>{
            this._screensSwitch(false);
            (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._setActiveCategory('indsellers');
        });
        homeScreenDisplayAllButtonBack.addEventListener('click', ()=>{
            this._screensSwitch(true);
            const buttonScrollTop = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
            buttonScrollTop.style.display = "flex";
        });
    }
    _openSearch() {
        let text = 'Buscando en "Listados"';
        const currentCat = (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._getCurrentCategory();
        if (currentCat === "listings") text = 'Buscando en "Listados"';
        if (currentCat === "businesses") text = 'Buscando en "Negocios"';
        if (currentCat === "indsellers") text = 'Buscando en "Vendedores"';
        const homeHeaderSearchCon10A = document.getElementById("homeHeaderSearchCon10A");
        const HomeScreenButtonCreateListing = document.getElementById("HomeScreenButtonCreateListing");
        const SearchStartUpComponentSearchInputIcon = document.getElementById("SearchStartUpComponentSearchInputIcon");
        const HomeScreenCon3 = document.getElementById("HomeScreenCon3");
        const homeHeaderSearchCon13 = document.getElementById("homeHeaderSearchCon13");
        const SearchStartUpComponentSearchInput = document.getElementById("SearchStartUpComponentSearchInput");
        const homeHeaderSearchCon10 = document.getElementById("homeHeaderSearchCon10");
        const homeHeaderSearchCatCon = document.getElementById("homeHeaderSearchCatCon");
        const homeHeaderSearchCon9 = document.getElementById("homeHeaderSearchCon9");
        const nvHeaderCon2BigAddContainer = document.getElementById("nvHeaderCon2BigAddContainer");
        const homeScreenDisplayAllButtonBack = document.getElementById("homeScreenDisplayAllButtonBack");
        const homeScreenDisplayAllButtonCloseSearch = document.getElementById("homeScreenDisplayAllButtonCloseSearch");
        SearchStartUpComponentSearchInputIcon.style.display = "none";
        homeScreenDisplayAllButtonBack.style.display = "none";
        homeScreenDisplayAllButtonCloseSearch.style.display = "flex";
        homeScreenDisplayAllButtonCloseSearch.dataset.close = "search";
        homeHeaderSearchCon10.classList.add("homeHeaderSearchCon10Act");
        SearchStartUpComponentSearchInput.classList.add("SearchStartUpComponentCon5InputAct");
        (0, $84d4f35da787c4f0$export$2e2bcd8739ae039)._hideDispBigVideoAdd('hide');
        HomeScreenButtonCreateListing.style.display = "none";
        homeHeaderSearchCon10A.classList.remove("homeHeaderSearchCon10APaddingLeft");
        homeHeaderSearchCatCon.style.display = "none";
        (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._hide();
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._startSearch();
    }
    _closeSearch() {
        const homeHeaderSearchCon10A = document.getElementById("homeHeaderSearchCon10A");
        const HomeScreenButtonCreateListing = document.getElementById("HomeScreenButtonCreateListing");
        const SearchStartUpComponentSearchInputIcon = document.getElementById("SearchStartUpComponentSearchInputIcon");
        const SearchStartUpComponentSearchInput = document.getElementById("SearchStartUpComponentSearchInput");
        const homeHeaderSearchCon10 = document.getElementById("homeHeaderSearchCon10");
        const homeHeaderSearchCatCon = document.getElementById("homeHeaderSearchCatCon");
        const homeScreenDisplayAllButtonBack = document.getElementById("homeScreenDisplayAllButtonBack");
        const homeScreenDisplayAllButtonCloseSearch = document.getElementById("homeScreenDisplayAllButtonCloseSearch");
        homeScreenDisplayAllButtonBack.style.display = "flex";
        homeScreenDisplayAllButtonCloseSearch.style.display = "none";
        SearchStartUpComponentSearchInput.value = "";
        homeHeaderSearchCon10.classList.remove("homeHeaderSearchCon10Act");
        SearchStartUpComponentSearchInput.classList.remove("SearchStartUpComponentCon5InputAct");
        SearchStartUpComponentSearchInputIcon.style.display = "flex";
        HomeScreenButtonCreateListing.style.display = "flex";
        homeHeaderSearchCon10A.classList.add("homeHeaderSearchCon10APaddingLeft");
        homeHeaderSearchCatCon.style.display = "flex";
        (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._show();
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._endSearch();
        (0, $84d4f35da787c4f0$export$2e2bcd8739ae039)._hideDispBigVideoAdd('show');
    }
    _openLocationFilter() {
        const homeHeaderSearchCatCon = document.getElementById("homeHeaderSearchCatCon");
        const homeHeaderSearchCon10A = document.getElementById("homeHeaderSearchCon10A");
        const homeScreenDisplayAllButtonCloseSearch = document.getElementById("homeScreenDisplayAllButtonCloseSearch");
        const homeScreenDisplayAllButtonBack = document.getElementById("homeScreenDisplayAllButtonBack");
        const homeHeaderSearchCon10 = document.getElementById("homeHeaderSearchCon10");
        const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
        const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");
        locationFilterAdjCon.style.display = "flex";
        locationFilterOpenerCon.style.display = "none";
        homeHeaderSearchCatCon.style.display = "none";
        homeScreenDisplayAllButtonCloseSearch.style.display = "none";
        homeScreenDisplayAllButtonCloseSearch.dataset.close = "location";
        homeHeaderSearchCon10A.style.display = "none";
        this.#locationFilterTrigerFunctions = (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._startLocationFilter();
    // SearchStartUpComponentSearchInputIcon.style.display = "none";
    // SearchStartUpComponentSearchInput.classList.add(
    //   "SearchStartUpComponentCon5InputAct"
    // );
    // adds._hideDispBigVideoAdd('hide')
    // HomeScreenButtonCreateListing.style.display = "none";
    // nav._hide();
    // allHandeling._startSearch();
    }
    _closeLocationFilter() {
        const homeHeaderSearchCatCon = document.getElementById("homeHeaderSearchCatCon");
        const homeScreenDisplayAllButtonCloseSearch = document.getElementById("homeScreenDisplayAllButtonCloseSearch");
        const homeScreenDisplayAllButtonBack = document.getElementById("homeScreenDisplayAllButtonBack");
        const homeHeaderSearchCon10 = document.getElementById("homeHeaderSearchCon10");
        const homeHeaderSearchCon10A = document.getElementById("homeHeaderSearchCon10A");
        const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
        const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");
        locationFilterAdjCon.style.display = "none";
        locationFilterOpenerCon.style.display = "flex";
        homeHeaderSearchCatCon.style.display = "flex";
        homeHeaderSearchCon10A.style.display = "flex";
        homeScreenDisplayAllButtonCloseSearch.style.display = "none";
        // nav._show();
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._endLocationFilter();
    // adds._hideDispBigVideoAdd('show')
    }
    _inserntSearchComponent() {
        const HomeScreenContenConForSeachAndAdd = document.getElementById("MainAppConWithNavigationContentConHome");
        HomeScreenContenConForSeachAndAdd.innerHTML = "";
        const topToolsSetterComponent = (0, $632c6627a2700d24$export$2e2bcd8739ae039)._topToolsSetter();
        HomeScreenContenConForSeachAndAdd.insertAdjacentHTML("beforeend", topToolsSetterComponent);
        // allHandeling._startInitialLoading();
        (0, $3932d5095c13a35b$export$2e2bcd8739ae039)._setActiveCategory('listings');
    }
}
var $8e7556506143d1fe$export$2e2bcd8739ae039 = new $8e7556506143d1fe$var$HomeScreen();







class $44000a6e927f1f0a$var$Nav {
    #navWas = "Home";
    #navIs = "Home";
    #keepHidden = false;
    constructor(){
        this.icons = {
            Home: {
                active: (0, (/*@__PURE__*/$parcel$interopDefault($88f9782579f7686d$exports))),
                inactive: (0, (/*@__PURE__*/$parcel$interopDefault($58e6274e123f7274$exports)))
            },
            Notification: {
                active: (0, (/*@__PURE__*/$parcel$interopDefault($4cb497ff9fea61cf$exports))),
                inactive: (0, (/*@__PURE__*/$parcel$interopDefault($3d1e6e71eb7e5348$exports)))
            },
            // Wallet: { active: iconNavActWallet, inactive: iconNavWallet },
            Activity: {
                active: (0, (/*@__PURE__*/$parcel$interopDefault($552f21117d8c010d$exports))),
                inactive: (0, (/*@__PURE__*/$parcel$interopDefault($532b86f0cc5dafb6$exports)))
            },
            Menu: {
                active: (0, (/*@__PURE__*/$parcel$interopDefault($3b1f096ec516b8ec$exports))),
                inactive: (0, (/*@__PURE__*/$parcel$interopDefault($14fe910e53b1d182$exports)))
            }
        };
    }
    _changeNav(InNav) {
        if (InNav === "Menu") return;
        const navTaps = document.querySelectorAll(".NavBarCon2");
        let menuOption = InNav;
        if (InNav === "last") menuOption = this.#navWas;
        navTaps.forEach((navTap)=>{
            const navIcon = navTap.querySelector(".NavBarIconCon");
            const NavActiveBar = navTap.querySelector(".NavBarCon2D");
            const NavActiveBarText = navTap.querySelector(".NavBarText");
            if (navIcon && NavActiveBar) {
                // console.log('here', navTap);
                if (navTap.dataset.menuoption === menuOption) {
                    // console.log('here', navTap);
                    navTap.classList.add("NavBarCon2DAct");
                    NavActiveBarText.classList.add("NavBarTextAct");
                    navIcon.src = this.icons[menuOption].active;
                } else {
                    navIcon.src = this.icons[navTap.dataset.menuoption].inactive;
                    navTap.classList.remove("NavBarCon2DAct");
                    NavActiveBarText.classList.remove("NavBarTextAct");
                }
            }
        });
    }
    _blockNav(block) {
        const HeaderCon1BolckAction = document.getElementById("HeaderCon1BolckAction");
        const NavBarCon1BlockNav = document.getElementById("NavBarCon1BlockNav");
        if (block) {
            HeaderCon1BolckAction.style.display = "flex";
            NavBarCon1BlockNav.style.display = "flex";
        } else {
            HeaderCon1BolckAction.style.display = "none";
            NavBarCon1BlockNav.style.display = "none";
        }
    }
    _init(NavIn = 'Home', tab = 'businesses') {
        const navBar = document.getElementById("NavBarCon1");
        // const ButtonReward = document.getElementById("ButtonReward");
        // ButtonReward.addEventListener("click", () => {
        //   alert('Estamos desarollando un sistema para que tu podrás generar ingresos extras con Mercado MAI. Si ya estás esperando esto, porfavor mandanos un WhtasApp al: +52 981 107 2143, para decirnos tus sugerencias.')
        // })
        navBar.addEventListener("click", (e)=>{
            const buttonScrollTop = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
            if (buttonScrollTop) buttonScrollTop.style.display = 'none';
            const closestNavOption = e.target.closest('.NavBarCon2');
            if (!closestNavOption) return;
            const navOption = closestNavOption.dataset.menuoption;
            this._changeNav(navOption);
            if (this.#navIs !== "Menu") this.#navWas = this.#navIs;
            this.#navIs = navOption;
            if (navOption === "Menu") (0, $5328a9c179d47403$export$2e2bcd8739ae039)._setMenu();
            if (navOption === "Home") {
                (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._init();
                if (buttonScrollTop) buttonScrollTop.style.display = 'flex';
            }
            if (navOption === "Activity") (0, $fec3fe9805a53782$export$2e2bcd8739ae039)._init(tab);
            if (navOption === "Wallet") // wallet._open();
            console.log("wallet now");
            if (navOption === "Notification") (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
        });
        this._changeNav(NavIn);
    }
    _initNavObserver() {
        function translateElementY(id, yPx) {
            const el = document.getElementById(id);
            if (!el) {
                console.warn(`Element not found: ${id}`);
                return;
            }
            el.style.transform = `translateY(${yPx}px)`;
        }
        const action = (isGreater, width)=>{
            const navButtonPublishCon1B = document.getElementById("navButtonPublishCon1B");
            const navButtonPublishCon1 = document.getElementById("navButtonPublishCon1");
            const btnScrollTop = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
            console.log('Width:', width);
            if (isGreater) {
                console.log('Element is larger than 500px');
                navButtonPublishCon1B.style.display = "none";
                navButtonPublishCon1.style.display = "flex";
                btnScrollTop.classList.remove('initScreenButtonScrollTopCon1Bottom180');
            } else {
                console.log('Element is smaller than 500px');
                navButtonPublishCon1B.style.display = "flex";
                navButtonPublishCon1.style.display = "none";
                btnScrollTop.classList.add('initScreenButtonScrollTopCon1Bottom180');
            }
        };
        function watchElementWidth(id, minWidth) {
            const el = document.getElementById(id);
            if (!el) {
                console.warn(`Element not found: ${id}`);
                return;
            }
            // Initial check
            action(el.offsetWidth > minWidth, el.offsetWidth);
            // Live resize observer
            const observer = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    const width = entry.contentRect.width;
                    action(width > minWidth, width);
                }
            });
            observer.observe(el);
            // Optional cleanup return
            return ()=>observer.disconnect();
        }
        watchElementWidth('NavBarCon1', 360);
    }
    _hide(keepHidden = false) {
        if (keepHidden) this.#keepHidden = true;
        const NavBarCon1 = document.getElementById("NavBarCon1");
        // NavBarCon1.style.display = "none";
        NavBarCon1.classList.add("homeHeaderSearchCon1disapearNav");
    }
    _show(keepHidden = true) {
        if (!keepHidden) this.#keepHidden = false;
        if (this.#keepHidden) return;
        const NavBarCon1 = document.getElementById("NavBarCon1");
        NavBarCon1.classList.remove("homeHeaderSearchCon1disapearNav");
    // NavBarCon1.style.display = "flex";
    }
}
var $44000a6e927f1f0a$export$2e2bcd8739ae039 = new $44000a6e927f1f0a$var$Nav();







class $553d90f630b14a75$var$generateHtml {
    // Start new type of Main screen
    _HeaderTop(helloMesage, userName) {
        console.log("trigered");
        return `
<div id="HeaderCon2ForColorChangeWhenMiniScreenOnDisplay" class="HeaderCon1">
  <div id="HeaderCon1BolckAction" class="HeaderCon1BolckAction" style="display: none"></div>

</div>
    `;
    }
    _FooterNavBar() {
        return `
    <div id="NavBarCon1" class="NavBarCon1">

      <div id="navButtonPublishCon1B" class="navButtonPublishCon1B">
        <div id="HomeScreenButtonCreateListingFloating" class="navButtonPublishCon2B">
          <img class="navButtonPublishConIconB" src="${0, (/*@__PURE__*/$parcel$interopDefault($d9126ea873ff0a97$exports))}" alt="Saved Icon" />
        </div>
      </div>

      <div class="NavBarCon1A">
        <div id="NavBarCon1BlockNav" class="NavBarCon1BlockNav" style="display: none"></div>

        <div class="NavBarCon1B">
          <div data-menuoption="Menu" class="NavBarCon2">
            <div class="NavBarCon2D">
              <img class="NavBarIconCon" src="${0, (/*@__PURE__*/$parcel$interopDefault($14fe910e53b1d182$exports))}" alt="Menu Icon" />
              <div class="NavBarText">Menu</div>
            </div>
          </div>

          <div data-menuoption="Notification" class="NavBarCon2">
            <div class="NavBarCon2D">
              <img class="NavBarIconCon" src="${0, (/*@__PURE__*/$parcel$interopDefault($3d1e6e71eb7e5348$exports))}" alt="Saved Icon" />
              <div class="NavBarText">Noti</div>
            </div>
          </div>

          <div data-menuoption="Activity" class="NavBarCon2">
            <div class="NavBarCon2D">
              <img class="NavBarIconCon" src="${0, (/*@__PURE__*/$parcel$interopDefault($532b86f0cc5dafb6$exports))}" alt="Business Icon" />
              <div class="NavBarText">Actividad</div>
            </div>
          </div>

          <div data-menuoption="Home" class="NavBarCon2 NavBarCon2DAct">
            <div class="NavBarCon2D">
              <img class="NavBarIconCon" src="${0, (/*@__PURE__*/$parcel$interopDefault($58e6274e123f7274$exports))}" alt="Home Icon" />
              <div class="NavBarText">Inicio</div>
            </div>
          </div>
        </div>

        <div id="navButtonPublishCon1" class="navButtonPublishCon1">
          <div id="HomeScreenButtonCreateListing" class="navButtonPublishCon2">
            <img class="navButtonPublishConIcon" src="${0, (/*@__PURE__*/$parcel$interopDefault($d9126ea873ff0a97$exports))}" alt="Saved Icon" />
          </div>
        </div>



      </div>

    </div>
    `;
    }
    _initialMainScreenGeneration(htmlHeaderNav, htmlFooterNav) {
        return `
  <div class="MainAppConWithNavigationCon2">
    ${htmlHeaderNav}
    <div id="MainAppConWithNavigationCon2BWholeHeader" class="MainAppConWithNavigationCon2B"></div>
    <div class="MainAppConWithNavigationCon">
      <div id="MainAppConWithNavigationContentConHome" style="display: none" class="MainAppConWithNavigationContentCon"></div>
      <div id="MainAppConWithNavigationContentConBusiness" style="display: none" class="MainAppConWithNavigationContentCon"></div>
      <div id="MainAppConWithNavigationContentConWallet" style="display: none" class="MainAppConWithNavigationContentCon"></div>
      <div id="MainAppConWithNavigationContentConSaved" style="display: none" class="MainAppConWithNavigationContentCon"></div>
    </div>
    ${htmlFooterNav}
  </div>
    `;
    }
}
var $553d90f630b14a75$export$2e2bcd8739ae039 = new $553d90f630b14a75$var$generateHtml();







// import ratingNow from "../rating-now.js";
// ratingNow._open();
// import openLinks from "../open-links/open-links.js";
// import { doc } from "firebase/firestore";
// TODO This code here is for onbording tours
// import OnboardingTour from "../onboarding-tour";
// const message = [
//   {
//     message: "Take this onboarding tour",
//     attachEl: `${this.#prefixId}ActivateOnlyBusinessSeachingButton`,
//     // hideAfter: 3000,
//     buttonNext: "Step 3",
//     buttonBack: "Step 1",
//     buttonFinish: "Done",
//   },
//   {
//     message: "Take this onboarding tour step 2",
//     attachEl: `${this.#prefixId}ActivateOnlyBusinessSeachingButton`,
//     // hideAfter: 3000,
//     buttonNext: "Step 3",
//     buttonBack: "Step 1",
//     buttonFinish: "Done",
//   },
// ];
// const TakeTour = new OnboardingTour(message);
// TakeTour.start();
class $126d653b8453b922$var$StartUpMainApp {
    #accountState;
    #mainNavInitialized;
    #lastReloadedTimeStamp;
    #reloadActive;
    #isMainInitialized = false;
    constructor(){
    // TODO activate to track user visits
    }
    _changeUserNameOnHeader() {
        const HeaderUserName = document.querySelector(".HeaderUserName");
        let name = "registrate";
        HeaderUserName.style.color = "#FF8400";
        if (this.#accountState) {
            if (this.#accountState.userName) {
                name = this.#accountState.userName;
                HeaderUserName.style.color = "#FFFFFF";
            } else {
                name = "! nombre";
                HeaderUserName.style.color = "#FF8400";
            }
        }
        HeaderUserName.textContent = name;
    }
    async _init() {
        this.#reloadActive = false;
        this.#mainNavInitialized = false;
        this.#accountState = (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getLatestCurrentUserData();
        if (!this.#accountState) {
            console.log("no account found");
            (0, $345d151430356fa0$export$2e2bcd8739ae039)._openCTARegister();
        }
        if (this.#isMainInitialized) return;
        this.#isMainInitialized = true;
        (0, $5df95a5c365eca14$export$2e2bcd8739ae039)._init();
        this._setHomeScreen();
        (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._init();
        (0, $8e7556506143d1fe$export$2e2bcd8739ae039)._init(true);
        // this._changeUserNameOnHeader();
        (0, $a7738523b33a53ea$export$2e2bcd8739ae039)._setPromtLoaded();
    }
    _clearContainer() {
        const MainAppContentContainer = document.getElementById("MainAppContentContainer");
        MainAppContentContainer.innerHTML = "";
    }
    _setHomeScreen() {
        const container = document.getElementById("MainAppContentContainer");
        let helloMesage = "Hola,";
        let userName = "Sin cuenta";
        if (this.#accountState) {
            helloMesage = "Hola,";
            userName = this.#accountState.userName;
        }
        const HeaderHtml = (0, $553d90f630b14a75$export$2e2bcd8739ae039)._HeaderTop(helloMesage, userName);
        const FooterHtml = (0, $553d90f630b14a75$export$2e2bcd8739ae039)._FooterNavBar();
        container.innerHTML = "";
        if (!this.#mainNavInitialized) {
            const MainScreenHtml = (0, $553d90f630b14a75$export$2e2bcd8739ae039)._initialMainScreenGeneration(HeaderHtml, FooterHtml);
            container.insertAdjacentHTML("beforeend", MainScreenHtml);
        }
        this._RELOAD();
        this.#mainNavInitialized = true;
    // this._clearContainer();
    }
    _RELOAD() {
        const container = document.getElementById("MainAppConWithNavigationContentConHome");
        let isCountDonwRunnig = false;
        let countDown;
        // Listen for the scroll event to detect pull down
        container.addEventListener("scroll", ()=>{
            const HomeScreenContenConForSeachAndAddReloadMessage = document.getElementById("HomeScreenContenConForSeachAndAddReloadMessage");
            if (container.scrollTop < 1) {
                HomeScreenContenConForSeachAndAddReloadMessage.textContent = "Mantener para actualizar";
                const now = Date.now();
                const calculated = now - this.#lastReloadedTimeStamp;
                if (this.#lastReloadedTimeStamp) {
                    if (calculated < 1000) return;
                }
                if (isCountDonwRunnig) return;
                isCountDonwRunnig = true;
                countDown = setTimeout(async ()=>{
                    await (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._getUserDataFromBase();
                    isCountDonwRunnig = false;
                    this.#lastReloadedTimeStamp = Date.now();
                }, 250);
            } else HomeScreenContenConForSeachAndAddReloadMessage.textContent = "Deslizar hacia abajo para actualizar";
            if (container.scrollTop > 0 && isCountDonwRunnig) {
                isCountDonwRunnig = false;
                clearTimeout(countDown);
            }
        });
        this.#reloadActive = true;
    }
}
var $126d653b8453b922$export$2e2bcd8739ae039 = new $126d653b8453b922$var$StartUpMainApp();



const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $568f4ee4022ba00e$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    return ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset);
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))();
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;



var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "11.0.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $57d436074e210fb5$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');







/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $a0779144dbc42ee1$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $a0779144dbc42ee1$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $a0779144dbc42ee1$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $a0779144dbc42ee1$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $a0779144dbc42ee1$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.'
    };
}
function $a0779144dbc42ee1$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $a0779144dbc42ee1$export$2329c99376c9d0a4 = $a0779144dbc42ee1$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $a0779144dbc42ee1$export$7f8ddf7c7c20b3cd = $a0779144dbc42ee1$var$_prodErrorMap;
const $a0779144dbc42ee1$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $a0779144dbc42ee1$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $a0779144dbc42ee1$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$logClient = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/auth');
function $a0779144dbc42ee1$var$_logWarn(msg, ...args) {
    if ($a0779144dbc42ee1$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) $a0779144dbc42ee1$var$logClient.warn(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $a0779144dbc42ee1$var$_logError(msg, ...args) {
    if ($a0779144dbc42ee1$var$logClient.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) $a0779144dbc42ee1$var$logClient.error(`Auth (${(0, $57d436074e210fb5$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $a0779144dbc42ee1$var$createErrorInternal(authOrCode, ...rest);
}
function $a0779144dbc42ee1$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $a0779144dbc42ee1$var$createErrorInternal(authOrCode, ...rest);
}
function $a0779144dbc42ee1$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $a0779144dbc42ee1$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $a0779144dbc42ee1$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $a0779144dbc42ee1$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $a0779144dbc42ee1$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $a0779144dbc42ee1$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $a0779144dbc42ee1$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $a0779144dbc42ee1$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $a0779144dbc42ee1$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $a0779144dbc42ee1$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $a0779144dbc42ee1$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $a0779144dbc42ee1$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $a0779144dbc42ee1$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$_getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function $a0779144dbc42ee1$var$_isHttpOrHttps() {
    return $a0779144dbc42ee1$var$_getCurrentScheme() === 'http:' || $a0779144dbc42ee1$var$_getCurrentScheme() === 'https:';
}
function $a0779144dbc42ee1$var$_getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $a0779144dbc42ee1$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($a0779144dbc42ee1$var$_isHttpOrHttps() || (0, $c38e0f42709c826a$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $a0779144dbc42ee1$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $a0779144dbc42ee1$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $a0779144dbc42ee1$export$1fbe638ecf81657e(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $c38e0f42709c826a$export$872f8323f01d7ae0)() || (0, $c38e0f42709c826a$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$a0779144dbc42ee1$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$_emulatorUrl(config, path) {
    $a0779144dbc42ee1$export$1fbe638ecf81657e(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $a0779144dbc42ee1$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $a0779144dbc42ee1$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $a0779144dbc42ee1$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $a0779144dbc42ee1$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$DEFAULT_API_TIMEOUT_MS = new $a0779144dbc42ee1$var$Delay(30000, 60000);
function $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $a0779144dbc42ee1$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $a0779144dbc42ee1$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $c38e0f42709c826a$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method: method,
            headers: headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $c38e0f42709c826a$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'no-referrer';
        return $a0779144dbc42ee1$export$2ed0fc6709e59212.fetch()($a0779144dbc42ee1$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $a0779144dbc42ee1$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $a0779144dbc42ee1$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $a0779144dbc42ee1$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $a0779144dbc42ee1$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $a0779144dbc42ee1$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $a0779144dbc42ee1$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $a0779144dbc42ee1$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $a0779144dbc42ee1$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $a0779144dbc42ee1$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $a0779144dbc42ee1$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $a0779144dbc42ee1$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $a0779144dbc42ee1$var$_emulatorUrl(auth.config, base);
}
function $a0779144dbc42ee1$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $a0779144dbc42ee1$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($a0779144dbc42ee1$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $a0779144dbc42ee1$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $a0779144dbc42ee1$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $a0779144dbc42ee1$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $a0779144dbc42ee1$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $a0779144dbc42ee1$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $a0779144dbc42ee1$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$getRecaptchaParams(auth) {
    return (await $a0779144dbc42ee1$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $a0779144dbc42ee1$var$getRecaptchaConfig(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$deleteAccount(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $a0779144dbc42ee1$var$deleteLinkedAccounts(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $a0779144dbc42ee1$var$getAccountInfo(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $a0779144dbc42ee1$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $a0779144dbc42ee1$var$_parseToken(token);
    $a0779144dbc42ee1$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $a0779144dbc42ee1$var$utcTimestampToDateString($a0779144dbc42ee1$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $a0779144dbc42ee1$var$utcTimestampToDateString($a0779144dbc42ee1$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $a0779144dbc42ee1$var$utcTimestampToDateString($a0779144dbc42ee1$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function $a0779144dbc42ee1$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $a0779144dbc42ee1$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $a0779144dbc42ee1$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $c38e0f42709c826a$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $a0779144dbc42ee1$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $a0779144dbc42ee1$var$_logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $a0779144dbc42ee1$var$_tokenExpiresIn(token) {
    const parsedToken = $a0779144dbc42ee1$var$_parseToken(token);
    $a0779144dbc42ee1$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $a0779144dbc42ee1$export$890c4ad488842ce7(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $a0779144dbc42ee1$export$890c4ad488842ce7(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56) && $a0779144dbc42ee1$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $a0779144dbc42ee1$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $a0779144dbc42ee1$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $a0779144dbc42ee1$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $a0779144dbc42ee1$var$_logoutIfInvalidated(user, $a0779144dbc42ee1$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $a0779144dbc42ee1$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $a0779144dbc42ee1$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $a0779144dbc42ee1$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $a0779144dbc42ee1$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$d24c54395ce0c509(user) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $a0779144dbc42ee1$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $a0779144dbc42ee1$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $a0779144dbc42ee1$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$requestStsToken(auth, refreshToken) {
    const response = await $a0779144dbc42ee1$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $c38e0f42709c826a$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $a0779144dbc42ee1$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        return $a0779144dbc42ee1$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $a0779144dbc42ee1$var$revokeToken(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $a0779144dbc42ee1$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $a0779144dbc42ee1$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $a0779144dbc42ee1$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $a0779144dbc42ee1$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $a0779144dbc42ee1$var$StsTokenManager();
        if (refreshToken) {
            $a0779144dbc42ee1$export$890c4ad488842ce7(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $a0779144dbc42ee1$export$890c4ad488842ce7(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $a0779144dbc42ee1$export$890c4ad488842ce7(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $a0779144dbc42ee1$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $a0779144dbc42ee1$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$assertStringOrUndefined(assertion, appName) {
    $a0779144dbc42ee1$export$890c4ad488842ce7(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $a0779144dbc42ee1$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $a0779144dbc42ee1$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $a0779144dbc42ee1$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $a0779144dbc42ee1$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $a0779144dbc42ee1$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $a0779144dbc42ee1$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $a0779144dbc42ee1$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $a0779144dbc42ee1$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $a0779144dbc42ee1$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $a0779144dbc42ee1$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $a0779144dbc42ee1$var$_logoutIfInvalidated(this, $a0779144dbc42ee1$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $a0779144dbc42ee1$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $a0779144dbc42ee1$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a0779144dbc42ee1$var$assertStringOrUndefined(displayName, auth.name);
        $a0779144dbc42ee1$var$assertStringOrUndefined(email, auth.name);
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $a0779144dbc42ee1$var$assertStringOrUndefined(phoneNumber, auth.name);
        $a0779144dbc42ee1$var$assertStringOrUndefined(photoURL, auth.name);
        $a0779144dbc42ee1$var$assertStringOrUndefined(tenantId, auth.name);
        $a0779144dbc42ee1$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $a0779144dbc42ee1$var$assertStringOrUndefined(createdAt, auth.name);
        $a0779144dbc42ee1$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $a0779144dbc42ee1$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $a0779144dbc42ee1$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $a0779144dbc42ee1$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $a0779144dbc42ee1$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $a0779144dbc42ee1$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $a0779144dbc42ee1$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $a0779144dbc42ee1$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $a0779144dbc42ee1$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $a0779144dbc42ee1$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$instanceCache = new Map();
function $a0779144dbc42ee1$export$158acd800e1ef08b(cls) {
    $a0779144dbc42ee1$export$1fbe638ecf81657e(cls instanceof Function, 'Expected a class definition');
    let instance = $a0779144dbc42ee1$var$instanceCache.get(cls);
    if (instance) {
        $a0779144dbc42ee1$export$1fbe638ecf81657e(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $a0779144dbc42ee1$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$a0779144dbc42ee1$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $a0779144dbc42ee1$export$3a6d5c9ae78a2c08 = $a0779144dbc42ee1$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $a0779144dbc42ee1$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $a0779144dbc42ee1$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $a0779144dbc42ee1$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $a0779144dbc42ee1$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $a0779144dbc42ee1$var$PersistenceUserManager($a0779144dbc42ee1$export$158acd800e1ef08b($a0779144dbc42ee1$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $a0779144dbc42ee1$export$158acd800e1ef08b($a0779144dbc42ee1$export$3a6d5c9ae78a2c08);
        const key = $a0779144dbc42ee1$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $a0779144dbc42ee1$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $a0779144dbc42ee1$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $a0779144dbc42ee1$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $a0779144dbc42ee1$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($a0779144dbc42ee1$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($a0779144dbc42ee1$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($a0779144dbc42ee1$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($a0779144dbc42ee1$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($a0779144dbc42ee1$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $a0779144dbc42ee1$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($a0779144dbc42ee1$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $a0779144dbc42ee1$var$_isFirefox(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $a0779144dbc42ee1$var$_isSafari(userAgent = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $a0779144dbc42ee1$var$_isChromeIOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $a0779144dbc42ee1$var$_isIEMobile(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $a0779144dbc42ee1$export$92108d983e8ee699(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $a0779144dbc42ee1$var$_isBlackBerry(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $a0779144dbc42ee1$var$_isWebOS(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $a0779144dbc42ee1$export$d66dc83d8cfc8dd(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $a0779144dbc42ee1$export$91c6e00c14e7e6fd(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $a0779144dbc42ee1$var$_isIOSStandalone(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    var _a;
    return $a0779144dbc42ee1$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $a0779144dbc42ee1$var$_isIE10() {
    return (0, $c38e0f42709c826a$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $a0779144dbc42ee1$var$_isMobileBrowser(ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $a0779144dbc42ee1$export$d66dc83d8cfc8dd(ua) || $a0779144dbc42ee1$export$92108d983e8ee699(ua) || $a0779144dbc42ee1$var$_isWebOS(ua) || $a0779144dbc42ee1$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $a0779144dbc42ee1$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $a0779144dbc42ee1$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $a0779144dbc42ee1$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$a0779144dbc42ee1$var$_getBrowserName((0, $c38e0f42709c826a$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $57d436074e210fb5$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $a0779144dbc42ee1$var$_getPasswordPolicy(auth, request = {}) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $a0779144dbc42ee1$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $a0779144dbc42ee1$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $a0779144dbc42ee1$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $a0779144dbc42ee1$var$Subscription(this);
        this.idTokenSubscription = new $a0779144dbc42ee1$var$Subscription(this);
        this.beforeStateQueue = new $a0779144dbc42ee1$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $a0779144dbc42ee1$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $a0779144dbc42ee1$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $a0779144dbc42ee1$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $a0779144dbc42ee1$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $a0779144dbc42ee1$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $a0779144dbc42ee1$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $a0779144dbc42ee1$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $a0779144dbc42ee1$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $a0779144dbc42ee1$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $a0779144dbc42ee1$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(this.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($a0779144dbc42ee1$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $a0779144dbc42ee1$var$_getPasswordPolicy(this);
        const passwordPolicy = new $a0779144dbc42ee1$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $a0779144dbc42ee1$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $a0779144dbc42ee1$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $a0779144dbc42ee1$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $a0779144dbc42ee1$var$PersistenceUserManager.create(this, [
                $a0779144dbc42ee1$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $a0779144dbc42ee1$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $a0779144dbc42ee1$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $a0779144dbc42ee1$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $a0779144dbc42ee1$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $c38e0f42709c826a$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $a0779144dbc42ee1$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $a0779144dbc42ee1$var$_setExternalJSProvider(p) {
    $a0779144dbc42ee1$var$externalJSProvider = p;
}
function $a0779144dbc42ee1$var$_loadJS(url) {
    return $a0779144dbc42ee1$var$externalJSProvider.loadJS(url);
}
function $a0779144dbc42ee1$var$_recaptchaV2ScriptUrl() {
    return $a0779144dbc42ee1$var$externalJSProvider.recaptchaV2Script;
}
function $a0779144dbc42ee1$var$_recaptchaEnterpriseScriptUrl() {
    return $a0779144dbc42ee1$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $a0779144dbc42ee1$var$_gapiScriptUrl() {
    return $a0779144dbc42ee1$var$externalJSProvider.gapiScript;
}
function $a0779144dbc42ee1$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$_SOLVE_TIME_MS = 500;
const $a0779144dbc42ee1$var$_EXPIRATION_TIME_MS = 60000;
const $a0779144dbc42ee1$var$_WIDGET_ID_START = 1000000000000;
class $a0779144dbc42ee1$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $a0779144dbc42ee1$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $a0779144dbc42ee1$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $a0779144dbc42ee1$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $a0779144dbc42ee1$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $a0779144dbc42ee1$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class $a0779144dbc42ee1$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $a0779144dbc42ee1$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $a0779144dbc42ee1$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $a0779144dbc42ee1$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $a0779144dbc42ee1$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $a0779144dbc42ee1$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $a0779144dbc42ee1$var$_EXPIRATION_TIME_MS);
        }, $a0779144dbc42ee1$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $a0779144dbc42ee1$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $a0779144dbc42ee1$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $a0779144dbc42ee1$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $a0779144dbc42ee1$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $a0779144dbc42ee1$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $a0779144dbc42ee1$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $a0779144dbc42ee1$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $a0779144dbc42ee1$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($a0779144dbc42ee1$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($a0779144dbc42ee1$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $a0779144dbc42ee1$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $a0779144dbc42ee1$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $a0779144dbc42ee1$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $a0779144dbc42ee1$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $a0779144dbc42ee1$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $a0779144dbc42ee1$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $a0779144dbc42ee1$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $a0779144dbc42ee1$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    var _a, _b;
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $a0779144dbc42ee1$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $a0779144dbc42ee1$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if ((_b = authInstance._getRecaptchaConfig()) === null || _b === void 0 ? void 0 : _b.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $a0779144dbc42ee1$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                var _a;
                if (((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $a0779144dbc42ee1$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $a0779144dbc42ee1$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $a0779144dbc42ee1$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    const response = await $a0779144dbc42ee1$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $a0779144dbc42ee1$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $a0779144dbc42ee1$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $a0779144dbc42ee1$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $a0779144dbc42ee1$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($a0779144dbc42ee1$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $a0779144dbc42ee1$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    $a0779144dbc42ee1$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $a0779144dbc42ee1$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $a0779144dbc42ee1$var$extractProtocol(url);
    const { host: host, port: port } = $a0779144dbc42ee1$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $a0779144dbc42ee1$var$emitEmulatorWarning();
}
function $a0779144dbc42ee1$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $a0779144dbc42ee1$var$extractHostAndPort(url) {
    const protocol = $a0779144dbc42ee1$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $a0779144dbc42ee1$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $a0779144dbc42ee1$var$parsePort(port)
        };
    }
}
function $a0779144dbc42ee1$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $a0779144dbc42ee1$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $a0779144dbc42ee1$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $a0779144dbc42ee1$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $a0779144dbc42ee1$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $a0779144dbc42ee1$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $a0779144dbc42ee1$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$resetPassword(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
async function $a0779144dbc42ee1$var$updateEmailPassword(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $a0779144dbc42ee1$var$linkEmailPassword(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $a0779144dbc42ee1$var$applyActionCode$1(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$signInWithPassword(auth, request) {
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
async function $a0779144dbc42ee1$var$sendOobCode(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
async function $a0779144dbc42ee1$var$sendEmailVerification$1(auth, request) {
    return $a0779144dbc42ee1$var$sendOobCode(auth, request);
}
async function $a0779144dbc42ee1$var$sendPasswordResetEmail$1(auth, request) {
    return $a0779144dbc42ee1$var$sendOobCode(auth, request);
}
async function $a0779144dbc42ee1$var$sendSignInLinkToEmail$1(auth, request) {
    return $a0779144dbc42ee1$var$sendOobCode(auth, request);
}
async function $a0779144dbc42ee1$var$verifyAndChangeEmail(auth, request) {
    return $a0779144dbc42ee1$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$signInWithEmailLink$1(auth, request) {
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
async function $a0779144dbc42ee1$var$signInWithEmailLinkForLinking(auth, request) {
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $a0779144dbc42ee1$export$3a1a48c8f6ef640e extends $a0779144dbc42ee1$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $a0779144dbc42ee1$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $a0779144dbc42ee1$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $a0779144dbc42ee1$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $a0779144dbc42ee1$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $a0779144dbc42ee1$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $a0779144dbc42ee1$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $a0779144dbc42ee1$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $a0779144dbc42ee1$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$signInWithIdp(auth, request) {
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $a0779144dbc42ee1$export$a07804094c3ecf2d extends $a0779144dbc42ee1$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $a0779144dbc42ee1$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $a0779144dbc42ee1$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $a0779144dbc42ee1$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $a0779144dbc42ee1$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $a0779144dbc42ee1$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $a0779144dbc42ee1$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $a0779144dbc42ee1$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $c38e0f42709c826a$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$sendPhoneVerificationCode(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
async function $a0779144dbc42ee1$var$signInWithPhoneNumber$1(auth, request) {
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
async function $a0779144dbc42ee1$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $a0779144dbc42ee1$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $a0779144dbc42ee1$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $a0779144dbc42ee1$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, apiRequest), $a0779144dbc42ee1$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $a0779144dbc42ee1$export$3722cfe417b6ed86 extends $a0779144dbc42ee1$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $a0779144dbc42ee1$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $a0779144dbc42ee1$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $a0779144dbc42ee1$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $a0779144dbc42ee1$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $a0779144dbc42ee1$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $a0779144dbc42ee1$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $a0779144dbc42ee1$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $a0779144dbc42ee1$var$parseDeepLink(url) {
    const link = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $a0779144dbc42ee1$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $c38e0f42709c826a$export$c1271ca4c8a70741)((0, $c38e0f42709c826a$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $a0779144dbc42ee1$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $a0779144dbc42ee1$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $a0779144dbc42ee1$var$parseDeepLink(link);
        try {
            return new $a0779144dbc42ee1$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $a0779144dbc42ee1$export$3b513254972cfc9c(link) {
    return $a0779144dbc42ee1$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $a0779144dbc42ee1$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $a0779144dbc42ee1$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $a0779144dbc42ee1$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $a0779144dbc42ee1$export$f38c853ae54ed474.parseLink(emailLink);
        $a0779144dbc42ee1$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $a0779144dbc42ee1$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $a0779144dbc42ee1$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $a0779144dbc42ee1$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $a0779144dbc42ee1$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $a0779144dbc42ee1$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $a0779144dbc42ee1$var$BaseOAuthProvider extends $a0779144dbc42ee1$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $a0779144dbc42ee1$export$dc98b0b04f4c7758 extends $a0779144dbc42ee1$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $a0779144dbc42ee1$export$890c4ad488842ce7('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $a0779144dbc42ee1$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $a0779144dbc42ee1$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a0779144dbc42ee1$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a0779144dbc42ee1$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $a0779144dbc42ee1$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $a0779144dbc42ee1$export$71cec2538cb2c617 extends $a0779144dbc42ee1$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $a0779144dbc42ee1$export$a07804094c3ecf2d._fromParams({
            providerId: $a0779144dbc42ee1$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $a0779144dbc42ee1$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a0779144dbc42ee1$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a0779144dbc42ee1$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $a0779144dbc42ee1$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $a0779144dbc42ee1$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $a0779144dbc42ee1$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $a0779144dbc42ee1$export$78acf4525d8a74c4 extends $a0779144dbc42ee1$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $a0779144dbc42ee1$export$a07804094c3ecf2d._fromParams({
            providerId: $a0779144dbc42ee1$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $a0779144dbc42ee1$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a0779144dbc42ee1$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a0779144dbc42ee1$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $a0779144dbc42ee1$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $a0779144dbc42ee1$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $a0779144dbc42ee1$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $a0779144dbc42ee1$export$8743009a87fcb00f extends $a0779144dbc42ee1$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $a0779144dbc42ee1$export$a07804094c3ecf2d._fromParams({
            providerId: $a0779144dbc42ee1$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $a0779144dbc42ee1$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a0779144dbc42ee1$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a0779144dbc42ee1$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $a0779144dbc42ee1$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $a0779144dbc42ee1$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $a0779144dbc42ee1$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $a0779144dbc42ee1$export$f96d196f7728bb5 extends $a0779144dbc42ee1$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $a0779144dbc42ee1$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $a0779144dbc42ee1$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $a0779144dbc42ee1$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $a0779144dbc42ee1$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $a0779144dbc42ee1$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $a0779144dbc42ee1$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $a0779144dbc42ee1$export$71511d61b312f219 extends $a0779144dbc42ee1$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $a0779144dbc42ee1$export$890c4ad488842ce7(providerId.startsWith($a0779144dbc42ee1$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a0779144dbc42ee1$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a0779144dbc42ee1$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $a0779144dbc42ee1$export$f96d196f7728bb5.fromJSON(json);
        $a0779144dbc42ee1$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $a0779144dbc42ee1$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $a0779144dbc42ee1$export$3d8c2f653ac9d0b9 extends $a0779144dbc42ee1$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $a0779144dbc42ee1$export$a07804094c3ecf2d._fromParams({
            providerId: $a0779144dbc42ee1$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $a0779144dbc42ee1$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $a0779144dbc42ee1$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $a0779144dbc42ee1$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $a0779144dbc42ee1$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $a0779144dbc42ee1$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $a0779144dbc42ee1$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$signUp(auth, request) {
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $a0779144dbc42ee1$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $a0779144dbc42ee1$var$providerIdForResponse(idTokenResponse);
        const userCred = new $a0779144dbc42ee1$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $a0779144dbc42ee1$var$providerIdForResponse(response);
        return new $a0779144dbc42ee1$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $a0779144dbc42ee1$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $a0779144dbc42ee1$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $a0779144dbc42ee1$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $a0779144dbc42ee1$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$MultiFactorError extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $a0779144dbc42ee1$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $a0779144dbc42ee1$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $a0779144dbc42ee1$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $a0779144dbc42ee1$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $a0779144dbc42ee1$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $a0779144dbc42ee1$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $a0779144dbc42ee1$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $a0779144dbc42ee1$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $a0779144dbc42ee1$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $a0779144dbc42ee1$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $a0779144dbc42ee1$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $a0779144dbc42ee1$var$_assertLinkedStatus(expected, user, provider) {
    await $a0779144dbc42ee1$var$_reloadWithoutSaving(user);
    const providerIds = $a0779144dbc42ee1$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $a0779144dbc42ee1$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $a0779144dbc42ee1$var$_logoutIfInvalidated(user, $a0779144dbc42ee1$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $a0779144dbc42ee1$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $a0779144dbc42ee1$var$_parseToken(response.idToken);
        $a0779144dbc42ee1$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $a0779144dbc42ee1$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $a0779144dbc42ee1$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $a0779144dbc42ee1$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $a0779144dbc42ee1$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$3c2fa207a37baaea(auth, credential) {
    return $a0779144dbc42ee1$var$_signInWithCredential($a0779144dbc42ee1$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $a0779144dbc42ee1$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $a0779144dbc42ee1$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$6559d589eb85fbb6(user, credential) {
    return $a0779144dbc42ee1$var$_reauthenticate((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$signInWithCustomToken$1(auth, request) {
    return $a0779144dbc42ee1$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    const response = await $a0779144dbc42ee1$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $a0779144dbc42ee1$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $a0779144dbc42ee1$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $a0779144dbc42ee1$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $a0779144dbc42ee1$var$PhoneMultiFactorInfoImpl extends $a0779144dbc42ee1$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $a0779144dbc42ee1$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $a0779144dbc42ee1$var$TotpMultiFactorInfoImpl extends $a0779144dbc42ee1$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $a0779144dbc42ee1$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $a0779144dbc42ee1$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $a0779144dbc42ee1$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $a0779144dbc42ee1$var$recachePasswordPolicy(auth) {
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $a0779144dbc42ee1$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $a0779144dbc42ee1$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $a0779144dbc42ee1$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $a0779144dbc42ee1$var$resetPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $a0779144dbc42ee1$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$a93c5207d687da10(auth, oobCode) {
    await $a0779144dbc42ee1$var$applyActionCode$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const response = await $a0779144dbc42ee1$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $a0779144dbc42ee1$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $a0779144dbc42ee1$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $a0779144dbc42ee1$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $a0779144dbc42ee1$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $a0779144dbc42ee1$var$MultiFactorInfoImpl._fromServerResponse($a0779144dbc42ee1$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $a0779144dbc42ee1$export$c3950d9923825c02((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $a0779144dbc42ee1$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $a0779144dbc42ee1$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $a0779144dbc42ee1$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $a0779144dbc42ee1$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $a0779144dbc42ee1$export$555508cbc6add439(auth, email, password) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $a0779144dbc42ee1$export$3c2fa207a37baaea((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), $a0779144dbc42ee1$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $a0779144dbc42ee1$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $a0779144dbc42ee1$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $a0779144dbc42ee1$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $a0779144dbc42ee1$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $a0779144dbc42ee1$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $a0779144dbc42ee1$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const credential = $a0779144dbc42ee1$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $a0779144dbc42ee1$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $a0779144dbc42ee1$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $a0779144dbc42ee1$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$createAuthUri(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $a0779144dbc42ee1$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $a0779144dbc42ee1$var$_isHttpOrHttps() ? $a0779144dbc42ee1$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $a0779144dbc42ee1$var$createAuthUri((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $a0779144dbc42ee1$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $a0779144dbc42ee1$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $a0779144dbc42ee1$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $a0779144dbc42ee1$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$var$updateProfile$1(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $a0779144dbc42ee1$var$_logoutIfInvalidated(userInternal, $a0779144dbc42ee1$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $a0779144dbc42ee1$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $a0779144dbc42ee1$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $a0779144dbc42ee1$export$1a82df3d29112e01(user, newPassword) {
    return $a0779144dbc42ee1$var$updateEmailOrPassword((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $a0779144dbc42ee1$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $a0779144dbc42ee1$var$_logoutIfInvalidated(user, $a0779144dbc42ee1$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $a0779144dbc42ee1$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $a0779144dbc42ee1$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $a0779144dbc42ee1$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $a0779144dbc42ee1$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $a0779144dbc42ee1$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $a0779144dbc42ee1$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $a0779144dbc42ee1$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $a0779144dbc42ee1$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $a0779144dbc42ee1$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $a0779144dbc42ee1$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $a0779144dbc42ee1$var$FederatedAdditionalUserInfoWithUsername extends $a0779144dbc42ee1$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $a0779144dbc42ee1$var$FacebookAdditionalUserInfo extends $a0779144dbc42ee1$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $a0779144dbc42ee1$var$GithubAdditionalUserInfo extends $a0779144dbc42ee1$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $a0779144dbc42ee1$var$GoogleAdditionalUserInfo extends $a0779144dbc42ee1$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $a0779144dbc42ee1$var$TwitterAdditionalUserInfo extends $a0779144dbc42ee1$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $a0779144dbc42ee1$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $a0779144dbc42ee1$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $a0779144dbc42ee1$export$9e5f44173e64f162(auth, persistence) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $a0779144dbc42ee1$export$625550452a3fa3ec(auth) {
    return $a0779144dbc42ee1$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$90a7f3efeed30595(auth, password) {
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $a0779144dbc42ee1$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $a0779144dbc42ee1$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $a0779144dbc42ee1$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $a0779144dbc42ee1$export$df995fae86a55f06(auth) {
    (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $a0779144dbc42ee1$export$ef35774e6d314e91(auth, user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $a0779144dbc42ee1$export$e7094788287c5e9b(auth) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $a0779144dbc42ee1$export$96f57966bedc81b4(auth, token) {
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$a9c23c6ac3fc3eca(user) {
    return (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $a0779144dbc42ee1$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $a0779144dbc42ee1$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $a0779144dbc42ee1$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $a0779144dbc42ee1$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $a0779144dbc42ee1$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$a0779144dbc42ee1$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $a0779144dbc42ee1$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $a0779144dbc42ee1$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $a0779144dbc42ee1$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $a0779144dbc42ee1$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $a0779144dbc42ee1$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $a0779144dbc42ee1$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $a0779144dbc42ee1$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $a0779144dbc42ee1$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $a0779144dbc42ee1$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $a0779144dbc42ee1$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$startEnrollPhoneMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
function $a0779144dbc42ee1$var$finalizeEnrollPhoneMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
function $a0779144dbc42ee1$var$startEnrollTotpMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
function $a0779144dbc42ee1$var$finalizeEnrollTotpMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
function $a0779144dbc42ee1$var$withdrawMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
class $a0779144dbc42ee1$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$a0779144dbc42ee1$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $a0779144dbc42ee1$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $a0779144dbc42ee1$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $a0779144dbc42ee1$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $a0779144dbc42ee1$var$_logoutIfInvalidated(this.user, $a0779144dbc42ee1$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $a0779144dbc42ee1$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $a0779144dbc42ee1$export$493d36ec626b6698(user) {
    const userModular = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if (!$a0779144dbc42ee1$var$multiFactorUserCache.has(userModular)) $a0779144dbc42ee1$var$multiFactorUserCache.set(userModular, $a0779144dbc42ee1$var$MultiFactorUserImpl._fromUser(userModular));
    return $a0779144dbc42ee1$var$multiFactorUserCache.get(userModular);
}
const $a0779144dbc42ee1$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $a0779144dbc42ee1$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($a0779144dbc42ee1$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($a0779144dbc42ee1$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $a0779144dbc42ee1$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $a0779144dbc42ee1$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $a0779144dbc42ee1$var$BrowserLocalPersistence extends $a0779144dbc42ee1$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $a0779144dbc42ee1$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($a0779144dbc42ee1$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $a0779144dbc42ee1$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $a0779144dbc42ee1$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$a0779144dbc42ee1$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $a0779144dbc42ee1$export$8b22cf2602fb60ce = $a0779144dbc42ee1$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$BrowserSessionPersistence extends $a0779144dbc42ee1$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$a0779144dbc42ee1$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $a0779144dbc42ee1$export$407448d2b89b1813 = $a0779144dbc42ee1$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $a0779144dbc42ee1$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $a0779144dbc42ee1$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $a0779144dbc42ee1$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $a0779144dbc42ee1$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$a0779144dbc42ee1$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$export$faec65b429be379(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $a0779144dbc42ee1$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $a0779144dbc42ee1$export$faec65b429be379('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $a0779144dbc42ee1$var$_window() {
    return window;
}
function $a0779144dbc42ee1$var$_setWindowLocation(url) {
    $a0779144dbc42ee1$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$_isWorker() {
    return typeof $a0779144dbc42ee1$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $a0779144dbc42ee1$var$_window()['importScripts'] === 'function';
}
async function $a0779144dbc42ee1$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $a0779144dbc42ee1$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $a0779144dbc42ee1$var$_getWorkerGlobalScope() {
    return $a0779144dbc42ee1$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$DB_NAME = 'firebaseLocalStorageDb';
const $a0779144dbc42ee1$var$DB_VERSION = 1;
const $a0779144dbc42ee1$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $a0779144dbc42ee1$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $a0779144dbc42ee1$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $a0779144dbc42ee1$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $a0779144dbc42ee1$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($a0779144dbc42ee1$var$DB_OBJECTSTORE_NAME);
}
function $a0779144dbc42ee1$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($a0779144dbc42ee1$var$DB_NAME);
    return new $a0779144dbc42ee1$var$DBPromise(request).toPromise();
}
function $a0779144dbc42ee1$var$_openDatabase() {
    const request = indexedDB.open($a0779144dbc42ee1$var$DB_NAME, $a0779144dbc42ee1$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($a0779144dbc42ee1$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $a0779144dbc42ee1$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($a0779144dbc42ee1$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $a0779144dbc42ee1$var$_deleteDatabase();
                resolve(await $a0779144dbc42ee1$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $a0779144dbc42ee1$var$_putObject(db, key, value) {
    const request = $a0779144dbc42ee1$var$getObjectStore(db, true).put({
        [$a0779144dbc42ee1$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $a0779144dbc42ee1$var$DBPromise(request).toPromise();
}
async function $a0779144dbc42ee1$var$getObject(db, key) {
    const request = $a0779144dbc42ee1$var$getObjectStore(db, false).get(key);
    const data = await new $a0779144dbc42ee1$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $a0779144dbc42ee1$var$_deleteObject(db, key) {
    const request = $a0779144dbc42ee1$var$getObjectStore(db, true).delete(key);
    return new $a0779144dbc42ee1$var$DBPromise(request).toPromise();
}
const $a0779144dbc42ee1$var$_POLLING_INTERVAL_MS = 800;
const $a0779144dbc42ee1$var$_TRANSACTION_RETRY_COUNT = 3;
class $a0779144dbc42ee1$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $a0779144dbc42ee1$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $a0779144dbc42ee1$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $a0779144dbc42ee1$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $a0779144dbc42ee1$var$Receiver._getInstance($a0779144dbc42ee1$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $a0779144dbc42ee1$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $a0779144dbc42ee1$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $a0779144dbc42ee1$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $a0779144dbc42ee1$var$_openDatabase();
            await $a0779144dbc42ee1$var$_putObject(db, $a0779144dbc42ee1$var$STORAGE_AVAILABLE_KEY, '1');
            await $a0779144dbc42ee1$var$_deleteObject(db, $a0779144dbc42ee1$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$a0779144dbc42ee1$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$a0779144dbc42ee1$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$a0779144dbc42ee1$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $a0779144dbc42ee1$var$getObjectStore(db, false).getAll();
            return new $a0779144dbc42ee1$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $a0779144dbc42ee1$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$a0779144dbc42ee1$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $a0779144dbc42ee1$export$23f2a1d2818174ef = $a0779144dbc42ee1$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$startSignInPhoneMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
function $a0779144dbc42ee1$var$finalizeSignInPhoneMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
function $a0779144dbc42ee1$var$finalizeSignInTotpMfa(auth, request) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $a0779144dbc42ee1$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $a0779144dbc42ee1$var$_JSLOAD_CALLBACK = $a0779144dbc42ee1$var$_generateCallbackName('rcb');
const $a0779144dbc42ee1$var$NETWORK_TIMEOUT_DELAY = new $a0779144dbc42ee1$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $a0779144dbc42ee1$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $a0779144dbc42ee1$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        $a0779144dbc42ee1$export$890c4ad488842ce7($a0779144dbc42ee1$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $a0779144dbc42ee1$var$isV2($a0779144dbc42ee1$var$_window().grecaptcha)) return Promise.resolve($a0779144dbc42ee1$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $a0779144dbc42ee1$var$_window().setTimeout(()=>{
                reject($a0779144dbc42ee1$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $a0779144dbc42ee1$var$NETWORK_TIMEOUT_DELAY.get());
            $a0779144dbc42ee1$var$_window()[$a0779144dbc42ee1$var$_JSLOAD_CALLBACK] = ()=>{
                $a0779144dbc42ee1$var$_window().clearTimeout(networkTimeout);
                delete $a0779144dbc42ee1$var$_window()[$a0779144dbc42ee1$var$_JSLOAD_CALLBACK];
                const recaptcha = $a0779144dbc42ee1$var$_window().grecaptcha;
                if (!recaptcha || !$a0779144dbc42ee1$var$isV2(recaptcha)) {
                    reject($a0779144dbc42ee1$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$a0779144dbc42ee1$var$_recaptchaV2ScriptUrl()}?${(0, $c38e0f42709c826a$export$ac4103b836844853)({
                onload: $a0779144dbc42ee1$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $a0779144dbc42ee1$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($a0779144dbc42ee1$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $a0779144dbc42ee1$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $a0779144dbc42ee1$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $a0779144dbc42ee1$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $a0779144dbc42ee1$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $a0779144dbc42ee1$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $a0779144dbc42ee1$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $a0779144dbc42ee1$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $a0779144dbc42ee1$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $a0779144dbc42ee1$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $a0779144dbc42ee1$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $a0779144dbc42ee1$var$MockReCaptchaLoaderImpl() : new $a0779144dbc42ee1$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $a0779144dbc42ee1$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $a0779144dbc42ee1$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $a0779144dbc42ee1$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $a0779144dbc42ee1$export$890c4ad488842ce7($a0779144dbc42ee1$var$_isHttpOrHttps() && !$a0779144dbc42ee1$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $a0779144dbc42ee1$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $a0779144dbc42ee1$var$getRecaptchaParams(this.auth);
        $a0779144dbc42ee1$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $a0779144dbc42ee1$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $a0779144dbc42ee1$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    const verificationId = await $a0779144dbc42ee1$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $a0779144dbc42ee1$var$ConfirmationResultImpl(verificationId, (cred)=>$a0779144dbc42ee1$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    await $a0779144dbc42ee1$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $a0779144dbc42ee1$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $a0779144dbc42ee1$var$ConfirmationResultImpl(verificationId, (cred)=>$a0779144dbc42ee1$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $a0779144dbc42ee1$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(appVerifier));
    return new $a0779144dbc42ee1$var$ConfirmationResultImpl(verificationId, (cred)=>$a0779144dbc42ee1$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $a0779144dbc42ee1$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    if (!auth._getRecaptchaConfig()) try {
        await $a0779144dbc42ee1$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $a0779144dbc42ee1$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $a0779144dbc42ee1$var$FAKE_TOKEN) {
                        $a0779144dbc42ee1$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $a0779144dbc42ee1$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $a0779144dbc42ee1$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $a0779144dbc42ee1$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $a0779144dbc42ee1$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $a0779144dbc42ee1$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $a0779144dbc42ee1$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $a0779144dbc42ee1$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $a0779144dbc42ee1$var$FAKE_TOKEN) {
                        $a0779144dbc42ee1$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $a0779144dbc42ee1$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $a0779144dbc42ee1$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $a0779144dbc42ee1$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $a0779144dbc42ee1$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $a0779144dbc42ee1$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $a0779144dbc42ee1$var$FAKE_TOKEN) {
                    $a0779144dbc42ee1$export$890c4ad488842ce7((verifier === null || verifier === void 0 ? void 0 : verifier.type) === $a0779144dbc42ee1$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $a0779144dbc42ee1$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $a0779144dbc42ee1$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $a0779144dbc42ee1$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $a0779144dbc42ee1$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier === null || verifier === void 0 || verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $a0779144dbc42ee1$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $a0779144dbc42ee1$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $a0779144dbc42ee1$export$890c4ad488842ce7(recaptchaV2Verifier.type === $a0779144dbc42ee1$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $a0779144dbc42ee1$export$890c4ad488842ce7(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = Object.assign({}, request);
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $a0779144dbc42ee1$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $a0779144dbc42ee1$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $a0779144dbc42ee1$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $a0779144dbc42ee1$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $a0779144dbc42ee1$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $a0779144dbc42ee1$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $a0779144dbc42ee1$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $a0779144dbc42ee1$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $a0779144dbc42ee1$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $a0779144dbc42ee1$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $a0779144dbc42ee1$export$158acd800e1ef08b(resolverOverride);
    $a0779144dbc42ee1$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$IdpCredential extends $a0779144dbc42ee1$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $a0779144dbc42ee1$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $a0779144dbc42ee1$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $a0779144dbc42ee1$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $a0779144dbc42ee1$var$_signIn(params) {
    return $a0779144dbc42ee1$var$_signInWithCredential(params.auth, new $a0779144dbc42ee1$var$IdpCredential(params), params.bypassAuthState);
}
function $a0779144dbc42ee1$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $a0779144dbc42ee1$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $a0779144dbc42ee1$var$_reauthenticate(user, new $a0779144dbc42ee1$var$IdpCredential(params), params.bypassAuthState);
}
async function $a0779144dbc42ee1$var$_link(params) {
    const { auth: auth, user: user } = params;
    $a0779144dbc42ee1$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $a0779144dbc42ee1$var$_link$1(user, new $a0779144dbc42ee1$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $a0779144dbc42ee1$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $a0779144dbc42ee1$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $a0779144dbc42ee1$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $a0779144dbc42ee1$var$_reauth;
            default:
                $a0779144dbc42ee1$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $a0779144dbc42ee1$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $a0779144dbc42ee1$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $a0779144dbc42ee1$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    $a0779144dbc42ee1$var$_assertInstanceOf(auth, provider, $a0779144dbc42ee1$var$FederatedAuthProvider);
    const resolverInternal = $a0779144dbc42ee1$var$_withDefaultResolver(authInternal, resolver);
    const action = new $a0779144dbc42ee1$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a0779144dbc42ee1$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $a0779144dbc42ee1$var$_assertInstanceOf(userInternal.auth, provider, $a0779144dbc42ee1$var$FederatedAuthProvider);
    const resolverInternal = $a0779144dbc42ee1$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $a0779144dbc42ee1$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $a0779144dbc42ee1$var$_assertInstanceOf(userInternal.auth, provider, $a0779144dbc42ee1$var$FederatedAuthProvider);
    const resolverInternal = $a0779144dbc42ee1$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $a0779144dbc42ee1$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $a0779144dbc42ee1$var$PopupOperation extends $a0779144dbc42ee1$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($a0779144dbc42ee1$var$PopupOperation.currentPopupAction) $a0779144dbc42ee1$var$PopupOperation.currentPopupAction.cancel();
        $a0779144dbc42ee1$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $a0779144dbc42ee1$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $a0779144dbc42ee1$export$1fbe638ecf81657e(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $a0779144dbc42ee1$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($a0779144dbc42ee1$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($a0779144dbc42ee1$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $a0779144dbc42ee1$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($a0779144dbc42ee1$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $a0779144dbc42ee1$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$a0779144dbc42ee1$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $a0779144dbc42ee1$var$redirectOutcomeMap = new Map();
class $a0779144dbc42ee1$var$RedirectAction extends $a0779144dbc42ee1$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $a0779144dbc42ee1$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $a0779144dbc42ee1$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $a0779144dbc42ee1$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $a0779144dbc42ee1$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $a0779144dbc42ee1$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $a0779144dbc42ee1$var$pendingRedirectKey(auth);
    const persistence = $a0779144dbc42ee1$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $a0779144dbc42ee1$var$_setPendingRedirectStatus(resolver, auth) {
    return $a0779144dbc42ee1$var$resolverPersistence(resolver)._set($a0779144dbc42ee1$var$pendingRedirectKey(auth), 'true');
}
function $a0779144dbc42ee1$export$b9a6b53f9be3734() {
    $a0779144dbc42ee1$var$redirectOutcomeMap.clear();
}
function $a0779144dbc42ee1$export$a33b77bbdbb8366c(auth, result) {
    $a0779144dbc42ee1$var$redirectOutcomeMap.set(auth._key(), result);
}
function $a0779144dbc42ee1$var$resolverPersistence(resolver) {
    return $a0779144dbc42ee1$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $a0779144dbc42ee1$var$pendingRedirectKey(auth) {
    return $a0779144dbc42ee1$export$cf2f7c5792f80b46($a0779144dbc42ee1$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $a0779144dbc42ee1$export$2d1720544b23b823(auth, provider, resolver) {
    return $a0779144dbc42ee1$var$_signInWithRedirect(auth, provider, resolver);
}
async function $a0779144dbc42ee1$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    $a0779144dbc42ee1$var$_assertInstanceOf(auth, provider, $a0779144dbc42ee1$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $a0779144dbc42ee1$var$_withDefaultResolver(authInternal, resolver);
    await $a0779144dbc42ee1$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $a0779144dbc42ee1$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $a0779144dbc42ee1$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $a0779144dbc42ee1$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $a0779144dbc42ee1$var$_assertInstanceOf(userInternal.auth, provider, $a0779144dbc42ee1$var$FederatedAuthProvider);
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $a0779144dbc42ee1$var$_withDefaultResolver(userInternal.auth, resolver);
    await $a0779144dbc42ee1$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $a0779144dbc42ee1$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $a0779144dbc42ee1$export$39b482c5e57630a8(user, provider, resolver) {
    return $a0779144dbc42ee1$var$_linkWithRedirect(user, provider, resolver);
}
async function $a0779144dbc42ee1$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(user);
    $a0779144dbc42ee1$var$_assertInstanceOf(userInternal.auth, provider, $a0779144dbc42ee1$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $a0779144dbc42ee1$var$_withDefaultResolver(userInternal.auth, resolver);
    await $a0779144dbc42ee1$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $a0779144dbc42ee1$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $a0779144dbc42ee1$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $a0779144dbc42ee1$export$35e795649ee09318(auth, resolver) {
    await $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $a0779144dbc42ee1$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $a0779144dbc42ee1$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $57d436074e210fb5$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($a0779144dbc42ee1$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $a0779144dbc42ee1$export$a05254e7c3aeba6e(auth);
    const resolver = $a0779144dbc42ee1$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $a0779144dbc42ee1$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $a0779144dbc42ee1$var$prepareUserForRedirect(user) {
    const eventId = $a0779144dbc42ee1$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $a0779144dbc42ee1$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $a0779144dbc42ee1$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$a0779144dbc42ee1$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$a0779144dbc42ee1$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($a0779144dbc42ee1$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $a0779144dbc42ee1$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($a0779144dbc42ee1$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($a0779144dbc42ee1$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $a0779144dbc42ee1$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $a0779144dbc42ee1$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $a0779144dbc42ee1$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $a0779144dbc42ee1$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a0779144dbc42ee1$export$3d12bd131bb975d1(auth, request = {}) {
    return $a0779144dbc42ee1$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $a0779144dbc42ee1$var$HTTP_REGEX = /^https?/;
async function $a0779144dbc42ee1$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $a0779144dbc42ee1$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($a0779144dbc42ee1$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $a0779144dbc42ee1$var$matchDomain(expected) {
    const currentUrl = $a0779144dbc42ee1$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$a0779144dbc42ee1$var$HTTP_REGEX.test(protocol)) return false;
    if ($a0779144dbc42ee1$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$NETWORK_TIMEOUT = new $a0779144dbc42ee1$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $a0779144dbc42ee1$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $a0779144dbc42ee1$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $a0779144dbc42ee1$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $a0779144dbc42ee1$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $a0779144dbc42ee1$var$resetUnloadedGapiModules();
                    reject($a0779144dbc42ee1$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $a0779144dbc42ee1$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $a0779144dbc42ee1$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $a0779144dbc42ee1$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $a0779144dbc42ee1$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $a0779144dbc42ee1$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($a0779144dbc42ee1$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $a0779144dbc42ee1$var$_loadJS(`${$a0779144dbc42ee1$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $a0779144dbc42ee1$var$cachedGApiLoader = null;
        throw error;
    });
}
let $a0779144dbc42ee1$var$cachedGApiLoader = null;
function $a0779144dbc42ee1$var$_loadGapi(auth) {
    $a0779144dbc42ee1$var$cachedGApiLoader = $a0779144dbc42ee1$var$cachedGApiLoader || $a0779144dbc42ee1$var$loadGapi(auth);
    return $a0779144dbc42ee1$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$PING_TIMEOUT = new $a0779144dbc42ee1$var$Delay(5000, 15000);
const $a0779144dbc42ee1$var$IFRAME_PATH = '__/auth/iframe';
const $a0779144dbc42ee1$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $a0779144dbc42ee1$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $a0779144dbc42ee1$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $a0779144dbc42ee1$var$getIframeUrl(auth) {
    const config = auth.config;
    $a0779144dbc42ee1$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $a0779144dbc42ee1$var$_emulatorUrl(config, $a0779144dbc42ee1$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$a0779144dbc42ee1$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c)
    };
    const eid = $a0779144dbc42ee1$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(params).slice(1)}`;
}
async function $a0779144dbc42ee1$var$_openIframe(auth) {
    const context = await $a0779144dbc42ee1$var$_loadGapi(auth);
    const gapi1 = $a0779144dbc42ee1$var$_window().gapi;
    $a0779144dbc42ee1$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $a0779144dbc42ee1$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $a0779144dbc42ee1$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $a0779144dbc42ee1$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $a0779144dbc42ee1$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $a0779144dbc42ee1$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $a0779144dbc42ee1$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $a0779144dbc42ee1$var$DEFAULT_WIDTH = 500;
const $a0779144dbc42ee1$var$DEFAULT_HEIGHT = 600;
const $a0779144dbc42ee1$var$TARGET_BLANK = '_blank';
const $a0779144dbc42ee1$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $a0779144dbc42ee1$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $a0779144dbc42ee1$var$_open(auth, url, name, width = $a0779144dbc42ee1$var$DEFAULT_WIDTH, height = $a0779144dbc42ee1$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, $a0779144dbc42ee1$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $c38e0f42709c826a$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $a0779144dbc42ee1$var$_isChromeIOS(ua) ? $a0779144dbc42ee1$var$TARGET_BLANK : name;
    if ($a0779144dbc42ee1$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $a0779144dbc42ee1$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($a0779144dbc42ee1$var$_isIOSStandalone(ua) && target !== '_self') {
        $a0779144dbc42ee1$var$openAsNewWindowIOS(url || '', target);
        return new $a0779144dbc42ee1$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $a0779144dbc42ee1$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $a0779144dbc42ee1$export$c03999cb2f36933f(newWin);
}
function $a0779144dbc42ee1$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $a0779144dbc42ee1$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $a0779144dbc42ee1$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $a0779144dbc42ee1$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $a0779144dbc42ee1$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $a0779144dbc42ee1$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $a0779144dbc42ee1$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $57d436074e210fb5$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $a0779144dbc42ee1$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $c38e0f42709c826a$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $a0779144dbc42ee1$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$a0779144dbc42ee1$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$a0779144dbc42ee1$var$getHandlerBase(auth)}?${(0, $c38e0f42709c826a$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $a0779144dbc42ee1$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$a0779144dbc42ee1$var$WIDGET_PATH}`;
    return $a0779144dbc42ee1$var$_emulatorUrl(config, $a0779144dbc42ee1$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $a0779144dbc42ee1$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $a0779144dbc42ee1$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $a0779144dbc42ee1$export$407448d2b89b1813;
        this._completeRedirectFn = $a0779144dbc42ee1$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $a0779144dbc42ee1$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $a0779144dbc42ee1$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await $a0779144dbc42ee1$export$28f7fcd39efa255(auth, provider, authType, $a0779144dbc42ee1$var$_getCurrentUrl(), eventId);
        return $a0779144dbc42ee1$var$_open(auth, url, $a0779144dbc42ee1$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $a0779144dbc42ee1$export$28f7fcd39efa255(auth, provider, authType, $a0779144dbc42ee1$var$_getCurrentUrl(), eventId);
        $a0779144dbc42ee1$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $a0779144dbc42ee1$export$1fbe638ecf81657e(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $a0779144dbc42ee1$var$_openIframe(auth);
        const manager = new $a0779144dbc42ee1$export$24baa2b76016ce0e(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $a0779144dbc42ee1$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($a0779144dbc42ee1$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $a0779144dbc42ee1$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$a0779144dbc42ee1$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $a0779144dbc42ee1$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $a0779144dbc42ee1$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $a0779144dbc42ee1$var$_isMobileBrowser() || $a0779144dbc42ee1$var$_isSafari() || $a0779144dbc42ee1$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $a0779144dbc42ee1$export$342063e11d6c3cad = $a0779144dbc42ee1$var$BrowserPopupRedirectResolver;
class $a0779144dbc42ee1$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $a0779144dbc42ee1$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $a0779144dbc42ee1$var$PhoneMultiFactorAssertionImpl extends $a0779144dbc42ee1$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $a0779144dbc42ee1$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $a0779144dbc42ee1$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $a0779144dbc42ee1$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $a0779144dbc42ee1$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $a0779144dbc42ee1$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $a0779144dbc42ee1$export$953cecd6e717a553.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $a0779144dbc42ee1$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $a0779144dbc42ee1$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $a0779144dbc42ee1$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $a0779144dbc42ee1$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $a0779144dbc42ee1$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $a0779144dbc42ee1$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $a0779144dbc42ee1$var$TotpMultiFactorAssertionImpl extends $a0779144dbc42ee1$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $a0779144dbc42ee1$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $a0779144dbc42ee1$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $a0779144dbc42ee1$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $a0779144dbc42ee1$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $a0779144dbc42ee1$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $a0779144dbc42ee1$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($a0779144dbc42ee1$var$_isEmptyString(accountName) || $a0779144dbc42ee1$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($a0779144dbc42ee1$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if ($a0779144dbc42ee1$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $a0779144dbc42ee1$var$_isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $a0779144dbc42ee1$var$name = "@firebase/auth";
var $a0779144dbc42ee1$var$version = "1.8.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $a0779144dbc42ee1$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $a0779144dbc42ee1$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a0779144dbc42ee1$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $a0779144dbc42ee1$var$registerAuth(clientPlatform) {
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $a0779144dbc42ee1$export$890c4ad488842ce7(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $a0779144dbc42ee1$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $a0779144dbc42ee1$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $a0779144dbc42ee1$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $a0779144dbc42ee1$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $a0779144dbc42ee1$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($a0779144dbc42ee1$var$name, $a0779144dbc42ee1$var$version, $a0779144dbc42ee1$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($a0779144dbc42ee1$var$name, $a0779144dbc42ee1$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a0779144dbc42ee1$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $a0779144dbc42ee1$var$authIdTokenMaxAge = (0, $c38e0f42709c826a$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $a0779144dbc42ee1$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $a0779144dbc42ee1$var$lastPostedIdToken = null;
const $a0779144dbc42ee1$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $a0779144dbc42ee1$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($a0779144dbc42ee1$var$lastPostedIdToken === idToken) return;
        $a0779144dbc42ee1$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $a0779144dbc42ee1$export$ae1af26003f05816(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)()) {
    const provider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $a0779144dbc42ee1$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $a0779144dbc42ee1$export$342063e11d6c3cad,
        persistence: [
            $a0779144dbc42ee1$export$23f2a1d2818174ef,
            $a0779144dbc42ee1$export$8b22cf2602fb60ce,
            $a0779144dbc42ee1$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $c38e0f42709c826a$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $a0779144dbc42ee1$var$mintCookieFactory(authTokenSyncUrl.toString());
            $a0779144dbc42ee1$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $a0779144dbc42ee1$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $c38e0f42709c826a$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $a0779144dbc42ee1$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $a0779144dbc42ee1$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$a0779144dbc42ee1$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $a0779144dbc42ee1$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $a0779144dbc42ee1$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$a0779144dbc42ee1$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );














/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $03ee16a658161e2a$var$LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
const $03ee16a658161e2a$var$UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
function $03ee16a658161e2a$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    const result = {};
    for(const key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */ function $03ee16a658161e2a$var$encode(data) {
    if (data == null) return null;
    if (data instanceof Number) data = data.valueOf();
    if (typeof data === 'number' && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
    if (data === true || data === false) return data;
    if (Object.prototype.toString.call(data) === '[object String]') return data;
    if (data instanceof Date) return data.toISOString();
    if (Array.isArray(data)) return data.map((x)=>$03ee16a658161e2a$var$encode(x));
    if (typeof data === 'function' || typeof data === 'object') return $03ee16a658161e2a$var$mapValues(data, (x)=>$03ee16a658161e2a$var$encode(x));
    // If we got this far, the data is not encodable.
    throw new Error('Data cannot be encoded in JSON: ' + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */ function $03ee16a658161e2a$var$decode(json) {
    if (json == null) return json;
    if (json['@type']) switch(json['@type']){
        case $03ee16a658161e2a$var$LONG_TYPE:
        // Fall through and handle this the same as unsigned.
        case $03ee16a658161e2a$var$UNSIGNED_LONG_TYPE:
            {
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                const value = Number(json['value']);
                if (isNaN(value)) throw new Error('Data cannot be decoded from JSON: ' + json);
                return value;
            }
        default:
            throw new Error('Data cannot be decoded from JSON: ' + json);
    }
    if (Array.isArray(json)) return json.map((x)=>$03ee16a658161e2a$var$decode(x));
    if (typeof json === 'function' || typeof json === 'object') return $03ee16a658161e2a$var$mapValues(json, (x)=>$03ee16a658161e2a$var$decode(x));
    // Anything else is safe to return.
    return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ const $03ee16a658161e2a$var$FUNCTIONS_TYPE = 'functions';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ const $03ee16a658161e2a$var$errorCodeMap = {
    OK: 'ok',
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    UNAUTHENTICATED: 'unauthenticated',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss'
};
/**
 * An error returned by the Firebase Functions client SDK.
 *
 * See {@link FunctionsErrorCode} for full documentation of codes.
 *
 * @public
 */ class $03ee16a658161e2a$export$738689d52335bb3c extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /**
     * Constructs a new instance of the `FunctionsError` class.
     */ constructor(/**
     * A standard error code that will be returned to the client. This also
     * determines the HTTP status code of the response, as defined in code.proto.
     */ code, message, /**
     * Additional details to be converted to JSON and included in the error response.
     */ details){
        super(`${$03ee16a658161e2a$var$FUNCTIONS_TYPE}/${code}`, message || '');
        this.details = details;
        // Since the FirebaseError constructor sets the prototype of `this` to FirebaseError.prototype,
        // we also have to do it in all subclasses to allow for correct `instanceof` checks.
        Object.setPrototypeOf(this, $03ee16a658161e2a$export$738689d52335bb3c.prototype);
    }
}
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $03ee16a658161e2a$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return 'ok';
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return 'internal';
        case 400:
            return 'invalid-argument';
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission-denied';
        case 404:
            return 'not-found';
        case 409:
            return 'aborted';
        case 429:
            return 'resource-exhausted';
        case 499:
            return 'cancelled';
        case 500:
            return 'internal';
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline-exceeded';
    }
    return 'unknown';
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $03ee16a658161e2a$var$_errorForResponse(status, bodyJSON) {
    let code = $03ee16a658161e2a$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    let description = code;
    let details = undefined;
    // Then look through the body for explicit details.
    try {
        const errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            const status = errorJSON.status;
            if (typeof status === 'string') {
                if (!$03ee16a658161e2a$var$errorCodeMap[status]) // They must've included an unknown error code in the body.
                return new $03ee16a658161e2a$export$738689d52335bb3c('internal', 'internal');
                code = $03ee16a658161e2a$var$errorCodeMap[status];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status;
            }
            const message = errorJSON.message;
            if (typeof message === 'string') description = message;
            details = errorJSON.details;
            if (details !== undefined) details = $03ee16a658161e2a$var$decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === 'ok') // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $03ee16a658161e2a$export$738689d52335bb3c(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */ class $03ee16a658161e2a$var$ContextProvider {
    constructor(authProvider, messagingProvider, appCheckProvider){
        this.auth = null;
        this.messaging = null;
        this.appCheck = null;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then((auth)=>this.auth = auth, ()=>{
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then((messaging)=>this.messaging = messaging, ()=>{
        /* get() never rejects */ });
        if (!this.appCheck) appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck, ()=>{
        /* get() never rejects */ });
    }
    async getAuthToken() {
        if (!this.auth) return undefined;
        try {
            const token = await this.auth.getToken();
            return token === null || token === void 0 ? void 0 : token.accessToken;
        } catch (e) {
            // If there's any error when trying to get the auth token, leave it off.
            return undefined;
        }
    }
    async getMessagingToken() {
        if (!this.messaging || !('Notification' in self) || Notification.permission !== 'granted') return undefined;
        try {
            return await this.messaging.getToken();
        } catch (e) {
            // We don't warn on this, because it usually means messaging isn't set up.
            // console.warn('Failed to retrieve instance id token.', e);
            // If there's any error when trying to get the token, leave it off.
            return undefined;
        }
    }
    async getAppCheckToken(limitedUseAppCheckTokens) {
        if (this.appCheck) {
            const result = limitedUseAppCheckTokens ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
            if (result.error) // Do not send the App Check header to the functions endpoint if
            // there was an error from the App Check exchange endpoint. The App
            // Check SDK will already have logged the error to console.
            return null;
            return result.token;
        }
        return null;
    }
    async getContext(limitedUseAppCheckTokens) {
        const authToken = await this.getAuthToken();
        const messagingToken = await this.getMessagingToken();
        const appCheckToken = await this.getAppCheckToken(limitedUseAppCheckTokens);
        return {
            authToken: authToken,
            messagingToken: messagingToken,
            appCheckToken: appCheckToken
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $03ee16a658161e2a$var$DEFAULT_REGION = 'us-central1';
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $03ee16a658161e2a$var$failAfter(millis) {
    // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer = null;
    return {
        promise: new Promise((_, reject)=>{
            timer = setTimeout(()=>{
                reject(new $03ee16a658161e2a$export$738689d52335bb3c('deadline-exceeded', 'deadline-exceeded'));
            }, millis);
        }),
        cancel: ()=>{
            if (timer) clearTimeout(timer);
        }
    };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */ class $03ee16a658161e2a$var$FunctionsService {
    /**
     * Creates a new Functions service for the given app.
     * @param app - The FirebaseApp to use.
     */ constructor(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain = $03ee16a658161e2a$var$DEFAULT_REGION){
        this.app = app;
        this.emulatorOrigin = null;
        this.contextProvider = new $03ee16a658161e2a$var$ContextProvider(authProvider, messagingProvider, appCheckProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise((resolve)=>{
            this.deleteService = ()=>{
                return Promise.resolve(resolve());
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            const url = new URL(regionOrCustomDomain);
            this.customDomain = url.origin + (url.pathname === '/' ? '' : url.pathname);
            this.region = $03ee16a658161e2a$var$DEFAULT_REGION;
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain;
        }
    }
    _delete() {
        return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */ _url(name) {
        const projectId = this.app.options.projectId;
        if (this.emulatorOrigin !== null) {
            const origin = this.emulatorOrigin;
            return `${origin}/${projectId}/${this.region}/${name}`;
        }
        if (this.customDomain !== null) return `${this.customDomain}/${name}`;
        return `https://${this.region}-${projectId}.cloudfunctions.net/${name}`;
    }
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */ function $03ee16a658161e2a$var$connectFunctionsEmulator$1(functionsInstance, host, port) {
    functionsInstance.emulatorOrigin = `http://${host}:${port}`;
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $03ee16a658161e2a$var$httpsCallable$1(functionsInstance, name, options) {
    return (data)=>{
        return $03ee16a658161e2a$var$call(functionsInstance, name, data, options || {});
    };
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */ function $03ee16a658161e2a$var$httpsCallableFromURL$1(functionsInstance, url, options) {
    return (data)=>{
        return $03ee16a658161e2a$var$callAtURL(functionsInstance, url, data, options || {});
    };
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @return A Promise that will succeed when the request finishes.
 */ async function $03ee16a658161e2a$var$postJSON(url, body, headers) {
    headers['Content-Type'] = 'application/json';
    let response;
    try {
        response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: headers
        });
    } catch (e) {
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        return {
            status: 0,
            json: null
        };
    }
    let json = null;
    try {
        json = await response.json();
    } catch (e) {
    // If we fail to parse JSON, it will fail the same as an empty body.
    }
    return {
        status: response.status,
        json: json
    };
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ function $03ee16a658161e2a$var$call(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $03ee16a658161e2a$var$callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ async function $03ee16a658161e2a$var$callAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $03ee16a658161e2a$var$encode(data);
    const body = {
        data: data
    };
    // Add a header for the authToken.
    const headers = {};
    const context = await functionsInstance.contextProvider.getContext(options.limitedUseAppCheckTokens);
    if (context.authToken) headers['Authorization'] = 'Bearer ' + context.authToken;
    if (context.messagingToken) headers['Firebase-Instance-ID-Token'] = context.messagingToken;
    if (context.appCheckToken !== null) headers['X-Firebase-AppCheck'] = context.appCheckToken;
    // Default timeout to 70s, but let the options override it.
    const timeout = options.timeout || 70000;
    const failAfterHandle = $03ee16a658161e2a$var$failAfter(timeout);
    const response = await Promise.race([
        $03ee16a658161e2a$var$postJSON(url, body, headers),
        failAfterHandle.promise,
        functionsInstance.cancelAllRequests
    ]);
    // Always clear the failAfter timeout
    failAfterHandle.cancel();
    // If service was deleted, interrupted response throws an error.
    if (!response) throw new $03ee16a658161e2a$export$738689d52335bb3c('cancelled', 'Firebase Functions instance was deleted.');
    // Check for an error status, regardless of http status.
    const error = $03ee16a658161e2a$var$_errorForResponse(response.status, response.json);
    if (error) throw error;
    if (!response.json) throw new $03ee16a658161e2a$export$738689d52335bb3c('internal', 'Response is not valid JSON object.');
    let responseData = response.json.data;
    // TODO(klimt): For right now, allow "result" instead of "data", for
    // backwards compatibility.
    if (typeof responseData === 'undefined') responseData = response.json.result;
    if (typeof responseData === 'undefined') // Consider the response malformed.
    throw new $03ee16a658161e2a$export$738689d52335bb3c('internal', 'Response is missing data field.');
    // Decode any special types, such as dates, in the returned data.
    const decodedData = $03ee16a658161e2a$var$decode(responseData);
    return {
        data: decodedData
    };
}
const $03ee16a658161e2a$var$name = "@firebase/functions";
const $03ee16a658161e2a$var$version = "0.11.10";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $03ee16a658161e2a$var$AUTH_INTERNAL_NAME = 'auth-internal';
const $03ee16a658161e2a$var$APP_CHECK_INTERNAL_NAME = 'app-check-internal';
const $03ee16a658161e2a$var$MESSAGING_INTERNAL_NAME = 'messaging-internal';
function $03ee16a658161e2a$var$registerFunctions(variant) {
    const factory = (container, { instanceIdentifier: regionOrCustomDomain })=>{
        // Dependencies
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider($03ee16a658161e2a$var$AUTH_INTERNAL_NAME);
        const messagingProvider = container.getProvider($03ee16a658161e2a$var$MESSAGING_INTERNAL_NAME);
        const appCheckProvider = container.getProvider($03ee16a658161e2a$var$APP_CHECK_INTERNAL_NAME);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $03ee16a658161e2a$var$FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain);
    };
    (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)($03ee16a658161e2a$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($03ee16a658161e2a$var$name, $03ee16a658161e2a$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($03ee16a658161e2a$var$name, $03ee16a658161e2a$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */ function $03ee16a658161e2a$export$7d4c14593b8a2193(app = (0, $57d436074e210fb5$export$f9962582c9e66d99)(), regionOrCustomDomain = $03ee16a658161e2a$var$DEFAULT_REGION) {
    // Dependencies
    const functionsProvider = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(app), $03ee16a658161e2a$var$FUNCTIONS_TYPE);
    const functionsInstance = functionsProvider.getImmediate({
        identifier: regionOrCustomDomain
    });
    const emulator = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)('functions');
    if (emulator) $03ee16a658161e2a$export$472343ee9d485d97(functionsInstance, ...emulator);
    return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */ function $03ee16a658161e2a$export$472343ee9d485d97(functionsInstance, host, port) {
    $03ee16a658161e2a$var$connectFunctionsEmulator$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $03ee16a658161e2a$export$438b58c7f2c6bf5e(functionsInstance, name, options) {
    return $03ee16a658161e2a$var$httpsCallable$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */ function $03ee16a658161e2a$export$486b60b301a0b194(functionsInstance, url, options) {
    return $03ee16a658161e2a$var$httpsCallableFromURL$1((0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */ $03ee16a658161e2a$var$registerFunctions();






var $2f75560c51037fec$exports = {};
!function(t, e) {
    e($2f75560c51037fec$exports);
}($2f75560c51037fec$exports, function(t) {
    "use strict";
    var e = "0123456789bcdefghjkmnpqrstuvwxyz", n = 40007860, r = 110574, o = 6378137, a = .00669447819799;
    function i(t) {
        return Math.log(t) / Math.log(2);
    }
    function h(t) {
        var e;
        if (Array.isArray(t)) {
            if (2 !== t.length) e = "expected array of length 2, got length " + t.length;
            else {
                var n = t[0], r = t[1];
                "number" != typeof n || isNaN(n) ? e = "latitude must be a number" : n < -90 || n > 90 ? e = "latitude must be within the range [-90, 90]" : "number" != typeof r || isNaN(r) ? e = "longitude must be a number" : (r < -180 || r > 180) && (e = "longitude must be within the range [-180, 180]");
            }
        } else e = "location must be an array";
        if (void 0 !== e) throw new Error("Invalid GeoFire location '" + t + "': " + e);
    }
    function u(t) {
        var n;
        if ("string" != typeof t) n = "geohash must be a string";
        else if (0 === t.length) n = "geohash cannot be the empty string";
        else for(var r = 0, o = t; r < o.length; r++){
            var a = o[r];
            -1 === e.indexOf(a) && (n = "geohash cannot contain '" + a + "'");
        }
        if (void 0 !== n) throw new Error("Invalid GeoFire geohash '" + t + "': " + n);
    }
    function s(t) {
        if ("number" != typeof t || isNaN(t)) throw new Error("Error: degrees must be a number");
        return t * Math.PI / 180;
    }
    function f(t, n) {
        if (void 0 === n && (n = 10), h(t), void 0 !== n) {
            if ("number" != typeof n || isNaN(n)) throw new Error("precision must be a number");
            if (n <= 0) throw new Error("precision must be greater than 0");
            if (n > 22) throw new Error("precision cannot be greater than 22");
            if (Math.round(n) !== n) throw new Error("precision must be an integer");
        }
        for(var r = {
            min: -90,
            max: 90
        }, o = {
            min: -180,
            max: 180
        }, a = "", i = 0, u = 0, s = 1; a.length < n;){
            var f = s ? t[1] : t[0], c = s ? o : r, g = (c.min + c.max) / 2;
            f > g ? (i = 1 + (i << 1), c.min = g) : (i = 0 + (i << 1), c.max = g), s = !s, u < 4 ? u++ : (u = 0, a += e[i], i = 0);
        }
        return a;
    }
    function c(t, e) {
        var n = s(e), r = Math.cos(n) * o * Math.PI / 180 * (1 / Math.sqrt(1 - a * Math.sin(n) * Math.sin(n)));
        return r < 1e-12 ? t > 0 ? 360 : 0 : Math.min(360, t / r);
    }
    function g(t, e) {
        var n = c(t, e);
        return Math.abs(n) > 1e-6 ? Math.max(1, i(360 / n)) : 1;
    }
    function l(t) {
        return Math.min(i(20003930 / t), 110);
    }
    function m(t) {
        if (t <= 180 && t >= -180) return t;
        var e = t + 180;
        return e > 0 ? e % 360 - 180 : 180 - -e % 360;
    }
    function d(t, e) {
        var n = e / r, o = Math.min(90, t[0] + n), a = Math.max(-90, t[0] - n), i = 2 * Math.floor(l(e)), h = 2 * Math.floor(g(e, o)) - 1, u = 2 * Math.floor(g(e, a)) - 1;
        return Math.min(i, h, u, 110);
    }
    function M(t, e) {
        var n = e / r, o = Math.min(90, t[0] + n), a = Math.max(-90, t[0] - n), i = c(e, o), h = c(e, a), u = Math.max(i, h);
        return [
            [
                t[0],
                t[1]
            ],
            [
                t[0],
                m(t[1] - u)
            ],
            [
                t[0],
                m(t[1] + u)
            ],
            [
                o,
                t[1]
            ],
            [
                o,
                m(t[1] - u)
            ],
            [
                o,
                m(t[1] + u)
            ],
            [
                a,
                t[1]
            ],
            [
                a,
                m(t[1] - u)
            ],
            [
                a,
                m(t[1] + u)
            ]
        ];
    }
    function b(t, n) {
        u(t);
        var r = Math.ceil(n / 5);
        if (t.length < r) return [
            t,
            t + "~"
        ];
        var o = (t = t.substring(0, r)).substring(0, t.length - 1), a = e.indexOf(t.charAt(t.length - 1)), i = 5 - (n - 5 * o.length), h = a >> i << i, s = h + (1 << i);
        return s > 31 ? [
            o + e[h],
            o + "~"
        ] : [
            o + e[h],
            o + e[s]
        ];
    }
    t.BASE32 = e, t.BITS_PER_CHAR = 5, t.E2 = a, t.EARTH_EQ_RADIUS = o, t.EARTH_MERI_CIRCUMFERENCE = n, t.EPSILON = 1e-12, t.GEOHASH_PRECISION = 10, t.MAXIMUM_BITS_PRECISION = 110, t.METERS_PER_DEGREE_LATITUDE = r, t.boundingBoxBits = d, t.boundingBoxCoordinates = M, t.degreesToRadians = s, t.distanceBetween = function(t, e) {
        h(t), h(e);
        var n = s(e[0] - t[0]), r = s(e[1] - t[1]), o = Math.sin(n / 2) * Math.sin(n / 2) + Math.cos(s(t[0])) * Math.cos(s(e[0])) * Math.sin(r / 2) * Math.sin(r / 2);
        return 6371 * (2 * Math.atan2(Math.sqrt(o), Math.sqrt(1 - o)));
    }, t.geohashForLocation = f, t.geohashQuery = b, t.geohashQueryBounds = function(t, e) {
        h(t);
        var n = Math.max(1, d(t, e)), r = Math.ceil(n / 5), o = M(t, e).map(function(t) {
            return b(f(t, r), n);
        });
        return o.filter(function(t, e) {
            return !o.some(function(n, r) {
                return e > r && t[0] === n[0] && t[1] === n[1];
            });
        });
    }, t.latitudeBitsForResolution = l, t.longitudeBitsForResolution = g, t.metersToLongitudeDegrees = c, t.validateGeohash = u, t.validateKey = function(t) {
        var e;
        if ("string" != typeof t ? e = "key must be a string" : 0 === t.length ? e = "key cannot be the empty string" : 11 + t.length > 755 ? e = "key is too long to be stored in Firebase" : /[\[\].#$\/\u0000-\u001F\u007F]/.test(t) && (e = "key cannot contain any of the following characters: . # $ ] [ /"), void 0 !== e) throw new Error("Invalid GeoFire key '" + t + "': " + e);
    }, t.validateLocation = h, t.wrapLongitude = m, Object.defineProperty(t, "__esModule", {
        value: !0
    });
});









const $27ce1bd96c2798d8$var$firebaseConfig = {
    apiKey: "AIzaSyDaR-KYChndjdq72ajqVApfekNGMjfRUDc",
    authDomain: "mqmexico-7c834.firebaseapp.com",
    projectId: "mqmexico-7c834",
    storageBucket: "mqmexico-7c834.firebasestorage.app",
    messagingSenderId: "1010457339958",
    appId: "1:1010457339958:web:2ea6e38dd339d903329097",
    measurementId: "G-V07BLTYCSS"
};
const $27ce1bd96c2798d8$var$firebaseApp = (0, $57d436074e210fb5$export$c55cfd413944906d)($27ce1bd96c2798d8$var$firebaseConfig);
const $27ce1bd96c2798d8$var$auth = (0, $a0779144dbc42ee1$export$ae1af26003f05816)($27ce1bd96c2798d8$var$firebaseApp);
const $27ce1bd96c2798d8$var$functions = (0, $03ee16a658161e2a$export$7d4c14593b8a2193)($27ce1bd96c2798d8$var$firebaseApp);
const $27ce1bd96c2798d8$var$storage = (0, $df9a6d7fd06616c9$export$fbd9b57a66480737)($27ce1bd96c2798d8$var$firebaseApp); // ✅ for Storage
const $27ce1bd96c2798d8$var$db = (0, $70fd6868680e912c$export$f06a05d14c3a6678)($27ce1bd96c2798d8$var$firebaseApp); // ✅ for Firestore
const $27ce1bd96c2798d8$var$dbRT = (0, $da38ac6aa733c404$export$d0dd861204d0bf72)($27ce1bd96c2798d8$var$firebaseApp); // ✅ Realtime DB (pass the app)
const $27ce1bd96c2798d8$var$messaging = (0, $97b6afad2c5c80cd$export$f74c3c76482a8451)($27ce1bd96c2798d8$var$firebaseApp); // ✅ for messaging
// const swRegistration = await navigator.serviceWorker.ready;
const $27ce1bd96c2798d8$var$VAPIDKEY = 'BHe5dIT3RZJOk5aeZ33IB7JxM5dZ56Pkt-xLRg1zRwFLBoNJ6FEzdzg4nlBFiIcM_mzmLMU4wmc14oBJHO2_Yg8';
const $27ce1bd96c2798d8$var$omittedWordsInTokens = [
    "a\xf1o",
    "de",
    "a",
    "del",
    "venta",
    "compra"
];
class $27ce1bd96c2798d8$var$FireBaseHelperOwn {
    #targetedSearchLastDoc;
    #currentAuthUserID = null;
    #currentAuthUserData = null;
    #liveListenerForAccount = false;
    #notificationOnWalletChange = false;
    #notificationOnWalletChangeTitle = "";
    #notificationOnWalletChangeBody = "";
    #notificationOnWalletChangeButtonLabel = "";
    #notificationOnWalletChangeButtonAction = "";
    #userDataLiveListenerUnsubscribe = null;
    #timesCalledAgain = 0;
    #wasSignedIn = false;
    constructor(){
        // this._NVSearchTest()
        // this._authenticateListerner();
        // THIS is the funtion that initializes this page
        // this._authStateHandlerOnceAndOnChange();}
        // this._syncDataToItems();
        // this._requestPayPalOrder({ amount: "12688.93" });
        // this._onSnapShotForWallet("ygTqsX1DPwE2rQCLhLec");
        // this._signInUser("benklassen19@icloud.com", "Be123456");
        // setTimeout(() => {
        //   this._signInUser("thorastrack@gmail.com", "Be123456");
        //   setTimeout(() => {
        //     this._signOutUser();
        //   }, 4000);
        // }, 8000);
        // this._authenticateNewUser("benklasse19@icloud.com", "Be123456", "Ben");
        // this._updateUserTemplate(dataForTemplate);
        // this._uploadMachineData(machines);
        // this._uploadMachineData("remolque", "nortezac", "6 toneladas");
        // Start how to get sumary
        // this._getDocumentCountInColection("individualListings");
        // this._getDocumentCountInColection("accounts");
        // this._getDocumentCountInColection("businesses");
        // this._getArrayLength("accounts/CDLTykc4Bnav6fzZWwqw", "listings");
        // End how to get sumary
        // setTimeout(() => {
        //   this._writeStats("Athere", "83y4g2fh894u3rhf9un4d3");
        //   this._writeStats("Athere", "83y4g2fh894u3rhf9un4d3");
        //   this._writeStats("Athere", "83y4g2fh894u3rhf9un4d3");
        //   this._writeStats("accountsCreated", "83y4g2fh894u3rhf9un4d3");
        //   this._writeStats("accountsCreated", "83y4g2fh894u3rhf9un4d3");
        //   this._writeStats("accountsCreated", "83y4g2fh894u3rhf9un4d3");
        // }, 3000);
        const notification = {
            title: "Test new user",
            body: "Test preferences notification.",
            url: "",
            openTo: "notification/fugichfbedjxn",
            image: "https://...",
            tag: "message-1",
            category: "important",
            inAppLink: "channel/8f4y9hf934/post/ugcreiwbkc"
        };
        const notificationBroadcast = {
            title: "MAI Braodcast Noti All 6.0",
            body: "This is a broadcast test notification.",
            url: "",
            image: "https://...",
            tag: "broadcast-1.0",
            category: "promotional",
            inAppLink: "broadcast"
        };
        const targetSystem = 'appNotifications';
    // this._NVCreateNotificationsForUsers({ requestId: crypto.randomUUID(), userIds: ['ZPww1k6WI6TfnGBlhIbHSByRbLI2', 'uxH81vCURJQdbFqNCtJdDhuLyII2'], notification })
    // this._NVWriteSystemNotification({ notification: notificationBroadcast, targetSystem })
    // this._getVideoUrlByPath('big add videos/land scape test vid.MOV')
    }
    _ALLINIT() {
        this._authStateHandlerOnceAndOnChange();
    }
    _getVideoUrlByPath(path = 'big add videos/0210.mov') {
        const storageRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)($27ce1bd96c2798d8$var$storage, path);
        (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(storageRef).then((url)=>{
            console.log("Video URL:", url);
        }).catch((error)=>{
            console.error(error);
        });
    }
    async _getAndStoreFCMToken(userId, swRegistration) {
        try {
            const token = await (0, $97b6afad2c5c80cd$export$257b2d10b709d8ef)($27ce1bd96c2798d8$var$messaging, {
                vapidKey: $27ce1bd96c2798d8$var$VAPIDKEY,
                serviceWorkerRegistration: swRegistration
            });
            if (!token) {
                console.warn("No FCM token returned");
                return;
            }
            console.log("FCM token:", token);
            // alert(`FCM token:${token}`)
            const clientPlatformData = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getClientPlatformInfo();
            console.log(clientPlatformData);
            const sendData = {
                token: token,
                platform: clientPlatformData.platform,
                os: clientPlatformData.os,
                browser: clientPlatformData.browser,
                isPWA: clientPlatformData.isPWA,
                permission: 'granted',
                appVersion: '3.0.0',
                locale: 'es-MX'
            };
            const result = await this._NVUpdateUserDeviceFCMToken(sendData);
            console.log(result);
            if (result.data.success) ;
            else throw new Error(`ERROR: ${result.data.message}`);
        } catch (err) {
            console.error("Error getting FCM token:", err);
            if (err?.code === "messaging/permission-blocked") alert("No podimos activar tus notificaciones en este momento. Favor ingresa en los ajustes de tu dispositivo, y activa las notificaciones para esta aplicaci\xf3n. Despu\xe9s regrese a Mercado MAI, y vuele a abrir en menu de notificaciones para finalizar la activacion.");
            else alert(err.message);
        }
    }
    async _storeNativeFCMToken(nativeToken) {
        try {
            if (!nativeToken) {
                console.warn("No native token provided");
                return;
            }
            console.log("\uD83D\uDCF1 Native FCM token:", nativeToken);
            // 👇 You can reuse this if it works on native
            const clientPlatformData = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._getClientPlatformInfo();
            const sendData = {
                token: nativeToken,
                platform: "native",
                os: clientPlatformData.os || "android",
                browser: "native-app",
                isPWA: false,
                permission: "granted",
                appVersion: "3.0.0",
                locale: "es-MX"
            };
            console.log("\uD83D\uDCE4 Sending native token:", sendData);
            const result = await this._NVUpdateUserDeviceFCMToken(sendData);
            console.log(result);
            if (result.data.success) console.log("\u2705 Native device registered");
            else throw new Error(`ERROR: ${result.data.message}`);
        } catch (err) {
            console.error("Error storing native FCM token:", err);
        }
    }
    async _NVUpdateUserDeviceFCMToken(data) {
        console.log(data);
        try {
            console.log(data);
            const NVUpdateUserDeviceFCMToken = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVUpdateUserDeviceFCMToken");
            const result = await NVUpdateUserDeviceFCMToken(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVCreateNotificationsForUsers(data) {
        console.log(data);
        // return
        try {
            console.log(data);
            const NVCreateNotificationsForUsers = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVCreateNotificationsForUsers");
            const result = await NVCreateNotificationsForUsers(data);
            console.warn(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVWriteSystemNotification(data) {
        console.log(data);
        try {
            console.log(data);
            const NVWriteSystemNotification = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVWriteSystemNotification");
            const result = await NVWriteSystemNotification(data);
            console.warn(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    // async _getNotifications(path, lastDoc = null) {
    //   try {
    //     const collectionRef = collection(db, path);
    //     let q = query(
    //       collectionRef,
    //       orderBy("createdAt", "desc"),
    //       limit(20)
    //     );
    //     // Pagination cursor
    //     if (lastDoc) {
    //       q = query(
    //         collectionRef,
    //         orderBy("createdAt", "desc"),
    //         startAfter(lastDoc),
    //         limit(20)
    //       );
    //     }
    //     const querySnapshot = await getDocs(q);
    //     if (querySnapshot.empty) {
    //       return {
    //         notifications: [],
    //         lastDoc: null,
    //         hasMore: false,
    //       };
    //     }
    //     const notifications = querySnapshot.docs.map((doc) => ({
    //       id: doc.id,
    //       ...doc.data(),
    //     }));
    //     return {
    //       notifications,
    //       lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1],
    //       hasMore: querySnapshot.size === 20,
    //     };
    //   } catch (error) {
    //     console.error("Error getting notifications:", error);
    //     return {
    //       notifications: [],
    //       lastDoc: null,
    //       hasMore: false,
    //     };
    //   }
    // }
    async _getNotifications(path, category = "all", lastDoc = null) {
        try {
            const collectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, path);
            const constraints = [
                (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("createdAt", "desc"),
                (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(10)
            ];
            // Optional category filter
            if (category !== "all") constraints.unshift((0, $70fd6868680e912c$export$9c59b80dda569a6e)("category", "==", category));
            // Pagination cursor
            if (lastDoc) constraints.push((0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastDoc));
            const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(collectionRef, ...constraints);
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            if (querySnapshot.empty) return {
                notifications: [],
                lastDoc: null,
                hasMore: false
            };
            const notifications = querySnapshot.docs.map((doc)=>({
                    id: doc.id,
                    ...doc.data()
                }));
            return {
                notifications: notifications,
                lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1],
                hasMore: querySnapshot.size === 10
            };
        } catch (error) {
            console.error("Error getting notifications:", error);
            return {
                notifications: [],
                lastDoc: null,
                hasMore: false
            };
        }
    }
    async _NVSearchTest() {
        const NVSearchresults = await this._NVSearchSellersFunction({
            query: "bernardo"
        });
        // const NVSearchresults = await this._NVSearchBusinessesFunction({ query: "silos" })
        // const NVSearchresults = await this._NVSearchListingsFunction({ query: "Generador en hopelchén" })
        console.log(NVSearchresults);
    }
    async _getStats(path) {
        // return;
        // Define the path to the stats node in Realtime Database
        const statsRef = (0, $da38ac6aa733c404$export$eff4d24c3ff7876e)($27ce1bd96c2798d8$var$dbRT, path);
        try {
            // Fetch the data at the specified path
            const snapshot = await (0, $da38ac6aa733c404$export$3988ae62b71be9a3)(statsRef);
            if (snapshot.exists()) {
                // Get the count from the snapshot
                const count = snapshot.val();
                console.log(`Listings Created Count: ${count}`);
                return count;
            } else {
                console.log("No data available at the specified path.");
                return null;
            }
        } catch (error) {
            console.error("Error getting data:", error);
        }
    }
    // Call the function to get the stats
    _setNotificationOnWalletChange(title, body, butonLabel, buttonAction) {
        this.#notificationOnWalletChange = true;
        this.#notificationOnWalletChangeTitle = title;
        this.#notificationOnWalletChangeBody = body;
        this.#notificationOnWalletChangeButtonLabel = butonLabel;
        this.#notificationOnWalletChangeButtonAction = buttonAction;
    }
    _logToConsole(log) {
        console.log(log);
    }
    // Attach a listener to the document
    _onSnapShotForWallet(docId) {
        // Unsubscribe the previous listener
        if (this._currentUnsubscribe) {
            this._currentUnsubscribe();
            console.log("Previous listener unsubscribed.");
        }
        // Attach a new listener
        const unsubscribe = (0, $70fd6868680e912c$export$d36370812fb26935)((0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, "wallets", docId), async (docSnapshot)=>{
            if (docSnapshot.exists()) {
                // Get the updated document data
                const walletData = docSnapshot.data();
                console.log("Document data:", walletData);
                // Fetch the subcollection data (e.g., 'logs')
                const logsCollectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, `wallets/${docId}/logs`);
                const logsSnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(logsCollectionRef);
                // Map and sort the logs by the 'time' field and then by 'tagName'
                const logs = logsSnapshot.docs.map((logDoc)=>({
                        id: logDoc.id,
                        ...logDoc.data()
                    })).sort((a, b)=>{
                    // Primary sorting: by time (descending)
                    const timeDifference = b.time.toMillis() - a.time.toMillis();
                    if (timeDifference !== 0) return timeDifference;
                    // Secondary sorting: prioritize 'salida' for matching times
                    if (a.tagName === "salida" && b.tagName !== "salida") return 1;
                    if (a.tagName !== "salida" && b.tagName === "salida") return -1;
                    // Keep order unchanged for other cases
                    return 0;
                });
                console.log("Sorted Logs subcollection data:", logs);
                if (this.#notificationOnWalletChange) {
                    (0, $3ac641e112e66bf5$export$2e2bcd8739ae039)._showNotification(this.#notificationOnWalletChangeTitle, this.#notificationOnWalletChangeBody, this.#notificationOnWalletChangeButtonLabel, this.#notificationOnWalletChangeButtonAction);
                    this.#notificationOnWalletChange = false;
                }
            // Optionally: Pass the data to a callback or handle it further
            // onUpdate({ wallet: walletData, logs });
            } else console.log("Document does not exist!");
        });
        // Store the new unsubscribe function
        this._currentUnsubscribe = unsubscribe;
    }
    // Start get sumary functions
    async _getArrayLength(path, arrayField) {
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, path);
        const docSnapshot = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
        if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            const array = data[arrayField];
            if (Array.isArray(array)) {
                console.log(`Length of the array '${arrayField}':`, array.length);
                return array.length;
            } else {
                console.log(`'${arrayField}' is not an array.`);
                return 0;
            }
        } else {
            console.log("Document does not exist.");
            return 0;
        }
    }
    async _getDocumentCountInColection(path) {
        const segments = path.split("/");
        let collectionRef;
        if (segments.length % 2 === 0) {
            // Path points to a sub-collection under a specific document
            const parentDoc = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, segments.slice(0, -1).join("/"));
            collectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)(parentDoc, segments.at(-1));
        } else // Path is a direct collection
        collectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, path);
        const snapshot = await (0, $70fd6868680e912c$export$b1de1b12889d0afb)(collectionRef);
        console.log("Number of documents:", snapshot.data().count);
        return snapshot.data().count; // Return the count for further use
    }
    // End get sumary functions
    // Start record stats
    async _writeStats(activity, id) {
        try {
            const serverTimestampValue = (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)();
            // Add a temporary document to fetch the server timestamp
            const tempRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "temp"), {
                temp: true,
                timestamp: serverTimestampValue
            });
            const tempDoc = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(tempRef);
            const serverTimestampData = tempDoc.data().timestamp;
            // Delete the temporary document
            await (0, $70fd6868680e912c$export$a4f20481fae8f78b)(tempRef);
            // Format date into Year and Month
            const date = serverTimestampData.toDate();
            const year = date.getFullYear().toString();
            const month = date.toLocaleString("default", {
                month: "long"
            });
            // Firestore path based on your nested structure
            const recordsCollectionPath = `stats/${activity}/years/${year}/months/${month}/records`;
            // Add a new activity document with an auto-generated ID under the "records" collection
            await (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, recordsCollectionPath), {
                recordActivityId: id,
                timeStored: serverTimestampData
            });
            console.log(`Activity "${activity}" with ID "${id}" successfully recorded in nested structure.`);
        } catch (error) {
            console.error("Error writing activity:", error);
        }
    }
    _addStatsToBatch(batch, activity, id) {
        const serverTimestampValue = (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)();
        // Format date into Year and Month
        const date = new Date();
        const year = date.getFullYear().toString();
        const month = date.toLocaleString("default", {
            month: "long"
        });
        // Firestore path based on your nested structure
        const recordsCollectionPath = `stats/${activity}/years/${year}/months/${month}/records`;
        // Create a new document reference with an auto-generated ID under the "records" collection
        const statsDocRef = (0, $70fd6868680e912c$export$2a111da947c407d2)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, recordsCollectionPath));
        // Add the stats write operation to the batch
        batch.set(statsDocRef, {
            recordActivityId: id,
            timeStored: serverTimestampValue
        });
        console.log(`Stats for activity "${activity}" with ID "${id}" added to the batch.`);
    }
    async _getMonthlyRecords(path) {
        try {
            // Reference the "records" collection based on the provided path
            const recordsRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, path);
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)((0, $70fd6868680e912c$export$2fa187e846a241c4)(recordsRef, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("timeStored", "desc")));
            // Extract and organize the records
            const records = [];
            querySnapshot.forEach((doc)=>{
                records.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            console.log("Monthly records retrieved:", records);
            return records;
        } catch (error) {
            console.error("Error retrieving monthly records:", error);
            return [];
        }
    }
    // End record stats
    async _getRecentListingsWithFilter(lastVisibleDoc = null, limitNumber = null, path, filterField = null, filterValue = null, sellerprofile = false) {
        // Determine if the path is a direct collection or a sub-collection
        let collectionRef;
        const segments = path.split("/");
        if (segments.length % 2 === 1) // Path points to a direct collection
        collectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, path);
        else {
            // Path points to a sub-collection under a specific document
            const parentDocPath = segments.slice(0, -1).join("/");
            const subCollectionName = segments.at(-1);
            collectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)((0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, parentDocPath), subCollectionName);
        }
        // Start building the query
        let queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)(collectionRef, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"));
        // If filterField and filterValue are provided, add a 'where' clause to filter
        if (filterField && filterValue && !sellerprofile) queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)(collectionRef, (0, $70fd6868680e912c$export$9c59b80dda569a6e)(filterField, "==", filterValue), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"));
        if (filterField && filterValue && sellerprofile) queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)(collectionRef, (0, $70fd6868680e912c$export$9c59b80dda569a6e)(filterField, "==", filterValue), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"));
        // Apply limit only if `limitNumber` is provided
        if (limitNumber) queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)(queryObj, (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(limitNumber)); // Add the limit
        // If paginating, start after the last document from the previous batch
        if (lastVisibleDoc) queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)(queryObj, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
        // Fetch query results
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(queryObj);
        let docsToReturn = [];
        querySnapshot.forEach((doc)=>{
            docsToReturn.push({
                id: doc.id,
                ...doc.data()
            });
        });
        // Get the last document for pagination (for the next batch)
        const newLastVisibleDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;
        return {
            listings: docsToReturn,
            lastVisibleDoc: newLastVisibleDoc
        };
    }
    // // Haversine distance
    // getDistanceKm = (lat1, lng1, lat2, lng2) => {
    //   const R = 6371;
    //   const dLat = (lat2 - lat1) * Math.PI / 180;
    //   const dLng = (lng2 - lng1) * Math.PI / 180;
    //   const a =
    //     Math.sin(dLat / 2) ** 2 +
    //     Math.cos(lat1 * Math.PI / 180) *
    //     Math.cos(lat2 * Math.PI / 180) *
    //     Math.sin(dLng / 2) ** 2;
    //   return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    // }
    // // radius → geohash precision
    // getPrecision = (radiusKm) => {
    //   if (radiusKm <= 10) return 6;
    //   if (radiusKm <= 50) return 5;
    //   if (radiusKm <= 200) return 4;
    //   return 3;
    // }
    // async _getListingsNearby({
    //   lat,
    //   lng,
    //   radiusKm,
    //   lastVisible = null,
    //   pageSize = 20
    // }) {
    //   const db = getFirestore();
    //   const precision = this.getPrecision(radiusKm);
    //   const centerHash = ngeohash.encode(lat, lng, precision);
    //   const neighbors = ngeohash.neighbors(centerHash);
    //   const prefixes = [centerHash, ...neighbors];
    //   let allResults = [];
    //   for (const prefix of prefixes) {
    //     let q = query(
    //       collectionGroup(db, "listings"),
    //       where("status", "==", "active"),
    //       where("filterGeoHash", ">=", prefix),
    //       where("filterGeoHash", "<=", prefix + "\uf8ff"),
    //       orderBy("filterGeoHash"),
    //       limit(100) // batch per prefix
    //     );
    //     if (lastVisible) {
    //       q = query(q, startAfter(lastVisible));
    //     }
    //     const snap = await getDocs(q);
    //     snap.forEach(doc => {
    //       const data = doc.data();
    //       if (!data.filterLat || !data.filterLng) return;
    //       const distance = this.getDistanceKm(
    //         lat,
    //         lng,
    //         data.filterLat,
    //         data.filterLng
    //       );
    //       if (distance <= radiusKm) {
    //         allResults.push({
    //           id: doc.id,
    //           ...data,
    //           distance,
    //           _doc: doc
    //         });
    //       }
    //     });
    //   }
    //   // 🔥 Remove duplicates (important!)
    //   const uniqueMap = new Map();
    //   allResults.forEach(item => {
    //     uniqueMap.set(item.id, item);
    //   });
    //   let results = Array.from(uniqueMap.values());
    //   // 🔥 Sort by distance
    //   results.sort((a, b) => a.distance - b.distance);
    //   // 🔥 Pagination
    //   const paginated = results.slice(0, pageSize);
    //   const newLastVisible =
    //     paginated.length > 0
    //       ? paginated[paginated.length - 1]._doc
    //       : null;
    //   return {
    //     listings: paginated,
    //     lastVisible: newLastVisible
    //   };
    // }
    // async _getListingsNearby({
    //   lat,
    //   lng,
    //   radiusKm,
    //   lastVisibleMap = {}, // 👈 per-bound pagination
    //   pageSize = 20
    // }) {
    //   const db = getFirestore();
    //   const center = [lat, lng];
    //   const radiusInM = radiusKm * 1000;
    //   // 🔥 get ALL bounds needed to cover the circle
    //   const bounds = geohashQueryBounds(center, radiusInM);
    //   let allResults = [];
    //   const queries = bounds.map(async (b, i) => {
    //     let q = query(
    //       collectionGroup(db, "listings"),
    //       where("status", "==", "active"),
    //       orderBy("filterGeoHash"),
    //       startAt(b[0]),
    //       endAt(b[1]),
    //       limit(100)
    //     );
    //     // 👇 pagination per bound
    //     if (lastVisibleMap[i]) {
    //       q = query(q, startAfter(lastVisibleMap[i]));
    //     }
    //     const snap = await getDocs(q);
    //     return {
    //       docs: snap.docs,
    //       index: i
    //     };
    //   });
    //   const snapshots = await Promise.all(queries);
    //   let newLastVisibleMap = {};
    //   snapshots.forEach(({ docs, index }) => {
    //     if (docs.length > 0) {
    //       newLastVisibleMap[index] = docs[docs.length - 1];
    //     }
    //     docs.forEach(doc => {
    //       const data = doc.data();
    //       // if (!data.filterLat || !data.filterLng) return;
    //       if (
    //         typeof data.filterLat !== "number" ||
    //         typeof data.filterLng !== "number"
    //       ) return;
    //       // const distance = distanceBetween(
    //       //   [lat, lng],
    //       //   [data.filterLat, data.filterLng]
    //       // ) * 6371; // convert to km
    //       const distance = distanceBetween(
    //         [lat, lng],
    //         [data.filterLat, data.filterLng]
    //       );
    //       if (distance <= radiusKm) {
    //         allResults.push({
    //           id: doc.id,
    //           ...data,
    //           distance,
    //           _doc: doc
    //         });
    //       }
    //     });
    //   });
    //   // 🔥 remove duplicates
    //   const uniqueMap = new Map();
    //   allResults.forEach(item => {
    //     uniqueMap.set(item.id, item);
    //   });
    //   let results = Array.from(uniqueMap.values());
    //   // 🔥 sort by closest
    //   results.sort((a, b) => a.distance - b.distance);
    //   // 🔥 paginate final results
    //   const paginated = results.slice(0, pageSize);
    //   return {
    //     isAllListingsLoaded,
    //     listings: paginated,
    //     lastVisibleMap: newLastVisibleMap
    //   };
    // }
    async _getListingsNearby({ lat: lat, lng: lng, radiusKm: radiusKm, lastVisibleMap: lastVisibleMap = {}, pageSize: pageSize = 20 }) {
        const db = (0, $70fd6868680e912c$export$f06a05d14c3a6678)();
        const center = [
            lat,
            lng
        ];
        const radiusInM = radiusKm * 1000;
        // 🔥 get ALL bounds needed to cover the circle
        const bounds = (0, $2f75560c51037fec$exports.geohashQueryBounds)(center, radiusInM);
        let allResults = [];
        const queries = bounds.map(async (b, i)=>{
            let q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$473d82a73f88c107)(db, "listings"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("filterGeoHash"), (0, $70fd6868680e912c$export$859941c5fc8eba6b)(b[0]), (0, $70fd6868680e912c$export$28ec54a8428bdb3f)(b[1]), // limit(2)
            (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(100) // also line 989
            );
            // 👇 pagination per bound
            if (lastVisibleMap?.[i]) q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(q, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleMap[i]));
            const snap = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            return {
                docs: snap.docs,
                index: i
            };
        });
        const snapshots = await Promise.all(queries);
        let newLastVisibleMap = {};
        let isAllListingsLoaded = true; // 👈 assume true
        snapshots.forEach(({ docs: docs, index: index })=>{
            // 👇 if any query hits the limit, more data might exist
            // if (docs.length === 2) {
            //   isAllListingsLoaded = false;
            // }
            if (docs.length === 100) isAllListingsLoaded = false;
            if (docs.length > 0) newLastVisibleMap[index] = docs[docs.length - 1];
            docs.forEach((doc)=>{
                const data = doc.data();
                if (typeof data.filterLat !== "number" || typeof data.filterLng !== "number") return;
                const distance = (0, $2f75560c51037fec$exports.distanceBetween)([
                    lat,
                    lng
                ], [
                    data.filterLat,
                    data.filterLng
                ]);
                if (distance <= radiusKm) allResults.push({
                    id: doc.id,
                    ...data,
                    distance: distance,
                    _doc: doc
                });
            });
        });
        // 🔥 remove duplicates
        const uniqueMap = new Map();
        allResults.forEach((item)=>{
            uniqueMap.set(item.id, item);
        });
        let results = Array.from(uniqueMap.values());
        // 🔥 sort by closest
        results.sort((a, b)=>a.distance - b.distance);
        // 🔥 paginate final results
        const paginated = results.slice(0, pageSize);
        return {
            listings: paginated,
            lastVisibleMap: newLastVisibleMap,
            isAllListingsLoaded: isAllListingsLoaded
        };
    }
    async _getMostRecentListingsWithOutFilterGlobal(lastVisibleDoc = null, limitNumber = 10 // 📌 Default limit (fetch 10 listings)
    ) {
        const db = (0, $70fd6868680e912c$export$f06a05d14c3a6678)();
        // 🔥 Base query: Get all 'listings' subcollections across Firestore
        let queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$473d82a73f88c107)(db, "listings"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(limitNumber) // ⏳ Limit to `limitNumber` results
        );
        // 🔥 If paginating, start after the last document from the previous batch
        if (lastVisibleDoc) queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)(queryObj, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
        // 🚀 Fetch query results
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(queryObj);
        // 📝 Extract listings
        let listings = [];
        querySnapshot.forEach((doc)=>{
            listings.push({
                id: doc.id,
                ...doc.data()
            });
        // console.log('Listing path:', doc.ref.path);
        // console.log('path:', doc.ref.path);
        // console.log('data:', doc.data());
        });
        // 🔚 Get the last document for pagination
        const newLastVisibleDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;
        return {
            listings: listings,
            lastVisibleDoc: newLastVisibleDoc
        };
    }
    async _getMostRelevantListingsWithFilter(lastVisibleDoc = null, limitNumber = 10, filterField = null, filterValue = null) {
        const db = (0, $70fd6868680e912c$export$f06a05d14c3a6678)();
        // 🔥 Base query: Get all 'listings' subcollections across Firestore
        let queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$473d82a73f88c107)(db, "listings"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("score", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(limitNumber) // ⏳ Limit to `limitNumber` results
        );
        // ✅ Apply additional filter if provided
        if (filterField && filterValue) queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$473d82a73f88c107)(db, "listings"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)(filterField, "==", filterValue), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("score", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(limitNumber));
        // 🔥 If paginating, start after the last document from the previous batch
        if (lastVisibleDoc) queryObj = (0, $70fd6868680e912c$export$2fa187e846a241c4)(queryObj, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
        // 🚀 Fetch query results
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(queryObj);
        // 📝 Extract listings
        let listings = [];
        querySnapshot.forEach((doc)=>{
            listings.push({
                id: doc.id,
                ...doc.data()
            });
        });
        // 🔚 Get the last document for pagination
        const newLastVisibleDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : null;
        return {
            listings: listings,
            lastVisibleDoc: newLastVisibleDoc
        };
    }
    async _getAllDocumentsFromPath(path) {
        try {
            const collectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, path); // Reference to the collection
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(collectionRef); // Get all documents in the collection
            if (!querySnapshot.empty) {
                const documents = querySnapshot.docs.map((doc)=>({
                        id: doc.id,
                        ...doc.data()
                    }));
                console.log("Documents data:", documents);
                return documents; // Return the list of documents
            } else {
                console.log("No documents found in the collection.");
                return [];
            }
        } catch (error) {
            console.error("Error getting documents:", error);
            return [];
        }
    }
    async _getTips(category) {
        const validCategories = [
            "catGeneral",
            "catSellerOnly",
            "catBusiness",
            "catAccountOnly"
        ];
        if (!validCategories.includes(category)) {
            console.error("Invalid category:", category);
            return [];
        }
        try {
            const tipsRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "mercado_mai_tips/videos/tips");
            // Sort all tips by the selected category's numeric value, highest first
            const tipsQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(tipsRef, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)(category, "asc"));
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(tipsQuery);
            return querySnapshot.docs.map((doc)=>({
                    id: doc.id,
                    ...doc.data()
                }));
        } catch (error) {
            console.error("Error getting tips:", error);
            return [];
        }
    }
    async _getAllAffiliatedItemsPaginated(path, pageSize = 10, lastDoc = null) {
        try {
            const baseRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, path);
            let q;
            if (lastDoc) q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(baseRef, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("createdAt", "desc"), (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastDoc), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
            else q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(baseRef, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("createdAt", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
            const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            if (snapshot.empty) return {
                items: [],
                lastDoc: null
            };
            const items = snapshot.docs.map((doc)=>({
                    id: doc.id,
                    ...doc.data()
                }));
            const newLastDoc = snapshot.docs[snapshot.docs.length - 1];
            return {
                items: items,
                lastDoc: newLastDoc
            };
        } catch (error) {
            console.error("Error fetching affiliated items:", error);
            return {
                items: [],
                lastDoc: null
            };
        }
    }
    async _getAllDocsFromPathByMostRecent(collectionPath, listings, onlyNum = null) {
        if (!$27ce1bd96c2798d8$var$db) throw new Error("Firestore is not initialized. Please call _initFirebase first.");
        const constraints = [];
        if (listings) {
            constraints.push((0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"));
            constraints.push((0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"));
        } else constraints.push((0, $70fd6868680e912c$export$f18af21d6f4dafd8)("lastSeenAt", "desc"));
        // 🔢 Optional limit
        if (typeof onlyNum === "number" && onlyNum > 0) constraints.push((0, $70fd6868680e912c$export$ee37e834aaad6f7e)(onlyNum));
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, collectionPath), ...constraints);
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (querySnapshot.empty) {
            console.log("No logs found.");
            return [];
        }
        return querySnapshot.docs.map((doc)=>({
                id: doc.id,
                ...doc.data()
            }));
    }
    async _loadComments(collectionPath) {
        if (!$27ce1bd96c2798d8$var$db) throw new Error("Firestore is not initialized. Please call _initFirebase first.");
        const constraints = [];
        constraints.push((0, $70fd6868680e912c$export$f18af21d6f4dafd8)("createdAt", "desc"));
        // // 🔢 Optional limit
        // if (typeof onlyNum === "number" && onlyNum > 0) {
        //   constraints.push(limit(onlyNum));
        // }
        const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, collectionPath), ...constraints);
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
        if (querySnapshot.empty) {
            console.log("No logs found.");
            return [];
        }
        return querySnapshot.docs.map((doc)=>({
                id: doc.id,
                ...doc.data()
            }));
    }
    async _getMachineData(path) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, path); // Reference to the document at the specified path
            const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef); // Get the document snapshot
            if (docSnap.exists()) {
                console.log("Document data:", docSnap.data()); // The data of the document
                return docSnap.data(); // Return the data if it exists
            } else {
                console.log("No such document!"); // If the document doesn't exist
                return null;
            }
        } catch (error) {
            console.error("Error getting document:", error);
            return null; // Return null in case of error
        }
    }
    async _getAnyDocById(path) {
        console.warn(path);
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, path); // Reference to the document at the specified path
            const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef); // Get the document snapshot
            if (docSnap.exists()) return docSnap.data(); // Return the data if it exists
            else {
                console.log("No such document!"); // If the document doesn't exist
                return null;
            }
        } catch (error) {
            console.error("Error getting document:", error);
            return null; // Return null in case of error
        }
    }
    async _uploadMachineData(machineData) {
        try {
            const machineCollectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "machines"); // Reference to the "machines" collection
            // Iterate through each machine type (tractor, combineHarvester, etc.)
            for (const [machineType, manufacturers] of Object.entries(machineData)){
                const machineDocRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(machineCollectionRef, machineType); // Create a document for each machine type
                // Set the data for the machine type document
                await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(machineDocRef, {
                    manufacturers: manufacturers
                });
                console.log(`Machine data for ${machineType} uploaded successfully`);
            }
        } catch (error) {
            console.error("Error uploading machine data: ", error);
        }
    }
    async _createUserAccountDocument(data) {
        const batch = (0, $70fd6868680e912c$export$44cd1c9d57edd9b1)($27ce1bd96c2798d8$var$db); // Create a batch instance
        try {
            // Collection reference for the accounts
            const accountsCollection = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "accounts");
            // Generate a new document reference with an auto-generated ID
            const accountDocRef = (0, $70fd6868680e912c$export$2a111da947c407d2)(accountsCollection);
            const userId = accountDocRef.id;
            console.log(userId);
            // Prepare the account document data
            const accountData = {
                userId: userId,
                email: data.email,
                userName: data.userName,
                password: data.password,
                termsAccepted: data.termsAccepted,
                likes: [],
                pastSaves: [],
                activeSaves: [],
                createdAt: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)(),
                updatedAt: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)()
            };
            // Add the account document to the batch
            batch.set(accountDocRef, accountData);
            // Add stats to the batch
            this._addStatsToBatch(batch, "accountsCreated", userId);
            // Commit the batch
            await batch.commit();
            // Return success data
            return {
                success: true,
                userId: userId
            };
        } catch (error) {
            console.error("Error creating user account document:", error);
            throw new Error("Failed to create user account document");
        }
    }
    async _updateExistingBusinessDocument(data, imgBack, imgProfile, accountId, businessId) {
        try {
            let tokens = [];
            const generatedTokesForName = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(data.name, $27ce1bd96c2798d8$var$omittedWordsInTokens);
            const generatedTokesForDescription = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(data.shortDescription, $27ce1bd96c2798d8$var$omittedWordsInTokens);
            generatedTokesForName.forEach((token)=>{
                tokens.push(token);
            });
            generatedTokesForDescription.forEach((token)=>{
                tokens.push(token);
            });
            // Create a batch instance
            const batch = (0, $70fd6868680e912c$export$44cd1c9d57edd9b1)($27ce1bd96c2798d8$var$db);
            // Reference to the existing business document
            const businessDocRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, `businesses/${businessId}`);
            // Prepare the updated business data
            const updatedBusinessData = {
                name: data.name,
                shortDescription: data.shortDescription,
                backgroundImg: imgBack,
                profileImg: imgProfile,
                about: data.about,
                listingsApear: data.listingsApear,
                place: data.place,
                contacts: data.contacts,
                lists: data.lists,
                colors: data.colors,
                businessTokens: tokens,
                status: "active",
                updatedAt: (0, $70fd6868680e912c$export$3ff8e7e00c3264b7)()
            };
            // Set the updates in the batch
            batch.update(businessDocRef, updatedBusinessData);
            // Commit the batch
            await batch.commit();
            // Return success response
            return {
                success: true,
                businessId: businessId
            };
        } catch (error) {
            console.error("Error updating business document:", error);
            throw new Error("Failed to update the business document");
        }
    }
    async _getAccountDataById(accountId) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, "accounts", accountId); // Reference to the document
            const docSnapshot = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef); // Fetch the document
            if (docSnapshot.exists()) return docSnapshot.data(); // Return the document data if it exists
            else {
                console.log("No such document!");
                return null;
            }
        } catch (error) {
            console.error("Error getting document:", error);
            throw new Error("Failed to fetch account data");
        }
    }
    // async _getBusinessById2(businessId) {
    //   try {
    //     const docRef = doc(db, "businesses", businessId); // Reference to the document
    //     const docSnapshot = await getDoc(docRef); // Fetch the document
    //     if (docSnapshot.exists()) {
    //       return docSnapshot.data(); // Return the document data if it exists
    //     } else {
    //       console.log("No such document!");
    //       return null;
    //     }
    //   } catch (error) {
    //     console.error("Error getting document:", error);
    //     throw new Error("Failed to fetch account data");
    //   }
    // }
    async _getBusinessById(businessId) {
        try {
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, "businesses", businessId); // Reference to the document
            const docSnapshot = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef); // Fetch the document
            if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                console.log(data);
                if (data.status === "active") return data; // Return the document data if the status is "active"
                else {
                    console.log("Document exists but is not active");
                    return data;
                }
            } else {
                console.log("No such document!");
                return null;
            }
        } catch (error) {
            console.error("Error getting document:", error);
            throw new Error("Failed to fetch account data");
        }
    }
    async _getAccountDataByEmail(email) {
        try {
            const accountsRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "accounts");
            const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(accountsRef, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("email", "==", email)); // Query for email match
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            if (!querySnapshot.empty) {
                // If there are matching documents, return the first one
                const accountData = querySnapshot.docs[0].data();
                return accountData;
            } else {
                console.log("No account found with the provided email.");
                return null;
            }
        } catch (error) {
            console.error("Error getting account by email:", error);
            throw new Error("Failed to fetch account data by email");
        }
    }
    async _subscriptionHandle() {
        const url = "https://createsubscription-vu7zimlfzq-uc.a.run.app";
        const subscriptionData = {
            accountId: "HwoQpx8HJjrQM1iV3wfN",
            numberOfListingsIncluded: 30,
            amount: 200,
            time: 30
        };
        console.log("Sending subscription data:", subscriptionData);
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(subscriptionData)
            });
            const result = await response.json();
            if (response.ok && result.status === "success") {
                console.log("Subscription created successfully.");
                return {
                    success: true
                };
            } else {
                console.error("Failed to create subscription:", result.error);
                return {
                    success: false,
                    error: result.error || "Unknown error"
                };
            }
        } catch (error) {
            console.error("Error creating subscription:", error);
            return {
                success: false,
                error: error.message
            };
        }
    }
    async _uploadImagesAndGetReferences(id, progressConId, noChildren = false, adminPath, isFrom = 'listing') {
        console.log('id', id);
        const imagesContainer = document.getElementById(id);
        const progressCon = document.getElementById(progressConId);
        progressCon.style.display = "flex";
        let existingListingImages = [];
        if (isFrom === 'listing') existingListingImages = (0, $4f930c604957bd07$export$2e2bcd8739ae039)._getListingImageArr?.() || [];
        if (isFrom === 'businessBackground') existingListingImages = [
            (0, $81574927169af67f$export$2e2bcd8739ae039)._getImages?.('back')
        ];
        if (isFrom === 'businessProfile') existingListingImages = [
            (0, $81574927169af67f$export$2e2bcd8739ae039)._getImages?.('prof')
        ];
        console.log(existingListingImages);
        function isFirebaseStorageUrl(url) {
            return url.includes("storage.googleapis.com") || url.includes("firebasestorage.googleapis.com");
        }
        // --- Collect image elements ---
        let imageFiles = [];
        if (noChildren) {
            const singleImg = imagesContainer.tagName === "IMG" ? imagesContainer : imagesContainer.querySelector("img");
            console.log('here');
            if (!singleImg || !singleImg.src) return [];
            imageFiles = [
                singleImg
            ];
            console.log('here', imageFiles);
        } else {
            console.log('imagesContainer', imagesContainer);
            imageFiles = Array.from(imagesContainer.querySelectorAll("img"));
        }
        if (imageFiles.length === 0) return [];
        console.log('here');
        let uploadedImages = [];
        const con = document.getElementById(`SearchStartUpComponentAllCon`);
        console.log(con);
        if (con) con.remove();
        // --- Progress UI ---
        progressCon.innerHTML = `
  <div style="width:100%;background:rgba(0,0,0,0.1);border-radius:6px;height:8px;overflow:hidden;margin-top:10px;">
    <div id="progressBarFill" style="width:0%;height:100%;background:linear-gradient(90deg,#4ade80,#16a34a);transition:width 0.3s ease;"></div>
  </div>
  <div id="progressText" style="text-align:center;font-size:13px;color:#555;margin-top:6px;font-family:system-ui,sans-serif;">Preparando...</div>
  `;
        const progressBarFill = progressCon.querySelector("#progressBarFill");
        const progressText = progressCon.querySelector("#progressText");
        // --- Convert src → File ---
        async function srcToFile(src, filename = "image.jpg") {
            if (src.startsWith("data:image")) {
                const arr = src.split(",");
                const mimeMatch = arr[0].match(/:(.*?)(;|,)/);
                const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";
                const bstr = atob(arr[1]);
                const u8arr = new Uint8Array(bstr.length);
                for(let i = 0; i < bstr.length; i++)u8arr[i] = bstr.charCodeAt(i);
                return new File([
                    u8arr
                ], filename, {
                    type: mime
                });
            } else {
                const res = await fetch(src);
                const blob = await res.blob();
                return new File([
                    blob
                ], filename, {
                    type: blob.type || "image/jpeg"
                });
            }
        }
        // --- Resize + convert to AVIF ---
        function resizeAndConvertToAvif(file, maxWidth = 1200) {
            return new Promise((resolve, reject)=>{
                const img = new Image();
                const reader = new FileReader();
                reader.onload = (e)=>img.src = e.target.result;
                reader.onerror = ()=>reject(new Error("Failed to read file."));
                reader.readAsDataURL(file);
                img.onload = ()=>{
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    let width = img.width;
                    let height = img.height;
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);
                    canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error("AVIF conversion failed")), "image/avif", 0.7);
                };
                img.onerror = ()=>reject(new Error("Image load failed"));
            });
        }
        try {
            // const totalImages = imageFiles.length;
            // Only images that will actually be processed
            const imagesToProcess = imageFiles.filter((img)=>{
                const src = img.src;
                if (!src) return false;
                const shouldUpload = img.classList.contains("uploadSpecific");
                const isFirebase = isFirebaseStorageUrl(src);
                return shouldUpload || isFirebase;
            });
            const totalImages = imagesToProcess.length;
            console.log(imagesToProcess);
            console.log(`Total images to process: ${totalImages}`);
            for(let i = 0; i < totalImages; i++){
                const imgElement = imagesToProcess[i];
                const src = imgElement.src;
                if (!src) continue;
                const shouldUpload = imgElement.classList.contains("uploadSpecific");
                // --- Handle existing Firebase images BEFORE fetch ---
                if (isFirebaseStorageUrl(src)) {
                    const existingObj = existingListingImages.find((img)=>img.res_original === src);
                    console.log(existingObj);
                    if (isFrom === 'businessBackground') uploadedImages = existingListingImages;
                    else if (isFrom === 'businessProfile') uploadedImages = existingListingImages;
                    else uploadedImages.push(existingObj || {
                        res_original: src
                    });
                    console.info(`Using existing Firebase image (${i + 1}/${totalImages})`);
                    continue;
                }
                // --- Skip images not marked for upload ---
                if (!shouldUpload) {
                    console.info(`Skipping non-upload image (${i + 1}/${totalImages})`);
                    continue;
                }
                // --- Upload new image ---
                const imageFile = await srcToFile(src, `image_${i}.jpg`);
                const resizedImage = await resizeAndConvertToAvif(imageFile, 1200);
                const fileId = `${(0, $3fa3ae484854b431$export$2e2bcd8739ae039)()}.avif`;
                const storageRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)($27ce1bd96c2798d8$var$storage, `${adminPath}/${fileId}`);
                const uploadTask = (0, $df9a6d7fd06616c9$export$3895d39eb7ac9b25)(storageRef, resizedImage);
                const uploadedUrl = await new Promise((resolve, reject)=>{
                    uploadTask.on("state_changed", (snapshot)=>{
                        const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                        const overall = (i + progress / 100) / totalImages * 100;
                        if (progressBarFill) progressBarFill.style.width = `${overall.toFixed(1)}%`;
                        if (progressText) progressText.textContent = `Cargando imagen ${i + 1}/${totalImages} \u{2014} ${overall.toFixed(0)}%`;
                    }, reject, async ()=>{
                        const downloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(uploadTask.snapshot.ref);
                        resolve(downloadURL);
                    });
                });
                uploadedImages.push({
                    res_original: uploadedUrl
                });
            }
            if (progressText) progressText.textContent = "Im\xe1genes cargadas con \xe9xito!";
            if (progressBarFill) progressBarFill.style.background = "linear-gradient(90deg,#22c55e,#15803d)";
            return uploadedImages;
        } catch (error) {
            console.error("Error in image upload process:", error);
            if (progressText) progressText.textContent = "Error al cargar im\xe1genes. Intente de nuevo.";
            if (progressBarFill) progressBarFill.style.background = "#dc2626";
            throw new Error("Failed to upload images.");
        } finally{
            progressCon.style.display = "none";
        }
    }
    async _uploadImageById(id) {
        const imgElement = document.getElementById(id);
        if (!imgElement) {
            console.log("Image not found.");
            return null;
        }
        // Convert data URL to File object
        function dataURLtoFile(dataUrl, filename) {
            const arr = dataUrl.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while(n--)u8arr[n] = bstr.charCodeAt(n);
            return new File([
                u8arr
            ], filename, {
                type: mime
            });
        }
        // Resize image to specified dimensions
        function resizeImage(file, maxWidth, maxHeight) {
            return new Promise((resolve, reject)=>{
                const img = new Image();
                const reader = new FileReader();
                reader.onload = (e)=>img.src = e.target.result;
                reader.onerror = ()=>reject(new Error("Failed to read file."));
                reader.readAsDataURL(file);
                img.onload = function() {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    let width = img.width;
                    let height = img.height;
                    if (width > height) {
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);
                    canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error("Failed to resize image.")), "image/jpeg", 0.7);
                };
                img.onerror = ()=>reject(new Error("Failed to load image."));
            });
        }
        try {
            const imageSrc = imgElement.src;
            if (!imageSrc.startsWith("data:")) throw new Error("Only data URL images can be processed.");
            const imageFile = dataURLtoFile(imageSrc, `${id}.jpg`);
            console.log(imageFile);
            const resizedImage = await resizeImage(imageFile, 800, 800);
            console.log(resizedImage);
            // Generate a unique file ID
            const fileId = `${(0, $3fa3ae484854b431$export$2e2bcd8739ae039)()}.jpg`;
            const storageRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)($27ce1bd96c2798d8$var$storage, `images/${fileId}`);
            // Upload the resized image to Firebase
            await (0, $df9a6d7fd06616c9$export$ac40f56b52f99dd1)(storageRef, resizedImage);
            // Get the public URL for the uploaded image
            const downloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(storageRef);
            return downloadURL; // Return the URL of the uploaded image
        } catch (error) {
            console.error("Error in image upload process:", error);
            throw new Error("Failed to upload the image. Please try again.");
        }
    }
    // TODO Should not be uesed any more
    async _getImageUrlNOTINUSE(imgId) {
        const cacheName = "image-cache";
        try {
            if (!imgId || imgId.trim() === "") throw new Error("Image ID is missing or invalid.");
            const imageKey = `images/${imgId}`;
            // Open the cache
            const cache = await caches.open(cacheName);
            // Check if the image is already in the cache
            const cachedResponse = await cache.match(imageKey);
            if (cachedResponse) {
                const blob = await cachedResponse.blob(); // Convert to blob
                const blobUrl = URL.createObjectURL(blob); // Create a Blob URL
                return blobUrl;
            }
            // If the image is not in the cache, download it from Firebase Storage
            const storageRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)($27ce1bd96c2798d8$var$storage, imageKey);
            const imageUrl = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(storageRef);
            // Fetch the image as a blob
            const fetchResponse = await fetch(imageUrl);
            if (!fetchResponse.ok) throw new Error("Failed to fetch the image from URL");
            // Cache the fetched image
            await cache.put(imageKey, fetchResponse.clone());
            // Return the fetched image URL
            const blob = await fetchResponse.blob();
            const blobUrl = URL.createObjectURL(blob);
            return blobUrl;
        } catch (error) {
            console.error(`Failed to load image with ID '${imgId}':`, error);
            throw new Error("Failed to retrieve image URL.");
        }
    }
    async _addDocumentToSubcollection(path, subcollectionName, docObject) {
        try {
            const parentDocRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, path); // Reference to the parent document
            const subcollectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)(parentDocRef, subcollectionName); // Subcollection reference
            const newDocRef = await (0, $70fd6868680e912c$export$a13890143fb1c2dd)(subcollectionRef, docObject);
            console.log(`Document added with ID: ${newDocRef.id}`);
            return newDocRef.id;
        } catch (error) {
            console.error("Error adding document to subcollection:", error);
            throw error;
        }
    }
    async _removeDocumentFromSubcollection(path, subcollectionName, key, value) {
        try {
            const parentDocRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, path); // Reference to the parent document
            const subcollectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)(parentDocRef, subcollectionName); // Subcollection reference
            const q = (0, $70fd6868680e912c$export$2fa187e846a241c4)(subcollectionRef, (0, $70fd6868680e912c$export$9c59b80dda569a6e)(key, "==", value)); // Query to find matching documents
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(q);
            if (querySnapshot.empty) {
                console.log("No matching documents found.");
                return;
            }
            for (const docSnapshot of querySnapshot.docs){
                await (0, $70fd6868680e912c$export$a4f20481fae8f78b)(docSnapshot.ref);
                console.log(`Document with ID ${docSnapshot.id} deleted.`);
            }
        } catch (error) {
            console.error("Error removing document from subcollection:", error);
            throw error;
        }
    }
    async _storeMachineData(machine, brand, model, metadata = {}) {
        try {
            // Add machine to the `machineTypes` collection
            const machineRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, `machineTypes/${machine}`);
            await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(machineRef, {
                name: machine
            }, {
                merge: true
            } // Merge to avoid overwriting existing data
            );
            // Add brand to the `brands` subcollection
            const brandRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, `machineTypes/${machine}/brands/${brand}`);
            await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(brandRef, {
                name: brand
            }, {
                merge: true
            } // Merge to avoid overwriting existing data
            );
            // Add model to the `models` subcollection
            const modelRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, `machineTypes/${machine}/brands/${brand}/models/${model}`);
            await (0, $70fd6868680e912c$export$5ff77ddaff3c9e12)(modelRef, {
                name: model,
                ...metadata
            }, {
                merge: true
            } // Merge to avoid overwriting existing data
            );
            console.log(`Data stored successfully for ${machine} -> ${brand} -> ${model}`);
        } catch (error) {
            console.error("Error storing data:", error);
        }
    }
    async _getMachineData(path) {
        try {
            // Determine if the path points to a collection or document
            const pathParts = path.split("/");
            const isCollection = pathParts.length % 2 !== 0; // Odd-length paths point to collections
            if (isCollection) {
                // Fetch all documents in the collection
                const collectionRef = (0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, path);
                const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(collectionRef);
                const data = querySnapshot.docs.map((doc)=>({
                        id: doc.id,
                        data: doc.data()
                    }));
                // console.log(`Data retrieved for collection '${path}':`, data);
                return data; // Array of documents
            } else {
                // Fetch a single document
                const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, path);
                const docSnap = await (0, $70fd6868680e912c$export$11eb3b5ef9574821)(docRef);
                if (docSnap.exists()) {
                    console.log(`Data retrieved for document '${path}':`, docSnap.data());
                    return docSnap.data(); // Object containing document data
                } else {
                    console.log(`No document found at path '${path}'`);
                    return null; // Return null if the document does not exist
                }
            }
        } catch (error) {
            console.error("Error retrieving data:", error);
            throw error; // Re-throw the error for further handling
        }
    }
    async _searchListings(collectionPath, searchInput, omittedWords = [
        "de",
        "para",
        "el",
        "del",
        "y",
        "en",
        "con"
    ]) {
        // Ensure `db` is properly initialized
        if (!$27ce1bd96c2798d8$var$db) throw new Error("Firestore is not initialized. Please call _initFirebase first.");
        // Tokenize the search input
        const searchTokens = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(searchInput, omittedWords);
        if (searchTokens.length === 0) {
            console.warn("No valid tokens generated from the search input.");
            return [];
        }
        // Query Firestore with 'array-contains-any' for matching tokens
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)((0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, collectionPath), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("listingTokens", "array-contains-any", searchTokens)));
        if (querySnapshot.empty) {
            console.log("No matching listings found.");
            return [];
        }
        // Collect and return matching listings
        const listings = [];
        querySnapshot.forEach((doc)=>{
            listings.push({
                id: doc.id,
                ...doc.data()
            });
        });
        return listings;
    }
    async _searchBusinesses(searchInput, omittedWords = [
        "de",
        "para",
        "el",
        "del",
        "y",
        "en",
        "con"
    ], lastVisibleDoc = null, pageSize = 10) {
        // Ensure `db` is properly initialized
        if (!$27ce1bd96c2798d8$var$db) throw new Error("Firestore is not initialized. Please call _initFirebase first.");
        // Tokenize the search input
        console.log(searchInput);
        let searchTokens = [];
        if (searchInput) searchTokens = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(searchInput, omittedWords);
        // Initialize the query
        let searchQuery;
        if (searchTokens.length === 0) // No search input: return all businesses ordered by priorityLevelPoints (descending) and updatedAt (recent first)
        searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "businesses"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
        else // Search input provided: query by tokens, then order by priority and updatedAt
        searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "businesses"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("businessTokens", "array-contains-any", searchTokens), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
        // Apply pagination if `lastVisibleDoc` is provided
        if (lastVisibleDoc) searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
        // Execute the query
        try {
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(searchQuery);
            if (querySnapshot.empty) {
                console.log("No matching businesses found.");
                return {
                    results: [],
                    lastVisibleDoc: null
                };
            }
            // Collect and return matching businesses
            const businesses = [];
            querySnapshot.forEach((doc)=>{
                businesses.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            // Get the last document for pagination
            const newLastVisibleDoc = querySnapshot.docs[querySnapshot.docs.length - 1] || null;
            return {
                results: businesses,
                lastVisibleDoc: newLastVisibleDoc
            };
        } catch (error) {
            console.error("Error searching businesses by priority:", error);
            throw error;
        }
    }
    async _searchSellerProfiles(searchInput, omittedWords = [
        "de",
        "para",
        "el",
        "del",
        "y",
        "en",
        "con"
    ], lastVisibleDoc = null, pageSize = 10) {
        // Ensure `db` is properly initialized
        if (!$27ce1bd96c2798d8$var$db) throw new Error("Firestore is not initialized. Please call _initFirebase first.");
        // Tokenize the search input
        console.log(searchInput);
        let searchTokens = [];
        if (searchInput) searchTokens = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(searchInput, omittedWords);
        // Initialize the query
        let searchQuery;
        if (searchTokens.length === 0) // No search input: return all businesses ordered by priorityLevelPoints (descending) and updatedAt (recent first)
        searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "accounts"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
        else // Search input provided: query by tokens, then order by priority and updatedAt
        searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "accounts"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("sellerProfileTokens", "array-contains-any", searchTokens), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
        // Apply pagination if `lastVisibleDoc` is provided
        if (lastVisibleDoc) searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
        // Execute the query
        try {
            const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(searchQuery);
            if (querySnapshot.empty) {
                console.log("No matching businesses found.");
                return {
                    results: [],
                    lastVisibleDoc: null
                };
            }
            // Collect and return matching businesses
            const businesses = [];
            querySnapshot.forEach((doc)=>{
                businesses.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            // Get the last document for pagination
            const newLastVisibleDoc = querySnapshot.docs[querySnapshot.docs.length - 1] || null;
            return {
                results: businesses,
                lastVisibleDoc: newLastVisibleDoc
            };
        } catch (error) {
            console.error("Error searching businesses by priority:", error);
            throw error;
        }
    }
    async _searchListingsGlobal(searchInput, omittedWords = [
        "de",
        "para",
        "el",
        "del",
        "y",
        "en",
        "con"
    ], lastVisibleDocument = null, pageSize = 10 // Default to 10 results per page
    ) {
        // Ensure `db` is properly initialized
        if (!$27ce1bd96c2798d8$var$db) throw new Error("Firestore is not initialized. Please call _initFirebase first.");
        // Tokenize the search input
        const searchTokens = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(searchInput, omittedWords);
        if (searchTokens.length === 0) {
            console.warn("No valid tokens generated from the search input.");
            return [];
        }
        // Start the base query for global search across all subcollections
        let queryRef = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$473d82a73f88c107)($27ce1bd96c2798d8$var$db, "listings"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("listingTokens", "array-contains-any", searchTokens), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("score", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize) // Limit to a specific number of results (pagination)
        );
        // If we are on a subsequent page, apply the startAfter condition for pagination
        if (lastVisibleDocument) queryRef = (0, $70fd6868680e912c$export$2fa187e846a241c4)(queryRef, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDocument));
        // Execute the query and get the snapshot
        const querySnapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(queryRef);
        if (querySnapshot.empty) {
            console.log("No matching listings found.");
            return [];
        }
        // Collect the listings
        const listings = [];
        querySnapshot.forEach((doc)=>{
            listings.push({
                id: doc.id,
                ...doc.data()
            });
        });
        // Get the last visible document to use for pagination in the next page
        const lastVisibleDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
        return {
            listings: listings,
            lastVisibleDoc: lastVisibleDoc
        };
    }
    async _globalGetFromMostRecentWithOutPriority(lastVisibleDoc, pageSize = 10) {
        const results = [];
        try {
            // Reference the collection group using the initialized Firestore instance
            let searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$473d82a73f88c107)($27ce1bd96c2798d8$var$db, "listings"));
            searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active") // Filter documents with "listingDiscount"
            );
            // Order by 'priorityLevelPoints' in descending order to get the highest first
            searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"));
            // Apply pagination
            if (lastVisibleDoc) searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
            // Limit the number of results
            searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
            // Execute the query
            const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(searchQuery);
            // Process the results
            snapshot.forEach((doc)=>{
                results.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            // Get the last document for the next page
            const newLastVisibleDoc = snapshot.docs[snapshot.docs.length - 1] || null;
            return {
                results: results,
                lastVisibleDoc: newLastVisibleDoc
            };
        } catch (error) {
            console.error("Error performing global search with pagination:", error);
            throw error;
        }
    }
    async _globalTargetedSearch(lastVisibleDoc, machine, brand, model, discount, pageSize = 10) {
        const results = [];
        try {
            // Reference the collection group using the initialized Firestore instance
            let searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$473d82a73f88c107)($27ce1bd96c2798d8$var$db, "listings"));
            // Dynamically build the query based on the specified parameters
            if (machine && machine !== "todos") searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("listingMachineType", "==", machine));
            if (brand && brand !== "todos") searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("listingBrand", "==", brand));
            if (model && model !== "todos") searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("listingModel", "==", model));
            if (discount) searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("listingDiscount", "==", "onDiscount") // Filter documents with "listingDiscount"
            );
            searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active") // Filter documents with "listingDiscount"
            );
            // Order by 'priorityLevelPoints' in descending order to get the highest first
            searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("score", "desc"));
            // Apply pagination
            if (lastVisibleDoc) searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
            // Limit the number of results
            searchQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(searchQuery, (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize));
            // Execute the query
            const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(searchQuery);
            // Process the results
            snapshot.forEach((doc)=>{
                results.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            // Get the last document for the next page
            const newLastVisibleDoc = snapshot.docs[snapshot.docs.length - 1] || null;
            return {
                results: results,
                lastVisibleDoc: newLastVisibleDoc
            };
        } catch (error) {
            console.error("Error performing global search with pagination:", error);
            throw error;
        }
    }
    async _getBusinessesPaginated(lastVisibleDoc = null, pageSize = 10) {
        const results = [];
        try {
            // Initialize the query to reference the "business" collection
            let businessQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($27ce1bd96c2798d8$var$db, "businesses"), (0, $70fd6868680e912c$export$9c59b80dda569a6e)("status", "==", "active"), (0, $70fd6868680e912c$export$f18af21d6f4dafd8)("updatedAt", "desc"), (0, $70fd6868680e912c$export$ee37e834aaad6f7e)(pageSize) // Limit the number of results
            );
            // Apply pagination if lastVisibleDoc is provided
            if (lastVisibleDoc) businessQuery = (0, $70fd6868680e912c$export$2fa187e846a241c4)(businessQuery, (0, $70fd6868680e912c$export$dd8dee5f7b804673)(lastVisibleDoc));
            // Execute the query
            const snapshot = await (0, $70fd6868680e912c$export$81d3477bd73c86ef)(businessQuery);
            // Process the results
            snapshot.forEach((doc)=>{
                results.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            // Get the last document for the next page
            const newLastVisibleDoc = snapshot.docs[snapshot.docs.length - 1] || null;
            console.log(results);
            return {
                results: results,
                lastVisibleDoc: newLastVisibleDoc
            };
        } catch (error) {
            console.error("Error retrieving paginated businesses:", error);
            throw error;
        }
    }
    // unsubscribe() {}
    // Start Firebase fucntions.
    _liveListenerForAccount(id) {
        // this.unsubscribe;
        if (id) {
            if (this.#liveListenerForAccount) return;
            const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, "accounts", id);
            // Set up a live listener
            this.unsubscribe = (0, $70fd6868680e912c$export$d36370812fb26935)(docRef, (docSnapshot)=>{
                if (docSnapshot.exists()) this.#currentAuthUserData = docSnapshot.data();
                else console.log("No such document!");
            }, (error)=>{
                console.error("Error listening to document changes:", error);
            });
            this.#liveListenerForAccount = true;
        } else // To stop listening if id is not there
        if (this.unsubscribe) {
            console.log("Was killed");
            this.unsubscribe(); // Unsubscribe only if the unsubscribe function exists
            this.#liveListenerForAccount = false;
        }
    }
    _authStateHandlerOnceAndOnChange() {
        (0, $a0779144dbc42ee1$export$4a5767248b18ef41)($27ce1bd96c2798d8$var$auth, (user)=>{
            if (user) {
                console.log('this');
                this._signedInOrOut(true);
                user.devices;
            } else {
                console.log('this');
                // For dev purposes auto login after clearing site data
                // this._signInUser('benklassen19@icloud.com', 'BeOnMercadoMAI2025')
                // this._signInUser('mercadomaionline@gmail.com', 'Be12345')
                this._signedInOrOut();
            }
        });
    }
    _getLatestCurrentUserData(uid) {
        return this.#currentAuthUserData;
    }
    async _signedInOrOut(signedIn = false) {
        try {
            if (!signedIn) {
                if (this.#userDataLiveListenerUnsubscribe) {
                    this.#userDataLiveListenerUnsubscribe();
                    this.#userDataLiveListenerUnsubscribe = null;
                    this.#currentAuthUserData = null;
                    location.reload(true); // force reload from server (some browsers ignore this)
                }
                return;
            }
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._displaySpinner("Cargando tu cuenta");
            await this._getUserDataFromBase();
        } catch (error) {
            console.log(error);
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
            (0, $126d653b8453b922$export$2e2bcd8739ae039)._init();
        } finally{
            (0, $126d653b8453b922$export$2e2bcd8739ae039)._init();
            (0, $f260e10f63c0e00d$export$2e2bcd8739ae039)._initNotificationClickListener();
            (0, $15f2cce3daf449fd$export$2e2bcd8739ae039)._hideSpinner();
        }
    }
    // async _getUserDataFromBase(uid = this.#currentAuthUserData?.userId, timeoutInMs = 20000) {
    //   if (!uid) {
    //     this.#currentAuthUserData = null;
    //     return null;
    //   }
    //   const docRef = doc(db, "accounts", uid);
    //   return new Promise((resolve) => {
    //     let timeoutId;
    //     let resolved = false;
    //     const unsubscribe = onSnapshot(
    //       docRef,
    //       (docSnapshot) => {
    //         if (docSnapshot.exists()) {
    //           clearTimeout(timeoutId);
    //           unsubscribe();
    //           this.#currentAuthUserData = docSnapshot.data();
    //           resolved = true;
    //           resolve(this.#currentAuthUserData);
    //         }
    //       },
    //       (error) => {
    //         console.error("Error listening to user document:", error);
    //         clearTimeout(timeoutId);
    //         unsubscribe();
    //         this.#currentAuthUserData = null;
    //         resolved = true;
    //         resolve(null);
    //       }
    //     );
    //     timeoutId = setTimeout(() => {
    //       if (!resolved) {
    //         unsubscribe();
    //         this.#currentAuthUserData = null;
    //         resolve(null);
    //       }
    //     }, timeoutInMs);
    //   });
    // }
    // async _getUserDataFromBase(
    //   uid = this.#currentAuthUserData?.userId,
    //   timeoutInMs = 20000
    // ) {
    //   if (!uid) {
    //     this.#currentAuthUserData = null;
    //     return null;
    //   }
    //   const docRef = doc(db, "accounts", uid);
    //   // unsubscribe previous live listener if exists
    //   if (this.#userDataLiveListenerUnsubscribe) {
    //     this.#userDataLiveListenerUnsubscribe();
    //     this.#userDataLiveListenerUnsubscribe = null;
    //   }
    //   return new Promise((resolve) => {
    //     let timeoutId;
    //     let resolved = false;
    //     const unsubscribe = onSnapshot(
    //       docRef,
    //       (docSnapshot) => {
    //         if (docSnapshot.exists()) {
    //           // always keep local data updated live
    //           this.#currentAuthUserData =
    //             docSnapshot.data();
    //           // FIRST successful load only
    //           if (!resolved) {
    //             clearTimeout(timeoutId);
    //             resolved = true;
    //             // save persistent listener
    //             this.#userDataLiveListenerUnsubscribe =
    //               unsubscribe;
    //             resolve(this.#currentAuthUserData);
    //           }
    //         }
    //       },
    //       (error) => {
    //         console.error(
    //           "Error listening to user document:",
    //           error
    //         );
    //         clearTimeout(timeoutId);
    //         unsubscribe();
    //         this.#currentAuthUserData = null;
    //         resolved = true;
    //         resolve(null);
    //       }
    //     );
    //     timeoutId = setTimeout(() => {
    //       if (!resolved) {
    //         unsubscribe();
    //         this.#currentAuthUserData = null;
    //         resolve(null);
    //       }
    //     }, timeoutInMs);
    //   });
    // }
    async _getUserDataFromBase(timeoutInMs = 20000) {
        // get uid directly from authenticated user
        const uid = $27ce1bd96c2798d8$var$auth.currentUser?.uid;
        if (!uid) {
            this.#currentAuthUserData = null;
            return null;
        }
        const docRef = (0, $70fd6868680e912c$export$2a111da947c407d2)($27ce1bd96c2798d8$var$db, "accounts", uid);
        // unsubscribe previous live listener if exists
        if (this.#userDataLiveListenerUnsubscribe) {
            this.#userDataLiveListenerUnsubscribe();
            this.#userDataLiveListenerUnsubscribe = null;
        }
        return new Promise((resolve)=>{
            let timeoutId;
            let resolved = false;
            const unsubscribe = (0, $70fd6868680e912c$export$d36370812fb26935)(docRef, (docSnapshot)=>{
                if (docSnapshot.exists()) {
                    // always keep local data updated live
                    this.#currentAuthUserData = docSnapshot.data();
                    // FIRST successful load only
                    if (!resolved) {
                        clearTimeout(timeoutId);
                        resolved = true;
                        // save persistent listener
                        this.#userDataLiveListenerUnsubscribe = unsubscribe;
                        resolve(this.#currentAuthUserData);
                    }
                }
            }, (error)=>{
                console.error("Error listening to user document:", error);
                clearTimeout(timeoutId);
                unsubscribe();
                this.#currentAuthUserData = null;
                resolved = true;
                resolve(null);
            });
            timeoutId = setTimeout(()=>{
                if (!resolved) {
                    unsubscribe();
                    this.#currentAuthUserData = null;
                    resolve(null);
                }
            }, timeoutInMs);
        });
    }
    async _signOutUser() {
        try {
            await (0, $a0779144dbc42ee1$export$e7094788287c5e9b)($27ce1bd96c2798d8$var$auth);
            console.log("User signed out successfully.");
        } catch (error) {
            console.error("Error signing out:", error.message);
        }
    }
    async _signInUser(email, password) {
        try {
            const userCredential = await (0, $a0779144dbc42ee1$export$555508cbc6add439)($27ce1bd96c2798d8$var$auth, email, password);
            const user = userCredential.user;
            console.log("User signed in:", user.uid);
            // location.reload(true); // force reload from server (some browsers ignore this)
            return user.uid;
        } catch (error) {
            throw new Error(error.message);
        }
    }
    // async _authenticateNewUser(email, password) {
    //   try {
    //     const userCredential = await createUserWithEmailAndPassword(
    //       auth,
    //       email,
    //       password
    //     );
    //     const user = userCredential.user;
    //     console.log("User created:", user.uid);
    //     return result
    //     // location.reload(true); // force reload from server (some browsers ignore this)
    //   } catch (error) {
    //     console.error("Error signing up:", error.message);
    //   }
    // }
    async _checkEmailVerificationStatus() {
        try {
            const user = $27ce1bd96c2798d8$var$auth.currentUser;
            if (!user) return {
                success: false,
                verified: false,
                message: "No authenticated user"
            };
            // IMPORTANT:
            // Refresh user data from Firebase
            await user.reload();
            // Get refreshed user
            const refreshedUser = $27ce1bd96c2798d8$var$auth.currentUser;
            const isVerified = refreshedUser.emailVerified;
            console.log("Email verified:", isVerified);
            return {
                success: true,
                verified: isVerified
            };
        } catch (error) {
            console.error("Error checking email verification:", error);
            return {
                success: false,
                verified: false,
                errorCode: error.code,
                message: error.message
            };
        }
    }
    async _sendVerificationEmail() {
        try {
            const user = $27ce1bd96c2798d8$var$auth.currentUser;
            if (!user) return {
                success: false,
                message: "No authenticated user"
            };
            await (0, $a0779144dbc42ee1$export$ee7c8ad385a60b7b)(user, {
                url: "https://mercadomai.com?verified"
            });
            console.log("Verification email sent successfully");
            return {
                success: true
            };
        } catch (error) {
            console.error("Error sending verification email:", error);
            return {
                success: false,
                errorCode: error.code,
                message: error.message
            };
        }
    }
    async _sendPasswordResetEmail(email) {
        try {
            if (!email) return {
                success: false,
                message: "No email provided"
            };
            await (0, $a0779144dbc42ee1$export$a8550f7dbe79f93a)($27ce1bd96c2798d8$var$auth, email, {
                url: "https://mercadomai.com?login"
            });
            console.log("Password reset email sent successfully");
            return {
                success: true
            };
        } catch (error) {
            console.error("Error sending password reset email:", error);
            return {
                success: false,
                errorCode: error.code,
                message: error.message
            };
        }
    }
    async _authenticateNewUser(email, password) {
        try {
            // Create Auth user
            const userCredential = await (0, $a0779144dbc42ee1$export$7910e0436ed8d1de)($27ce1bd96c2798d8$var$auth, email, password);
            const user = userCredential.user;
            console.log("User created:", user.uid);
            // Send verification email
            await (0, $a0779144dbc42ee1$export$ee7c8ad385a60b7b)(user, {
                url: "https://mercadomai.com?verified"
            });
            console.log("Verification email sent");
            // OPTIONAL (recommended)
            // Force verification before app usage
            // await signOut(auth);
            return {
                success: true,
                verificationSent: true
            };
        } catch (error) {
            console.error("Error signing up:", error);
            return {
                success: false,
                errorCode: error.code,
                message: error.message
            };
        }
    }
    async _updateUserTemplate(data) {
        const updateUserDataStructure = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateUserDataStructure");
        const result = await updateUserDataStructure(data);
        return result;
    }
    async _uploadNewListing(dataIn) {
        const data = dataIn.listingData;
        let tokens = [];
        tokens.push(data.listingMachineType);
        data.listingBrand.split("-").forEach((spl)=>{
            tokens.push(spl);
        });
        data.listingModel.split("-").forEach((spl)=>{
            tokens.push(spl);
        });
        tokens.push(data.listingBrand);
        tokens.push(data.listingModel);
        tokens.push(data.listingCondition);
        tokens.push(data.listingYear);
        const generatedTokes = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(data.listingName, $27ce1bd96c2798d8$var$omittedWordsInTokens);
        generatedTokes.forEach((token)=>{
            tokens.push(token);
        });
        const dataToUpload = dataIn;
        console.log(dataToUpload);
        dataToUpload.listingData.listingTokens = tokens;
        console.log(data);
        const createListingFree = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "createListingFree");
        const result = await createListingFree(dataToUpload);
        // const createListing = httpsCallable(functions, "createListing");
        // const result = await createListing(dataToUpload);
        return result;
    }
    async _NvUploadNewListing(dataIn) {
        console.log(dataIn);
        const NVCreateListingFree = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVCreateListingFree");
        const result = await NVCreateListingFree(dataIn);
        return result;
    }
    async _NVEditBusinessCatLists(dataIn) {
        console.log(dataIn);
        const NVEditBusinessCatLists = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVEditBusinessCatLists");
        const result = await NVEditBusinessCatLists(dataIn);
        console.log(result);
        return result;
    }
    async _createUpdateBusiness(data, imgBack, imgProfile, edit) {
        let tokens = [];
        const generatedTokesForName = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(data.name, $27ce1bd96c2798d8$var$omittedWordsInTokens);
        const generatedTokesForDescription = (0, $a082c89adac62edb$export$2e2bcd8739ae039)._createTokens(data.shortDescription, $27ce1bd96c2798d8$var$omittedWordsInTokens);
        generatedTokesForName.forEach((token)=>{
            tokens.push(token);
        });
        generatedTokesForDescription.forEach((token)=>{
            tokens.push(token);
        });
        // Prepare data for the new business document
        const businessData = {
            moreData: {
                edit: edit
            },
            // businessId: businessId,
            name: data.name,
            shortDescription: data.shortDescription,
            backgroundImg: imgBack,
            profileImg: imgProfile,
            about: data.about,
            ratedAt: data.ratedAt,
            numberOfReviews: data.numberOfReviews,
            listingsApear: data.listingsApear,
            place: data.place,
            contacts: data.contacts,
            lists: data.lists,
            colors: data.colors,
            businessTokens: tokens
        };
        const createUpdateBusiness = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "createUpdateBusiness");
        console.log(businessData);
        const result = await createUpdateBusiness(businessData);
        return result;
    }
    async _getOrderDraft(data) {
        try {
            console.log(data);
            const createOrderDraft = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "createOrderDraft");
            const result = await createOrderDraft(data);
            return result;
        } catch (error) {
            return error;
        }
    }
    async _getPaypalOrder() {
        const realdata = {
            draftOrderId: "fvb84ibcn9on439xij4p3",
            useWallet: true
        };
        const data = {
            amount: "211"
        };
        try {
            console.log(data);
            const paymentHandle = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "paymentHandle");
            const result = await paymentHandle(data);
            console.warn(result);
            return result;
        } catch (error) {
            return error;
        }
    }
    async _activateWallet(data) {
        try {
            console.log(data);
            const createWallet = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "createWallet");
            const result = await createWallet(data);
            return result;
        } catch (error) {
            return error;
        }
    }
    async _requestPayPalOrder(data) {
        try {
            console.log(data);
            const createPayPalOrder = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "createPayPalOrder");
            const result = await createPayPalOrder(data);
            console.log(result);
            return result;
        } catch (error) {
            return error;
        }
    }
    async _requestPaymentOrder(data) {
        try {
            console.log(data);
            const createStripePayment = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "createStripePayment");
            const result = await createStripePayment(data);
            console.log(result);
            return result;
        } catch (error) {
            return error;
        }
    }
    async _writeVisitStats(activity, data) {
        console.error("No View recorded. IN DEV MODE");
        var error;
        return;
    }
    async _processPaymentOnOrder(data) {
        try {
            console.log(data);
            const proccesingPaymentOnOrder = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "proccesingPaymentOnOrder");
            const result = await proccesingPaymentOnOrder(data);
            console.log(result);
            return result;
        } catch (error) {
            return error;
        }
    }
    async _updateViewsOnListings(data) {
        console.error("No View recorded. IN DEV MODE");
        var error;
        return;
    }
    async _updateViewsOnBusiness(data) {
        // return;
        try {
            console.log(data);
            const updateViewsOnBusiness = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateViewsOnBusiness");
            const result = await updateViewsOnBusiness(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _updateLikesOnListings(data) {
        try {
            console.log(data);
            const updateLikesOnListings = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateLikesOnListings");
            const result = await updateLikesOnListings(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _updateSavesOnListings(data) {
        try {
            console.log(data);
            const updateSavesOnListings = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateSavesOnListings");
            const result = await updateSavesOnListings(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _updateSharesOnListings(data) {
        try {
            console.log(data);
            const updateSharesOnListings = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateSharesOnListings");
            const result = await updateSharesOnListings(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _updateSavesOnBusiness(data) {
        try {
            console.log(data);
            const updateSavesOnBusiness = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateSavesOnBusiness");
            const result = await updateSavesOnBusiness(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _updateFollowsOnBusiness(data) {
        try {
            console.log(data);
            const updateFollowsOnBusiness = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateFollowsOnBusiness");
            const result = await updateFollowsOnBusiness(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _updateSharesOnBusiness(data) {
        try {
            console.log(data);
            const updateSharesOnBusiness = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateSharesOnBusiness");
            const result = await updateSharesOnBusiness(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _registerPWAInstalls(data) {
        try {
            console.log(data);
            const registerPWAInstalls = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "registerPWAInstalls");
            const result = await registerPWAInstalls(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _syncDataToItems(data) {
        try {
            console.log(data);
            const syncDataToItems = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "syncDataToItems");
            const result = await syncDataToItems(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVDeleteListing(data) {
        console.error(data);
        try {
            console.log(data);
            const NVDeleteListing = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVDeleteListing");
            const result = await NVDeleteListing(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVDeleteBusiness(data) {
        console.error(data);
        try {
            console.log(data);
            const NVDeleteBusiness = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVDeleteBusiness");
            const result = await NVDeleteBusiness(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _deleteAccount(data) {
        console.error(data);
        try {
            console.log(data);
            const deleteAccount = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "deleteAccount");
            const result = await deleteAccount(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _generateImgFromHtmlCss(id) {
        function getHtmlAndCss() {
            const element = document.getElementById(id);
            if (!element) return null;
            // Get HTML content
            const html = element.outerHTML;
            // Get all styles from stylesheets
            let css = "";
            for (let sheet of document.styleSheets)try {
                for (let rule of sheet.cssRules)css += rule.cssText + "\n";
            } catch (err) {
                console.warn("Could not read stylesheet:", sheet.href);
            }
            return {
                html: html,
                css: css
            };
        }
        const htmlCss = getHtmlAndCss();
        try {
            const generateImgFromHtmlCss = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "generateImgFromHtmlCss");
            const result = await generateImgFromHtmlCss(htmlCss);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _uploadImagesByUrls(imageUrls) {
        const uploadedURLs = [];
        // Helper: Convert data URL to File
        function dataURLtoFile(dataUrl, filename) {
            const arr = dataUrl.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while(n--)u8arr[n] = bstr.charCodeAt(n);
            return new File([
                u8arr
            ], filename, {
                type: mime
            });
        }
        // Helper: Resize image
        function resizeImage(file, maxWidth, maxHeight) {
            return new Promise((resolve, reject)=>{
                const img = new Image();
                const reader = new FileReader();
                reader.onload = (e)=>img.src = e.target.result;
                reader.onerror = ()=>reject(new Error("Failed to read file."));
                reader.readAsDataURL(file);
                img.onload = function() {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    let width = img.width;
                    let height = img.height;
                    if (width > height) {
                        if (width > maxWidth) {
                            height *= maxWidth / width;
                            width = maxWidth;
                        }
                    } else if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);
                    canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error("Failed to resize image.")), "image/jpeg", 0.7);
                };
                img.onerror = ()=>reject(new Error("Failed to load image."));
            });
        }
        // Process each image URL
        for (const imageSrc of imageUrls)try {
            // ✅ If already a Firebase URL, skip uploading
            if (imageSrc.includes("firebasestorage.googleapis.com")) {
                uploadedURLs.push(imageSrc);
                continue;
            }
            // ✅ Only process if it’s a data URL
            if (!imageSrc.startsWith("data:")) {
                console.warn("Skipping non-data URL:", imageSrc);
                continue;
            }
            const imageFile = dataURLtoFile(imageSrc, `${(0, $3fa3ae484854b431$export$2e2bcd8739ae039)()}.jpg`);
            const resizedImage = await resizeImage(imageFile, 800, 800);
            // Upload resized image
            const fileId = `${(0, $3fa3ae484854b431$export$2e2bcd8739ae039)()}.jpg`;
            const storageRef = (0, $df9a6d7fd06616c9$export$eff4d24c3ff7876e)($27ce1bd96c2798d8$var$storage, `images/${fileId}`);
            await (0, $df9a6d7fd06616c9$export$ac40f56b52f99dd1)(storageRef, resizedImage);
            const downloadURL = await (0, $df9a6d7fd06616c9$export$c8bf645a0c2a7d9f)(storageRef);
            uploadedURLs.push(downloadURL);
        } catch (error) {
            console.error("Error uploading image:", error);
        }
        return uploadedURLs;
    }
    async _NVCommentOnTips(data) {
        console.log(data);
        try {
            console.log(data);
            const NVCommentOnTips = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVCommentOnTips");
            const result = await NVCommentOnTips(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVDeleteTipComment(data) {
        console.log(data);
        try {
            console.log(data);
            const NVDeleteTipComment = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVDeleteTipComment");
            const result = await NVDeleteTipComment(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVSearchListingsFunction(data) {
        console.log(data);
        try {
            console.log(data);
            const searchListings = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "searchListings");
            const result = await searchListings(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVSearchBusinessesFunction(data) {
        console.log(data);
        try {
            console.log(data);
            const searchBusinesses = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "searchBusinesses");
            const result = await searchBusinesses(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVSearchSellersFunction(data) {
        console.log(data);
        try {
            console.log(data);
            const searchSellers = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "searchSellers");
            const result = await searchSellers(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVcreateUpdateBusiness(data) {
        console.log(data);
        try {
            console.log(data);
            const NVcreateUpdateBusiness = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVcreateUpdateBusiness");
            const result = await NVcreateUpdateBusiness(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _mlItemPreview(data) {
        console.log(data);
        try {
            console.log(data);
            const mlItemPreviewCallable = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "mlItemPreview");
            const result = await mlItemPreviewCallable(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVWUpdateNotiSetBlockedCat(data) {
        console.log(data);
        try {
            console.log(data);
            const NVWUpdateNotiSetBlockedCat = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVWUpdateNotiSetBlockedCat");
            const result = await NVWUpdateNotiSetBlockedCat(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVWUpdateDeleteDevice(data) {
        console.log(data);
        try {
            console.log(data);
            const NVWUpdateDeleteDevice = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVWUpdateDeleteDevice");
            const result = await NVWUpdateDeleteDevice(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _updateUserEmailVerifiedStatus(data) {
        console.log(data);
        try {
            console.log(data);
            const updateUserEmailVerifiedStatus = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "updateUserEmailVerifiedStatus");
            const result = await updateUserEmailVerifiedStatus(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    // START NV Search
    async _NVsearchListings(data) {
        console.log(data);
        try {
            console.log(data);
            const searchListings = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "searchListings");
            const result = await searchListings(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVsearchBusinesses(data) {
        console.log(data);
        try {
            console.log(data);
            const searchBusinesses = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "searchBusinesses");
            const result = await searchBusinesses(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVsearchSellers(data) {
        console.log(data);
        try {
            console.log(data);
            const searchSellers = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "searchSellers");
            const result = await searchSellers(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    async _NVPreviewAffiliatedItem(data) {
        console.log(data);
        try {
            console.log(data);
            const NVPreviewAffiliatedItem = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "NVPreviewAffiliatedItem");
            const result = await NVPreviewAffiliatedItem(data);
            console.log(result);
            return result;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    // END NV Search
    async _reportAProblem(data) {
        const reportAProblem = (0, $03ee16a658161e2a$export$438b58c7f2c6bf5e)($27ce1bd96c2798d8$var$functions, "reportAProblem");
        const result = await reportAProblem(data);
        return result;
    }
}
var $27ce1bd96c2798d8$export$2e2bcd8739ae039 = new $27ce1bd96c2798d8$var$FireBaseHelperOwn();





var $gJCIb = parcelRequire("gJCIb");



console.log('INDEX JS START', performance.now());
// ================================
// 🔔 HANDLE NOTIFICATION OPEN
// ================================
function $8bfe43a2def9b0db$var$handleNotificationOpen(url) {
    console.log("\uD83D\uDD14 Opening notification:", url);
    setTimeout(()=>{
        console.log("\uD83D\uDD14 Notification opened:", url);
        (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
        (0, $44000a6e927f1f0a$export$2e2bcd8739ae039)._changeNav('Notification');
    }, 500);
}
// ================================
// 🚀 BOOT APP
// ================================
// function bootApp() {
//     localStorage.removeItem('openNotification');
//   if (window.__APP_ALREADY_INITIALIZED__) {
//     console.warn("🚫 App already initialized");
//     return;
//   }
//   window.__APP_ALREADY_INITIALIZED__ = true;
//   console.log("🔥 APP INIT");
//   FireBaseHelperOwn._ALLINIT();
// }
// bootApp();
// START Notifications
function $8bfe43a2def9b0db$var$bootApp() {
    // ================================
    // 🧹 Cleanup stale notification flag
    // ================================
    const openNotification = localStorage.getItem('openNotification');
    if (openNotification) {
        const savedTimestamp = Number(openNotification);
        // 20 seconds
        const MAX_AGE = 20000;
        const isExpired = Date.now() - savedTimestamp > MAX_AGE;
        if (isExpired) {
            console.log("\uD83E\uDDF9 Removing stale openNotification");
            localStorage.removeItem('openNotification');
        }
    }
    // 🚫 Prevent double init
    if (window.__APP_ALREADY_INITIALIZED__) {
        console.warn("\uD83D\uDEAB App already initialized");
        return;
    }
    window.__APP_ALREADY_INITIALIZED__ = true;
    console.log("\uD83D\uDD25 APP INIT");
    (0, $27ce1bd96c2798d8$export$2e2bcd8739ae039)._ALLINIT();
}
$8bfe43a2def9b0db$var$bootApp();
// ================================
// 📱 NATIVE ONLY
// ================================
if ((0, $gJCIb.Capacitor).isNativePlatform()) {
    // =========================================
    // 🔗 App opened from deep link / cold start
    // =========================================
    (0, $fc70cc85372c45fc$export$86fbec116b87613f).addListener('appUrlOpen', (event)=>{
        console.log("\uD83D\uDE80 appUrlOpen:", event);
        const url = event.url;
        if (!url) return;
        const parsed = new URL(url);
        const isFromNotification = parsed.searchParams.get("fromNotification") === "true";
        if (isFromNotification) $8bfe43a2def9b0db$var$handleNotificationOpen(url);
    });
    // =========================================
    // 👆 Notification tapped while app alive
    // =========================================
    // PushNotifications.addListener(
    //   'pushNotificationActionPerformed',
    //   (notification) => {
    //     console.log("👆 pushNotificationActionPerformed:", notification);
    //     const data = notification.notification?.data || {};
    //     if (data.url) {
    //       alert("appUrlOpen3: " + data.url);
    //       handleNotificationOpen(data.url);
    //     }
    //   }
    // );
    function openNotificationsPanel() {
        console.log("\uD83D\uDCEC Opening notifications panel");
        // Example
        (0, $c31a2d575b60811d$export$2e2bcd8739ae039)._openNotifications();
        // or
        document.querySelector('.notificationBell')?.click();
    }
    function showNotificationToast(notification) {
        // Remove existing toast
        document.querySelectorAll('.maiNotificationToast').forEach((el)=>el.remove());
        const toast = document.createElement('div');
        toast.className = 'maiNotificationToast';
        toast.innerHTML = `
    <div class="maiNotificationToastTitle">
      ${notification.title || "Nueva notificaci\xf3n"}
    </div>

    <div class="maiNotificationToastBody">
      ${notification.body || ''}
    </div>
  `;
        document.body.appendChild(toast);
        // Animate in
        requestAnimationFrame(()=>{
            toast.classList.add('show');
        });
        // Tap toast
        toast.onclick = ()=>{
            toast.remove();
            openNotificationsPanel();
        };
        // Auto hide
        setTimeout(()=>{
            toast.classList.remove('show');
            setTimeout(()=>{
                toast.remove();
            }, 300);
        }, 5000);
    }
    // =========================================
    // 🔔 Notification received while app open
    // =========================================
    (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener('pushNotificationReceived', (notification)=>{
        console.log("\uD83D\uDD14 Foreground notification:", notification);
        showNotificationToast(notification);
    });
    (0, $73af3aa28454c31d$export$8f83d3f28eb09744).addListener('pushNotificationActionPerformed', (notification)=>{
        console.log("\uD83D\uDC46 pushNotificationActionPerformed:", notification);
        const data = notification.notification?.data || {};
        if (data.url?.includes('fromNotification=true')) {
            // 🧠 Persist notification-open request
            localStorage.setItem('openNotification', Date.now().toString());
            console.log("\uD83D\uDCBE openNotification stored");
        }
        // Optional immediate handling when app already alive
        if (data.url) $8bfe43a2def9b0db$var$handleNotificationOpen(data.url);
    });
}
// END notifications
// START Back Button navigation
let $8bfe43a2def9b0db$var$lastBackPressTime = 0;
const $8bfe43a2def9b0db$var$EXIT_DELAY = 2000; // 2 seconds
async function $8bfe43a2def9b0db$var$checkInternet() {
    try {
        // lightweight request (no cache)
        await fetch('https://www.google.com/generate_204', {
            method: 'GET',
            cache: 'no-store',
            mode: 'no-cors'
        });
        return true;
    } catch (e) {
        return false;
    }
}
const $8bfe43a2def9b0db$var$backButton = document.querySelector('.backButton');
const $8bfe43a2def9b0db$var$backFunctionForAndroid = (canGoBack = null)=>{
    // 1. Overlay (highest priority)
    if ($8bfe43a2def9b0db$var$handleCustomBack('.topExitButtonOnVideoOverlay')) return;
    // 1. Overlay (highest priority)
    if ($8bfe43a2def9b0db$var$handleCustomBack('.topExitCloseVideoButtonOnVideoOverlay')) return;
    // 1. Overlay (highest priority)
    if ($8bfe43a2def9b0db$var$handleCustomBack('.topRightExitButtonOnFullScreenOverlay')) return;
    // 2. Fullscreen window
    if ($8bfe43a2def9b0db$var$handleCustomBack('.topRightExitButtonOnFullScreenWindow')) return;
    // 3. Stack navigation
    if ($8bfe43a2def9b0db$var$handleCustomBack('.CloseCurrentStackPageButton')) return;
    // 4. Fallback to browser navigation
    if (canGoBack) {
        console.log("\uD83D\uDD19 Back button pressed on stack Fallback 1");
        window.history.back();
    } else {
        console.log("\uD83D\uDD19 Back button pressed on stack Fallback 2");
        const now = Date.now();
        if (now - $8bfe43a2def9b0db$var$lastBackPressTime < $8bfe43a2def9b0db$var$EXIT_DELAY) {
            console.log("\uD83D\uDD19 Back button pressed on stack Fallback 3");
            (0, $fc70cc85372c45fc$export$86fbec116b87613f).exitApp();
        } else {
            console.log("\uD83D\uDD19 Back button pressed on stack Fallback 4");
            $8bfe43a2def9b0db$var$lastBackPressTime = now;
            $8bfe43a2def9b0db$var$showExitToast();
        }
    }
};
$8bfe43a2def9b0db$var$backButton.addEventListener('click', ()=>{
    console.log("\uD83D\uDD19 Back button pressed");
    $8bfe43a2def9b0db$var$backFunctionForAndroid();
});
async function $8bfe43a2def9b0db$var$updateConnectionStatus(canGoBack) {
    const isOnline = await $8bfe43a2def9b0db$var$checkInternet();
    if (!isOnline) (0, $fc70cc85372c45fc$export$86fbec116b87613f).exitApp();
    else {
        $8bfe43a2def9b0db$var$backFunctionForAndroid(canGoBack);
        return;
    }
}
(0, $fc70cc85372c45fc$export$86fbec116b87613f).addListener('backButton', ({ canGoBack: canGoBack })=>{
    $8bfe43a2def9b0db$var$updateConnectionStatus(canGoBack);
});
function $8bfe43a2def9b0db$var$showExitToast() {
    let toast = document.getElementById('exit-toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.id = 'exit-toast';
        toast.innerText = 'Presiona de nuevo para salir';
        Object.assign(toast.style, {
            position: 'fixed',
            bottom: '30px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0,0,0,0.8)',
            color: '#fff',
            padding: '10px 16px',
            borderRadius: '8px',
            fontSize: '14px',
            zIndex: 999999,
            opacity: '0',
            pointerEvents: 'none',
            transition: 'opacity 0.2s ease'
        });
        document.body.appendChild(toast);
    }
    // show
    toast.style.opacity = '1';
    toast.style.pointerEvents = 'none'; // 👈 always non-interactive
    // clear any previous timeout (important if spam clicking)
    if (toast.hideTimeout) clearTimeout(toast.hideTimeout);
    // hide after delay
    toast.hideTimeout = setTimeout(()=>{
        toast.style.opacity = '0';
        // optional: fully hide after fade
        setTimeout(()=>{
            toast.style.display = 'none';
        }, 200); // match transition
    }, $8bfe43a2def9b0db$var$EXIT_DELAY);
    // ensure it's visible again if reused
    toast.style.display = 'block';
}
function $8bfe43a2def9b0db$var$handleCustomBack(selector) {
    const elements = document.querySelectorAll(selector);
    if (selector === '.topExitCloseVideoButtonOnVideoOverlay') {
        const el = elements?.[0];
        if (el) {
            if ($8bfe43a2def9b0db$var$isElementOnTop(el)) {
                console.log('Action on back button 7');
                el.click();
                return true;
            }
        }
    }
    // iterate from top-most (last in DOM)
    for(let i = elements.length - 1; i >= 0; i--){
        const el = elements[i];
        console.log('Action on back button 2');
        console.log({
            visible: $8bfe43a2def9b0db$var$isElementVisible(el),
            onTop: $8bfe43a2def9b0db$var$isElementOnTop(el),
            element: el
        });
        if ($8bfe43a2def9b0db$var$isElementVisible(el) && $8bfe43a2def9b0db$var$isElementOnTop(el)) {
            console.log('Action on back button 3');
            el.click();
            return true;
        }
    }
    console.log('Action on back button 4');
    return false;
}
// ✅ Check if element is visible
function $8bfe43a2def9b0db$var$isElementVisible(el) {
    const rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && el.offsetParent !== null && style.pointerEvents !== 'none';
}
// ✅ Check if element is actually on top (not covered)
function $8bfe43a2def9b0db$var$isElementOnTop(el) {
    const rect = el.getBoundingClientRect();
    // Check center point
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    // If off-screen, ignore
    if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) return false;
    const topElement = document.elementFromPoint(x, y);
    return el === topElement || el.contains(topElement);
}
// END Back Button navigation
// START Deep linking
// App opened via deep link (background / running)
(0, $fc70cc85372c45fc$export$86fbec116b87613f).addListener('appUrlOpen', (event)=>{
    console.log('Deep link (appUrlOpen):', event.url);
    (0, $5df95a5c365eca14$export$2e2bcd8739ae039)._parseLocateAndDisplay(event.url);
});
// App opened from CLOSED state
(0, $fc70cc85372c45fc$export$86fbec116b87613f).getLaunchUrl().then((data)=>{
    if (data?.url) {
        console.log('Deep link (cold start):', data.url);
        (0, $5df95a5c365eca14$export$2e2bcd8739ae039)._parseLocateAndDisplay(data.url);
    }
});
// END Deep linking
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register(new URL("/firebase-messaging-sw.js", import.meta.url))
//       .then((registration) => {
//         // console.log(
//         //   "Service Worker registered with scope:",
//         //   registration.scope
//         // );
//       })
//       .catch((error) => {
//         console.error("Service Worker registration failed:", error);
//       });
//   });
// }
// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", async () => {
//     try {
//       const registration = await navigator.serviceWorker.register(
//         new URL("./firebase-messaging-sw.js", import.meta.url)
//       );
//       console.log("SW registered:", registration.scope);
//     } catch (err) {
//       console.error("SW registration failed:", err);
//     }
//   });
// }
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.addEventListener("message", (event) => {
//     if (event.data?.type === "NEW_VERSION_READY") {
//       const confirmUpdate = confirm(event.data.message + "\n\nInstall now?");
//       if (confirmUpdate) {
//         window.location.reload();
//       }
//     }
//   });
// }
// START
// this version is the original
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register(new URL("./firebase-messaging-sw.js", import.meta.url))
//     .then((registration) => {
//       // 🔥 Force check for updates on every load
//       registration.update();
//     });
//   // Prevent infinite reload loop
//   navigator.serviceWorker.addEventListener("controllerchange", () => {
//     if (sessionStorage.getItem("swRefreshed")) return;
//     sessionStorage.setItem("swRefreshed", "true");
//     window.location.reload();
//   });
// }
if ("serviceWorker" in navigator) {
    const isLocalhost = location.hostname === "localhost" || location.hostname === "127.0.0.1";
    const swUrl = isLocalhost ? `/firebase-messaging-sw.js?dev=${Date.now()}` : `/firebase-messaging-sw.js`;
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        // // 🔥 Force update check
        // registration.update();
        navigator.serviceWorker.register(swUrl);
        console.log("SW registered:", registration);
    }).catch((err)=>{
        console.error("SW registration failed:", err);
    });
    // =========================
    // AUTO RELOAD ON NEW SW
    // =========================
    navigator.serviceWorker.addEventListener("controllerchange", ()=>{
        if (sessionStorage.getItem("swRefreshed")) return;
        sessionStorage.setItem("swRefreshed", "true");
        window.location.reload();
    });
}
// END
// installApp._initiateInstallApp();
// import openUrls from "./modules/open-app-urls/open-urls";
// import installApp from "./modules/install-app";
// installApp._initiateInstallApp();
// if (window.matchMedia("(display-mode: standalone)").matches) {
//   // User has the PWA installed, redirect them inside the app  
//   // window.location.replace(window.location.href);
//   alert("You have this app installed");
// } else {
//   alert("You do not have this app installed");  
// }
// document.addEventListener("DOMContentLoaded", () => {
//   const body = document.body;
//   // Function to show a click/tap effect
//   const showClickEffect = (x, y) => {
//     const ripple = document.createElement("div");
//     ripple.className = "click-effect";
//     ripple.style.left = `${x}px`;
//     ripple.style.top = `${y}px`;
//     body.appendChild(ripple);
//     // Remove the ripple after animation
//     setTimeout(() => {
//       ripple.remove();
//     }, 600); // Match animation duration
//   };
//   // Function to start tracking a swipe trail
//   const startSwipeTrail = (x, y) => {
//     const trail = document.createElement("div");
//     trail.className = "swipe-trail";
//     trail.style.left = `${x}px`;
//     trail.style.top = `${y}px`;
//     body.appendChild(trail);
//     return trail;
//   };
//   // Event listeners
//   body.addEventListener("pointerdown", (e) => {
//     showClickEffect(e.clientX, e.clientY);
//   });
//   let swipeTrail;
//   body.addEventListener("pointermove", (e) => {
//     if (!swipeTrail) {
//       swipeTrail = startSwipeTrail(e.clientX, e.clientY);
//     } else {
//       swipeTrail.style.left = `${e.clientX}px`;
//       swipeTrail.style.top = `${e.clientY}px`;
//     }
//   });
//   body.addEventListener("pointerup", () => {
//     if (swipeTrail) {
//       swipeTrail.remove();
//       swipeTrail = null;
//     }
//   });
// });
//
//
//
// document.addEventListener("DOMContentLoaded", () => {
//   const body = document.body;
//   let swipeTrail = null;
//   let isSwiping = false;
//   // Function to show a click/tap effect
//   const showClickEffect = (x, y) => {
//     const ripple = document.createElement("div");
//     ripple.className = "click-effect";
//     ripple.style.left = `${x}px`;
//     ripple.style.top = `${y}px`;
//     body.appendChild(ripple);
//     // Remove the ripple after animation
//     setTimeout(() => {
//       ripple.remove();
//     }, 600); // Match animation duration
//   };
//   // Function to start tracking a swipe trail
//   const startSwipeTrail = (x, y) => {
//     const trail = document.createElement("div");
//     trail.className = "swipe-trail";
//     trail.style.left = `${x}px`;
//     trail.style.top = `${y}px`;
//     body.appendChild(trail);
//     return trail;
//   };
//   // Event listener for clicks
//   body.addEventListener("pointerdown", (e) => {
//     // For clicks, trigger the ripple effect
//     showClickEffect(e.clientX, e.clientY);
//     // Start swipe tracking if swipe is initiated
//     isSwiping = true;
//     swipeTrail = startSwipeTrail(e.clientX, e.clientY);
//   });
//   // Event listener for swipe movement
//   body.addEventListener("pointermove", (e) => {
//     if (isSwiping) {
//       // Update the swipe trail's position to follow the mouse/touch
//       swipeTrail.style.left = `${e.clientX}px`;
//       swipeTrail.style.top = `${e.clientY}px`;
//     }
//   });
//   // Event listener to stop swipe tracking
//   body.addEventListener("pointerup", () => {
//     if (isSwiping) {
//       // Remove the swipe trail after the swipe ends
//       swipeTrail.remove();
//       isSwiping = false;
//       swipeTrail = null;
//     }
//   });
//   // Prevent default for touch gestures (optional)
//   body.addEventListener("touchmove", (e) => e.preventDefault(), {
//     passive: false,
//   });
// });
//
//
//
// document.addEventListener("DOMContentLoaded", () => {
//   const body = document.body;
//   let swipeTrail = null;
//   let isSwiping = false;
//   // Function to show a mouse tracking dot
//   const showMouseTrackingDot = (x, y) => {
//     const dot = document.createElement("div");
//     dot.className = "mouse-tracking-dot";
//     dot.style.left = `${x - 5}px`; // Center the dot
//     dot.style.top = `${y - 5}px`; // Center the dot
//     body.appendChild(dot);
//     // Remove the dot after 300ms (fading effect duration)
//     setTimeout(() => {
//       dot.remove();
//     }, 300); // Adjust this to change how long the dot stays
//   };
//   // Function to show a click effect with a bigger fading line
//   const showClickEffect = (x, y) => {
//     const ripple = document.createElement("div");
//     ripple.className = "click-effect";
//     ripple.style.left = `${x - 25}px`; // Center the ripple
//     ripple.style.top = `${y - 25}px`; // Center the ripple
//     body.appendChild(ripple);
//     // Remove the ripple after animation
//     setTimeout(() => {
//       ripple.remove();
//     }, 600); // Match animation duration
//   };
//   // Function to start tracking a swipe trail
//   const startSwipeTrail = (x, y) => {
//     const trail = document.createElement("div");
//     trail.className = "swipe-trail";
//     trail.style.left = `${x}px`;
//     trail.style.top = `${y}px`;
//     body.appendChild(trail);
//     return trail;
//   };
//   // Event listener for mouse or touch movements (for tracking mouse position)
//   body.addEventListener("pointermove", (e) => {
//     // Only track if the user is not clicking (no swipe initiated)
//     if (!isSwiping) {
//       showMouseTrackingDot(e.clientX, e.clientY);
//     }
//     if (isSwiping) {
//       // Update the swipe trail's position to follow the mouse/touch
//       swipeTrail.style.left = `${e.clientX}px`;
//       swipeTrail.style.top = `${e.clientY}px`;
//     }
//   });
//   // Event listener for pointer down (click or swipe start)
//   body.addEventListener("pointerdown", (e) => {
//     // For clicks, trigger the ripple effect
//     showClickEffect(e.clientX, e.clientY);
//     // Start swipe tracking if swipe is initiated
//     isSwiping = true;
//     swipeTrail = startSwipeTrail(e.clientX, e.clientY);
//   });
//   // Event listener for pointer up (end swipe)
//   body.addEventListener("pointerup", () => {
//     if (isSwiping) {
//       // Remove the swipe trail after the swipe ends
//       swipeTrail.remove();
//       isSwiping = false;
//       swipeTrail = null;
//     }
//   });
//   // Prevent default for touch gestures (optional)
//   body.addEventListener("touchmove", (e) => e.preventDefault(), {
//     passive: false,
//   });
// });
// Developer function START
const $8bfe43a2def9b0db$var$prod = true;
function $8bfe43a2def9b0db$var$addFloatingCopyButtons(cssText, htmlText) {
    if ($8bfe43a2def9b0db$var$prod) return;
    // if (htmlString.length < 1) return;
    if (localStorage.getItem("hideFloatingFrame") === "true") return;
    const frame = document.createElement("div");
    frame.style.position = "fixed";
    frame.style.top = "20px";
    frame.style.right = "20px";
    frame.style.backgroundColor = "#fff";
    frame.style.border = "1px solid #ccc";
    frame.style.borderRadius = "8px";
    frame.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
    frame.style.padding = "12px";
    frame.style.zIndex = "9999";
    frame.style.cursor = "move";
    frame.style.fontFamily = "sans-serif";
    frame.style.display = "flex";
    frame.style.flexDirection = "column";
    frame.style.alignItems = "flex-start";
    frame.style.gap = "8px";
    frame.addEventListener("mousedown", (e)=>{
        isDragging = true;
        offsetX = e.clientX - frame.getBoundingClientRect().left;
        offsetY = e.clientY - frame.getBoundingClientRect().top;
    });
    document.addEventListener("mousemove", (e)=>{
        if (isDragging) {
            frame.style.left = e.clientX - offsetX + "px";
            frame.style.top = e.clientY - offsetY + "px";
            frame.style.right = "auto";
        }
    });
    document.addEventListener("mouseup", ()=>{
        isDragging = false;
    });
    // reset the whole thing
    function resetTheHtmlProssesing() {
        console.log("reseting now");
        localStorage.setItem("hideFloatingFrame", "true");
    }
    function createButton(text, color, onClick) {
        const btn = document.createElement("button");
        btn.textContent = text;
        btn.style.padding = "6px 10px";
        btn.style.fontSize = "14px";
        btn.style.border = "none";
        btn.style.borderRadius = "4px";
        btn.style.cursor = "pointer";
        btn.style.backgroundColor = color;
        btn.style.color = "#fff";
        btn.style.fontWeight = "bold";
        btn.addEventListener("click", async ()=>{
            await onClick();
            const originalText = btn.textContent;
            btn.textContent = "Copied!";
            setTimeout(()=>{
                btn.textContent = originalText;
            }, 2000);
        });
        return btn;
    }
    const cssBtn = createButton("Copy CSS", "#0085ff", ()=>navigator.clipboard.writeText(cssText));
    const htmlBtn = createButton("Copy HTML", "#28a745", ()=>navigator.clipboard.writeText(htmlText));
    const closeBtn = createButton("Close", "#e63946", ()=>{
        frame.remove();
        resetTheHtmlProssesing();
    });
    frame.appendChild(cssBtn);
    frame.appendChild(htmlBtn);
    frame.appendChild(closeBtn);
    document.body.appendChild(frame);
    // Make draggable
    let isDragging = false;
    let offsetX = 0;
    let offsetY = 0;
    frame.addEventListener("mousedown", (e)=>{
        isDragging = true;
        offsetX = e.clientX - frame.getBoundingClientRect().left;
        offsetY = e.clientY - frame.getBoundingClientRect().top;
        frame.style.transition = "none";
    });
    document.addEventListener("mousemove", (e)=>{
        if (!isDragging) return;
        e.preventDefault();
        frame.style.left = `${e.clientX - offsetX}px`;
        frame.style.top = `${e.clientY - offsetY}px`;
        frame.style.right = "auto";
        frame.style.bottom = "auto";
    });
    document.addEventListener("mouseup", ()=>{
        isDragging = false;
    });
}
const $8bfe43a2def9b0db$var$colorMap = {
    "#ffbc00": "--color-yellow-900",
    "#face53": "--color-yellow-700",
    "#ffe6a1": "--color-yellow-400",
    "#fff8e5": "--color-yellow-100",
    "#f6f6f6": "--color-gray-background",
    "#ff6200": "--color-orange-warning"
};
function $8bfe43a2def9b0db$var$processHTML(htmlString) {
    $8bfe43a2def9b0db$var$checkAndUpdateHtmlString(htmlString);
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const uniqueClasses = new Map();
    // Convert to camelCase
    function toCamelCase(str) {
        return str.replace(/[^a-zA-Z0-9 ]/g, "").trim().split(/\s+/).map((word, index)=>index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join("");
    }
    // ✅ Updated: Pass global colorMap into here
    function styleToCSS(styleString) {
        return styleString.split(";").filter(Boolean).map((rule)=>{
            const [property, valueRaw] = rule.split(":").map((s)=>s.trim());
            // Normalize and check for color
            const hexMatch = valueRaw.match(/^#([0-9a-f]{6})$/i);
            if (hexMatch) {
                const hexWithHash = `#${hexMatch[1].toLowerCase()}`;
                if ($8bfe43a2def9b0db$var$colorMap[hexWithHash]) return `${property}: var(${$8bfe43a2def9b0db$var$colorMap[hexWithHash]});`;
            }
            return `${property}: ${valueRaw};`;
        }).join(" ");
    }
    function cleanElement(element) {
        if (element.nodeType !== Node.ELEMENT_NODE) return;
        const dataLayer = element.getAttribute("data-layer");
        let className = element.getAttribute("class") || null;
        if (dataLayer) {
            className = toCamelCase(dataLayer);
            element.setAttribute("class", className);
            element.removeAttribute("data-layer");
        }
        const styleAttr = element.getAttribute("style");
        if (styleAttr && className) {
            const css = styleToCSS(styleAttr); // ← uses outer colorMap
            if (!uniqueClasses.has(className)) uniqueClasses.set(className, css);
            element.removeAttribute("style");
        }
        // 🚀 New: remove *all* data-* attributes
        Array.from(element.attributes).forEach((attr)=>{
            if (attr.name.startsWith("data-")) element.removeAttribute(attr.name);
        });
        Array.from(element.children).forEach(cleanElement);
    }
    Array.from(doc.body.children).forEach(cleanElement);
    const cleanedHTML = doc.body.innerHTML;
    const cssOutput = Array.from(uniqueClasses.entries()).map(([cls, css])=>`.${cls} {\n  ${css}\n}`).join("\n\n");
    // console.log("✅ Cleaned HTML:\n", cleanedHTML);
    // console.log("🎨 Full CSS:\n" + cssOutput);
    // Add floating buttons
    $8bfe43a2def9b0db$var$addFloatingCopyButtons(cssOutput, cleanedHTML);
}
// Example usage
const $8bfe43a2def9b0db$var$htmlString = `
<div data-layer="delete all con 1" class="DeleteAllCon1" style="align-self: stretch; align-self: stretch; background: white; overflow: hidden; border-top-left-radius: 30px; flex-direction: column; justify-content: flex-start; align-items: center; display: inline-flex">
  <div data-layer="delete all con 2" class="DeleteAllCon2" style="align-self: stretch; padding: 20px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 20px; display: flex">
    <div data-layer="delete all con 3" class="DeleteAllCon3" style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 5px; display: flex">
      <div data-layer="delete all text 1" class="DeleteAllText1" style="align-self: stretch; text-align: center; color: black; font-size: 20px; font-family: Inter; font-weight: 700; word-wrap: break-word">Elimina estos primero</div>
      <div data-layer="delete all text 2" class="DeleteAllText2" style="align-self: stretch; text-align: center; color: black; font-size: 12px; font-family: Inter; font-weight: 400; word-wrap: break-word">Para poder eliminar tu cuenta, necesitas eliminar primero todos tus listados, y todos tus negocios.</div>
    </div>
    <div data-layer="delete all con 4" class="DeleteAllCon4" style="align-self: stretch; flex-direction: column; justify-content: center; align-items: flex-end; gap: 10px; display: flex">
      <div data-layer="delete all con 5" class="DeleteAllCon5" style="padding-left: 20px; padding-right: 20px; padding-top: 5px; padding-bottom: 5px; background: white; border-radius: 10px; outline: 1px #FF0000 solid; outline-offset: -1px; justify-content: flex-start; align-items: center; gap: 5px; display: inline-flex">
        <div data-layer="delete all text 3" class="DeleteAllText3" style="text-align: center; color: #FF0000; font-size: 14px; font-family: Inter; font-weight: 500; word-wrap: break-word">Eliminar todo</div>
      </div>
    </div>
  </div>
  <div data-layer="delete all con 6" class="DeleteAllCon6" style="align-self: stretch; flex: 1 1 0; padding: 20px"></div>
</div>
  `;
function $8bfe43a2def9b0db$var$checkAndUpdateHtmlString(htmlString) {
    const stored = localStorage.getItem("storedHtmlString");
    if (stored !== htmlString) {
        // console.log("HTML strings are not the same.");
        localStorage.removeItem("hideFloatingFrame");
        localStorage.setItem("storedHtmlString", htmlString);
    }
}
$8bfe43a2def9b0db$var$processHTML($8bfe43a2def9b0db$var$htmlString); // Developer function END


//# sourceMappingURL=index.b14a7c27.js.map
